// // REACT
// import React from "react";
// import ReactDOM from "react-dom";
import L from "leaflet";
import leafletPip from "@mapbox/leaflet-pip";
// // OPEN LAYERS
// import Feature from "ol/Feature";
// import * as ol from "ol";
// import { Image as ImageLayer } from "ol/layer.js";
// import ImageWMS from "ol/source/ImageWMS.js";
// import { GeoJSON } from "ol/format.js";
// import { OSM, TileArcGISRest, TileImage, Vector as VectorSource } from "ol/source.js";
// import TileLayer from "ol/layer/Tile.js";
// import TileGrid from "ol/tilegrid/TileGrid.js";
// import Point from "ol/geom/Point";
// import VectorLayer from "ol/layer/Vector";
// import Vector from "ol/source/Vector";
// import { getTopLeft } from "ol/extent.js";
// import { easeOut } from "ol/easing";
// import { Fill, Stroke, Style, Circle as CircleStyle, Text as TextStyle } from "ol/style";
// import XYZ from "ol/source/XYZ.js";
// import { unByKey } from "ol/Observable.js";
// import WKT from "ol/format/WKT.js";
// import { transform } from "ol/proj.js";
// import Projection from "ol/proj/Projection.js";
// import proj4 from "proj4";
// import { register } from "ol/proj/proj4";
// import { fromLonLat } from "ol/proj";
// import { getVectorContext } from "ol/render";

// //OTHER
// import { parseString } from "xml2js";
// import shortid from "shortid";
// import ShowMessage from "./ShowMessage.jsx";
// import URLWindow from "./URLWindow.jsx";
// import mainConfig from "../config.json";
// import { InfoRow } from "./InfoRow.jsx";
// MOBILE VIEW

var statesData = {
  type: "FeatureCollection",
  name: "india_boundary",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        AREA: 221543775899.0,
        PERIMETER: 3369064.7106499998,
        IND_ST_WGS: 2,
        IND_ST_W_1: 1,
        STATE: "JAMMU & KASHMIR",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [93.699171198370209, 7.208038867505207],
              [93.695205533883126, 7.212060633815311],
              [93.691926464265222, 7.223688128223841],
              [93.690287988164599, 7.230331347351236],
              [93.693269387075148, 7.23263148270005],
              [93.697866465961511, 7.226629102807076],
              [93.703789263766879, 7.218643099377884],
              [93.704438233256582, 7.214323557335582],
              [93.704114700483146, 7.209350288262289],
              [93.699171198370209, 7.208038867505207],
            ],
          ],
          [
            [
              [93.75126391061697, 7.394626308126902],
              [93.747474920032388, 7.398788084061185],
              [93.747823684820233, 7.404947493610615],
              [93.753423163426604, 7.402070823092908],
              [93.75126391061697, 7.394626308126902],
            ],
          ],
          [
            [
              [93.741525283754271, 7.198477820483062],
              [93.73500518389551, 7.198079018941159],
              [93.734693656900632, 7.201238359980551],
              [93.736191520053097, 7.206021987788792],
              [93.736850782846929, 7.209334680991411],
              [93.738818581797744, 7.212639303356583],
              [93.742458480824368, 7.216773376107216],
              [93.745437327983154, 7.217255131916768],
              [93.748231167841894, 7.215579187181154],
              [93.748722428000065, 7.212100479892309],
              [93.751516911366735, 7.20974357573662],
              [93.755961806327463, 7.210056070384028],
              [93.75892164198774, 7.212514042116474],
              [93.763363265655158, 7.211327205916954],
              [93.766650980665602, 7.207671349449386],
              [93.769957648745773, 7.202494026008059],
              [93.772571019149652, 7.20081944398912],
              [93.774566844772053, 7.206462831748397],
              [93.773083206785628, 7.209788754832934],
              [93.767335084106435, 7.211642815258001],
              [93.76551166336391, 7.214630322988206],
              [93.76964510115063, 7.216262533861125],
              [93.775083061298503, 7.217386527305134],
              [93.780677707390566, 7.216191451336329],
              [93.784143160922966, 7.212193901784492],
              [93.785283513761527, 7.206052626591481],
              [93.788396112061065, 7.205692101977592],
              [93.789397918527072, 7.210660137619231],
              [93.788411940495422, 7.214164940706536],
              [93.794347597814138, 7.215443506327534],
              [93.794692748457408, 7.218440117461452],
              [93.794702023074876, 7.223074283521259],
              [93.795524303301377, 7.228203724614088],
              [93.79191901851523, 7.231226265594471],
              [93.790439469157363, 7.235711255989451],
              [93.796218030385589, 7.237014212477065],
              [93.802813801797896, 7.240287512658696],
              [93.809400488011676, 7.239062429834203],
              [93.812355842684113, 7.238225052890592],
              [93.817641250400442, 7.24018850042133],
              [93.824731333998173, 7.242617378068002],
              [93.830670592077809, 7.244895129974624],
              [93.831155688276979, 7.239097143493387],
              [93.827670246038792, 7.234645861102047],
              [93.828644971222118, 7.227323573452785],
              [93.830452711868588, 7.218360437202326],
              [93.837037711746774, 7.216180266004911],
              [93.843969234454633, 7.218767663345153],
              [93.848414665371408, 7.219077809949724],
              [93.85334894357122, 7.215726089336202],
              [93.858431990067544, 7.209375541468637],
              [93.861399754114942, 7.205538376291146],
              [93.861203816536673, 7.199247638320316],
              [93.861183576931367, 7.191274829829641],
              [93.863157809274043, 7.186627181542175],
              [93.860989439678846, 7.176194233096923],
              [93.862306301604079, 7.17087048660055],
              [93.866732032841412, 7.163866641745143],
              [93.869664622507585, 7.155397075050958],
              [93.869148646907064, 7.146771500364697],
              [93.865837017220414, 7.139845471257883],
              [93.866318578899964, 7.133688234662529],
              [93.870592124971608, 7.12918453089412],
              [93.873373133322602, 7.123374435382322],
              [93.871866984349211, 7.116255424449318],
              [93.868240918657207, 7.109151278286274],
              [93.868384722136753, 7.103337362910203],
              [93.87279654493382, 7.092181299329448],
              [93.874928867995166, 7.088034161014846],
              [93.878548518385173, 7.084353285354958],
              [93.884450116229559, 7.083312016922116],
              [93.887581786880347, 7.082790151943857],
              [93.889873815821588, 7.079958809381272],
              [93.892337980269787, 7.074651090210978],
              [93.893965162459281, 7.067329574051853],
              [93.895931885550937, 7.061685377634204],
              [93.901994237141693, 7.053515041328967],
              [93.903448413973621, 7.049190936979728],
              [93.901626494751639, 7.042418108020758],
              [93.902263642891782, 7.036602468409524],
              [93.90388488026872, 7.028306771205146],
              [93.909316275916225, 7.028425443068526],
              [93.912948582062953, 7.029737541703888],
              [93.917065714515658, 7.028050392189191],
              [93.920502829910518, 7.02421177155278],
              [93.923766147652742, 7.015426707109249],
              [93.927050821322197, 7.013745573803425],
              [93.931821733482124, 7.012053099905985],
              [93.935098041020026, 7.007376410733333],
              [93.938770754356, 7.000472326645816],
              [93.939183515836703, 6.99524985105933],
              [93.938729163670786, 6.986720568621644],
              [93.938312380355569, 6.982548931033885],
              [93.935400354669056, 6.980483282544006],
              [93.930260880388133, 6.986784808559694],
              [93.925327012793772, 6.994310678743184],
              [93.925748736932235, 7.000139225268373],
              [93.926040608192764, 7.007444259659241],
              [93.921769721471804, 7.010789551633545],
              [93.915194978768554, 7.011995749898279],
              [93.908117516954775, 7.010572992957716],
              [93.903981153627939, 7.006110202056716],
              [93.904799624691108, 6.99997642274362],
              [93.896414294290963, 6.998381152023114],
              [93.890796917832418, 6.995448851362289],
              [93.899691438652695, 6.994386367317726],
              [93.908074008356024, 6.995323029935371],
              [93.913835984371048, 6.993283513917824],
              [93.916615443776408, 6.988452423373938],
              [93.917246401560519, 6.98082324807279],
              [93.91788235072562, 6.974692254834212],
              [93.921166468187579, 6.973668991475555],
              [93.924449957681361, 6.97148884697333],
              [93.924933279902604, 6.967197433782655],
              [93.93134025422917, 6.963336698758477],
              [93.935115564052211, 6.960472801839973],
              [93.933618897252842, 6.957352778346499],
              [93.930819354964058, 6.955037246040613],
              [93.927869704015791, 6.95474142361245],
              [93.921455448274074, 6.95660431369373],
              [93.919666995381746, 6.953101020075335],
              [93.916975786365413, 6.948946518415853],
              [93.913861862003557, 6.947313640921271],
              [93.91301792915425, 6.943145181178843],
              [93.913437291530329, 6.940216032696537],
              [93.917337890302065, 6.93415224644362],
              [93.916089261196134, 6.930417937659791],
              [93.911336958185302, 6.930022385126071],
              [93.907831827062438, 6.93277092766391],
              [93.900831483783705, 6.933388837701528],
              [93.900319611354163, 6.927766606854937],
              [93.901452813471749, 6.92179255517082],
              [93.900781252275351, 6.91533298048312],
              [93.896184954620551, 6.913891414932578],
              [93.887967173472546, 6.913611426222163],
              [93.886307816137915, 6.908315020524414],
              [93.886949461052623, 6.903342407990915],
              [93.886280871373216, 6.897722073514587],
              [93.887395130572457, 6.885126691485829],
              [93.888211711818997, 6.878974125994427],
              [93.884234161063432, 6.873061240414359],
              [93.879945019843603, 6.867943735907954],
              [93.880269724794687, 6.862816103611475],
              [93.882878374603479, 6.85352249064725],
              [93.885319387286714, 6.849196345758428],
              [93.891572321659652, 6.84781357964849],
              [93.896644965638316, 6.843490809377572],
              [93.898942655644603, 6.835673613323734],
              [93.894312283306235, 6.829426518916847],
              [93.892159680303692, 6.824136512331847],
              [93.890498370121819, 6.816530300730686],
              [93.885896214506829, 6.812255741532447],
              [93.881441088645843, 6.811970337710947],
              [93.879320765272581, 6.8098321132023],
              [93.879129502024838, 6.805525474942745],
              [93.87862371922914, 6.80072323450976],
              [93.875199017318536, 6.799250742561638],
              [93.872734154354262, 6.803077028711773],
              [93.868816422863631, 6.810224432293695],
              [93.860126351637163, 6.816905468227554],
              [93.852913150847328, 6.820606960795634],
              [93.85014127846928, 6.828084822033508],
              [93.842582116359438, 6.828454564681402],
              [93.840100883935406, 6.826000921228641],
              [93.843718932223339, 6.823821934734772],
              [93.845015293212839, 6.820162403446924],
              [93.841564218202365, 6.81653663029432],
              [93.838421326571606, 6.809779497280423],
              [93.838081529086267, 6.798355537194819],
              [93.838058101243234, 6.788924132958597],
              [93.83541232065474, 6.78264053009741],
              [93.830635399488756, 6.77904599815369],
              [93.828326824100628, 6.77210298905242],
              [93.825187840084041, 6.766321962101739],
              [93.824861193099665, 6.760861062438633],
              [93.820405846473264, 6.760392355781875],
              [93.813843864743546, 6.762590495618065],
              [93.808425010433936, 6.762626481090999],
              [93.805326158049311, 6.764641903824338],
              [93.801870058720056, 6.76863078629655],
              [93.797107305112235, 6.771653935913132],
              [93.796643208623564, 6.775284344272248],
              [93.799761131755389, 6.781882518610535],
              [93.803230443107068, 6.784693519406568],
              [93.801911298670305, 6.788986827320072],
              [93.799784999539966, 6.79414649221533],
              [93.799792610114238, 6.797614796996637],
              [93.803079292584954, 6.798432186834616],
              [93.80571246955212, 6.800070276943861],
              [93.805564924409666, 6.804037969724116],
              [93.800954914938274, 6.80538408724609],
              [93.799498213537149, 6.808386182207333],
              [93.799169098629434, 6.811856953579209],
              [93.802611340068154, 6.812174012307691],
              [93.802889302676888, 6.815640992529067],
              [93.800853030794173, 6.821481668774698],
              [93.798545368628353, 6.826099019447608],
              [93.797383120020044, 6.818488407813581],
              [93.794093716366177, 6.817036285340744],
              [93.790632688609037, 6.818873384701843],
              [93.787045558880664, 6.824360390420185],
              [93.784087207702811, 6.830343644633041],
              [93.77801728742044, 6.833193907039796],
              [93.775389915656135, 6.83620329471259],
              [93.776589614870289, 6.839804554049879],
              [93.774799550249796, 6.848229922149649],
              [93.781330231119185, 6.848750462596376],
              [93.789392449375583, 6.851668848757337],
              [93.791851099615442, 6.853965464349606],
              [93.788257306968205, 6.857640283819782],
              [93.783823409415874, 6.857328796625021],
              [93.778224332359386, 6.859859047655025],
              [93.772146452622152, 6.858900439373821],
              [93.768526068189786, 6.86141812819418],
              [93.766418423830117, 6.865241215563984],
              [93.763294536679183, 6.867733358035207],
              [93.760825465893632, 6.87124155451559],
              [93.761484039475505, 6.874207948144184],
              [93.762320039725196, 6.877015507433477],
              [93.761991333367675, 6.881485030941136],
              [93.764627393621609, 6.883305025755718],
              [93.772349006491112, 6.884072858823215],
              [93.776621539763482, 6.881392198686064],
              [93.77975261536335, 6.882369362065835],
              [93.780905638428095, 6.885355955317149],
              [93.776970275279069, 6.887694426811707],
              [93.773034853042475, 6.889874907902404],
              [93.769412737613337, 6.890555322368112],
              [93.771559859893074, 6.8955089170154],
              [93.770763701932424, 6.903634444656673],
              [93.766823044305156, 6.902343465413777],
              [93.765488442787642, 6.898881359484612],
              [93.760720938620977, 6.901566114049714],
              [93.756469963902106, 6.903905588930622],
              [93.754499858090583, 6.909702467796511],
              [93.75401127222807, 6.913856340198408],
              [93.75203872944796, 6.919335592033336],
              [93.749430008913563, 6.921348289828479],
              [93.74580285529558, 6.919034657656814],
              [93.742014476347592, 6.915586879081168],
              [93.738570744615288, 6.916765283601022],
              [93.737248897959418, 6.92024400239398],
              [93.733813785476656, 6.926413113062991],
              [93.73152702938313, 6.932869457771049],
              [93.730698489734536, 6.936866923785841],
              [93.735969235137631, 6.936653413930713],
              [93.739415712431352, 6.93797014612282],
              [93.739424650685464, 6.943279450193594],
              [93.736639919007786, 6.948423524509057],
              [93.737299721126959, 6.95223066377199],
              [93.739107354421009, 6.957028912313551],
              [93.736320202311461, 6.959678392456389],
              [93.734860592958185, 6.962523605612001],
              [93.735362978531654, 6.966491578518848],
              [93.729938191833028, 6.969496814163977],
              [93.727118046475454, 6.965883273713953],
              [93.724328793280577, 6.967874337500942],
              [93.725977612713947, 6.971517978510672],
              [93.722535742924165, 6.973693692548557],
              [93.719745378900342, 6.976365447865456],
              [93.720433229388107, 6.983305257488166],
              [93.716005766724777, 6.99045629244717],
              [93.721590941931723, 6.990263810294508],
              [93.719772894616327, 6.994086973877943],
              [93.714685713181368, 6.997431305751083],
              [93.710749443271183, 7.00076728441327],
              [93.705473984577822, 6.999141979865665],
              [93.698398087290443, 6.997028197003986],
              [93.693802157068575, 6.996896957698584],
              [93.694305983163943, 7.002521303653624],
              [93.694130927924206, 7.006176131411253],
              [93.692335031390044, 7.011156457399458],
              [93.685920110844421, 7.016163560232361],
              [93.678039725055456, 7.020022032980939],
              [93.670784419237421, 7.020563018847748],
              [93.667988243927738, 7.017764221813123],
              [93.666336087537601, 7.012303950656481],
              [93.663222207781047, 7.006852461829009],
              [93.659751133964534, 7.00487462669652],
              [93.656148361480959, 7.006710263731246],
              [93.653830203695208, 7.009718816809601],
              [93.655163108159456, 7.013183877668295],
              [93.659943006935961, 7.016969853163531],
              [93.662402568572901, 7.02076903542627],
              [93.662249487890335, 7.023923879358051],
              [93.659617914140298, 7.02906817066389],
              [93.659284905227807, 7.033291948606043],
              [93.659784928623125, 7.037442907203986],
              [93.656005698314971, 7.044250444881801],
              [93.654861347305555, 7.048410317757465],
              [93.654213609447055, 7.056040478607196],
              [93.656026004462717, 7.064475208911822],
              [93.655534573918757, 7.068291406123529],
              [93.650444729342965, 7.071974421149541],
              [93.650944185674973, 7.076602562593775],
              [93.6545563410412, 7.082053834629096],
              [93.655710276616276, 7.085361987222434],
              [93.653414329721443, 7.089029659338198],
              [93.650460135325702, 7.088887182340505],
              [93.646496723327559, 7.092881923263135],
              [93.645034657767283, 7.0970223630663],
              [93.645353350996359, 7.100516959849808],
              [93.646348862312323, 7.104326072660781],
              [93.648154725679433, 7.106631786765431],
              [93.65212396859441, 7.108108975431162],
              [93.655240470914507, 7.111405919381324],
              [93.660674929979805, 7.113032775035776],
              [93.664460820137634, 7.112512730452544],
              [93.664963455659603, 7.1183223330423],
              [93.663320525089418, 7.121646532871592],
              [93.659278444058501, 7.118175002038205],
              [93.655689176544513, 7.119112343585418],
              [93.649809979027793, 7.116249746110729],
              [93.645059316227446, 7.12222466765671],
              [93.643418011586945, 7.127047726382648],
              [93.643917603381865, 7.131518495844039],
              [93.647369258555273, 7.133657323948789],
              [93.651813587345259, 7.135630721024838],
              [93.654115254979686, 7.137775340783403],
              [93.652814397198497, 7.143754967052292],
              [93.659738566933768, 7.144874465184995],
              [93.663354289193293, 7.152484516650768],
              [93.662345015622819, 7.157531860875839],
              [93.661199236733793, 7.162193980676275],
              [93.659716141069751, 7.16683531504573],
              [93.658731280011764, 7.173972451413132],
              [93.659075498970239, 7.180284606123207],
              [93.662033225490134, 7.182425778358839],
              [93.666658299081249, 7.183558237650894],
              [93.667969376718631, 7.186525995306321],
              [93.668808496742528, 7.190178175217901],
              [93.671924197526579, 7.192477620535341],
              [93.678350037828849, 7.190941505826206],
              [93.68329075803797, 7.190413882464835],
              [93.68872918974634, 7.191540327731221],
              [93.697120566424346, 7.191831978456338],
              [93.705014409620318, 7.190286926138582],
              [93.712097349511566, 7.190744183682506],
              [93.717874922889479, 7.192867776952814],
              [93.725303714042369, 7.196797861692729],
              [93.72892144338401, 7.202431911656149],
              [93.731056030163657, 7.197762334082983],
              [93.730235014184814, 7.191634096106518],
              [93.739963663460884, 7.194891217992979],
              [93.741525283754271, 7.198477820483062],
            ],
          ],
          [
            [
              [93.634195878667541, 7.469875602979381],
              [93.629431985245361, 7.476793114148612],
              [93.633388567210517, 7.477271986933171],
              [93.634195878667541, 7.469875602979381],
            ],
          ],
          [
            [
              [93.620502389991614, 7.475498888898819],
              [93.616887385331097, 7.476427658385345],
              [93.615330401659023, 7.479756764591158],
              [93.615399797860988, 7.482827342644064],
              [93.620597026032726, 7.482071983391925],
              [93.620502389991614, 7.475498888898819],
            ],
          ],
          [
            [
              [93.528373741897155, 7.511945030630521],
              [93.521773131349335, 7.518299918942688],
              [93.521433310448828, 7.524603404312653],
              [93.5282166316954, 7.524913105914065],
              [93.532490012381317, 7.521731069630441],
              [93.532488979607223, 7.518250463997046],
              [93.53117827708914, 7.51509438562775],
              [93.528373741897155, 7.511945030630521],
            ],
          ],
          [
            [
              [93.63531133187027, 7.243635875265642],
              [93.63036982592736, 7.244821143012352],
              [93.6251200403876, 7.253800763535282],
              [93.620184418314807, 7.26328018662644],
              [93.617884127966263, 7.265950370577992],
              [93.614407567818247, 7.266309921957631],
              [93.613258195596742, 7.269133201049702],
              [93.615745178433613, 7.273096842582194],
              [93.618206464195239, 7.276560334373845],
              [93.61541080726694, 7.2802339633209],
              [93.618215152332681, 7.286013876218203],
              [93.619549752384444, 7.289483406040358],
              [93.619213848399227, 7.294962063808619],
              [93.612878228157342, 7.304290930577705],
              [93.608589947324674, 7.308131259892814],
              [93.606945118739432, 7.310617270123954],
              [93.611236719591474, 7.313912893436144],
              [93.616520151376605, 7.31572598975198],
              [93.619322871081167, 7.320188560495634],
              [93.620639199231604, 7.326818577948539],
              [93.619337626709324, 7.338099257522746],
              [93.616701374228711, 7.346751108783194],
              [93.615221460166936, 7.360534534777066],
              [93.615904423677264, 7.368328717888992],
              [93.617218785559984, 7.374959939670789],
              [93.622165819276915, 7.375933908507896],
              [93.628422149187756, 7.373399993840993],
              [93.633863543686019, 7.37121079317287],
              [93.637160421842182, 7.370692384436941],
              [93.639488128139192, 7.372680688883461],
              [93.642451779396069, 7.377961641504799],
              [93.645596235244923, 7.382764026327194],
              [93.650702248458572, 7.384895696046926],
              [93.652684570369459, 7.378405294210568],
              [93.659594801289359, 7.376889261826268],
              [93.664542047937431, 7.378020591025959],
              [93.665383503411945, 7.382494650811355],
              [93.666041677419855, 7.386128745469237],
              [93.672643205601474, 7.39050219527148],
              [93.676100029932513, 7.390323365003763],
              [93.679398780230898, 7.390304176713752],
              [93.683353172193989, 7.392760239259521],
              [93.690132505844929, 7.39338003555766],
              [93.693091000709884, 7.393362674827896],
              [93.69489557817333, 7.39071529104458],
              [93.691433687434028, 7.38757500784523],
              [93.692922715894682, 7.384746768551461],
              [93.69721234628588, 7.383721314061239],
              [93.701325406283004, 7.385516072500264],
              [93.700189421532343, 7.397140655188828],
              [93.699382606153279, 7.402625614358739],
              [93.695746565412648, 7.403488597704738],
              [93.690460388409107, 7.402177432575908],
              [93.690803940179578, 7.40699541903982],
              [93.691324212442666, 7.424592999704383],
              [93.689694095359826, 7.441044021250686],
              [93.693631131829932, 7.444341353410626],
              [93.697267321913174, 7.442318973196994],
              [93.699720730844746, 7.435004186936623],
              [93.704185771408959, 7.42933828746139],
              [93.705327689710359, 7.420371993560901],
              [93.705961805317386, 7.405587982387245],
              [93.706274431247365, 7.402425576583115],
              [93.710061927834545, 7.396764384245905],
              [93.717802312986947, 7.39073825564497],
              [93.725564273609919, 7.384711691892441],
              [93.734457640574632, 7.381338457187279],
              [93.736095788575781, 7.374689865050143],
              [93.738886307045348, 7.367375071159218],
              [93.74018730380898, 7.362047162360968],
              [93.737721114548563, 7.358925356839685],
              [93.734239449231481, 7.357787305000687],
              [93.73143140700644, 7.3521440841897],
              [93.726320740916577, 7.347697239010584],
              [93.722361797972582, 7.343584221575446],
              [93.72101929700392, 7.335954735745754],
              [93.716396123206124, 7.325185682940077],
              [93.710787321713696, 7.317764090775194],
              [93.707300969508466, 7.311648413596165],
              [93.704496597308676, 7.308506188079663],
              [93.695599465114455, 7.306740125814258],
              [93.690158094737612, 7.306112814776885],
              [93.686700646041317, 7.302974066330433],
              [93.676959681068809, 7.294666600549555],
              [93.672327471650505, 7.29119328010852],
              [93.666227525655188, 7.286432701166055],
              [93.664352672238323, 7.284102387707625],
              [93.658563912131129, 7.275023092483623],
              [93.656095809194724, 7.267902013350622],
              [93.653608664780208, 7.261780647530899],
              [93.651482752479438, 7.258133704147903],
              [93.64586007913249, 7.253847605025787],
              [93.640937160610534, 7.25123951572485],
              [93.6389469855188, 7.24627443319549],
              [93.63531133187027, 7.243635875265642],
            ],
          ],
          [
            [
              [93.675746410705102, 7.398055765244606],
              [93.670306177460517, 7.400747144026123],
              [93.667688593870764, 7.403581063057911],
              [93.668011338047464, 7.410219225771423],
              [93.673135307951199, 7.406369926573741],
              [93.675098240877887, 7.403880613121024],
              [93.675746410705102, 7.398055765244606],
            ],
          ],
          [
            [
              [93.582304263129501, 8.035977938710058],
              [93.578493887570005, 8.041972016814302],
              [93.574025994832354, 8.048996056919366],
              [93.569399406861777, 8.054834889760228],
              [93.566586210366907, 8.058999705594021],
              [93.56658838999661, 8.064496918975713],
              [93.566431013612757, 8.068170000724951],
              [93.570719012535875, 8.06548015593677],
              [93.573874613576464, 8.063456931629473],
              [93.576348146794771, 8.061460657481078],
              [93.580501635917486, 8.061097440405751],
              [93.579502564889722, 8.064592253378171],
              [93.577850342990345, 8.071602649967943],
              [93.57372164438415, 8.07743976237953],
              [93.573223204010773, 8.080772238113346],
              [93.56990848953393, 8.082796369914661],
              [93.567595473004346, 8.084792341543055],
              [93.564939906037367, 8.087976375222111],
              [93.56394138579742, 8.091972871078362],
              [93.567256601330968, 8.093120186678116],
              [93.566259932855971, 8.099603926111847],
              [93.566603037153413, 8.103434370183026],
              [93.561972750168422, 8.10562372542023],
              [93.557319022183634, 8.109319884080486],
              [93.555004330599232, 8.112821584249081],
              [93.554186674434362, 8.115654054177956],
              [93.557322223520799, 8.118468121329849],
              [93.565610458124382, 8.120914452975097],
              [93.569425426933151, 8.121739546793956],
              [93.574715436356499, 8.120869303912119],
              [93.577212149402285, 8.11554116527679],
              [93.579863083103817, 8.106858806394998],
              [93.582334759285601, 8.100367837118077],
              [93.58217452012947, 8.095372962772833],
              [93.578675840951178, 8.093063710526563],
              [93.576204005475745, 8.095060134127065],
              [93.574704449528937, 8.09242125025661],
              [93.576358682526262, 8.087919534122225],
              [93.581489095801075, 8.086730650660002],
              [93.58132866881391, 8.083058784247207],
              [93.581665724159407, 8.077559943564948],
              [93.583318652598024, 8.069910225013501],
              [93.583316032619024, 8.063090293357893],
              [93.586444691210161, 8.057418374464799],
              [93.590096495423481, 8.050397749923951],
              [93.591907740654634, 8.044915016323159],
              [93.591406183307228, 8.040744362608171],
              [93.588272645580133, 8.037430089811716],
              [93.582304263129501, 8.035977938710058],
            ],
          ],
          [
            [
              [93.457567788305454, 8.117754439321237],
              [93.453593515695658, 8.119755992187477],
              [93.453698049226105, 8.125943459653787],
              [93.461198784500951, 8.125884010619588],
              [93.458720355556096, 8.132556453307288],
              [93.462693713721407, 8.132699547504755],
              [93.464850149040288, 8.138029390510656],
              [93.457878937128157, 8.138377805204914],
              [93.453403530542047, 8.140906120669538],
              [93.449769863347456, 8.140077055638715],
              [93.449924782675851, 8.146898779078709],
              [93.450421830627519, 8.152076257427229],
              [93.448920235410981, 8.159407290144177],
              [93.448441290307485, 8.1642234237575],
              [93.449096805847248, 8.168876275038395],
              [93.449255356608276, 8.173553388182548],
              [93.451751075587694, 8.176190536099108],
              [93.461679606739082, 8.177312844496745],
              [93.467811714209461, 8.179455376368557],
              [93.475603585180465, 8.184100196918635],
              [93.477601219279308, 8.187423029854545],
              [93.486026307842323, 8.198524306289444],
              [93.487184838040719, 8.207328790077414],
              [93.488342391263473, 8.217320551760974],
              [93.497135813115406, 8.219952574864742],
              [93.508906633691808, 8.224898518396998],
              [93.516518625493674, 8.226028051290596],
              [93.527130773864386, 8.224632540478154],
              [93.535925547985556, 8.221258520609128],
              [93.537422517000508, 8.213263386704751],
              [93.538078947736693, 8.198790077723718],
              [93.53526003929386, 8.188966891534033],
              [93.530444074840574, 8.182987759307919],
              [93.525968010292416, 8.176184965574121],
              [93.521038301904341, 8.17278464978784],
              [93.517993118589132, 8.171155516166847],
              [93.51313155275902, 8.169831730184503],
              [93.513404658793164, 8.173344761922129],
              [93.512859433802973, 8.177682648588329],
              [93.509906494007467, 8.173908283217502],
              [93.507748827514291, 8.171750054379013],
              [93.504342206287134, 8.168387791152623],
              [93.501275545065454, 8.163495783841419],
              [93.500117791384127, 8.154327482938966],
              [93.499460407423371, 8.149835700544527],
              [93.495645491874654, 8.147023508231145],
              [93.492328240821791, 8.146375895232486],
              [93.490170401318949, 8.143716190317368],
              [93.493646842652666, 8.140551919769759],
              [93.499279896169256, 8.138017089120188],
              [93.50277588525789, 8.135013218166359],
              [93.506751099923548, 8.128994491615281],
              [93.508409200516297, 8.124834853193329],
              [93.513519002164244, 8.119563910427702],
              [93.516334979129709, 8.111725863158929],
              [93.518650353736504, 8.105555879711446],
              [93.521306633785045, 8.09972646884691],
              [93.524281074150608, 8.093553574102513],
              [93.527934842228348, 8.091209715727814],
              [93.531250157779809, 8.08635842165457],
              [93.535380299190194, 8.084833479768673],
              [93.53835518049155, 8.082994535632444],
              [93.540350322526564, 8.077488438745153],
              [93.542346469326063, 8.067328300912308],
              [93.541232635434, 8.064094693999346],
              [93.540074540171133, 8.05312980714211],
              [93.540482512797581, 8.04947834138005],
              [93.538166923683889, 8.045658147155143],
              [93.538438704577274, 8.04214440270087],
              [93.540320590041574, 8.039695481033846],
              [93.541227884371693, 8.035837390656759],
              [93.537098403335008, 8.033849684783515],
              [93.534601621128289, 8.03917510772154],
              [93.531629035950004, 8.043339646923222],
              [93.526817434963846, 8.044365722998679],
              [93.522823903069138, 8.044384532685198],
              [93.520146232102647, 8.040884524374526],
              [93.520394509747589, 8.037895328637745],
              [93.515562218384432, 8.036845585861309],
              [93.513949103557565, 8.033592337396458],
              [93.50909424752254, 8.031721009450997],
              [93.506144501390779, 8.031460926274878],
              [93.501560559792622, 8.030409441256102],
              [93.500767081715637, 8.022294883668033],
              [93.501560764716231, 8.018756928863668],
              [93.504262011195848, 8.014959297045774],
              [93.500494808902459, 8.010916769126528],
              [93.499383342030924, 8.005244250967641],
              [93.496025315590956, 8.000926756289545],
              [93.490082784115742, 7.999128784965074],
              [93.48511392170731, 7.996801888652154],
              [93.484615262528919, 8.0003159016516],
              [93.480799585378193, 8.011299949196571],
              [93.479638644512875, 8.026948525585889],
              [93.479477680590634, 8.040426916744682],
              [93.483607695982968, 8.038584591580445],
              [93.487738009042658, 8.036719848274034],
              [93.491233026333845, 8.035723311715708],
              [93.494205938784972, 8.038036622378263],
              [93.498335786872943, 8.034506161158168],
              [93.501149768795415, 8.03684285901851],
              [93.502647931423155, 8.042811101014543],
              [93.502648559108238, 8.046140961074517],
              [93.501331207248541, 8.050137611892689],
              [93.497676526096427, 8.051317353764528],
              [93.500831450670717, 8.055978912900892],
              [93.501648443325436, 8.059966596410366],
              [93.503303950254207, 8.062946744532848],
              [93.507117905753319, 8.061606754440881],
              [93.506959776003882, 8.056931934017486],
              [93.505961270536986, 8.051280188367263],
              [93.508276396631814, 8.045796106141308],
              [93.513246620715037, 8.045773750616974],
              [93.514744255368015, 8.049415974238117],
              [93.519874037340287, 8.049483423971241],
              [93.518216001919981, 8.054144312709102],
              [93.518058022156396, 8.058477794144663],
              [93.520373777327279, 8.060292469923883],
              [93.526244824548925, 8.063709951513372],
              [93.523869184763456, 8.067939840981104],
              [93.520556605886696, 8.067111274021583],
              [93.518217692344479, 8.064635494063534],
              [93.515243883698687, 8.066131729445525],
              [93.516401954157573, 8.069638789396116],
              [93.519715565871053, 8.072954290744166],
              [93.524028503882292, 8.074416521268509],
              [93.525345779245839, 8.078904008550822],
              [93.522032532275276, 8.078097751814086],
              [93.51724209875654, 8.076295575838888],
              [93.514085574433651, 8.076469687069061],
              [93.515902043323479, 8.081456947241355],
              [93.511430603706032, 8.080815730169578],
              [93.507298047916905, 8.08149552736254],
              [93.503485828472321, 8.081011435080004],
              [93.505982907287418, 8.07634639785176],
              [93.501827934925458, 8.070868525159083],
              [93.49635858289021, 8.066399177999196],
              [93.492069296310902, 8.062928249747836],
              [93.486917233886601, 8.062266612460785],
              [93.484602584718729, 8.060132674914584],
              [93.484284396963233, 8.057123727153618],
              [93.485760822346279, 8.05146089699408],
              [93.485263008323869, 8.04696995713582],
              [93.480134061129235, 8.045327598756138],
              [93.479315163020331, 8.050667639895755],
              [93.478972240739807, 8.0619819471651],
              [93.47915337481551, 8.068640949493641],
              [93.478152812378283, 8.075123334871103],
              [93.476153406749631, 8.078804110254501],
              [93.47680957373278, 8.082610403199249],
              [93.479147694221112, 8.085109945062868],
              [93.485936237461814, 8.083574618015044],
              [93.488910575174629, 8.081395306140204],
              [93.48972699072263, 8.088896282449621],
              [93.490066351471526, 8.096878759322619],
              [93.491382151406142, 8.104195291092308],
              [93.489904185824628, 8.109517540753444],
              [93.485433021493321, 8.100731631973835],
              [93.48643468938883, 8.094727476994683],
              [93.484436107998903, 8.089580603002679],
              [93.480963033780185, 8.090097852695706],
              [93.478305885816994, 8.092276323607969],
              [93.474674313290208, 8.09277065681521],
              [93.473176405198117, 8.088625372921172],
              [93.465385999700629, 8.098307845130876],
              [93.459411207332266, 8.109146008135276],
              [93.457567788305454, 8.117754439321237],
            ],
          ],
          [
            [
              [93.328087334304058, 7.931969118656105],
              [93.32607581819002, 7.927917764424107],
              [93.32567411875111, 7.922449085303739],
              [93.32225222787882, 7.921229247116852],
              [93.319822747174825, 7.923060286412313],
              [93.316191167705043, 7.925715871629321],
              [93.314167328601968, 7.929779370770007],
              [93.314160359797455, 7.934839570993946],
              [93.312949927119334, 7.940930017234629],
              [93.308907333689362, 7.944201985962031],
              [93.306273280924572, 7.947242380225603],
              [93.304653678097466, 7.95333413876239],
              [93.303830254543357, 7.957804464901133],
              [93.30543503058675, 7.961857551857476],
              [93.308876266378221, 7.965494546780538],
              [93.312704071012334, 7.969130036449871],
              [93.314718385179518, 7.972384280350326],
              [93.316935692342057, 7.976435736786821],
              [93.317315619189031, 7.981085143822735],
              [93.316104125732579, 7.987997187748747],
              [93.315688421576112, 7.992672815021983],
              [93.319112060774515, 7.994281328837845],
              [93.322149224858933, 7.995890175199511],
              [93.324369406880564, 7.998117521860251],
              [93.326975834962127, 8.000754319852186],
              [93.329808340646821, 8.003366824855686],
              [93.336674463399532, 8.00984346790626],
              [93.341098970220145, 8.010831558270006],
              [93.344933874594503, 8.010636770199559],
              [93.34858775217009, 8.009393341163328],
              [93.350790717389543, 8.00715114814575],
              [93.354649814567381, 8.00551850321585],
              [93.359888728251093, 8.008943628401608],
              [93.363924948797475, 8.011369558263695],
              [93.365940270652359, 8.014007834727634],
              [93.368570561339297, 8.015823006369409],
              [93.372198433229613, 8.017839524273361],
              [93.376034021711874, 8.017210004416212],
              [93.381072488641365, 8.016393664120999],
              [93.384316939625165, 8.015971448462599],
              [93.389561177008119, 8.014332896222129],
              [93.394601067081581, 8.012079124069379],
              [93.399254427987827, 8.00941646719583],
              [93.40431525067271, 8.0061604917538],
              [93.401485148762319, 8.000492947153306],
              [93.398654663523573, 7.99338939126326],
              [93.397863285725364, 7.989539196140046],
              [93.398071539634671, 7.985890606744575],
              [93.398870081297545, 7.978181309395045],
              [93.397264967226235, 7.973308588447119],
              [93.397064772195165, 7.967632572288855],
              [93.402127671519324, 7.963349748484926],
              [93.405757293303211, 7.961306838639564],
              [93.408391827480244, 7.957854414427041],
              [93.410411193276246, 7.954997390757812],
              [93.414449211287362, 7.954571517628916],
              [93.417056313898229, 7.956408281448533],
              [93.419686363846282, 7.9590193106017],
              [93.421498741720995, 7.961657021043155],
              [93.425534839142699, 7.962849574885884],
              [93.429371228152092, 7.956360080334233],
              [93.430779347210162, 7.952889174046468],
              [93.433618617435499, 7.94861468375981],
              [93.438654080034851, 7.945357985164481],
              [93.444121370370098, 7.941483184402596],
              [93.449974692484417, 7.937196625310738],
              [93.453604717600314, 7.933124435672903],
              [93.456418304234333, 7.928849650909391],
              [93.458642312486376, 7.924578254334559],
              [93.459461722376119, 7.920312493165062],
              [93.458850020974268, 7.917283712844839],
              [93.458442584444327, 7.914048549912198],
              [93.459261320101916, 7.910786162972674],
              [93.459875249945767, 7.906931477648169],
              [93.462484344309658, 7.900219964579975],
              [93.464707702570976, 7.893327883001793],
              [93.464914483969153, 7.887447111291612],
              [93.462309269978434, 7.883196630247234],
              [93.459883991968795, 7.879970721606766],
              [93.457053521959494, 7.874900421391144],
              [93.455036973839242, 7.872082719634681],
              [93.451411002283422, 7.871072671361318],
              [93.448395533471071, 7.871905277539476],
              [93.442930287994031, 7.876781438282787],
              [93.442723331708763, 7.882069058463789],
              [93.442722175533476, 7.886923768926289],
              [93.437481283466553, 7.891001422734627],
              [93.433035901956188, 7.895691285372719],
              [93.428204027891141, 7.899972116274695],
              [93.422557232337297, 7.902614992269936],
              [93.416684378370419, 7.903663937072188],
              [93.40943088641373, 7.90207402874362],
              [93.401767923590597, 7.900279761514339],
              [93.391679894420392, 7.898676590053331],
              [93.388667479344448, 7.896066732539286],
              [93.387650203413969, 7.892423551036052],
              [93.383415255750066, 7.889385310557006],
              [93.380401352798401, 7.886752718828892],
              [93.37595975017058, 7.884740662793526],
              [93.371926272593569, 7.883546574826227],
              [93.367891637288622, 7.883355966084108],
              [93.363037954314962, 7.885401309230324],
              [93.358414197311319, 7.884802068120966],
              [93.354583510299122, 7.884427678399151],
              [93.351339120092632, 7.886467686566319],
              [93.347504440575236, 7.890126351686627],
              [93.34123964043826, 7.895822183076751],
              [93.339827201311707, 7.900886711274946],
              [93.340639711352537, 7.904553433020183],
              [93.338998865997098, 7.910826589621369],
              [93.338812178521223, 7.915089283313986],
              [93.338401503412342, 7.918350286667861],
              [93.341821025762442, 7.920367599117271],
              [93.345037617332125, 7.924208669238089],
              [93.347664211158332, 7.927436450872376],
              [93.353305436489464, 7.930653713829432],
              [93.356546955273615, 7.931873501969233],
              [93.356927859544641, 7.936932702905681],
              [93.356326812031355, 7.947489130122223],
              [93.356317447022093, 7.955809821052863],
              [93.351669344020991, 7.95479994501355],
              [93.348650540173523, 7.955425939385922],
              [93.345612180940307, 7.955231125498852],
              [93.342191292017745, 7.951800055187123],
              [93.339971559508399, 7.949573467403241],
              [93.336139858569979, 7.948765273899114],
              [93.332306563772349, 7.94818536802399],
              [93.330293438580867, 7.94433929617696],
              [93.331499089202083, 7.941486156190932],
              [93.334743855706094, 7.941475365528933],
              [93.340775448542431, 7.940680375705406],
              [93.345334590300425, 7.941508931369567],
              [93.346588836560002, 7.935645582687417],
              [93.343689418702894, 7.932304874725627],
              [93.340363988006843, 7.926457769124407],
              [93.334133229745618, 7.921053606329988],
              [93.332066664108083, 7.924388185383805],
              [93.328087334304058, 7.931969118656105],
            ],
          ],
          [
            [
              [93.568645463548222, 7.92519384064992],
              [93.565197920541934, 7.926943656370416],
              [93.561207692403045, 7.930564586495167],
              [93.558148839596583, 7.932858630513441],
              [93.555110710358349, 7.93554066039745],
              [93.552184680035651, 7.937036458757468],
              [93.550189076169303, 7.939576218573026],
              [93.547536756663789, 7.9439887541708],
              [93.543933430940811, 7.947083294557315],
              [93.541007672875395, 7.948966418008529],
              [93.538626891514269, 7.950984189437691],
              [93.534113951473927, 7.95367245087789],
              [93.530643644675507, 7.958498690837742],
              [93.527717566184549, 7.960518608729934],
              [93.524134755860175, 7.962541474937707],
              [93.520822167475515, 7.96469976807168],
              [93.518145820235475, 7.966444650482667],
              [93.51204500746536, 7.970621804078176],
              [93.507916272015208, 7.977457742469388],
              [93.504331082689902, 7.980004407744546],
              [93.50219797196651, 7.9830919143096],
              [93.500859854903936, 7.985765437269842],
              [93.500859918800586, 7.988706869191705],
              [93.503785603561511, 7.990563266910346],
              [93.506986204756657, 7.990024281083238],
              [93.511908798394586, 7.988793356998304],
              [93.514289774627741, 7.991062673851982],
              [93.514699719976036, 7.994800521982906],
              [93.517760596767729, 7.997590747618947],
              [93.521209713563223, 7.999855251407168],
              [93.523343410784221, 8.002102989951423],
              [93.525476390758826, 8.006243245745718],
              [93.52465929953506, 8.009325288861403],
              [93.523480807837586, 8.012796687209734],
              [93.522004934103265, 8.018686810345786],
              [93.523730243899251, 8.021346866779814],
              [93.528131548830487, 8.018657942726248],
              [93.529335425335375, 8.01598468509917],
              [93.532510419111247, 8.013552969176933],
              [93.534914890504552, 8.009527849090722],
              [93.53756889020454, 8.005114760641781],
              [93.539293051028977, 8.000295480815046],
              [93.539699910035054, 7.996280210454981],
              [93.541831980953063, 7.9930783738962],
              [93.544871793236851, 7.99438557901533],
              [93.544736833230985, 7.997738682185117],
              [93.547415249261761, 8.001601680501755],
              [93.545668652325944, 8.005874358090775],
              [93.543696732585104, 8.008688499114578],
              [93.544739967200741, 8.012696722190785],
              [93.540883752119115, 8.015132110437348],
              [93.540226327108542, 8.018738250865786],
              [93.537980075020656, 8.022214872659781],
              [93.542633262780782, 8.023264483295049],
              [93.545946025348385, 8.022450835330224],
              [93.552071437963193, 8.021075922039222],
              [93.556860010589816, 8.019456604223757],
              [93.5596505961677, 8.017436119184321],
              [93.562711221855892, 8.011538126512541],
              [93.564162363776035, 8.007130026931488],
              [93.566427108392062, 8.001099187544039],
              [93.568673116757353, 7.99814645857115],
              [93.571349209530098, 7.996126931076134],
              [93.572663178057297, 7.991172807954078],
              [93.572389063563634, 7.988232544630591],
              [93.572274973412902, 7.984767402839236],
              [93.571069713871495, 7.976748017693679],
              [93.572381949282601, 7.968853142065789],
              [93.571992870045335, 7.961787511582354],
              [93.571195868095316, 7.955111951414498],
              [93.571713676744565, 7.94441777447077],
              [93.571052873215692, 7.937605197579809],
              [93.569985997785693, 7.932800423002578],
              [93.568645463548222, 7.92519384064992],
            ],
          ],
          [
            [
              [93.242285775422417, 8.221675521236627],
              [93.236100764674333, 8.223083876058904],
              [93.232212289433875, 8.224691584825345],
              [93.229002512463339, 8.227004939283306],
              [93.226022714638631, 8.229089242613741],
              [93.220971468563221, 8.231384465891756],
              [93.219350252291449, 8.235314960167424],
              [93.217294771908598, 8.240364227608282],
              [93.217511488109835, 8.244746904990615],
              [93.217274978519185, 8.249815133480011],
              [93.221834072008932, 8.254163894203275],
              [93.225737171731325, 8.256916308874352],
              [93.230986922172377, 8.257588007005022],
              [93.234195117461525, 8.25552533017043],
              [93.237181026455417, 8.251363000685874],
              [93.238802979151671, 8.24699878246779],
              [93.242019791848278, 8.240781180775288],
              [93.244782865906487, 8.235021230059278],
              [93.245703235610605, 8.228559251436883],
              [93.245711301799048, 8.224199652844899],
              [93.242285775422417, 8.221675521236627],
            ],
          ],
          [
            [
              [93.640712720879179, 8.381679188583583],
              [93.637484602809153, 8.383043911315523],
              [93.637964600549253, 8.386445150731225],
              [93.642218350394685, 8.386901757154369],
              [93.645358672480469, 8.386312996023531],
              [93.646311036685702, 8.382836010712374],
              [93.640712720879179, 8.381679188583583],
            ],
          ],
          [
            [
              [93.050387109709035, 8.432892541325019],
              [93.046241398383359, 8.434291345417085],
              [93.042801591932403, 8.434752273958885],
              [93.038192492753993, 8.437751370308547],
              [93.034739824211897, 8.442827388771743],
              [93.032417174045833, 8.449958627436912],
              [93.035856324724222, 8.45548389713761],
              [93.037892090077662, 8.459639837826778],
              [93.042931973395497, 8.463541446858713],
              [93.048217124003116, 8.461912333731094],
              [93.051210783041029, 8.458915185570509],
              [93.053296014715315, 8.454776724399668],
              [93.053534683387156, 8.451326811040447],
              [93.053775827457144, 8.447624580447158],
              [93.053079981812132, 8.444404132483781],
              [93.056076861790359, 8.439807904802915],
              [93.057025652791637, 8.43519131330164],
              [93.054505707868358, 8.433138116783836],
              [93.050387109709035, 8.432892541325019],
            ],
          ],
          [
            [
              [93.613393952302843, 8.41791751343065],
              [93.611735044048444, 8.422267567678961],
              [93.612080875133202, 8.428273689003886],
              [93.610080589045992, 8.433105127272739],
              [93.610430748317953, 8.443110330050544],
              [93.610434143422168, 8.450124631044387],
              [93.616082908762166, 8.456264619958292],
              [93.61608799415292, 8.462593838431095],
              [93.615249687277824, 8.466597077617903],
              [93.611768607102732, 8.469128785602178],
              [93.611428671369666, 8.472626740072357],
              [93.614595276669291, 8.47443817819606],
              [93.618420163179778, 8.476749102739031],
              [93.620086346047145, 8.480259073564381],
              [93.619587749839027, 8.484923500768687],
              [93.617268103389208, 8.487266728886912],
              [93.619752901430786, 8.492098890925673],
              [93.620758912038809, 8.496434885605908],
              [93.618757952728927, 8.501267928033419],
              [93.61496157285616, 8.509469769513673],
              [93.611848666212722, 8.520182491446825],
              [93.610738301025933, 8.525320609160138],
              [93.607760379382995, 8.526716032212962],
              [93.603386627804028, 8.533734784388276],
              [93.602729263615515, 8.540093225041263],
              [93.604881184680252, 8.555922844185469],
              [93.606191323430309, 8.566708619604892],
              [93.608895845084277, 8.563742859515855],
              [93.611875900499484, 8.557875080389543],
              [93.61337698026874, 8.554872747224449],
              [93.614194106770711, 8.55052466458956],
              [93.614349985132762, 8.545860860990517],
              [93.612523051154398, 8.540042004683801],
              [93.614183045436192, 8.5345239128894],
              [93.615839111258353, 8.527338632119628],
              [93.616837690442196, 8.521504506112954],
              [93.623302333500419, 8.518956651447036],
              [93.628948391978582, 8.516252056509712],
              [93.630126847995896, 8.508406403348131],
              [93.625086358428391, 8.499062936527668],
              [93.628723615785731, 8.491547990383461],
              [93.631038283087733, 8.483856885234793],
              [93.631872530973737, 8.473683552979477],
              [93.634187574144207, 8.465490616813391],
              [93.633864421289971, 8.461333457648305],
              [93.63037999460353, 8.461472046761351],
              [93.626536179893776, 8.462035298159684],
              [93.621391771441324, 8.460897720050783],
              [93.618906652021138, 8.4550840562641],
              [93.619562717776631, 8.450076339651023],
              [93.617736814104148, 8.445745671912269],
              [93.616892017812376, 8.441591627452985],
              [93.619210081150143, 8.435889956847168],
              [93.62105132340065, 8.432224331770261],
              [93.620046071868515, 8.42756925036613],
              [93.617538521990468, 8.422396716805055],
              [93.613393952302843, 8.41791751343065],
            ],
          ],
          [
            [
              [92.858214050436928, 8.80802907231835],
              [92.854873751088661, 8.809836670541635],
              [92.852515793729921, 8.811621314365832],
              [92.851808689363452, 8.816496003072555],
              [92.852747000666639, 8.820363858867475],
              [92.854394438122995, 8.824391909407655],
              [92.856039069352462, 8.829106436054312],
              [92.857530634593843, 8.832311173587755],
              [92.859868969606495, 8.834669127390598],
              [92.864436849321862, 8.834394181669314],
              [92.866533170702013, 8.829817381211564],
              [92.867396062831702, 8.826201016348607],
              [92.867276889110713, 8.822035472696305],
              [92.866448250235749, 8.818716879531605],
              [92.865107829824538, 8.812743871723741],
              [92.858214050436928, 8.80802907231835],
            ],
          ],
          [
            [
              [93.184408291766729, 8.192373259808486],
              [93.177768272447892, 8.19423687249323],
              [93.16951127922917, 8.198385519549518],
              [93.165628729082485, 8.197708532741798],
              [93.160807094931201, 8.199567364805855],
              [93.156686969780353, 8.202565479739556],
              [93.150950379148199, 8.206707800041331],
              [93.146831347979571, 8.209021753978149],
              [93.142465383994136, 8.210399260450544],
              [93.137187272087942, 8.212942677795287],
              [93.132615312229575, 8.214799854561226],
              [93.127110635364318, 8.216636235730777],
              [93.120695319480888, 8.219181216240147],
              [93.114732393007458, 8.222409842395873],
              [93.113112135380874, 8.225174313530543],
              [93.111031474121944, 8.229104281494022],
              [93.107137650058945, 8.232100669312475],
              [93.103241479387052, 8.235097719837038],
              [93.100708694530354, 8.239004719536464],
              [93.097031183424718, 8.244991687035849],
              [93.093809882746683, 8.250977402817606],
              [93.089655022792059, 8.256965182785908],
              [93.087111809916834, 8.2636347077653],
              [93.083200968465235, 8.271243508526904],
              [93.08318575848601, 8.275832206453151],
              [93.082485907427284, 8.282293874255723],
              [93.082226989127946, 8.291951951054163],
              [93.084045971883413, 8.299347030675353],
              [93.087459825993804, 8.306237398087475],
              [93.089745505727677, 8.309453458598806],
              [93.091797473874905, 8.314976228751533],
              [93.092469059790119, 8.318903002827852],
              [93.092229687220808, 8.322807745372518],
              [93.094257679981993, 8.328787741901641],
              [93.095859243237442, 8.333397826669101],
              [93.097212055966537, 8.337072301778651],
              [93.099732922278221, 8.338895050536998],
              [93.103388924235873, 8.340739479418522],
              [93.11005169934765, 8.340956451403933],
              [93.11462117685285, 8.341862125259505],
              [93.118047148985369, 8.344162658676611],
              [93.120568035946789, 8.346008546840624],
              [93.124936813446524, 8.345315259867329],
              [93.127469447681335, 8.341839352778084],
              [93.131134429352045, 8.340691079603047],
              [93.136867589822856, 8.340680057468509],
              [93.139171741439185, 8.337912390520119],
              [93.138474704107452, 8.334922021669874],
              [93.136890698740373, 8.331705554809655],
              [93.136452502879308, 8.325266524255369],
              [93.135306449435674, 8.320655615280588],
              [93.132562803048472, 8.317441574083768],
              [93.130303430052038, 8.312626972240805],
              [93.128016276561567, 8.308475376244456],
              [93.129169126336706, 8.302947572229455],
              [93.130572396757103, 8.297191062485775],
              [93.129661691932156, 8.289338482784499],
              [93.128282365101313, 8.286350700990992],
              [93.127385400729125, 8.282219371292545],
              [93.124420097244922, 8.277612792187554],
              [93.123070299335808, 8.272090680689944],
              [93.124670302086528, 8.268868877183827],
              [93.127655988731931, 8.265872907589106],
              [93.131100949972222, 8.261277554438637],
              [93.135933573071483, 8.256428901330846],
              [93.140535871834658, 8.25203760813238],
              [93.147644575038399, 8.245814465802505],
              [93.152246234267523, 8.241901822676535],
              [93.157733820354693, 8.237987051400614],
              [93.164400937863647, 8.234047933721753],
              [93.170138479208589, 8.230131949693686],
              [93.177007666012173, 8.227583741155815],
              [93.185719472713771, 8.224346288806268],
              [93.191452237174332, 8.220886407644004],
              [93.19786756838397, 8.21765364498266],
              [93.20131505015911, 8.210502179432403],
              [93.200873765399606, 8.205207822963345],
              [93.199749749692543, 8.199938240502703],
              [93.197235206815051, 8.196475035439166],
              [93.193582346523186, 8.193493932406509],
              [93.187634279673048, 8.192366114988703],
              [93.184408291766729, 8.192373259808486],
            ],
          ],
          [
            [
              [92.47048883052841, 10.851860501218475],
              [92.488252453683657, 10.851356005792272],
              [92.490107324499064, 10.8542460330416],
              [92.492191811134632, 10.857458835600367],
              [92.494886245107196, 10.856127237328092],
              [92.494450885065504, 10.852595127962283],
              [92.491595380692345, 10.850372142538673],
              [92.49372800026174, 10.846824228196144],
              [92.499606552117285, 10.847300851524633],
              [92.503602541511825, 10.848626583058721],
              [92.507029721603047, 10.848427607281382],
              [92.511478862235847, 10.848207691211641],
              [92.515671086125707, 10.851311690267966],
              [92.519652817894865, 10.854644123442871],
              [92.524619787456089, 10.856202308687017],
              [92.52985566525642, 10.855891519089523],
              [92.533313708523252, 10.851584535406053],
              [92.535790353364447, 10.848498275451149],
              [92.53880183975977, 10.844951013313336],
              [92.542814659170915, 10.843968700421579],
              [92.546258011025003, 10.844645240479919],
              [92.549674381965218, 10.846407555973276],
              [92.552666550865993, 10.84906712637067],
              [92.553406845100071, 10.852392285563957],
              [92.551498648504321, 10.857256969762803],
              [92.549255067533039, 10.86013761215297],
              [92.5445523478745, 10.863541915794032],
              [92.541317460898952, 10.865981021491317],
              [92.537080557719605, 10.868948360674427],
              [92.534745932832195, 10.871596733601773],
              [92.535812425801794, 10.874807950875089],
              [92.539502168562706, 10.873823128413404],
              [92.541832802626672, 10.871844249503235],
              [92.54553716393383, 10.868529163788416],
              [92.548097533195005, 10.866665575402404],
              [92.55122155399819, 10.863788332286703],
              [92.554255342907368, 10.860354932817616],
              [92.557503069920912, 10.856048195784531],
              [92.560076729203502, 10.852083851689661],
              [92.562459825986522, 10.845673553509249],
              [92.562366866614099, 10.84235002791624],
              [92.56160365931207, 10.839025604376745],
              [92.560772433131206, 10.835285474527973],
              [92.561476217368622, 10.830417498954075],
              [92.562266909734589, 10.826544128848017],
              [92.564199824890693, 10.821355773320654],
              [92.566445656010288, 10.81803741509448],
              [92.566683355664921, 10.813608194670115],
              [92.565040472766484, 10.810074061287768],
              [92.563070932294053, 10.806978774094572],
              [92.562544709161315, 10.802662239024407],
              [92.564677597931777, 10.798790963376415],
              [92.559909030167859, 10.798895525845833],
              [92.556562965461026, 10.800987358865136],
              [92.553215360118131, 10.802849997010654],
              [92.549228725379123, 10.803740481728244],
              [92.546224337547287, 10.802949416233048],
              [92.546694716628153, 10.798635637803537],
              [92.546831331604295, 10.795660111428626],
              [92.549313339483902, 10.791580825132311],
              [92.553302109420542, 10.790482931434415],
              [92.557757728128266, 10.788601764532682],
              [92.559453404906407, 10.784405583808018],
              [92.561692647891249, 10.781757300970446],
              [92.564681616531217, 10.781210365639184],
              [92.567045823524623, 10.777569965471141],
              [92.571257624782305, 10.777464258953678],
              [92.572943399924128, 10.774583268531259],
              [92.571881400224498, 10.770774551116228],
              [92.574446038655765, 10.768126765183808],
              [92.576418433992671, 10.770783610921772],
              [92.579299543908874, 10.772565830106284],
              [92.582189049565812, 10.769457813526719],
              [92.583560718163383, 10.764938773375437],
              [92.583580249637052, 10.761962671634622],
              [92.583380445125343, 10.757302194885623],
              [92.582649660043842, 10.752549536084596],
              [92.587287148987684, 10.754334215890998],
              [92.588858451601553, 10.751453883447045],
              [92.587779122136737, 10.746583696439474],
              [92.587164892602686, 10.74150834967633],
              [92.587294294402668, 10.73608718049144],
              [92.588000004889068, 10.730876048528799],
              [92.589073566305444, 10.72239031935823],
              [92.590451510079419, 10.71685685584908],
              [92.591851886897857, 10.711440059362875],
              [92.594150707514217, 10.706877004547723],
              [92.596656074468939, 10.702037902816382],
              [92.59827352295676, 10.698996896925191],
              [92.600269931055806, 10.694296007739494],
              [92.60030743504295, 10.688484005245304],
              [92.600553960469355, 10.682695959443471],
              [92.600367538808243, 10.679443363419667],
              [92.599452504629539, 10.674368143746939],
              [92.599035460494292, 10.671046709898265],
              [92.598105177779928, 10.668070954269051],
              [92.593961279700252, 10.668845904734118],
              [92.590900771798815, 10.670154800299127],
              [92.587347169720147, 10.668994582826432],
              [92.584296659677975, 10.668550642691425],
              [92.583886202734973, 10.664353382789766],
              [92.582453913655897, 10.660729328875426],
              [92.580364683740754, 10.658464161273425],
              [92.580014080754296, 10.655351319494521],
              [92.581354364053496, 10.652171228608484],
              [92.58274412762124, 10.648415550762806],
              [92.581607791748169, 10.645507671884985],
              [92.578491957313844, 10.644556864487352],
              [92.575682169452264, 10.642960094568373],
              [92.571618527564937, 10.641936676463981],
              [92.568853530309028, 10.640777778647221],
              [92.565544296137304, 10.637727435662329],
              [92.56227982542768, 10.634815020370146],
              [92.557665570412169, 10.630100867161904],
              [92.555788737709847, 10.627353845011909],
              [92.553405824328493, 10.624235203890592],
              [92.55162149822614, 10.621625423793679],
              [92.549672481563334, 10.619153951234743],
              [92.546869265334564, 10.613429629431419],
              [92.546105898362867, 10.610084529199966],
              [92.543870416681699, 10.606021888687417],
              [92.543039273506253, 10.602261486480675],
              [92.542630020467357, 10.598272307420654],
              [92.542928117834578, 10.595299468830262],
              [92.54405610256272, 10.592558319795476],
              [92.544429668197765, 10.588570319011993],
              [92.546789086695355, 10.585025956903936],
              [92.551452419213064, 10.582430496976643],
              [92.554349880879386, 10.581123627184954],
              [92.558285866139101, 10.579980427404266],
              [92.561485262487864, 10.578696009550534],
              [92.564547223072083, 10.576950707984752],
              [92.567746504988122, 10.575366777699584],
              [92.571991910116182, 10.573208629395682],
              [92.572867429672357, 10.570029258944885],
              [92.569549989227909, 10.568408240386665],
              [92.567102897411431, 10.564645970601582],
              [92.563813011639738, 10.559429831309378],
              [92.562214460598355, 10.556382792668646],
              [92.561380546680994, 10.553338608611725],
              [92.557173422586189, 10.550148350367142],
              [92.554885873001922, 10.54710132901501],
              [92.552733948702226, 10.544191667375122],
              [92.55099393295869, 10.54158341371917],
              [92.547824331293427, 10.539109406367729],
              [92.54511135516023, 10.533895083538333],
              [92.54383483273277, 10.527944668712481],
              [92.541107516229602, 10.524758196001223],
              [92.538665137389003, 10.520557552854164],
              [92.535227819014381, 10.513336333726906],
              [92.533514001577686, 10.510704348505833],
              [92.531196081407259, 10.50853290199408],
              [92.525862907634732, 10.505039368186669],
              [92.522524334824695, 10.503441324716199],
              [92.514691201455989, 10.503722373960397],
              [92.510633370704895, 10.502835504217481],
              [92.505553257147497, 10.502684004055132],
              [92.501914660660731, 10.50412703984528],
              [92.494206138850245, 10.50657324669573],
              [92.488526521049266, 10.509300256710814],
              [92.482981140061753, 10.512604497144078],
              [92.478144541497599, 10.516808207686074],
              [92.471869648308584, 10.521999955982457],
              [92.467334160321357, 10.526042813935661],
              [92.464696998625072, 10.529655497365429],
              [92.457717683532763, 10.533114559259227],
              [92.447090641737134, 10.535827038449106],
              [92.442130845250773, 10.538140479370147],
              [92.438489514588682, 10.539718336133156],
              [92.432676900034735, 10.541430174507557],
              [92.428759348516309, 10.540265499995851],
              [92.424419501579933, 10.536772027475743],
              [92.422706986887732, 10.534162136218248],
              [92.420400181782512, 10.530813230717849],
              [92.416792876546282, 10.528197094447592],
              [92.414062745111281, 10.525721982250845],
              [92.411032172472503, 10.523546216181989],
              [92.40799111132921, 10.522384404896272],
              [92.402752382810135, 10.521697335106992],
              [92.396803368201248, 10.523130111913723],
              [92.392858330512098, 10.525422594503164],
              [92.388618108965929, 10.529764165295864],
              [92.391035706578137, 10.536709521592654],
              [92.394901898214087, 10.541516882131047],
              [92.397631250128541, 10.546874406086413],
              [92.399774188382338, 10.550500304109843],
              [92.401481210152312, 10.553709689753346],
              [92.402911303336992, 10.556895480439238],
              [92.406069525953967, 10.560801060454526],
              [92.408946221040082, 10.565167840729874],
              [92.410953495146231, 10.568493197104912],
              [92.413399551690773, 10.571843827380871],
              [92.415253768220452, 10.57692090194689],
              [92.416810025241489, 10.581997387497331],
              [92.416910273211656, 10.58677043104416],
              [92.418489286464265, 10.591662544207656],
              [92.419924758080498, 10.594272036340834],
              [92.421056300790468, 10.59731914007198],
              [92.424080145772777, 10.600809434044054],
              [92.423441287675402, 10.60862258651755],
              [92.421787010070261, 10.61615753005014],
              [92.420410240902029, 10.62369314528306],
              [92.418054966191534, 10.629196801193482],
              [92.415391931818363, 10.635851561159791],
              [92.411850164991733, 10.642203793765239],
              [92.409046488835131, 10.648720430594317],
              [92.406543243867461, 10.65247114029853],
              [92.404043984850432, 10.655668246182184],
              [92.400832990091146, 10.657963873667669],
              [92.394711806418883, 10.659974060698946],
              [92.391217530639892, 10.660400579748275],
              [92.388715582375326, 10.663872929764226],
              [92.386356649649343, 10.666609811538915],
              [92.385138026290008, 10.674284558369502],
              [92.385238969280408, 10.679082278264277],
              [92.385372098127192, 10.682542454688237],
              [92.38502021307437, 10.688929379345687],
              [92.384278032957113, 10.694968900278409],
              [92.384650336392696, 10.700321416105743],
              [92.385366175659016, 10.703229827399861],
              [92.38648950627713, 10.707569459022148],
              [92.388637774801154, 10.710782615214512],
              [92.387440995490138, 10.71555307035862],
              [92.385354554919871, 10.722073675291881],
              [92.38327081975882, 10.727718123896302],
              [92.382651927976426, 10.732790089138394],
              [92.383930107293196, 10.737707328453459],
              [92.384321198208866, 10.741053731724628],
              [92.38503036991159, 10.744816146398509],
              [92.385444650444597, 10.747862518129301],
              [92.385856468146372, 10.751485701034689],
              [92.383789211317776, 10.755099612648415],
              [92.381860559185071, 10.759015375585713],
              [92.380243723913296, 10.761616647700727],
              [92.379638387571035, 10.764799010705101],
              [92.3806143130668, 10.769876914748707],
              [92.382324847943977, 10.773228240820874],
              [92.383895773987888, 10.776417467077994],
              [92.385626903857002, 10.779767908498632],
              [92.390862326025641, 10.779185655716178],
              [92.392341224037878, 10.776445498198196],
              [92.392374941673609, 10.772385093929989],
              [92.394154882374238, 10.766877209041796],
              [92.395776308506257, 10.763699876106893],
              [92.397121840671161, 10.7605202007076],
              [92.397869847194428, 10.756600959385134],
              [92.39803509438407, 10.753418662519644],
              [92.398242230641031, 10.747628530550509],
              [92.399001785394674, 10.742555460825487],
              [92.399467036507659, 10.739212882252236],
              [92.399359988521567, 10.735314228322217],
              [92.39998927216007, 10.72892720400481],
              [92.402496658765344, 10.724875223482169],
              [92.405394792195295, 10.724008412575934],
              [92.408462562168509, 10.72242647014931],
              [92.412725583402178, 10.718680534875203],
              [92.417506570983164, 10.719572432520421],
              [92.419813377403912, 10.723339002735953],
              [92.418168766835805, 10.72667948371946],
              [92.418744417913686, 10.729864108589675],
              [92.422632842068452, 10.732759307437254],
              [92.424644983962992, 10.735811125399584],
              [92.42652118642205, 10.738446118034554],
              [92.429123871327121, 10.740045852063368],
              [92.432446481377468, 10.743954294751298],
              [92.434664454181132, 10.747467404096058],
              [92.436548933168197, 10.752271975268382],
              [92.434653606595774, 10.757917636186155],
              [92.432302265501619, 10.762801138415925],
              [92.428466463878394, 10.76800300709535],
              [92.428156812657591, 10.77192429033205],
              [92.42711695577043, 10.77482805559368],
              [92.424312387295004, 10.778141063870446],
              [92.421851373626666, 10.776403310173791],
              [92.418806208730928, 10.775078302349657],
              [92.414913893884346, 10.775614510050476],
              [92.417462370140697, 10.781165253862078],
              [92.420628096341716, 10.784796656234814],
              [92.423221807278651, 10.787573395544468],
              [92.426534235993103, 10.793005220027865],
              [92.427819900859234, 10.797508853469266],
              [92.428806040697722, 10.801572690371454],
              [92.430369222937045, 10.805915874300016],
              [92.431494463075865, 10.809979208512436],
              [92.433362973985965, 10.814046105693484],
              [92.440346128147524, 10.815083253198097],
              [92.443972567775432, 10.815970579731683],
              [92.445826048630366, 10.818860794726294],
              [92.447422713592829, 10.821911258928228],
              [92.449700697927, 10.826717517821203],
              [92.453623270987435, 10.828597920005169],
              [92.45854480766981, 10.829788582683856],
              [92.463209539729476, 10.831533086594847],
              [92.466281703372886, 10.835464695337103],
              [92.467255843249063, 10.838351989563193],
              [92.466349695647935, 10.841787165540973],
              [92.463874448578537, 10.844758145116547],
              [92.461746272678994, 10.847405032759214],
              [92.464943081192544, 10.850414624755771],
              [92.46840492836472, 10.848647449530603],
              [92.47048883052841, 10.851860501218475],
            ],
          ],
          [
            [
              [92.587657804322873, 10.764946970134584],
              [92.586524652640421, 10.768198048548848],
              [92.585625304137309, 10.771079200599825],
              [92.584489318074503, 10.77495286908753],
              [92.581247820611424, 10.778706133414181],
              [92.579217160872375, 10.781125756272594],
              [92.57689084116646, 10.783104395760507],
              [92.571200417550969, 10.786092270665685],
              [92.568198266473928, 10.788415577456941],
              [92.566949603754296, 10.791504668711395],
              [92.57047849371159, 10.793381040366857],
              [92.575375519176134, 10.791522248323533],
              [92.579176973644664, 10.787215921646158],
              [92.582421598080884, 10.783230889802008],
              [92.584543868868238, 10.78069793726501],
              [92.586456253757021, 10.778372081272044],
              [92.590020480874188, 10.774849227466509],
              [92.592155196965606, 10.770539005030958],
              [92.591744434504164, 10.766223532701384],
              [92.587657804322873, 10.764946970134584],
            ],
          ],
          [
            [
              [92.619780308833953, 10.915901805155196],
              [92.611657996239728, 10.928952975646203],
              [92.614891877217218, 10.92697331274583],
              [92.616967183380609, 10.924668654608986],
              [92.618677376384525, 10.921855321427428],
              [92.619780308833953, 10.915901805155196],
            ],
          ],
          [
            [
              [92.47048883052841, 10.851860501218475],
              [92.469354232440025, 10.854835543437401],
              [92.47422163252503, 10.857501837370792],
              [92.477867491868523, 10.859172970645023],
              [92.482503091648638, 10.861633033024226],
              [92.485264044950299, 10.86429423470226],
              [92.486906625619937, 10.867391076507094],
              [92.489337095809248, 10.870836612436577],
              [92.4921857886971, 10.874051886832019],
              [92.495287780064075, 10.877268188574451],
              [92.498581532397139, 10.879700731624533],
              [92.503897602140228, 10.881374926480083],
              [92.507155613121753, 10.879168702722898],
              [92.506510082884787, 10.875636038497984],
              [92.503857699741118, 10.873967633410139],
              [92.500654110180278, 10.871973679921009],
              [92.500773551403597, 10.868212816887512],
              [92.504688174462714, 10.865014648642516],
              [92.502269800210712, 10.8630005839943],
              [92.49703315537397, 10.863425325437747],
              [92.492608572117547, 10.863644644826334],
              [92.488495722636699, 10.862526546115275],
              [92.486970548628406, 10.858991296919019],
              [92.485443271642154, 10.855548063046641],
              [92.482459660002917, 10.855101487057356],
              [92.478777215468625, 10.855091639647169],
              [92.475360531807411, 10.853858858605651],
              [92.47048883052841, 10.851860501218475],
            ],
          ],
          [
            [
              [92.526665300986281, 10.868161561735565],
              [92.525614181719604, 10.87279762238682],
              [92.525262530086053, 10.876674954875904],
              [92.523568597470529, 10.88020090168431],
              [92.519783881267017, 10.881530939828384],
              [92.512800010650665, 10.879967031678984],
              [92.51245135905522, 10.883497132101688],
              [92.514744758956823, 10.886595436541596],
              [92.518420628215793, 10.887621299226584],
              [92.521738877245184, 10.886844112179116],
              [92.525756625103654, 10.885307460923125],
              [92.529322024138139, 10.882315651719265],
              [92.5313633813997, 10.878350915037172],
              [92.529493729035764, 10.874468911764266],
              [92.529752200272128, 10.870476797758167],
              [92.526665300986281, 10.868161561735565],
            ],
          ],
          [
            [
              [78.697280018286378, 9.145074657689216],
              [78.694459611287371, 9.1484097452695],
              [78.694739452149051, 9.151827748953131],
              [78.698074549051, 9.150531496555944],
              [78.697280018286378, 9.145074657689216],
            ],
          ],
          [
            [
              [78.70956639611795, 9.173743750098323],
              [78.705012700279482, 9.174340668296635],
              [78.704403470356866, 9.179842537413244],
              [78.709403646843654, 9.182004829358101],
              [78.711959705527676, 9.179988402964005],
              [78.70956639611795, 9.173743750098323],
            ],
          ],
          [
            [
              [79.433171758498318, 9.14648316136965],
              [79.43050732583859, 9.147981118093268],
              [79.429378223669403, 9.153202594396511],
              [79.432865104930997, 9.154448214583477],
              [79.437665740684409, 9.15522309800102],
              [79.439682216733161, 9.149793782924348],
              [79.437790096052311, 9.146833427652277],
              [79.433171758498318, 9.14648316136965],
            ],
          ],
          [
            [
              [78.730636916583705, 9.149498154486272],
              [78.727007637461767, 9.15042060116531],
              [78.727399069641734, 9.154048173774671],
              [78.730313755982948, 9.155303017378335],
              [78.734432450204466, 9.154205899729492],
              [78.734267797271599, 9.150767734877752],
              [78.730636916583705, 9.149498154486272],
            ],
          ],
          [
            [
              [78.759956393936079, 9.154465078774525],
              [78.75605203181162, 9.155289359098029],
              [78.75482780833984, 9.158724787315659],
              [78.756525200690419, 9.161869951286638],
              [78.759796731862806, 9.162624519361469],
              [78.762158060553915, 9.159072656374905],
              [78.759956393936079, 9.154465078774525],
            ],
          ],
          [
            [
              [78.705379474503658, 9.155752042436646],
              [78.7003076342518, 9.157720759618067],
              [78.699729251174844, 9.161146812799076],
              [78.70271413343967, 9.163280672294931],
              [78.706256089613618, 9.162653664475364],
              [78.707349170588799, 9.158542467873158],
              [78.705379474503658, 9.155752042436646],
            ],
          ],
          [
            [
              [78.822226990237183, 9.161092628057478],
              [78.819040297034306, 9.161931398611554],
              [78.820037073299758, 9.168983522834049],
              [78.822973845170594, 9.170353097580222],
              [78.828970290718757, 9.170167573633901],
              [78.828089619751537, 9.165492742686224],
              [78.822226990237183, 9.161092628057478],
            ],
          ],
          [
            [
              [78.91855925060095, 9.175588273779455],
              [78.905088569081556, 9.176719713419784],
              [78.904553163807947, 9.180560161107419],
              [78.907924306632225, 9.183367428149072],
              [78.912864035721498, 9.185304072184854],
              [78.917380707590624, 9.18635731666145],
              [78.922101185906698, 9.186421919120708],
              [78.927910847899881, 9.186461411239938],
              [78.937219925545705, 9.188664296658718],
              [78.939312604671528, 9.185751922878772],
              [78.938488219115385, 9.18163244119873],
              [78.931823849831957, 9.179132549220004],
              [78.922435823707261, 9.177436111949559],
              [78.91855925060095, 9.175588273779455],
            ],
          ],
          [
            [
              [78.967668183829502, 9.18083745028413],
              [78.96261293636806, 9.182542016144957],
              [78.962090223488161, 9.185714373467075],
              [78.963765233581981, 9.188927714109493],
              [78.966977055024245, 9.190439808703825],
              [78.972783441171856, 9.188195718571116],
              [78.973340802843751, 9.183202309327802],
              [78.967668183829502, 9.18083745028413],
            ],
          ],
          [
            [
              [79.085476053904387, 9.191165974451557],
              [79.081159262153136, 9.191778747336366],
              [79.074581844673162, 9.194494720572386],
              [79.069963193985657, 9.196370717524948],
              [79.063252700013592, 9.198714537805161],
              [79.062282759814082, 9.202316888600659],
              [79.065393415129208, 9.205555593234202],
              [79.071077055829008, 9.206120765557756],
              [79.075705462767189, 9.20373859327186],
              [79.079116921543388, 9.202001582236731],
              [79.086249574837041, 9.199341927586973],
              [79.088034530949415, 9.195524024942278],
              [79.085476053904387, 9.191165974451557],
            ],
          ],
          [
            [
              [79.132302553651058, 9.209953808113967],
              [79.128219618915352, 9.210433255953447],
              [79.122214867842459, 9.213390990735945],
              [79.122148320754448, 9.217010047245783],
              [79.126885657816942, 9.21870980804399],
              [79.134724014063409, 9.215438885739124],
              [79.135458773338001, 9.212040439681456],
              [79.132302553651058, 9.209953808113967],
            ],
          ],
          [
            [
              [79.180691204528046, 9.24055836079002],
              [79.177530482633131, 9.240859460722348],
              [79.177451318713068, 9.245174831184872],
              [79.179780680284154, 9.247372700373745],
              [79.183196120796765, 9.247433885013624],
              [79.183796964175954, 9.24349058053698],
              [79.180691204528046, 9.24055836079002],
            ],
          ],
          [
            [
              [79.424292855975125, 9.166749729673567],
              [79.421677840589339, 9.170600203498829],
              [79.41888048077999, 9.174402172362321],
              [79.405130288192808, 9.181011058001923],
              [79.400721313161341, 9.182939969616049],
              [79.396463622622704, 9.185425728729925],
              [79.38827376733947, 9.190447038295545],
              [79.382596577103541, 9.194682800635038],
              [79.372575150467298, 9.202416181091007],
              [79.366139132177963, 9.206384615097218],
              [79.361873331113586, 9.208335305942271],
              [79.359207703507849, 9.210805202607531],
              [79.354372517271187, 9.214571423679963],
              [79.347920568946719, 9.218077905045478],
              [79.339614385238079, 9.224295667306146],
              [79.331108961527619, 9.23131710096521],
              [79.325963070669971, 9.234269678940702],
              [79.317034129163105, 9.237755703324233],
              [79.31379912256034, 9.239958079952489],
              [79.308983414086299, 9.242594313834562],
              [79.283946032710702, 9.253495850608125],
              [79.278860766184351, 9.255663820828175],
              [79.272889886691232, 9.258050197256894],
              [79.262394698121042, 9.261069272853875],
              [79.258687210239557, 9.261210920084178],
              [79.239624782481187, 9.260434165684421],
              [79.236610869763396, 9.260970044511916],
              [79.233703646727221, 9.260144603240908],
              [79.228723866740168, 9.257727150858496],
              [79.221420323668923, 9.258288790202846],
              [79.217393813635354, 9.267070515504255],
              [79.214542698894732, 9.273590341894376],
              [79.207848921410474, 9.27757524069477],
              [79.205569582178327, 9.283183503853687],
              [79.208331140235572, 9.28788949224405],
              [79.224185748961844, 9.293290693465151],
              [79.233080279965449, 9.294347832140959],
              [79.241842184809229, 9.293812163802968],
              [79.247220681443139, 9.293469408363444],
              [79.254818250024059, 9.291990159303234],
              [79.260223612720722, 9.291417950005119],
              [79.264312197189, 9.291950819021171],
              [79.270697976357653, 9.293447417423526],
              [79.275863668099575, 9.297158246032943],
              [79.279797334139076, 9.299020539189017],
              [79.281663003936401, 9.30553745689525],
              [79.283972818657048, 9.308413880045695],
              [79.286306918731526, 9.312536007026207],
              [79.289228352320862, 9.314846727920717],
              [79.298003442382921, 9.320027079105513],
              [79.311374924025444, 9.323282714531599],
              [79.315449136320183, 9.324621938961318],
              [79.32142249128249, 9.323389048028313],
              [79.324635004261651, 9.321162919872716],
              [79.331604224559115, 9.314691488625412],
              [79.333636753646218, 9.30981632929063],
              [79.333952804953057, 9.303850853124965],
              [79.327138664548173, 9.29646932504683],
              [79.323084353583312, 9.287545167718646],
              [79.321544903264609, 9.284336352042949],
              [79.317250570098523, 9.282164780787861],
              [79.315996827584627, 9.278546544091295],
              [79.317379323829769, 9.274979357821914],
              [79.32005639866685, 9.271838105645749],
              [79.322381523167948, 9.2686969022374],
              [79.327055043997632, 9.262415509998995],
              [79.329183608205511, 9.258602924027187],
              [79.332442469115719, 9.255040525248722],
              [79.335026463525523, 9.251673658362192],
              [79.337445516215894, 9.248758672599795],
              [79.339220690779541, 9.246306112005028],
              [79.343377226363685, 9.242966488764722],
              [79.3461460989503, 9.239603065228348],
              [79.35432373007454, 9.231538332633759],
              [79.360062731053759, 9.226474102171627],
              [79.364559885987219, 9.22348657908244],
              [79.377139426327815, 9.21383841478279],
              [79.387539296403887, 9.206987586966704],
              [79.402242753685826, 9.195024011918745],
              [79.404660447731104, 9.193083626706706],
              [79.410145896494967, 9.189212985713491],
              [79.416562315645109, 9.183698844274678],
              [79.419110434543498, 9.180999463338747],
              [79.421541669627416, 9.178297944035522],
              [79.422936790316115, 9.175371101259836],
              [79.425949960077716, 9.172472551589594],
              [79.424292855975125, 9.166749729673567],
            ],
          ],
          [
            [
              [79.199049298605061, 9.229382999454092],
              [79.195576698840966, 9.232196449423475],
              [79.197089781058054, 9.235820230254648],
              [79.199956092622969, 9.237307049611864],
              [79.201849237631919, 9.234465063328358],
              [79.199049298605061, 9.229382999454092],
            ],
          ],
          [
            [
              [79.18744262824103, 9.230973052416729],
              [79.184531649992294, 9.231998793175944],
              [79.18394255588656, 9.235584870765001],
              [79.186774841052952, 9.238869363849245],
              [79.189954875141524, 9.237491047055428],
              [79.190542259930652, 9.234262708186597],
              [79.18744262824103, 9.230973052416729],
            ],
          ],
          [
            [
              [79.20872127105855, 9.2425224383572],
              [79.206950126181894, 9.245672939402223],
              [79.211440539325039, 9.248243320836135],
              [79.215220825201285, 9.249117594080991],
              [79.21867670498753, 9.247541901338813],
              [79.216199000662016, 9.245030823149413],
              [79.211996574346415, 9.243180845334061],
              [79.20872127105855, 9.2425224383572],
            ],
          ],
          [
            [
              [78.191866663733705, 8.727252597154822],
              [78.188486891569937, 8.735111502586857],
              [78.19297376409601, 8.736093512383036],
              [78.194328917693241, 8.732589511770323],
              [78.191866663733705, 8.727252597154822],
            ],
          ],
          [
            [
              [78.231039402050243, 8.859329564016358],
              [78.22789264463772, 8.861293178492115],
              [78.227003925472999, 8.866487549326273],
              [78.232193837473119, 8.869338728338558],
              [78.2340775551327, 8.866656845641613],
              [78.231039402050243, 8.859329564016358],
            ],
          ],
          [
            [
              [78.213911768416395, 8.829229253156749],
              [78.210649963942714, 8.830406626669172],
              [78.209659553733985, 8.836774058525696],
              [78.212568923179163, 8.839186679537995],
              [78.218096204097748, 8.835388273967972],
              [78.217294638325569, 8.831120419980406],
              [78.213911768416395, 8.829229253156749],
            ],
          ],
          [
            [
              [78.256858445288529, 8.944518867882786],
              [78.252349661227811, 8.944425876696746],
              [78.25159844873987, 8.949695619073063],
              [78.252837197710335, 8.952363762139544],
              [78.256673379404418, 8.953331741425705],
              [78.259315723305662, 8.950743844653712],
              [78.256858445288529, 8.944518867882786],
            ],
          ],
          [
            [
              [78.495359057342014, 9.081510881006581],
              [78.492395462585094, 9.083872918198031],
              [78.488662855025026, 9.08649706999663],
              [78.487621178337832, 9.092171766025725],
              [78.490309101766258, 9.094277667356847],
              [78.494205850936865, 9.093893707391862],
              [78.4958707657795, 9.090536966381149],
              [78.496683304125511, 9.084673035239749],
              [78.495359057342014, 9.081510881006581],
            ],
          ],
          [
            [
              [79.485368511277855, 9.110189700257653],
              [79.482487442812044, 9.11219167772728],
              [79.484498236869328, 9.114946662248775],
              [79.490465838532685, 9.117768961601653],
              [79.491231906160067, 9.113679005728887],
              [79.488785145592161, 9.110685994397944],
              [79.485368511277855, 9.110189700257653],
            ],
          ],
          [
            [
              [79.465769548271879, 9.124584461489535],
              [79.462686441997704, 9.124876912256736],
              [79.457998707898724, 9.125603070685363],
              [79.456561845258065, 9.129658723596091],
              [79.462317375040882, 9.132662708572825],
              [79.465586097101493, 9.133664144910863],
              [79.468371219065503, 9.13191391513551],
              [79.468909394942372, 9.12761218995584],
              [79.465769548271879, 9.124584461489535],
            ],
          ],
          [
            [
              [79.477070761984905, 9.114270694879492],
              [79.472899959591928, 9.115742961742848],
              [79.4724446666727, 9.12037625410192],
              [79.476533254675076, 9.123535606502077],
              [79.479544981654286, 9.12358695384461],
              [79.481131500519197, 9.118973683443581],
              [79.479680718598317, 9.115859773402381],
              [79.477070761984905, 9.114270694879492],
            ],
          ],
          [
            [
              [78.571583263830235, 9.097682966487252],
              [78.567203314344198, 9.099188335781745],
              [78.567347541717481, 9.102373334337098],
              [78.571267754386312, 9.106485615032726],
              [78.57586275459758, 9.110472986842288],
              [78.581989145732038, 9.111953882070313],
              [78.58438176713301, 9.107226855766914],
              [78.582856164173151, 9.103346212770189],
              [78.576552529814435, 9.099164491994671],
              [78.571583263830235, 9.097682966487252],
            ],
          ],
          [
            [
              [78.538023980572959, 9.100203851147389],
              [78.533683802749778, 9.100809739676439],
              [78.5332941258565, 9.104076611401869],
              [78.536733655240084, 9.11051499117516],
              [78.539275191886787, 9.108138108182839],
              [78.539911916726382, 9.104138438473029],
              [78.538023980572959, 9.100203851147389],
            ],
          ],
          [
            [
              [92.740298701559283, 9.11545131843341],
              [92.735710326006867, 9.118128549678763],
              [92.732174147322581, 9.124862031267696],
              [92.729990987177317, 9.130772938443197],
              [92.727001558807174, 9.137507675805265],
              [92.726445539450367, 9.143144395622578],
              [92.729876976176485, 9.150963865410514],
              [92.728519986939304, 9.156347742992923],
              [92.726867041727189, 9.161457588359241],
              [92.725772434414139, 9.165215238794257],
              [92.725458040480376, 9.176262348806118],
              [92.725155673405837, 9.181098424831291],
              [92.725411378669534, 9.184605739669053],
              [92.727790862105877, 9.188367386737781],
              [92.728565583834623, 9.193204906156083],
              [92.726945847743494, 9.196435383303401],
              [92.725852523428671, 9.199392053009685],
              [92.728506585863059, 9.203703996064815],
              [92.72984100471551, 9.206410140677949],
              [92.733328036166938, 9.209095801228308],
              [92.736551292341503, 9.209901294514335],
              [92.741930324166589, 9.209378979848806],
              [92.749733655083006, 9.20560306544643],
              [92.752172737071135, 9.202923325395727],
              [92.756208002407107, 9.201574045903644],
              [92.761028391045642, 9.202930292752827],
              [92.763970546090917, 9.205087430270396],
              [92.767996017400691, 9.205365533085446],
              [92.770164704354855, 9.202134602649252],
              [92.774210490623588, 9.202939869092539],
              [92.776600759366076, 9.205096235484978],
              [92.777373323419596, 9.210759126856848],
              [92.776816844724124, 9.216398541290568],
              [92.779753799563579, 9.219357427628442],
              [92.78431923138713, 9.221515521961612],
              [92.781075533873448, 9.224745985285631],
              [92.781056473360337, 9.228529018002725],
              [92.783997713963956, 9.230663160546097],
              [92.78397517710782, 9.234721400545711],
              [92.781003995132821, 9.238479267394638],
              [92.780436213302337, 9.241986362548909],
              [92.779092156684172, 9.245218992429823],
              [92.783650142283619, 9.244671422570114],
              [92.785548802292155, 9.240362031554],
              [92.792579266286452, 9.235528262936299],
              [92.798245899833773, 9.228538554281675],
              [92.805806749751667, 9.222329420809023],
              [92.809583694673378, 9.217493780112788],
              [92.813908179405459, 9.213184954416551],
              [92.817438955204807, 9.207272163983514],
              [92.822863160962683, 9.197852607673399],
              [92.826126108067641, 9.190586992098524],
              [92.828567276070075, 9.182519169151485],
              [92.829149931704222, 9.176054979606063],
              [92.828096971454428, 9.171218131859968],
              [92.830798871514091, 9.166084541023096],
              [92.833525609599405, 9.160721899547809],
              [92.835432505901608, 9.154259281175641],
              [92.833840093385504, 9.147520859207248],
              [92.833881497749715, 9.138903934309859],
              [92.831519616305357, 9.130836123170203],
              [92.825363723352012, 9.127075585389045],
              [92.821342352152925, 9.126271996505405],
              [92.818927984472865, 9.124117327572897],
              [92.816282555740031, 9.117929028753876],
              [92.81117633206604, 9.114421362523416],
              [92.806357235671769, 9.113342132684108],
              [92.802866647578469, 9.111736690168275],
              [92.794287110244625, 9.112258870384233],
              [92.788633435441625, 9.11360814662296],
              [92.783001157311816, 9.114681426603457],
              [92.7794912358234, 9.116558458759464],
              [92.774914037253907, 9.117357457923081],
              [92.769282844870901, 9.118155406772605],
              [92.762836251534395, 9.1178984488617],
              [92.758808867279384, 9.118147661147006],
              [92.750767491578841, 9.116537214943246],
              [92.747001813447255, 9.115181814859678],
              [92.740298701559283, 9.11545131843341],
            ],
          ],
          [
            [
              [77.100038424802634, 8.291311065917743],
              [77.085446390178632, 8.30102949108136],
              [77.082884853894669, 8.303407598429262],
              [77.079128175625101, 8.306741885968217],
              [77.07497352778428, 8.309858705423766],
              [77.07025262927236, 8.313382873110635],
              [77.056289138728687, 8.324410658131931],
              [77.052143979885301, 8.328653804806056],
              [77.049032426854964, 8.331899601734795],
              [77.044158603319531, 8.335728337326609],
              [77.040371336457341, 8.339592310309031],
              [77.025982046397743, 8.351805817338953],
              [77.023123552344302, 8.355067000355724],
              [77.019993311381185, 8.356978444293109],
              [77.016156059060521, 8.356931722573064],
              [77.012490765986499, 8.357201941636868],
              [77.006440097517185, 8.360327460200857],
              [77.002778267073808, 8.369873373603564],
              [77.001497052681259, 8.372558119794173],
              [76.999476418290811, 8.377520658617518],
              [76.994941569498479, 8.378092986811469],
              [76.990327740850063, 8.375306914247126],
              [76.987610128456993, 8.37709058972318],
              [76.982739639699048, 8.380296750356001],
              [76.980254901726624, 8.384466586962354],
              [76.975048926812349, 8.389569706713061],
              [76.973251383138916, 8.392016890854135],
              [76.972505801682431, 8.402465039704138],
              [76.97172404714027, 8.410958110393448],
              [76.962172104771582, 8.422128277387834],
              [76.954012684690667, 8.431184933922779],
              [76.943222234855085, 8.441931193870571],
              [76.940075019853225, 8.444073199178781],
              [76.938169970461928, 8.446798911988241],
              [76.934189122701511, 8.451957066468921],
              [76.931083060084788, 8.455455709450762],
              [76.925388386187649, 8.46204518686824],
              [76.922251895416863, 8.465291135747812],
              [76.92030998908956, 8.46753521662813],
              [76.912721988886446, 8.476505736306512],
              [76.910668721309392, 8.478913351691268],
              [76.90253290333267, 8.488060620112005],
              [76.899446787212199, 8.491489772154305],
              [76.897680530668723, 8.494234493432275],
              [76.891947430028694, 8.500318693868323],
              [76.890934719807404, 8.503524880354837],
              [76.886464325303095, 8.507845410281002],
              [76.883458799212249, 8.512353604542026],
              [76.879351293928735, 8.516432795075037],
              [76.877974001329676, 8.519074764949282],
              [76.873540171689399, 8.523808541122893],
              [76.871155943307642, 8.526755343923501],
              [76.869429856328409, 8.529292294240671],
              [76.867258919160292, 8.533222317090804],
              [76.862739948373601, 8.538211903110181],
              [76.860481280003796, 8.542237359097893],
              [76.858499844224809, 8.545564110797466],
              [76.856762305616755, 8.548492163049429],
              [76.848678300721957, 8.558672617595828],
              [76.846516530828765, 8.562142692605782],
              [76.839883648668547, 8.569127355740752],
              [76.838626346176426, 8.571880350940591],
              [76.83618330338804, 8.574437517162803],
              [76.831335090101007, 8.580034921382355],
              [76.828521656448544, 8.58485851432226],
              [76.823667591063526, 8.589535686083073],
              [76.821773231999018, 8.592675397248696],
              [76.817760565985736, 8.597648997509289],
              [76.815145191472809, 8.601362732499624],
              [76.812065278064082, 8.605043303959965],
              [76.808552680773673, 8.609703316808073],
              [76.805934329152421, 8.61339415266996],
              [76.803779815682518, 8.61707028936199],
              [76.801999961178169, 8.619666264769638],
              [76.798085669661489, 8.623819749083752],
              [76.796398208241939, 8.626907085027677],
              [76.794833734502191, 8.629484275603582],
              [76.790812719056376, 8.632640635546135],
              [76.784887309048855, 8.639373209871236],
              [76.77881275942562, 8.645766014318895],
              [76.776042384153939, 8.648239689456359],
              [76.773622874268781, 8.650819888593039],
              [76.772103149424424, 8.6533497558374],
              [76.76903989157924, 8.656823143472579],
              [76.766191251324955, 8.660542346043419],
              [76.763430552737532, 8.664121632779157],
              [76.760758705272167, 8.667537078804861],
              [76.756523367991804, 8.672839585127072],
              [76.752341044834779, 8.678392557845484],
              [76.749354297722107, 8.683681799021972],
              [76.744281558908412, 8.68960741847612],
              [76.742773706954523, 8.692482226121081],
              [76.737666306079134, 8.697257060581657],
              [76.735496292751264, 8.699713886350313],
              [76.733952916193331, 8.702244729889088],
              [76.729797314238283, 8.7071295871418],
              [76.725595433972458, 8.712016057876625],
              [76.723887510530744, 8.715219539127279],
              [76.719470941216983, 8.719905204633317],
              [76.71820832233432, 8.723325409142324],
              [76.714475543417464, 8.727691658050391],
              [76.713432752224222, 8.730714445619519],
              [76.708971914917583, 8.734710773325091],
              [76.707712576816405, 8.737440740796224],
              [76.70350339740969, 8.742120235114736],
              [76.700351181297066, 8.746516033222951],
              [76.695594077580495, 8.751418544695092],
              [76.693680505927489, 8.75552415640758],
              [76.689899864033364, 8.759040894604837],
              [76.688398389996465, 8.762260212088394],
              [76.682651484986877, 8.768089800615291],
              [76.682306424421526, 8.771275701314412],
              [76.67986311909327, 8.77314148102117],
              [76.672234728550663, 8.780653314760826],
              [76.671733080951384, 8.79033595554796],
              [76.665982642367339, 8.793913965210482],
              [76.663351693166135, 8.795834477220668],
              [76.660403093659497, 8.798793798457876],
              [76.657648244917468, 8.800901906500396],
              [76.653567920065782, 8.805988167217576],
              [76.651767104530435, 8.80841044656553],
              [76.647334590895142, 8.814223772914751],
              [76.645437632904347, 8.818099770794037],
              [76.642678384401876, 8.82101045320476],
              [76.637087691186437, 8.827478578479653],
              [76.632207271106381, 8.832982283447008],
              [76.630022066400443, 8.835761362664336],
              [76.628268789870774, 8.838297563649144],
              [76.626546998107159, 8.841063573378502],
              [76.623478962668884, 8.84524883170968],
              [76.620589575529294, 8.848485736484479],
              [76.61725242445776, 8.852195186934249],
              [76.614678700150805, 8.855905781548348],
              [76.610895627117586, 8.859421490105698],
              [76.607124230430557, 8.863327944915101],
              [76.60422817636298, 8.866310821416221],
              [76.59537561625568, 8.87441436172894],
              [76.591637039678389, 8.877100651707165],
              [76.585577664856032, 8.88031272168152],
              [76.582651738195892, 8.881524187886056],
              [76.579978567365785, 8.883419515109846],
              [76.575421112761333, 8.884241036318107],
              [76.569961783488324, 8.881129621201774],
              [76.5668878665129, 8.882046217501347],
              [76.554646731220686, 8.889808706571083],
              [76.553154200892067, 8.892567169732425],
              [76.550316396869775, 8.896745710770029],
              [76.54739783819916, 8.906105342397497],
              [76.545745321438162, 8.919962313605188],
              [76.542716558973183, 8.929366554599914],
              [76.540483449644469, 8.934613693891325],
              [76.535970831241286, 8.944041540491463],
              [76.535261810710153, 8.950621875600079],
              [76.531513971508843, 8.962513809674707],
              [76.529607977335232, 8.97478986037985],
              [76.527474569887644, 8.982538466124097],
              [76.524380996262721, 8.993076800369577],
              [76.514662880159591, 9.017591059457567],
              [76.51202670759848, 9.02558373946008],
              [76.510589193523003, 9.031033729419814],
              [76.507376858969266, 9.040677589099403],
              [76.503198818279671, 9.05050980363772],
              [76.499905788664293, 9.057439299744717],
              [76.495662573874725, 9.066675651265372],
              [76.494287126317744, 9.069522329239176],
              [76.492565060389708, 9.07235667427552],
              [76.490691826997349, 9.07717501600168],
              [76.487086964719836, 9.082893399868912],
              [76.485077172552209, 9.086978702655095],
              [76.484209593784172, 9.089811264800744],
              [76.482463035802027, 9.092600143021471],
              [76.481860648997426, 9.09577020212279],
              [76.478914507276258, 9.09792570218908],
              [76.475741925242602, 9.103425059039377],
              [76.472041194908741, 9.109860160114426],
              [76.469172379116102, 9.11311782850143],
              [76.467027734433444, 9.117322116660977],
              [76.464207664605098, 9.124652128537805],
              [76.462739751735853, 9.129067246212092],
              [76.458111422400094, 9.142891054397593],
              [76.452784008515565, 9.152044894201985],
              [76.449749149112719, 9.158322651212213],
              [76.447778376308264, 9.160634167968833],
              [76.441076345248035, 9.176913326163723],
              [76.437765823297454, 9.184924709495695],
              [76.434302161601039, 9.19160508415408],
              [76.43028257811595, 9.201454837723579],
              [76.429049514504982, 9.206024453057998],
              [76.426034346473728, 9.21223252826254],
              [76.423019343858996, 9.217611883827345],
              [76.421066603494538, 9.220567234085365],
              [76.415926392156351, 9.23334915447241],
              [76.413528804983869, 9.237720360459157],
              [76.410783192565731, 9.244381466017783],
              [76.401012401224122, 9.273174612575296],
              [76.396208017879317, 9.28396811413263],
              [76.394004896367306, 9.28628557065149],
              [76.393789181151831, 9.29082588089042],
              [76.391745779289963, 9.29544092988837],
              [76.387481756571503, 9.305488895100114],
              [76.383661468634074, 9.315370933767715],
              [76.380797250834448, 9.318835171915969],
              [76.379040266873901, 9.321370491270308],
              [76.376050804863638, 9.328475256973393],
              [76.373185232598544, 9.331961850234563],
              [76.371744204735549, 9.336537109139796],
              [76.368142000898828, 9.343359134251225],
              [76.365035100025949, 9.349638772117],
              [76.361408333765567, 9.357221216289869],
              [76.358456901627363, 9.36250578919844],
              [76.35733784428821, 9.36541434643369],
              [76.355664402723747, 9.368476355929245],
              [76.350084951541788, 9.383801150575026],
              [76.342846857147009, 9.402694425301206],
              [76.341810156473088, 9.406084029069918],
              [76.337272032229023, 9.422231119949934],
              [76.336913796401333, 9.425877265420876],
              [76.336146563289873, 9.430640851360959],
              [76.334742835680672, 9.437354780988025],
              [76.332641640487395, 9.445630453070667],
              [76.329554043263045, 9.45506173705639],
              [76.328956396393181, 9.458439383601011],
              [76.327399119448913, 9.467090848060202],
              [76.326205576436166, 9.473131454467588],
              [76.320134619559084, 9.497216034432],
              [76.318866553966458, 9.503857207495377],
              [76.316213960663887, 9.525981083325206],
              [76.314652240315354, 9.539305343522955],
              [76.312150207641324, 9.551413036174374],
              [76.308987502245884, 9.563929989749326],
              [76.30847573060683, 9.570297328408429],
              [76.307516258492782, 9.573983680225558],
              [76.306233552110982, 9.589808895657796],
              [76.30600230835519, 9.593492318125836],
              [76.305804428087697, 9.596633372237338],
              [76.29750707597691, 9.625636101755029],
              [76.292938706911883, 9.653751755582428],
              [76.28994910169709, 9.672317125961944],
              [76.286357000049776, 9.717460101405605],
              [76.28576166872007, 9.724980033337459],
              [76.285451990228566, 9.739143652910274],
              [76.285129121649035, 9.744883944400408],
              [76.28459716967798, 9.748120435216686],
              [76.284750212998702, 9.752627842036931],
              [76.281142389683282, 9.781176389575386],
              [76.280226735301667, 9.788484394849856],
              [76.2778791864515, 9.807206257868181],
              [76.271626956224438, 9.836587982002133],
              [76.270105967546698, 9.84503184681906],
              [76.263604164636945, 9.881071689901347],
              [76.262627593569505, 9.885840101138122],
              [76.258456747040782, 9.902182206933935],
              [76.256731235506507, 9.907569937487645],
              [76.254989140768274, 9.912314032188959],
              [76.250938615774302, 9.922346992387892],
              [76.248869438282426, 9.926270830177355],
              [76.242137223923066, 9.946390057677473],
              [76.241215966176284, 9.953872400257177],
              [76.241971810902839, 9.96404730878513],
              [76.24295726114444, 9.968439002806672],
              [76.232217702359748, 9.985794982457181],
              [76.229879286823902, 9.989359588556693],
              [76.227819482408108, 9.992800488469621],
              [76.225530162009207, 9.995145549428958],
              [76.221743199738341, 9.999961980391049],
              [76.218348856924479, 10.011126195092045],
              [76.214956585612924, 10.022336893123667],
              [76.213374060044444, 10.026247533140502],
              [76.210753463328246, 10.030370926339828],
              [76.206670175956944, 10.038585424642701],
              [76.202348063933655, 10.048970615678828],
              [76.198151476937028, 10.065381724248679],
              [76.195602619393313, 10.074497222410425],
              [76.194421910129279, 10.082700276746403],
              [76.193187625349978, 10.087429776382789],
              [76.191951258766395, 10.092941284479718],
              [76.190325046684933, 10.099361954155025],
              [76.184671172213598, 10.117654089242219],
              [76.182634991635823, 10.13009294637731],
              [76.181262645846346, 10.13404332885886],
              [76.179455062605371, 10.143161213555151],
              [76.175736105371257, 10.154404178505304],
              [76.173307265249349, 10.159626511231108],
              [76.171346387655703, 10.16331708742136],
              [76.168876638624795, 10.16872515853863],
              [76.168241416758391, 10.174956655081541],
              [76.170088005755431, 10.179234849561301],
              [76.168895004335297, 10.18383201741031],
              [76.166838185856776, 10.189264743262713],
              [76.162153253200373, 10.191096925739535],
              [76.157179138485134, 10.195883239969955],
              [76.155917430986207, 10.198863741828376],
              [76.147334641497309, 10.218801033803377],
              [76.142355663680618, 10.229087860597582],
              [76.140520425183155, 10.232360801696082],
              [76.13897684752898, 10.238501962487518],
              [76.140014883367201, 10.242317507049599],
              [76.140906273631259, 10.25000257684041],
              [76.139958006225797, 10.255829338484492],
              [76.134307176546116, 10.263003854239384],
              [76.132541958161056, 10.268690590129196],
              [76.131462165260942, 10.27157438765294],
              [76.129424338773234, 10.284081483884643],
              [76.126989996296771, 10.291628340372696],
              [76.120804653579384, 10.315113036621552],
              [76.110165250400726, 10.343045936271132],
              [76.106812219926638, 10.354230817346567],
              [76.104818488122007, 10.364250742825707],
              [76.102527659205734, 10.37110298524364],
              [76.09875740441808, 10.382391771424833],
              [76.094875029378841, 10.392164277160925],
              [76.091604167443691, 10.398145191422415],
              [76.086622221784509, 10.408499974981204],
              [76.083193702786673, 10.416280877474978],
              [76.081899679640287, 10.419031980141638],
              [76.075446702004484, 10.433247137067037],
              [76.072930144193037, 10.437159425231741],
              [76.071555382674433, 10.441132793685126],
              [76.066679085776073, 10.45530452571799],
              [76.063787624367507, 10.462357128645186],
              [76.062376810645091, 10.465087990625429],
              [76.057614920305667, 10.471799927793525],
              [76.054443478307249, 10.474705437841438],
              [76.051709656984556, 10.477589348360503],
              [76.049480828228539, 10.480495487369266],
              [76.046873615326945, 10.484740074576868],
              [76.044868135528048, 10.493895933354706],
              [76.049038007768274, 10.489961998976119],
              [76.05101421962631, 10.486119310967988],
              [76.053445511822787, 10.482325436023091],
              [76.058450304948863, 10.479536288982642],
              [76.058385223926038, 10.483032071308335],
              [76.057406530117902, 10.486239327359556],
              [76.055991659800725, 10.489243107920363],
              [76.053557158234483, 10.492738843874911],
              [76.052105172049906, 10.495678229060475],
              [76.049827008766499, 10.498962667926511],
              [76.048104054510873, 10.50218499161199],
              [76.046315911254368, 10.504673510444823],
              [76.044238900096005, 10.509378648982771],
              [76.040250495797224, 10.518807840400319],
              [76.040196526019784, 10.521847525294461],
              [76.041604725665707, 10.524801347160814],
              [76.054289091716328, 10.526942466790992],
              [76.057530385230564, 10.523171626497147],
              [76.063611950477963, 10.518199914978002],
              [76.062728418172924, 10.525308575270582],
              [76.062127586070488, 10.528753984969173],
              [76.065436729348292, 10.529008832761884],
              [76.066807766259785, 10.532263040642199],
              [76.065728574856351, 10.535215195367233],
              [76.062158167039328, 10.538051097888843],
              [76.057411235865416, 10.539538290811576],
              [76.053991534233546, 10.540299055545209],
              [76.051380916776537, 10.54582451610516],
              [76.048728747149156, 10.549049049851526],
              [76.047126785397879, 10.556572411062707],
              [76.04973169179199, 10.559907948392411],
              [76.048178272687053, 10.565841940534167],
              [76.043743212551803, 10.566860024471016],
              [76.039503367273852, 10.562464513929397],
              [76.037534071147491, 10.557731062542464],
              [76.039620663525426, 10.552611018954455],
              [76.041779757942109, 10.548340442636466],
              [76.044795607937857, 10.542320985640224],
              [76.048133043763428, 10.536154452418989],
              [76.048274731581273, 10.53299696950701],
              [76.038360400580515, 10.530090802625015],
              [76.035453639289699, 10.528443758509704],
              [76.035133831018825, 10.523664881682198],
              [76.034841342635303, 10.519070303655349],
              [76.038725959966314, 10.506743892724566],
              [76.034008324980093, 10.505974538662484],
              [76.031509577607494, 10.510552912844425],
              [76.028020627382588, 10.522845967414829],
              [76.025591278919052, 10.531565177098063],
              [76.022359901485061, 10.539868516065415],
              [76.017662957905173, 10.551388660823097],
              [76.010613976852426, 10.571993423479761],
              [76.008509310294158, 10.574835663943453],
              [76.005495569916803, 10.582626881769656],
              [76.003118800873011, 10.587431544064932],
              [76.000672782635064, 10.589753367963944],
              [75.996516046421149, 10.599094825382885],
              [75.994549584053587, 10.601955374450284],
              [75.992853893355786, 10.604486940504195],
              [75.991123354801331, 10.60745633339069],
              [75.981923804227023, 10.629361844187367],
              [75.979852218611953, 10.634296250861363],
              [75.978247390774214, 10.637653772492426],
              [75.97640854575809, 10.642559376123634],
              [75.968753852635245, 10.659934161196524],
              [75.96746474562363, 10.662914786674039],
              [75.965339874033489, 10.66842671268687],
              [75.96080428475193, 10.677593396342154],
              [75.956823842366404, 10.682464321236177],
              [75.954923502874635, 10.686059764667277],
              [75.952175355554019, 10.693474710172374],
              [75.948407341211208, 10.705129797637019],
              [75.939526512102205, 10.72213164973482],
              [75.935157214958693, 10.728994446188672],
              [75.931685590333174, 10.744698399490375],
              [75.928439747969051, 10.755129800133274],
              [75.924693826619219, 10.765285034774299],
              [75.919123950906211, 10.770586925164334],
              [75.915624634528854, 10.77497098702605],
              [75.914951580314721, 10.778714697383631],
              [75.913421649023306, 10.78413582465142],
              [75.908836935831459, 10.792469989088293],
              [75.904154538970602, 10.796451648213168],
              [75.901634064571496, 10.802480533311149],
              [75.901323863990015, 10.809716779238233],
              [75.897438743118485, 10.827951420631155],
              [75.895988428203012, 10.838533902883782],
              [75.895387736094136, 10.842918059057096],
              [75.892455679945542, 10.858688419113244],
              [75.889445345062938, 10.876123689906773],
              [75.886318200224053, 10.889958633988549],
              [75.880950729646869, 10.912150069405017],
              [75.880175647775289, 10.916910946581265],
              [75.877554492433205, 10.929891630835542],
              [75.870953504416846, 10.95637185109193],
              [75.870219051480618, 10.960120434132911],
              [75.867757508270046, 10.972981726899841],
              [75.866813062450689, 10.984305551949648],
              [75.866940729540701, 10.993163413839369],
              [75.860422299024066, 11.015084470679602],
              [75.858208707984076, 11.026005409817548],
              [75.857199879812683, 11.029967058989499],
              [75.855759353197357, 11.036840086883748],
              [75.852629726743984, 11.048338547805468],
              [75.852098570774103, 11.053575988926768],
              [75.846219366834305, 11.073454747160746],
              [75.840157397092426, 11.090115506031843],
              [75.837634962304875, 11.098351958189129],
              [75.833798469060568, 11.11295280869909],
              [75.829285141334339, 11.124163541536685],
              [75.82686906039477, 11.127794269374318],
              [75.825498318197148, 11.130499847169432],
              [75.822249606010985, 11.134314065908356],
              [75.821866415777208, 11.137293256729501],
              [75.817784693236177, 11.139656211394012],
              [75.815627491666618, 11.144246734721417],
              [75.812954132340252, 11.147032665184915],
              [75.810167583735648, 11.154125810724858],
              [75.810163000387092, 11.158198569198545],
              [75.820164707437428, 11.159292709061553],
              [75.823794779976183, 11.159074486058785],
              [75.823030625658973, 11.168009983711126],
              [75.818175601359357, 11.171997740404347],
              [75.814747712804746, 11.172046712211486],
              [75.812424703018308, 11.170151712598196],
              [75.810231070791559, 11.16768299852105],
              [75.806838491621932, 11.166915866807139],
              [75.80302851693439, 11.16904110845423],
              [75.801014322993851, 11.172040404641256],
              [75.798678926525639, 11.178659325200954],
              [75.792614933501639, 11.196263506397512],
              [75.784371948642345, 11.217767063966777],
              [75.783071747767508, 11.222173442570217],
              [75.774449892899753, 11.250337640724004],
              [75.772217989439582, 11.254769136976446],
              [75.767368557739658, 11.270084203132056],
              [75.765634066818009, 11.273973341054145],
              [75.761729178780385, 11.282913185750656],
              [75.759651084064231, 11.287915014760291],
              [75.757773300152905, 11.294222268756776],
              [75.756314370117934, 11.298012194187896],
              [75.754628420263089, 11.301162495222043],
              [75.753034513537244, 11.304218837405259],
              [75.749151992721721, 11.313158126938985],
              [75.748342379466038, 11.316791937117669],
              [75.743602056186518, 11.320781867073602],
              [75.740615653875508, 11.326659160142567],
              [75.740132114694362, 11.352597964764655],
              [75.73955544948069, 11.357108964488678],
              [75.732413472218809, 11.363647373026213],
              [75.730646661634822, 11.366409286480717],
              [75.727352898473526, 11.372155526831575],
              [75.725363161952501, 11.374462570040805],
              [75.720780624898097, 11.383418964476272],
              [75.716039980621261, 11.390883300555243],
              [75.71241640174965, 11.396546494461317],
              [75.711111575214389, 11.399985893485454],
              [75.7082677333606, 11.404363865917295],
              [75.705476004270949, 11.409705476291878],
              [75.704173630012804, 11.412454245866044],
              [75.700768894099369, 11.421909604400534],
              [75.698478726332979, 11.424316186092476],
              [75.695945971865655, 11.42806339026691],
              [75.694305170742538, 11.431212086049143],
              [75.690732463257618, 11.43448055121093],
              [75.689175664512973, 11.437259910499263],
              [75.676677709052726, 11.450262853455627],
              [75.66896508330494, 11.454834341576058],
              [75.664477230442841, 11.457044032131552],
              [75.653805090503099, 11.461714546597234],
              [75.64605866392867, 11.463271577719341],
              [75.640976069110835, 11.462481640514801],
              [75.63817184742166, 11.460529464706697],
              [75.633151835805322, 11.462016774466633],
              [75.631377658890699, 11.464569719947168],
              [75.628521362983903, 11.469384118446305],
              [75.624838444413328, 11.47293065261316],
              [75.621363220374278, 11.476355660422067],
              [75.620294465430405, 11.479144177643489],
              [75.616107373507219, 11.493473646813909],
              [75.611388535425903, 11.506297423822026],
              [75.610084325675743, 11.513348628454162],
              [75.605700434583042, 11.527314551737858],
              [75.604275714486349, 11.532528628743853],
              [75.600624394052645, 11.541666132139598],
              [75.597748356413845, 11.544868046610878],
              [75.594386989838597, 11.55268711953153],
              [75.59371760198114, 11.557305133029038],
              [75.59062309430162, 11.561265229130829],
              [75.587968467335472, 11.569143429533277],
              [75.585633767482179, 11.573482793647248],
              [75.582905092577661, 11.583125098556408],
              [75.581038736809148, 11.590191161885841],
              [75.578492942024354, 11.597919306131825],
              [75.573702540980833, 11.612560711930334],
              [75.572080040136328, 11.616467938964435],
              [75.568775124617716, 11.622927458556291],
              [75.558722739055966, 11.65033619271599],
              [75.552049681609617, 11.664450416774519],
              [75.547011611715746, 11.675991245897633],
              [75.544193305217988, 11.680572735438014],
              [75.541735599793085, 11.684731700073787],
              [75.539976285727121, 11.68795091396551],
              [75.536907215302463, 11.692769338772111],
              [75.534922037780305, 11.697146070210568],
              [75.5318279591731, 11.701043921036314],
              [75.529114912124825, 11.705286215911935],
              [75.520873239307633, 11.71310163587701],
              [75.517557445501922, 11.717489213523722],
              [75.515817173665653, 11.72050067392323],
              [75.513812265172334, 11.723244005873967],
              [75.512071062822059, 11.727153603534743],
              [75.508412264918334, 11.730905043264675],
              [75.496175458094868, 11.74046334927905],
              [75.482141658246505, 11.750986246598078],
              [75.480253842746023, 11.75377316205576],
              [75.480500215372558, 11.757840107493216],
              [75.478018202425204, 11.760156461559719],
              [75.476785426850853, 11.763915620675791],
              [75.474855359005915, 11.766864310132807],
              [75.469482303375884, 11.767642427419441],
              [75.464570232005684, 11.764590941705901],
              [75.460903834899383, 11.765417430450967],
              [75.46060149641248, 11.769935731129033],
              [75.461476750648671, 11.77304313893462],
              [75.459721912136757, 11.776492935169422],
              [75.45783960794742, 11.779461793116853],
              [75.455152149773312, 11.782037158119829],
              [75.453844666420721, 11.784716347786702],
              [75.447094143068597, 11.789924709407703],
              [75.441664955873946, 11.794847021740877],
              [75.438656204459704, 11.797614041463879],
              [75.428228700764919, 11.806939671440801],
              [75.426053782446189, 11.811296872676497],
              [75.422456408958311, 11.814791780028298],
              [75.420292521803205, 11.819586357715872],
              [75.417616188234518, 11.82262023374499],
              [75.416760346026578, 11.825586704393539],
              [75.414315467641302, 11.828592873184975],
              [75.411692034884197, 11.83183349692395],
              [75.410221643359918, 11.83458545218337],
              [75.400316789885068, 11.841619315148666],
              [75.396822195935002, 11.845548852989273],
              [75.393916818457896, 11.848774094308354],
              [75.39100637033404, 11.851790242084043],
              [75.388848285932937, 11.856837054825123],
              [75.384333690429912, 11.860124413476056],
              [75.377197859221482, 11.859611101819857],
              [75.373352647702376, 11.858117715612673],
              [75.370842826992941, 11.854106626922185],
              [75.368497347115607, 11.851886805546423],
              [75.363011530853413, 11.851056465249133],
              [75.360314041742157, 11.852410038025029],
              [75.357750761424839, 11.854430212180686],
              [75.356344656471819, 11.857870130287662],
              [75.356211450842423, 11.866248522862225],
              [75.353293567761284, 11.869035746661],
              [75.351788096410459, 11.872247650304821],
              [75.349320926077311, 11.874356979645622],
              [75.343481254173824, 11.880689818264312],
              [75.340584975186843, 11.884304401391448],
              [75.336576140315458, 11.88916665660078],
              [75.331638815996882, 11.89425769534135],
              [75.322314286774059, 11.897661326934285],
              [75.32081914149893, 11.902208353670915],
              [75.320567837821713, 11.905830093784589],
              [75.32390321370724, 11.908284774082885],
              [75.32158925632352, 11.910357057622278],
              [75.318723803871052, 11.918803617054936],
              [75.315156141331769, 11.922732388567306],
              [75.312972399285357, 11.927779413971921],
              [75.310814041317471, 11.933723168973184],
              [75.309674263462668, 11.937592821532503],
              [75.309418192883911, 11.941235107840161],
              [75.314295427859378, 11.942910951535085],
              [75.321375330982974, 11.94114928743088],
              [75.329732381831747, 11.936342592222152],
              [75.33336488882054, 11.934068348675162],
              [75.335857508262464, 11.931981436424168],
              [75.339682248206429, 11.928159995896349],
              [75.34237650056815, 11.926622167818056],
              [75.346273852738918, 11.925605516684801],
              [75.349629350656869, 11.927109878570366],
              [75.34983365710444, 11.933226111441876],
              [75.341467209945989, 11.94123259627696],
              [75.337794114078775, 11.944613019622551],
              [75.333059618990418, 11.948571793476074],
              [75.33007592061368, 11.949725680663434],
              [75.323726866698905, 11.952643361237122],
              [75.321992867882628, 11.956090351413103],
              [75.319716174663171, 11.964774737734768],
              [75.31917232723832, 11.96937066880745],
              [75.318608170279106, 11.973316327287458],
              [75.314615065261293, 11.976547247365847],
              [75.311432255111683, 11.974703197874607],
              [75.311467487262263, 11.969598909507924],
              [75.306696296328624, 11.968820021755949],
              [75.303911861600142, 11.97096423118748],
              [75.302219376750713, 11.974296850489559],
              [75.300506499204332, 11.978192111635696],
              [75.298793362003366, 11.982090785389117],
              [75.295926396845687, 11.985933152672612],
              [75.29308424948438, 11.989211956495003],
              [75.288262222321677, 11.989565147988531],
              [75.288077457071196, 11.985206962968187],
              [75.289002680740509, 11.979675512395232],
              [75.290329748596321, 11.976790011431195],
              [75.292724050760938, 11.971762439469106],
              [75.296208906340837, 11.965220753168781],
              [75.298155778234019, 11.962202895672357],
              [75.29965365480399, 11.95886134782633],
              [75.301150096965756, 11.955524276461462],
              [75.299384584291914, 11.952041191146298],
              [75.296096333869059, 11.952464144899428],
              [75.292129641767104, 11.955126259727662],
              [75.288141185240519, 11.958353072016205],
              [75.284291094376073, 11.962721316214258],
              [75.282127059598011, 11.965692663532412],
              [75.279299834680515, 11.969351133447322],
              [75.275750115013494, 11.97307275836369],
              [75.273951659963885, 11.975832023638956],
              [75.272036240027091, 11.981330302388798],
              [75.267801029473489, 11.986588466155585],
              [75.265207491874165, 11.993024046690895],
              [75.2585093501568, 12.000688367644939],
              [75.256745233987218, 12.003883069698235],
              [75.254542429932641, 12.007319152973427],
              [75.252767308231938, 12.010099951790284],
              [75.251447596940054, 12.013306631842456],
              [75.249251815940724, 12.016098100662214],
              [75.243371346605386, 12.020979256694337],
              [75.236070993360485, 12.023411904341792],
              [75.230298573063592, 12.022423764889865],
              [75.226546097856797, 12.019109197716736],
              [75.222795904144377, 12.013146931375074],
              [75.220245611304989, 12.011115955267352],
              [75.212164917906946, 12.006685451663918],
              [75.208883573601227, 12.002554800368195],
              [75.204975913446503, 12.003315751010309],
              [75.201880080242688, 12.017655408975102],
              [75.19922296474617, 12.025288431026302],
              [75.196649681433684, 12.028893866164587],
              [75.192661291029026, 12.03938851113149],
              [75.186499940717866, 12.052720674289098],
              [75.184798823399618, 12.055660588436696],
              [75.182963639782017, 12.060740693985819],
              [75.178636227553724, 12.072719307800167],
              [75.174039456318482, 12.08322906462425],
              [75.172511542094611, 12.086602269967656],
              [75.169220413385474, 12.094204165842802],
              [75.166223753328396, 12.098692603711559],
              [75.163220223106038, 12.105712954600371],
              [75.161374055733958, 12.110381887749247],
              [75.159900366443026, 12.113086679167369],
              [75.156901460066507, 12.121232993027126],
              [75.155960831033013, 12.125650489553697],
              [75.149023840129814, 12.140840012044061],
              [75.146986556376334, 12.144431124907333],
              [75.146088703470625, 12.147812388556412],
              [75.143314235234385, 12.154666006075354],
              [75.135552911405739, 12.175281662867182],
              [75.133058952270375, 12.181230324593177],
              [75.129930832713171, 12.18701073807688],
              [75.121901391040367, 12.208206417109174],
              [75.118019283603317, 12.21662656817548],
              [75.116548544311627, 12.22050437002691],
              [75.115081231982359, 12.2244965503582],
              [75.11207324049613, 12.232148544219363],
              [75.110932931298549, 12.235408209355443],
              [75.108510175245783, 12.239537693331117],
              [75.106109279198321, 12.244587360694881],
              [75.102468545611558, 12.256222707055116],
              [75.099564513481809, 12.263537765884776],
              [75.093868376322192, 12.280008739117401],
              [75.090416691995131, 12.288901140752474],
              [75.087294830986764, 12.295094813421338],
              [75.08532288019471, 12.299488562641988],
              [75.080785560859482, 12.309948195663953],
              [75.076548123973694, 12.318307969414253],
              [75.074832309201327, 12.320856395141027],
              [75.072010777614963, 12.327823789465386],
              [75.069775432160966, 12.330131115361329],
              [75.068574075212211, 12.333563936647687],
              [75.066088323798184, 12.339052751786561],
              [75.061934328733315, 12.347984760361712],
              [75.05726135517672, 12.357734349543763],
              [75.055420283060343, 12.360859300562995],
              [75.049468094016206, 12.374779354195748],
              [75.04626314150255, 12.380491630599961],
              [75.045323411804532, 12.384147966360414],
              [75.043082157199947, 12.386225480826498],
              [75.041123716521142, 12.390366254864569],
              [75.035686846570854, 12.394772317721172],
              [75.030306455708242, 12.401477210283655],
              [75.026978452546686, 12.406086419092082],
              [75.023857644924092, 12.410485144096766],
              [75.021240800823264, 12.416411791354667],
              [75.017435186134932, 12.420573563055603],
              [75.015476745892059, 12.424689634661865],
              [75.012793222761431, 12.428847300314503],
              [75.00947076841922, 12.433663876186554],
              [75.0068336925208, 12.438717555931763],
              [75.005247399661698, 12.442383570383193],
              [75.003781531024785, 12.446011375912667],
              [74.99855922167815, 12.458371843967802],
              [74.995654602696007, 12.462075403271607],
              [74.994382239654541, 12.467534386233526],
              [74.99448698820423, 12.47183208198795],
              [74.995784214792735, 12.477002775554705],
              [74.994825667222372, 12.47994631707982],
              [74.992520989259944, 12.486048732096283],
              [74.990511889340439, 12.49179117851088],
              [74.987663376850293, 12.493029961192157],
              [74.986400050067445, 12.490236694165489],
              [74.985168186623028, 12.48675590841289],
              [74.980922609290545, 12.487931784232485],
              [74.979637831279618, 12.493006955519908],
              [74.972371142743611, 12.513385146571773],
              [74.969049905752016, 12.521214704528786],
              [74.967109061258228, 12.524158993335638],
              [74.964827595424183, 12.530491683199273],
              [74.961816747928395, 12.535759967523969],
              [74.960212064569433, 12.539063731486767],
              [74.949726227947181, 12.568198736698315],
              [74.946698482426555, 12.572777318438009],
              [74.945433921997036, 12.576671933164892],
              [74.94305698905022, 12.581994546193714],
              [74.940953681573788, 12.586987741173321],
              [74.939225986547086, 12.591077009491423],
              [74.936186210029035, 12.599980199262173],
              [74.93265837475532, 12.606180216366644],
              [74.928909938889504, 12.617791586983451],
              [74.925435306508575, 12.624220853475588],
              [74.923276822054078, 12.628893718368058],
              [74.920114041788793, 12.635661146508694],
              [74.917246010573166, 12.645962905103596],
              [74.915822692791821, 12.649124738733681],
              [74.912912231371038, 12.654710561340968],
              [74.911630699311061, 12.657891915182205],
              [74.909258828179148, 12.663536168240592],
              [74.907039818700142, 12.667658475500007],
              [74.901575679105349, 12.681056078792082],
              [74.900037179259783, 12.684358510357113],
              [74.896402143535511, 12.693895571145806],
              [74.893734171669323, 12.699891355856662],
              [74.890003942028969, 12.706532069617786],
              [74.884904478039218, 12.711777795574163],
              [74.878602414929958, 12.728981865693699],
              [74.86989061758031, 12.744984261425811],
              [74.864071900126589, 12.755334723513055],
              [74.863011839660288, 12.758254862157901],
              [74.860761612113947, 12.769759484834768],
              [74.859660402921591, 12.77329382349059],
              [74.855412105346886, 12.7771630250108],
              [74.852645896727822, 12.781981535832461],
              [74.849932524700932, 12.7854186254069],
              [74.848117834318288, 12.787924174701859],
              [74.846786948329139, 12.791806247068605],
              [74.840717288475886, 12.803475924180463],
              [74.838488015466112, 12.80842676118322],
              [74.836723351888054, 12.813118797189205],
              [74.834696096198385, 12.81730728749474],
              [74.831580368273336, 12.824293771118768],
              [74.830497197934406, 12.827413729182906],
              [74.828347693356619, 12.831258654252508],
              [74.826596011670077, 12.837578339966548],
              [74.823992194012348, 12.848807296139032],
              [74.822420221822384, 12.857082627460294],
              [74.818857306526866, 12.867732894058367],
              [74.81704990354477, 12.872886896369913],
              [74.814881037950371, 12.87914792805268],
              [74.810151387496774, 12.885898273390474],
              [74.807101175207094, 12.894656737443054],
              [74.805391109954925, 12.904135250854587],
              [74.804531643257448, 12.910498698271104],
              [74.802581872961355, 12.93132903926252],
              [74.799117074931473, 12.958621487641002],
              [74.796875022311497, 12.968637333557959],
              [74.791481921313348, 12.992910814903057],
              [74.790218323698411, 13.004711005131666],
              [74.784747125660516, 13.022425726886826],
              [74.784338360537916, 13.025467970281362],
              [74.782853408820358, 13.030341237884008],
              [74.782822201366201, 13.033701793306486],
              [74.782598568550696, 13.040587212476124],
              [74.781591715867975, 13.054266888164289],
              [74.778576149825469, 13.056979976683847],
              [74.777267061129308, 13.061002091080647],
              [74.77550820527965, 13.065020893933051],
              [74.772398449776063, 13.069503448039608],
              [74.772444134927724, 13.073511109286919],
              [74.776527374926104, 13.071245086117584],
              [74.7779902624237, 13.068374465650686],
              [74.781866089348114, 13.058107854289485],
              [74.783478373056667, 13.070089014097704],
              [74.78170226033015, 13.075986825933105],
              [74.779344436974895, 13.090390348633314],
              [74.782660648353016, 13.096316610269049],
              [74.787214465777794, 13.097139483047359],
              [74.789898667109256, 13.099142742977509],
              [74.789934901355181, 13.1022568331496],
              [74.787706421416203, 13.104502128045489],
              [74.784001953975604, 13.103116486065129],
              [74.777803774326344, 13.102721040318723],
              [74.775246272119574, 13.099802120133605],
              [74.774312529980335, 13.089844758457241],
              [74.771650835455446, 13.086028369981914],
              [74.767290010674117, 13.088791733186516],
              [74.763030201906759, 13.118737831274645],
              [74.756202326679272, 13.14896545430272],
              [74.754106588248561, 13.1639261918193],
              [74.751690360675539, 13.173458489987315],
              [74.749068887534236, 13.185501811453944],
              [74.74563558884357, 13.187794069162953],
              [74.743756284214982, 13.19315320982483],
              [74.74095629791411, 13.199858664019125],
              [74.738709458835515, 13.20374876667074],
              [74.736303253035331, 13.214201295551797],
              [74.735583579298293, 13.218742654476936],
              [74.730124492474104, 13.242532556484818],
              [74.728430021894837, 13.251872038839791],
              [74.723665934651081, 13.264926957015282],
              [74.722164362304255, 13.268602416246869],
              [74.720400588645958, 13.271911817901259],
              [74.718192421029443, 13.277252064536915],
              [74.716568680336479, 13.28053798186002],
              [74.714101542716037, 13.287814239460122],
              [74.712098567865738, 13.309402525185034],
              [74.709842989419698, 13.318886688410075],
              [74.706518302356201, 13.327022260004735],
              [74.704212681842662, 13.330061809716847],
              [74.700606125960917, 13.338016452681034],
              [74.702158139434758, 13.342129038389384],
              [74.709545235628354, 13.332009337883271],
              [74.71157862259129, 13.329755802185929],
              [74.712786707582254, 13.326958919547058],
              [74.719217944256783, 13.312229845660752],
              [74.720206531410767, 13.298270563154784],
              [74.720420434506352, 13.288186596501717],
              [74.722827439112123, 13.285905655104095],
              [74.725782322970161, 13.290714553369781],
              [74.72366254643444, 13.297210066409631],
              [74.725218050899443, 13.305096621726712],
              [74.723820571131242, 13.31372907493312],
              [74.725157758570148, 13.318291958156312],
              [74.723378472080483, 13.324409290945662],
              [74.720971920905995, 13.32671325987487],
              [74.719577722141494, 13.331677000189343],
              [74.718075374060888, 13.335352038256675],
              [74.714250218704564, 13.340593252274804],
              [74.710131959093005, 13.344709877256481],
              [74.707846671423738, 13.347448862364573],
              [74.700048936141201, 13.348909505632571],
              [74.69594402696724, 13.352105149700893],
              [74.694601850965412, 13.357574422789096],
              [74.694762607114612, 13.369957124972965],
              [74.695532982633551, 13.378165640310101],
              [74.694871859264751, 13.383881037919313],
              [74.694871275460756, 13.388046985789018],
              [74.694135945000525, 13.397653654419406],
              [74.690771583237179, 13.419162933547076],
              [74.690337461018203, 13.422275617594119],
              [74.687386434808175, 13.436806657952744],
              [74.685896249012643, 13.441701141716116],
              [74.686343888699014, 13.450374084072916],
              [74.6882083795375, 13.453877481752766],
              [74.690820077303187, 13.450950089860369],
              [74.694922261133058, 13.436729941746869],
              [74.695690584077397, 13.432233499046681],
              [74.696282051412695, 13.424378831649753],
              [74.697690094741532, 13.420542668575081],
              [74.699646356445996, 13.415505234954839],
              [74.70522458107969, 13.412041908948337],
              [74.708837049514045, 13.407708162760642],
              [74.709340796767137, 13.404366461114913],
              [74.712715118415701, 13.40264450399107],
              [74.714434487900988, 13.405997837712432],
              [74.717487813046105, 13.403768091879316],
              [74.721522692687415, 13.402575330887801],
              [74.725281407744546, 13.401868974317598],
              [74.732194780393172, 13.402719026772772],
              [74.734434035300168, 13.400002947799228],
              [74.737613376466157, 13.391545492555588],
              [74.741930456249136, 13.388439547072233],
              [74.745392615317769, 13.390406149711753],
              [74.745054741998203, 13.393631325403581],
              [74.74308865494605, 13.399729540171668],
              [74.740470590916829, 13.410322021499715],
              [74.739006794478144, 13.413282856296133],
              [74.732565990167032, 13.414915239722927],
              [74.723828012948672, 13.416155354621392],
              [74.717604743826456, 13.418359898053732],
              [74.714202519253618, 13.419660725703064],
              [74.706665940436608, 13.425860317283851],
              [74.705231372383054, 13.431537353954873],
              [74.706777323217253, 13.435826587818493],
              [74.709782357904643, 13.436693994030865],
              [74.712793252731444, 13.438021312085139],
              [74.716259047517312, 13.440264861846929],
              [74.717385195478712, 13.448884534170736],
              [74.718486227063991, 13.453154715533886],
              [74.721540676811216, 13.456300199201483],
              [74.723722006824232, 13.458763563075291],
              [74.730085162011704, 13.458467839411638],
              [74.741303706783043, 13.45499133875818],
              [74.745693239200037, 13.454002829912993],
              [74.749621721676206, 13.455779764640642],
              [74.750134084293421, 13.459619387443926],
              [74.74327294201268, 13.463557168419678],
              [74.739353849185292, 13.464702200707904],
              [74.739997417835937, 13.47194597007687],
              [74.7355636679425, 13.475191046752649],
              [74.731867925833626, 13.475436841720443],
              [74.722269198940268, 13.471138646761066],
              [74.718169369664224, 13.468694984275128],
              [74.714822888096947, 13.462514043265193],
              [74.7123154594005, 13.45593409800102],
              [74.709083390861366, 13.451546736066335],
              [74.706423495911835, 13.443978486459262],
              [74.701808955937452, 13.443587769498841],
              [74.698643971946296, 13.459917273335867],
              [74.695817619318632, 13.464618366516333],
              [74.691013272159736, 13.462042819014917],
              [74.688453410729764, 13.465475811723033],
              [74.685489042406644, 13.472549026261939],
              [74.683050957136174, 13.489123312112863],
              [74.681694985983057, 13.502003751039297],
              [74.681071050589452, 13.526039944964728],
              [74.678588882322387, 13.5408423342497],
              [74.677848117079805, 13.548008656626994],
              [74.676885952096782, 13.554186268651502],
              [74.674833616249302, 13.56776502032915],
              [74.672409163363525, 13.59432837537112],
              [74.671953908267312, 13.599741149706121],
              [74.668796894465686, 13.610844335283247],
              [74.668086335883558, 13.614419412666805],
              [74.667912740813051, 13.619968371756224],
              [74.666078644823017, 13.62355444146379],
              [74.663723062876301, 13.630932100717816],
              [74.667255576514947, 13.632633921315586],
              [74.672296724178665, 13.631019036863204],
              [74.675146514327324, 13.62394691681259],
              [74.676317808417309, 13.619653580007236],
              [74.677277730222869, 13.611059171511098],
              [74.678509203656446, 13.608054549816476],
              [74.682422259251226, 13.608268316596218],
              [74.684444467560326, 13.619572854356495],
              [74.681838034861457, 13.627517107964012],
              [74.680842953920688, 13.632866643527196],
              [74.683423799450708, 13.637467929505799],
              [74.687136667691718, 13.638558349109269],
              [74.693819518693871, 13.63918162949847],
              [74.697481536712388, 13.6357377821528],
              [74.697986687433058, 13.632694798796059],
              [74.697391147232366, 13.62759042483882],
              [74.695043184172178, 13.62489788900452],
              [74.694648990572787, 13.62103486254437],
              [74.703024256048153, 13.615979170691775],
              [74.70659957488482, 13.615251894786574],
              [74.710164940520798, 13.61567667489256],
              [74.71170066377266, 13.618975061339238],
              [74.714840026514807, 13.621198562577414],
              [74.719334280976042, 13.620946730858439],
              [74.723596912879117, 13.621451869455377],
              [74.721141535667613, 13.625439853888787],
              [74.713795912433099, 13.630439836955206],
              [74.711024688669738, 13.63194056782843],
              [74.707604579286539, 13.638236167975137],
              [74.712042888940047, 13.639227539623606],
              [74.723647836822522, 13.635955578254372],
              [74.728133900132946, 13.634965972233642],
              [74.735263564374449, 13.635768888545844],
              [74.739211201755651, 13.639217233985253],
              [74.734815539451361, 13.639505367296701],
              [74.730909447553799, 13.640022514601167],
              [74.728743160898432, 13.642691006629722],
              [74.729036003099708, 13.646535389089181],
              [74.723773045459197, 13.647187115876202],
              [74.714206728907826, 13.648481789118931],
              [74.711192313597394, 13.649041288421252],
              [74.704592238070788, 13.651755255441046],
              [74.701825438316192, 13.653578706621277],
              [74.699888260658867, 13.656314178414016],
              [74.699813212430072, 13.660182182123664],
              [74.703921380217167, 13.665135716373429],
              [74.707758574254228, 13.668916954312515],
              [74.707256552432952, 13.672319367403647],
              [74.703428268366494, 13.673517892109867],
              [74.695528814659667, 13.666785214088499],
              [74.690375898430247, 13.668976990212386],
              [74.687256600497605, 13.670734679700068],
              [74.679480132582981, 13.675116711018514],
              [74.682312276284748, 13.681211336616204],
              [74.690584243845365, 13.687781055624257],
              [74.696870745498487, 13.690686444164443],
              [74.713300946886577, 13.696708730599175],
              [74.699345141856654, 13.696208499535638],
              [74.695935573476149, 13.697187368088754],
              [74.692621005309078, 13.698301611080682],
              [74.691299627159196, 13.701721770012472],
              [74.686542767763868, 13.699583262591085],
              [74.681820920549598, 13.700481522957011],
              [74.680285872439384, 13.70371923315407],
              [74.678627109443866, 13.706245257069018],
              [74.668168990750544, 13.71378855288976],
              [74.675696879859913, 13.701877406731878],
              [74.677109962445684, 13.698204183160788],
              [74.67777951706276, 13.690969659318457],
              [74.671853100600643, 13.6803260916738],
              [74.669590843872598, 13.668425574479201],
              [74.66907594624827, 13.65349220326538],
              [74.669024232903482, 13.648705791159257],
              [74.667305972542351, 13.641564253305146],
              [74.66282486166962, 13.64301337430407],
              [74.661084090549892, 13.648783893622301],
              [74.659216958993326, 13.651541696303298],
              [74.656180154995553, 13.654495382057],
              [74.654362261885012, 13.65745899347651],
              [74.652798229924599, 13.660191374297854],
              [74.6505044871232, 13.662492389914249],
              [74.647174262681077, 13.668647645110752],
              [74.645300794806332, 13.672970309018966],
              [74.642930095623441, 13.687701670056301],
              [74.640490706073962, 13.696104188765991],
              [74.639937050534229, 13.701264779163742],
              [74.63952878940691, 13.713352011885169],
              [74.635841104896372, 13.72335441706795],
              [74.634372948719715, 13.726315885243832],
              [74.63243352305976, 13.729027186785299],
              [74.631385874152173, 13.749200008722145],
              [74.628777067706508, 13.76600496614677],
              [74.627999493510444, 13.77869485081394],
              [74.627264986238444, 13.7822919595584],
              [74.622842578816872, 13.79840116484163],
              [74.619994466429944, 13.805977397823035],
              [74.619382469510825, 13.812312725550916],
              [74.616127656979472, 13.825831920158175],
              [74.614304845601453, 13.835240821295631],
              [74.612281201470253, 13.841152017281681],
              [74.609337599169365, 13.848660522248288],
              [74.606508653226371, 13.858530921474353],
              [74.612336695450807, 13.85516819746633],
              [74.61504914909051, 13.852288847421692],
              [74.621146250214466, 13.848086185904318],
              [74.624742885707676, 13.848948794258558],
              [74.623956782351556, 13.852133750903242],
              [74.625141558402021, 13.855504864948648],
              [74.626326276444743, 13.85889986202004],
              [74.622568307917348, 13.860432641597807],
              [74.619208387328896, 13.861937993649164],
              [74.618090071306284, 13.864871914780322],
              [74.614156126955507, 13.863091736061072],
              [74.608420435563659, 13.866116142759873],
              [74.605223216004248, 13.869760496861616],
              [74.603163210048905, 13.872265322729929],
              [74.601808820121306, 13.874995035605064],
              [74.598374471298982, 13.878433964600637],
              [74.589214790127926, 13.908189613034569],
              [74.587045509878024, 13.920453993471442],
              [74.582354533521809, 13.925909720036065],
              [74.579519307150932, 13.927315367162295],
              [74.576647944408293, 13.933096609999112],
              [74.57500468808739, 13.939602764314531],
              [74.572499848161328, 13.942318995359624],
              [74.571050992432077, 13.945071453167101],
              [74.566817593595772, 13.94851701449949],
              [74.556435222831411, 13.951560955130221],
              [74.551747983267958, 13.951834922072695],
              [74.53759556972787, 13.96011443637148],
              [74.536394537081009, 13.966454944708703],
              [74.540003571796035, 13.968468695631838],
              [74.540271364696054, 13.971643031969771],
              [74.537517448130274, 13.973026169159057],
              [74.533155010133356, 13.973135639907948],
              [74.530109961929412, 13.973532670900497],
              [74.522897695932969, 13.979352521082737],
              [74.521070904038936, 13.981878320202652],
              [74.51917377077433, 13.98451870718268],
              [74.517118369129747, 13.987690918919336],
              [74.51238656661458, 13.999978975886014],
              [74.510686337812402, 14.012675009856288],
              [74.509195545484147, 14.016117774039973],
              [74.505935901789812, 14.025492708748194],
              [74.507843359807424, 14.030859865029585],
              [74.505714599087213, 14.033779550869077],
              [74.501024617384402, 14.041071253595501],
              [74.499035768354034, 14.048592215192798],
              [74.498245192670296, 14.063329613648143],
              [74.497028374082788, 14.068310891153978],
              [74.493083546762392, 14.077437588118958],
              [74.490088721074287, 14.082988340312511],
              [74.48863874430252, 14.085832162357393],
              [74.483538980988428, 14.099180882095473],
              [74.48314807780983, 14.102406394788277],
              [74.484026023423354, 14.119843274369357],
              [74.483599174463606, 14.12415103350035],
              [74.481121411091735, 14.129833990608713],
              [74.477974249617461, 14.139137804405046],
              [74.4776380745475, 14.152534317681182],
              [74.474565431980011, 14.16931610208627],
              [74.468922197787606, 14.182715555203929],
              [74.467178467743736, 14.191568295654253],
              [74.464942352822348, 14.198169183732142],
              [74.462647789979599, 14.201135747378054],
              [74.454951061397523, 14.204127094298833],
              [74.449285063739836, 14.215292776162707],
              [74.445541742649212, 14.223932288898308],
              [74.444237995803277, 14.232320817991186],
              [74.439737520442549, 14.247641907320487],
              [74.438079367628646, 14.253431819541408],
              [74.436160467541015, 14.256625266543731],
              [74.432386020948087, 14.262112052339422],
              [74.432659806419835, 14.266182859940127],
              [74.437819903950086, 14.265470201272539],
              [74.449129624418191, 14.259457140821288],
              [74.452544023275777, 14.255561179078976],
              [74.458125728684792, 14.249988699205669],
              [74.462458869034393, 14.251192440176775],
              [74.47013522745921, 14.255635767105675],
              [74.476641774484619, 14.253460530099719],
              [74.48964511123755, 14.24789017800733],
              [74.496583574358723, 14.244330321384263],
              [74.503098737213136, 14.24298274530222],
              [74.515895894629409, 14.240427112856516],
              [74.527091001400478, 14.23973524255574],
              [74.517658649649903, 14.245175328248424],
              [74.512132390863044, 14.249161026405549],
              [74.509191654944161, 14.253284203680831],
              [74.506185131917661, 14.25568133429071],
              [74.500432058948206, 14.258081374622551],
              [74.490998989256667, 14.263597453025056],
              [74.489882190692569, 14.26703590954031],
              [74.489940242432596, 14.272927296279512],
              [74.488297984351092, 14.27782114141637],
              [74.485138772252469, 14.281370741072774],
              [74.479878882081749, 14.283878951124258],
              [74.473647537964638, 14.28324466730974],
              [74.470717382156394, 14.288586807967041],
              [74.468735861089115, 14.291906305484366],
              [74.465214741648495, 14.287875239458554],
              [74.460710070811587, 14.283611826574379],
              [74.45720368485587, 14.282951859415588],
              [74.449327766005439, 14.279845531937529],
              [74.445178074510608, 14.280572854457935],
              [74.437795004403498, 14.28468781165893],
              [74.435615677654511, 14.287559530152773],
              [74.431321956529047, 14.297792173824668],
              [74.425994789601489, 14.30493577331954],
              [74.427057206130399, 14.296425989221193],
              [74.427263355625769, 14.29340870699062],
              [74.428750144749074, 14.289345723785431],
              [74.432296831709323, 14.279603360740596],
              [74.431367117714913, 14.272995793675149],
              [74.42756458132213, 14.278493781202693],
              [74.425521227677621, 14.280950272102832],
              [74.422667440543421, 14.28939865347407],
              [74.418442783850494, 14.301953842508278],
              [74.414027473375668, 14.311842095768235],
              [74.410471256185929, 14.330604757266313],
              [74.408708735313866, 14.345016009411186],
              [74.408160894925444, 14.349495328009798],
              [74.404566461605029, 14.364277633446946],
              [74.403445556537733, 14.367462503717027],
              [74.404308865161894, 14.371736330139059],
              [74.405612201048683, 14.375360654414884],
              [74.404990654008245, 14.381695207452738],
              [74.403192301743616, 14.387854143778293],
              [74.398347944184579, 14.404764564611259],
              [74.397369977083983, 14.408270329466307],
              [74.397419271911858, 14.413471684884637],
              [74.402989291632352, 14.419022802342411],
              [74.394466794322767, 14.419387058138128],
              [74.38708186133384, 14.42126788831473],
              [74.385271555007478, 14.423767947481991],
              [74.381408364580906, 14.442786244408643],
              [74.379935228814361, 14.448736619669152],
              [74.37544974757418, 14.464168868361593],
              [74.370699972781821, 14.474104474008477],
              [74.367509571570821, 14.479883738226118],
              [74.362811775969476, 14.485445592742661],
              [74.359169286651763, 14.495762236118825],
              [74.35795261179436, 14.49897141241834],
              [74.356446050540868, 14.506625326969356],
              [74.356672344908461, 14.51053376812273],
              [74.362051539762419, 14.515022167597902],
              [74.364290148806234, 14.520665350993921],
              [74.370001362015856, 14.522895976145239],
              [74.373205238626838, 14.521050778367375],
              [74.375490885279191, 14.518983995896509],
              [74.377109549552003, 14.516024589893155],
              [74.378320420389485, 14.509801940844408],
              [74.376548182681574, 14.506295935328319],
              [74.373268153605224, 14.502456441066768],
              [74.3731014771014, 14.497257818978822],
              [74.377819360845365, 14.493835931438015],
              [74.379531214917662, 14.490875942033432],
              [74.380295770366473, 14.48723295317925],
              [74.375170267859147, 14.484560148382611],
              [74.375368836768928, 14.480715448982126],
              [74.378121411315377, 14.478413941145023],
              [74.381091722244562, 14.47431588351427],
              [74.380430638759577, 14.463920483686293],
              [74.385606257974018, 14.459343390509977],
              [74.385760386972464, 14.453220810023051],
              [74.390127276476619, 14.450238185437543],
              [74.395940778176012, 14.451040697922553],
              [74.405368832111535, 14.448705363124184],
              [74.410247099843758, 14.450067191439182],
              [74.411008125156116, 14.455929243843691],
              [74.410263472855135, 14.459272520174748],
              [74.409921673001818, 14.465258937500886],
              [74.41185511179286, 14.470903881694637],
              [74.421203372180642, 14.472526281752481],
              [74.426886470837005, 14.471879343982115],
              [74.431478795512547, 14.467790287894388],
              [74.433533392686613, 14.463906378238734],
              [74.436076284997554, 14.461561554511944],
              [74.437721842582107, 14.466815933273237],
              [74.436169610825473, 14.471592632821508],
              [74.433628623907097, 14.473892564164549],
              [74.426487798996419, 14.476877025165676],
              [74.421254965585362, 14.477957458652117],
              [74.41564483451576, 14.481273349560292],
              [74.407593013307789, 14.487463156427188],
              [74.405793379528717, 14.491091701054614],
              [74.40097286051386, 14.495895841019969],
              [74.399054227378784, 14.499409973631968],
              [74.395295709903223, 14.504781166880285],
              [74.393680062349617, 14.507969682847413],
              [74.389610366983121, 14.517739079635241],
              [74.387342129845351, 14.521623172756836],
              [74.384700210548004, 14.524361419661727],
              [74.378834788693794, 14.52961131666064],
              [74.377262912283911, 14.532547134951409],
              [74.378104334973344, 14.537073537467149],
              [74.377572130893483, 14.540506087178475],
              [74.374499305055195, 14.541291408543698],
              [74.369034422096476, 14.542832906857686],
              [74.368133918492859, 14.547143387177087],
              [74.369496315841999, 14.557073760784196],
              [74.363388873570329, 14.557837581946055],
              [74.361726326715214, 14.55361703227673],
              [74.360049095988273, 14.547647711087031],
              [74.357104885137474, 14.544610947699622],
              [74.35533197632931, 14.541013211058527],
              [74.352275268153804, 14.535952588086957],
              [74.352063959882244, 14.52578285153689],
              [74.350296431014584, 14.522828866055828],
              [74.345226543564934, 14.521259982489161],
              [74.340998292408983, 14.516554037579105],
              [74.336108642454491, 14.514108503537807],
              [74.330795891561635, 14.514152277103829],
              [74.324621640023224, 14.517746077232104],
              [74.32090225313506, 14.519893040985247],
              [74.314629369055268, 14.517895889949113],
              [74.310783774971625, 14.519101011707228],
              [74.308070309920581, 14.523149329569636],
              [74.311784871336727, 14.525742888818819],
              [74.313119411168614, 14.530380204904208],
              [74.308522504597235, 14.534260135780722],
              [74.308555876042632, 14.53789569149909],
              [74.312303072155771, 14.5414783717686],
              [74.314169491010901, 14.545098754967086],
              [74.314225164694392, 14.55119653873788],
              [74.312059330477439, 14.556208265040514],
              [74.309362416980221, 14.559657766412396],
              [74.307743159607952, 14.562571282920839],
              [74.304709614864421, 14.570534373749295],
              [74.301867260333538, 14.573525154038181],
              [74.29944300144966, 14.581207652684633],
              [74.294300545016526, 14.587369575435643],
              [74.294576828982102, 14.591900160166896],
              [74.300712892574325, 14.591621227183165],
              [74.302458074682008, 14.594783612755673],
              [74.306769908919392, 14.595646422852393],
              [74.309984329212952, 14.594722950204879],
              [74.314874336052839, 14.597060452103191],
              [74.318859385217394, 14.600772257946936],
              [74.32539261742356, 14.602721786805082],
              [74.329279789889611, 14.603404200384576],
              [74.341533690238904, 14.600819333878659],
              [74.351225418414671, 14.595723254281079],
              [74.357861639109046, 14.59373037013815],
              [74.366240980473449, 14.591808771747079],
              [74.373881694652809, 14.593026412352677],
              [74.384116979141567, 14.592300738873595],
              [74.39045393979022, 14.594168582579005],
              [74.399458861866563, 14.601773072577986],
              [74.412373179009791, 14.607424074220669],
              [74.420718146165768, 14.614392534458903],
              [74.425806624792912, 14.622029440219293],
              [74.429531809638334, 14.624559459736236],
              [74.424750594195146, 14.625876244121216],
              [74.419277922839868, 14.623364947429863],
              [74.4144231119963, 14.617006551756347],
              [74.410259528740596, 14.614480487862362],
              [74.402160219667763, 14.610706510680791],
              [74.39141518781291, 14.603757601428848],
              [74.382674531142058, 14.601273390932898],
              [74.377214447292332, 14.600037973085044],
              [74.369797435168181, 14.599458725326134],
              [74.363686935497526, 14.598228320737148],
              [74.360436253056477, 14.59850756915459],
              [74.356818284598262, 14.60023426993666],
              [74.354177373671817, 14.602119637246924],
              [74.351277173393953, 14.603892161560941],
              [74.348093795783242, 14.60822141945197],
              [74.343009118349642, 14.607802970297261],
              [74.33973358120538, 14.607161314010289],
              [74.336413260126278, 14.609329318325081],
              [74.332360241322817, 14.61106431540888],
              [74.32546622558236, 14.610890959438962],
              [74.320805059139701, 14.610490795644688],
              [74.318741800408191, 14.613890395049625],
              [74.31352921586253, 14.614852549652927],
              [74.3108000856042, 14.604449725029141],
              [74.308193220348755, 14.602192556702375],
              [74.300010149712662, 14.60246531813128],
              [74.296633027111142, 14.603573555982457],
              [74.284656518364045, 14.608501011561639],
              [74.282587880307162, 14.6112323811754],
              [74.281018545971691, 14.614651034737657],
              [74.279405842821888, 14.618505914731173],
              [74.274569942005215, 14.622364019272482],
              [74.271740339503467, 14.626964877426483],
              [74.275128826887922, 14.62965418597719],
              [74.28020182846754, 14.628693851894869],
              [74.282800410190475, 14.63525463758495],
              [74.285143606390179, 14.639539618824267],
              [74.283344636698118, 14.643603576302297],
              [74.281969533766045, 14.650402425542186],
              [74.280091623257945, 14.656216529288786],
              [74.282960199121575, 14.658678706180504],
              [74.285557067358411, 14.66293417816258],
              [74.2826079068289, 14.664019620182358],
              [74.276351450025103, 14.664299557231885],
              [74.274536321338161, 14.6692832993207],
              [74.279440474594537, 14.673110891638714],
              [74.279073659879757, 14.676795972159528],
              [74.275884150279538, 14.688740109288245],
              [74.274023698760033, 14.691263261002073],
              [74.270163343374421, 14.696516282278424],
              [74.255865740335608, 14.705671077085979],
              [74.257727573176837, 14.708808149923406],
              [74.262260009752751, 14.71038485846462],
              [74.265439536390886, 14.713305246800608],
              [74.265214267899779, 14.717149812571735],
              [74.262506495582429, 14.722394044621263],
              [74.258368905880658, 14.725693229570734],
              [74.256532788486496, 14.728330547932044],
              [74.251021744301994, 14.733343744233506],
              [74.246895173288962, 14.737885264908607],
              [74.241739716902003, 14.743263717529507],
              [74.236549762295709, 14.747260376095324],
              [74.228851388602791, 14.747065745923623],
              [74.224832209287101, 14.745095022753738],
              [74.224496678012414, 14.736031137376926],
              [74.221354931658325, 14.734697732860926],
              [74.209560024865681, 14.734326104006071],
              [74.203852333016599, 14.732781159407992],
              [74.204749272985339, 14.727574606806952],
              [74.206666721295974, 14.720542020085823],
              [74.200167980225359, 14.720152937932516],
              [74.195092163387912, 14.723803109864528],
              [74.192132280345021, 14.730153834036193],
              [74.185660647880596, 14.735746355541426],
              [74.183165694656296, 14.738595695006422],
              [74.18052550269644, 14.743700104206951],
              [74.177216045398936, 14.747705230454844],
              [74.166848506059026, 14.752083750357698],
              [74.166641920948052, 14.755491017354384],
              [74.17129745483355, 14.757712106166315],
              [74.173643844088133, 14.759788758967751],
              [74.175965770846872, 14.764303746231013],
              [74.173772504152012, 14.76675926735594],
              [74.170669659179396, 14.767219237066554],
              [74.163360440751219, 14.765707849456145],
              [74.160900397185415, 14.761423294762336],
              [74.160401733808087, 14.758043844062488],
              [74.159424015027611, 14.750780157759825],
              [74.15718017050753, 14.747000796666017],
              [74.154311391220375, 14.750126900586555],
              [74.152532312926439, 14.759942854530635],
              [74.151654765484778, 14.764895446195805],
              [74.148668570568233, 14.768161103161507],
              [74.144075041042569, 14.773555879673815],
              [74.136526434412843, 14.77747607840837],
              [74.133047396187649, 14.778075504871609],
              [74.129539012980104, 14.777962158759538],
              [74.125553666755096, 14.774125999396716],
              [74.122091679261771, 14.773920409807019],
              [74.119784979560478, 14.776881867318377],
              [74.120066147017681, 14.78253926325235],
              [74.117046707850122, 14.784815775528076],
              [74.113133095451417, 14.783946053510547],
              [74.109416617156455, 14.784432846361327],
              [74.107832743282557, 14.789437088016564],
              [74.10738811402608, 14.792822585317984],
              [74.100454412261755, 14.794228806620307],
              [74.095367591790591, 14.796978985058638],
              [74.094394870965729, 14.801977922713688],
              [74.100480412384528, 14.803362241192531],
              [74.107486116234995, 14.802117160267368],
              [74.114617471328799, 14.79889105608542],
              [74.118799009926647, 14.800771394735362],
              [74.123148205153896, 14.805848361615428],
              [74.124545458803667, 14.81271800278868],
              [74.125435097795986, 14.817843735388186],
              [74.125089559505994, 14.833445917778743],
              [74.135749183747663, 14.83270242252939],
              [74.145984384872065, 14.834677310138705],
              [74.150318468057066, 14.837683198922164],
              [74.155539851672756, 14.839808179939382],
              [74.159013335829826, 14.838471461303026],
              [74.161533640737034, 14.835669766071836],
              [74.157988267737025, 14.831185455363064],
              [74.156122128520408, 14.821833300178652],
              [74.155986769940895, 14.816772593795696],
              [74.156720215565912, 14.812804126982178],
              [74.160731287607817, 14.815427350952953],
              [74.165090427576388, 14.818685888483556],
              [74.167706562552326, 14.8218191992715],
              [74.1698945174345, 14.824472293477113],
              [74.170964515794779, 14.828605764089197],
              [74.170573576179123, 14.832635152167725],
              [74.170592659133618, 14.840620002291327],
              [74.17663498681118, 14.84237034483051],
              [74.178847649230917, 14.845092000573874],
              [74.177376347313199, 14.849451836268987],
              [74.176135830924707, 14.853257719055723],
              [74.17837435810587, 14.856186010256724],
              [74.181461868454718, 14.856624122132292],
              [74.187010464345647, 14.861208263892538],
              [74.191645784169921, 14.863544271276478],
              [74.204649777988934, 14.866875977971301],
              [74.215777672009764, 14.868358290437932],
              [74.220693883044476, 14.864938804250489],
              [74.223406403485356, 14.862616943761193],
              [74.226614285350408, 14.860361552194247],
              [74.230964133999763, 14.859684453181799],
              [74.238477082258186, 14.862434375315773],
              [74.243261603323475, 14.865688517940457],
              [74.248025739126376, 14.869265127366182],
              [74.250144112609561, 14.87465699685913],
              [74.234128176191049, 14.871626021462836],
              [74.223651699755976, 14.872141747514735],
              [74.214072093730948, 14.873680659356774],
              [74.208659249293021, 14.875768181417964],
              [74.207434659279969, 14.879450034116058],
              [74.209143653298526, 14.883937293415817],
              [74.211679073455883, 14.886777492403574],
              [74.205829110608832, 14.887227434208372],
              [74.202885928742447, 14.885209793378884],
              [74.192983930725447, 14.882885293917855],
              [74.19140392095926, 14.879721310801148],
              [74.184966905008821, 14.880356427343365],
              [74.181431913227556, 14.881381733395459],
              [74.177300204538184, 14.880193013667192],
              [74.176409284894419, 14.872054229108654],
              [74.173159805466881, 14.869338987114384],
              [74.171083087697639, 14.87163284476552],
              [74.166690558873356, 14.873021712837069],
              [74.16406781879769, 14.86613762555505],
              [74.162674580548909, 14.862858154032333],
              [74.154036428649448, 14.857720294287093],
              [74.14640764837219, 14.857774943520898],
              [74.142469316025085, 14.857113214104514],
              [74.141474243694347, 14.850562346286486],
              [74.137952707501199, 14.846054715094404],
              [74.128951369364245, 14.848143564060152],
              [74.124188133181008, 14.8473031083359],
              [74.123545824173817, 14.840726982771569],
              [74.12099189946079, 14.838396181365356],
              [74.114287507408662, 14.843047087754918],
              [74.112472245264456, 14.845774807891642],
              [74.107166251066786, 14.865530299531988],
              [74.10568003504379, 14.868255546624264],
              [74.102946383067305, 14.87391173086994],
              [74.096494411902754, 14.880077383698252],
              [74.096057080744799, 14.88438284291351],
              [74.097960852109736, 14.886877189392125],
              [74.097769175732054, 14.892308710100995],
              [74.087989961794193, 14.895966011412821],
              [74.082998239537801, 14.901015502294561],
              [74.08161003479151, 14.904199870960154],
              [74.07817089163477, 14.907168285574611],
              [74.066813296470912, 14.906555362592261],
              [74.059848354197442, 14.907523205985218],
              [74.057794688004776, 14.910022266880842],
              [74.054793514566157, 14.911836608996081],
              [74.049247160599123, 14.913484902050378],
              [74.045995196840963, 14.913276600744606],
              [74.042311156337135, 14.915095367614414],
              [74.041721451902475, 14.918159260805504],
              [74.042753994129171, 14.92381248021797],
              [74.042530623360349, 14.93791767422517],
              [74.0423164818327, 14.946822647921845],
              [74.043610635663285, 14.949736097240864],
              [74.0467271075767, 14.950635877177641],
              [74.050135784440911, 14.955812311596066],
              [74.054559482751344, 14.962276934414218],
              [74.051074111125772, 14.964572309897047],
              [74.047324628364365, 14.964205642867904],
              [74.044059174302831, 14.965378479181735],
              [74.042472863131977, 14.970611372905905],
              [74.039525274049183, 14.976498080898301],
              [74.037231880937412, 14.978537229861907],
              [74.039524998537601, 14.983074821472369],
              [74.045660363143867, 14.987063005342163],
              [74.038688384680896, 14.990537272645186],
              [74.034843053550162, 14.993094330664663],
              [74.02671096144276, 14.998991224258253],
              [74.020189384491701, 15.006027901889571],
              [74.017492764317126, 15.007886213442927],
              [74.011043121784439, 15.008894354569984],
              [74.007269870316762, 15.008412468214264],
              [74.002544043671804, 15.009915623788181],
              [73.99963018652349, 15.011791290252312],
              [73.996474750811686, 15.017754220109696],
              [73.992393285137666, 15.020449033116655],
              [73.987907551566863, 15.022570597689477],
              [73.983995633092391, 15.025770667185519],
              [73.984190242309879, 15.029818384607578],
              [73.987196270630278, 15.034792624661401],
              [73.987349816937083, 15.039783555310366],
              [73.985042505345504, 15.043410150157797],
              [73.982510376712909, 15.045244085918458],
              [73.981500012364734, 15.048885451395849],
              [73.984077256013023, 15.05317135708456],
              [73.981408375272167, 15.055672915105614],
              [73.976310155871147, 15.054807808007878],
              [73.971455387578914, 15.054814783706927],
              [73.967550648116671, 15.062546280419502],
              [73.965235714719171, 15.065068395297859],
              [73.963657732654568, 15.068690913446131],
              [73.959245655932236, 15.068027497294789],
              [73.952526445535199, 15.071244697845845],
              [73.95012129337978, 15.074434551781565],
              [73.939808015679588, 15.076062291266011],
              [73.934231999685778, 15.077476421916328],
              [73.932179780553355, 15.080664039091474],
              [73.929417855885532, 15.083602255903028],
              [73.922470911650663, 15.084587162500625],
              [73.919204025055436, 15.082536704375862],
              [73.915036475393762, 15.083251977824473],
              [73.913682979771352, 15.088690002739009],
              [73.921137648698817, 15.092946310016146],
              [73.922808350592717, 15.099285437405365],
              [73.916792867713838, 15.102036447174859],
              [73.916002088063635, 15.10701111574673],
              [73.930530155854015, 15.111224719523833],
              [73.935668511115651, 15.114368151394398],
              [73.937658688920081, 15.116699772415771],
              [73.939761195239328, 15.11979616861616],
              [73.938298438165631, 15.126361515618942],
              [73.938334760182428, 15.131560542895755],
              [73.941020533705483, 15.134488709181879],
              [73.949285135115161, 15.136255394694894],
              [73.954365929803345, 15.139401933296229],
              [73.958278451728702, 15.144344000766429],
              [73.958096014164042, 15.148463340538431],
              [73.956662746063202, 15.162482477821637],
              [73.955272652073461, 15.16610375326159],
              [73.954609265563803, 15.169052395600717],
              [73.959289140517171, 15.173785234930099],
              [73.959068463916253, 15.185004467041539],
              [73.955714215580898, 15.178500367731745],
              [73.949091077113039, 15.175666123313874],
              [73.947228774238766, 15.17250183443598],
              [73.947322871238967, 15.169050405097508],
              [73.948429498914152, 15.165938182771002],
              [73.951226621330079, 15.157455549621297],
              [73.952422648087804, 15.149809298978228],
              [73.950032894424652, 15.145315501016594],
              [73.946569248652125, 15.145796076308638],
              [73.944956537090832, 15.151120426365969],
              [73.943418472795557, 15.160517000305651],
              [73.94224443157546, 15.164572256745704],
              [73.939690827714159, 15.177080740816002],
              [73.937885109864666, 15.181922421857944],
              [73.936335413534181, 15.18632546908038],
              [73.931425182585187, 15.206117043844033],
              [73.92281828800958, 15.237409063489411],
              [73.9189312996794, 15.24854340970519],
              [73.916541955389775, 15.254539958244086],
              [73.915313223882507, 15.257605961995139],
              [73.908298197340144, 15.284378845901989],
              [73.901616560143353, 15.308320013150096],
              [73.899329863652682, 15.315649127620816],
              [73.896945708444008, 15.32227787585707],
              [73.895599239561193, 15.326022474097252],
              [73.892200052567659, 15.33650927938686],
              [73.885712733026082, 15.351291946815282],
              [73.884105065419377, 15.354453728553073],
              [73.880442531302421, 15.361053617725647],
              [73.87805647997979, 15.364264301521299],
              [73.874915549335427, 15.367664401266639],
              [73.870417978950087, 15.36934595235636],
              [73.867255269621268, 15.369294222189096],
              [73.861911161509823, 15.367944402037358],
              [73.858153009602503, 15.363456660864408],
              [73.854988834772513, 15.363313262037009],
              [73.850741611442928, 15.363498168986455],
              [73.84769042299537, 15.358959726172021],
              [73.843024154201373, 15.360135547084147],
              [73.840049698772305, 15.363787383480151],
              [73.832648893321704, 15.369256020341],
              [73.828245649020374, 15.370844593017285],
              [73.809488802225985, 15.380009579114301],
              [73.807799728592855, 15.385492601800403],
              [73.804001153676808, 15.393380390493672],
              [73.800522992399891, 15.395906356803902],
              [73.790646049507984, 15.398328300525256],
              [73.786651068310462, 15.405272197872474],
              [73.784069957443435, 15.407977656470239],
              [73.783641057085617, 15.411154313078892],
              [73.787024603815951, 15.412286543370314],
              [73.792233196577456, 15.41087922421384],
              [73.80105533091124, 15.40565658360628],
              [73.804063187653753, 15.403363091376486],
              [73.812841303370931, 15.399015225772969],
              [73.815678292592651, 15.40714318703148],
              [73.817704057778073, 15.410236884516999],
              [73.822312213552749, 15.410810623079115],
              [73.824517545324255, 15.404817395997416],
              [73.828689853108102, 15.403921196171929],
              [73.831478648460759, 15.407954883743463],
              [73.840136670323815, 15.410645259506595],
              [73.844754878976445, 15.409239420382189],
              [73.845324622198433, 15.406084293450418],
              [73.843996449505084, 15.401330546869948],
              [73.847246744296001, 15.400184517251978],
              [73.857834550326629, 15.40555520144029],
              [73.86355893337182, 15.40734091435508],
              [73.865866715567961, 15.402795822572571],
              [73.873166539950333, 15.399879723907347],
              [73.87757699003842, 15.39916443736381],
              [73.885131373139444, 15.402687477350232],
              [73.900274792481554, 15.407799484319591],
              [73.906251144376938, 15.40820263573381],
              [73.911659637514205, 15.40504209373157],
              [73.916509414378794, 15.402966629203821],
              [73.922322275369595, 15.403623696885562],
              [73.92512006013169, 15.40540148820614],
              [73.931046009254942, 15.405481198013938],
              [73.938349061133877, 15.410038764085632],
              [73.930054039830949, 15.412389137470823],
              [73.926343053850303, 15.415125492961682],
              [73.926704267718904, 15.421454781542197],
              [73.932006906183645, 15.425282774702007],
              [73.936695477776553, 15.430684913930961],
              [73.937118504961532, 15.433744958254266],
              [73.933947450393148, 15.436359846824541],
              [73.928127747894507, 15.43460013736148],
              [73.922620315359438, 15.430330162342726],
              [73.922028985166548, 15.426699071492303],
              [73.918994392679593, 15.424898829324682],
              [73.911197373029438, 15.424046571450228],
              [73.910121774926921, 15.418623662114934],
              [73.907770910084196, 15.416590781513872],
              [73.89778991115061, 15.417567982828885],
              [73.880698137864627, 15.428637676957692],
              [73.86951857747475, 15.430609905259344],
              [73.864428372009144, 15.432226477042594],
              [73.862247885960315, 15.434607719238624],
              [73.860212164177966, 15.437402337410493],
              [73.857981811032033, 15.443142822339773],
              [73.851970118407806, 15.448374265505597],
              [73.847812607052816, 15.451802022512767],
              [73.844794499050934, 15.452509230996066],
              [73.842230925102484, 15.450475703852566],
              [73.828078893831176, 15.453037053719392],
              [73.821782407974894, 15.454427950434534],
              [73.816565496903905, 15.454754918987341],
              [73.804360309839254, 15.455440704117873],
              [73.800259360255879, 15.456589335377357],
              [73.794931308585547, 15.458135433966369],
              [73.785621972493274, 15.461612725013923],
              [73.788460937692747, 15.465829901044875],
              [73.792127395851281, 15.466822818417329],
              [73.800302031805501, 15.463697669589704],
              [73.803718375771439, 15.462229482261389],
              [73.806746388921667, 15.463110608760251],
              [73.808619455646209, 15.468092583530005],
              [73.806106719566671, 15.474432306465534],
              [73.806134922388452, 15.478963182603303],
              [73.807314663406956, 15.482592047151194],
              [73.813635161982077, 15.488676913604218],
              [73.816728282012591, 15.492410252476448],
              [73.81947984145026, 15.494281458039822],
              [73.821807188826355, 15.496315967185966],
              [73.832764743392929, 15.49986963285401],
              [73.833719686139844, 15.505085434704199],
              [73.827690920483917, 15.508063093734828],
              [73.824446723617768, 15.50672260377703],
              [73.81819149108189, 15.507422905948109],
              [73.813861545074872, 15.506318985368786],
              [73.811861624035103, 15.503615402161044],
              [73.810940663972801, 15.499986163719893],
              [73.807514137909479, 15.49586273283618],
              [73.801361471410658, 15.493940790327811],
              [73.787904568824231, 15.498772574036064],
              [73.782529903315407, 15.496545577791126],
              [73.780186944161272, 15.492003273945647],
              [73.776468087377495, 15.490228356320344],
              [73.772671960711534, 15.491260058824603],
              [73.769045000894707, 15.492980633783411],
              [73.764881395122615, 15.499787163461088],
              [73.761728176105507, 15.517745366198538],
              [73.758782923900512, 15.531077656435755],
              [73.755574598434706, 15.539904139484156],
              [73.755390706344983, 15.544643046647847],
              [73.751726627766701, 15.552366998044008],
              [73.750084964347423, 15.558494106567739],
              [73.748379572743914, 15.561952230463174],
              [73.742961844788752, 15.564647701987131],
              [73.740862071364191, 15.569419543753881],
              [73.735878658096524, 15.590260616942912],
              [73.733341105646318, 15.59275669078227],
              [73.731161145410837, 15.595942375763252],
              [73.730833739836086, 15.600681764368453],
              [73.740152603662764, 15.602016165804487],
              [73.744108200970658, 15.603584232397916],
              [73.747367505014552, 15.607409436521998],
              [73.752278869099101, 15.61126218304975],
              [73.752873400443448, 15.614332896296657],
              [73.751486690422709, 15.623288599251749],
              [73.755245506261232, 15.627460804150335],
              [73.760137391355187, 15.629954252499376],
              [73.763924494163774, 15.634543636883439],
              [73.759320348829604, 15.636667390602138],
              [73.752992300527367, 15.634742258048645],
              [73.749251319518763, 15.63364344472382],
              [73.744023320046495, 15.629829542006089],
              [73.743076019798934, 15.625325739382085],
              [73.738753049349938, 15.621620254774205],
              [73.735665095836069, 15.614712664752176],
              [73.732190683224744, 15.614729630852448],
              [73.730939519721233, 15.619036299245238],
              [73.728852074090895, 15.621991013613556],
              [73.724680417785251, 15.624035447487115],
              [73.721241599980573, 15.634471053322153],
              [73.716426578522018, 15.64399340779077],
              [73.714806830331199, 15.650143423259832],
              [73.716022356967756, 15.656255345421284],
              [73.715574592916923, 15.660559054624533],
              [73.711400263080435, 15.662372477584716],
              [73.708029849869718, 15.672601407749346],
              [73.706073793005658, 15.678084880850362],
              [73.701557879895532, 15.690710497157982],
              [73.698242979162544, 15.694175588392147],
              [73.694383615140481, 15.697321633096271],
              [73.690823028669485, 15.70622418819185],
              [73.689701116034755, 15.714547772356172],
              [73.6905486705149, 15.718154977614654],
              [73.696598516330624, 15.717689693304461],
              [73.699658697290374, 15.721478124648122],
              [73.697041679351443, 15.723699056233006],
              [73.693181775961307, 15.726974565547858],
              [73.687074977456959, 15.722931704016046],
              [73.678003681825743, 15.724560291828972],
              [73.67570526039674, 15.727949768906328],
              [73.672899162981892, 15.736750763538433],
              [73.659937596751348, 15.745139657165877],
              [73.658932015813264, 15.74896317464961],
              [73.662170205718837, 15.751515234843575],
              [73.670549120328062, 15.753198844188114],
              [73.679208378752321, 15.751897668819055],
              [73.685157624461993, 15.755775530025483],
              [73.679123360563736, 15.757734702845855],
              [73.673972615440633, 15.759385496700292],
              [73.666418272751926, 15.764701981260888],
              [73.664758357676774, 15.774401197269396],
              [73.656344981785494, 15.797794164850782],
              [73.653551196457457, 15.802189679706432],
              [73.648162244631678, 15.808617553582261],
              [73.646108682665712, 15.811000967723551],
              [73.642149541605534, 15.818643411216025],
              [73.636294905882266, 15.835752241313831],
              [73.633146629258619, 15.851105394283987],
              [73.628874485652787, 15.855779432230591],
              [73.623648511864602, 15.852668187620846],
              [73.61767731423528, 15.853362904636054],
              [73.615722664603297, 15.86666519653873],
              [73.611716955842894, 15.875661939511364],
              [73.600824363547815, 15.894097424991987],
              [73.595719514019876, 15.900319746935009],
              [73.591511442830779, 15.908462672999619],
              [73.581109384075475, 15.911388234219174],
              [73.574601554930524, 15.912900786524201],
              [73.571576730398931, 15.914993296682296],
              [73.570368019056062, 15.917916864893437],
              [73.566616997923617, 15.922480790672429],
              [73.556748895663887, 15.926217619082035],
              [73.549887009168174, 15.930620053816156],
              [73.545366334860034, 15.935745896454561],
              [73.538663281704558, 15.937483436645481],
              [73.535343343045227, 15.93244578968055],
              [73.529982408784775, 15.931905080310363],
              [73.520805123660097, 15.936984173975599],
              [73.513769724426524, 15.938738943536082],
              [73.507592002945728, 15.943333867466579],
              [73.506137835705985, 15.948252516831246],
              [73.505680337796278, 15.95325571020048],
              [73.508418224524576, 15.957480683905539],
              [73.509205250891057, 15.962217105511467],
              [73.504618558273066, 15.962374582534295],
              [73.499889636874798, 15.96236813062535],
              [73.498896398753402, 15.96932250220237],
              [73.487564249722411, 15.97493271442867],
              [73.489140848697701, 15.992002291364841],
              [73.492500788715418, 16.000501347823707],
              [73.494470424118475, 16.004658075198613],
              [73.492080003593912, 16.008689124927614],
              [73.491981455053619, 16.015031114016644],
              [73.486471056164405, 16.037561278748239],
              [73.482672704641828, 16.041800575073413],
              [73.471353137469265, 16.046612321081863],
              [73.467982889352683, 16.053800236026657],
              [73.460222842750468, 16.055931585377785],
              [73.457872384924997, 16.064720708030606],
              [73.467308036852529, 16.066429107152192],
              [73.467222489153997, 16.073299891516008],
              [73.4666101201353, 16.080461225760352],
              [73.468218952190426, 16.090001080372044],
              [73.474092459732631, 16.095974898499055],
              [73.473556979106789, 16.099781314450748],
              [73.469866957212375, 16.104504212201768],
              [73.468624937780902, 16.116895449763739],
              [73.470754378966291, 16.129614959671834],
              [73.469339159288126, 16.143841509659254],
              [73.472387845545896, 16.158574760260016],
              [73.469019766021518, 16.157970312266055],
              [73.464755038875339, 16.153927848886919],
              [73.463647560729825, 16.144327952211274],
              [73.463315583596582, 16.141265161944951],
              [73.460785297002985, 16.137388421754864],
              [73.460938268339959, 16.126244508582126],
              [73.461675794482886, 16.117247408702227],
              [73.462028680172693, 16.11300130407805],
              [73.458750108782809, 16.114305963187476],
              [73.455635676156476, 16.126162131493292],
              [73.453788046260968, 16.13323465697427],
              [73.451330384340224, 16.144135968227133],
              [73.450565615398503, 16.147341435984941],
              [73.44285516321554, 16.187736395401707],
              [73.441434043335519, 16.193275855399026],
              [73.441693637383523, 16.196335961314073],
              [73.438495897771332, 16.199687026375674],
              [73.432144531576952, 16.201379299671636],
              [73.427905754020642, 16.214871081554875],
              [73.425722799495773, 16.221869014725605],
              [73.419726366031213, 16.252776314347084],
              [73.411649003957663, 16.281143305554622],
              [73.40605076306673, 16.294613011209176],
              [73.398185537899295, 16.30395503481196],
              [73.394328428000463, 16.309822055087778],
              [73.394387358393516, 16.326553068596525],
              [73.388533107432764, 16.332226814842567],
              [73.386265116622951, 16.335477320826875],
              [73.386328263937088, 16.338855314624645],
              [73.390828697065061, 16.344604302708618],
              [73.389526998201703, 16.351361896665054],
              [73.390518945165965, 16.356113039514277],
              [73.402296599158888, 16.353750816274104],
              [73.409866375188088, 16.355250977508625],
              [73.415315458585283, 16.358371968142489],
              [73.41930222289362, 16.362111544125888],
              [73.42010103775651, 16.365640533708881],
              [73.416138176813377, 16.366266563578744],
              [73.410623105860168, 16.361353210233972],
              [73.40779199904577, 16.359790365437892],
              [73.400488728920664, 16.360891832954906],
              [73.396362641020858, 16.364226458243465],
              [73.391430601550226, 16.364376952198931],
              [73.387853967313859, 16.360366712424053],
              [73.381568043072576, 16.357553324699314],
              [73.373570236475643, 16.361675584472593],
              [73.371860933696368, 16.371438154365681],
              [73.371932422208047, 16.378654949351663],
              [73.372272464485462, 16.382521134865286],
              [73.374443042624634, 16.385153370615448],
              [73.381337023929618, 16.385838041754354],
              [73.389947099472522, 16.389355264014497],
              [73.401655923270354, 16.389773973102322],
              [73.409156976215755, 16.398465707329944],
              [73.411753411752514, 16.401334219577862],
              [73.41655229278949, 16.403479833809378],
              [73.431906777153742, 16.403862314402048],
              [73.444059655404473, 16.406284511047243],
              [73.448482312206963, 16.408238760352049],
              [73.45155677395195, 16.409574846805285],
              [73.454821060919642, 16.410891096666216],
              [73.458758908574737, 16.411848497270572],
              [73.463811255242788, 16.413146833195388],
              [73.469495496144162, 16.41505185261504],
              [73.463753421506325, 16.416708126543504],
              [73.459480133218761, 16.415859381781349],
              [73.455903115924471, 16.41463018749381],
              [73.451123981432872, 16.412739936332692],
              [73.446019299330857, 16.411784825083391],
              [73.437212035296369, 16.410036516895989],
              [73.432896306535909, 16.410335719600688],
              [73.427194823102013, 16.410911509746342],
              [73.416805498525761, 16.411274126832502],
              [73.41216563710897, 16.411015783911139],
              [73.408997270565933, 16.408207369607794],
              [73.4063916549065, 16.40297169021721],
              [73.402089182915603, 16.399616819102221],
              [73.393506879065228, 16.4016154316502],
              [73.389159518635111, 16.40099367932903],
              [73.37794719041932, 16.392103099140986],
              [73.370325018832489, 16.393657007673042],
              [73.367330834632682, 16.397584554865848],
              [73.366277075501287, 16.403680021629132],
              [73.358864612079984, 16.426860384017068],
              [73.353713167028829, 16.441483349284358],
              [73.346858598359901, 16.453872232271699],
              [73.344046745277424, 16.466648843804027],
              [73.343791929076446, 16.471929561904908],
              [73.344358980985987, 16.475018052870425],
              [73.340996311987396, 16.476908430978849],
              [73.336686705935833, 16.476477384744232],
              [73.334318903736801, 16.478483943621235],
              [73.332176143956247, 16.486812847398387],
              [73.327446994509344, 16.510012684555662],
              [73.319909109609014, 16.511933794478765],
              [73.318207690065861, 16.516661923538429],
              [73.314122374824322, 16.532679212621225],
              [73.313870679225062, 16.536259809698208],
              [73.322976205621927, 16.552909372233941],
              [73.33141506653935, 16.557023873964447],
              [73.336018352396579, 16.557877686197461],
              [73.341082474616186, 16.560569730618873],
              [73.345937054425605, 16.567555852984853],
              [73.34631365657782, 16.572298177227381],
              [73.34417879275486, 16.574537865573802],
              [73.33370355958202, 16.576616733512502],
              [73.330076065942137, 16.578281049405724],
              [73.327751635989941, 16.580378773961982],
              [73.322589424924743, 16.589553482330697],
              [73.321281626084215, 16.593553701196022],
              [73.31994090607725, 16.599459353003205],
              [73.324212249714193, 16.603390696394491],
              [73.331270307597919, 16.603277728816263],
              [73.335523805186696, 16.601303526403107],
              [73.345227596590533, 16.595581407773313],
              [73.350921266468276, 16.591607450616944],
              [73.354936022186081, 16.590984413879507],
              [73.354355992970724, 16.597087586346497],
              [73.34371471107255, 16.601875447823126],
              [73.342899681829707, 16.607744990033748],
              [73.345213213880982, 16.610493695422107],
              [73.354632578844559, 16.608903002868345],
              [73.357831515736748, 16.614309719108672],
              [73.365567952490409, 16.623490619766287],
              [73.36937802940983, 16.623783507910332],
              [73.378137232132843, 16.611884790420898],
              [73.378979675944478, 16.605672104540385],
              [73.378448768919952, 16.601824924883637],
              [73.379027720382766, 16.594320312639649],
              [73.391918965899876, 16.588900347155224],
              [73.401938241801844, 16.585638710378458],
              [73.400929047614127, 16.590379440038102],
              [73.390444206867812, 16.594460771956829],
              [73.386738868187408, 16.596514631055335],
              [73.385583984946479, 16.602792351276463],
              [73.387992885754855, 16.605565396414136],
              [73.388375006040135, 16.609778148013586],
              [73.391868867959545, 16.613327283052826],
              [73.397575248334775, 16.614178917572275],
              [73.398797528604973, 16.619530000371995],
              [73.392336135018041, 16.626663066214309],
              [73.379363711046821, 16.629623049978363],
              [73.370003281016452, 16.636133022282813],
              [73.366167282791963, 16.634599803659285],
              [73.358672665734701, 16.62657113185465],
              [73.353029111937346, 16.620572993124838],
              [73.343925286403447, 16.616125787745151],
              [73.335458032060757, 16.619179478623085],
              [73.335514942321893, 16.622788218712671],
              [73.341893158245341, 16.62627175131146],
              [73.341828939544527, 16.631464817417541],
              [73.335148744297726, 16.635903554239075],
              [73.326606128923416, 16.634911887244666],
              [73.324771702886366, 16.63897055085927],
              [73.330771698071743, 16.645090821800082],
              [73.330951178056793, 16.662466599925992],
              [73.329204425784113, 16.668365120845063],
              [73.327474356753996, 16.674725004875746],
              [73.328557077642273, 16.678304645693835],
              [73.333214834424027, 16.680657208538424],
              [73.341104721420336, 16.679524543301397],
              [73.345611508151805, 16.683781151741101],
              [73.345376448753768, 16.690555224921276],
              [73.339698708821615, 16.68641690592592],
              [73.333067602752578, 16.68786930898052],
              [73.328390859073608, 16.688021034481761],
              [73.322498379542381, 16.690887517852588],
              [73.315736891478835, 16.708192496165594],
              [73.312405298686571, 16.714639622456538],
              [73.310112252284085, 16.721770410220351],
              [73.304332229324018, 16.74281299780349],
              [73.302606317105557, 16.754319541048886],
              [73.30352245452103, 16.763387329188109],
              [73.30879630799663, 16.775677503586603],
              [73.314758301035226, 16.784164948015164],
              [73.317612118693788, 16.797080998580615],
              [73.316352675108348, 16.801185536396961],
              [73.314764236278123, 16.804595923309201],
              [73.305404500601242, 16.810226534710729],
              [73.300322176708647, 16.81838961809315],
              [73.29764417544591, 16.822755661987127],
              [73.293456822297841, 16.83426521576504],
              [73.294211542141568, 16.857991698601143],
              [73.295074973452856, 16.863199056201985],
              [73.292518413117691, 16.874230526397003],
              [73.2927684538477, 16.883150922874886],
              [73.297709045063414, 16.88727821825395],
              [73.301915472071798, 16.888407250196778],
              [73.312684716489485, 16.885578966837915],
              [73.315317160253358, 16.887966949782218],
              [73.306244429841357, 16.894822250416873],
              [73.299004319048819, 16.893733883506222],
              [73.286123114658679, 16.891769393020798],
              [73.282327404714493, 16.893059812622241],
              [73.28265540429193, 16.897523128278337],
              [73.285849528921915, 16.908675918615657],
              [73.288855661331738, 16.922352975323285],
              [73.289769755211793, 16.925999070608405],
              [73.289312120966002, 16.931689823316219],
              [73.28829380103133, 16.94065598539547],
              [73.2849473735196, 16.944896134467136],
              [73.284768001138829, 16.948293926579392],
              [73.290416807294889, 16.954363697831337],
              [73.293840392361389, 16.966071921858568],
              [73.294640241764696, 16.974909801517349],
              [73.301656627176939, 16.969835701001156],
              [73.304306894016875, 16.965813640023814],
              [73.307760758517517, 16.956818771847811],
              [73.311026405263533, 16.954461357755346],
              [73.32002173130428, 16.954981883130959],
              [73.327929429400456, 16.950680395012743],
              [73.331263749824856, 16.949864178770333],
              [73.333673130522598, 16.967873248253039],
              [73.326011692713209, 16.962091341109403],
              [73.319902575409401, 16.961781521222036],
              [73.31324940256269, 16.965276184008633],
              [73.31520906059103, 16.974707511756321],
              [73.315630407771124, 16.977977330872921],
              [73.312314775933359, 16.97904646265718],
              [73.311911912307536, 16.974766014045702],
              [73.307255635254634, 16.973330933080089],
              [73.305712078571332, 16.979624523605043],
              [73.299787057265618, 16.982441363061813],
              [73.296255544214958, 16.983530538736826],
              [73.293154636249753, 16.984625794681993],
              [73.286508923207876, 16.988993054809594],
              [73.28341523551849, 16.991008643807074],
              [73.27609584547865, 16.98486264549701],
              [73.272702882937438, 16.98494321093396],
              [73.271515309866388, 16.992596248894646],
              [73.274395321396426, 16.995840062119196],
              [73.279612285300928, 16.999375589999726],
              [73.282860688773724, 17.000787263738335],
              [73.282653910020201, 17.011101292671892],
              [73.280096311419683, 17.017858400230768],
              [73.27533095625212, 17.022532449681034],
              [73.2651173124721, 17.01647533297837],
              [73.260598774434754, 17.017982675950449],
              [73.258981563279406, 17.024250315827835],
              [73.259355322173917, 17.028737089482455],
              [73.260117239512823, 17.03424175067066],
              [73.258715550579126, 17.041799050784398],
              [73.257844904021823, 17.046425908814509],
              [73.263581362408274, 17.04900664788121],
              [73.26711218445196, 17.047940879940519],
              [73.27289297746033, 17.042686800331506],
              [73.275709549643949, 17.040185937953272],
              [73.278757901479096, 17.039410863896855],
              [73.281875450994903, 17.041463406097151],
              [73.287598251447463, 17.047535152204251],
              [73.288606417134787, 17.052676295916765],
              [73.294024372616803, 17.055664297156429],
              [73.292438990008009, 17.060232842213782],
              [73.291734277378652, 17.063574935265319],
              [73.291658352234791, 17.070513896183272],
              [73.295377813830825, 17.072392330695191],
              [73.299223952784146, 17.068391286401788],
              [73.302297458199988, 17.067547241326345],
              [73.312060593910118, 17.073597067399483],
              [73.312363176037053, 17.076772225266076],
              [73.309330238060696, 17.077984486872747],
              [73.300249820877923, 17.076565870769947],
              [73.29289905864249, 17.080046788552387],
              [73.291366224306103, 17.085627182368558],
              [73.290291661334109, 17.089584622622986],
              [73.288154746431317, 17.095566930266983],
              [73.287332403140496, 17.101435026348053],
              [73.28244806152216, 17.111300601022094],
              [73.278193798119716, 17.112582862072802],
              [73.271351240187087, 17.114280257058169],
              [73.273597372908313, 17.11964959112067],
              [73.273140472701996, 17.126511627042724],
              [73.271130759476591, 17.133254790937883],
              [73.269365513307619, 17.146366914983965],
              [73.275403633507281, 17.150975804577197],
              [73.277450226443605, 17.154182138850079],
              [73.271666849707458, 17.155322838547256],
              [73.266820467301784, 17.157627592100237],
              [73.262666664380305, 17.165230044689011],
              [73.258583739815876, 17.182116711052561],
              [73.254531479168705, 17.185400571325559],
              [73.249994878999914, 17.188996993108379],
              [73.239066987568449, 17.194228449184727],
              [73.238841517639585, 17.200083978807097],
              [73.248080017369958, 17.199624345069989],
              [73.248912453408607, 17.219697948305711],
              [73.242971796096526, 17.22542988275627],
              [73.240101447355059, 17.226758775920494],
              [73.237735905394729, 17.229243556221874],
              [73.229998643581254, 17.245628792725455],
              [73.228430729780015, 17.248978698503361],
              [73.226565585069366, 17.259353314697552],
              [73.219698600167888, 17.275062099191477],
              [73.215614029373015, 17.278620054479713],
              [73.212841471293146, 17.277192615865779],
              [73.210687045966793, 17.272077320981378],
              [73.207478095272378, 17.273490927768215],
              [73.203838024686846, 17.280226942434954],
              [73.201494797641317, 17.293052057233279],
              [73.189820252495082, 17.299415289063788],
              [73.189522049061296, 17.302580162273706],
              [73.196756174963326, 17.306086680643467],
              [73.200097870577537, 17.303894611491035],
              [73.206268068748017, 17.301522610775837],
              [73.220853756942731, 17.303343353948023],
              [73.231753470662284, 17.29839883550159],
              [73.243306870641035, 17.310746658639427],
              [73.245307528880105, 17.313859850669626],
              [73.246013329051721, 17.317135291058595],
              [73.24290227228407, 17.319791672927401],
              [73.239118236839872, 17.319955268910885],
              [73.230799980707388, 17.322037379296795],
              [73.225876915141768, 17.32431668134625],
              [73.223698650851503, 17.326920806396451],
              [73.223620293768533, 17.331215818035844],
              [73.23016095150949, 17.333375513321489],
              [73.221972847983224, 17.344007282417042],
              [73.220071789056206, 17.351049494564236],
              [73.225439411956359, 17.353304251308668],
              [73.225031640340376, 17.357248366428376],
              [73.219057544162965, 17.359325984789351],
              [73.219259559284779, 17.369116856504288],
              [73.216845784650559, 17.37150980811154],
              [73.212261348015829, 17.372186717651658],
              [73.212109924621544, 17.380316879865493],
              [73.205850144220378, 17.387443187137642],
              [73.197880929931429, 17.389851094101836],
              [73.194277865056421, 17.389258526822314],
              [73.191015856239858, 17.385707166900236],
              [73.188012419936427, 17.383723956754991],
              [73.180771436083276, 17.386902884158683],
              [73.177788035454327, 17.388985836110145],
              [73.170630150258162, 17.399218448236134],
              [73.168559006464946, 17.403730059673013],
              [73.170848718364141, 17.406712016797286],
              [73.174732189861189, 17.406437873509681],
              [73.186882414499777, 17.410952168391542],
              [73.188532877480895, 17.413577761227344],
              [73.189958064938921, 17.419346931152017],
              [73.190013381935898, 17.422748229831129],
              [73.190181424164081, 17.43171151337928],
              [73.192719250977035, 17.435593490220455],
              [73.196350106351119, 17.436071911944492],
              [73.202247642899351, 17.435649558461073],
              [73.204445880514726, 17.438514358195711],
              [73.197267484356374, 17.44337157538207],
              [73.191303365489631, 17.44473590692494],
              [73.188494168166571, 17.446384852993571],
              [73.187434180702439, 17.453143833430612],
              [73.191952063882468, 17.45483286054251],
              [73.194475628819248, 17.460737185476134],
              [73.194536526222578, 17.463908544480148],
              [73.186992175396085, 17.488172515485292],
              [73.183575490442536, 17.508098707015343],
              [73.177275999038102, 17.516945192428402],
              [73.167859945454722, 17.525919393001473],
              [73.160662859060153, 17.531463060004626],
              [73.153026979249631, 17.538675364256825],
              [73.149376146314452, 17.54292870648769],
              [73.144585268227758, 17.549135507702825],
              [73.141257951625505, 17.556541043793281],
              [73.142848995862991, 17.566082508208677],
              [73.15006471297211, 17.570945913787153],
              [73.156031767127914, 17.573444015506716],
              [73.155508009811001, 17.577694727309549],
              [73.160063045142138, 17.590817443129787],
              [73.152896254759867, 17.595878173148062],
              [73.148861330178576, 17.600054957842293],
              [73.145433372618044, 17.603874814740276],
              [73.140419046477092, 17.619152601710677],
              [73.133729938280908, 17.634170060783134],
              [73.130457917633521, 17.639784478801904],
              [73.138575642234287, 17.641518510094702],
              [73.138027037116217, 17.645115416207993],
              [73.134150468771281, 17.652188473117949],
              [73.130942969133685, 17.658125961565062],
              [73.123670478549798, 17.667249399670485],
              [73.121221584178144, 17.672396329786281],
              [73.119970687168973, 17.676324963101465],
              [73.118333795963835, 17.681624328971132],
              [73.117005456014041, 17.689525190090965],
              [73.11705511021195, 17.69313332749763],
              [73.120988426081198, 17.696812346283661],
              [73.124153126363268, 17.69811211306958],
              [73.132677404489925, 17.702473353512801],
              [73.136386432775666, 17.70536736605753],
              [73.139287091991108, 17.709141919646815],
              [73.138133742182276, 17.717966075865533],
              [73.111982121717062, 17.78132459123476],
              [73.108558714856372, 17.789530404477276],
              [73.09768117209633, 17.808303152566832],
              [73.096196989344691, 17.822771281146778],
              [73.093380071909053, 17.831815298533172],
              [73.097725493311657, 17.836583379521969],
              [73.105689980636228, 17.83307979905317],
              [73.111001256683764, 17.831478863383946],
              [73.115574835321098, 17.830759317859865],
              [73.125052088895842, 17.833348590629647],
              [73.115946954161927, 17.836257433219878],
              [73.110852166677034, 17.839080193739516],
              [73.102056670504425, 17.844566380702734],
              [73.098039574785886, 17.8438019893415],
              [73.092095588082884, 17.838720044756982],
              [73.083427784735292, 17.855304617852585],
              [73.075886707554716, 17.877775854647187],
              [73.075480816865337, 17.886129021233494],
              [73.079408569270441, 17.890270053046763],
              [73.080264046052108, 17.894351976427266],
              [73.07526851143372, 17.895613198171223],
              [73.069513611155614, 17.889301810027415],
              [73.066930909112813, 17.887552820225174],
              [73.063390188393726, 17.888174318941179],
              [73.055939013746453, 17.893431492634644],
              [73.054541332519378, 17.90574089622141],
              [73.057165156026045, 17.910178653570625],
              [73.05527846083838, 17.918113908639977],
              [73.047600573891401, 17.922764937295092],
              [73.044814452101363, 17.929859173511023],
              [73.039391442869999, 17.932075930365606],
              [73.036380725978702, 17.933741680446634],
              [73.033588708504112, 17.936444672036355],
              [73.031757652850985, 17.944976969932711],
              [73.028418926617704, 17.963695227134728],
              [73.028077210287719, 17.986737891026305],
              [73.019943193006085, 17.991336373091123],
              [73.01570875541114, 18.002326390535725],
              [73.007776765132036, 18.014370620801444],
              [73.006807720519262, 18.021816519356655],
              [73.015719985249945, 18.025388775468219],
              [73.020043778521028, 18.021866373407832],
              [73.024615696808482, 18.02149447660581],
              [73.028128980905464, 18.029533184874644],
              [73.030410550476049, 18.034286627116479],
              [73.035696045781492, 18.037856893004573],
              [73.044038972271693, 18.039946080624539],
              [73.046822620652918, 18.042503647390269],
              [73.041722901978915, 18.048722612059887],
              [73.036294155514597, 18.047492903239441],
              [73.031640462589834, 18.0447384394556],
              [73.027769951271054, 18.042481674271031],
              [73.026100834803714, 18.039486547306364],
              [73.023106453363113, 18.035524179575944],
              [73.017519776962331, 18.030178428864041],
              [73.011796138552484, 18.031653137109164],
              [73.011545024609475, 18.045154843623013],
              [73.009309071581953, 18.048763483918808],
              [73.004555122959431, 18.050945989261031],
              [72.99661130181309, 18.048126910368055],
              [72.992280357175474, 18.049581717698473],
              [72.992417274143861, 18.059301413966253],
              [72.998406170420751, 18.062586704859299],
              [72.998577417100122, 18.065967139263247],
              [73.002020451539366, 18.070329669302382],
              [73.001590829833361, 18.073720462788366],
              [72.990820838463421, 18.097262776871446],
              [72.981796400604949, 18.104850050706283],
              [72.975976977898725, 18.117760693190732],
              [72.973094794591987, 18.119978151075745],
              [72.970764044951764, 18.12918826471854],
              [72.972469246860214, 18.132736738112257],
              [72.976379392943997, 18.133157980465633],
              [72.980609160221789, 18.134365796182507],
              [72.984468927662761, 18.141883942515868],
              [72.985799060314363, 18.157758876740765],
              [72.981589827318203, 18.183449254827238],
              [72.977674725636604, 18.194810917916431],
              [72.976189377952693, 18.199146037236183],
              [72.952333188575594, 18.217579458506972],
              [72.947671468393338, 18.218520684088695],
              [72.943387547267378, 18.216367939756722],
              [72.939112806802498, 18.211459218952641],
              [72.933991471806976, 18.212552025221566],
              [72.931963957352551, 18.219769630967633],
              [72.940420277168286, 18.231652598007063],
              [72.941551184964823, 18.236222170611928],
              [72.940992275293283, 18.239932068450088],
              [72.939755512226697, 18.24838406881182],
              [72.933646535050826, 18.263191286003398],
              [72.931974305093249, 18.275147635464883],
              [72.932412217945696, 18.279475063425217],
              [72.937355705676879, 18.283500890060882],
              [72.940635689157617, 18.284255157229435],
              [72.947166064027201, 18.284936929238512],
              [72.955058513295612, 18.296738214214777],
              [72.962139037604331, 18.315553767504234],
              [72.959585820414759, 18.319108522427747],
              [72.957311176920413, 18.323258155740952],
              [72.955661461130163, 18.328378905675532],
              [72.953508330142895, 18.33230971974557],
              [72.951427477918756, 18.33509395037289],
              [72.945546328799452, 18.338950791077892],
              [72.942773838263449, 18.341444313785978],
              [72.935465754863046, 18.345616316746661],
              [72.920896076519469, 18.353892191817003],
              [72.914616144338694, 18.358335750160702],
              [72.912510393365551, 18.361096258249738],
              [72.912395382921346, 18.366513784951533],
              [72.921470777891784, 18.368764194422219],
              [72.925558904662537, 18.371211345964682],
              [72.927019061430371, 18.374961345958869],
              [72.926604510196796, 18.380902768277494],
              [72.912185958873295, 18.392073714004969],
              [72.9077780976572, 18.404548475312815],
              [72.904526123446317, 18.431561794890985],
              [72.902899775907571, 18.438900765307327],
              [72.901432845673028, 18.442178932107769],
              [72.894621454244017, 18.449826359576576],
              [72.89209211378116, 18.45655014720073],
              [72.895302049427443, 18.461806194903257],
              [72.899235307062042, 18.46595211315578],
              [72.899983886802147, 18.474786968699316],
              [72.901223130413456, 18.488821656153426],
              [72.902492892063407, 18.495852782688072],
              [72.907558706335976, 18.497770399357382],
              [72.909632810873049, 18.501005263399353],
              [72.909226197550879, 18.514318426727137],
              [72.908266488872329, 18.5197196595159],
              [72.907040207366478, 18.522955714208791],
              [72.905320650039357, 18.525630485911556],
              [72.904039758994202, 18.529119433600087],
              [72.903465656612113, 18.534550299099514],
              [72.906730612595908, 18.53620177371743],
              [72.910462890306121, 18.534049711299378],
              [72.915977935850918, 18.530830697250853],
              [72.923702442373141, 18.530206519489106],
              [72.931459651581648, 18.533625284970739],
              [72.932196303322186, 18.538306008350194],
              [72.931390070269799, 18.541340628946944],
              [72.927655486653265, 18.542460046978277],
              [72.924629046631054, 18.54425955003882],
              [72.921410650033948, 18.548236256384801],
              [72.915835826140466, 18.560962163032613],
              [72.912085037566811, 18.570601253234077],
              [72.909568826502351, 18.574408573892171],
              [72.907767513656324, 18.578529994574726],
              [72.904861594226006, 18.58297981151479],
              [72.902272410857094, 18.587181379074917],
              [72.894297031106305, 18.596192235883482],
              [72.889534114922739, 18.602433891734449],
              [72.885772041322682, 18.605825120801732],
              [72.870656703099925, 18.61800839874234],
              [72.867663064212735, 18.620404443600918],
              [72.861676940768035, 18.639366137963201],
              [72.861728157561856, 18.644719359150582],
              [72.861790803160503, 18.648365433498064],
              [72.862352326160192, 18.654493934461996],
              [72.862245442833554, 18.658487010824153],
              [72.861580649242384, 18.668968153404517],
              [72.862570577436486, 18.672226951129666],
              [72.862368446905364, 18.678148631040248],
              [72.860358795637254, 18.682860818142675],
              [72.852905172506155, 18.69274376028924],
              [72.852449828962278, 18.699187873097962],
              [72.852619006496269, 18.704610969041077],
              [72.858923370281886, 18.71516809538031],
              [72.86036118203306, 18.730883876884558],
              [72.86090770764045, 18.737785778986641],
              [72.865967352620871, 18.756653835257794],
              [72.864747027705462, 18.763863963754339],
              [72.862761063609881, 18.767450629991362],
              [72.86035410373465, 18.773740239132824],
              [72.859946670613468, 18.78229751697172],
              [72.860532732885787, 18.787455039566002],
              [72.864912655597905, 18.804333781532559],
              [72.839982855615645, 18.845340357381161],
              [72.811136076158675, 18.893555331787017],
              [72.807512082658477, 18.895798554752073],
              [72.805646572866678, 18.904600170715405],
              [72.806158050863957, 18.908675766499126],
              [72.811560118658733, 18.920755605046285],
              [72.814159757971979, 18.923290339062607],
              [72.821164495157333, 18.932854861982026],
              [72.822726376435142, 18.937480953714587],
              [72.82223676874051, 18.94314221538513],
              [72.816873493907707, 18.949574896146068],
              [72.812770484685345, 18.95153119769224],
              [72.808261466798768, 18.950149431801407],
              [72.802972835957362, 18.946914923034001],
              [72.796150507582354, 18.941005665034247],
              [72.794068170497198, 18.938020977270604],
              [72.787611638509404, 18.939468948789145],
              [72.787609113264935, 18.944888033983872],
              [72.790055745144926, 18.949831896755107],
              [72.793429678874176, 18.95440457683895],
              [72.799524490348958, 18.964708446769198],
              [72.802126998873788, 18.970297781342055],
              [72.807847322615842, 18.980134298802458],
              [72.812668315572211, 19.003981839419971],
              [72.813254539468048, 19.014374636429668],
              [72.816446998643059, 19.017451188416491],
              [72.820159222018177, 19.018699300147919],
              [72.817646619755592, 19.032531559063571],
              [72.816033117349633, 19.038843716469348],
              [72.817821877922455, 19.04839160025897],
              [72.816987785791028, 19.054253175261774],
              [72.8167069958524, 19.06125085788679],
              [72.816877426961724, 19.06442400565258],
              [72.817735484090377, 19.06794114448358],
              [72.8201437562672, 19.072259438549967],
              [72.82174805568917, 19.075198398427887],
              [72.821805266626654, 19.078331218921036],
              [72.823044741781175, 19.090538878701999],
              [72.822401116643505, 19.104203282231463],
              [72.821805757596792, 19.108047921323784],
              [72.826293813143437, 19.111657971004167],
              [72.825751363344352, 19.124468745958779],
              [72.820234620462927, 19.126142904322485],
              [72.819717083783303, 19.122241807427649],
              [72.81260247804785, 19.126706838133856],
              [72.807669006604613, 19.133077100216653],
              [72.806673189873962, 19.137369706230853],
              [72.799733642639168, 19.137478021856779],
              [72.795168797037121, 19.124634699159419],
              [72.785986880518806, 19.124322242567764],
              [72.783961856320389, 19.130387405048626],
              [72.787489263541104, 19.136801680970855],
              [72.78765423989563, 19.145394462900281],
              [72.780593313193563, 19.1527059799127],
              [72.779929311326086, 19.156296923386197],
              [72.780997336572966, 19.160292488019902],
              [72.789211596161223, 19.165980749170814],
              [72.791643943634099, 19.168512953516505],
              [72.794435186199365, 19.176496421959527],
              [72.794605289925101, 19.1827457805786],
              [72.793899458660817, 19.189206442715218],
              [72.788849996504368, 19.192083210708713],
              [72.784628698737066, 19.193692035250901],
              [72.782701661782184, 19.205844181401396],
              [72.778955853526497, 19.216121066166519],
              [72.780156202294904, 19.222760476674818],
              [72.781984680308511, 19.236807880069524],
              [72.782250822786324, 19.244116301652575],
              [72.782197432619597, 19.257847954856434],
              [72.78158735914802, 19.26128289037894],
              [72.78124644156712, 19.267689853925443],
              [72.782434104305295, 19.273635197074007],
              [72.783102989671107, 19.277592665241396],
              [72.782828823114897, 19.280688524479483],
              [72.782964677506641, 19.285260534535592],
              [72.783535586601246, 19.289866533346586],
              [72.784164277372156, 19.298193089870558],
              [72.793901909986062, 19.304144271875071],
              [72.797814082295091, 19.318627087533883],
              [72.800049313146886, 19.330318504046545],
              [72.796899320696212, 19.332500918283607],
              [72.789986763774465, 19.337219827962141],
              [72.776656142479013, 19.352339946713407],
              [72.765937290511417, 19.363254708273221],
              [72.757543463228032, 19.373675375855289],
              [72.75520632646078, 19.378433226970998],
              [72.75437869220417, 19.382278493984028],
              [72.758668983776175, 19.389127088516435],
              [72.757690217295632, 19.398737665580111],
              [72.755785644543167, 19.417013238550215],
              [72.753197687931817, 19.432382747225898],
              [72.749096540972531, 19.448678792154546],
              [72.74656767378562, 19.462118300036838],
              [72.748618270525299, 19.485921395285324],
              [72.743304640774852, 19.492927979261722],
              [72.730240854781186, 19.500125941477851],
              [72.730168528642494, 19.511261663080731],
              [72.728380264867923, 19.515102739622922],
              [72.728009261368584, 19.519480025356593],
              [72.720513228933441, 19.52785621321495],
              [72.71823881648443, 19.530722091211235],
              [72.715357802819682, 19.534584551870218],
              [72.713047345205368, 19.539952247968991],
              [72.71174087067844, 19.546902997409642],
              [72.709556577396512, 19.553077299586974],
              [72.709787599542679, 19.566631152125158],
              [72.710240970903868, 19.569970468412421],
              [72.710710780799047, 19.573631907923389],
              [72.711648709785308, 19.577345669314667],
              [72.711703313068739, 19.581137669324534],
              [72.71318267242313, 19.585726598896951],
              [72.713950594598501, 19.590122572233721],
              [72.71570464066248, 19.593812608735334],
              [72.718935461713698, 19.598637648809369],
              [72.721132714150372, 19.602061876490776],
              [72.721144145244125, 19.609662984511566],
              [72.721147890138468, 19.616528261069043],
              [72.704926444858202, 19.630425986965676],
              [72.703734129085333, 19.633614212942511],
              [72.700776964881413, 19.637520607583646],
              [72.69900212890812, 19.640741410076703],
              [72.696794139605828, 19.64769521268402],
              [72.694850159316331, 19.656859325715185],
              [72.694770139873, 19.662138392815592],
              [72.694704159717205, 19.667877612318119],
              [72.69713499850431, 19.673673137509596],
              [72.697350912260617, 19.676777055417425],
              [72.697759125602857, 19.679955180228085],
              [72.702002547660115, 19.682071658006439],
              [72.708413011397852, 19.683845918373951],
              [72.712363412464484, 19.685035631138508],
              [72.714311178089389, 19.690820288470835],
              [72.712443228117962, 19.694796470662126],
              [72.706694217915683, 19.705712258023528],
              [72.699229449262873, 19.713306926182113],
              [72.695477783704675, 19.716918790721028],
              [72.69087097684482, 19.716700425973524],
              [72.685233637921769, 19.717008950054666],
              [72.679733121254188, 19.713693134935433],
              [72.676035763669518, 19.714045872362487],
              [72.675743396899307, 19.720055589172574],
              [72.675250577695692, 19.731203802866773],
              [72.676186376291454, 19.73464668621747],
              [72.677660705568371, 19.739845379720531],
              [72.677632075010365, 19.745952401050438],
              [72.671164369856541, 19.751363004005711],
              [72.669919831439728, 19.758567924726563],
              [72.670888968435506, 19.76188296395966],
              [72.674072561415429, 19.76377261461835],
              [72.677145730734793, 19.765799158416495],
              [72.68000169924052, 19.767959360239868],
              [72.685175189264484, 19.772271177379796],
              [72.686298785210923, 19.776688237580036],
              [72.685688968302088, 19.792701488561203],
              [72.710129911930267, 19.800026982006994],
              [72.713439904549503, 19.801685393503146],
              [72.72235806338044, 19.813411847090084],
              [72.722705923750638, 19.819068480437281],
              [72.720600802271761, 19.821730981343283],
              [72.709689220627325, 19.818110592760817],
              [72.699373434012998, 19.809956525384141],
              [72.694836916921616, 19.809739405618355],
              [72.68946748617816, 19.811135726035779],
              [72.684815585639441, 19.810272174983496],
              [72.683952412536982, 19.805702047574542],
              [72.680078566616089, 19.804856016162418],
              [72.675884528863691, 19.80906071059615],
              [72.673071570305297, 19.812534638482877],
              [72.669660687373735, 19.816501708714195],
              [72.665030996581535, 19.821687303371128],
              [72.663192232493387, 19.818122852212415],
              [72.660478939707829, 19.809720263900356],
              [72.65716171108015, 19.809895165425086],
              [72.654964242953824, 19.81212273667596],
              [72.653532433404834, 19.814870414801174],
              [72.652094447105014, 19.81786981575376],
              [72.644381244033511, 19.838991815903952],
              [72.642889066746733, 19.851150564991816],
              [72.645110365262468, 19.863416496080028],
              [72.644363482013077, 19.86904755686858],
              [72.64924709591071, 19.869939550361718],
              [72.651510426175562, 19.862942861489557],
              [72.655822317168642, 19.860492297406388],
              [72.666965704365651, 19.863685695013146],
              [72.669724536748021, 19.867598081219228],
              [72.6727282926486, 19.873322900446642],
              [72.671438638151656, 19.887138991465036],
              [72.669791703204638, 19.89281858231881],
              [72.667670195311103, 19.898051656220272],
              [72.663243447267718, 19.917834271776901],
              [72.657643466358635, 19.922229617986897],
              [72.65392806209131, 19.930892639797722],
              [72.651778825906135, 19.934241584579684],
              [72.650409307218084, 19.942407291191518],
              [72.653704160265988, 19.944755834104416],
              [72.665498315557841, 19.942523438458377],
              [72.668826159300934, 19.9425997789611],
              [72.675012014959179, 19.946988544588002],
              [72.680192816966382, 19.949747106086733],
              [72.684304613324343, 19.960357613173667],
              [72.688721502522185, 19.960687026589035],
              [72.695994998365379, 19.961403341706571],
              [72.704344544318744, 19.966805774939409],
              [72.707927952722059, 19.968357095259901],
              [72.710469946107821, 19.961847140614445],
              [72.711138820017865, 19.954422404578391],
              [72.715035236131243, 19.952122281143708],
              [72.720297956314155, 19.952585290518989],
              [72.723872130557211, 19.951541683642485],
              [72.724500848713134, 19.945676864320593],
              [72.720613675907629, 19.9436602967208],
              [72.724338200581116, 19.937453209759322],
              [72.725736525020537, 19.933925261434652],
              [72.726845244517889, 19.928324191898962],
              [72.728250597684578, 19.924544569832275],
              [72.732589285413653, 19.922711492250492],
              [72.736469561425665, 19.922582444029981],
              [72.737081371029987, 19.918227231233072],
              [72.734459768437588, 19.915107478900481],
              [72.73476105543179, 19.909653072858376],
              [72.737519792329849, 19.90709406001119],
              [72.742402449865907, 19.907203443648843],
              [72.743658259565194, 19.910944927520461],
              [72.747141715492234, 19.913208599581875],
              [72.751446218756911, 19.90937085793426],
              [72.752543154393052, 19.905900074919114],
              [72.753876801817839, 19.902963230347758],
              [72.753993919263237, 19.898159429562977],
              [72.753790152763941, 19.892473427991462],
              [72.753570713312072, 19.887661425151542],
              [72.756700115264096, 19.88380129935544],
              [72.759243444881932, 19.889974521528782],
              [72.761852020505415, 19.893528104235244],
              [72.767514474832595, 19.896275406200665],
              [72.772543381129964, 19.897262084978397],
              [72.771782410464724, 19.900741124684377],
              [72.767355974222028, 19.902823049139862],
              [72.770705352220844, 19.907179998274827],
              [72.769610011635478, 19.910652141456112],
              [72.76800079397357, 19.914547152202118],
              [72.766027523142782, 19.919529394765938],
              [72.763695771072605, 19.925377027387743],
              [72.76242707147378, 19.929061794675668],
              [72.762483343699287, 19.9336520133037],
              [72.765935437299575, 19.937222316698623],
              [72.769462054065002, 19.9377381815302],
              [72.769867379897846, 19.941898771964514],
              [72.769250433629125, 19.946473753106204],
              [72.766986361001273, 19.949482097327706],
              [72.763443251420995, 19.949620256680365],
              [72.759770195916019, 19.94822823073693],
              [72.756071251012997, 19.947928247749722],
              [72.753228693541487, 19.953981395374115],
              [72.753322823841955, 19.957041701525906],
              [72.759360126392593, 19.958268717497319],
              [72.764269892889203, 19.957286354837827],
              [72.767484888207122, 19.956702968972344],
              [72.768542258655913, 19.961750324448708],
              [72.767574596708855, 19.966972571496523],
              [72.76587361680734, 19.971161500474246],
              [72.764155287694535, 19.974651646785947],
              [72.761885306201407, 19.978595720305417],
              [72.759990005508001, 19.981492290319547],
              [72.752456143702958, 19.981437688199044],
              [72.749412100497224, 19.978660265015517],
              [72.747191825905517, 19.972043593783425],
              [72.740579243779138, 19.973019679170342],
              [72.737572345570442, 19.978739014111898],
              [72.733957496147951, 19.974501504070897],
              [72.730963075279334, 19.97565060443667],
              [72.727878841983326, 19.983503065773011],
              [72.724581802884117, 19.98115491758756],
              [72.721342103864828, 19.977453959412674],
              [72.719467169885576, 19.984461738540571],
              [72.719085971954655, 19.99111136993103],
              [72.719701370054011, 19.995741476588673],
              [72.7200226428279, 19.99951619909125],
              [72.718412116098108, 20.006063959226751],
              [72.717577483440593, 20.010508156826436],
              [72.716221173664181, 20.014004464488242],
              [72.715151630857008, 20.019586616718417],
              [72.71686133546919, 20.023253448271252],
              [72.723200817309262, 20.027462162123374],
              [72.724905234562101, 20.03631809867893],
              [72.721442632397896, 20.041658048571669],
              [72.714645966629163, 20.035167346602076],
              [72.711739955355455, 20.036685602200862],
              [72.711095833332166, 20.047003877376358],
              [72.708719199685106, 20.053653823984451],
              [72.707209251765249, 20.056697348991268],
              [72.705186174368393, 20.05981938411125],
              [72.704005272771326, 20.064315889949775],
              [72.703664385690331, 20.072161577079477],
              [72.704199155737385, 20.081036165938908],
              [72.709534517786466, 20.092477711032537],
              [72.713266946625282, 20.095984254987599],
              [72.720762056051385, 20.102790524093226],
              [72.72178284344443, 20.105752499395567],
              [72.727134689390709, 20.121579639297568],
              [72.728120001711133, 20.130427263526119],
              [72.729242640861344, 20.136801890665872],
              [72.729839084813875, 20.141247178294247],
              [72.731285992825292, 20.146070136293524],
              [72.732290906908119, 20.149215402071427],
              [72.734737685573549, 20.155345401110331],
              [72.736775523817812, 20.170806618793357],
              [72.737227113030457, 20.183605952295544],
              [72.737490073290616, 20.19015539652597],
              [72.741077628515015, 20.195614740252783],
              [72.744099469886024, 20.198710292625996],
              [72.745543411621796, 20.202130460646611],
              [72.748439427375658, 20.203708333330365],
              [72.751988606538859, 20.204158929550733],
              [72.754262568340195, 20.208610551707665],
              [72.757280712926686, 20.21011981647537],
              [72.769067483611011, 20.210799602758264],
              [72.769735101646688, 20.214727686311903],
              [72.760752989126431, 20.217027232648956],
              [72.755185739856969, 20.216169555717684],
              [72.751750112724025, 20.213190190330899],
              [72.748411175281248, 20.210050911778115],
              [72.744842010062058, 20.211162918078312],
              [72.74429550445528, 20.215118262338297],
              [72.743464525981182, 20.221508968512314],
              [72.742491292299718, 20.229186498186095],
              [72.738378065166188, 20.235011784309396],
              [72.738123847961546, 20.239356217624962],
              [72.737779982239303, 20.246227646487995],
              [72.739204484342665, 20.250981615177135],
              [72.743091983326337, 20.258692903501302],
              [72.744538231414225, 20.262526852603219],
              [72.747450739577133, 20.265848303765129],
              [72.74843759451619, 20.269516669131061],
              [72.74941527739567, 20.273194834393305],
              [72.748465012242178, 20.278248319506048],
              [72.74994222180527, 20.284218323207394],
              [72.751404715092519, 20.28835157814752],
              [72.75191527168387, 20.293866610991561],
              [72.7538682794236, 20.297532739954033],
              [72.75631014151385, 20.302577834246506],
              [72.758761435124725, 20.307630397202004],
              [72.760226795678705, 20.312677140955355],
              [72.76073481593869, 20.317270689444701],
              [72.760265661862931, 20.32462322925387],
              [72.759310114706963, 20.328298047821033],
              [72.759814335687878, 20.334735417750586],
              [72.766159395585902, 20.342071212334901],
              [72.770062940245509, 20.34803251731072],
              [72.773969187596208, 20.35399505227452],
              [72.776417153841436, 20.357660520318699],
              [72.782259610997599, 20.36178104603551],
              [72.790539764053619, 20.366350140041583],
              [72.796866127436559, 20.37000352431787],
              [72.8019479265473, 20.37417078473635],
              [72.804188632366731, 20.376877398175612],
              [72.80664056724018, 20.384222620707977],
              [72.811048787990003, 20.394775164889467],
              [72.813027266255787, 20.402122311790883],
              [72.814995548660193, 20.409002354142331],
              [72.822784467693069, 20.412658240074538],
              [72.824257148691558, 20.416326360712517],
              [72.820863025673219, 20.419095139168789],
              [72.820417123462732, 20.422942489637808],
              [72.819421662970967, 20.430368237358646],
              [72.821033874427215, 20.438819453746753],
              [72.821727967119486, 20.442333827573957],
              [72.825579913183859, 20.450708512323079],
              [72.840274584094601, 20.469137683905608],
              [72.844575469181265, 20.474561895079461],
              [72.846634360200213, 20.477158915251064],
              [72.849663942335354, 20.480021585352471],
              [72.851844448304746, 20.483852747610261],
              [72.856215463164233, 20.487422938964613],
              [72.863500005113863, 20.49507274775975],
              [72.867091873495681, 20.498462477164402],
              [72.871176319243304, 20.503365874924718],
              [72.872989824824216, 20.506415214293238],
              [72.871342496415238, 20.520553270223136],
              [72.871182786425592, 20.529263549728174],
              [72.870640613117942, 20.535554503125951],
              [72.872419673691098, 20.540335472127047],
              [72.87268287249816, 20.545090631826348],
              [72.877276714392039, 20.555001507699668],
              [72.88412480352541, 20.562239084233415],
              [72.885721689063232, 20.571494577182332],
              [72.882641446250318, 20.610179192447159],
              [72.875429814648783, 20.633941839180554],
              [72.871521790694814, 20.649465460198027],
              [72.869299146018989, 20.654345757180735],
              [72.863153705688177, 20.677437964860658],
              [72.859828913297406, 20.687170368305555],
              [72.854249455956946, 20.699827230534954],
              [72.849826958283089, 20.709815132799442],
              [72.843691919062081, 20.736743021136746],
              [72.835597911451046, 20.749432660530811],
              [72.835869387369428, 20.756691855845407],
              [72.837543482756445, 20.760732550933248],
              [72.834945083827932, 20.768410541707397],
              [72.826096746892034, 20.780099943002863],
              [72.824333129982534, 20.792368853374445],
              [72.820478573968785, 20.800840932971827],
              [72.81826802019016, 20.803099639945628],
              [72.81737716120675, 20.819164811039094],
              [72.81227194706419, 20.837013369474946],
              [72.80691735613901, 20.847002039326782],
              [72.805979636122402, 20.85047503487537],
              [72.804530970922499, 20.854684073801565],
              [72.799514897121028, 20.864352417874766],
              [72.796407524812267, 20.86865999614459],
              [72.790450475423441, 20.881453073497237],
              [72.788556837494866, 20.88394082497269],
              [72.782829024111095, 20.899792436824015],
              [72.783142755056204, 20.919461652371588],
              [72.782947700949649, 20.925988160677448],
              [72.782350568709177, 20.929643598259531],
              [72.788364405530658, 20.932569580898761],
              [72.792901851004913, 20.933325682108372],
              [72.798269483801036, 20.934473753828669],
              [72.801980747731207, 20.935628233236091],
              [72.807356749185416, 20.938721677192593],
              [72.813558146508697, 20.94335671081457],
              [72.82099870870961, 20.947995976950239],
              [72.824721600516071, 20.949927278291305],
              [72.82801868063035, 20.949917177522472],
              [72.834188334102677, 20.946005766620935],
              [72.839543732422968, 20.944049431128576],
              [72.843671633339824, 20.944421683796268],
              [72.845742015945888, 20.947525915652296],
              [72.842458171762829, 20.95063935549847],
              [72.83628491684108, 20.953771900485027],
              [72.828870070963106, 20.955733451596075],
              [72.821856967326013, 20.955757927798643],
              [72.818559741233855, 20.955767893169167],
              [72.814022837402916, 20.955397538129041],
              [72.807001556395605, 20.953475599175178],
              [72.799564430578428, 20.949617131706233],
              [72.791298302143431, 20.945760322916019],
              [72.787165049905965, 20.943441072262218],
              [72.780946318529587, 20.939734946897094],
              [72.77414478951799, 20.935964995751476],
              [72.773691451771512, 20.931968273826438],
              [72.774411390906806, 20.928472527254545],
              [72.773657732860656, 20.922224034298704],
              [72.77088261132414, 20.917683251498854],
              [72.764957668087376, 20.919608881962606],
              [72.756061516324252, 20.93064141137809],
              [72.749761929030768, 20.944814104735098],
              [72.746777693066377, 20.950168228268748],
              [72.744323748187924, 20.957161567264645],
              [72.740645951749656, 20.9661029338227],
              [72.738400267196482, 20.971779266689293],
              [72.734741335588524, 20.995157392740353],
              [72.728404340899999, 21.006481325971308],
              [72.72732056847623, 21.011517408376044],
              [72.722821893133428, 21.032878036478714],
              [72.721990410035133, 21.039978976119961],
              [72.721917488118265, 21.047885267663542],
              [72.726160468645602, 21.052608081954954],
              [72.730190318963707, 21.052412503021536],
              [72.738666010269924, 21.051375970256064],
              [72.742182589894881, 21.050952431166195],
              [72.754909920074894, 21.050387302615107],
              [72.749023252190113, 21.05798786119459],
              [72.746147408131293, 21.060041592135725],
              [72.737578363571203, 21.062524983888292],
              [72.728624218976989, 21.066203460547513],
              [72.715865247388876, 21.065044934616797],
              [72.712026924856289, 21.064641182669625],
              [72.706695273794722, 21.063001440760225],
              [72.69972471216839, 21.060835689436427],
              [72.694700738262128, 21.063790169405046],
              [72.692788559653891, 21.077767086599835],
              [72.699332040808457, 21.091743389802733],
              [72.702603801940413, 21.095023662003452],
              [72.665506578332753, 21.099039253765667],
              [72.663498689457782, 21.089421559823425],
              [72.658492963827683, 21.082516983769395],
              [72.656695881491174, 21.078018292439641],
              [72.654074388441728, 21.075635021623899],
              [72.648672036859125, 21.074657272404888],
              [72.646381132727328, 21.077075363170678],
              [72.632021738783521, 21.081404500917849],
              [72.627349180805467, 21.084720043452183],
              [72.624429508414124, 21.090233609153895],
              [72.621193458266021, 21.098572000874661],
              [72.619421028688734, 21.112340914519269],
              [72.616473132819635, 21.135234481373089],
              [72.616730076212903, 21.149757803269033],
              [72.615421594168964, 21.154058337751174],
              [72.614930577780399, 21.182095174457398],
              [72.613761813334136, 21.203284626246976],
              [72.60930146110374, 21.212808141528679],
              [72.60538585254173, 21.218031507681122],
              [72.600604736058543, 21.233024158968291],
              [72.598902655538183, 21.237048942237575],
              [72.593738616423735, 21.275942116425774],
              [72.590428426697358, 21.287167905320945],
              [72.587407051007446, 21.298794579888675],
              [72.589519817968991, 21.301940433658839],
              [72.591557756011341, 21.304602005591398],
              [72.595507673891092, 21.318678471016742],
              [72.600105610030951, 21.326803166410421],
              [72.600850203438057, 21.334211632782292],
              [72.365610004854076, 21.35735607188046],
              [72.126632508859345, 21.302174583777298],
              [72.124303847439734, 21.298889700544571],
              [72.121786748761394, 21.294360920274482],
              [72.120812864369668, 21.28735085472541],
              [72.118179472725245, 21.274226522464641],
              [72.115824388054932, 21.250554247117339],
              [72.115559631459831, 21.245036912265995],
              [72.109803490831041, 21.22354600539073],
              [72.110515719673757, 21.220099367397705],
              [72.111989045051402, 21.213020244543404],
              [72.113093419951213, 21.207736248217614],
              [72.116495753384768, 21.204888902650211],
              [72.116939857634904, 21.199741283855289],
              [72.110488923188967, 21.192979350633042],
              [72.106577637621967, 21.190975813245323],
              [72.101564652047301, 21.190695807893054],
              [72.093812481646069, 21.190276257559496],
              [72.086601442507501, 21.187556120983619],
              [72.079637430818877, 21.181898014727256],
              [72.050387699921799, 21.164489604893671],
              [72.044034509644817, 21.161563662981532],
              [72.030936712731901, 21.155802519520009],
              [72.018060463153077, 21.149718257029843],
              [72.014571655478633, 21.144495815467884],
              [72.012190082065104, 21.134861943236519],
              [72.00881830694037, 21.133961641650707],
              [72.006491671772906, 21.136463060698272],
              [72.002918662685715, 21.139054304739215],
              [72.000859679110349, 21.142659627208484],
              [72.002415165748133, 21.148546791085025],
              [72.007908014841107, 21.153725547997361],
              [72.013448684679673, 21.160145605636625],
              [72.015131126247411, 21.163317714200424],
              [72.023065646815596, 21.171879949155475],
              [72.024401705020367, 21.177971397690101],
              [72.019433443534354, 21.181388157379882],
              [72.009092187209944, 21.179099228462274],
              [72.003449441597027, 21.175275678714037],
              [71.996364574028703, 21.171611686951685],
              [71.993026648006435, 21.163746760993305],
              [71.991762387478403, 21.159654499503588],
              [71.987679113618327, 21.159416510499639],
              [71.984601098984186, 21.157781218940997],
              [71.985978270545701, 21.151054261651591],
              [71.990149913065395, 21.143999677179185],
              [71.989428639310702, 21.136528501892549],
              [71.98640563712874, 21.131421781089436],
              [71.973589529106377, 21.121357395311485],
              [71.967115884154964, 21.118841981534342],
              [71.942310750529259, 21.116660975832321],
              [71.932004140678018, 21.112482417818935],
              [71.919956849843487, 21.111080147945682],
              [71.89858443013776, 21.104625777999932],
              [71.870935611965848, 21.08721246766105],
              [71.85675419263886, 21.080423644284195],
              [71.850282158069746, 21.078800151812811],
              [71.84282412683315, 21.080596323338728],
              [71.843147700013361, 21.087607973411934],
              [71.853128864071522, 21.093055327036961],
              [71.855392938173154, 21.096577772531532],
              [71.848786960236794, 21.099617327870103],
              [71.842181430672866, 21.092500577801555],
              [71.836993318576489, 21.095292087326161],
              [71.835541697873737, 21.098920322264171],
              [71.832433741030243, 21.100496764607907],
              [71.827596051325671, 21.09979492935048],
              [71.82411651229981, 21.094132435335364],
              [71.824032557311185, 21.089260836587115],
              [71.825250903665875, 21.081680379534149],
              [71.832708484096841, 21.08013408553818],
              [71.833914970243356, 21.076736059409964],
              [71.831772715720945, 21.07378884055133],
              [71.822171263947425, 21.072846488823238],
              [71.811211214399037, 21.068887025570611],
              [71.804213802950031, 21.06362826065422],
              [71.799312968837143, 21.05996242239636],
              [71.796689169855313, 21.05469194652423],
              [71.792609473480681, 21.05467928133789],
              [71.790907235605417, 21.060100237940183],
              [71.793267322904072, 21.063600245350454],
              [71.79664805422199, 21.06871019320829],
              [71.789435886039527, 21.070070756966743],
              [71.785723066619184, 21.069716261059686],
              [71.781285588204199, 21.066415768402713],
              [71.779706028041176, 21.063563763080694],
              [71.778432619027697, 21.056457100342936],
              [71.780375980819699, 21.052164252709176],
              [71.791917763219629, 21.048977646967145],
              [71.79817746457131, 21.047227061315937],
              [71.8051754651203, 21.043635502759855],
              [71.803720630331924, 21.039793784974503],
              [71.799297936634346, 21.039942411367203],
              [71.791939958081088, 21.041509799228539],
              [71.786266012046738, 21.043470686103632],
              [71.782578770109367, 21.042954080316424],
              [71.777254565779515, 21.042203476619026],
              [71.773859561505574, 21.057152121421623],
              [71.765090341068458, 21.056994575817608],
              [71.759927699761718, 21.059277753306322],
              [71.754719100378153, 21.060480658838216],
              [71.751854774571399, 21.054793868742838],
              [71.753916599691948, 21.051858497873543],
              [71.75622572183012, 21.047911490669303],
              [71.750561044149237, 21.046885294686003],
              [71.75057219156453, 21.043482225803015],
              [71.747958012089143, 21.036004522789561],
              [71.753483248143596, 21.034666778],
              [71.758562024362078, 21.035599797266975],
              [71.762394725906759, 21.036415211569754],
              [71.769598179231849, 21.037446898603996],
              [71.772823386983504, 21.037226635723897],
              [71.776293786439666, 21.03684546879547],
              [71.780183048557916, 21.035432005253774],
              [71.773940718145738, 21.031553867020683],
              [71.770570156684713, 21.03133759543579],
              [71.762442295929404, 21.021339032779075],
              [71.754018399571351, 21.02018889029539],
              [71.746620021853332, 21.019316010512359],
              [71.736010084053305, 21.014479966282135],
              [71.720897463486295, 21.012479723065461],
              [71.715942967429299, 21.011154944188718],
              [71.710589643873661, 21.005391031516069],
              [71.70540715048142, 20.999788559357867],
              [71.697365809892716, 20.994660345279488],
              [71.689925080430569, 20.992384154956277],
              [71.68535648900631, 20.992828292096654],
              [71.680186494645014, 20.993975728036993],
              [71.66875720342631, 20.997068974608794],
              [71.662727984323183, 20.996152529025121],
              [71.649055309264895, 20.988864003176062],
              [71.646230546966024, 20.986648562816029],
              [71.637623495890168, 20.977123888056045],
              [71.633758159563683, 20.972857532631451],
              [71.627764116343698, 20.969640521081583],
              [71.623736703889449, 20.968499005994257],
              [71.61934889018211, 20.967265516889633],
              [71.614757997123689, 20.967226228142831],
              [71.610803358126461, 20.966956513036784],
              [71.606923873411432, 20.966207617460174],
              [71.601779537585088, 20.964395286388626],
              [71.594613657779632, 20.961356103714238],
              [71.575701042218455, 20.953283527711516],
              [71.570875239684369, 20.951217834356971],
              [71.558985544529449, 20.951009521584282],
              [71.555105420860002, 20.950579757317417],
              [71.550604246722628, 20.9498851531642],
              [71.543965142104241, 20.945990025519176],
              [71.540895374630466, 20.944048265335038],
              [71.525342940694884, 20.920551736661267],
              [71.5174414686566, 20.919129181307447],
              [71.512787317375867, 20.915255714161223],
              [71.496908626877286, 20.902037801988065],
              [71.481686614740028, 20.894788250583975],
              [71.478423699406008, 20.895605895147678],
              [71.475923300911361, 20.893027053345925],
              [71.472859956407632, 20.89059998259177],
              [71.450997892728722, 20.875488642822447],
              [71.440581696323221, 20.87013008438408],
              [71.436512200651052, 20.868984950585169],
              [71.405516335124858, 20.869706251099888],
              [71.399971720399051, 20.870595824748094],
              [71.392032515519404, 20.87643992306106],
              [71.379307793651577, 20.87389293931944],
              [71.372823683174587, 20.87680202285005],
              [71.373966377411122, 20.881795534981045],
              [71.383763007311828, 20.892924469198526],
              [71.384916578564983, 20.896101337081181],
              [71.386325291097876, 20.901625655569227],
              [71.386778099597407, 20.912153779955617],
              [71.395504531731405, 20.918658028039264],
              [71.399313410465993, 20.922975422421242],
              [71.403503962487264, 20.928765804263616],
              [71.403927053090442, 20.931800903966138],
              [71.403129265149929, 20.934761120042147],
              [71.393749173738215, 20.931313050678671],
              [71.388077006185554, 20.932756130310306],
              [71.384501507291446, 20.930484552846927],
              [71.384018665447044, 20.925265632553078],
              [71.382178847894252, 20.91824609302201],
              [71.376942142027147, 20.911919560627943],
              [71.372882379402469, 20.904843834267201],
              [71.366907662158027, 20.899617702536826],
              [71.359623864900826, 20.897144252079094],
              [71.356018705017362, 20.895951515657501],
              [71.350100453790262, 20.893874522616166],
              [71.342440982953477, 20.893144735028557],
              [71.330904766082341, 20.891725375266674],
              [71.326029582768285, 20.890665058591463],
              [71.319775349571074, 20.887711815826762],
              [71.305757746413263, 20.881198487955412],
              [71.313239475167563, 20.878965383517421],
              [71.31311827559378, 20.87489525540019],
              [71.311776208448023, 20.862958695001584],
              [71.312396940992585, 20.857239559775671],
              [71.315507001698961, 20.8554413736363],
              [71.320577107393817, 20.856296916111358],
              [71.328585916023187, 20.859488318541057],
              [71.332547569165996, 20.862109409850476],
              [71.337785823866625, 20.867561244817782],
              [71.341562836996857, 20.876638105486066],
              [71.348782362114036, 20.877364356784678],
              [71.35355085814173, 20.879873933832577],
              [71.359587176211775, 20.874251586080742],
              [71.36661324063239, 20.870449852388735],
              [71.371337686682082, 20.86794651666635],
              [71.376224073587736, 20.866845214310924],
              [71.381536505526924, 20.863952068380378],
              [71.382480744365907, 20.860758065918137],
              [71.380458266850482, 20.856398749922132],
              [71.376877143771381, 20.855422674334083],
              [71.3708749571732, 20.855072483337093],
              [71.358959301759171, 20.851441838083637],
              [71.350776507017741, 20.849967089810661],
              [71.344636010794176, 20.849456075628201],
              [71.336451134028692, 20.848450856543945],
              [71.329794261260218, 20.847445777606552],
              [71.324166207083451, 20.846446936100328],
              [71.314461115559794, 20.842534483403988],
              [71.307816635900465, 20.839598927606279],
              [71.302198287592262, 20.837151579717233],
              [71.296586404862381, 20.833740447444388],
              [71.289948087316247, 20.829845087683907],
              [71.283311857383225, 20.827388690353107],
              [71.276662477367722, 20.825422283819741],
              [71.270742754728616, 20.823263444787337],
              [71.26364003264429, 20.820094625695699],
              [71.258602213199353, 20.81824997272648],
              [71.237078857790621, 20.804562284789373],
              [71.23096412074905, 20.803400231978713],
              [71.213459731801692, 20.801938100324893],
              [71.209732960953616, 20.795645140167405],
              [71.199714801533403, 20.79277015042473],
              [71.187175109914719, 20.786513278946998],
              [71.182580277399921, 20.784391243542835],
              [71.174739080264189, 20.782666010383664],
              [71.167784320350307, 20.779724553853846],
              [71.164593197867319, 20.7792211961237],
              [71.161656934734154, 20.777179460462332],
              [71.157167255593194, 20.772377344162152],
              [71.153549208644023, 20.768507812233228],
              [71.14737266944401, 20.771053247906369],
              [71.143217416088831, 20.763126804917864],
              [71.152899808073869, 20.760357008360632],
              [71.150772957842165, 20.757757240001549],
              [71.145880752696073, 20.756371215465869],
              [71.142376060281435, 20.755565516295583],
              [71.124100282952966, 20.757099279057371],
              [71.102981035704872, 20.757325779318009],
              [71.09696847942628, 20.759101537994578],
              [71.099516767669101, 20.763990089440004],
              [71.10698751481867, 20.769350332338917],
              [71.099776827522149, 20.771553291380606],
              [71.097576732080697, 20.775401430745784],
              [71.085728784222212, 20.768425012096287],
              [71.085963626708079, 20.763231961877068],
              [71.083400407431355, 20.760364773622829],
              [71.080359931839638, 20.752988261814878],
              [71.07682528235047, 20.74969942958904],
              [71.075709149966457, 20.745830773539421],
              [71.08101925797466, 20.743361124526427],
              [71.08010142506302, 20.739057269698502],
              [71.076536293137053, 20.736550381047639],
              [71.065006396767515, 20.733068863593932],
              [71.045797962362414, 20.73564556280504],
              [71.014191840442578, 20.734995837844949],
              [71.0063299974383, 20.734832973520582],
              [70.999749471365845, 20.731498048283381],
              [70.992619254833045, 20.723952265433109],
              [70.985276163721309, 20.727415310343776],
              [70.995607042447062, 20.734203065167684],
              [71.004214609401387, 20.74304754132579],
              [71.005237980221111, 20.746635581690718],
              [70.99999952106181, 20.747087450779105],
              [70.995015713837759, 20.743992049741674],
              [70.991087803747533, 20.740976549686877],
              [70.985647363283874, 20.738975062489523],
              [70.982565784352062, 20.736164689568394],
              [70.98244950528445, 20.732850924161408],
              [70.97294603995104, 20.735983510413345],
              [70.957211815259257, 20.738180209504748],
              [70.942573799793593, 20.734083416458528],
              [70.929015606436707, 20.738647817307591],
              [70.919331167799555, 20.741429283031366],
              [70.914431249845137, 20.740895281090214],
              [70.910062228279571, 20.734016029150823],
              [70.929068565733388, 20.734250825944756],
              [70.930920711807374, 20.728702363201783],
              [70.937036391559346, 20.729118253236592],
              [70.940739532737751, 20.729445354986229],
              [70.945138249937742, 20.719755875503129],
              [70.948876410783257, 20.718772983532304],
              [70.953041513443026, 20.722093190147948],
              [70.957836549025359, 20.723024154487703],
              [70.969649273848631, 20.718586910321619],
              [70.981150204266754, 20.719361468944435],
              [70.992198743232095, 20.715814143125225],
              [70.999646742514074, 20.7172481966875],
              [70.99824566790798, 20.712686743814306],
              [70.980057262297137, 20.704185211934711],
              [70.965893325741803, 20.707250164328869],
              [70.947081727410747, 20.706325930314968],
              [70.937121441298146, 20.710776218328043],
              [70.933450813764594, 20.712425767482841],
              [70.92386772422239, 20.709870618011436],
              [70.917716553806088, 20.705177523833779],
              [70.919635710683352, 20.700344706315047],
              [70.912463403998288, 20.69824198438139],
              [70.902112461584252, 20.699976174754561],
              [70.893434136569411, 20.70551523424685],
              [70.884413414114036, 20.70829282060496],
              [70.879849267101719, 20.708693669606912],
              [70.876550913900232, 20.709769861453253],
              [70.875239084268259, 20.714677489546368],
              [70.870385854981237, 20.708068104316009],
              [70.866407929193755, 20.709757255077818],
              [70.849972852349509, 20.710427930583936],
              [70.840402130935331, 20.706717235660019],
              [70.837165193202139, 20.703495325641796],
              [70.833247194647456, 20.702796629248354],
              [70.830286091207768, 20.706632671759799],
              [70.827888125723973, 20.71024321277606],
              [70.818753424331675, 20.714671559933532],
              [70.819145990291346, 20.722144539443992],
              [70.805878400697239, 20.730398902349204],
              [70.79708024573452, 20.730002640272634],
              [70.794058177172914, 20.728482013102049],
              [70.792565567970144, 20.7241188153371],
              [70.797496359162878, 20.722426304488497],
              [70.801824018533324, 20.72162958239063],
              [70.809245120879211, 20.719066823879871],
              [70.811691717202095, 20.716802626750173],
              [70.811734751053351, 20.712199434599533],
              [70.810169338381741, 20.706823044761343],
              [70.811814307759064, 20.703758424626415],
              [70.818356109410729, 20.700751218074149],
              [70.824888621709079, 20.696979571387129],
              [70.828959326276433, 20.695475571142243],
              [70.828994799152341, 20.69165156962816],
              [70.824123902380279, 20.692371434743464],
              [70.819228833377906, 20.693855133253464],
              [70.811871996792206, 20.697634003792455],
              [70.804530715121558, 20.701397575592217],
              [70.796358448553619, 20.705928931237349],
              [70.78165769052579, 20.713469207678628],
              [70.77104307790735, 20.717977453611777],
              [70.762082543934525, 20.720201166715398],
              [70.754761362618993, 20.721675779835344],
              [70.747439734461352, 20.721611402163742],
              [70.740118264961836, 20.723071457013287],
              [70.732758161618477, 20.726846581746294],
              [70.726208272689206, 20.731381472129794],
              [70.71725285542837, 20.73755464385988],
              [70.709534389466398, 20.741322493238425],
              [70.675780347278135, 20.756160659789021],
              [70.660924654739674, 20.758965497308026],
              [70.649575966125326, 20.762189820307697],
              [70.644725482482372, 20.764259912438789],
              [70.639520882099248, 20.764711125005334],
              [70.632235552648822, 20.766831087739316],
              [70.618039735127439, 20.769407501380758],
              [70.602583491691945, 20.777875655726298],
              [70.590491897775308, 20.781851241555152],
              [70.582089965777001, 20.785145694286566],
              [70.575084439803533, 20.790041453873215],
              [70.5682602034301, 20.791813092731914],
              [70.564094417607862, 20.793497106832124],
              [70.56010038868861, 20.797362888163661],
              [70.554064162435921, 20.802728823073284],
              [70.557388182185946, 20.80434679266407],
              [70.571951395238287, 20.802124450437955],
              [70.579982298821378, 20.801628326052462],
              [70.590008279989675, 20.797105834599584],
              [70.592371373982914, 20.799611732752847],
              [70.592938402778358, 20.803547116885692],
              [70.590035391641024, 20.805817319393491],
              [70.587800116828916, 20.811656846084087],
              [70.579601479685294, 20.814080953908007],
              [70.572938305946948, 20.809924257442503],
              [70.564963108525077, 20.8141665614326],
              [70.557451265292656, 20.809655836692599],
              [70.551313182339541, 20.813179743892039],
              [70.54388917652507, 20.811681321263649],
              [70.545119962555148, 20.808522454045512],
              [70.546937447602005, 20.805253949752263],
              [70.542903195297654, 20.803904324753542],
              [70.539392996558405, 20.803706827804799],
              [70.512347166707613, 20.815890046272891],
              [70.490856910977186, 20.828332757805622],
              [70.486253454636682, 20.831893910332614],
              [70.463345079169827, 20.840043077364779],
              [70.449309962097047, 20.84667563229981],
              [70.446108379356545, 20.849146456519495],
              [70.441826268406302, 20.85220287843276],
              [70.42411711068884, 20.86789460857997],
              [70.410241961097313, 20.881096688372502],
              [70.402489111001117, 20.886437714581266],
              [70.396343221364987, 20.890047787940169],
              [70.380730246396823, 20.899298507581015],
              [70.374752730839589, 20.89904873579172],
              [70.370413835036686, 20.896588507043703],
              [70.349308652529018, 20.913451362437552],
              [70.33577097675149, 20.920309620365103],
              [70.319638980705918, 20.931411312468942],
              [70.307642501992234, 20.939710040188316],
              [70.303279062613868, 20.94294608957884],
              [70.29501574014671, 20.949467987979567],
              [70.274626985384131, 20.964400645759508],
              [70.262016046333898, 20.972618255122125],
              [70.258593050269809, 20.976644770682014],
              [70.242960920091988, 20.990668520422101],
              [70.226729650262143, 21.00522555368493],
              [70.209552640150349, 21.014601401437673],
              [70.19065120408851, 21.024922026819471],
              [70.170481491255472, 21.041333123836381],
              [70.134207922618131, 21.070831074084186],
              [70.124227206538023, 21.080196330899771],
              [70.116129228811616, 21.091171651914095],
              [70.108726630208878, 21.097788407537546],
              [70.071866176403432, 21.131648940402815],
              [70.063690604479689, 21.140711789760527],
              [70.034109875138171, 21.170316142978063],
              [70.02706112084573, 21.177322948218418],
              [70.006691407530369, 21.201710068922129],
              [69.986210815774868, 21.223244546559688],
              [69.982313412972076, 21.227639635049719],
              [69.976649730650024, 21.23265258744075],
              [69.963136753499072, 21.246025748884275],
              [69.958313209324331, 21.251038686181477],
              [69.953490957628674, 21.255959267239199],
              [69.930475072075339, 21.283724137249074],
              [69.925964325120972, 21.290509392076125],
              [69.91573264075663, 21.303074792074774],
              [69.9078079095557, 21.312064445669403],
              [69.904384878408266, 21.31495867024395],
              [69.897813398488239, 21.323392110326736],
              [69.880660895678901, 21.341396255930892],
              [69.877423987794089, 21.34479689874469],
              [69.872851177499129, 21.353647460630818],
              [69.853950085848851, 21.373300081311221],
              [69.844577888908347, 21.386516200357104],
              [69.819798128742477, 21.414651626568702],
              [69.803749998642715, 21.429744367960033],
              [69.797878028591796, 21.435241340960491],
              [69.770357730208701, 21.466476162039495],
              [69.763981020250952, 21.472630830658076],
              [69.762245008388987, 21.475318390991745],
              [69.758424554121476, 21.479556550136504],
              [69.740773679685219, 21.497262047903508],
              [69.732554676052615, 21.506420131101432],
              [69.726663483534679, 21.514075262364862],
              [69.723708415366147, 21.519178022400343],
              [69.719561126979826, 21.523756023424699],
              [69.711207200034508, 21.531992344813233],
              [69.720098918117102, 21.535296980883714],
              [69.720976226283057, 21.538458900216831],
              [69.718056980333344, 21.539998625226275],
              [69.707813548735416, 21.539728938282977],
              [69.704294475226433, 21.540480257691495],
              [69.698428971330841, 21.543676942328574],
              [69.69369680905713, 21.546545922302162],
              [69.691108290688589, 21.548779748051025],
              [69.686708251229732, 21.555077859429648],
              [69.675079837709461, 21.56666352762301],
              [69.659199793933865, 21.58146562280459],
              [69.642993145652383, 21.596516785522955],
              [69.636519420895652, 21.607512438951801],
              [69.623011574102051, 21.620855430097183],
              [69.606667453163652, 21.630776100469845],
              [69.586019829646787, 21.639799400256205],
              [69.577534756509209, 21.645016439977834],
              [69.548769402305254, 21.666930597731891],
              [69.525209859038242, 21.686902195451438],
              [69.514981216027181, 21.698451434548328],
              [69.510393430098091, 21.703614695527872],
              [69.494912842905705, 21.717602772137681],
              [69.485900098093964, 21.72822834086033],
              [69.481223872675614, 21.732746013528182],
              [69.474388092055236, 21.737203889314987],
              [69.467125842406432, 21.740826637788128],
              [69.462269582279802, 21.744420926269875],
              [69.45119719828061, 21.753401644804555],
              [69.445295502145854, 21.758975964367227],
              [69.442453309297946, 21.761203801520235],
              [69.426421284675541, 21.773798141296076],
              [69.422970514182254, 21.777000605219982],
              [69.410585955431173, 21.788782624611461],
              [69.391190868350421, 21.807217425178784],
              [69.38994199892538, 21.810802507932454],
              [69.382772445600537, 21.818144818012389],
              [69.381466704513599, 21.823314695906845],
              [69.371437730505562, 21.827172957373708],
              [69.362900907587104, 21.832939595742388],
              [69.338604113818619, 21.850158137298262],
              [69.335638052062592, 21.853506136927159],
              [69.31006372329675, 21.875199971551829],
              [69.288211331481008, 21.891166921348869],
              [69.273215481437433, 21.902130596956276],
              [69.239641832913719, 21.935223858834203],
              [69.229412012369011, 21.949508765257086],
              [69.227117419121981, 21.952223527826433],
              [69.222217835576302, 21.958426203678712],
              [69.211381144266653, 21.96748485578237],
              [69.188414963447073, 21.98830972366807],
              [69.180773123451644, 21.996330347875592],
              [69.156563194031591, 22.021734724131367],
              [69.148936633044499, 22.034384493491977],
              [69.144751816010654, 22.037912454477237],
              [69.137340691971502, 22.045008308053607],
              [69.134596485034479, 22.047896341323874],
              [69.106321472284321, 22.079701028118865],
              [69.101622688789391, 22.08298768378128],
              [69.090683096758283, 22.097018529615418],
              [69.083881218142722, 22.102976690295858],
              [69.069173312719769, 22.115830743651856],
              [69.047365947088409, 22.137779185646764],
              [69.037059614106127, 22.153863369974108],
              [69.01725689398873, 22.172675816920307],
              [69.015718383797676, 22.176481989063252],
              [69.004991287574001, 22.187984404938796],
              [69.003244478422317, 22.191164677341558],
              [68.997654320789877, 22.198724456903566],
              [68.994621367427868, 22.2021104981641],
              [68.989299667290226, 22.20866462880457],
              [68.982925982413192, 22.218649717540355],
              [68.989115298291807, 22.216745762786498],
              [68.999204850866334, 22.209617790859895],
              [69.000056058221077, 22.2155159573045],
              [68.995565702622287, 22.220179559396353],
              [68.997429186746459, 22.223823499542583],
              [68.996314691727548, 22.230576319817899],
              [68.994548679999582, 22.233479895754328],
              [68.989116443928353, 22.237232420313148],
              [68.986279599909409, 22.233065241226871],
              [68.987448407522933, 22.226127584246555],
              [68.98008694125491, 22.229151709306517],
              [68.977845805554011, 22.233401021660146],
              [68.961941339377205, 22.238275835351036],
              [68.956833383514095, 22.242903653083044],
              [68.954464007618697, 22.246256325425183],
              [68.95449920205435, 22.25009190516813],
              [68.958169481334735, 22.253335505928487],
              [68.967364404108821, 22.255331724676648],
              [68.965550758340342, 22.260278983517136],
              [68.966443494797559, 22.26323855867],
              [68.974147824878813, 22.262542107372067],
              [68.977459218819519, 22.265363567392829],
              [68.968939109327962, 22.272612341460786],
              [68.965485396766908, 22.273828229678589],
              [68.961825396834655, 22.272217689155489],
              [68.958668903089745, 22.270178996105514],
              [68.955910236741204, 22.267987372126328],
              [68.949311420490858, 22.269876511600792],
              [68.944814483761334, 22.275687314449865],
              [68.94048318840106, 22.290298747509841],
              [68.938660899174522, 22.306176760974957],
              [68.941641222673113, 22.329638640229966],
              [68.954349232986942, 22.330216840513437],
              [68.955611821813847, 22.336419328162439],
              [68.957413241125479, 22.344862073258749],
              [68.95866583344889, 22.348285105528362],
              [68.963583420461333, 22.345674476921104],
              [68.967185997652464, 22.346641881754881],
              [68.967527362552161, 22.353217828580345],
              [68.959479342146082, 22.355766425380377],
              [68.960297071621284, 22.363063187054006],
              [68.963075652073215, 22.373016516993918],
              [68.972047835064416, 22.391409825343292],
              [68.98568953529886, 22.40851493989647],
              [68.99337288539158, 22.421989849313945],
              [69.00522516588461, 22.435568519650847],
              [69.009759306478344, 22.439078986411047],
              [69.015724367474775, 22.443676176616144],
              [69.038960523142606, 22.458143806473721],
              [69.047037659159813, 22.461080680105749],
              [69.052913024118212, 22.463192857027533],
              [69.05871087941064, 22.467625908815933],
              [69.063904708974633, 22.471537780357185],
              [69.070888965768177, 22.479231728831703],
              [69.077037659984626, 22.481301530793846],
              [69.100331799586144, 22.678872267257915],
              [69.123162976063369, 22.877202320115011],
              [69.123790048428248, 22.881280300460237],
              [69.124749712337788, 22.884834011563466],
              [69.122428503578405, 22.887912652860219],
              [69.116992561395847, 22.891873332204014],
              [69.10962760714547, 22.89244267907582],
              [69.104430426869385, 22.893489616776652],
              [69.083547163916094, 22.905026093926537],
              [69.080328270476429, 22.907234815234897],
              [69.078739153147609, 22.912853555743251],
              [69.073225245715165, 22.919062596654499],
              [69.069347339182158, 22.918641897946031],
              [69.066977657641445, 22.915080764066275],
              [69.059644068908256, 22.917462988109587],
              [69.042893995948219, 22.927671026663166],
              [69.02760965419516, 22.936957829496244],
              [68.988883800930495, 22.952197079620515],
              [68.969352284933834, 22.963375511369879],
              [68.937459784255267, 22.981670512213309],
              [68.933760961375683, 22.984073367924847],
              [68.918689848437978, 22.994786235857692],
              [68.912574447319017, 22.998746772833243],
              [68.902228324700602, 23.005514273065319],
              [68.894826303013318, 23.01038974211356],
              [68.885583053995703, 23.014537032323119],
              [68.881401383212506, 23.016332903333939],
              [68.877468534087797, 23.01808775391715],
              [68.870271923445159, 23.022575307393321],
              [68.850617410063279, 23.033873143413036],
              [68.834856487373884, 23.03987846072193],
              [68.829106637489076, 23.043911711702801],
              [68.822144626419345, 23.048739035246378],
              [68.81583382575127, 23.053250366008573],
              [68.802967841242037, 23.062260373487828],
              [68.796654949496229, 23.066766227107241],
              [68.79185283953538, 23.067990302955856],
              [68.77552566615158, 23.072278267708167],
              [68.767113892048471, 23.074750322876174],
              [68.761565819432164, 23.077279717885464],
              [68.755967474130557, 23.081802442939818],
              [68.751112518988194, 23.085011676833489],
              [68.744763657782059, 23.090844452121914],
              [68.736215135346697, 23.098616960435749],
              [68.729390405306248, 23.104652778603736],
              [68.718120392226325, 23.111936881446979],
              [68.696169015477224, 23.124679069520568],
              [68.684665439858676, 23.130301006689525],
              [68.674683585184681, 23.136508919302571],
              [68.672016457162897, 23.138929712201584],
              [68.666580350942695, 23.141976965840346],
              [68.646540517063556, 23.157093830481166],
              [68.639606684538919, 23.162335062699118],
              [68.635521997008354, 23.165800839829156],
              [68.633504180864392, 23.171772535404649],
              [68.64300916590966, 23.165968976260242],
              [68.652143053093837, 23.157220777751164],
              [68.65640767385365, 23.157315579596844],
              [68.652579673602943, 23.163431379636435],
              [68.648290462501251, 23.170063922231552],
              [68.644342961608061, 23.172670151029479],
              [68.643239373946543, 23.177806524040861],
              [68.648766241748802, 23.179499419565314],
              [68.650374202358677, 23.182899116198168],
              [68.646934816205587, 23.184842434063011],
              [68.642364560563266, 23.1833931523642],
              [68.637800368701235, 23.181946570755606],
              [68.627074593565553, 23.184395599290784],
              [68.621658235152395, 23.187639837777983],
              [68.614733110001396, 23.192867079720482],
              [68.609298523865277, 23.196784627095258],
              [68.606005041483627, 23.20209331093298],
              [68.602765103872429, 23.205383095066178],
              [68.596577628601395, 23.210179783801394],
              [68.592861815525197, 23.21323316674361],
              [68.587888056709829, 23.218057998598898],
              [68.583865548170067, 23.223348263958254],
              [68.582007695489935, 23.22936841369647],
              [68.580930987133655, 23.233380715770497],
              [68.580600010739829, 23.236739601999929],
              [68.584580184078973, 23.240479011733967],
              [68.588793868311569, 23.24148217448904],
              [68.597345558826532, 23.238959313910314],
              [68.602631520075533, 23.236363296739249],
              [68.608399500728822, 23.240421465770005],
              [68.611072281737066, 23.244105060430314],
              [68.616213758970972, 23.247090142045352],
              [68.620881625750215, 23.249457504455215],
              [68.625059711763129, 23.251818624220039],
              [68.62873939096562, 23.254621435314874],
              [68.62427639401551, 23.256784317880232],
              [68.623330208923676, 23.261744936817429],
              [68.622312404947095, 23.269421236716941],
              [68.620095411342973, 23.272993466940711],
              [68.617985227575815, 23.280092618389737],
              [68.618125373692877, 23.28432322752052],
              [68.619827057318673, 23.287183389121942],
              [68.622291250275325, 23.290055100276511],
              [68.625531423788871, 23.292243399061373],
              [68.63030165058872, 23.294466693566363],
              [68.632779446344827, 23.296638673142187],
              [68.634463425372346, 23.300197802597392],
              [68.628136474092557, 23.299350263026184],
              [68.62311894748612, 23.297125974586603],
              [68.617372468631601, 23.293468271056902],
              [68.612449094198823, 23.287720447589166],
              [68.611308018646724, 23.282758772927224],
              [68.612926344916247, 23.279272687424253],
              [68.611941676014524, 23.272807681875751],
              [68.611374315160589, 23.269626385093947],
              [68.610328919444811, 23.265977459103262],
              [68.607327998110065, 23.262285791316522],
              [68.603850003653022, 23.258131110708256],
              [68.60129941483639, 23.255808760897793],
              [68.597271290255293, 23.253906529627436],
              [68.590086682298534, 23.254193432930784],
              [68.586475578632474, 23.255015032337059],
              [68.581849212186626, 23.257176198903256],
              [68.577712048559079, 23.259343424824898],
              [68.56947373186911, 23.262327815566088],
              [68.563919945397657, 23.262651197939316],
              [68.555103216037367, 23.262901963369746],
              [68.560026287762753, 23.255766635679109],
              [68.562880782983783, 23.252663178733087],
              [68.565738479730157, 23.249557651515424],
              [68.565523797000949, 23.24547753300148],
              [68.562484936717865, 23.243141368530132],
              [68.555778008492993, 23.243894377228031],
              [68.551940670463324, 23.246977825316968],
              [68.545488103719308, 23.247181654475153],
              [68.541179899613425, 23.246848865733526],
              [68.540567010309687, 23.250828066815469],
              [68.542778263207438, 23.253461474775303],
              [68.544207180748231, 23.257020090925447],
              [68.54008602593278, 23.259273340290179],
              [68.53597230379772, 23.261055343380171],
              [68.536135363130242, 23.26435161230139],
              [68.537305600313275, 23.268134862300176],
              [68.534405714184359, 23.272064197351281],
              [68.532205095695176, 23.278354340298471],
              [68.534106339085383, 23.283097408250885],
              [68.538514841097779, 23.289075409883473],
              [68.54115302092103, 23.294774009506099],
              [68.542078728037751, 23.298082251633968],
              [68.548057060042012, 23.302452673549745],
              [68.551793186559181, 23.305121288162379],
              [68.554268837459503, 23.307528041310597],
              [68.557033531340409, 23.311248497436825],
              [68.561229089600531, 23.313136424449421],
              [68.570156408249375, 23.30530770115034],
              [68.573981802155316, 23.303734637754218],
              [68.573408180317301, 23.311832227731035],
              [68.569891218260963, 23.315150400264979],
              [68.573019808332077, 23.317036272616861],
              [68.578853775542498, 23.313427575840905],
              [68.582000361027113, 23.314625654998377],
              [68.580786920868434, 23.318179633436877],
              [68.580226564650104, 23.321472073335325],
              [68.610549299926674, 23.32060351935645],
              [68.614446425224401, 23.321612559303176],
              [68.620633270641477, 23.328065698020371],
              [68.614745522700915, 23.32903478109807],
              [68.609536369214752, 23.326698439690468],
              [68.604790245228116, 23.327016008483746],
              [68.600046305761865, 23.330742526903073],
              [68.597764355526678, 23.333399986537827],
              [68.587633048816599, 23.337023789678529],
              [68.582276736483507, 23.335753565889195],
              [68.578609436180514, 23.3363574616017],
              [68.566668702033141, 23.335187873256523],
              [68.559235435667517, 23.338185444312561],
              [68.559525730187275, 23.343976788001743],
              [68.560816034361764, 23.349539622134078],
              [68.562337265617757, 23.353594104570089],
              [68.564294833689146, 23.362384290506942],
              [68.571092404546818, 23.373768685992498],
              [68.566612392343075, 23.373137358106725],
              [68.563289655571381, 23.370145007735537],
              [68.55920446663724, 23.362267748977473],
              [68.55630208378075, 23.356620287102412],
              [68.550597336797054, 23.355364461001027],
              [68.545524091172069, 23.355568114769618],
              [68.537495741458784, 23.356643417551943],
              [68.529027651204089, 23.360165641477039],
              [68.524903696826769, 23.361079446078577],
              [68.521481564666956, 23.362652024420065],
              [68.517232238913905, 23.364505098190705],
              [68.515624359785946, 23.368782424220537],
              [68.506879408087897, 23.367866107955962],
              [68.500634271010824, 23.369097689555655],
              [68.490621517192281, 23.363143856930609],
              [68.49230474956218, 23.359749994041469],
              [68.491362208889683, 23.353953538269476],
              [68.489130792133381, 23.349312376391904],
              [68.485056196582178, 23.35112225024136],
              [68.485032420544584, 23.35467965004722],
              [68.485129690356999, 23.359112818088441],
              [68.487292665784665, 23.362085006521884],
              [68.482745288865445, 23.363739538070444],
              [68.480119869282973, 23.361635148626032],
              [68.474465118443433, 23.363084643107662],
              [68.458570378810833, 23.366911889999606],
              [68.459248246535694, 23.391190780387173],
              [68.453331517672311, 23.3930696533183],
              [68.444853934173494, 23.398538906734615],
              [68.442543156366526, 23.40208698613899],
              [68.442216922785917, 23.4066259971199],
              [68.442847498783067, 23.412494604852746],
              [68.443752724564362, 23.415683832439161],
              [68.446662472358838, 23.420941225249262],
              [68.448644953478222, 23.423544007381977],
              [68.450172966316217, 23.426448618544011],
              [68.452583376332385, 23.430648344373338],
              [68.450775438071062, 23.435617532014454],
              [68.447603213198079, 23.434393791911624],
              [68.445848165200374, 23.428728102440736],
              [68.437887285031579, 23.420113361510595],
              [68.43337727163015, 23.415205802239441],
              [68.426903971982867, 23.4147073234301],
              [68.42618879059178, 23.410993671398479],
              [68.41944315235925, 23.406057392157276],
              [68.414370139190183, 23.407931508469314],
              [68.408039911227092, 23.411198965905985],
              [68.399743357883622, 23.419813985604268],
              [68.399728061462625, 23.423853460387445],
              [68.399781300800171, 23.429939141392676],
              [68.399969241472164, 23.438139391646281],
              [68.404389342339542, 23.443571947363203],
              [68.409025068565896, 23.441388362829354],
              [68.411812776799678, 23.446529206764666],
              [68.412462852687739, 23.452559392758403],
              [68.413099869251283, 23.458176692630584],
              [68.41582817061834, 23.46104307012849],
              [68.421772011038399, 23.462745928092762],
              [68.426860322571116, 23.463030752579979],
              [68.431508624952443, 23.463967774466663],
              [68.436561691265481, 23.467302240080045],
              [68.442694927741726, 23.471123579503558],
              [68.438499109189209, 23.475861513791003],
              [68.433115036859618, 23.474015047654667],
              [68.423095363787525, 23.467829911755945],
              [68.417697057338287, 23.46792903928575],
              [68.41826642231355, 23.472418457938595],
              [68.425562158038716, 23.47998713696612],
              [68.431923764633993, 23.484546263025933],
              [68.436251949792364, 23.487129135209958],
              [68.439823141257861, 23.491027619411561],
              [68.445568462656468, 23.496794085085984],
              [68.450914385666692, 23.499268138313454],
              [68.456794005135379, 23.500813385130275],
              [68.461671129332828, 23.50186683982183],
              [68.465020818395075, 23.503041140520565],
              [68.468192411824703, 23.504678313717314],
              [68.471507559640315, 23.507102989275786],
              [68.47533314872426, 23.509540524702853],
              [68.478140329604273, 23.511949998735318],
              [68.481273265036307, 23.514994301082769],
              [68.478655473368534, 23.517743282214191],
              [68.473773146263127, 23.516847250205341],
              [68.47025469254946, 23.515669754678076],
              [68.466742151354282, 23.514178140921118],
              [68.462929314792177, 23.511276623592643],
              [68.459067733792565, 23.510246449073044],
              [68.45460247988639, 23.512476928302906],
              [68.452128251997024, 23.516329974946597],
              [68.449302094548671, 23.520482440458704],
              [68.447505277311436, 23.524187530923946],
              [68.447920709914513, 23.527481120389542],
              [68.449666672195562, 23.53158694155465],
              [68.452088504392208, 23.53586385859489],
              [68.447877080043938, 23.535137724758268],
              [68.443525307364936, 23.533314205856914],
              [68.439610052909032, 23.5341569325793],
              [68.438496990848023, 23.537568933577049],
              [68.435142756114388, 23.536550985770745],
              [68.434736172250467, 23.532948184932945],
              [68.436025809255682, 23.529228112589557],
              [68.438876064561285, 23.524138919762851],
              [68.441013143718791, 23.520438753484033],
              [68.442107574484595, 23.511559578007631],
              [68.441705383331936, 23.507799917244892],
              [68.439981678969261, 23.502911844090978],
              [68.435386991337694, 23.497802764938626],
              [68.430928868955633, 23.493943124431759],
              [68.428106276324954, 23.492003145536057],
              [68.423256109169444, 23.49000958031608],
              [68.420084253032769, 23.488526339485009],
              [68.416082953785065, 23.486397734092392],
              [68.410357305246791, 23.485479819290294],
              [68.405687424764025, 23.486349058398957],
              [68.326332897784738, 23.495820302328198],
              [68.310100339628477, 23.578373933888329],
              [68.30442019810188, 23.580276196279399],
              [68.300074118623584, 23.582531830031115],
              [68.301398808209072, 23.589130135242961],
              [68.299272935061538, 23.592887644593507],
              [68.289942953734936, 23.587697493675847],
              [68.274745326524936, 23.594178296128597],
              [68.271078225136193, 23.594454068555404],
              [68.269067010117681, 23.588390327607119],
              [68.26591013985086, 23.585739420302247],
              [68.251811532427979, 23.587840906020087],
              [68.244746190277169, 23.590256873644361],
              [68.2409935323833, 23.590091614798933],
              [68.234627173145213, 23.592410630798842],
              [68.23087312714631, 23.594794254327137],
              [68.215306995836556, 23.590999753096952],
              [68.186489161276427, 23.5917331690925],
              [68.178876098732985, 23.592456388923249],
              [68.174567960773231, 23.593377305272917],
              [68.157046655957899, 23.597447685448877],
              [68.14606838016924, 23.59996420592956],
              [68.141855140847611, 23.601001602352603],
              [68.137482827308204, 23.603183456327859],
              [68.132828620476076, 23.606412992855415],
              [68.128507720513994, 23.608527581003891],
              [68.125158513512389, 23.611401424743029],
              [68.119253873890642, 23.615631864227016],
              [68.115948266331145, 23.620318653723615],
              [68.112667881254367, 23.624984556251938],
              [68.111582897525594, 23.627893237645427],
              [68.109463812730311, 23.631212029680491],
              [68.106057636714965, 23.634290882898451],
              [68.116889957823986, 23.64152648822585],
              [68.123099444480204, 23.645247406284426],
              [68.128996230366681, 23.648532421270914],
              [68.138395000642632, 23.652737107596462],
              [68.147803952967578, 23.656939772235077],
              [68.155782728488731, 23.661104491313111],
              [68.165063746555418, 23.669254910310823],
              [68.172964144581869, 23.676055701537013],
              [68.177923203810778, 23.68541176917455],
              [68.180022159148976, 23.694702797506274],
              [68.179267705848133, 23.703913373091613],
              [68.177570345881918, 23.712659118611803],
              [68.176421979931561, 23.719229144598359],
              [68.175627661672337, 23.729754740927596],
              [68.176862457628999, 23.735939235273705],
              [68.180441878204874, 23.743948509190666],
              [68.183605345796806, 23.749745433528432],
              [68.19079603104943, 23.757991102452362],
              [68.195959319610679, 23.766293555395205],
              [68.19956261009871, 23.777270036294478],
              [68.201657580368163, 23.789569727889173],
              [68.200786920119526, 23.801802539523262],
              [68.199968063369624, 23.812665918372556],
              [68.199079469557816, 23.825799304007997],
              [68.199741895697045, 23.836248312813463],
              [68.201837213674807, 23.848547892417471],
              [68.205277478525602, 23.864968596413792],
              [68.208924632371208, 23.87458357097308],
              [68.212737011838172, 23.878767827601258],
              [68.218541199115222, 23.882548744341168],
              [68.231692640033671, 23.887422110867991],
              [68.242817437359889, 23.894505955770107],
              [68.255453422955128, 23.900274459400215],
              [68.261366180928817, 23.900322856985785],
              [68.267986162322615, 23.896347176658615],
              [68.273572112521109, 23.893497385669139],
              [68.279110237740966, 23.892255404730264],
              [68.28332542705391, 23.893512962236823],
              [68.28448853842724, 23.896531993377494],
              [68.282905953403983, 23.899255921004738],
              [68.27935879193754, 23.900778669098351],
              [68.274508295848321, 23.904111136318782],
              [68.269653675767273, 23.90743847430263],
              [68.264824466733316, 23.910080943639215],
              [68.263956519565369, 23.91397005215623],
              [68.264272681763003, 23.920193226294359],
              [68.266890314015967, 23.924636225683791],
              [68.273140062491223, 23.933081138897084],
              [68.27722563973137, 23.93871288037397],
              [68.282849724975378, 23.942997529412576],
              [68.287810278974177, 23.944504445920039],
              [68.291371436841771, 23.942522349434949],
              [68.293534844767251, 23.937051502848369],
              [68.294160293117073, 23.9329208031292],
              [68.297073648877756, 23.927470928602055],
              [68.302213370201514, 23.92276652192761],
              [68.308792630574743, 23.920168697878474],
              [68.318292019602083, 23.920406618635525],
              [68.321730377304419, 23.922564944273866],
              [68.321339582466393, 23.927387484596021],
              [68.321694030161467, 23.932230471796412],
              [68.325152980801448, 23.933698911584678],
              [68.331670909249127, 23.933171764954881],
              [68.34054311391165, 23.929248723559347],
              [68.347040650851454, 23.929410732323515],
              [68.35043917136089, 23.932945684282831],
              [68.352295935535523, 23.937830154345104],
              [68.344301262012678, 23.937631780011582],
              [68.337260739439543, 23.938839063582659],
              [68.335327508173577, 23.945006363631187],
              [68.337935208027474, 23.949902661684774],
              [68.339832904085341, 23.953405423849642],
              [68.340401745020188, 23.956687621046886],
              [68.339418872546432, 23.967175124645106],
              [68.338946443255892, 23.970514606524894],
              [68.342039913946252, 23.97396687547965],
              [68.348619511061656, 23.976860720234814],
              [68.358646504301262, 23.977110493640936],
              [68.360569253698515, 23.967701485699106],
              [68.361310223356028, 23.954335816048072],
              [68.363833989009805, 23.943127683595584],
              [68.369304958218578, 23.941219446322922],
              [68.374415447766651, 23.942241864009677],
              [68.377738643065797, 23.946386967349849],
              [68.374851658962911, 23.952099506338378],
              [68.372162925474811, 23.959585266132283],
              [68.372384075666886, 23.965697466333442],
              [68.377322663842435, 23.969216294719455],
              [68.383402458119832, 23.967003222898214],
              [68.38655639674792, 23.96584083975938],
              [68.391411709244949, 23.967085039190863],
              [68.395634972482583, 23.965191939741484],
              [68.407396454052048, 23.965847385201013],
              [68.430670034839906, 23.967172719925045],
              [68.455243786938212, 23.967538825307141],
              [68.460131279284369, 23.967701210327107],
              [68.548122230937679, 23.967275331266261],
              [68.63062046608259, 23.967794192683726],
              [68.634696817018281, 23.967498475524188],
              [68.63850862982865, 23.967746116293299],
              [68.643178484469999, 23.967624614483469],
              [68.651285782707617, 23.967786971515586],
              [68.654708684822282, 23.967657986755398],
              [68.666984799767462, 23.96777867321752],
              [68.713184179989838, 23.967675371358776],
              [68.748316966384479, 23.967979829091679],
              [68.752500181883363, 23.967385026995135],
              [68.754202971729001, 23.986179856478575],
              [68.759280948903736, 24.080842471159663],
              [68.758863631554362, 24.084367410629898],
              [68.759869563562617, 24.089786769725809],
              [68.760696412997461, 24.104888660684896],
              [68.761522115457723, 24.120015829979412],
              [68.761906134363372, 24.127256638620104],
              [68.762848908746832, 24.135105337544079],
              [68.765630640337108, 24.195505671813081],
              [68.768637010239544, 24.255910558347892],
              [68.769546540644114, 24.2726212976598],
              [68.769098964208141, 24.284803004841027],
              [68.761667463336693, 24.290515429925907],
              [68.763040577806649, 24.294379901900356],
              [68.770571987415352, 24.298174790582166],
              [68.775956753345625, 24.299881114825144],
              [68.794223116376088, 24.307495370468793],
              [68.805768724377259, 24.312845708542095],
              [68.817164916784648, 24.311513923327471],
              [68.822439185682256, 24.315578985573037],
              [68.827486133809089, 24.316838151148268],
              [68.842094964754068, 24.281315636171154],
              [68.842888452547442, 24.277728235699719],
              [68.842009455976623, 24.257527705506789],
              [68.850978706110624, 24.221076393267364],
              [68.852712934989739, 24.216843673468972],
              [68.858717601261318, 24.213781979782883],
              [68.86628557277669, 24.212155859128099],
              [68.871340092418919, 24.212011100065677],
              [68.875434523753938, 24.213247503991198],
              [68.878343119507718, 24.214895515026114],
              [68.884507788928147, 24.225175957191258],
              [68.893398027623192, 24.257122343997967],
              [68.894743380736642, 24.261262747089308],
              [68.89889643109899, 24.269111289319635],
              [68.902684053468604, 24.274611745710853],
              [68.9143921108992, 24.284483137246639],
              [68.933600966801606, 24.295635750693794],
              [68.943121358636461, 24.302129835907781],
              [68.957000888227498, 24.288415303359717],
              [68.968999616704551, 24.271721544572582],
              [68.972860090928904, 24.260323443036395],
              [68.982030843589385, 24.233396208926074],
              [68.989525203635409, 24.227651770780884],
              [69.005138896650152, 24.22319932252212],
              [69.022113200364942, 24.229541658085861],
              [69.029004389387708, 24.234092414965914],
              [69.034798533182865, 24.241606305342078],
              [69.039941602057837, 24.245065309577882],
              [69.072938799269593, 24.262384537447684],
              [69.091961567650827, 24.272344948905296],
              [69.097995541572246, 24.272122463436045],
              [69.129697614996516, 24.260149847751148],
              [69.134692947722982, 24.258319948118107],
              [69.139951383991416, 24.257022864099213],
              [69.192717476632964, 24.237945795900956],
              [69.250477811996205, 24.259292137386026],
              [69.308581032031498, 24.2807151303982],
              [69.332591996522908, 24.276386276484232],
              [69.35175623705328, 24.273986161471019],
              [69.36473806485904, 24.271721427497553],
              [69.375022469745403, 24.270416911748587],
              [69.401322228257072, 24.272273269070734],
              [69.437313967970837, 24.279514412059484],
              [69.443006542729336, 24.280029322721479],
              [69.449682015117119, 24.279022792869021],
              [69.467350916156605, 24.270287291947621],
              [69.481175756292899, 24.268257489109995],
              [69.511543259734054, 24.271695854029684],
              [69.535423342926862, 24.277126817684707],
              [69.539844485731592, 24.277433053228677],
              [69.563350270643411, 24.282796713844938],
              [69.587819889577347, 24.291342991026607],
              [69.594973551219908, 24.290130872213805],
              [69.604190088222595, 24.281237003636488],
              [69.714978736754475, 24.184114354052557],
              [69.730044190155482, 24.171853795851515],
              [69.772116932998372, 24.171386397978996],
              [69.811660219472955, 24.172002619941928],
              [69.878491617323817, 24.170733348904182],
              [69.952922371250565, 24.171225113567907],
              [69.980144277038505, 24.170951010087354],
              [69.997853553237846, 24.170077361013952],
              [70.016425908973915, 24.169925376783652],
              [70.025019986544464, 24.171609325836123],
              [70.038408355985595, 24.178158663763035],
              [70.042249652865721, 24.181725465788734],
              [70.051508858199895, 24.190192333963989],
              [70.063775795269009, 24.196725673684075],
              [70.06770860993413, 24.202385147579463],
              [70.072740309540777, 24.217408526738019],
              [70.076283778830117, 24.22402622273599],
              [70.088619001102501, 24.246797350878506],
              [70.095794051902033, 24.267225842007669],
              [70.100232049040144, 24.275899036421588],
              [70.101889367721654, 24.278633675681256],
              [70.104053667296412, 24.282498085989833],
              [70.108053206458735, 24.293625124136298],
              [70.110928003009889, 24.295340459664914],
              [70.120294682104543, 24.297854435604897],
              [70.139905548659002, 24.301171860356817],
              [70.1499750843399, 24.30199406663084],
              [70.171626599518206, 24.306160347926163],
              [70.18321503012379, 24.309068042868077],
              [70.187497518122953, 24.310455961137038],
              [70.201089070168422, 24.314951099592822],
              [70.219769991900478, 24.322219924109209],
              [70.245957816524864, 24.324572852620005],
              [70.258691063176457, 24.331533312912264],
              [70.268987163923256, 24.334143561836342],
              [70.303994025813068, 24.348128279726922],
              [70.331452718881195, 24.351285996001636],
              [70.35269232701863, 24.353675745612904],
              [70.366001334129095, 24.354063967216824],
              [70.37238889320281, 24.353702674274857],
              [70.377531098627742, 24.356473728016773],
              [70.385021044733648, 24.359616331454227],
              [70.393124274958836, 24.363708084444902],
              [70.401898770656828, 24.369367672694981],
              [70.408656345853188, 24.373102735077939],
              [70.418885388620126, 24.377794701588162],
              [70.425164199650723, 24.380153142268671],
              [70.429959338677662, 24.381581805603787],
              [70.441728166677763, 24.383085184100398],
              [70.448848571574274, 24.38453817382738],
              [70.457121808266052, 24.386460938878489],
              [70.462920986550046, 24.387442019270601],
              [70.46920127703936, 24.389796362510229],
              [70.474483741521794, 24.392142498799402],
              [70.48222704172268, 24.394513719968913],
              [70.499414663328309, 24.399253020385121],
              [70.508962771648299, 24.401843474917484],
              [70.52170622698236, 24.404958638464951],
              [70.534450079908112, 24.40806810848532],
              [70.542350652723471, 24.409641819339754],
              [70.548614837659002, 24.41268440673198],
              [70.554878895599174, 24.415724395602378],
              [70.561140538915382, 24.418766234812228],
              [70.567423862441615, 24.420317405205044],
              [70.573530745406231, 24.421705053730925],
              [70.581135915629588, 24.417984213565159],
              [70.58801513717593, 24.41507747415562],
              [70.594905676634312, 24.411185101326932],
              [70.599609234317057, 24.409247945880935],
              [70.598773183131243, 24.40378608933182],
              [70.596489488594017, 24.399299884640502],
              [70.594214859137338, 24.393823491284572],
              [70.591943131458137, 24.388344948453852],
              [70.587364513242747, 24.379867904170546],
              [70.584541236203691, 24.375375958123005],
              [70.581726529886538, 24.369893753880806],
              [70.579972039941566, 24.366405038724182],
              [70.574280912164625, 24.360893367179678],
              [70.564670210442685, 24.356262732495658],
              [70.559862863455464, 24.352393778501071],
              [70.560607060586591, 24.348578274910757],
              [70.564585786231987, 24.335243241695242],
              [70.567452030408745, 24.327631713487776],
              [70.569248261969079, 24.322871382479608],
              [70.573119481973606, 24.318138562676818],
              [70.573879683409672, 24.312409495916732],
              [70.574635086658574, 24.307643192889476],
              [70.57745326253476, 24.303850421657341],
              [70.577225590528229, 24.294294579702285],
              [70.580101770214753, 24.28572740851715],
              [70.58192499808051, 24.278098062842172],
              [70.581651157851439, 24.272365875751451],
              [70.57824304245564, 24.267550498129197],
              [70.576892448590868, 24.264673675174052],
              [70.575542947408067, 24.261792296156461],
              [70.574239605184005, 24.255087192793056],
              [70.576005103803013, 24.252243858091106],
              [70.581943023306806, 24.24848250521104],
              [70.593063738963195, 24.245730203918296],
              [70.596885710339933, 24.244813457165716],
              [70.602662836789179, 24.24227507472067],
              [70.610800337449419, 24.238948714583429],
              [70.644649442578753, 24.224610700251908],
              [70.669525299992415, 24.220330759835118],
              [70.688726342010767, 24.220286673503761],
              [70.71113979934016, 24.216894697723173],
              [70.721993614604472, 24.216538781787566],
              [70.727620072157222, 24.21863621009361],
              [70.734477042242077, 24.220285730615721],
              [70.741409352010351, 24.2196610080351],
              [70.749052502719763, 24.219330639198137],
              [70.759162370329449, 24.219425574059635],
              [70.767528980672324, 24.220299745627646],
              [70.78282944855971, 24.221230576149576],
              [70.796378293154149, 24.223743148660073],
              [70.81425847971046, 24.226293413095355],
              [70.833875113510331, 24.22885716086358],
              [70.839621812532073, 24.232090646425046],
              [70.845346950498893, 24.236922695753467],
              [70.848196481500636, 24.240928807794415],
              [70.854835287499014, 24.244545210437281],
              [70.860000522659647, 24.245601770196526],
              [70.863584594962774, 24.244735146038241],
              [70.867364931237049, 24.244307601813833],
              [70.878946190289213, 24.246427262694553],
              [70.897049411802385, 24.256756682899418],
              [70.904624808719674, 24.259531029252255],
              [70.907202836789196, 24.263315313622176],
              [70.899800060815721, 24.265107457207051],
              [70.895415350788596, 24.26692381743441],
              [70.891036973993948, 24.268738210237345],
              [70.883617932970978, 24.2714567596216],
              [70.877859199544034, 24.275366874368473],
              [70.875923333397282, 24.278889006252157],
              [70.874162146886931, 24.282502303717969],
              [70.873061596543224, 24.287479793134509],
              [70.873529535210366, 24.29327306178671],
              [70.873965020503704, 24.297290446508534],
              [70.876622685085437, 24.300092633407999],
              [70.879279838981958, 24.302894727233092],
              [70.88194656196562, 24.304762210224226],
              [70.888638528604986, 24.307597814727718],
              [70.894331043674185, 24.309497111735695],
              [70.898784499700199, 24.312230233544874],
              [70.904377620472843, 24.315953151808081],
              [70.906553481300634, 24.31856748519985],
              [70.910255387993587, 24.321262056955167],
              [70.913911533080565, 24.323567583649154],
              [70.918106014905106, 24.329643551916796],
              [70.921985070862036, 24.33256303182268],
              [70.92699272889854, 24.335688531696597],
              [70.933669843571735, 24.340368233162764],
              [70.937337839735008, 24.343177375497255],
              [70.942015616178907, 24.345992208597625],
              [70.945675513723998, 24.349721890690489],
              [70.949003435523238, 24.352526999897186],
              [70.956725929724996, 24.353514628467249],
              [70.963432161064105, 24.354493445844216],
              [70.971128730938261, 24.358258641211648],
              [70.976801403100254, 24.362002779674434],
              [70.98148009601988, 24.364816354657396],
              [70.987851516069682, 24.366719050159084],
              [70.990554789901068, 24.364887887019858],
              [70.992257123922528, 24.36212130967273],
              [70.993965686493269, 24.359362090706682],
              [70.998703606315914, 24.35569317717562],
              [71.002423981227693, 24.352941822408088],
              [71.006126573969624, 24.352043296951418],
              [71.014867492867822, 24.351184400158804],
              [71.018562889650667, 24.351211000611904],
              [71.023205800816029, 24.351395329459475],
              [71.036753410489794, 24.353287193569557],
              [71.052332674940743, 24.360594214617219],
              [71.056078712351621, 24.361540178844077],
              [71.065130433913438, 24.374286635701147],
              [71.066825420576308, 24.378136356629312],
              [71.076669752618585, 24.386223466654137],
              [71.083227610753511, 24.389349798023471],
              [71.111407632093247, 24.396416557788552],
              [71.114969724174998, 24.398622446383392],
              [71.121783330584492, 24.407468106841044],
              [71.123729161080661, 24.414604167397439],
              [71.124140829892966, 24.419477356277266],
              [71.114187943073546, 24.433422107612909],
              [71.10897634070453, 24.43678843982924],
              [71.084414197678512, 24.438533646255809],
              [71.030844674231915, 24.436686861032079],
              [71.026536480000928, 24.436815525154646],
              [71.012899067482309, 24.441192885303547],
              [71.00707023062462, 24.443308822125825],
              [70.999959072149025, 24.445942307101291],
              [70.997232013392704, 24.448402369753154],
              [70.996689302453589, 24.453039268356953],
              [70.997237444409649, 24.472822922947202],
              [71.001472330418935, 24.49769155196989],
              [71.004059793267942, 24.508140143274119],
              [71.005251021223557, 24.528964531616172],
              [70.999658069391103, 24.535054869763261],
              [70.988165139967862, 24.547603241121362],
              [70.993375895184741, 24.572730719054814],
              [70.993468577376959, 24.576360089100824],
              [70.99116784496222, 24.581305081672145],
              [70.988646507837245, 24.591027611514619],
              [70.990621255808691, 24.605514392058573],
              [71.000328625070679, 24.621854115238008],
              [71.005426904980212, 24.626603192229915],
              [71.01070360718542, 24.636751429232717],
              [71.024734699658069, 24.641267142373103],
              [71.03641641704705, 24.644963011428736],
              [71.05117575144051, 24.652536454744123],
              [71.063453234415235, 24.660093580625823],
              [71.075483584291149, 24.667438126244303],
              [71.082806149756365, 24.673738929804042],
              [71.097775380632768, 24.686595440731995],
              [71.09102562217565, 24.689319383816489],
              [71.077126085716202, 24.703866825610071],
              [71.063453565160202, 24.718092214896036],
              [71.053406324535757, 24.745083099102558],
              [71.051598720928169, 24.748343811297293],
              [71.044463910335892, 24.76170726424435],
              [71.040944295875249, 24.766852357026625],
              [71.026015364153167, 24.805074771922623],
              [71.01430989435849, 24.82753784210222],
              [71.003171586703701, 24.842294859023376],
              [71.000316661159943, 24.848089148784801],
              [70.994760575199621, 24.859358419624801],
              [70.980321278957462, 24.879005894934117],
              [70.97607224187098, 24.883748927188257],
              [70.969410115898484, 24.896311976025512],
              [70.95266388261534, 24.914914779721702],
              [70.947005226613754, 24.921107558476223],
              [70.936264174055367, 24.94130504170078],
              [70.923428096505603, 24.980319680873158],
              [70.916461587428117, 25.001597169634625],
              [70.905621088214914, 25.048510511674834],
              [70.904699025207606, 25.052491282422675],
              [70.903009093441455, 25.064887218729019],
              [70.89644805292582, 25.102078225128501],
              [70.89125034662662, 25.126775689434062],
              [70.885474779273338, 25.151188859202424],
              [70.875735638764397, 25.160763273635105],
              [70.865942634246323, 25.170450990373158],
              [70.851937975923391, 25.18304094541806],
              [70.847113108131168, 25.189514593185329],
              [70.800467963230972, 25.231311065289798],
              [70.787295660435944, 25.247395809131294],
              [70.78463155346023, 25.249695828891497],
              [70.757529811133011, 25.272711034555481],
              [70.750133191493148, 25.282769496126733],
              [70.744675943277628, 25.304149178648895],
              [70.73541968744405, 25.32886715550076],
              [70.723427932970196, 25.342733605256775],
              [70.714324829614227, 25.353178591964728],
              [70.697055162475749, 25.368200257595102],
              [70.693091833444541, 25.37222539966481],
              [70.678178602328714, 25.386500811621676],
              [70.669837119659832, 25.393603269664361],
              [70.666824530894274, 25.395344984426764],
              [70.664806490099565, 25.403233258832028],
              [70.667419418813097, 25.409355193215401],
              [70.67019965886054, 25.420025518608423],
              [70.670969228106316, 25.42478888030033],
              [70.6708917456493, 25.455749205011639],
              [70.674317927758509, 25.481828949381118],
              [70.676442868762024, 25.497836149356534],
              [70.676712104226013, 25.51172693428537],
              [70.677485501789391, 25.518992502760163],
              [70.679407097416686, 25.525677110669029],
              [70.667727773459532, 25.532265585403334],
              [70.668071725105207, 25.539455877025578],
              [70.668499398385691, 25.54357061681425],
              [70.66899976546425, 25.597146068971586],
              [70.671138086965243, 25.62248299324542],
              [70.671646419684606, 25.628265296314613],
              [70.672784361847903, 25.654904238620315],
              [70.673029807105294, 25.660623352086009],
              [70.673067998853398, 25.669254057195214],
              [70.668111762099088, 25.688822996783575],
              [70.664887890377301, 25.694556361887159],
              [70.657936137001002, 25.705829103599186],
              [70.652771042371953, 25.709740026145337],
              [70.647400759848608, 25.712433247969518],
              [70.640814918986649, 25.714582632618818],
              [70.635899354289961, 25.715279910421515],
              [70.630348825546719, 25.715489666780879],
              [70.622751815464298, 25.715482283403354],
              [70.608900218757199, 25.715442604519456],
              [70.593517534343292, 25.712140791676582],
              [70.566393616802799, 25.699580009819751],
              [70.557437549779593, 25.695415903319478],
              [70.52858280475796, 25.686171153974119],
              [70.524269059837437, 25.685365102028626],
              [70.481658676353632, 25.685335473282386],
              [70.461638248066691, 25.683824794471661],
              [70.451021864835141, 25.682977184979695],
              [70.416466610160811, 25.6792329605376],
              [70.399851035088787, 25.676006147280429],
              [70.390688007763089, 25.673573161058343],
              [70.38543969460261, 25.673939821848919],
              [70.366179067235933, 25.678348789218422],
              [70.356613804004652, 25.681643472028473],
              [70.276013522743867, 25.709274949192508],
              [70.270363503711806, 25.711648335778658],
              [70.266693570432565, 25.713806495662759],
              [70.263077993691084, 25.719154603491116],
              [70.251600942791711, 25.752830074823262],
              [70.235344059507099, 25.77689185184953],
              [70.214621853303726, 25.798643965222769],
              [70.194042162904637, 25.816101184734507],
              [70.168736452175139, 25.830506495622586],
              [70.156185044116469, 25.855318371182751],
              [70.152321649210663, 25.859991830209729],
              [70.145569199212972, 25.869909159347841],
              [70.143207600319357, 25.874313755395345],
              [70.14090289234565, 25.877388314792857],
              [70.133748278254032, 25.884935898925981],
              [70.124368752703987, 25.90168123140251],
              [70.114407139540148, 25.91508952599974],
              [70.099224375831383, 25.935482538310538],
              [70.097178708921206, 25.947646411844353],
              [70.091783433417248, 25.993100118527416],
              [70.090716105579844, 26.008747913905573],
              [70.089955510180829, 26.020134674841593],
              [70.085764793603971, 26.06166415639715],
              [70.086366215213033, 26.087874636491328],
              [70.092900936535344, 26.098030017589476],
              [70.095098866018276, 26.100619445601946],
              [70.105872389699726, 26.11414032695685],
              [70.108213307936168, 26.117146658777358],
              [70.109997797123896, 26.120048131178432],
              [70.118122074290696, 26.128721436870457],
              [70.125695146544928, 26.140248835953678],
              [70.13525980137787, 26.152529790560312],
              [70.147412232736428, 26.170386849617625],
              [70.162895669316669, 26.206317600174785],
              [70.164388860453144, 26.209789064868964],
              [70.166364729496962, 26.214347256712003],
              [70.172065058969793, 26.231159145836425],
              [70.173966094804982, 26.242025752704151],
              [70.174121980220633, 26.256710849397003],
              [70.171939361782975, 26.263895693612426],
              [70.16871902739318, 26.277161270872384],
              [70.168212791029816, 26.28233616348863],
              [70.165727520022273, 26.287243161220118],
              [70.165690589687273, 26.294032143022186],
              [70.165651449329872, 26.300913228871149],
              [70.174443632852771, 26.330015807350378],
              [70.176236643559605, 26.339066267946432],
              [70.180897357228389, 26.354827566492837],
              [70.183488754268112, 26.361439017782939],
              [70.184143159908444, 26.375467997036893],
              [70.183175688847385, 26.386025737595549],
              [70.181723607432389, 26.392351572488479],
              [70.177873741103468, 26.42407464110606],
              [70.178446382168076, 26.440374172747056],
              [70.182486384964733, 26.477663233916029],
              [70.183268863295737, 26.484286897288026],
              [70.182086287942596, 26.496237196499873],
              [70.178710536122978, 26.506104069301646],
              [70.176323520603859, 26.538107877143325],
              [70.173250820392255, 26.551121300545219],
              [70.163967480824553, 26.560436614022134],
              [70.154117227429211, 26.56677826577792],
              [70.139063889569201, 26.573038438451881],
              [70.124684449388326, 26.582890043714695],
              [70.118869918535196, 26.586855102347073],
              [70.111695578118969, 26.590082079699034],
              [70.106909676845888, 26.592715209654827],
              [70.098557765072783, 26.595023740991937],
              [70.064283562999179, 26.600195865402956],
              [70.049819468837512, 26.600996913028659],
              [70.041702889730715, 26.599063514913453],
              [70.018487898731749, 26.594863561634082],
              [70.003094073051358, 26.592155644494053],
              [69.973935765841745, 26.587940325720989],
              [69.91290885861261, 26.582848515246255],
              [69.894833207526887, 26.581332180430397],
              [69.884273952243987, 26.581194885292472],
              [69.879314402418458, 26.580581969124207],
              [69.874751681921751, 26.582293415555554],
              [69.859216723586869, 26.585896718997095],
              [69.851097304520195, 26.587026641825659],
              [69.838550379626952, 26.588605608808525],
              [69.804386817013409, 26.597662461262345],
              [69.800724962596433, 26.599024436243553],
              [69.776034889889075, 26.614064255769879],
              [69.765739663028242, 26.622545096062758],
              [69.73693569529334, 26.646335533030413],
              [69.722326410819747, 26.654600000319473],
              [69.710853998833045, 26.662018147073692],
              [69.698740045054308, 26.665935124109058],
              [69.677577392265718, 26.674545565679274],
              [69.670232069702593, 26.676851406218116],
              [69.638340113011679, 26.692360049542351],
              [69.634044410580898, 26.693382131783466],
              [69.603537918967305, 26.704899752910308],
              [69.597428280342768, 26.707644098245318],
              [69.591440908168693, 26.710527146376773],
              [69.57078455650236, 26.720440287985006],
              [69.552925655601896, 26.728078728550759],
              [69.537736031635816, 26.73357853911671],
              [69.514636679249094, 26.741979370638159],
              [69.510866411951795, 26.745784069547174],
              [69.506829049856165, 26.750797391196393],
              [69.50040437019139, 26.767790946763668],
              [69.490015625321107, 26.789772793937264],
              [69.486368142231669, 26.799450485631894],
              [69.484313968634453, 26.808020791879088],
              [69.485776315237942, 26.818648893311344],
              [69.487755575395084, 26.831561111585113],
              [69.49883601492256, 26.872003562392401],
              [69.501492660086555, 26.894516893863923],
              [69.508516230811651, 26.953844580635238],
              [69.510134983646154, 26.970232633257655],
              [69.514116364451908, 27.009582264307692],
              [69.515136252113535, 27.013894665316347],
              [69.528285079854513, 27.04267341121982],
              [69.538486125284876, 27.065028517885693],
              [69.551474964345275, 27.102676151716725],
              [69.552952137472502, 27.105487618805054],
              [69.5629711683126, 27.123180932601912],
              [69.567073068265572, 27.134059039036515],
              [69.577961522108282, 27.157002375543751],
              [69.584080049570574, 27.173316384296555],
              [69.589633525543022, 27.182967585067306],
              [69.603039583898195, 27.195124760631998],
              [69.608027331517334, 27.197287197549954],
              [69.619643944957502, 27.205938598471338],
              [69.635785639596136, 27.218616732660617],
              [69.642445080986732, 27.223273428448319],
              [69.653763673213192, 27.233473497688113],
              [69.671852558740724, 27.254221931282224],
              [69.681251881576287, 27.262654441958958],
              [69.685286555399159, 27.265961592828074],
              [69.705046350339714, 27.285255771606483],
              [69.713460865504956, 27.291556301601098],
              [69.76390041650069, 27.324681400218022],
              [69.786609940039753, 27.346649729661813],
              [69.790333787196872, 27.350245227367697],
              [69.810476888657917, 27.362657502787158],
              [69.834811307238667, 27.38229389999443],
              [69.853085924433941, 27.393879621001535],
              [69.871618123472601, 27.409206140144036],
              [69.889618480400713, 27.429883812623448],
              [69.897115497352587, 27.438446120958488],
              [69.913184383028991, 27.460456021879779],
              [69.922083196821603, 27.476936800504134],
              [69.924905020308174, 27.480876095093347],
              [69.926174188406492, 27.484230700352548],
              [69.940737288393265, 27.502512755394651],
              [69.959309429284616, 27.518335113252693],
              [69.964740611605023, 27.522903652886868],
              [69.977757455296199, 27.532317241221925],
              [69.985038310807212, 27.537019007188857],
              [69.993245241904219, 27.541783969704646],
              [69.999458231474833, 27.545131259905453],
              [70.024597607865516, 27.561342204477363],
              [70.032265939576277, 27.571828401872594],
              [70.034582267481696, 27.575638915620505],
              [70.039629676500383, 27.586024736353409],
              [70.0498187206057, 27.612896192968829],
              [70.055988707271624, 27.623762208711248],
              [70.057640295096405, 27.629370056152172],
              [70.059347389511245, 27.634797661846648],
              [70.075013996553068, 27.664238803612719],
              [70.082097120603336, 27.68448188257393],
              [70.08834850863046, 27.697323917606258],
              [70.09544128007299, 27.714425103211553],
              [70.099446589131702, 27.725610408679643],
              [70.101117319277222, 27.732527120531536],
              [70.109984862834082, 27.74993997441879],
              [70.113161953658278, 27.75647651145546],
              [70.118582571939484, 27.771730148526167],
              [70.121377115349262, 27.781055472786953],
              [70.134639990236892, 27.80704644091837],
              [70.146162909206723, 27.819032346941835],
              [70.154174115569958, 27.827321127202531],
              [70.197271098054912, 27.866566667925444],
              [70.199986288524826, 27.869328732301817],
              [70.20529422962575, 27.876640451473044],
              [70.224838758197166, 27.898419458371865],
              [70.236841656760859, 27.90650873361357],
              [70.241495131740962, 27.908278213405772],
              [70.250111340567159, 27.913615196510037],
              [70.253244243754068, 27.916294151032805],
              [70.27308541009927, 27.925019378860263],
              [70.293502205974974, 27.936622221436124],
              [70.303594400711503, 27.944027425710782],
              [70.310212911098972, 27.948906548319595],
              [70.348911417877417, 27.989219384738405],
              [70.355309588983161, 27.995883183884626],
              [70.370766997787271, 28.009283000676156],
              [70.374264929085996, 28.012057041853705],
              [70.392436679745643, 28.012958994954801],
              [70.410424709437365, 28.016104672311815],
              [70.442339291324487, 28.02159828747925],
              [70.474931371516902, 28.032465715726065],
              [70.496675110333811, 28.036611226856468],
              [70.536455985707079, 28.032155280434409],
              [70.539886892816057, 28.031323460757044],
              [70.54745244782184, 28.029420324067274],
              [70.563220751218367, 28.022568658060685],
              [70.569242179733493, 28.019189793194009],
              [70.592406404044226, 28.009670216987434],
              [70.594012476848377, 28.006073750259656],
              [70.59664609338742, 28.002723942645574],
              [70.601593629576698, 27.998773774314795],
              [70.602661373105448, 27.994938108252818],
              [70.614634894183425, 27.984089329880252],
              [70.619104030459951, 27.977170371751502],
              [70.642883181367026, 27.956730799900882],
              [70.668309861939889, 27.934913290251028],
              [70.671918625712436, 27.929285260116988],
              [70.676966115038027, 27.923978831627895],
              [70.680984041749042, 27.89107304292445],
              [70.680320906660256, 27.872796717779323],
              [70.683795773768963, 27.842109353863552],
              [70.687398551153166, 27.82817235173065],
              [70.699452124309104, 27.811006575105594],
              [70.708975856095464, 27.799831933441077],
              [70.714504333415704, 27.790884448243414],
              [70.717693428743416, 27.787654786648361],
              [70.72138329948497, 27.782668797606789],
              [70.737508324160117, 27.751546098410511],
              [70.740453096632635, 27.748819084729991],
              [70.744542598815144, 27.743080063680388],
              [70.762389752210495, 27.728963372882934],
              [70.765436442746363, 27.726213194835701],
              [70.786974377203833, 27.720346819272937],
              [70.799514096445293, 27.718391528692152],
              [70.817195868768138, 27.714452132525832],
              [70.839637120705405, 27.713410775728107],
              [70.85620554191982, 27.712203202677504],
              [70.867884075011858, 27.710642535454721],
              [70.88249126719694, 27.708252938526961],
              [70.896346419282594, 27.710028865943542],
              [70.905255388040203, 27.710394466747072],
              [70.948489420071482, 27.728427724928466],
              [70.960143729765761, 27.732250310928968],
              [70.968304916942316, 27.736056178329168],
              [70.983024897248114, 27.74365383325889],
              [71.032847100772827, 27.766510211466915],
              [71.054850069468671, 27.773069378950591],
              [71.069442191363308, 27.77743197838436],
              [71.086027645084044, 27.78581566861126],
              [71.139140092685139, 27.807118768963768],
              [71.173006218167771, 27.820664015763885],
              [71.183128253137554, 27.823048988368981],
              [71.208089092289157, 27.83288434284853],
              [71.229609068807576, 27.83723144480556],
              [71.242208448239865, 27.84136748064455],
              [71.254784375369695, 27.845385720026897],
              [71.272585840038076, 27.850206245735347],
              [71.325534663905742, 27.859803303423117],
              [71.341697320952946, 27.862707006596139],
              [71.380964696210711, 27.869753418898341],
              [71.409708083616906, 27.873493630915771],
              [71.418767446019416, 27.871650086391984],
              [71.447951526971082, 27.873596335045413],
              [71.499883909368336, 27.872899668486994],
              [71.523862173506771, 27.872568783088514],
              [71.531037309161718, 27.872486475258125],
              [71.549321922187517, 27.87335190317874],
              [71.586946472222181, 27.877265915717309],
              [71.60487230908349, 27.875046593847266],
              [71.621220915103365, 27.875214838814106],
              [71.644914554611319, 27.87545697678355],
              [71.658809498704301, 27.875596602855808],
              [71.664467442338832, 27.879296954528442],
              [71.681575244151787, 27.883833632034204],
              [71.698675270084408, 27.88909060866758],
              [71.720641006071617, 27.898022156363812],
              [71.744236575793636, 27.906979977275775],
              [71.760457781060708, 27.913602141187528],
              [71.766468600966689, 27.916211799021262],
              [71.827322715989737, 27.93655186513552],
              [71.859636388807971, 27.947348765552192],
              [71.894328902044066, 27.960936869381989],
              [71.897529708353773, 27.962662193054889],
              [71.902809337276381, 27.974806702901869],
              [71.904919385495106, 27.989243398301031],
              [71.906845352195788, 28.003276824584916],
              [71.910095587058152, 28.019755186552167],
              [71.913391249606363, 28.031983565277613],
              [71.913996948301218, 28.040517624148631],
              [71.914640909900982, 28.044182731955019],
              [71.913858370741139, 28.053928396473889],
              [71.919163569701496, 28.071030660236467],
              [71.921797909899112, 28.081411901717075],
              [71.923694031446345, 28.097274997774996],
              [71.926972864982943, 28.11131812190888],
              [71.929621565511979, 28.120486955002381],
              [71.932289406312606, 28.127816221498211],
              [71.934996923926192, 28.132720602970622],
              [71.944460866090495, 28.145590224491414],
              [71.9553199949152, 28.158485110903843],
              [71.967938550206014, 28.171046074242224],
              [71.976793236423802, 28.183979988874071],
              [71.999041142379625, 28.214140752619649],
              [72.021259740581527, 28.232289432467251],
              [72.027534373702352, 28.236743519979502],
              [72.046524106528921, 28.249037849094755],
              [72.068588503826447, 28.266345069663878],
              [72.093217393580204, 28.283923309120297],
              [72.096207955553027, 28.285689841052321],
              [72.100588423762431, 28.28826970058747],
              [72.11107018790409, 28.295277167678464],
              [72.128673700517567, 28.308830270893477],
              [72.164849806737124, 28.34879411238844],
              [72.167023727040998, 28.352207969576138],
              [72.169232492690611, 28.354655748942616],
              [72.191004185883642, 28.374245610684373],
              [72.196796045389931, 28.382593798831582],
              [72.19916248679786, 28.384951818248854],
              [72.205161498949394, 28.39038494943323],
              [72.206474182780212, 28.393579346683609],
              [72.209994453006246, 28.402147864313008],
              [72.213241851459387, 28.414636055675413],
              [72.220349852111141, 28.434337554432677],
              [72.229472433898536, 28.462199975224596],
              [72.231798266321292, 28.470249839792459],
              [72.233062207666364, 28.474530378587996],
              [72.235572586771823, 28.482191269170759],
              [72.243557154761106, 28.500333613341027],
              [72.245369180864785, 28.507670701520926],
              [72.256747538066506, 28.541146610485804],
              [72.258737439344983, 28.545751248048319],
              [72.263909971039553, 28.555495289605187],
              [72.270143585066009, 28.579940416650754],
              [72.272471818555545, 28.584661739977697],
              [72.281435384902466, 28.609329144916213],
              [72.287038285108778, 28.624814133602452],
              [72.290671600595331, 28.636316951910135],
              [72.293706726326732, 28.655025663612776],
              [72.298902920102478, 28.666190640813177],
              [72.302074089090794, 28.673464982380221],
              [72.308526481023804, 28.680046750640422],
              [72.311575420423949, 28.686377825545584],
              [72.324801232776807, 28.698872081859133],
              [72.348289824910211, 28.721043175232381],
              [72.350340644078514, 28.725462511605414],
              [72.369838559628661, 28.746806211193903],
              [72.382444940797484, 28.760646675171621],
              [72.388819256448613, 28.768832227781267],
              [72.40692195528797, 28.782722671700043],
              [72.413800630096659, 28.78567032746319],
              [72.435200406274092, 28.793327718704262],
              [72.450894448972889, 28.797856036104573],
              [72.463562695603216, 28.80388404594423],
              [72.472498953056572, 28.807160852091176],
              [72.489219109109555, 28.814995269358409],
              [72.508301889387567, 28.824813108365255],
              [72.5243751969942, 28.833075925256939],
              [72.556203593498012, 28.852536352298582],
              [72.592634783016962, 28.870284467778923],
              [72.596245466558898, 28.872316454258893],
              [72.648418672667106, 28.903219939587995],
              [72.65554829705772, 28.907440892979352],
              [72.66335122717858, 28.910979485320112],
              [72.671540337269349, 28.915964390452409],
              [72.67674538981845, 28.917816195525582],
              [72.679498887066771, 28.92032663161681],
              [72.716361344680266, 28.93894037540597],
              [72.746581895212159, 28.95212789862596],
              [72.791085182347132, 28.969062487731748],
              [72.794981486015743, 28.970545329154117],
              [72.849412848476263, 28.991241592537438],
              [72.854231567598475, 28.993409463191806],
              [72.867441388806483, 28.999698599940412],
              [72.893247767371307, 29.007084915173298],
              [72.904531565921403, 29.012748950289712],
              [72.918374126205066, 29.017702980954027],
              [72.933807599055939, 29.023209693293936],
              [72.941160403725206, 29.026202492184026],
              [72.945071147135053, 29.028478998776507],
              [72.949421148577386, 29.033145481094682],
              [72.959336151071071, 29.056395430216092],
              [72.963816506214428, 29.064322328171841],
              [72.966392543739715, 29.071328714598383],
              [72.981581289092688, 29.102390027828161],
              [72.98465479990108, 29.110270790270405],
              [72.989270058144868, 29.117094667755762],
              [72.991590895076442, 29.120839025808884],
              [72.993907170746922, 29.130853272056775],
              [72.99876533212975, 29.142722787989324],
              [73.021777426594767, 29.167474234174112],
              [73.026425455844702, 29.171311224866898],
              [73.030262889492221, 29.17714587195233],
              [73.041700285070661, 29.191113922600234],
              [73.046297894318769, 29.19467409955935],
              [73.06139758145261, 29.210201196448327],
              [73.084789506911022, 29.236406542039397],
              [73.095639165131189, 29.25209191372706],
              [73.098673960600593, 29.256775187961196],
              [73.104872336500094, 29.268739894612413],
              [73.107960021950049, 29.275514400187422],
              [73.11591356662646, 29.285709428110277],
              [73.118714384980578, 29.292300042050623],
              [73.120416321090687, 29.295100161004346],
              [73.1436378306786, 29.332249645362502],
              [73.146205951635878, 29.338358091410658],
              [73.153543092818282, 29.35282318867624],
              [73.157710428826945, 29.360168946241291],
              [73.164103848262286, 29.370730287397041],
              [73.175794671535883, 29.388888465537427],
              [73.177839714089615, 29.392330334411515],
              [73.198200187998381, 29.431449428482825],
              [73.209319465932126, 29.44475990647598],
              [73.228703730285318, 29.482266087786961],
              [73.230882062668755, 29.484835108672122],
              [73.234610472731973, 29.489445521448101],
              [73.239546700243366, 29.495826148202532],
              [73.245254819960294, 29.508931299464948],
              [73.250138972298373, 29.515287817321905],
              [73.25479352205501, 29.523664120850942],
              [73.269404496901004, 29.543993060311173],
              [73.2786370673617, 29.559734240811459],
              [73.28222192465104, 29.569443241681313],
              [73.291331765494192, 29.600456712256715],
              [73.293419396354309, 29.607411551548982],
              [73.305129911551589, 29.63632839417544],
              [73.31968388350451, 29.689009812688681],
              [73.322453133741561, 29.694240742482986],
              [73.323746827877059, 29.697270927451473],
              [73.325022529168152, 29.701747115166157],
              [73.333227210455405, 29.730529060655829],
              [73.334470030887871, 29.733879496169216],
              [73.341503947683009, 29.752491182720007],
              [73.343572532124071, 29.760386709304157],
              [73.348200107007187, 29.771654580398039],
              [73.353621089665907, 29.794861735631823],
              [73.357545417309325, 29.807989119963999],
              [73.362310487685576, 29.820427389339038],
              [73.366751863092261, 29.838973530525909],
              [73.373923935707381, 29.855677177025125],
              [73.37961280583464, 29.876837248063275],
              [73.393683797258817, 29.928869198004129],
              [73.399668745215365, 29.94072843302683],
              [73.407581457447037, 29.946244546225405],
              [73.430304525503459, 29.955855808405332],
              [73.450680413009252, 29.963427940909657],
              [73.483616223217226, 29.977024613177075],
              [73.509054525010043, 29.984158643736237],
              [73.515069486157046, 29.986828052284338],
              [73.52723238816327, 29.992253292111577],
              [73.548483501320348, 29.997834284083289],
              [73.570443440926411, 30.008023245525472],
              [73.58827818575196, 30.014066674289278],
              [73.608226876301543, 30.020834083064422],
              [73.619943279418052, 30.024670254846399],
              [73.662246533915877, 30.033338906729519],
              [73.680754448408081, 30.039023463690782],
              [73.687320226296578, 30.041038239605186],
              [73.718092901593593, 30.049119203853952],
              [73.763001899230773, 30.058409186712556],
              [73.796300876016801, 30.068183947096568],
              [73.803177154752916, 30.071430596348364],
              [73.80957648507983, 30.078148852354932],
              [73.815444847256813, 30.084248807329942],
              [73.846931337577487, 30.11039163854629],
              [73.857665370323986, 30.117749267222305],
              [73.863578040953868, 30.12191790222867],
              [73.881893662271708, 30.133935736382458],
              [73.892837173297195, 30.140439695559238],
              [73.904870980442738, 30.150976005109914],
              [73.913304564811426, 30.156551061295385],
              [73.932933628802431, 30.169424409122858],
              [73.967461280330696, 30.187209512601701],
              [73.97587271734352, 30.196473773199212],
              [73.974209239565369, 30.22592828859235],
              [73.973527375719399, 30.232274824212954],
              [73.970791138282038, 30.242689760801692],
              [73.969531049386831, 30.256685864856635],
              [73.967529460896117, 30.263216223836064],
              [73.964117353218228, 30.26772325729479],
              [73.96123704874708, 30.271542093663623],
              [73.958408973205195, 30.275386346320708],
              [73.954202944392975, 30.283423663288392],
              [73.9530186134307, 30.286561573159197],
              [73.950965820503882, 30.289122820721754],
              [73.946725729464703, 30.297961796003179],
              [73.944087310897032, 30.304675012227282],
              [73.941850224328704, 30.306981911329441],
              [73.936614340699165, 30.310996742789271],
              [73.933884111722975, 30.315710719663624],
              [73.92992689007302, 30.321774054778007],
              [73.9280539195111, 30.324932274637003],
              [73.925696898573293, 30.328982245428509],
              [73.922814428172927, 30.332573249929226],
              [73.91832993389562, 30.338449616367409],
              [73.915476239297135, 30.341579366407778],
              [73.910747090669147, 30.344723186136974],
              [73.909324324860179, 30.347608158496804],
              [73.907077945306852, 30.350809211321046],
              [73.895454456745767, 30.356282847251723],
              [73.890489070800612, 30.359011270305079],
              [73.88535669779381, 30.362679068296867],
              [73.8938843793334, 30.371077356829225],
              [73.908424984693866, 30.378357640579576],
              [73.913317743484583, 30.381731132456494],
              [73.917732782435451, 30.385403465008629],
              [73.921160469454946, 30.390171204747329],
              [73.923513028098256, 30.393809326737735],
              [73.928797292713057, 30.398126561248503],
              [73.938950094939969, 30.402236632338298],
              [73.942753629318105, 30.406431699424139],
              [73.948457971626283, 30.411485499641284],
              [73.95369296863349, 30.415412354551012],
              [73.964838085554021, 30.421774208063766],
              [73.967439743699245, 30.424265349892959],
              [73.972055610421819, 30.433581526775491],
              [73.972665566242867, 30.440790337558035],
              [73.968838068722391, 30.443045900233521],
              [73.958723764970671, 30.440290760119634],
              [73.942784603630756, 30.437852743834885],
              [73.93847366439725, 30.437602222002944],
              [73.930577376947383, 30.43903229688874],
              [73.937305134431313, 30.445146415173362],
              [73.939264911324798, 30.448553709752694],
              [73.93984328625676, 30.455992129295705],
              [73.938781084845999, 30.460048260170389],
              [73.934807237134891, 30.467512387047556],
              [73.935295825545438, 30.472929488784931],
              [73.935479567708313, 30.483534137195512],
              [73.935171515149619, 30.489408201845258],
              [73.940899031981957, 30.491706535535947],
              [73.942988811601282, 30.488321896529801],
              [73.947692550638436, 30.486094466742752],
              [73.950456103466252, 30.48112711595229],
              [73.949650318423465, 30.468477376750489],
              [73.949963269328379, 30.461937194407355],
              [73.957258648643673, 30.459700465375558],
              [73.966107761300876, 30.461990084110894],
              [73.967627862121333, 30.46789527834542],
              [73.970345375248442, 30.472634968048244],
              [73.971168813718293, 30.475921362402854],
              [73.970238751402661, 30.483721774387508],
              [73.970084290407911, 30.486888816338062],
              [73.975518303520502, 30.493270734212075],
              [73.984860283914159, 30.50139004344906],
              [73.988689526014412, 30.510450047332782],
              [73.991376140931649, 30.512367637538418],
              [73.998646166566715, 30.514213298747329],
              [74.003516675783757, 30.514578829935996],
              [74.009564622288735, 30.513134514161564],
              [74.015903729928453, 30.511601284995013],
              [74.020365444742524, 30.513303434491057],
              [74.015786484898882, 30.517223416028944],
              [74.012615015445292, 30.520033744987717],
              [74.010477116113023, 30.526794645058121],
              [74.011748077209106, 30.53065620842154],
              [74.015919884189216, 30.53271717559041],
              [74.021778247719269, 30.53193825350839],
              [74.028430285657663, 30.531392567338653],
              [74.033915746256511, 30.530956527582081],
              [74.040942124663957, 30.533946218553417],
              [74.043284290700072, 30.536319658012175],
              [74.045828880910719, 30.540048608905899],
              [74.050009331471557, 30.54075423299626],
              [74.051877578547078, 30.534449089802674],
              [74.05611343123924, 30.522462522754605],
              [74.060543412004478, 30.521378986336817],
              [74.067592159935373, 30.520716068370351],
              [74.074533449046086, 30.524508084840761],
              [74.077460790796863, 30.526630376573518],
              [74.081620898411813, 30.53059313684717],
              [74.083697705097478, 30.533195638485559],
              [74.088094897843732, 30.537503819748622],
              [74.091456782975754, 30.54226723321537],
              [74.092596782820607, 30.546517435412198],
              [74.092838106995401, 30.550396647529716],
              [74.082556379482654, 30.550818657568971],
              [74.078599165836479, 30.552385770804932],
              [74.078309897259572, 30.556447378052489],
              [74.081316311308399, 30.558708278191578],
              [74.086379744466939, 30.562584116462371],
              [74.09456212181189, 30.567732658728467],
              [74.100464534042118, 30.573261980880691],
              [74.10311952255374, 30.576875979590966],
              [74.103569262176293, 30.581421748237609],
              [74.102644038657033, 30.589978373786561],
              [74.102585678321191, 30.599686684055698],
              [74.105012397718212, 30.606238759181348],
              [74.100721066034083, 30.610078215896358],
              [74.101570710671382, 30.614373068183884],
              [74.106408034353791, 30.616639603851596],
              [74.110076132914784, 30.61506937761331],
              [74.112695302981592, 30.611475885283813],
              [74.115307869071188, 30.608982597592082],
              [74.119506100289584, 30.607206734261815],
              [74.122305187191074, 30.618302243744715],
              [74.127489930372832, 30.624838391518111],
              [74.129004275380225, 30.633681560086846],
              [74.134244420006354, 30.630532632883565],
              [74.140508651721461, 30.629405238991499],
              [74.150910812597431, 30.632607010492912],
              [74.154282321417966, 30.636681959345921],
              [74.160805701095839, 30.641453129165104],
              [74.167307682582489, 30.645536566885315],
              [74.175633299234178, 30.65077348433919],
              [74.180302250235528, 30.655516287591922],
              [74.182639098183301, 30.660066862591215],
              [74.18612146244098, 30.663658840761741],
              [74.192615256219256, 30.665178285942684],
              [74.198007413439541, 30.668216361799452],
              [74.209530862641785, 30.682043594833747],
              [74.213488221048792, 30.686300290336163],
              [74.220568744337427, 30.692472071334564],
              [74.221481754195452, 30.695642813451922],
              [74.223130445202059, 30.706022396633685],
              [74.226775374242138, 30.709428625656102],
              [74.230362423759729, 30.719607459031959],
              [74.23207444813734, 30.722525523169509],
              [74.235837703000172, 30.7235924234128],
              [74.24080518975947, 30.722573270728649],
              [74.24498469155904, 30.72552173210504],
              [74.248618009517685, 30.726220726774802],
              [74.253612306148, 30.725154430080558],
              [74.258022306906156, 30.724176876683703],
              [74.262479106152668, 30.724418324903016],
              [74.267698353520743, 30.726473135395214],
              [74.273404850568909, 30.732592625244862],
              [74.280990967875852, 30.733620069048293],
              [74.286983391767777, 30.735310528869565],
              [74.287756955895674, 30.740523313892609],
              [74.283816047220625, 30.743680773129057],
              [74.27753160133139, 30.748165780628398],
              [74.276941668058427, 30.755784075810602],
              [74.273576577114468, 30.76039113981891],
              [74.265694088290957, 30.765993732320212],
              [74.263569439962978, 30.772095698994271],
              [74.26721748206657, 30.775708643166368],
              [74.271672203971391, 30.777095469745962],
              [74.276650080810043, 30.77439929239312],
              [74.283187952534306, 30.773037021247095],
              [74.290205418764003, 30.777369214393048],
              [74.295141248465967, 30.778274972221332],
              [74.302253022989404, 30.779644691047256],
              [74.307443889787237, 30.782801137516092],
              [74.310294939198016, 30.787123207367454],
              [74.309243227410846, 30.791183375702051],
              [74.307399056055402, 30.794117509598909],
              [74.301763896833279, 30.795436442078373],
              [74.297985299547108, 30.797034994478455],
              [74.296907924383575, 30.800865105859888],
              [74.303430576269136, 30.803588128680559],
              [74.305762478447591, 30.811489733020689],
              [74.309545406511788, 30.815583326465898],
              [74.313574393407606, 30.817634776397728],
              [74.318815357096227, 30.822375352578678],
              [74.321739071491052, 30.835922808047712],
              [74.322884733619674, 30.841801076028798],
              [74.325343923998886, 30.844951265950336],
              [74.327454738549207, 30.848835042103389],
              [74.331274580830922, 30.850862276971061],
              [74.340658283688683, 30.849985953897527],
              [74.342718215939811, 30.853592673797092],
              [74.34874375234736, 30.855325084823829],
              [74.353977607133828, 30.855657330750407],
              [74.357382749905682, 30.854744437172336],
              [74.358700685597526, 30.850248884187927],
              [74.36263808459114, 30.84912985391653],
              [74.368128485907192, 30.851849495885837],
              [74.371235920882143, 30.860439287233159],
              [74.376201387102753, 30.861778071483045],
              [74.380906674746143, 30.861350745289577],
              [74.384569438423284, 30.862710749547478],
              [74.385515885713318, 30.866132164115722],
              [74.380936460328087, 30.868374160783613],
              [74.37301017298951, 30.870150951951963],
              [74.371430448249299, 30.873522913860516],
              [74.367758029760338, 30.87478027777604],
              [74.364156244320483, 30.878812111786953],
              [74.368530291379727, 30.882126329617208],
              [74.370083492744939, 30.886856479358475],
              [74.372262348063742, 30.894985975022603],
              [74.379700236598666, 30.89681267830516],
              [74.390192415172592, 30.899766865285468],
              [74.393748236164654, 30.901816550678355],
              [74.395654530197234, 30.904527800169937],
              [74.407941467058293, 30.912463871289404],
              [74.419213562855404, 30.912939652573307],
              [74.425493490974091, 30.911571298183123],
              [74.42862405148415, 30.914075936363723],
              [74.428080518413736, 30.918367162901411],
              [74.424135882138572, 30.921531219081245],
              [74.416699280456186, 30.925002170691506],
              [74.421778612423708, 30.927173929551984],
              [74.427791947968274, 30.926264082303341],
              [74.427802680857042, 30.931680538469788],
              [74.424552219524841, 30.933765643946497],
              [74.420823523247876, 30.935734752442634],
              [74.42437441184542, 30.940032849560229],
              [74.42511122832795, 30.942972679491621],
              [74.439542608223832, 30.947511736229625],
              [74.445647076040899, 30.952478326288752],
              [74.449447671410567, 30.95406454723943],
              [74.454714410348075, 30.954001604660359],
              [74.460462766324667, 30.952975450233694],
              [74.461492725581962, 30.956143398912634],
              [74.462521752230373, 30.959519296938261],
              [74.466460075660564, 30.959065479461543],
              [74.469326899255449, 30.962004851521723],
              [74.465887542252929, 30.965101463940407],
              [74.459643006448829, 30.969705263305258],
              [74.467492428020108, 30.972172716384328],
              [74.479777093760674, 30.9758109158115],
              [74.48892838180474, 30.976782797718815],
              [74.492599770795465, 30.977154988847655],
              [74.498376881752478, 30.975139061492612],
              [74.500487928994161, 30.971075679443032],
              [74.506702028062691, 30.966466720965244],
              [74.511452551207782, 30.969937391825539],
              [74.51617183959516, 30.978755344824997],
              [74.520637772225371, 30.980937092345023],
              [74.526111052549567, 30.985761448227517],
              [74.534486270121263, 30.989851854627233],
              [74.544436861433795, 30.99141705453896],
              [74.548372467089735, 30.993025162417162],
              [74.550333021884541, 30.998191133218068],
              [74.548865404268597, 31.001152769400729],
              [74.545423479054108, 31.005926007332562],
              [74.543632566223721, 31.010171053866053],
              [74.543627887908684, 31.013569580300395],
              [74.547560459983956, 31.017634481509496],
              [74.549878619728574, 31.032555152679492],
              [74.552482836669924, 31.035702113591295],
              [74.557988609620338, 31.039559336593353],
              [74.561628841278463, 31.044083370573635],
              [74.564795132367806, 31.046103738627593],
              [74.564891134507405, 31.053106040951327],
              [74.571119522828681, 31.055219730327224],
              [74.583098950558579, 31.058320863072716],
              [74.58810559549832, 31.058780981950967],
              [74.591781368899703, 31.058321368462739],
              [74.596497866469306, 31.055383486186777],
              [74.5996539146564, 31.043630928447929],
              [74.605940203299795, 31.041380819831563],
              [74.614590214690253, 31.045442153948159],
              [74.626385048409873, 31.04688637790542],
              [74.634505389834231, 31.047711746037873],
              [74.645526114405726, 31.053585234403482],
              [74.654421283446851, 31.053811391229733],
              [74.658095945592919, 31.053581067856811],
              [74.668054817042133, 31.055136292824255],
              [74.678651968476814, 31.059400096842047],
              [74.684296939198987, 31.062152799873211],
              [74.69031592626952, 31.067335186805938],
              [74.695295270054885, 31.072749626388106],
              [74.69715920424494, 31.077042138148737],
              [74.697052380904367, 31.080554203929847],
              [74.696359455340655, 31.086983289460854],
              [74.698436246038042, 31.090149450127164],
              [74.70315179213361, 31.092624369240578],
              [74.706587958760892, 31.09599724319078],
              [74.702911920109486, 31.104584945076031],
              [74.702783718721335, 31.115087802171313],
              [74.698433742791678, 31.119970863534821],
              [74.694249422359761, 31.120869433657713],
              [74.6928087419912, 31.126103796501507],
              [74.691342870907803, 31.129685003334231],
              [74.688757052636859, 31.131708134294286],
              [74.681134863806108, 31.131070396046738],
              [74.675886209930539, 31.12744480559352],
              [74.671168118474242, 31.128136106919477],
              [74.66959364806587, 31.133302540049947],
              [74.664875627031989, 31.135807847946847],
              [74.652004564896984, 31.130852618013829],
              [74.647824314182159, 31.124977706162838],
              [74.643349068392169, 31.122041494158527],
              [74.637059362757228, 31.12337406185565],
              [74.636815500139733, 31.128127185494836],
              [74.638144783081572, 31.133154386901602],
              [74.638488297329943, 31.136482926199729],
              [74.634702162330711, 31.13760810388246],
              [74.626921036429266, 31.136828179507987],
              [74.623057358210502, 31.134602231375794],
              [74.618687336917503, 31.133799686799946],
              [74.613434437712485, 31.136279433011524],
              [74.607145312971127, 31.135821801378931],
              [74.604002992002179, 31.1328602310004],
              [74.603900623674477, 31.129208844201322],
              [74.607928340719397, 31.125650363945947],
              [74.610071111150617, 31.116262164707784],
              [74.611379949601115, 31.113071973869644],
              [74.61268825624127, 31.109628087243586],
              [74.612160884617481, 31.104188676943707],
              [74.610246829703527, 31.100628896508994],
              [74.608523574876628, 31.091746463457255],
              [74.604854561251216, 31.088230587815943],
              [74.601439121836037, 31.090413865533495],
              [74.600103537268808, 31.094041687685888],
              [74.59748915031507, 31.096062291555988],
              [74.59370982366228, 31.09378889506073],
              [74.590169813946176, 31.091078340981518],
              [74.584922253351365, 31.090367517148241],
              [74.577843162967923, 31.085224694597553],
              [74.569713655158807, 31.087931490686319],
              [74.565239542632725, 31.087104328048675],
              [74.559217989577434, 31.088363894160015],
              [74.557867607617197, 31.099451851106117],
              [74.555915101765478, 31.104408598735631],
              [74.555849253474278, 31.111983005058701],
              [74.556561521806969, 31.116599260056848],
              [74.555887081774586, 31.121348890059867],
              [74.548417907485614, 31.126074817688188],
              [74.542212209814082, 31.124121754843365],
              [74.538536008518378, 31.123430892236485],
              [74.537251404638226, 31.126345131947154],
              [74.535270891960707, 31.130614597084811],
              [74.529669722758896, 31.133135270234728],
              [74.518228461404817, 31.136915224152855],
              [74.516650404726491, 31.139623884367992],
              [74.517666835598263, 31.150688309859714],
              [74.516075686941193, 31.159686541075555],
              [74.515955843578325, 31.166158578191688],
              [74.515916203154816, 31.172149806823381],
              [74.513445249957655, 31.181100494762415],
              [74.514449653977678, 31.185485115132856],
              [74.519673388299665, 31.186406970244114],
              [74.521640086407402, 31.189782196144016],
              [74.519951469268378, 31.194075651365747],
              [74.520449402053089, 31.198596872078273],
              [74.52308284679097, 31.201767105882421],
              [74.526745926865814, 31.210560918525623],
              [74.526063149158588, 31.218708432197865],
              [74.523038073415066, 31.224146860608034],
              [74.523554330505391, 31.232504174029703],
              [74.526024465617638, 31.237921334350006],
              [74.531911623502964, 31.242884235152065],
              [74.534516103564059, 31.248761813061453],
              [74.533467097180107, 31.252595104882133],
              [74.531088042765901, 31.254841817677629],
              [74.529934023229529, 31.257918716706708],
              [74.52821309069796, 31.264574326414827],
              [74.526899998115056, 31.267511399625384],
              [74.523986310066689, 31.269322403384457],
              [74.523470940956003, 31.273613805790124],
              [74.525145994368202, 31.276783029203212],
              [74.52869256870008, 31.278806353604583],
              [74.530787897730377, 31.285142195376711],
              [74.537067485260849, 31.295980821612279],
              [74.542853487308662, 31.30006993307175],
              [74.544288171647551, 31.303721134286441],
              [74.542572791765309, 31.30750768504895],
              [74.532392520964592, 31.310532007485438],
              [74.529824955573488, 31.31271046712034],
              [74.530325813215029, 31.316314573803854],
              [74.536517720316539, 31.318108516568252],
              [74.540942867711721, 31.32176091627575],
              [74.540156804633341, 31.328072166384498],
              [74.541324845447775, 31.33193025421301],
              [74.550402809114715, 31.333496226442751],
              [74.552502045908881, 31.338938048122742],
              [74.5482756923371, 31.342767889007661],
              [74.548107088164002, 31.346946432652913],
              [74.550878664518891, 31.350895364564636],
              [74.553272742275809, 31.356567271365652],
              [74.553494036226382, 31.366943028399682],
              [74.557445136994829, 31.368757420124727],
              [74.564017316366161, 31.369633193681448],
              [74.568472383290896, 31.373491146346488],
              [74.571971174362361, 31.374227340334464],
              [74.576111818866806, 31.374871468870108],
              [74.582679543159486, 31.37914195173061],
              [74.587936296641658, 31.383896377111515],
              [74.589375161957236, 31.387039570196208],
              [74.589760008673892, 31.398357958837703],
              [74.591972039858248, 31.402419604988946],
              [74.594051749693193, 31.406644175499018],
              [74.596185559167324, 31.40944627430509],
              [74.59668765881365, 31.41417496685937],
              [74.602617411833663, 31.417778281409433],
              [74.602879822558023, 31.420947953574561],
              [74.608919018586946, 31.422989543694516],
              [74.612874038286876, 31.424781856455574],
              [74.617605041570499, 31.425469600797129],
              [74.622606528649342, 31.423954577258939],
              [74.626532445831501, 31.42794859263757],
              [74.631218762999964, 31.430047255447214],
              [74.635356649893836, 31.425447226087741],
              [74.637578729937431, 31.422348027260057],
              [74.64022767027447, 31.419822759732629],
              [74.64771597240582, 31.415895398371916],
              [74.651954629303816, 31.417297629573284],
              [74.650519101949143, 31.421174324686152],
              [74.649446842017824, 31.424571772314579],
              [74.654555246188806, 31.426695523237697],
              [74.65641999922245, 31.429986892575986],
              [74.653129465914461, 31.432467659871367],
              [74.649168514484117, 31.437427569745179],
              [74.642853532594543, 31.443558164482411],
              [74.642582025508148, 31.44805521409355],
              [74.653619484720309, 31.457097305894507],
              [74.654926297122103, 31.461160248102775],
              [74.653103336784312, 31.465683593684677],
              [74.645182270131215, 31.470872230164659],
              [74.64360255816139, 31.473582172314558],
              [74.633619800020355, 31.479253151093356],
              [74.636691380575613, 31.483682811661478],
              [74.639336067384917, 31.487951688030751],
              [74.634920242439364, 31.488365589727447],
              [74.627003333876686, 31.487149793597609],
              [74.62199973302387, 31.488504927300283],
              [74.617261601565218, 31.490983618474278],
              [74.615677169118769, 31.496192746505915],
              [74.610240546335518, 31.499475341343601],
              [74.605931294808016, 31.501379414142416],
              [74.601196979111833, 31.500024848125133],
              [74.595391859823479, 31.499795280309183],
              [74.592506134540088, 31.497085533693131],
              [74.58800959998338, 31.49800135227056],
              [74.579066212366897, 31.502291251547849],
              [74.581443688677851, 31.504770518737484],
              [74.584598193092575, 31.506791707062757],
              [74.586304909794663, 31.510649098485004],
              [74.584287094564658, 31.517397330981201],
              [74.585886888817043, 31.521023798713351],
              [74.592304149653131, 31.525273761737811],
              [74.601160830738408, 31.526629201089822],
              [74.606405923722946, 31.526929171200834],
              [74.611942706986554, 31.528949546345487],
              [74.615655559586074, 31.534665597496275],
              [74.617761773426849, 31.54159671440096],
              [74.618773340450716, 31.547015387807907],
              [74.617910761462298, 31.551742666154297],
              [74.62000957541639, 31.555470717734043],
              [74.617022707476934, 31.55969166602474],
              [74.613291172951321, 31.561226802766463],
              [74.613136208199151, 31.564298932716483],
              [74.618804943946046, 31.565064804141326],
              [74.618947668036483, 31.570569671801231],
              [74.612235138585234, 31.570952938293669],
              [74.606112441692161, 31.574149326887984],
              [74.601090512697553, 31.576347376055022],
              [74.597126842737708, 31.577287366747584],
              [74.593454689766759, 31.579100867557734],
              [74.591035809626717, 31.585181785455926],
              [74.587872388488748, 31.587063707076258],
              [74.584736596527605, 31.588624994511147],
              [74.579954042641546, 31.598285008648983],
              [74.580721430321049, 31.604162326895153],
              [74.577583174423509, 31.606663621815905],
              [74.563355742740001, 31.608905790103403],
              [74.557778668627265, 31.611634197589222],
              [74.554069339061741, 31.618379259942859],
              [74.553912198429373, 31.63013228929271],
              [74.551495619578375, 31.63261086454721],
              [74.548783851212235, 31.635568965920587],
              [74.547865192892829, 31.643172429995499],
              [74.542434816838181, 31.64795839139736],
              [74.542416085598347, 31.657026362008658],
              [74.541067864089086, 31.660399676565195],
              [74.534196777982714, 31.665145005871111],
              [74.533139550404442, 31.670790524750952],
              [74.536160667381594, 31.674396074802694],
              [74.536684685036931, 31.679608874108006],
              [74.53311282615006, 31.682771588690308],
              [74.531013873756862, 31.68655781224475],
              [74.528139351026198, 31.689035518065737],
              [74.520948591114333, 31.691116338637936],
              [74.517244227736001, 31.693156821446429],
              [74.514341244513147, 31.696299258585118],
              [74.508786819589815, 31.698107095198729],
              [74.505634122522082, 31.70443932168445],
              [74.502731714267881, 31.706684786880174],
              [74.496952097049103, 31.712392849298755],
              [74.494237680315337, 31.714571403657636],
              [74.48975217111375, 31.717068441295449],
              [74.486003880684947, 31.722483036229427],
              [74.492623067849479, 31.726780087283029],
              [74.500690200452951, 31.729312881070516],
              [74.505412212298481, 31.739028355616544],
              [74.508569515687086, 31.742519010415339],
              [74.517934332965083, 31.741037280171241],
              [74.521525797265653, 31.742532786917575],
              [74.524900829853863, 31.74444046427573],
              [74.542214948536298, 31.751661269834507],
              [74.549831191119821, 31.753043931890556],
              [74.555413119418731, 31.752611834524625],
              [74.564369742832099, 31.754407995640996],
              [74.565433070128321, 31.759365563008988],
              [74.560914842287502, 31.765239202661629],
              [74.558281020967385, 31.767280709345609],
              [74.5574534237644, 31.778344211076174],
              [74.560604853314516, 31.786242780779212],
              [74.568001556334977, 31.792122121685274],
              [74.568260992534903, 31.796415592098143],
              [74.562997042174146, 31.798454763899613],
              [74.57113488220169, 31.809752850227166],
              [74.573752675582199, 31.817213528272017],
              [74.573128683537774, 31.820632051307356],
              [74.569793499078699, 31.823522364225685],
              [74.569271726944862, 31.82962785509725],
              [74.578231795837297, 31.83438344887945],
              [74.586136001753601, 31.843639075580587],
              [74.594056402636696, 31.845454709776778],
              [74.595916839303726, 31.856978811072665],
              [74.599187117701973, 31.860742878528491],
              [74.609627247427554, 31.866691573797308],
              [74.609608937278637, 31.879109014177516],
              [74.611720945561743, 31.885445652328372],
              [74.613974090678241, 31.887947991555002],
              [74.617522187051534, 31.887258413737371],
              [74.625480527570971, 31.883176301505404],
              [74.636307166106164, 31.883199202948248],
              [74.640280939011546, 31.884783633385851],
              [74.643502307084844, 31.887285404008612],
              [74.647420110570337, 31.891555891710293],
              [74.649269149912243, 31.896306484594398],
              [74.651630983309147, 31.89855534146713],
              [74.657999379951491, 31.898784086700008],
              [74.662218373912495, 31.898096049213585],
              [74.665385323878553, 31.902617609813319],
              [74.665113722901197, 31.906473154735242],
              [74.665377507325161, 31.910995527740575],
              [74.670159486006497, 31.913244365886527],
              [74.672791339848587, 31.915285864117834],
              [74.673700507554926, 31.920037423471815],
              [74.680448785880571, 31.918658503491617],
              [74.683995088134822, 31.91978259517143],
              [74.687862762597902, 31.922742810373212],
              [74.698559202717419, 31.924851288624364],
              [74.703451172693036, 31.924296876079545],
              [74.706892378986723, 31.922711383124255],
              [74.709823828175473, 31.919105756286093],
              [74.714850465811679, 31.917957237015749],
              [74.723045968646559, 31.921118976757839],
              [74.723178803989214, 31.926558714194293],
              [74.720758887624754, 31.929338807568485],
              [74.720139474298279, 31.933997352370341],
              [74.721428822083553, 31.937164398373689],
              [74.726723615335715, 31.939433959142008],
              [74.731212432721051, 31.939891599494906],
              [74.73519221073775, 31.939658629185971],
              [74.73885155758029, 31.944589681449113],
              [74.743225157171693, 31.942378717383221],
              [74.747746322093974, 31.938386472610613],
              [74.753560758726067, 31.940162655791404],
              [74.759719708023596, 31.943212356451603],
              [74.759719945595336, 31.947286921125755],
              [74.75912365821334, 31.95085418684857],
              [74.761295681890033, 31.953418755321948],
              [74.769061184702011, 31.94863796901533],
              [74.77343425656818, 31.947782875251441],
              [74.776915507391408, 31.949836790644227],
              [74.779927634895813, 31.95226683190587],
              [74.797648470912648, 31.956998879540027],
              [74.802300543751741, 31.958761244966343],
              [74.807652976868539, 31.960866327879049],
              [74.815397620578224, 31.963289629369527],
              [74.81698126743774, 31.95899466999883],
              [74.820314388022453, 31.956902964836896],
              [74.824401361735113, 31.957632373288728],
              [74.826208310999135, 31.963643340577644],
              [74.829146841945075, 31.973212075437726],
              [74.833937448156149, 31.977956935233362],
              [74.834213518618142, 31.985852544248079],
              [74.831827895715904, 31.99535827675394],
              [74.832476735343576, 31.998961050199078],
              [74.834603759642178, 32.001668149389424],
              [74.841898607249036, 32.006614414926446],
              [74.852553562106337, 32.008434376856052],
              [74.858312743740385, 32.009757129683685],
              [74.860305808479936, 32.012255110222632],
              [74.854878698368225, 32.018829678106727],
              [74.866533826375033, 32.023333869961249],
              [74.870655683434663, 32.027366434471915],
              [74.874772818765067, 32.027587313684727],
              [74.878456626841498, 32.025101867830429],
              [74.881722792559145, 32.032580294589138],
              [74.881538526194433, 32.035932288925942],
              [74.879012018230981, 32.038437976996391],
              [74.876356580500499, 32.044756079513078],
              [74.882982898552939, 32.049267511311648],
              [74.88670069214642, 32.051969030536647],
              [74.893593357459665, 32.053309434486962],
              [74.911595281213692, 32.050795565959845],
              [74.917423175392074, 32.058473646701842],
              [74.919609048423894, 32.061728636438019],
              [74.927692941476607, 32.066279864079249],
              [74.940265377001978, 32.0669858637796],
              [74.953474521524782, 32.063145934340447],
              [74.962346694101072, 32.058327196098723],
              [74.965681268536557, 32.056987605725141],
              [74.976091129689493, 32.053931575864866],
              [74.980473496354875, 32.052221373616149],
              [74.981003097408049, 32.048592447802704],
              [74.978360619401712, 32.046118858348699],
              [74.982578275215502, 32.04319353886428],
              [74.986562277961156, 32.043389986693043],
              [75.000235489724787, 32.044247670304266],
              [75.004326663164392, 32.044236250286041],
              [75.007470345501773, 32.042643837503796],
              [75.009342607941122, 32.038369527242587],
              [75.012433932875155, 32.036891036211834],
              [75.016176998180256, 32.037958697373185],
              [75.018880466462832, 32.041945470998947],
              [75.021657477718762, 32.043981907097702],
              [75.024437469345116, 32.046428676800907],
              [75.036639672759776, 32.050020155514261],
              [75.039557391470012, 32.044593049260818],
              [75.042997761261205, 32.043436421543156],
              [75.049771399154338, 32.04908446691028],
              [75.054191275717031, 32.051022971417858],
              [75.061814028453156, 32.052651356169157],
              [75.065054374732654, 32.055716089800072],
              [75.072268920483282, 32.063211596828999],
              [75.076137194844719, 32.061878532432324],
              [75.082506755256773, 32.058917903970112],
              [75.087034381682699, 32.060534034181764],
              [75.091874606565355, 32.062115228894505],
              [75.100290570630435, 32.063815906778018],
              [75.104505977696789, 32.060862553586972],
              [75.108734999869199, 32.061765924604245],
              [75.109833188815841, 32.067409152464336],
              [75.11194866528092, 32.071234962377716],
              [75.122546582226519, 32.075741906138148],
              [75.128037241428203, 32.082080161335533],
              [75.132379187756541, 32.083901393549255],
              [75.137733205111431, 32.082893019556217],
              [75.14435044762476, 32.081512961873131],
              [75.152813844148227, 32.083752867980891],
              [75.156343225647532, 32.084106350107625],
              [75.166453846769713, 32.081242789966623],
              [75.168722474745465, 32.076710236620769],
              [75.171586302599692, 32.073049971515836],
              [75.172887640720617, 32.069211168101624],
              [75.177380378704683, 32.068503241733538],
              [75.181241717054235, 32.070989395429095],
              [75.186181878996507, 32.079761967597364],
              [75.189369997767201, 32.082021826158226],
              [75.195485368427043, 32.082891161044877],
              [75.198936719345596, 32.083771506262984],
              [75.200086493781797, 32.087875216894368],
              [75.199775216923939, 32.095979699843674],
              [75.202300081082115, 32.100032679030569],
              [75.206183841989045, 32.101370387637623],
              [75.207841427422778, 32.115368443727249],
              [75.213672501165746, 32.118050509156838],
              [75.219240976864853, 32.116695158837686],
              [75.223673488376633, 32.103774125654361],
              [75.228518462450225, 32.103316257873331],
              [75.233572749541764, 32.101663624074192],
              [75.234635610112946, 32.093530792121008],
              [75.239624828306475, 32.090981987940928],
              [75.247227202689587, 32.096663716963683],
              [75.250098889111015, 32.099886909590623],
              [75.253637624562828, 32.101845175678903],
              [75.258649447546475, 32.102509822865372],
              [75.265451481272294, 32.100236992566259],
              [75.266488023687344, 32.107637208869072],
              [75.274685402541607, 32.114325924633434],
              [75.282876539486097, 32.119541836875868],
              [75.283143362697388, 32.12385695707561],
              [75.287152896337332, 32.127900104831717],
              [75.287446054969365, 32.131963263563819],
              [75.284277334720116, 32.133769159530111],
              [75.281381439681468, 32.136032657706629],
              [75.281401552421102, 32.139660857828467],
              [75.283009288668623, 32.14282030921683],
              [75.290075431118851, 32.148891961386155],
              [75.29448135580121, 32.151351240216648],
              [75.301627162589355, 32.152210215997677],
              [75.305589318218111, 32.161440722866971],
              [75.308619618102398, 32.168015455726795],
              [75.315287028883589, 32.174272148342709],
              [75.319250726640135, 32.174480003072951],
              [75.322219689050868, 32.179675694174009],
              [75.320489764206897, 32.183289763552139],
              [75.319920209727854, 32.191673224477107],
              [75.316038333777485, 32.191669198470933],
              [75.313827359721273, 32.195974448563057],
              [75.315950461063224, 32.199361143999354],
              [75.327687910668885, 32.214154280677505],
              [75.331242127685428, 32.217671126124309],
              [75.338156118464354, 32.219471051835775],
              [75.345004707298031, 32.219318124331977],
              [75.355108546795307, 32.218138351873158],
              [75.359345709179834, 32.218804887561973],
              [75.364666466446863, 32.220106989010326],
              [75.367598979482722, 32.223258631426582],
              [75.372932221087481, 32.226396919019052],
              [75.375480522345782, 32.232259571403887],
              [75.378168971818113, 32.23518246655815],
              [75.378705328955093, 32.23878462784355],
              [75.375428044999197, 32.244680627428615],
              [75.37200773749754, 32.249475166574221],
              [75.373689679679757, 32.259154369289142],
              [75.378216304032108, 32.26231906680983],
              [75.381037342931734, 32.264554540026992],
              [75.382093722379793, 32.269300020820971],
              [75.379249299779772, 32.272352268071451],
              [75.376169415372772, 32.27495774147669],
              [75.371421381893711, 32.279070226449413],
              [75.367154450953635, 32.278635318232411],
              [75.357585793260995, 32.275979071939062],
              [75.349100722632727, 32.278046178190351],
              [75.352070212833766, 32.286845047247986],
              [75.342036025326465, 32.291653234244286],
              [75.33219927253667, 32.293747133525748],
              [75.327975304421074, 32.296018634149675],
              [75.327218927054162, 32.300178726973002],
              [75.331753642558766, 32.304815861631333],
              [75.334544690528773, 32.310815179695297],
              [75.338968078475048, 32.314718724662008],
              [75.340447368775031, 32.31808484694303],
              [75.337699478811018, 32.323310206165402],
              [75.334803684290435, 32.326493625382923],
              [75.339599536046691, 32.342424232743404],
              [75.324682897659045, 32.341328093443586],
              [75.318017182560368, 32.334533149319753],
              [75.312100261047632, 32.335581276511931],
              [75.309398696827003, 32.337840630282656],
              [75.305376026009412, 32.337798986142815],
              [75.303130648424712, 32.343690572842554],
              [75.300425170885177, 32.346156809178346],
              [75.2971215372025, 32.347710719872047],
              [75.292355550522942, 32.349052858289674],
              [75.289074994745491, 32.351721067651333],
              [75.291641874220872, 32.35925745221968],
              [75.290240666620477, 32.363331427595675],
              [75.286982981513546, 32.366253185917117],
              [75.277315058879552, 32.36705258870068],
              [75.27304253665281, 32.367236893746551],
              [75.265133015435964, 32.363803198062939],
              [75.260507761657124, 32.363915929846456],
              [75.258073102968325, 32.366408332026694],
              [75.256383977392332, 32.371401605591309],
              [75.257111103676166, 32.3766319142673],
              [75.257296436162179, 32.381692119565741],
              [75.254982106097643, 32.385063616324352],
              [75.248921854019812, 32.384721519083996],
              [75.243880336232465, 32.380554347452204],
              [75.239621917740152, 32.37983896212166],
              [75.235294486139523, 32.383210158182365],
              [75.232299622793576, 32.386574097738688],
              [75.226385545916983, 32.387202581572147],
              [75.222893255770927, 32.387856923824089],
              [75.22038691608175, 32.392818501931565],
              [75.216617695433243, 32.395273838864682],
              [75.211547309993918, 32.394317382645625],
              [75.20727444624498, 32.392906145887096],
              [75.200423832122553, 32.391143268038647],
              [75.197098896126533, 32.393024382788361],
              [75.192455550158726, 32.397269462289223],
              [75.192899024594325, 32.402979955208259],
              [75.19902583312934, 32.405774429374347],
              [75.201406403583434, 32.408064591176448],
              [75.19941806355024, 32.414417492061659],
              [75.195085312387704, 32.41642565964893],
              [75.18966228454272, 32.419991846463716],
              [75.181634556684955, 32.420133580802862],
              [75.174162696183387, 32.417993652520799],
              [75.169612101697652, 32.418402981976271],
              [75.164826199098712, 32.41675562847103],
              [75.161897684030876, 32.414667811345588],
              [75.157386970592754, 32.412812973929938],
              [75.152291852150782, 32.413217594171094],
              [75.147243252744673, 32.411103476046883],
              [75.143816628027849, 32.409470593032957],
              [75.140290822334123, 32.405827563151455],
              [75.137745327365963, 32.403718627534175],
              [75.132403038586574, 32.402755353922053],
              [75.131013997736488, 32.405906077976198],
              [75.12867159594451, 32.416574293921514],
              [75.129138130739207, 32.420899132463234],
              [75.134456934602937, 32.421654266679347],
              [75.137007700278588, 32.425031532923057],
              [75.130439582148341, 32.428630406523958],
              [75.127080606701099, 32.430877438401765],
              [75.123243698177603, 32.43538362915784],
              [75.121560963216851, 32.439682974725812],
              [75.121979448675418, 32.44504829173885],
              [75.12118551111331, 32.44831885977932],
              [75.119495230057041, 32.451463466357865],
              [75.115196128125348, 32.453188542151622],
              [75.112187398550262, 32.455258441975651],
              [75.111008717153894, 32.460234034171208],
              [75.110123334922818, 32.463965053413887],
              [75.109753747509089, 32.469320119495677],
              [75.108022920181241, 32.473202633571816],
              [75.101864891526589, 32.473570747454701],
              [75.095622944044351, 32.466661583200917],
              [75.090841510546099, 32.464664229854549],
              [75.086794822297662, 32.465631836967027],
              [75.080016496734657, 32.470125780660446],
              [75.076495620159093, 32.472116724298374],
              [75.068905945153233, 32.474821134286522],
              [75.064641226463863, 32.475833733836154],
              [75.057681940544356, 32.475310780026277],
              [75.05393250614128, 32.476397006067927],
              [75.048702105529841, 32.482456834584482],
              [75.041727286467335, 32.484197709015199],
              [75.036007951235277, 32.488699945986944],
              [75.033263680173931, 32.492732589164071],
              [75.028409520898904, 32.491725352498136],
              [75.021906622199808, 32.484417955536031],
              [75.019758144706955, 32.479981788021803],
              [75.018068071870303, 32.474369598277391],
              [75.017831666067067, 32.471042665544587],
              [75.017925516271703, 32.467556562224225],
              [75.011676395615979, 32.458378310932822],
              [75.006367637395968, 32.45422521009796],
              [75.003740304383285, 32.452113283757541],
              [74.998681595830575, 32.450481641585853],
              [74.992572904699514, 32.448372935443224],
              [74.983475958145164, 32.447335314273481],
              [74.978659425679368, 32.44727741114253],
              [74.975422456762033, 32.448622678318422],
              [74.970875489752558, 32.448774036693152],
              [74.962531123496959, 32.449593109734415],
              [74.959637754694, 32.447271063006234],
              [74.955492714190953, 32.442113555178068],
              [74.950406957351433, 32.440570277778797],
              [74.946595414932716, 32.443457084003832],
              [74.942934620787454, 32.452511222121515],
              [74.936038333205332, 32.462679665634887],
              [74.929603802264054, 32.463266424418819],
              [74.92375835720199, 32.460235260811551],
              [74.91816102356664, 32.459725705879876],
              [74.914398223992123, 32.460116161685683],
              [74.911078517431832, 32.465525171776328],
              [74.906769402684233, 32.465930839505461],
              [74.904185116488094, 32.461808816204851],
              [74.89561820752003, 32.461467560929826],
              [74.891817788626568, 32.463681859449117],
              [74.887190575105492, 32.467734405353802],
              [74.882338459831985, 32.469473114949736],
              [74.878228191226, 32.472145072823871],
              [74.877901160835776, 32.476251867266967],
              [74.878919832403767, 32.479683233146609],
              [74.87646626202806, 32.482583197932811],
              [74.870516005427334, 32.480681870424434],
              [74.863861267335039, 32.481288530074252],
              [74.859773962832534, 32.484190905070044],
              [74.856017688566865, 32.484140940868755],
              [74.850725791699745, 32.482014509088422],
              [74.839406910141861, 32.485722803410546],
              [74.829328728139828, 32.486027932580008],
              [74.824866876469315, 32.48848527441254],
              [74.817346297140077, 32.488847784841667],
              [74.81456680425687, 32.483682469497232],
              [74.813529394004718, 32.47856281370985],
              [74.810932902415345, 32.476474241171317],
              [74.807214310420918, 32.474621610829068],
              [74.802341645158108, 32.475917711586966],
              [74.795536113508746, 32.469475336426996],
              [74.789626104585068, 32.469626382160008],
              [74.784261021157775, 32.469759914442776],
              [74.779969008464775, 32.470602480579529],
              [74.77486665535065, 32.472472946214289],
              [74.768339199413077, 32.474786648247047],
              [74.763740555108939, 32.474722944643567],
              [74.758984105596582, 32.474426830823155],
              [74.754718294479332, 32.472774520446244],
              [74.751842308668103, 32.469777953793894],
              [74.744312249534644, 32.470573875276919],
              [74.740005915881852, 32.4721092270089],
              [74.736238330717342, 32.473882051105342],
              [74.728718541946847, 32.474238296255777],
              [74.725257561953427, 32.471903245046811],
              [74.721543838912922, 32.471159924995767],
              [74.71592007381841, 32.470642401049112],
              [74.711885968638811, 32.472177596140739],
              [74.708713686120674, 32.481673839891073],
              [74.70626996350957, 32.483902518485813],
              [74.698986152694332, 32.485854713760517],
              [74.695556821552543, 32.483313314146315],
              [74.69210285687825, 32.481900029468413],
              [74.686480105608553, 32.481358818432959],
              [74.682131939317955, 32.484716821450569],
              [74.682721508589125, 32.495186272755831],
              [74.679593630200003, 32.503756821232081],
              [74.681093570345141, 32.511101338372825],
              [74.687570532525115, 32.517519681054402],
              [74.689129081308621, 32.520959851554537],
              [74.688496086814681, 32.525038869737237],
              [74.684165097226995, 32.526339365117913],
              [74.677686324401421, 32.528742562978806],
              [74.673616636037195, 32.530509595081696],
              [74.670109301669527, 32.532722480266628],
              [74.663037504165743, 32.536039117919024],
              [74.660251098654356, 32.541356810217344],
              [74.664651617292947, 32.546868807172707],
              [74.669205647952467, 32.549082061937348],
              [74.670459974451575, 32.552724938229169],
              [74.668186894960286, 32.55952881927842],
              [74.661629147889016, 32.560450448832086],
              [74.658177951359633, 32.558809341067757],
              [74.653724534297282, 32.558166422925481],
              [74.649614291251012, 32.566627879264935],
              [74.648040244767884, 32.571292917615992],
              [74.647237726678071, 32.578070193849683],
              [74.650662692537935, 32.58700995004213],
              [74.649510873114821, 32.591081122541368],
              [74.644385965638918, 32.592368126298666],
              [74.640841813309294, 32.593679413403912],
              [74.634756713575186, 32.602666870078039],
              [74.635833328278252, 32.6081542861385],
              [74.642221176932281, 32.610139457781351],
              [74.646118621985266, 32.610104711489925],
              [74.649301171129395, 32.612874164908085],
              [74.65098238613642, 32.626751997238514],
              [74.652143821414469, 32.62974601204035],
              [74.655903251871067, 32.629800500841107],
              [74.663632948826205, 32.630350933811727],
              [74.665818294068927, 32.635089998124052],
              [74.669202081648507, 32.639895424562695],
              [74.67385135867741, 32.642892583173968],
              [74.678107754360838, 32.643992521292468],
              [74.683183154768301, 32.644941749875692],
              [74.691074128532762, 32.651888123335752],
              [74.692645368337523, 32.654865446395057],
              [74.689865460079957, 32.659811234458758],
              [74.686335297101948, 32.660454878386957],
              [74.679225254014881, 32.667624496407569],
              [74.667105766696167, 32.669507644653379],
              [74.664084758512757, 32.671727474163532],
              [74.656581923564019, 32.684314890056569],
              [74.650353709608879, 32.69832992991838],
              [74.651394330792542, 32.701852681985187],
              [74.653205009090996, 32.705065788220729],
              [74.655443170171409, 32.711144143026189],
              [74.658516026865755, 32.717766538783906],
              [74.658393781291537, 32.722081880035979],
              [74.658833475749375, 32.726865606638519],
              [74.663557520989087, 32.737780765866269],
              [74.665373832849099, 32.740807052179129],
              [74.667750631122459, 32.74312765257843],
              [74.670517554143188, 32.746327621826033],
              [74.673956795919963, 32.761148289130482],
              [74.679580332601333, 32.773504931891431],
              [74.682070499128244, 32.781940300011584],
              [74.685738821699587, 32.788916662925423],
              [74.690085070321857, 32.796131791807518],
              [74.692961361776739, 32.799356078416018],
              [74.69603020616529, 32.802561419251596],
              [74.700005053416277, 32.810578542971932],
              [74.702993845788455, 32.821304420992206],
              [74.703617982114125, 32.829019628687035],
              [74.702742185378767, 32.832884320112854],
              [74.689003011435133, 32.833128590368432],
              [74.685413986544404, 32.831208456653954],
              [74.679673715343981, 32.830274190301211],
              [74.675863721328767, 32.828489692650322],
              [74.671150608980355, 32.825537224060561],
              [74.664273945740433, 32.821654635156342],
              [74.660761022685563, 32.822505394841912],
              [74.656889113885939, 32.827225223316326],
              [74.65314407027526, 32.827403701319255],
              [74.649964762768249, 32.825534911803715],
              [74.638126778999137, 32.81403532134955],
              [74.634919857285865, 32.812164925654656],
              [74.633138449764644, 32.807570958558948],
              [74.632341696998594, 32.80165103772223],
              [74.635835150113479, 32.79558622625192],
              [74.641033259268298, 32.79134585662095],
              [74.647667309670467, 32.7888338128123],
              [74.653296075896051, 32.783561030372923],
              [74.653386815510899, 32.77947710813865],
              [74.649950000914046, 32.77693692641904],
              [74.645912773991768, 32.776879371455948],
              [74.641570816088873, 32.778177749949727],
              [74.636224594552488, 32.778100827626133],
              [74.631476818841833, 32.774385311697877],
              [74.629236528857874, 32.76595306509131],
              [74.63243781713561, 32.758243606255441],
              [74.635221921026442, 32.750829447750675],
              [74.632604098437554, 32.748299821706198],
              [74.627524964284333, 32.747301572605195],
              [74.624254940847692, 32.749541126411678],
              [74.62015756049405, 32.752203524078276],
              [74.616594781212413, 32.755337690955095],
              [74.612563278530956, 32.755047488383525],
              [74.605935467243995, 32.751304414911921],
              [74.600584275703369, 32.751455854504194],
              [74.594911886875906, 32.752527913861542],
              [74.592812941129566, 32.749979751915077],
              [74.588881510005237, 32.746530970372646],
              [74.581588893730043, 32.746861599766262],
              [74.575544997358278, 32.745086169072522],
              [74.571774370406033, 32.74653115667828],
              [74.57105925678222, 32.750351095236589],
              [74.568812365820946, 32.75440298298372],
              [74.562830461650393, 32.75703680174859],
              [74.556932747325519, 32.757180653792872],
              [74.548683452148524, 32.749301657312422],
              [74.543826758891598, 32.743366792174371],
              [74.540063795788029, 32.74330979176235],
              [74.534932437997554, 32.74457243800952],
              [74.531258212695136, 32.741793504407873],
              [74.526677919012911, 32.740454993246097],
              [74.518583067701712, 32.743631867414756],
              [74.514547035431789, 32.743571126710194],
              [74.509311830845604, 32.738760244271845],
              [74.507252649715255, 32.743968961357353],
              [74.50879027522187, 32.748260927619505],
              [74.502370806828893, 32.759056763066631],
              [74.496376706664989, 32.762174566034737],
              [74.486731983732682, 32.761564709261698],
              [74.482951589393579, 32.762199578110504],
              [74.47390908044801, 32.770668832127882],
              [74.470069135302552, 32.77266349095472],
              [74.464962954635055, 32.772814866969163],
              [74.460941215956467, 32.773213090151742],
              [74.458454260671047, 32.776799808759684],
              [74.458618677472018, 32.780194793620602],
              [74.456656017635694, 32.783579921505954],
              [74.44970462564504, 32.783240081180971],
              [74.44571542588875, 32.781148258529754],
              [74.439879392719405, 32.779809760798393],
              [74.433662054301095, 32.77959809101938],
              [74.42877286152904, 32.78088210376081],
              [74.423655160197484, 32.782601493729516],
              [74.415840945148503, 32.784093370375359],
              [74.410210415321131, 32.783313754348931],
              [74.406456866339695, 32.782792391439258],
              [74.403030616196688, 32.780015337334049],
              [74.397220653388672, 32.766397580339238],
              [74.39101580541778, 32.767916260007546],
              [74.387184484627142, 32.768407866897597],
              [74.386203020858886, 32.764977538441677],
              [74.386859668040657, 32.760441191872602],
              [74.383673896629318, 32.757920224093979],
              [74.370766043423004, 32.759051954847358],
              [74.365075262984789, 32.76078436192995],
              [74.360225084949519, 32.761606348216645],
              [74.355681874718698, 32.76328639421591],
              [74.352356247919928, 32.765356668756034],
              [74.344708778111254, 32.770010926510501],
              [74.339779554922472, 32.774016229296912],
              [74.331675675515356, 32.776146155651624],
              [74.32848149615478, 32.778378947008576],
              [74.325385565636566, 32.781027994769737],
              [74.322225990221867, 32.788476804660064],
              [74.319188472141022, 32.792049775713956],
              [74.311942115248186, 32.791515430763745],
              [74.307834392051234, 32.795302715209061],
              [74.307699352361666, 32.799616803824939],
              [74.306010836539372, 32.802751201849475],
              [74.302192707502044, 32.80474071560517],
              [74.301551731473751, 32.808585426799382],
              [74.304900595502716, 32.815469382289606],
              [74.303109468357874, 32.821556255161639],
              [74.300115731882826, 32.823328913792331],
              [74.295233523312575, 32.825303156017668],
              [74.288730796367318, 32.827686850526085],
              [74.284366522463728, 32.829646048898226],
              [74.27603713815347, 32.829738086883459],
              [74.264474562163983, 32.830239344686021],
              [74.25626243963336, 32.836448373768],
              [74.244286093658459, 32.84240908842861],
              [74.237806393667626, 32.842737694249593],
              [74.232858892030549, 32.843970008065682],
              [74.225990671667688, 32.843438380929427],
              [74.222001988644521, 32.844594511606751],
              [74.217340523456883, 32.845323330600117],
              [74.21467744273005, 32.850121672185459],
              [74.213975046963682, 32.854033323387647],
              [74.212953799700756, 32.858676150478544],
              [74.209442338045164, 32.859285560327272],
              [74.206429234820604, 32.861726584280412],
              [74.20500953526394, 32.865925289222524],
              [74.202425969235321, 32.870749649189563],
              [74.191394503889128, 32.871691623855156],
              [74.187311398659148, 32.873238257232472],
              [74.18126689043585, 32.879824415826235],
              [74.17817816825405, 32.883048296777972],
              [74.174111406901318, 32.883969837060285],
              [74.16363847969528, 32.884390308388227],
              [74.159386270491083, 32.886117084860992],
              [74.155753980669942, 32.888129927217058],
              [74.152218296431357, 32.889637725897813],
              [74.143577246753637, 32.889947508948602],
              [74.132755999208214, 32.893151933720418],
              [74.128660004625772, 32.895133211119322],
              [74.122710717265747, 32.895928284685162],
              [74.113323055127552, 32.89553482263775],
              [74.108673849164418, 32.897760135322244],
              [74.103579024827866, 32.899284133969708],
              [74.098346101715705, 32.901868194284269],
              [74.094045357820931, 32.902253569151341],
              [74.085916480733701, 32.904831913459518],
              [74.081731229326351, 32.906050379088676],
              [74.070001852158484, 32.906348565009111],
              [74.066734793992737, 32.907905982291012],
              [74.061040044334916, 32.909372865372177],
              [74.055318170294782, 32.911786733180961],
              [74.052769945195109, 32.916055162542243],
              [74.052563366159205, 32.924679134548136],
              [74.052288272474115, 32.930740956049668],
              [74.048526375337389, 32.932404021781387],
              [74.043066657246897, 32.932214333516363],
              [74.039496731815873, 32.930811387133048],
              [74.033328486827585, 32.92954590459307],
              [74.027448318917735, 32.929694983602324],
              [74.017460670377702, 32.930181940002008],
              [74.004921540801163, 32.932008548833288],
              [73.997092280967593, 32.93348014886233],
              [73.992608159864389, 32.933560753983024],
              [73.988227361319943, 32.935786419189199],
              [73.988127428246244, 32.939384258001681],
              [73.989923932041421, 32.942600007064897],
              [73.99493184740318, 32.946335901879372],
              [73.997837474917745, 32.95194946241044],
              [73.998766202082635, 32.954918692967532],
              [73.99725283182562, 32.960217925580793],
              [73.993159650645779, 32.961966139741669],
              [73.987984655392395, 32.963232514214468],
              [73.983645984183596, 32.963938492717787],
              [73.979322996203564, 32.966027832606116],
              [73.972283499905117, 32.967511162814304],
              [73.968490357696595, 32.969241350617857],
              [73.965702368317622, 32.972143261099532],
              [73.962857778259448, 32.977073199561076],
              [73.961273064452698, 32.983894334697588],
              [73.958287365428532, 32.986997991398276],
              [73.941567642878582, 32.988488889838827],
              [73.937181703272671, 32.986953677998336],
              [73.933589899495445, 32.985388474872238],
              [73.929032134386986, 32.98507275247384],
              [73.925474550003685, 32.986158369040048],
              [73.915820631637132, 32.993959954804026],
              [73.912098273506416, 32.995041848939088],
              [73.907517225254523, 32.996525499455871],
              [73.904659392517601, 32.998915759940331],
              [73.896779330324208, 33.001951538215813],
              [73.892761824690609, 33.002843577215558],
              [73.885222952754901, 33.002541166518313],
              [73.878231415090241, 33.002246836031183],
              [73.873380321088689, 33.002638523144505],
              [73.868766546524412, 33.002343488319859],
              [73.863746262558195, 33.001994412708257],
              [73.859846083455523, 33.003512206677101],
              [73.852362047950351, 33.005121197252905],
              [73.845800814923138, 33.005965342642725],
              [73.841428766110838, 33.007725734589435],
              [73.83121389919441, 33.007299274853878],
              [73.823984213799648, 33.005776686131711],
              [73.820919813762401, 33.00117398146012],
              [73.816257242835164, 32.993218053898744],
              [73.815651991868535, 32.986795637506809],
              [73.813740847263489, 32.97923789818649],
              [73.811135523080182, 32.97669714248201],
              [73.808303038911973, 32.97258272330884],
              [73.799996108555334, 32.970576114984738],
              [73.796653956291479, 32.968942712883731],
              [73.793661742284129, 32.966600907204956],
              [73.788039660693101, 32.965360137529316],
              [73.781723467762376, 32.970012042349062],
              [73.780031500776616, 32.972701190830236],
              [73.781681583153841, 32.97976912489402],
              [73.787397533456257, 32.987146046804774],
              [73.789092380800668, 32.990847678670548],
              [73.789881503965958, 32.994691208273522],
              [73.78867462240143, 32.99851843765822],
              [73.782258030888869, 33.006560313044965],
              [73.777311935885464, 33.009207293066552],
              [73.773174770627335, 33.013185634242788],
              [73.762128643938439, 33.022287802717436],
              [73.757558065628089, 33.026971955623146],
              [73.754634047118429, 33.029636050359727],
              [73.751388105804523, 33.03116312066102],
              [73.743320146102292, 33.039398811146881],
              [73.740238902185141, 33.043651094607817],
              [73.740432368973117, 33.055461962530778],
              [73.738561352455434, 33.063127654088241],
              [73.735226585829849, 33.066705389190346],
              [73.730865502707658, 33.067978995031559],
              [73.725177781603335, 33.069666574779788],
              [73.721349042364238, 33.071434671063493],
              [73.716973493286744, 33.074069149730114],
              [73.713959500652493, 33.076038867763572],
              [73.709863563755263, 33.077547882583964],
              [73.702711753178434, 33.082408882486902],
              [73.698623414102968, 33.083688348650021],
              [73.692614185910571, 33.086957210308036],
              [73.688517356580249, 33.088488376776056],
              [73.682782683006508, 33.088973950531084],
              [73.67497471149818, 33.089231053744342],
              [73.670993770084394, 33.088782676393436],
              [73.665105148372376, 33.088018562621592],
              [73.658181556396158, 33.085363191975404],
              [73.652547086094799, 33.085250205188842],
              [73.643554695207015, 33.08845705651207],
              [73.636625150800896, 33.087785414101901],
              [73.632807683424502, 33.086439362429296],
              [73.628977132828382, 33.089082904730127],
              [73.625405987525681, 33.100147274048247],
              [73.625589711757456, 33.11193358510269],
              [73.629327294540943, 33.122962984017775],
              [73.630361603184213, 33.127595717642684],
              [73.62873386891853, 33.132427084138712],
              [73.625135353728623, 33.134613543318331],
              [73.626060884536173, 33.140095470901322],
              [73.636246039792539, 33.141871248552967],
              [73.639137079110469, 33.143982171824454],
              [73.645422303767873, 33.158635760356489],
              [73.646385845851256, 33.162043621652302],
              [73.653574094770022, 33.1651642021017],
              [73.656404212983603, 33.169301481463194],
              [73.655745606198479, 33.172930592077122],
              [73.655859332669124, 33.178141570081287],
              [73.659162320251113, 33.184779763696248],
              [73.656447044145139, 33.194706823780962],
              [73.658126758804741, 33.205182178301996],
              [73.657096638779478, 33.209265136069369],
              [73.653187417782391, 33.213472720569932],
              [73.649114083419974, 33.214083262315704],
              [73.645237864556535, 33.217185425715144],
              [73.641721576918584, 33.226403204318657],
              [73.637415838885317, 33.226545045664366],
              [73.63515411469254, 33.222582062979853],
              [73.634241078605498, 33.216661333241341],
              [73.631364385361735, 33.21399930568198],
              [73.626143165452788, 33.220738458767279],
              [73.627259989949422, 33.231548878478662],
              [73.626280596026845, 33.234915751229174],
              [73.623987008841553, 33.237266893444961],
              [73.615031094289307, 33.243329856422491],
              [73.610802166431185, 33.249813177498133],
              [73.60558995142334, 33.251756438302742],
              [73.60530826526923, 33.260809761333903],
              [73.603044503458136, 33.264841338316032],
              [73.600744805808233, 33.268196119899748],
              [73.599063831141905, 33.272093166365529],
              [73.598341977286566, 33.278633333050706],
              [73.597950376196493, 33.282772144262502],
              [73.59915576259101, 33.28585480728502],
              [73.600613323531945, 33.289159122180806],
              [73.602606440524312, 33.291819898574566],
              [73.604056495701883, 33.295346419719678],
              [73.599520587243305, 33.299184176904703],
              [73.594190267616426, 33.303438654809014],
              [73.589713578098028, 33.305313596266686],
              [73.588261531789342, 33.310087316337217],
              [73.587386162381065, 33.313126713681285],
              [73.587771697926343, 33.317499484384001],
              [73.586041758506141, 33.322922519927268],
              [73.582026505609136, 33.326551664283699],
              [73.585823215269926, 33.329904962568015],
              [73.590421467138228, 33.332400890861152],
              [73.590800823113241, 33.33699572676823],
              [73.588092599764266, 33.340435960311595],
              [73.584186315937103, 33.340571644590952],
              [73.580077109777662, 33.338958988327207],
              [73.57782413049317, 33.336294384993224],
              [73.575023627587257, 33.334267912989766],
              [73.571284760398839, 33.337465284345413],
              [73.569451708100758, 33.340449398496432],
              [73.565792627273481, 33.342562343746458],
              [73.565607900499089, 33.345831485035099],
              [73.567391317668111, 33.351905423759455],
              [73.570287443620273, 33.354890892798785],
              [73.570701233150473, 33.35831039995967],
              [73.567113515929364, 33.360724480021233],
              [73.562196873167807, 33.362694494645822],
              [73.558502129334926, 33.368494789300925],
              [73.558887442220822, 33.373709722493572],
              [73.560450413810884, 33.378947475178506],
              [73.563100605643385, 33.385362008358648],
              [73.563428593222596, 33.391496038077555],
              [73.564874231286211, 33.394383252760008],
              [73.567488081493806, 33.398376337758464],
              [73.572040654880638, 33.400254233135215],
              [73.573307366307404, 33.405044913207782],
              [73.573916468379835, 33.4083305639233],
              [73.578433178972105, 33.411249006125395],
              [73.582225739749418, 33.414753339904046],
              [73.584403669516277, 33.41881484332643],
              [73.587327697469703, 33.421703015580697],
              [73.59139113693395, 33.422231460341067],
              [73.591108301329214, 33.425649317224625],
              [73.586285875482815, 33.426740917233296],
              [73.582652097276508, 33.429491016394408],
              [73.584298588847062, 33.433543836656177],
              [73.58762523598449, 33.43495071988162],
              [73.587130027603251, 33.43940711760419],
              [73.587884304026517, 33.443589929089285],
              [73.594600120765563, 33.444471420043797],
              [73.599704447838761, 33.445764855255746],
              [73.604440235133083, 33.447498472930931],
              [73.608834883653827, 33.450620736911027],
              [73.61179971706315, 33.452363240407372],
              [73.618014598141613, 33.452028636818397],
              [73.620847806253167, 33.454482065697796],
              [73.624869102044855, 33.45760561360327],
              [73.624341035844523, 33.465748269376469],
              [73.620196278204659, 33.468382527582833],
              [73.61494544841608, 33.47214463362598],
              [73.614219745995157, 33.478691935402232],
              [73.610101606715133, 33.480427909758667],
              [73.605913836855549, 33.4764965532856],
              [73.601515698126917, 33.478434077491926],
              [73.60067957327071, 33.485854549404955],
              [73.598493407751718, 33.489035736071642],
              [73.595938442396829, 33.492598087773843],
              [73.597681501587587, 33.497424540622376],
              [73.596514067979399, 33.500531657875605],
              [73.596996194020335, 33.503560035246387],
              [73.600132648518937, 33.505097525813767],
              [73.603996580468007, 33.502758774005393],
              [73.609490953480091, 33.500912383155665],
              [73.609307310246678, 33.505054186183742],
              [73.60552272116071, 33.514558857621168],
              [73.606486084572296, 33.51888494491503],
              [73.613978684499727, 33.520855340688442],
              [73.617187004058451, 33.522763822330795],
              [73.620068414565011, 33.524619593122672],
              [73.623737175570724, 33.52853990898376],
              [73.632089272004251, 33.529376084207655],
              [73.633086493696368, 33.533564943422597],
              [73.630943883364921, 33.537965226939583],
              [73.625815394952411, 33.540348072717727],
              [73.622506082070871, 33.541663500342089],
              [73.618942221008908, 33.544078698373518],
              [73.618681314265416, 33.552454952066789],
              [73.621542782711771, 33.569988410050165],
              [73.620970461552844, 33.574259761156327],
              [73.619519084398064, 33.57763817897893],
              [73.616448462180884, 33.580061794886319],
              [73.61366594845137, 33.58295148008434],
              [73.610360637170999, 33.584934188019972],
              [73.607866493910407, 33.587370479503853],
              [73.600892085143116, 33.593328729447272],
              [73.605393468518585, 33.604978795430029],
              [73.603713966975846, 33.607682553771077],
              [73.596189387061557, 33.604811981931036],
              [73.59026485619242, 33.604461363621787],
              [73.582881225290592, 33.611998531780948],
              [73.579410594843949, 33.614850727294765],
              [73.573333688345656, 33.618384939953913],
              [73.569815222875121, 33.617484521580529],
              [73.56444840086121, 33.616820489070363],
              [73.561331651793225, 33.621521904007984],
              [73.562864668388556, 33.626066040608414],
              [73.567118690001109, 33.635016126166462],
              [73.569096721351386, 33.641157540661005],
              [73.568317583369492, 33.648415841071021],
              [73.561845914221195, 33.664372007812915],
              [73.562644994805353, 33.673896753207352],
              [73.565174069560868, 33.679173113949318],
              [73.570798405790811, 33.682212302542695],
              [73.574575017649181, 33.687192237077369],
              [73.58319195147395, 33.692202988191738],
              [73.59109373533245, 33.698947570080698],
              [73.597592565444756, 33.716296204641388],
              [73.598176626978116, 33.723096633132691],
              [73.597463461482491, 33.728307341124058],
              [73.593948809020858, 33.73684080462256],
              [73.592790646122353, 33.7483460040797],
              [73.591257690239317, 33.754207396015971],
              [73.587877039841928, 33.758440376162987],
              [73.579423139674233, 33.760336928577885],
              [73.576232767637833, 33.762872921493049],
              [73.571115805850795, 33.766265409417187],
              [73.566403317628044, 33.769090327739612],
              [73.560484585539484, 33.776905106951425],
              [73.558344075505531, 33.783649638255945],
              [73.559128707588997, 33.791904009777092],
              [73.561277177085316, 33.802302222298231],
              [73.567648363493944, 33.823713855061627],
              [73.570491297837691, 33.827843910965548],
              [73.57050271537102, 33.832721546422867],
              [73.571213784913411, 33.836372869426846],
              [73.572732000779368, 33.839762789474833],
              [73.572813410213456, 33.845882210420235],
              [73.574580951198982, 33.849209603187589],
              [73.578720615931417, 33.85157116793318],
              [73.580126070159366, 33.857695183898606],
              [73.582432316622999, 33.862274036329694],
              [73.585637139208174, 33.864618136516171],
              [73.585514617505638, 33.869400010547295],
              [73.586029062462174, 33.877529457667421],
              [73.589863478080588, 33.884395357632044],
              [73.5861361165923, 33.899497623385187],
              [73.57899878299078, 33.910875413446369],
              [73.57462313094797, 33.912396450237807],
              [73.569893136515304, 33.916462249538462],
              [73.566512359210293, 33.918783367986094],
              [73.560721828416646, 33.923194984519988],
              [73.549569261831408, 33.931564999981461],
              [73.543519457256053, 33.943214728457406],
              [73.537005428540496, 33.952117309053989],
              [73.535658423085479, 33.956321774194791],
              [73.528140675397069, 33.974125051504934],
              [73.522093723740085, 33.985541452962785],
              [73.516454519432244, 34.000578019469643],
              [73.514907598301818, 34.006660184927625],
              [73.51507928412488, 34.01333180784593],
              [73.515618793871127, 34.017988220225007],
              [73.514920718965612, 34.023398549121445],
              [73.514267177512579, 34.026557653089981],
              [73.509591119904542, 34.036415246494876],
              [73.508306210175746, 34.042045112538382],
              [73.509103683200905, 34.051555955334862],
              [73.50826753759948, 34.060365636215757],
              [73.506262333588793, 34.064392595855843],
              [73.505860248674608, 34.069166413140799],
              [73.503952134460491, 34.076112980546853],
              [73.499972811845993, 34.07970957195181],
              [73.497444216594673, 34.084482783583269],
              [73.497238564918732, 34.088271152113578],
              [73.496343665554306, 34.092940484050189],
              [73.496690344207593, 34.099269995013408],
              [73.498625505742027, 34.107700802439219],
              [73.49558876796624, 34.116232784486151],
              [73.492746827389027, 34.120447995463657],
              [73.493334978612864, 34.125309218811111],
              [73.495287473389865, 34.13408463764884],
              [73.494056638428106, 34.139713072190773],
              [73.491230642990274, 34.141676247462769],
              [73.488975421958926, 34.144821511243045],
              [73.491957461737741, 34.155893761985311],
              [73.491267552771546, 34.166128426684352],
              [73.488784941984704, 34.176231848785328],
              [73.488461994622838, 34.186176109416898],
              [73.489303694304297, 34.193455188882709],
              [73.489191949317188, 34.205423619902646],
              [73.4924275408911, 34.213855544467172],
              [73.493049198334234, 34.220209846604369],
              [73.489497658465496, 34.226660264926629],
              [73.484948948752191, 34.22883988839429],
              [73.47787365401679, 34.234825083629758],
              [73.474538670928737, 34.245599023929081],
              [73.469996724312637, 34.251819778624196],
              [73.470334007796779, 34.262671371288519],
              [73.476787601007402, 34.276681929465674],
              [73.478425494779003, 34.28071226696094],
              [73.478774499412353, 34.288646025668008],
              [73.475901947961503, 34.295362190564937],
              [73.472617324934291, 34.29687761535012],
              [73.467749118112934, 34.296084613113877],
              [73.464077006858247, 34.288337069741402],
              [73.461651201354599, 34.28217410474349],
              [73.458086882400792, 34.280445256817231],
              [73.453787753286434, 34.278355369984283],
              [73.454378238663139, 34.288131632900878],
              [73.453860320189875, 34.296365899071354],
              [73.449843266832247, 34.305010149858482],
              [73.446952459332437, 34.30717681164456],
              [73.444417864635085, 34.30939762172828],
              [73.442802333963044, 34.318182880007754],
              [73.43920146245047, 34.327569744091306],
              [73.435886332533428, 34.330002288160088],
              [73.43307446061516, 34.332215584219469],
              [73.42411472206544, 34.339718631713566],
              [73.423705093311753, 34.343751590584873],
              [73.426226258838113, 34.34947931397982],
              [73.425013544122208, 34.353516846524641],
              [73.41852747845428, 34.35223104124136],
              [73.413550511287838, 34.354651409001995],
              [73.408374463379175, 34.354747200457631],
              [73.404995024856674, 34.35738406246184],
              [73.40141979710458, 34.358432562057509],
              [73.398283053670923, 34.366219650180618],
              [73.397263562661877, 34.369435557279829],
              [73.390807060658119, 34.374717099458856],
              [73.39185470477544, 34.3781373645242],
              [73.39385957034095, 34.38109664077075],
              [73.400358108131712, 34.382843479441007],
              [73.403561338209926, 34.384703966528107],
              [73.408686672395433, 34.386168056382623],
              [73.410686488274663, 34.390965337591751],
              [73.411769666672996, 34.400033941088076],
              [73.42014593331551, 34.417825282794077],
              [73.420318599642428, 34.42097418526091],
              [73.422677940875403, 34.431632056817321],
              [73.42455068791368, 34.437802882671214],
              [73.425341340861365, 34.442341045923605],
              [73.423638590350336, 34.45282014748048],
              [73.423345667781504, 34.459976795002007],
              [73.422452575922279, 34.463515096561089],
              [73.422213122050266, 34.470742084984771],
              [73.425269396343282, 34.477143791085403],
              [73.434362035380147, 34.491108523234061],
              [73.437464070832107, 34.504510046977956],
              [73.436449734002437, 34.508415197148132],
              [73.435315781141838, 34.511696396055939],
              [73.43044640825056, 34.519050951343154],
              [73.430768952450464, 34.526058156665918],
              [73.434907353073456, 34.532458556777691],
              [73.441247671945263, 34.538469388818775],
              [73.442825312139945, 34.565398416519592],
              [73.447714100630989, 34.574290337430533],
              [73.450914047462362, 34.576424262952308],
              [73.454566704546721, 34.57744270264422],
              [73.46041158831656, 34.57841271125038],
              [73.469256533770888, 34.574079841570963],
              [73.475792873199723, 34.574217385570051],
              [73.483149887264574, 34.575495436015849],
              [73.486928195966343, 34.576949372542522],
              [73.49110006001456, 34.578185314826094],
              [73.497149238546442, 34.580537688675811],
              [73.501548181375426, 34.579940644763816],
              [73.509274508983623, 34.576726501037065],
              [73.517504035486226, 34.575084750177091],
              [73.522974135826018, 34.574762298939056],
              [73.526787767732017, 34.575943310545085],
              [73.534090492831865, 34.577241305170496],
              [73.537526036906613, 34.580708847186635],
              [73.541231525765852, 34.581838863186597],
              [73.544707221096417, 34.585812732833311],
              [73.54737706433427, 34.588115154470366],
              [73.553505628473403, 34.593220504384568],
              [73.55732223895626, 34.593504915712806],
              [73.563085045782017, 34.591833665451063],
              [73.56833736470773, 34.589691213199295],
              [73.577929271340707, 34.588786077222593],
              [73.586379933928868, 34.588016295819315],
              [73.592860182897866, 34.589961034785098],
              [73.597513961140251, 34.59005513413711],
              [73.602445559720366, 34.589237465583679],
              [73.607988142883514, 34.586642064207332],
              [73.61591040643421, 34.586801800840881],
              [73.620614068179151, 34.583522100421575],
              [73.628570775710457, 34.574641887538455],
              [73.631868187841079, 34.572894486356581],
              [73.638173145751878, 34.567147508821741],
              [73.644072947074932, 34.566369427150228],
              [73.648938770330702, 34.567592579268414],
              [73.657616898086005, 34.578159085708414],
              [73.660824718566971, 34.589053977684664],
              [73.660136390325491, 34.593352746920601],
              [73.657516917226019, 34.599151755337687],
              [73.658695266196588, 34.606702278130825],
              [73.66015830295909, 34.610493127242037],
              [73.664797728609216, 34.615495919801489],
              [73.673922353734213, 34.625244424598918],
              [73.681557117287369, 34.634779001495481],
              [73.688287463937883, 34.642183186009738],
              [73.69460983010174, 34.650290777153828],
              [73.696210887744613, 34.654107729565766],
              [73.694186655585639, 34.657691311026674],
              [73.690260122848059, 34.659105683543366],
              [73.683184447269582, 34.660112897580582],
              [73.676522665930307, 34.662965331081914],
              [73.671602229752622, 34.664242484867557],
              [73.6669100465909, 34.666191106237505],
              [73.66435144637461, 34.669078607925336],
              [73.667415346957455, 34.684714383305192],
              [73.670282728319293, 34.689748730753863],
              [73.675710589902167, 34.690061493330255],
              [73.681280082064532, 34.695607457293889],
              [73.683018299640509, 34.699518797727507],
              [73.686310327003454, 34.709675085799297],
              [73.68799688608874, 34.712552445880462],
              [73.691529272227328, 34.716772538327035],
              [73.701539022941787, 34.720593382381352],
              [73.706551916039047, 34.725416473768057],
              [73.707767152101894, 34.728306688290012],
              [73.711772037572473, 34.735863955789647],
              [73.715607283555528, 34.742311490144608],
              [73.720356119436389, 34.751378474391359],
              [73.723313059826097, 34.758054098093716],
              [73.726447085858965, 34.7626331501218],
              [73.731367197328666, 34.771510692584712],
              [73.737845297660968, 34.773906872596896],
              [73.742514792312207, 34.77917914490228],
              [73.745382178196735, 34.781687231217852],
              [73.750043955362315, 34.78721194487288],
              [73.754122962044207, 34.789102433227718],
              [73.757328833422022, 34.790516568582412],
              [73.761929399978698, 34.7908337370135],
              [73.76516225726759, 34.793144235646842],
              [73.769206743948374, 34.794368005606572],
              [73.773766091561228, 34.796932180654252],
              [73.783138279021458, 34.794634895993013],
              [73.792690758051847, 34.794588316157153],
              [73.799457101708867, 34.797651273298492],
              [73.804132525139025, 34.797281396482177],
              [73.80989031941057, 34.796038772140129],
              [73.821108357597666, 34.796020810797252],
              [73.824877190163846, 34.798131968584443],
              [73.830465611737964, 34.802525129646575],
              [73.843732800316872, 34.815865841177718],
              [73.849674599680398, 34.817765894169234],
              [73.854074287616783, 34.81738825886093],
              [73.858287312380412, 34.813868704948746],
              [73.861616736769903, 34.812119734245279],
              [73.867381668355009, 34.811537875891801],
              [73.872988124626758, 34.81638903889619],
              [73.880526977352261, 34.818798022147526],
              [73.884708015527508, 34.817292588748501],
              [73.891233044202792, 34.818307969414924],
              [73.895802506312975, 34.82063841927399],
              [73.901209772403561, 34.821885110531333],
              [73.90878415215424, 34.81638563880427],
              [73.913187849306127, 34.814883292316715],
              [73.918113829008561, 34.814537998655339],
              [73.922689955714389, 34.816639766145805],
              [73.927791072521089, 34.8207914393574],
              [73.929575714870523, 34.825339854838035],
              [73.935615506369899, 34.833565424743064],
              [73.938851935097006, 34.834999806409563],
              [73.949428284917076, 34.835168954890868],
              [73.954974299316234, 34.835498229179201],
              [73.961349378955049, 34.840815999113822],
              [73.966181306213585, 34.84473188510114],
              [73.972543404530171, 34.86320806193141],
              [73.976522668144483, 34.865892243344184],
              [73.984046344066002, 34.866073828730997],
              [73.990950396249843, 34.867525432643106],
              [73.999388802653982, 34.868777453775756],
              [74.002866865006467, 34.87154365872815],
              [74.010492720101382, 34.873053073538095],
              [74.016970074772786, 34.875873340179936],
              [74.024078580589702, 34.875999821590398],
              [74.029524722098358, 34.877013339344487],
              [74.032096772580033, 34.883361073709985],
              [74.03866492221168, 34.892943097970303],
              [74.042175146463961, 34.894584417275432],
              [74.03809538548451, 34.903314968241041],
              [74.039656294285862, 34.915075832213134],
              [74.043857316049568, 34.921909512639431],
              [74.048441318129449, 34.92400715060699],
              [74.055271729897044, 34.925271480632411],
              [74.058976405665575, 34.92895685111624],
              [74.064709872664409, 34.929699865062126],
              [74.070574117081108, 34.934727724772365],
              [74.073986206392874, 34.940034669633697],
              [74.072728028478437, 34.946315460701946],
              [74.067577094263967, 34.954566139344635],
              [74.064287922651999, 34.964911095237824],
              [74.063606492413115, 34.969390580257588],
              [74.064271330452826, 34.974488160505274],
              [74.066505105807636, 34.983186715514371],
              [74.065513466957796, 34.988828334307847],
              [74.060261454461653, 34.991670059077798],
              [74.062343931728137, 34.995807576087067],
              [74.064729286977766, 34.998070793675225],
              [74.070458847008666, 34.999041210045114],
              [74.074280623390678, 34.998649151909994],
              [74.08152494687819, 35.004204389053292],
              [74.090842525519804, 35.006243569678944],
              [74.09429906235853, 35.010037391693906],
              [74.103153817469575, 35.014726271152746],
              [74.108195932206016, 35.019554947037882],
              [74.108103648812019, 35.02294288656779],
              [74.103663590043908, 35.02554752624026],
              [74.097692886013903, 35.034242211709085],
              [74.09295021942188, 35.03573948467708],
              [74.089356092183394, 35.037946893985449],
              [74.085178032081203, 35.04011817796605],
              [74.079958213643025, 35.040716784680498],
              [74.076356112106794, 35.042212164675242],
              [74.073568107415454, 35.044429433657271],
              [74.066328652819806, 35.04858796991028],
              [74.072288178211565, 35.058425386373251],
              [74.074161376182033, 35.063154888355392],
              [74.077872602257898, 35.066815459115119],
              [74.084100046235363, 35.079107258626046],
              [74.089984603874314, 35.087774253594091],
              [74.09207647954878, 35.090627760899025],
              [74.09244952866581, 35.095237482849122],
              [74.095115617514978, 35.097550663491894],
              [74.101625702659263, 35.099677592406977],
              [74.111419089518805, 35.101905833776065],
              [74.114430327205795, 35.103737823158724],
              [74.118899646830087, 35.105079179816514],
              [74.122630493983365, 35.105142438334973],
              [74.126933472956352, 35.1052161113682],
              [74.132208991669714, 35.106603191015729],
              [74.134698603360604, 35.10995055416786],
              [74.131819178556967, 35.115564059898091],
              [74.129015151071485, 35.118349840202221],
              [74.12622287391369, 35.120779391537845],
              [74.122729258227992, 35.122490328182195],
              [74.118817824526658, 35.123838815060594],
              [74.114873975340956, 35.126366425368737],
              [74.111639492126258, 35.129389387417447],
              [74.109779283891712, 35.132265606155379],
              [74.110751799797939, 35.1363580826321],
              [74.113093711810151, 35.140360016945507],
              [74.115268759755395, 35.143365427098061],
              [74.11690593590086, 35.146461155122417],
              [74.11607960616098, 35.150457066475568],
              [74.111573584971495, 35.152387422950106],
              [74.106909135257567, 35.149712132968382],
              [74.103934953616474, 35.147301934644659],
              [74.095699213469402, 35.14601477666718],
              [74.093160252803685, 35.14821600074886],
              [74.090701158253566, 35.150554044929038],
              [74.087556717339211, 35.152422468438999],
              [74.08036342032301, 35.15477194833845],
              [74.073798288599562, 35.154430066288697],
              [74.070267734323167, 35.153246412534116],
              [74.067020609658812, 35.151838772123604],
              [74.063210293062127, 35.150628459529806],
              [74.055295885779117, 35.149826050398431],
              [74.050954151135542, 35.147712667751847],
              [74.047147194268874, 35.147416387819412],
              [74.039039597277849, 35.147527536492966],
              [74.032506899456592, 35.150090881332233],
              [74.021880940377031, 35.158490711520599],
              [74.015162423722529, 35.162654177997688],
              [74.009048225628476, 35.166141230819008],
              [74.005634146747383, 35.170589186726936],
              [74.004592111333253, 35.17492194134428],
              [74.003163587847354, 35.181123618189019],
              [73.999753483146151, 35.184451867447073],
              [73.992054784794774, 35.184771844549793],
              [73.988291560231062, 35.182896359940742],
              [73.982262479984612, 35.182354917986309],
              [73.978769578330372, 35.179796612745378],
              [73.97060781656792, 35.177841222676356],
              [73.965485514757731, 35.17482025931217],
              [73.960013325896966, 35.17426346454468],
              [73.955801166417274, 35.177347943895796],
              [73.950050278434986, 35.186492931077886],
              [73.944743906279527, 35.191753477616878],
              [73.938996030499283, 35.19687113805653],
              [73.933139595628219, 35.202807258571617],
              [73.926182447963569, 35.206343930268886],
              [73.919298938505477, 35.211140925251648],
              [73.91120335558287, 35.212619057147087],
              [73.900752585712823, 35.212656214736334],
              [73.896354524603169, 35.213446054678244],
              [73.888139083860679, 35.213294644973821],
              [73.881367126740756, 35.210468868650779],
              [73.870597536702277, 35.210933730594874],
              [73.865165729489192, 35.210856717865639],
              [73.859210779539794, 35.214338914707632],
              [73.853864620732537, 35.220765850313569],
              [73.847355814735252, 35.228769003050687],
              [73.842371255223128, 35.230486519479392],
              [73.831528081608226, 35.23522685584468],
              [73.827934510789603, 35.236075814341866],
              [73.824872886218301, 35.237803150353358],
              [73.819601959087905, 35.239765874369958],
              [73.815458956442086, 35.240328828160393],
              [73.811838888979295, 35.24209021004377],
              [73.798309787199884, 35.245199346093152],
              [73.789110306182849, 35.245233240747673],
              [73.777499610700573, 35.243912075812673],
              [73.772900207215173, 35.241125487897285],
              [73.76196227872083, 35.231462180652578],
              [73.758731487659389, 35.229591661917489],
              [73.756036497047987, 35.227480488118402],
              [73.752275480086439, 35.225622693345315],
              [73.747642678482094, 35.223975645124192],
              [73.744698088671498, 35.221858993704139],
              [73.740907996901484, 35.221854830674573],
              [73.73681511023301, 35.220815785619003],
              [73.732455560502146, 35.218488505231356],
              [73.727513204579566, 35.218828002231106],
              [73.723857663802931, 35.221687465985553],
              [73.720466960897753, 35.224092396677172],
              [73.716337922715255, 35.226050799400205],
              [73.715816281840233, 35.233916243913299],
              [73.718314676771485, 35.241426235833273],
              [73.719304832714656, 35.252706615861598],
              [73.721868541164952, 35.259966382749212],
              [73.727046226426893, 35.278308069317873],
              [73.726391377538206, 35.281453810157132],
              [73.720257391089731, 35.2886588603088],
              [73.716987693550905, 35.292531269485686],
              [73.710787133936364, 35.305434521639661],
              [73.709355366898876, 35.308427314883872],
              [73.707337792406705, 35.312368774279086],
              [73.699830461454113, 35.323276296388769],
              [73.699583444833394, 35.326727697271245],
              [73.700321358385565, 35.336214547438836],
              [73.699979246477355, 35.354375191755949],
              [73.700411298359867, 35.358434263148268],
              [73.709535758318594, 35.382703296301621],
              [73.711599607632749, 35.387251124924113],
              [73.714047024839786, 35.391140636018406],
              [73.719227494141876, 35.397807574522282],
              [73.724837420291081, 35.404161012317985],
              [73.728048378509541, 35.411336945298771],
              [73.734743778237998, 35.422354174462072],
              [73.738869360128461, 35.427992335564959],
              [73.741337122917514, 35.43037295147203],
              [73.745071266746706, 35.43334880148813],
              [73.754687206436543, 35.44208679177364],
              [73.758509164209698, 35.443075083575074],
              [73.761801766496276, 35.444991858237998],
              [73.769075632908667, 35.448217666056536],
              [73.772919422691686, 35.448518836369118],
              [73.783219088552443, 35.453243971721555],
              [73.791357887764647, 35.456530291396973],
              [73.795098662327561, 35.460215291888353],
              [73.794527209302686, 35.469877533188843],
              [73.79129433694284, 35.477022343463112],
              [73.7908589271332, 35.482180894724991],
              [73.787264675242199, 35.498419319632227],
              [73.786499235485664, 35.507985214878886],
              [73.787634436011274, 35.515666498019961],
              [73.78600067701673, 35.524394517952402],
              [73.780987858822868, 35.526563006433463],
              [73.776052168331177, 35.526241639709205],
              [73.771878197415475, 35.527532380594359],
              [73.763612799457107, 35.528244084706657],
              [73.759964357986902, 35.529683669809025],
              [73.755555950229578, 35.530354102555663],
              [73.750270698842328, 35.532289965292925],
              [73.746117520167502, 35.533763678150443],
              [73.741691523849994, 35.534137588929802],
              [73.73582694885458, 35.536721525706241],
              [73.731065843028858, 35.54069958165357],
              [73.730354528443129, 35.545624929401171],
              [73.727708705712402, 35.549850872435094],
              [73.720747350293095, 35.553533424145712],
              [73.713617758763419, 35.552710372939231],
              [73.708421287124523, 35.550825917209188],
              [73.69775211965225, 35.549705488711737],
              [73.676841878130645, 35.550761078627794],
              [73.672661385859968, 35.551273595378724],
              [73.669323176480148, 35.552534608541862],
              [73.662918719949303, 35.555335603731443],
              [73.656227424727518, 35.558359146617875],
              [73.652538472600369, 35.561899897334584],
              [73.648310943960425, 35.564742663948316],
              [73.643525326078873, 35.567574010189745],
              [73.640445093941395, 35.569525445307853],
              [73.635422323686981, 35.571894192390218],
              [73.629652903842782, 35.571345690406723],
              [73.624715718689416, 35.571020047033812],
              [73.619426208566452, 35.565061883738068],
              [73.615601489302591, 35.563180549872222],
              [73.61151626662587, 35.562413558612349],
              [73.607689971864531, 35.561444926342688],
              [73.595385842156361, 35.55985079420617],
              [73.587608680590208, 35.558321392251536],
              [73.580981978040882, 35.55668104326837],
              [73.57106223665572, 35.554879276289292],
              [73.564772933704461, 35.554868913160085],
              [73.557813786465232, 35.555733999904568],
              [73.553290650781747, 35.55900197064831],
              [73.550142094574539, 35.563009025782137],
              [73.545661328145059, 35.565843727856631],
              [73.54121738671239, 35.567537180407697],
              [73.535047868351469, 35.569880612685182],
              [73.524304038529763, 35.571033966791411],
              [73.517930209633732, 35.567611541624771],
              [73.506623254911389, 35.565480826139471],
              [73.502145086463983, 35.566508840667261],
              [73.497926695623022, 35.569806135241706],
              [73.49415071989057, 35.571558411688684],
              [73.491179529070251, 35.573508155446433],
              [73.485594636064945, 35.576730818894255],
              [73.481715498687407, 35.577337045021167],
              [73.477426898986636, 35.576858915205946],
              [73.469119876371806, 35.575293525404113],
              [73.463138386223889, 35.573590502859815],
              [73.457156765875183, 35.572689786557213],
              [73.448563229894219, 35.571366137220835],
              [73.439203625602516, 35.57121681438425],
              [73.424991818580963, 35.569844833426906],
              [73.415736774917207, 35.567408963810109],
              [73.410898748353901, 35.564153592676881],
              [73.406792691776104, 35.564066002612968],
              [73.402834322319094, 35.566246892656984],
              [73.390276541401704, 35.582076552236565],
              [73.387423571838696, 35.585421331689801],
              [73.384594115659638, 35.58808191079445],
              [73.379077477506712, 35.594113300081453],
              [73.369644695595127, 35.60424695413856],
              [73.3601910457906, 35.606741891433423],
              [73.356022595882493, 35.608435311884321],
              [73.349117828528207, 35.60920234549549],
              [73.343264566385955, 35.611088120639522],
              [73.335255802397498, 35.61137311690657],
              [73.329294658637423, 35.61234234058945],
              [73.325293966639705, 35.613193662710572],
              [73.318895527078126, 35.61463190803822],
              [73.313938195263916, 35.615646658900737],
              [73.31002826170446, 35.617137851915508],
              [73.305853649963169, 35.618167041000866],
              [73.302221632349884, 35.619667563672351],
              [73.298877065160411, 35.620943589009379],
              [73.291893076543701, 35.623922330706378],
              [73.286915020059595, 35.6247278826445],
              [73.282759347687175, 35.626009914984706],
              [73.27715493462749, 35.627899244967587],
              [73.273794809502107, 35.629609004295112],
              [73.263081598340193, 35.636824495912286],
              [73.259355651738048, 35.640994714198079],
              [73.256008279693546, 35.642292254257526],
              [73.250616188818555, 35.646905107957146],
              [73.245075680776594, 35.650144367110776],
              [73.241893377337988, 35.652313209488646],
              [73.231048068927919, 35.661581767061307],
              [73.223162012816474, 35.669384134010784],
              [73.215487255298441, 35.675132378473876],
              [73.207979488395679, 35.676976403631429],
              [73.203320960108158, 35.678906856388473],
              [73.196753625850192, 35.682601244440882],
              [73.187803102019586, 35.686423755999606],
              [73.179000769929814, 35.693881556226984],
              [73.173962914921262, 35.696237945835193],
              [73.165187694566754, 35.702118803606204],
              [73.158445954860966, 35.70669720973757],
              [73.154202286503789, 35.709526306877798],
              [73.150293390138131, 35.71078831263501],
              [73.144621831183954, 35.715161827654349],
              [73.139261733194118, 35.718627227587454],
              [73.134944338583182, 35.723488975654156],
              [73.133989510990233, 35.735165857184533],
              [73.132776839421751, 35.738519390233058],
              [73.134228503558788, 35.747897139008224],
              [73.137203599465337, 35.767842485444412],
              [73.136171557896134, 35.77547180639943],
              [73.135609440048157, 35.779434952059667],
              [73.134939593759597, 35.785541638531662],
              [73.135702726539719, 35.793873045118985],
              [73.137961395792374, 35.801120810720995],
              [73.144778313307796, 35.810937911473808],
              [73.145624076890726, 35.819337941456403],
              [73.146575506931782, 35.829432357674222],
              [73.148091107854611, 35.833282651292144],
              [73.152977655525945, 35.836841508277658],
              [73.154146274589635, 35.841732404103553],
              [73.146301068803822, 35.844044597214854],
              [73.140014294460329, 35.846643530469812],
              [73.13372251353185, 35.849356827196132],
              [73.130571362937616, 35.852003604071299],
              [73.126138275963768, 35.854483147691568],
              [73.123190173394008, 35.856950997949788],
              [73.119565748672329, 35.85871966485616],
              [73.108352583445281, 35.868786537107702],
              [73.100381567679932, 35.878287408207932],
              [73.092564165805825, 35.881260511193574],
              [73.089150170520853, 35.883419847020889],
              [73.084727155901405, 35.883982273182291],
              [73.080261738139583, 35.884999538140121],
              [73.075846432988953, 35.885354961177896],
              [73.072744640087535, 35.882794292560305],
              [73.067971994367852, 35.874623091363233],
              [73.064194611469247, 35.872162351835847],
              [73.060070107796349, 35.867681449450494],
              [73.055953418246332, 35.863795318047025],
              [73.052679574883356, 35.862121468284272],
              [73.048628787986402, 35.860247404286682],
              [73.038881797474943, 35.855521754461996],
              [73.028702780409063, 35.854167150405893],
              [73.024600889566656, 35.854436173555712],
              [73.017124137635122, 35.855016221203805],
              [73.010116457957935, 35.857320787064239],
              [73.00675220241321, 35.858816931011319],
              [73.004636124233883, 35.863724726516139],
              [72.999680407616964, 35.863586134246603],
              [72.995588258483835, 35.862827988331034],
              [72.98788090410217, 35.861300222475599],
              [72.981418885076309, 35.857996988321759],
              [72.974841219232673, 35.856288785221423],
              [72.972181899724845, 35.853942660468348],
              [72.96565718597131, 35.851549867695518],
              [72.960498251196881, 35.849417430541251],
              [72.95119497939173, 35.847164719483096],
              [72.946561101181359, 35.845937733933255],
              [72.939014464608661, 35.846123343930941],
              [72.929366223272325, 35.84559693746229],
              [72.920560158220937, 35.847238271865308],
              [72.916172162555952, 35.84765863272365],
              [72.910016117856557, 35.848882358305076],
              [72.905465384242063, 35.852814385174845],
              [72.904893360435807, 35.864861257055637],
              [72.90267607074216, 35.8788749511559],
              [72.901584608963248, 35.881727275111437],
              [72.897973929588701, 35.882325472584384],
              [72.890200703278495, 35.881064771279256],
              [72.885103033221938, 35.880212790127359],
              [72.874591074137228, 35.879480350150935],
              [72.870180580792635, 35.878983993805988],
              [72.857585261939448, 35.877744086919961],
              [72.851500736032861, 35.87851003495588],
              [72.847595190147075, 35.880197423450213],
              [72.842829656936189, 35.882341407976149],
              [72.839182852403425, 35.883143681933447],
              [72.834925157988295, 35.886649871714731],
              [72.830185649802701, 35.887425558332353],
              [72.8285503376962, 35.879733203734453],
              [72.825234942514697, 35.874879385398089],
              [72.815410680050931, 35.870186461051368],
              [72.811562099894502, 35.869659854448713],
              [72.803326783032531, 35.868796222262581],
              [72.798974621727254, 35.867546557130225],
              [72.799211355445323, 35.861500243534294],
              [72.79803167578261, 35.855828870308628],
              [72.795664064789875, 35.853303907480267],
              [72.792142465426451, 35.851643183463011],
              [72.783664487892608, 35.849857778375338],
              [72.780989415228333, 35.847325143634997],
              [72.777248521287206, 35.844080052344502],
              [72.771462643939785, 35.843710338175541],
              [72.766722809397592, 35.845191646703327],
              [72.763035632404993, 35.84845681760293],
              [72.758503369058531, 35.850379221935988],
              [72.755364444046691, 35.853222992751157],
              [72.749715819674293, 35.856441443509482],
              [72.745852940402116, 35.857007262318213],
              [72.742475968912558, 35.858750051394018],
              [72.737511498032319, 35.858855732911159],
              [72.732831825880339, 35.857390775053815],
              [72.728788605952346, 35.856149031503655],
              [72.723353949734772, 35.853981035391065],
              [72.71896568027941, 35.850170583309932],
              [72.715497894070438, 35.847159530521189],
              [72.71093877599381, 35.844830825149209],
              [72.707569887873049, 35.841457657575582],
              [72.703580043362479, 35.838204145637668],
              [72.696528768389101, 35.835125836927162],
              [72.691096163201635, 35.832934141630396],
              [72.686627435757487, 35.833963886168071],
              [72.683252514100886, 35.835660747293467],
              [72.677809222779544, 35.840708420927072],
              [72.67391974905378, 35.841958306072243],
              [72.671162645856498, 35.84428520972957],
              [72.666281842105477, 35.846492854119738],
              [72.660368723784842, 35.849243772866394],
              [72.652282532045248, 35.858630309692273],
              [72.645604812270079, 35.866409783232633],
              [72.639519478931916, 35.867168314895231],
              [72.634028667853357, 35.865681534118053],
              [72.631203748374361, 35.867618797135485],
              [72.626723809603135, 35.869538346509415],
              [72.620006016214376, 35.871374644650842],
              [72.603222732416285, 35.870487864634434],
              [72.598757908535802, 35.873412145614857],
              [72.594992246741199, 35.87568957069788],
              [72.590852932466646, 35.880928834582363],
              [72.586656960861632, 35.885455313692184],
              [72.579492256138963, 35.894703026333509],
              [72.570034119631799, 35.905831878165536],
              [72.561920835153813, 35.908772145905921],
              [72.553637916971866, 35.909015845397768],
              [72.550436315654196, 35.912516573817413],
              [72.544078033841146, 35.913036147434696],
              [72.538232769309516, 35.914666871629542],
              [72.53368516114989, 35.917494523699972],
              [72.531174447653228, 35.924597774022594],
              [72.530473910504099, 35.927960110601795],
              [72.530577135149741, 35.9322334452837],
              [72.529428751946483, 35.940971465505612],
              [72.531091782493419, 35.952932373732551],
              [72.533446942003138, 35.956351191526863],
              [72.538519366947696, 35.960524244212657],
              [72.545602001295492, 35.960891075397662],
              [72.54888949393353, 35.963509311854807],
              [72.549209489954421, 35.969340742554259],
              [72.554564884237934, 35.979592127354699],
              [72.555266304937845, 35.982989763998347],
              [72.553567756871573, 35.990135772612895],
              [72.555811008011673, 35.996267349333927],
              [72.560782978342871, 35.996167010212517],
              [72.566660134604675, 35.994515076112798],
              [72.5732023757745, 35.996487955793135],
              [72.575268117141221, 36.000148637177638],
              [72.577859132343704, 36.004026930623134],
              [72.58212379755463, 36.008176256443605],
              [72.581369257817542, 36.012860671507894],
              [72.583554875015238, 36.01976475000113],
              [72.587626900588887, 36.021787059107517],
              [72.590319452740047, 36.023887384398307],
              [72.593871907545306, 36.024868257053264],
              [72.595986522441166, 36.027409805677578],
              [72.594614839444276, 36.034815684580792],
              [72.593226814140337, 36.040599736491778],
              [72.589714405854409, 36.046833256551295],
              [72.586165779185023, 36.050507571137494],
              [72.580052071801916, 36.051719396992439],
              [72.575582465096829, 36.053178011961542],
              [72.571818017208628, 36.052556782021156],
              [72.568021917304307, 36.055424901553508],
              [72.559875760936535, 36.055512461220317],
              [72.553632191441892, 36.055739395136186],
              [72.549995901833796, 36.056785852540997],
              [72.547098310739727, 36.059607967386022],
              [72.545022618972894, 36.063618289071826],
              [72.538029760894403, 36.065671989022064],
              [72.534897647498141, 36.068055617620104],
              [72.531681846081426, 36.072467058823129],
              [72.531466262026157, 36.076956788028383],
              [72.535376801649605, 36.088970671948644],
              [72.534096511648272, 36.094095136364459],
              [72.533737727165828, 36.103372485931246],
              [72.534331305318148, 36.108020601008526],
              [72.536053556009634, 36.113223069748678],
              [72.54476381201485, 36.122665879425909],
              [72.546787776925939, 36.126711959351674],
              [72.548022486234842, 36.130827438312991],
              [72.552494252356439, 36.1368068191994],
              [72.557164881230818, 36.137337937560808],
              [72.559549818981679, 36.140113922308501],
              [72.563087162097972, 36.141552976485521],
              [72.571688455402764, 36.147614386798182],
              [72.57376793954171, 36.1510214289045],
              [72.571092867732631, 36.155241029231334],
              [72.568174388268972, 36.158542818539971],
              [72.565819855571192, 36.165189289068444],
              [72.564109433430417, 36.169865988074392],
              [72.562162580188485, 36.172736631622278],
              [72.558635093599861, 36.175793457475336],
              [72.553844188687435, 36.177449548444571],
              [72.551496257232643, 36.181220570712007],
              [72.553434243902799, 36.185330590001257],
              [72.557947896184373, 36.191720074092864],
              [72.560243933768078, 36.196706391815198],
              [72.55875729388697, 36.205425806181125],
              [72.560435379162683, 36.212447717957723],
              [72.563582395257555, 36.216566542521015],
              [72.571795705620076, 36.218558077159692],
              [72.577432639789947, 36.222989395402628],
              [72.585386582032754, 36.230582576287723],
              [72.586175416531177, 36.233956462553664],
              [72.58715459321192, 36.241598291046529],
              [72.588442657773726, 36.251301004928187],
              [72.59519249773507, 36.26225938143871],
              [72.60142355996858, 36.266021705830738],
              [72.604878045708773, 36.267524155139682],
              [72.611169412475434, 36.270511173848803],
              [72.614718740447387, 36.27174190337626],
              [72.619095261717362, 36.272742856412542],
              [72.62428591160689, 36.274448773011727],
              [72.634714361820897, 36.276717999479786],
              [72.639771480883908, 36.27552429607816],
              [72.642659822566785, 36.273682947458767],
              [72.646988719436479, 36.270988087387657],
              [72.656952067464758, 36.268092450702341],
              [72.661510134641929, 36.265288082562968],
              [72.66997113196409, 36.26404253859819],
              [72.674284963907738, 36.263808640618628],
              [72.679829651556076, 36.263719381899577],
              [72.685174363851871, 36.255325358067026],
              [72.688560160162737, 36.252970090036918],
              [72.690879785975795, 36.250544111868244],
              [72.695783289885327, 36.253129984138518],
              [72.695248294602038, 36.259409488834194],
              [72.693170109470955, 36.262822124673491],
              [72.689406170517941, 36.266879723669049],
              [72.689060102792126, 36.270587421017993],
              [72.692342293042344, 36.275708264662569],
              [72.697843227960348, 36.277419525326074],
              [72.701572844436853, 36.279107773523151],
              [72.713194618569659, 36.281152667446293],
              [72.717617255865704, 36.281719515683307],
              [72.722754168601298, 36.284105287199942],
              [72.730269616445, 36.290354867078108],
              [72.735574390224457, 36.296301720562631],
              [72.740705432025905, 36.299574587436759],
              [72.746178765347153, 36.301305064329519],
              [72.750442115776721, 36.305194627640169],
              [72.760559196032276, 36.308363242292842],
              [72.767792230444826, 36.309042057989579],
              [72.778506206006966, 36.309943471282587],
              [72.78294055221474, 36.315203539713572],
              [72.787006480997803, 36.319133131014979],
              [72.790833754804055, 36.320572407653849],
              [72.798833863257258, 36.329680543790154],
              [72.806693213126479, 36.333063701205901],
              [72.812680997557052, 36.336127259716811],
              [72.815630682541979, 36.338432168469822],
              [72.822520658096906, 36.353643435270818],
              [72.829685798159758, 36.36120307975083],
              [72.833458227448773, 36.363346215199087],
              [72.836953513637951, 36.366119742053193],
              [72.840493449949392, 36.367753678465917],
              [72.84513954767452, 36.369872795796908],
              [72.849795042686424, 36.371807947981637],
              [72.865258657957582, 36.373067795921692],
              [72.87000410791714, 36.37922129869073],
              [72.874852626293119, 36.382709846019551],
              [72.878892064580469, 36.385268026386235],
              [72.882695691394815, 36.387388949720368],
              [72.886720691470984, 36.391085575997252],
              [72.890062125225072, 36.397888098155967],
              [72.886660726282116, 36.4123219914201],
              [72.890149927414967, 36.424801140116536],
              [72.888868068392512, 36.42882602411084],
              [72.884044891323896, 36.431148712192105],
              [72.880040651436829, 36.434197248167187],
              [72.877407001770806, 36.43816683987307],
              [72.879429744525709, 36.443389149862249],
              [72.883831811807056, 36.443949941321449],
              [72.887945356097475, 36.445369575502795],
              [72.892339128188567, 36.446156645143155],
              [72.900020563988718, 36.448573642651446],
              [72.906517458955292, 36.452555130177245],
              [72.911157076288092, 36.454237514839711],
              [72.918540922253854, 36.460790052600636],
              [72.922231871670292, 36.463020224302966],
              [72.928619100386754, 36.4624879784024],
              [72.93205933816246, 36.458764530652026],
              [72.938958386333496, 36.458105776888736],
              [72.943449132843782, 36.458575233920854],
              [72.948848501717833, 36.462531503516971],
              [72.952147338513413, 36.463929568643366],
              [72.955961756850513, 36.465158867604615],
              [72.958926145231132, 36.467231383015402],
              [72.962801906113356, 36.467551558091081],
              [72.966508072794937, 36.464948959391457],
              [72.976482341187307, 36.464953668918568],
              [72.982640911375341, 36.463776305001829],
              [72.986304223787045, 36.462267427774023],
              [72.988689045090695, 36.458061468306724],
              [72.993849180800893, 36.460211060951764],
              [72.997911073503289, 36.467572048205355],
              [73.001149221519114, 36.471360824546309],
              [73.003310844543648, 36.474554717440689],
              [73.002852620310804, 36.479235232872256],
              [72.992323044492238, 36.478992218116723],
              [72.9910183548172, 36.483676053958824],
              [72.990508164446055, 36.489724002138281],
              [72.992290471500212, 36.496281166988489],
              [72.993495964908817, 36.499429905724973],
              [72.999310864146707, 36.507421481683032],
              [72.995449739558296, 36.513392345528132],
              [72.99870436849983, 36.515267515150882],
              [73.007297245804779, 36.5161490105449],
              [73.012990712260958, 36.519173890218653],
              [73.019494589598011, 36.523127468551401],
              [73.025909597731655, 36.526485441265336],
              [73.033724132156735, 36.528601194297828],
              [73.036698787188286, 36.530492524998159],
              [73.044910969901622, 36.534029614549731],
              [73.050698563902515, 36.534594026105196],
              [73.054542926897057, 36.535819916749787],
              [73.05811516104265, 36.536791448530579],
              [73.062538315563714, 36.539169751077097],
              [73.06699647863789, 36.544395141518763],
              [73.070212619278081, 36.555011536340189],
              [73.073860028762681, 36.561584886056444],
              [73.079319215764087, 36.564168160328052],
              [73.084529668301542, 36.565880703252397],
              [73.08819396046465, 36.568991656459026],
              [73.090577770383206, 36.571641880733317],
              [73.091507664979801, 36.574691596766165],
              [73.091405740249954, 36.582817138992645],
              [73.092899005032365, 36.586654394368722],
              [73.09573243452796, 36.590907986809974],
              [73.100944656184623, 36.597195736687809],
              [73.110469149835907, 36.607452262822967],
              [73.112429301291854, 36.610158687676936],
              [73.109036868950582, 36.615706420516467],
              [73.098472965323495, 36.624437792701954],
              [73.091966315179221, 36.634830042999781],
              [73.090814496931586, 36.643090743879462],
              [73.092402338890054, 36.651300115248944],
              [73.094077505884158, 36.660191512021221],
              [73.094383758000788, 36.66716321703683],
              [73.091703842352274, 36.67247412510563],
              [73.087928095337659, 36.676851383398535],
              [73.084929420134813, 36.682381400212122],
              [73.084407064799308, 36.688879279110601],
              [73.084360715291794, 36.692479133276208],
              [73.0847087817844, 36.697016981483294],
              [73.087876127658987, 36.698702434243543],
              [73.091426152542098, 36.697117195761493],
              [73.094547670447938, 36.693074944663692],
              [73.097049546958189, 36.690531665562332],
              [73.102799156138246, 36.687725067941933],
              [73.112148234656829, 36.687592680780142],
              [73.116976690692795, 36.687589112898578],
              [73.121200411204555, 36.686340475800051],
              [73.126439048094397, 36.686685172131796],
              [73.131091485606419, 36.688360033212668],
              [73.133839352398482, 36.690425135477646],
              [73.136238285595624, 36.693549733930197],
              [73.139806640237921, 36.696316118089044],
              [73.145428806168923, 36.700104357703005],
              [73.149542257703061, 36.701107191709966],
              [73.153491687255197, 36.70351545537347],
              [73.158590173966829, 36.704630749920938],
              [73.163227506674644, 36.706781803652348],
              [73.172093994523664, 36.708298105920889],
              [73.175656399444847, 36.709743689510525],
              [73.181105296882961, 36.712092253710409],
              [73.185192497555406, 36.714641228641945],
              [73.187440443761787, 36.721199370370933],
              [73.19383311623578, 36.720884257541286],
              [73.199513690171798, 36.717642811522545],
              [73.202661888520026, 36.715707636913955],
              [73.206717524867074, 36.711291262391576],
              [73.208916587060997, 36.703534120639553],
              [73.211789894897535, 36.701344740042444],
              [73.225719530524174, 36.699508820124173],
              [73.234354285559334, 36.699607785027816],
              [73.242581689064352, 36.702470855892251],
              [73.248404886280198, 36.703052057341452],
              [73.252655179835841, 36.708971486238561],
              [73.267912795767245, 36.709505567305186],
              [73.276160423195918, 36.708613673477053],
              [73.294049976600391, 36.70895369145164],
              [73.301014110313972, 36.70842081095909],
              [73.307742073279314, 36.706605810907185],
              [73.314691296766867, 36.706482300283092],
              [73.318713336106967, 36.708569315338174],
              [73.323359998309755, 36.712946859855883],
              [73.330215068650205, 36.715551115814499],
              [73.341324447399785, 36.716014281352201],
              [73.349421366242581, 36.71459092017809],
              [73.355089273005106, 36.714826461193333],
              [73.360796521498671, 36.715514777770792],
              [73.365107022669108, 36.71988334934877],
              [73.3667455054686, 36.723967201072966],
              [73.369096671043337, 36.732710425016627],
              [73.372067930085777, 36.735002028230511],
              [73.378148088026151, 36.735584665064522],
              [73.382867589866422, 36.733863113374589],
              [73.389695510525982, 36.73159461366339],
              [73.399423551480524, 36.732024077906964],
              [73.405764299669784, 36.73324904747291],
              [73.414608007268882, 36.734773944440562],
              [73.421887887990508, 36.7382700526923],
              [73.429163650203265, 36.7402422142993],
              [73.436245293649307, 36.744618559577802],
              [73.441507833456399, 36.745183565259261],
              [73.445159184473937, 36.743255591682669],
              [73.450374554353843, 36.736856350173902],
              [73.455192087037247, 36.734724884408003],
              [73.461375067202709, 36.733077273923058],
              [73.472289356690226, 36.731025340671735],
              [73.476666011437871, 36.732706066606561],
              [73.482470135425501, 36.733940191408848],
              [73.486500561514944, 36.729994847416592],
              [73.494443509201361, 36.728061569544984],
              [73.499495396326452, 36.723068408254505],
              [73.503730520410031, 36.721378401729972],
              [73.506572202026703, 36.719183071909832],
              [73.51143853573717, 36.715481760875015],
              [73.515333049472616, 36.715560898364238],
              [73.519169074848847, 36.71820838185355],
              [73.524029195182635, 36.720674303440056],
              [73.528197883236373, 36.720984070681034],
              [73.532158792423218, 36.719040024830541],
              [73.537954505372554, 36.711988308435522],
              [73.541625446488723, 36.710263306368553],
              [73.548024732703411, 36.709731461266522],
              [73.552966837616779, 36.711399616760261],
              [73.560317894230934, 36.716235336832824],
              [73.564784624038282, 36.716096438284275],
              [73.569310409947903, 36.713272362578479],
              [73.579058469452832, 36.713035490720372],
              [73.582456359953895, 36.714489256335426],
              [73.585593119137883, 36.716964687788348],
              [73.591029375353216, 36.71998367045861],
              [73.600193473797759, 36.720392830763785],
              [73.605568695025127, 36.715742033294525],
              [73.606593912239347, 36.711120000601007],
              [73.605346914454401, 36.705156956705622],
              [73.606123355777186, 36.701258725126181],
              [73.609569914666665, 36.696842426695625],
              [73.612956795192972, 36.695111228612475],
              [73.617443486588314, 36.694312293254754],
              [73.625526408405022, 36.694015455358958],
              [73.628949132993057, 36.691190670832235],
              [73.633132704070164, 36.690134476990366],
              [73.638690214970268, 36.690243410061719],
              [73.64557225357251, 36.692152209947189],
              [73.651572093455499, 36.696091820798102],
              [73.657723732193389, 36.694435741028862],
              [73.662759934188045, 36.693168256184663],
              [73.672992350643483, 36.691863339145449],
              [73.67727614790779, 36.691219257080256],
              [73.682318756392561, 36.689745084583159],
              [73.688062032392097, 36.686693033120484],
              [73.700537751176967, 36.684930002991742],
              [73.706887810564325, 36.6876435832704],
              [73.71037567394032, 36.690714766972448],
              [73.714248198141107, 36.697730563937228],
              [73.716279988087734, 36.700429543103631],
              [73.718543723259685, 36.703864146031385],
              [73.724221921466281, 36.709138556197559],
              [73.734480546778528, 36.710651496737974],
              [73.738655071762466, 36.709866166965242],
              [73.748389265669886, 36.710049995639338],
              [73.753484671933165, 36.7078472333124],
              [73.769387294401881, 36.703936891172212],
              [73.776431849134283, 36.703431618658648],
              [73.783070153821129, 36.702417865926279],
              [73.790795924502987, 36.704564529795874],
              [73.799972735347268, 36.712789221590278],
              [73.804883958600556, 36.715565843536787],
              [73.80902508484867, 36.71677843954366],
              [73.815148990469226, 36.716892519611939],
              [73.821601805824656, 36.714554012788184],
              [73.826899570445804, 36.71396946868591],
              [73.832533867875284, 36.711614711340196],
              [73.838616802831382, 36.70931435868512],
              [73.846834635461065, 36.707371375109787],
              [73.850747016094886, 36.705895886569699],
              [73.85411889908849, 36.704592545519795],
              [73.857791073043174, 36.702656994163938],
              [73.86450796757434, 36.700845153115928],
              [73.884032266917075, 36.699332085837234],
              [73.894517713920465, 36.70175255220542],
              [73.900775818408135, 36.706778580808923],
              [73.900489132760725, 36.710711460855009],
              [73.897130043355816, 36.716361632765448],
              [73.898655791778751, 36.721076011650226],
              [73.901676604047779, 36.722927588016098],
              [73.905208945514545, 36.725675400307551],
              [73.905315791233676, 36.730615432935871],
              [73.905286398601348, 36.734458880063379],
              [73.902135649460362, 36.744458607131918],
              [73.900027910498565, 36.749766730772969],
              [73.89503831812398, 36.754227935533962],
              [73.887417574964161, 36.762530164408375],
              [73.885196476624813, 36.764970585039833],
              [73.877690832427547, 36.771317187171697],
              [73.872161864383941, 36.779497795718392],
              [73.869733359921952, 36.78227361732921],
              [73.863561663932089, 36.788304435752799],
              [73.854788198800989, 36.789715079511055],
              [73.848514729565878, 36.789804208759541],
              [73.842411442975049, 36.787918510376024],
              [73.833820811758926, 36.787988778334558],
              [73.829399507132806, 36.789363493542425],
              [73.820873907028485, 36.792892148703835],
              [73.815022866220815, 36.798492074790637],
              [73.811925090103372, 36.803689037055626],
              [73.809598603280136, 36.812290181189965],
              [73.806574947658376, 36.815010078472142],
              [73.802890033999986, 36.816306371986137],
              [73.798200802022066, 36.816219026502203],
              [73.794345746629332, 36.81478256907986],
              [73.786282997408279, 36.814177925243037],
              [73.778163525069758, 36.815391150008203],
              [73.771435702722144, 36.818176369060673],
              [73.766841155143297, 36.822344331315612],
              [73.764010423967278, 36.824292149256806],
              [73.755035830624621, 36.826603206495328],
              [73.744110655872518, 36.833447832529352],
              [73.740336473844394, 36.833922347238726],
              [73.732309499911594, 36.833021017591058],
              [73.726466720636495, 36.832751740012498],
              [73.723281819965422, 36.836056679188104],
              [73.724136967592699, 36.840326113517357],
              [73.724179070029209, 36.843487478955304],
              [73.72131289179552, 36.846549450295043],
              [73.720162625041112, 36.853439181565783],
              [73.719024719609081, 36.857262066659814],
              [73.714736845819814, 36.860545777055464],
              [73.710810138899419, 36.861335296639531],
              [73.709562756327117, 36.864152861556491],
              [73.705695311541135, 36.867536889858059],
              [73.702756858469556, 36.870141978003417],
              [73.698303500606286, 36.872397197582941],
              [73.694271176504799, 36.873800117829475],
              [73.69082400936334, 36.87730228513955],
              [73.681398228161441, 36.885625409135152],
              [73.682546473151405, 36.889535947395416],
              [73.685224884316142, 36.896000699786406],
              [73.684820932845525, 36.900675790262035],
              [73.685653872205222, 36.903829071203241],
              [73.690281274556142, 36.912192524566017],
              [73.693573822568325, 36.913619597730218],
              [73.700795621092297, 36.914212769947788],
              [73.706465819313635, 36.913752652268037],
              [73.71116296165124, 36.912818191754489],
              [73.715925872603108, 36.910680727718088],
              [73.720172966302471, 36.908760850569784],
              [73.724157586891792, 36.906153730344997],
              [73.727789136369623, 36.904859142158827],
              [73.732326404318243, 36.903602724126038],
              [73.737364848245733, 36.901674896459824],
              [73.7422314771879, 36.897970112166142],
              [73.748943787460504, 36.896755206406617],
              [73.751650687322481, 36.898828448052754],
              [73.755757438861153, 36.901362020908103],
              [73.758458094750878, 36.903638800739913],
              [73.762612150386019, 36.904627648127828],
              [73.767614456066156, 36.904721481465963],
              [73.776085558357337, 36.900626967050627],
              [73.784182790240692, 36.900323072412341],
              [73.790213500161826, 36.894613708881138],
              [73.798585111906249, 36.893656232753628],
              [73.802712705982373, 36.895528402955577],
              [73.809637928406701, 36.896542662706864],
              [73.812760894406722, 36.89435053502158],
              [73.814612740534557, 36.888357522675285],
              [73.818030315316307, 36.885714955848151],
              [73.8300038561581, 36.885298528082984],
              [73.835806573353395, 36.886952170276864],
              [73.838495060005243, 36.889684544157056],
              [73.838653454570903, 36.893733685787915],
              [73.842129057340344, 36.898479685697453],
              [73.849041199050006, 36.899971445475146],
              [73.855739492083359, 36.899184489519769],
              [73.863345536802925, 36.897320869268633],
              [73.868932960121114, 36.895831759370971],
              [73.878731681874442, 36.894461481064397],
              [73.88265855925637, 36.892713389763401],
              [73.88889027636607, 36.888597115962213],
              [73.892568035696215, 36.886639973701428],
              [73.899226745782443, 36.88050752063873],
              [73.902922296436728, 36.87609395497509],
              [73.910806117020741, 36.87243862606141],
              [73.916151739330488, 36.871396342695768],
              [73.922917745614399, 36.877792618625712],
              [73.929014892885363, 36.878127413004187],
              [73.932142602517203, 36.876569990768445],
              [73.937759752250713, 36.874008447456895],
              [73.943099701148128, 36.868441147715139],
              [73.947787139324305, 36.86501594201561],
              [73.950589365267859, 36.862730253993696],
              [73.957771300844286, 36.856921852116756],
              [73.962013905723083, 36.851105956388636],
              [73.964769887491229, 36.848676563946221],
              [73.967300394608017, 36.844333286609846],
              [73.971322897973934, 36.840150237884416],
              [73.976138895153341, 36.836868849232062],
              [73.980451997408565, 36.835306388228943],
              [73.983234228482232, 36.832967461505582],
              [73.987170908441442, 36.831694757846186],
              [73.991951879738494, 36.828639949369325],
              [73.995089612724371, 36.826671310034364],
              [73.999877720560491, 36.824298194252961],
              [74.004582797196505, 36.824833764701886],
              [74.010928887203022, 36.827172808852282],
              [74.020662437592662, 36.827796054688136],
              [74.025140810349086, 36.826327452480221],
              [74.029688349169135, 36.824449321239875],
              [74.033616941314421, 36.821515976515151],
              [74.036759883550147, 36.819340525483923],
              [74.041556178393662, 36.815623519452132],
              [74.055748231067298, 36.806473878733712],
              [74.059017898059295, 36.808759166518648],
              [74.062306147776695, 36.810383735691175],
              [74.065524438300514, 36.813464763711835],
              [74.070174287670937, 36.817908772681726],
              [74.081514013748276, 36.828608074294038],
              [74.084409417784101, 36.831135768609727],
              [74.087711951848561, 36.834284884155267],
              [74.090415784851345, 36.83660420988533],
              [74.094314390999457, 36.838672500593994],
              [74.100746249432291, 36.838119775611418],
              [74.109394059586208, 36.837128608689348],
              [74.114292845762179, 36.835777657258568],
              [74.118634917566283, 36.834168341967334],
              [74.128141196680076, 36.832757523453552],
              [74.134216329350181, 36.834859993034826],
              [74.137014084869506, 36.836884589780382],
              [74.142688633457325, 36.840161426432985],
              [74.146395263895712, 36.847158704316563],
              [74.147705867053759, 36.851887184829351],
              [74.1497135613251, 36.860038540078754],
              [74.150401074902589, 36.863779360797658],
              [74.151812053013685, 36.872011110232997],
              [74.154355551097183, 36.882261300276056],
              [74.15555772848731, 36.885827519593292],
              [74.156803689304397, 36.888803894887197],
              [74.158510450449327, 36.892560672637593],
              [74.162601648679953, 36.897992957779103],
              [74.165502186891757, 36.900496203219518],
              [74.169063996493975, 36.902600830201557],
              [74.173493142708949, 36.903991028153968],
              [74.179033808101551, 36.904081468784391],
              [74.183766669646218, 36.903705389838066],
              [74.187449747224591, 36.902446401245562],
              [74.193475219884533, 36.902385422034257],
              [74.197521092403477, 36.90124547922187],
              [74.204372004068745, 36.900969852384392],
              [74.21201949972891, 36.899480971292874],
              [74.217745718142908, 36.898959853715496],
              [74.221537435163199, 36.89783720692202],
              [74.225428206149346, 36.897241090412905],
              [74.230090076218076, 36.895291715703728],
              [74.234735494433451, 36.892888732382417],
              [74.238382529909003, 36.891855674101031],
              [74.241514607114667, 36.888973044939945],
              [74.245485431677608, 36.887467789684919],
              [74.251059915283037, 36.886237328166992],
              [74.255242202745563, 36.886305674490899],
              [74.261342165421084, 36.886628964437726],
              [74.271403767164742, 36.895269472252053],
              [74.27798351251748, 36.899851480100892],
              [74.281847580232451, 36.901276760670022],
              [74.289271992802824, 36.90496306455654],
              [74.293896256497675, 36.907604790857867],
              [74.297364641113063, 36.909068292476206],
              [74.304631038345605, 36.912363610159552],
              [74.311531425562592, 36.915608892935047],
              [74.315622072195808, 36.918127873683474],
              [74.321070425158581, 36.921781861801421],
              [74.324923220738441, 36.923658176596717],
              [74.327093442031554, 36.926124068705256],
              [74.332609382373079, 36.929348006258778],
              [74.340203954258087, 36.936420382253274],
              [74.346290845628985, 36.940582874208964],
              [74.349513431133502, 36.94281410679833],
              [74.358590784850037, 36.950590684116136],
              [74.365275752703411, 36.956850795148938],
              [74.368304322398359, 36.958990141298855],
              [74.375481328757132, 36.961553996665451],
              [74.378195872780708, 36.963820615868649],
              [74.388669264502639, 36.96802591056472],
              [74.392804968467942, 36.968973770994701],
              [74.406455316317036, 36.96961221422243],
              [74.410861789397984, 36.971041837929299],
              [74.415561869994448, 36.973111336254618],
              [74.418565848145889, 36.97517908829272],
              [74.427011583207005, 36.982464154743035],
              [74.427181760198081, 36.986943038003112],
              [74.429343123020999, 36.989861208553563],
              [74.435707707801171, 36.991092238426063],
              [74.443911635557697, 36.991214946285162],
              [74.449603898862492, 36.992208170426643],
              [74.458496364370959, 36.991974510212025],
              [74.468813267984572, 36.992491502284892],
              [74.473559739639768, 36.99165123450318],
              [74.477452235620135, 36.992163119219022],
              [74.491725514443772, 36.98946123390963],
              [74.500916361205668, 36.988617682675049],
              [74.509799778886688, 36.988701391686682],
              [74.520429339617223, 36.989195105506376],
              [74.524892130624949, 36.988327928158334],
              [74.532172632243075, 36.986910773173115],
              [74.541643262002083, 36.977931718152107],
              [74.545314495640937, 36.971279623521788],
              [74.546312198904559, 36.966294768824973],
              [74.548663576593754, 36.962668964448206],
              [74.552132864404427, 36.957287020066161],
              [74.55442656961192, 36.953683206698713],
              [74.557530120114635, 36.951704414394783],
              [74.578656647416224, 36.948656382446892],
              [74.57915245070815, 36.96310109032585],
              [74.580682006951747, 36.970099510650599],
              [74.58310819762815, 36.977563475392103],
              [74.58262149168381, 36.986057698706965],
              [74.584581282900444, 36.996377564581515],
              [74.585056284548116, 37.000201123233708],
              [74.586255146933539, 37.008057900028014],
              [74.586617226338959, 37.011858564731767],
              [74.58941451953423, 37.028642736175755],
              [74.588763216755694, 37.032200942129371],
              [74.584458178325264, 37.037069527968598],
              [74.580507862089249, 37.038810791647052],
              [74.58156144109455, 37.042163144826297],
              [74.586495804716634, 37.045368015489984],
              [74.591250952933663, 37.045434317196587],
              [74.595939594502411, 37.047067573717875],
              [74.603138964759296, 37.049167005853818],
              [74.606446964551864, 37.050576068969825],
              [74.611788639358011, 37.050968818643547],
              [74.619525153563018, 37.051869633356688],
              [74.634288436035291, 37.054981843580848],
              [74.639289411605716, 37.055482614498537],
              [74.649793272131717, 37.056737617344396],
              [74.659225895383202, 37.057797174070636],
              [74.666962672864912, 37.061219543420705],
              [74.67129574588219, 37.06486676766913],
              [74.678412855998275, 37.070551099425607],
              [74.685024110394252, 37.074910733854857],
              [74.689798874208293, 37.076632077177472],
              [74.693875595962652, 37.077914490471549],
              [74.699587443187255, 37.078331046715881],
              [74.708664623420916, 37.077680238835534],
              [74.712903879522059, 37.074374309472944],
              [74.718462125520446, 37.062817756711972],
              [74.718927657036645, 37.05478239547017],
              [74.71847845383482, 37.049642409849305],
              [74.719780366476627, 37.044707030437245],
              [74.721956577161393, 37.038645494387609],
              [74.728215688128785, 37.026052162861866],
              [74.734477439941728, 37.020750445419296],
              [74.739869563213432, 37.016366545948998],
              [74.744918827495482, 37.014637967073476],
              [74.748850698695563, 37.012235966984811],
              [74.752516723457916, 37.011601222442103],
              [74.757461562417092, 37.013256630082097],
              [74.763366008915781, 37.025170821510514],
              [74.76719217184511, 37.027447098948414],
              [74.770784970011064, 37.028833523888707],
              [74.778830586696543, 37.029847647610161],
              [74.783585189899355, 37.029908750383655],
              [74.791238450597305, 37.02821204679244],
              [74.798438271429291, 37.025190761155727],
              [74.804614114060286, 37.023679206272824],
              [74.816599762933933, 37.02317339847361],
              [74.821945633039078, 37.023309175368077],
              [74.828280683031863, 37.024889379507933],
              [74.833827740115282, 37.024959103740805],
              [74.839177798203679, 37.022344390108827],
              [74.842096378887305, 37.016996640674598],
              [74.841627351727254, 37.00990255456793],
              [74.841911417464971, 37.005884961974154],
              [74.841369906720232, 36.999560286464742],
              [74.842629178921101, 36.996281099177082],
              [74.846018854968477, 36.990006700782317],
              [74.848869032931162, 36.987726215357974],
              [74.855971779209966, 36.979837623226601],
              [74.860226382403127, 36.976753897872591],
              [74.867390264197056, 36.967231775257652],
              [74.872252849754389, 36.962131611770886],
              [74.87507696212856, 36.959735165672988],
              [74.87935379712556, 36.954174038027496],
              [74.881988562225786, 36.951299282587421],
              [74.884938751584798, 36.948266994620404],
              [74.887900114628835, 36.946007963454178],
              [74.892558676594362, 36.937110190813428],
              [74.896805309624142, 36.932933724191933],
              [74.900337748900341, 36.927704307498232],
              [74.9024624952349, 36.924866557734511],
              [74.904839981200581, 36.920712615569052],
              [74.908822739336046, 36.916943899589846],
              [74.910867060845703, 36.912511885852517],
              [74.913995477137078, 36.910301444714378],
              [74.916808623581616, 36.908311215629496],
              [74.922142181381048, 36.906149351650697],
              [74.927372202732684, 36.908916951506434],
              [74.931493967557145, 36.92146876311957],
              [74.93259634587379, 36.92552805859453],
              [74.939207245310314, 36.93274401861629],
              [74.94322739792544, 36.935269375084808],
              [74.947068807389172, 36.938224270865135],
              [74.957337896579133, 36.942301986461516],
              [74.961113929421799, 36.945755637962051],
              [74.96622182550378, 36.947681004423302],
              [74.972145982147055, 36.951271965716295],
              [74.977092772113153, 36.952832079630078],
              [74.980022914019045, 36.95481984757869],
              [74.983178972437273, 36.9567897008911],
              [74.988110938675433, 36.960506013564789],
              [74.991117873324853, 36.962881863210733],
              [74.995022410286566, 36.964289961720709],
              [75.008626831936994, 36.96444958545402],
              [75.011933159600588, 36.966032804309982],
              [75.018713379498806, 36.97642929437211],
              [75.023450722393903, 36.975802405556379],
              [75.026262191715176, 36.973833339152222],
              [75.03073705218489, 36.973657232508273],
              [75.036501166429971, 36.971225114598816],
              [75.040533929881306, 36.970406287221408],
              [75.043671260803393, 36.967762185866],
              [75.047882623437346, 36.9651269664379],
              [75.054936072637346, 36.963253739244976],
              [75.058276618724264, 36.961654463275181],
              [75.063035391209056, 36.9599364826299],
              [75.067241770166376, 36.957529019897819],
              [75.070272279119123, 36.955858996039183],
              [75.074030499322518, 36.951787208260029],
              [75.078568022081384, 36.948247807682613],
              [75.085304209010701, 36.943733123666185],
              [75.095928834284607, 36.942850147881828],
              [75.100346938046727, 36.94401412608773],
              [75.105611046348557, 36.946774812493238],
              [75.115047550715076, 36.948879259062622],
              [75.118237838269081, 36.950664311064301],
              [75.124973829856685, 36.953443962105396],
              [75.127846611074588, 36.955543384317295],
              [75.131788594194902, 36.956539985408348],
              [75.13581693257008, 36.957425632785416],
              [75.139576417697782, 36.960556266345804],
              [75.144011486823672, 36.962378201208345],
              [75.14648749553551, 36.96465433637696],
              [75.151050405465469, 36.967157474248808],
              [75.16375935956026, 36.978928074626829],
              [75.166719904241589, 36.980982957406063],
              [75.173356784950229, 36.98618865479348],
              [75.175440343070647, 36.989779155299701],
              [75.180898147828913, 37.000584282122183],
              [75.187412180625515, 37.00794742928079],
              [75.193352402612547, 37.014257725453199],
              [75.198127449204861, 37.017761448766315],
              [75.202253721606198, 37.021168204124109],
              [75.207964262985016, 37.035404249281441],
              [75.214900616154097, 37.038428700333419],
              [75.221712895701629, 37.037455782982505],
              [75.225618018423575, 37.037496745625212],
              [75.230029815016366, 37.039334973336373],
              [75.238830608397478, 37.042629524359711],
              [75.243566451524728, 37.045290343891537],
              [75.248860414534903, 37.046913418378878],
              [75.251881631296001, 37.048941584947812],
              [75.256817546619132, 37.049993133316356],
              [75.264935072402139, 37.051983756353017],
              [75.27138053120747, 37.049367197856263],
              [75.275819629997102, 37.048117706082138],
              [75.282286542345815, 37.047478533542126],
              [75.285858342249242, 37.048830839458844],
              [75.293630759791384, 37.051158446342008],
              [75.302284658389951, 37.051676692763721],
              [75.305888600653248, 37.052846190812211],
              [75.311146499401559, 37.053353203254176],
              [75.31546673097013, 37.054010201612307],
              [75.332855638266821, 37.055338202512161],
              [75.337909476575334, 37.054502318386952],
              [75.342636395720149, 37.052980010118027],
              [75.345879808022161, 37.043856323694932],
              [75.34531199808066, 37.040648796007503],
              [75.343864286577187, 37.032636532402179],
              [75.344007935247788, 37.024256620460513],
              [75.34408731907962, 37.019689535457104],
              [75.345591166791806, 37.011208436013959],
              [75.345163556779795, 37.003137500756466],
              [75.346666092626535, 36.994767704323188],
              [75.347485193091131, 36.991526947325362],
              [75.351965947211269, 36.981072574523409],
              [75.35462355699913, 36.977869882478949],
              [75.357355105368541, 36.975305955712294],
              [75.362722029463285, 36.970881990084472],
              [75.366968273018841, 36.967353851038141],
              [75.37428425605421, 36.961379286786709],
              [75.377919275733959, 36.960528804032116],
              [75.384638101110554, 36.959682562120598],
              [75.389897292545442, 36.961504577484412],
              [75.394277754173203, 36.965158984858881],
              [75.400089542460719, 36.967872658792601],
              [75.413476095892847, 36.967564913150952],
              [75.417443305001896, 36.965489825924443],
              [75.420083356224751, 36.963172258903853],
              [75.423037971806309, 36.960723084425396],
              [75.425891170774761, 36.955817539854102],
              [75.427905326067062, 36.952018228735469],
              [75.427172681611054, 36.946693654312355],
              [75.426463313706407, 36.939938534963851],
              [75.425532860889078, 36.936337723391276],
              [75.422415262954374, 36.931626688814141],
              [75.419684165975994, 36.929147609014791],
              [75.416359169773528, 36.926639440654654],
              [75.413446904658528, 36.923203612066189],
              [75.408746567674626, 36.916750238886607],
              [75.411638610225097, 36.912844575276132],
              [75.413559422740065, 36.909612467034968],
              [75.415076329805359, 36.903374398422329],
              [75.414162549583324, 36.891954781952421],
              [75.415894341019197, 36.888152924484267],
              [75.42230822998269, 36.886666372892321],
              [75.430317950707419, 36.891219026581901],
              [75.437805422661825, 36.891515169467006],
              [75.443443399198685, 36.887292437746602],
              [75.448022332786522, 36.880424235698555],
              [75.449175437727405, 36.877297065840352],
              [75.45109018507992, 36.870768049765644],
              [75.451986161184792, 36.86786414735878],
              [75.452910314582581, 36.863099304623439],
              [75.45336575615282, 36.859421498143767],
              [75.452590947757017, 36.854933583849807],
              [75.45663906663647, 36.845808116426092],
              [75.459964489079994, 36.830627189075024],
              [75.462819526498947, 36.825288232120428],
              [75.469891341923784, 36.817710721316722],
              [75.474183065722613, 36.810813518215788],
              [75.478965456900085, 36.806832131655483],
              [75.483305530720045, 36.805687116405757],
              [75.488187416692071, 36.80423044868656],
              [75.491810107423731, 36.802034311729251],
              [75.497121054727245, 36.800284043969476],
              [75.50050311179254, 36.798973010321902],
              [75.503585927021803, 36.796998605151273],
              [75.507507395260106, 36.79546314328752],
              [75.5128242082139, 36.793259852650444],
              [75.516153457300874, 36.791720165750682],
              [75.522574969698212, 36.789319891264043],
              [75.52791265378454, 36.787569622485968],
              [75.532411291845349, 36.787016427171011],
              [75.536864205522846, 36.785871962491228],
              [75.542148926176736, 36.783870504452224],
              [75.548561652527013, 36.781923902365534],
              [75.555274968296956, 36.780640360237449],
              [75.566438431872868, 36.776480880108757],
              [75.570907715480303, 36.776064579819163],
              [75.578748535218296, 36.772992553440581],
              [75.586311038263332, 36.769710463728032],
              [75.593320121041742, 36.765515652974003],
              [75.597478362690637, 36.765096253241261],
              [75.603339240704997, 36.764053104425919],
              [75.609440954298648, 36.763874800122956],
              [75.614780362259964, 36.761873041449455],
              [75.620125979133363, 36.757457216636446],
              [75.623533574132935, 36.750320989614842],
              [75.629122882663893, 36.744725511010742],
              [75.631956285052098, 36.742064693291795],
              [75.638769799669078, 36.735659196755286],
              [75.640828752337114, 36.731876004617263],
              [75.645281917028655, 36.726543207178246],
              [75.651467652670419, 36.722340207562439],
              [75.660501763521836, 36.712561433045295],
              [75.663869463134432, 36.709903459057713],
              [75.666433227420484, 36.706306032398878],
              [75.675159086242232, 36.69609099825513],
              [75.690514639704475, 36.671820232297279],
              [75.694537270192569, 36.666709361902157],
              [75.701835150798658, 36.657345879576098],
              [75.707947507119641, 36.64785834473318],
              [75.712143115923041, 36.642382806392561],
              [75.714226795007832, 36.638553419312871],
              [75.719689519366369, 36.631062073559114],
              [75.729550263282405, 36.613454023220037],
              [75.733357828696711, 36.607178305870619],
              [75.738230176754044, 36.601411555528777],
              [75.742348238551614, 36.597207802586034],
              [75.748304167949499, 36.588466962483217],
              [75.753918406851867, 36.584024696948248],
              [75.760634670425688, 36.579386039524302],
              [75.769342303048418, 36.573393707923458],
              [75.776293673225368, 36.570099641305816],
              [75.781878331012521, 36.567658373058926],
              [75.78801158164309, 36.564334639301102],
              [75.793905439613766, 36.559914140944286],
              [75.801970228687978, 36.557513214673662],
              [75.806183080331593, 36.554403193816597],
              [75.809526442496761, 36.553059141985344],
              [75.814559873627516, 36.551774927943526],
              [75.818744038119249, 36.550893461268295],
              [75.824296434536947, 36.548703064308178],
              [75.833451086073211, 36.546967340136959],
              [75.839568697843276, 36.546804264874211],
              [75.849041979934626, 36.544387998081163],
              [75.852678810426838, 36.542023697920243],
              [75.856588991566909, 36.540411511591806],
              [75.859777660453673, 36.537768768233768],
              [75.863290622964712, 36.536402677773658],
              [75.865826091800358, 36.534190002763225],
              [75.877794779703834, 36.525777552904607],
              [75.882306538985546, 36.523326524020582],
              [75.885371080268939, 36.521549330021358],
              [75.889318614681386, 36.519116452285928],
              [75.895719190355123, 36.516448477329263],
              [75.901572154226855, 36.512479962107577],
              [75.905187618538775, 36.511821030765759],
              [75.908281955039413, 36.509837991133303],
              [75.913549989725965, 36.507616623746614],
              [75.917771899688987, 36.505618882237883],
              [75.923331452486593, 36.502512096803841],
              [75.931689526717093, 36.501017049887814],
              [75.940686684023134, 36.497773452309829],
              [75.944752492229981, 36.497046309212905],
              [75.951715615874349, 36.494175755765873],
              [75.955613566726797, 36.493334829970834],
              [75.959519621005441, 36.491764848193434],
              [75.964779792126336, 36.490021741991796],
              [75.971626623397029, 36.489928712233301],
              [75.976731112666641, 36.489413983691954],
              [75.982869359708928, 36.487218222021312],
              [75.989525407668864, 36.486577139090542],
              [75.993706991661114, 36.485484839681909],
              [75.998138796256214, 36.484625438954261],
              [76.002004231104507, 36.486652267482327],
              [76.021135455427952, 36.486308480362013],
              [76.025842239861817, 36.486108531257017],
              [76.030562793013203, 36.484587294023413],
              [76.040011978433839, 36.483503601972835],
              [76.04815224929763, 36.480931912575095],
              [76.053089109371712, 36.480231967252351],
              [76.060565667538526, 36.479158410112561],
              [76.064467568102572, 36.477814788369479],
              [76.069201778520124, 36.477612366684589],
              [76.072544377934037, 36.475854606268314],
              [76.077263764329658, 36.474334279622042],
              [76.080897798338086, 36.471643783083408],
              [76.083961407338862, 36.469633951068033],
              [76.088708039786752, 36.465630111901831],
              [76.093472783840241, 36.462421089895152],
              [76.097217226285636, 36.459702467964171],
              [76.100313634951988, 36.45723558734349],
              [76.106826973931533, 36.451066944673705],
              [76.110226932920497, 36.448603343555881],
              [76.113632835833727, 36.445646137544387],
              [76.119194053094162, 36.442447383042776],
              [76.121975122858601, 36.440231903921564],
              [76.125077529298096, 36.437519996553007],
              [76.130355387180401, 36.431588927586027],
              [76.135005094837354, 36.426653117772723],
              [76.138104498757741, 36.42368937616147],
              [76.143688669664641, 36.41801254992648],
              [76.147726244077674, 36.41332042629503],
              [76.150825261037198, 36.410107164482824],
              [76.154548380645153, 36.40566006414555],
              [76.159496096135271, 36.40196315605175],
              [76.167239201106156, 36.394804231149543],
              [76.173113692671521, 36.390367913744903],
              [76.177734379463899, 36.388154312098514],
              [76.183569011370508, 36.387689326095312],
              [76.191844239492369, 36.388470537239435],
              [76.198606324798064, 36.387510723659915],
              [76.202313041999972, 36.385050526805898],
              [76.207346192396258, 36.381534444113385],
              [76.210134163343142, 36.378381269368127],
              [76.213220809291812, 36.376367058961982],
              [76.217101413699709, 36.373721426610295],
              [76.219355436323283, 36.370359473435016],
              [76.224881556265075, 36.366239493374721],
              [76.228287902726819, 36.363135547836102],
              [76.231631593468876, 36.360552488570917],
              [76.235820010592803, 36.357974862428719],
              [76.238599760381405, 36.355642345166942],
              [76.243633639069714, 36.352748987408532],
              [76.247218522838693, 36.351421724793106],
              [76.251108549199998, 36.350755506675654],
              [76.254735122498289, 36.347855715315085],
              [76.268865093950666, 36.347257353196703],
              [76.280052125476317, 36.348446966604421],
              [76.284442309700324, 36.348398095055572],
              [76.292116668107525, 36.349159504181713],
              [76.297365620282008, 36.350528092384003],
              [76.301767882889251, 36.352346970489499],
              [76.31115868756693, 36.356396351921404],
              [76.315171099373345, 36.357665568575726],
              [76.324111962871925, 36.361849844166692],
              [76.328214406138684, 36.362571674736898],
              [76.340736207665202, 36.362577299564116],
              [76.352378908148552, 36.359936053831291],
              [76.360760257123545, 36.353475400831016],
              [76.365447228033574, 36.351467570803933],
              [76.369107861182499, 36.347677610909521],
              [76.374638075708589, 36.345669832266537],
              [76.378212775128304, 36.34192397260059],
              [76.382581353643573, 36.337521125286528],
              [76.385893071137588, 36.334821682768961],
              [76.388784163402434, 36.332236560539776],
              [76.393087223099471, 36.328697793581583],
              [76.397238998952361, 36.326480873434981],
              [76.401131629797234, 36.321572551633665],
              [76.40421324964889, 36.319556722073287],
              [76.408104522362933, 36.318226929807672],
              [76.411441344627789, 36.31598116016292],
              [76.420322121243146, 36.313347373041793],
              [76.425035582896896, 36.311109524537166],
              [76.428392352229054, 36.309777839379649],
              [76.431976592311827, 36.308217611336325],
              [76.43405006324987, 36.30177484659086],
              [76.436538614364096, 36.288498898437112],
              [76.440178444555244, 36.283109383473409],
              [76.445501250926327, 36.278206826818412],
              [76.449428991311038, 36.271701066385312],
              [76.448343471966851, 36.266342051202706],
              [76.44504441104678, 36.263845072702125],
              [76.441484653343679, 36.262489461878566],
              [76.438441240478923, 36.259560322065852],
              [76.43239678828823, 36.252133317121221],
              [76.437114911317423, 36.249003223279047],
              [76.440973414565832, 36.248059874120379],
              [76.444919514075224, 36.24656900841557],
              [76.449596564872323, 36.245011551163941],
              [76.454060482976757, 36.241904255809295],
              [76.457959508401274, 36.239205525651855],
              [76.464639253204425, 36.232732251146842],
              [76.473913532126147, 36.221181957829806],
              [76.479162722309553, 36.213927732332515],
              [76.48168180839042, 36.211474113718921],
              [76.488488059933559, 36.210697319139378],
              [76.493299089638484, 36.209937905827076],
              [76.498281644997363, 36.208608775587081],
              [76.504641352041077, 36.207284870853329],
              [76.509186340416548, 36.204243473104604],
              [76.512711104010251, 36.202384907426904],
              [76.518803333252151, 36.199030423553182],
              [76.525920036261368, 36.197796978254978],
              [76.535569695604039, 36.196070129168],
              [76.540697371298478, 36.193942392084729],
              [76.544834832985771, 36.192814441896324],
              [76.549271637303463, 36.188723940285712],
              [76.55254956503795, 36.185973933640348],
              [76.55609263213897, 36.181059917207534],
              [76.558225972045676, 36.176939491837693],
              [76.562942343604107, 36.173122246444798],
              [76.580951233441453, 36.168246372123335],
              [76.587019407250992, 36.168033475845291],
              [76.595063798456962, 36.166253182159295],
              [76.60113560457161, 36.165608583414226],
              [76.603902840188127, 36.167848948739213],
              [76.608864978528672, 36.16964070495311],
              [76.614939544303795, 36.173257186459693],
              [76.619051881228231, 36.176185878168489],
              [76.622642406161717, 36.177108005935615],
              [76.625411323347507, 36.179121072178091],
              [76.630655574896878, 36.180705178034607],
              [76.633567168442397, 36.182605679181933],
              [76.636421081192779, 36.184526795740766],
              [76.642235795569121, 36.184769117875057],
              [76.648080357598815, 36.174681312119972],
              [76.664772355183402, 36.158119628941307],
              [76.667985902623386, 36.155985278129606],
              [76.681439138985709, 36.145591803796947],
              [76.684760049061381, 36.144230937969866],
              [76.688764695885283, 36.14100148574078],
              [76.691698593329221, 36.138635598578119],
              [76.696149637228345, 36.135954277547825],
              [76.700572604838754, 36.133067510320686],
              [76.701963597386367, 36.130128542041419],
              [76.706426240456182, 36.125211684686413],
              [76.707040525617714, 36.114881460531784],
              [76.708705953290973, 36.107472455531578],
              [76.71290182746273, 36.099407798311177],
              [76.716836667778992, 36.08730351252958],
              [76.719607347183114, 36.08327331510489],
              [76.722396891514336, 36.081018874954502],
              [76.725974545469157, 36.078541139127346],
              [76.730640789059294, 36.077067179260091],
              [76.738708826623238, 36.07454795095402],
              [76.745099421155928, 36.070271850760477],
              [76.751004067619832, 36.068068495750452],
              [76.75822953389978, 36.065457629898781],
              [76.766943089403469, 36.062439632074472],
              [76.771975738441185, 36.060371016945766],
              [76.77495940340512, 36.058436052103858],
              [76.779681586956329, 36.056643253833819],
              [76.782468884752106, 36.054639299653971],
              [76.785508933481978, 36.052613670265195],
              [76.789947446496399, 36.051479518451494],
              [76.797672253545954, 36.049711196952352],
              [76.80183343257734, 36.047914408605308],
              [76.801173257928085, 36.044629054679383],
              [76.799080691729984, 36.041867070766969],
              [76.798814994496382, 36.038490068041014],
              [76.80105558858213, 36.032879921937194],
              [76.808570263772552, 36.020527299271976],
              [76.806087225521608, 36.017169019347442],
              [76.783173794856111, 36.015766211075281],
              [76.778497077236452, 36.013842930357718],
              [76.773260320026438, 36.011736281313198],
              [76.770241814625578, 36.009496334942973],
              [76.765605773401205, 36.004788783154545],
              [76.754314413978619, 35.990143788351318],
              [76.752956944785311, 35.986537330237475],
              [76.754597663081583, 35.983390274314552],
              [76.741979788210827, 35.97102531826831],
              [76.735633548848796, 35.967179263374177],
              [76.73012919566979, 35.962926849112002],
              [76.723546210998904, 35.955954578791641],
              [76.726889952897608, 35.948771703148815],
              [76.730488069329738, 35.946747474654416],
              [76.733841443377997, 35.943398134243729],
              [76.740469604571729, 35.934875463934453],
              [76.746663690817471, 35.929134087595095],
              [76.752700037382454, 35.921179449224397],
              [76.756020308601805, 35.918491727088004],
              [76.765701895607535, 35.909742724333569],
              [76.77166823679525, 35.904481049269037],
              [76.779007421367666, 35.898741011147948],
              [76.785659845698902, 35.890006843434684],
              [76.790091391613856, 35.876181046814388],
              [76.791266079968509, 35.870247452064852],
              [76.794042857248286, 35.862832517951396],
              [76.79877947667859, 35.855876620356703],
              [76.801534236610834, 35.85362024947117],
              [76.803760115257191, 35.850472979287098],
              [76.807609225330765, 35.847808484492433],
              [76.811767652357645, 35.844867499806178],
              [76.815357984631049, 35.843549101328314],
              [76.820268601908595, 35.841408680902511],
              [76.824588942694035, 35.839794784049069],
              [76.829445595546616, 35.837036146340822],
              [76.836650242664689, 35.835469892527577],
              [76.842958102557574, 35.834153268983918],
              [76.853437786764204, 35.832818895214835],
              [76.85786963625101, 35.831225448826871],
              [76.862025676833511, 35.828078350800979],
              [76.865336493853619, 35.826530112131096],
              [76.869693013490846, 35.822288753631454],
              [76.875850935463319, 35.815306733300702],
              [76.884700259861035, 35.807438901513912],
              [76.891324663704268, 35.802717147366238],
              [76.894919031910021, 35.799797571203584],
              [76.90044333412925, 35.797564738427788],
              [76.903642105573581, 35.795398153329934],
              [76.909563047063486, 35.791498418090704],
              [76.917827688848192, 35.789815845725009],
              [76.928838400552522, 35.787471048511037],
              [76.935203260167839, 35.784118816365108],
              [76.943155462581103, 35.783802710328608],
              [76.956958082946755, 35.783902256021243],
              [76.9619428767637, 35.783219714885384],
              [76.967709365159592, 35.783221217373573],
              [76.972108371893171, 35.782105123604325],
              [76.97765386184625, 35.781445188326046],
              [76.983425834757966, 35.779392293541626],
              [76.989221698457612, 35.778937232998224],
              [76.995554828215219, 35.776702209177266],
              [77.000931012236265, 35.776338094397595],
              [77.004404801013138, 35.775151654896838],
              [77.020641850017725, 35.77469780557054],
              [77.024782686485921, 35.776045440532158],
              [77.033292277963227, 35.776479172945756],
              [77.038270779918534, 35.778284741467708],
              [77.042693441340617, 35.778740111894479],
              [77.047085910877527, 35.780087647229919],
              [77.051197423561248, 35.781870210712718],
              [77.054496789681139, 35.783696916015806],
              [77.058638902645455, 35.78435755420066],
              [77.062051095967405, 35.786389787278431],
              [77.065826127052972, 35.788398545793648],
              [77.068846474629211, 35.790430668026858],
              [77.074048346221858, 35.793330252311719],
              [77.078746554548701, 35.79693741299829],
              [77.085828743551431, 35.797210858415085],
              [77.093335715752644, 35.796042855792763],
              [77.099943610392913, 35.7960413138603],
              [77.105762780967211, 35.798734641351501],
              [77.113322656434974, 35.798525580294424],
              [77.116769229825039, 35.796926816937919],
              [77.122551274823152, 35.786829692533125],
              [77.12698152476537, 35.782763554299194],
              [77.136080993936034, 35.78186802291728],
              [77.141608900109517, 35.771519599272828],
              [77.145727280622779, 35.768595890643212],
              [77.150599346421743, 35.767495292771841],
              [77.1553875497316, 35.766351708159078],
              [77.158408488819404, 35.768130457380501],
              [77.164205163571552, 35.766801153670308],
              [77.165019783002521, 35.763649480378277],
              [77.165583080435681, 35.760270249528304],
              [77.163136978042985, 35.744490640122081],
              [77.16311387583805, 35.740583988511389],
              [77.167260963140521, 35.734642930944318],
              [77.175296217152678, 35.731782681949113],
              [77.180221011333671, 35.731024627535902],
              [77.186013987266435, 35.731476429531163],
              [77.193708602831094, 35.733045242435615],
              [77.198634832981995, 35.730666649837012],
              [77.202806172517768, 35.72762565483815],
              [77.20720129350326, 35.726523600101068],
              [77.211425524478983, 35.726771267559634],
              [77.217104953791122, 35.728753459831935],
              [77.220994525458678, 35.728291841909424],
              [77.224556299084711, 35.715040180128284],
              [77.228166896942668, 35.71254772240048],
              [77.239190652511624, 35.712764208846387],
              [77.255697999014203, 35.710050156846656],
              [77.265603396778928, 35.709579418591559],
              [77.270835412827324, 35.710031057856519],
              [77.274135484582544, 35.717907078323542],
              [77.277521088633819, 35.720459097033782],
              [77.280151698828206, 35.7183551135263],
              [77.285439884692764, 35.711130195708321],
              [77.290391283535428, 35.709546127850395],
              [77.298645595909903, 35.708186876861696],
              [77.302729420090003, 35.704938387925964],
              [77.307177527343356, 35.702120471129973],
              [77.310785213798695, 35.700082951972504],
              [77.315178078656132, 35.699185054558619],
              [77.3215034771235, 35.7072617424679],
              [77.324974592502954, 35.716644521213951],
              [77.327578040657087, 35.719151867877279],
              [77.338295355491965, 35.719589974693299],
              [77.350829741923263, 35.718289747405443],
              [77.355698829346622, 35.718281239049851],
              [77.369146500437452, 35.704482015264524],
              [77.370234241974487, 35.699090318797587],
              [77.370790373904853, 35.695250473453299],
              [77.374902102968392, 35.694122988662116],
              [77.38016141237118, 35.693885736169477],
              [77.383740511990851, 35.692073187726251],
              [77.386480304975166, 35.689828566132796],
              [77.388126776278625, 35.685783633445062],
              [77.392149991396991, 35.680384309253832],
              [77.396922607978553, 35.669797111134088],
              [77.401586708942773, 35.662589124968143],
              [77.413247790952241, 35.661812384943076],
              [77.422085256163754, 35.66167792390749],
              [77.425830438443697, 35.659841715325186],
              [77.429321654548346, 35.656864378522684],
              [77.436551412456041, 35.645881142011284],
              [77.437324545860506, 35.63911558967613],
              [77.43376522398701, 35.632406309480494],
              [77.436771314266664, 35.622278106798099],
              [77.434839243185465, 35.619104934902637],
              [77.428150230571774, 35.613475902948679],
              [77.427112329168381, 35.610598598820651],
              [77.431888884759928, 35.607389123933046],
              [77.437305703598, 35.603354516480941],
              [77.443900263279815, 35.601099920120411],
              [77.447753360150344, 35.598601629665787],
              [77.453647020250727, 35.595866643064284],
              [77.456830622611449, 35.593665620427949],
              [77.464524030874827, 35.580117677782631],
              [77.46557525089726, 35.57337338533663],
              [77.464283951107603, 35.569674207520428],
              [77.460642326824654, 35.563283431697116],
              [77.459793199493603, 35.555856001840091],
              [77.461151692664785, 35.549774392449564],
              [77.461957240588177, 35.546184094314015],
              [77.46583719174815, 35.544345348111982],
              [77.468851474037606, 35.542098720470079],
              [77.474938840433836, 35.540025061602208],
              [77.478373574518741, 35.538919601262947],
              [77.482587382842681, 35.536668140287055],
              [77.486130798463563, 35.533734757159756],
              [77.486013496907631, 35.53064911905966],
              [77.483661880049752, 35.527887687417312],
              [77.478433604020168, 35.524976415349322],
              [77.474855105688619, 35.523407560304591],
              [77.472393601683933, 35.521174424119074],
              [77.467702084368099, 35.522100406474053],
              [77.463571942736849, 35.524121895142123],
              [77.451760058345556, 35.526640963191333],
              [77.446533994566067, 35.525052791603777],
              [77.441302718781671, 35.519007977684829],
              [77.435266415058507, 35.517442999525102],
              [77.431134114169794, 35.518779143328054],
              [77.428679667135711, 35.521733732781009],
              [77.425387340184855, 35.524003985465733],
              [77.420696062782255, 35.525568204658789],
              [77.416591885905419, 35.527154664013644],
              [77.412736436275182, 35.527162397566386],
              [77.408883095955346, 35.528291482631246],
              [77.405896086887111, 35.530972517768056],
              [77.402604335918127, 35.534658619248596],
              [77.397469512747122, 35.540544816511286],
              [77.395069269694844, 35.542833674106838],
              [77.391858825952767, 35.545882131731922],
              [77.385519560250515, 35.548590071520692],
              [77.381412662756105, 35.549283882870007],
              [77.367276772284313, 35.550386038101195],
              [77.359452798211848, 35.54971397415099],
              [77.348667534801436, 35.547768296788647],
              [77.34263127309427, 35.544831255070946],
              [77.337881136295536, 35.543444137215914],
              [77.331901599706981, 35.541260257641497],
              [77.32667597384291, 35.537680261414096],
              [77.322206183544893, 35.536863197265404],
              [77.320417624857683, 35.534031473227031],
              [77.325723593390109, 35.529246344356885],
              [77.328934879408209, 35.527160437017372],
              [77.332229688761188, 35.524642114652735],
              [77.340771972627664, 35.513951719663858],
              [77.34322853227178, 35.5107933664382],
              [77.345905499533615, 35.500065129675477],
              [77.34866670499629, 35.493750592881476],
              [77.354418760029304, 35.492849608923052],
              [77.357715031706775, 35.495107255488577],
              [77.366259797734841, 35.493720364456017],
              [77.373677685936372, 35.481337080931297],
              [77.377780353372287, 35.47842479645422],
              [77.381911308074791, 35.476587462152473],
              [77.394250156600961, 35.474093642809329],
              [77.406368446426214, 35.474527726159053],
              [77.411002928041498, 35.473167078242753],
              [77.415161631543057, 35.472723812824775],
              [77.418174657012642, 35.470659870442439],
              [77.421635664557712, 35.469028950891953],
              [77.425848645281903, 35.467282796475743],
              [77.429420709505749, 35.46503301928103],
              [77.437177819086273, 35.462249955208897],
              [77.444825594238722, 35.461387126476403],
              [77.450579677090204, 35.462951483431532],
              [77.453988855335311, 35.465023564649421],
              [77.457454228310326, 35.467209654894631],
              [77.460221129404403, 35.469237598482756],
              [77.464328606749646, 35.471239988251163],
              [77.469832316266022, 35.473238461364865],
              [77.473688163823695, 35.4752407249971],
              [77.477320313752315, 35.476421718982344],
              [77.486875566355167, 35.480649737746162],
              [77.492380852342947, 35.482874900998262],
              [77.498442307670018, 35.48397934348705],
              [77.501712082293437, 35.485321455694894],
              [77.507802100739525, 35.487110930247731],
              [77.511463414106686, 35.488197305190994],
              [77.516853433724179, 35.488664249603374],
              [77.520704681038467, 35.487737522335564],
              [77.525085992007718, 35.486171380912239],
              [77.529214873480839, 35.484330570192611],
              [77.534459453204249, 35.482259594245008],
              [77.539931025639987, 35.481396954596484],
              [77.550375317937508, 35.482029731157112],
              [77.554203876844213, 35.483389784319336],
              [77.560548778673976, 35.486298738346377],
              [77.568811772976602, 35.485131037819549],
              [77.57210275565491, 35.483542401428053],
              [77.574275385878806, 35.481066910382481],
              [77.577592240547432, 35.478906778516787],
              [77.581966732843654, 35.475190457002611],
              [77.585793710165916, 35.475840378768041],
              [77.591295442191083, 35.476508326279564],
              [77.595147826328073, 35.475811915446727],
              [77.603129932042904, 35.474687162987166],
              [77.614088252345795, 35.469689845523803],
              [77.62208001807295, 35.47169946323735],
              [77.625351982286134, 35.473699195383446],
              [77.631728791990241, 35.477358616563109],
              [77.635561838888293, 35.479746179372256],
              [77.638891596976805, 35.481976754562012],
              [77.642735388071358, 35.488273874800768],
              [77.64687011895964, 35.488486530806199],
              [77.650691669930197, 35.487330973441743],
              [77.653721723002363, 35.483067831315196],
              [77.658203657286535, 35.478958291878826],
              [77.664665055404541, 35.4735629270739],
              [77.670185199480741, 35.471073596557886],
              [77.678698392475553, 35.47058479626336],
              [77.683941478781065, 35.47687580175694],
              [77.69519675303448, 35.47772731357194],
              [77.70197774179276, 35.476741388399084],
              [77.708958262475633, 35.476530375589505],
              [77.715235624010219, 35.475384993013634],
              [77.722942731449649, 35.475585605410622],
              [77.72646936950683, 35.484944751170389],
              [77.726036749216803, 35.488627243727962],
              [77.722780575666789, 35.498974998684929],
              [77.723915680452535, 35.511198982796394],
              [77.724461235059366, 35.515198100618115],
              [77.727028137425094, 35.521544004705859],
              [77.733576094589381, 35.524604140582326],
              [77.737424897889071, 35.523240337203383],
              [77.740675514828283, 35.518722830125647],
              [77.744798429316802, 35.51600784023573],
              [77.748716999827806, 35.511101250133379],
              [77.758317463208414, 35.502283497922939],
              [77.761518964654343, 35.499959605136169],
              [77.765335541456366, 35.497680032007821],
              [77.772782397029829, 35.495408425142244],
              [77.778337736101761, 35.494700226168597],
              [77.783755560907011, 35.494700074037475],
              [77.787334810589641, 35.495805496219901],
              [77.791725096503455, 35.497363009348028],
              [77.795058508717588, 35.499360729372178],
              [77.797832115640716, 35.501382991655142],
              [77.802235844048738, 35.505867834052076],
              [77.808293730999011, 35.511259645744168],
              [77.812154158152609, 35.512567202330963],
              [77.815983588219396, 35.513441586273238],
              [77.81927244361404, 35.511873185710677],
              [77.823959954007151, 35.510730423347752],
              [77.827529826104396, 35.509571723457711],
              [77.831370761513213, 35.506856800834989],
              [77.839050704735584, 35.500969466388312],
              [77.842896632611343, 35.499168564572543],
              [77.847262836375151, 35.495535865865854],
              [77.854650009990422, 35.49280443107542],
              [77.861225445987756, 35.483993286400313],
              [77.864505733444261, 35.481279684137661],
              [77.868884422696382, 35.480139448123495],
              [77.872496035232913, 35.482155967791186],
              [77.875523466601734, 35.48438134334878],
              [77.879915232604276, 35.485916428083037],
              [77.885693236837426, 35.485453300785373],
              [77.888416794834257, 35.482971429852405],
              [77.889757798881433, 35.477796940440541],
              [77.894424736845551, 35.473269177497045],
              [77.898046401863297, 35.471490823059867],
              [77.901266399153016, 35.468115133084254],
              [77.905936151400994, 35.469372518315744],
              [77.911094459862738, 35.478354429204053],
              [77.912870190956767, 35.481499756031212],
              [77.915345035543865, 35.484848514059145],
              [77.918947524884828, 35.489791206579476],
              [77.920646871646369, 35.494287836606617],
              [77.925306794548789, 35.493600997572358],
              [77.929846806123265, 35.491474534136827],
              [77.932712940558602, 35.489493068039579],
              [77.937377049613502, 35.484736868108413],
              [77.940180462619963, 35.481909288616798],
              [77.945832732575866, 35.478862732014044],
              [77.953002565933673, 35.47308621489595],
              [77.956249274841269, 35.469570558095775],
              [77.961985955839225, 35.467070324160503],
              [77.969349577135787, 35.461178084032746],
              [77.971844531008941, 35.458236692724718],
              [77.975412899213381, 35.45730444641913],
              [77.982523205803219, 35.455916558418281],
              [77.986119867076013, 35.459738934590689],
              [77.984251811494303, 35.464685941423205],
              [77.980978711010053, 35.468316405809858],
              [77.976662103595459, 35.470170336824722],
              [77.972464509797675, 35.473301551522994],
              [77.968620670896399, 35.474695650389471],
              [77.967522482090502, 35.477833922193774],
              [77.963987295682102, 35.484596896481079],
              [77.963755861190407, 35.48798052322465],
              [77.964587032814805, 35.491566898654511],
              [77.964893300328413, 35.496068655999281],
              [77.960003730108653, 35.500599418079879],
              [77.95339912433181, 35.503103684041932],
              [77.949364618798256, 35.505616342085659],
              [77.944898321946724, 35.506074189437136],
              [77.941172937906757, 35.508949674231495],
              [77.937215957791665, 35.510617205402461],
              [77.933651240236316, 35.512442505347309],
              [77.931211877104417, 35.515814148557851],
              [77.93244645761213, 35.521796506710658],
              [77.937617552617453, 35.532216940135868],
              [77.941413880500136, 35.536768765628238],
              [77.949619699517086, 35.545069073421679],
              [77.958398402262119, 35.55572119323076],
              [77.961160723888113, 35.559752616389844],
              [77.963963901322558, 35.566159870182091],
              [77.965691746808844, 35.570081283233641],
              [77.96728579168753, 35.575032735379558],
              [77.965991246181233, 35.587632965782156],
              [77.961642736144341, 35.594421326196546],
              [77.958620169235161, 35.598480919680206],
              [77.955893738841382, 35.60073540795041],
              [77.952463873293084, 35.607038319286552],
              [77.965109627756235, 35.603931367533612],
              [77.969363360314532, 35.600206642605379],
              [77.977043061739778, 35.594337827158391],
              [77.980867280077661, 35.58892346996393],
              [77.983592349733655, 35.586645959345901],
              [77.986343467798108, 35.58393455256013],
              [77.99099850041938, 35.581897636131821],
              [77.994828126034676, 35.582036153074817],
              [78.003666574003404, 35.583152874190624],
              [78.009124689592042, 35.584447544922682],
              [78.024322956959594, 35.587974717358179],
              [78.041927178444254, 35.587438783037854],
              [78.045212710154672, 35.585614365183154],
              [78.048685590003771, 35.582463841647041],
              [78.054492036573336, 35.577309199865851],
              [78.064864753206209, 35.565593068975367],
              [78.067893398250646, 35.562992332482629],
              [78.072817064519981, 35.555556384888554],
              [78.077690226569828, 35.54921981421645],
              [78.082358276491703, 35.549420529621365],
              [78.088187027128924, 35.555876598221893],
              [78.092855911555631, 35.556304406879001],
              [78.097509796638803, 35.554494061306286],
              [78.101093192243937, 35.551547266207166],
              [78.107691268490186, 35.552191653390601],
              [78.11179195432824, 35.551250891436851],
              [78.118107080635525, 35.54762465563293],
              [78.123831936913462, 35.543313988696937],
              [78.130145084452437, 35.539435025756582],
              [78.137293460729239, 35.538931249371707],
              [78.142815231012392, 35.541387275732433],
              [78.14726457205974, 35.549679130323845],
              [78.153893713008358, 35.550756929255968],
              [78.156501544516004, 35.553095564268361],
              [78.155635292850221, 35.559318722561201],
              [78.153917735770094, 35.565043257006735],
              [78.151561082661985, 35.571253115880886],
              [78.151613160427431, 35.578223380807643],
              [78.155259533830957, 35.587432241728429],
              [78.159164730045134, 35.593693370521066],
              [78.166469743094837, 35.613230289977224],
              [78.16545456856413, 35.61949823662421],
              [78.161594297354895, 35.626515199708081],
              [78.163024708152435, 35.630777997721552],
              [78.168220868708261, 35.630288085182222],
              [78.171245112185346, 35.627136980174804],
              [78.175889702050469, 35.623954192853859],
              [78.179176170528279, 35.622357088435749],
              [78.185251491102306, 35.623436764505925],
              [78.190862195245501, 35.636674377101194],
              [78.19756776728687, 35.646523710023715],
              [78.199778001698036, 35.653683393465194],
              [78.199191149600097, 35.657297904746677],
              [78.197696431977135, 35.666308593263196],
              [78.199649001116683, 35.669220545032374],
              [78.206903757714343, 35.666979190191746],
              [78.209757765085513, 35.663761120878895],
              [78.214428868534341, 35.660371307736085],
              [78.218997477400833, 35.658077202139381],
              [78.222393879302473, 35.656250113005761],
              [78.228971665764206, 35.653509117466946],
              [78.232255366613913, 35.651452066144365],
              [78.236100271344796, 35.649850488547486],
              [78.24075575834884, 35.64803469320411],
              [78.249272142887591, 35.646604260173888],
              [78.25505424418607, 35.645696927289251],
              [78.256450359052948, 35.648839406056709],
              [78.257058946366499, 35.654662821952435],
              [78.259300271471858, 35.65848505432831],
              [78.263465038393321, 35.661586031431241],
              [78.268964091688261, 35.663556876319582],
              [78.27205812182136, 35.668949811428917],
              [78.269046391507231, 35.676397787701816],
              [78.271384701406078, 35.688305803517267],
              [78.270446566471733, 35.692949642097041],
              [78.268973109819697, 35.697300593794807],
              [78.270953125786065, 35.703134453157737],
              [78.268533203048634, 35.708085728737963],
              [78.267439347973877, 35.711018277653118],
              [78.269173086814988, 35.717516923847782],
              [78.273325437722534, 35.722009155952847],
              [78.276695549550922, 35.723492350820969],
              [78.281070920231741, 35.724648422287011],
              [78.289335350914769, 35.725710235913446],
              [78.292906465431017, 35.724565366570133],
              [78.296165084529278, 35.722714085689645],
              [78.303316142479574, 35.721337511481813],
              [78.317641815621073, 35.721231800262188],
              [78.33884606325114, 35.720618431404887],
              [78.343008393654031, 35.722848236507993],
              [78.350183006021169, 35.724140517981816],
              [78.357374969889221, 35.727239264662124],
              [78.36146953614778, 35.728099398958122],
              [78.367299665028256, 35.729173648786997],
              [78.371182720097394, 35.731405807182796],
              [78.3786106811216, 35.732695419183784],
              [78.384708892165094, 35.735344815837117],
              [78.388023812508791, 35.736664855326367],
              [78.392781506376053, 35.742475578869659],
              [78.396107090902888, 35.744915841923444],
              [78.399800525159108, 35.756354243429683],
              [78.404522695439525, 35.761272722172897],
              [78.41257399971127, 35.765913720277467],
              [78.41628913217221, 35.779382141214704],
              [78.417939520785396, 35.782041002610214],
              [78.42320820297013, 35.78537970149015],
              [78.427320277639481, 35.785048657376905],
              [78.435881781150798, 35.784408974195472],
              [78.442215551587879, 35.78230389757725],
              [78.446062658520773, 35.780718733503861],
              [78.452898654021311, 35.778425648749796],
              [78.456216677372367, 35.777027302053334],
              [78.459981129443435, 35.775559310073085],
              [78.463611283137595, 35.774729475899193],
              [78.472505298206002, 35.773878861418524],
              [78.477488902055185, 35.7739984795247],
              [78.481374782571706, 35.773463616126811],
              [78.488514489841137, 35.773518834307318],
              [78.506309186342762, 35.772570422260614],
              [78.512898422600287, 35.770937925021677],
              [78.51755130654368, 35.766216336714116],
              [78.521248499083711, 35.76383245319505],
              [78.524693297610469, 35.766681711202089],
              [78.53528763666715, 35.775474719228953],
              [78.543307200490986, 35.779217990503035],
              [78.551194101992749, 35.783581146648039],
              [78.554358643905474, 35.786201325532424],
              [78.558860747910572, 35.790752882659703],
              [78.562186320722731, 35.792755345763815],
              [78.566872818594476, 35.79116178491541],
              [78.569591046418424, 35.788876860421162],
              [78.573428917729274, 35.789072157064155],
              [78.577643071507694, 35.792848329787219],
              [78.578210377390221, 35.795994491548058],
              [78.578537484377009, 35.802614781355331],
              [78.579134621719717, 35.805873845108195],
              [78.588795137441565, 35.810766802062766],
              [78.606465153260146, 35.813257441203163],
              [78.610926304157616, 35.813925079639013],
              [78.619505762843787, 35.817202895028679],
              [78.624145978404087, 35.821316334618082],
              [78.628156370854938, 35.824088385887961],
              [78.634532275766801, 35.828071101549568],
              [78.641505562566778, 35.837506454890288],
              [78.644872759883242, 35.840350874033014],
              [78.647670172450034, 35.84233425181197],
              [78.658172921199764, 35.854017570341867],
              [78.664939007516011, 35.857448598839731],
              [78.670463612894906, 35.857991146931319],
              [78.680955069984662, 35.859123465811948],
              [78.686165857554684, 35.856815435347364],
              [78.691399765330047, 35.856331032383906],
              [78.698929949606779, 35.858154296623098],
              [78.70328953568891, 35.85959759433058],
              [78.707178015504269, 35.861339815810808],
              [78.710234653705257, 35.863776558271717],
              [78.714405549835618, 35.865744273705936],
              [78.718837373077889, 35.868395762091694],
              [78.722708938968296, 35.868815331843969],
              [78.730413294492905, 35.868740727683985],
              [78.741190871844054, 35.867972790732907],
              [78.748602662742215, 35.86701059200248],
              [78.753599493254612, 35.867783334419826],
              [78.759666346786361, 35.868910938123946],
              [78.766284413140937, 35.869302242309494],
              [78.77453671045734, 35.868305183388919],
              [78.779199423563313, 35.864902883462186],
              [78.783284987519835, 35.862373229935379],
              [78.786286875135701, 35.860562997276517],
              [78.790138273464564, 35.859382223196647],
              [78.794668512079994, 35.858811960639564],
              [78.799504733971034, 35.857963962301447],
              [78.803349301900582, 35.856326368238875],
              [78.810733099807194, 35.855428418010568],
              [78.82373932671706, 35.85589020768635],
              [78.827903310989527, 35.857216599028867],
              [78.833672974003676, 35.857158142297585],
              [78.840899856628724, 35.859091033838908],
              [78.850828554782012, 35.859901487197916],
              [78.859122891493243, 35.862053095738148],
              [78.863271804814147, 35.862236255001477],
              [78.870487922006376, 35.865401888499001],
              [78.88014895901587, 35.866990378360178],
              [78.883753147301718, 35.868320993091821],
              [78.890937867210368, 35.869113391120635],
              [78.894545702382842, 35.870673135570705],
              [78.898981600856814, 35.871287707959397],
              [78.913640735308149, 35.875627669363332],
              [78.918351112543959, 35.87580376229544],
              [78.921648538628602, 35.877114578574549],
              [78.928298040615488, 35.87770478481346],
              [78.939897758950323, 35.879634441133845],
              [78.943792680919074, 35.881600535371994],
              [78.947122394098386, 35.883115960867251],
              [78.952988085769263, 35.887593759129572],
              [78.956611315747239, 35.890134664464227],
              [78.960488201841486, 35.892648448637871],
              [78.965437681531782, 35.891908060156545],
              [78.969022425518745, 35.889860108585403],
              [78.97370513366684, 35.88430654503626],
              [78.975464444405858, 35.880131391837111],
              [78.978733899530582, 35.877605566791637],
              [78.985169833848261, 35.87319705126523],
              [78.989841628807241, 35.868896934459578],
              [78.993454728439502, 35.865090800602296],
              [78.996719640544953, 35.862337359512118],
              [79.003540700520787, 35.857556911382609],
              [79.00853223945407, 35.854075424050762],
              [79.012038427965194, 35.85252854352521],
              [79.01614235121923, 35.851567433143046],
              [79.021619761742926, 35.848811059329989],
              [79.027123339132629, 35.847858026226383],
              [79.041180381737718, 35.847444730034667],
              [79.053823972796849, 35.846203612183459],
              [79.063745405227579, 35.846545371216017],
              [79.073382957069896, 35.844811132620094],
              [79.080542977128459, 35.844064265520423],
              [79.085012870187683, 35.843280794715895],
              [79.091816241120497, 35.841236945641754],
              [79.09914439946931, 35.840487633478809],
              [79.103362306477464, 35.8397758985396],
              [79.115484626815103, 35.837622218007184],
              [79.130866215845955, 35.836068097425716],
              [79.139480038833767, 35.838656870681142],
              [79.142790007148491, 35.840627089026874],
              [79.150335285224003, 35.846403579714718],
              [79.154184041849362, 35.848823028822004],
              [79.169358627114917, 35.861901938645197],
              [79.173155722151549, 35.864549255451223],
              [79.178864509679329, 35.869205869266004],
              [79.183937773423992, 35.876084065294407],
              [79.192867383082373, 35.885629747650881],
              [79.197820260070117, 35.898625724706179],
              [79.196622988177538, 35.902452165717669],
              [79.194689391391634, 35.909211021364364],
              [79.188363021836906, 35.92663706127049],
              [79.187872371643437, 35.930865541797075],
              [79.189053848660265, 35.942856496922289],
              [79.189798602242234, 35.947253066633408],
              [79.194365256149894, 35.955457604850181],
              [79.198297487362794, 35.960865025924925],
              [79.202628269335463, 35.966606744635193],
              [79.208386046909112, 35.972173465372784],
              [79.212718783352599, 35.97633953579566],
              [79.215454308450717, 35.978839475367209],
              [79.219036592402091, 35.980117098857832],
              [79.222408179099858, 35.982105797228918],
              [79.230107145969455, 35.984588286069226],
              [79.237367425742633, 35.985957931629969],
              [79.241813281904385, 35.986812901222727],
              [79.290192764043866, 35.989777870271894],
              [79.300091352039757, 35.989579561890004],
              [79.34481342167615, 35.9886278699964],
              [79.354234584837556, 35.990054866309535],
              [79.362231789133375, 35.990174489265087],
              [79.366422846286966, 35.992354721612273],
              [79.374199049086968, 35.99428135768337],
              [79.378062053905083, 35.9953486339055],
              [79.384664062246188, 35.994347427392682],
              [79.386809695324743, 35.990528747657173],
              [79.388513133339885, 35.977908943535247],
              [79.391698706562337, 35.971135100192001],
              [79.392086819840841, 35.966291858799053],
              [79.39252302330155, 35.954964053795862],
              [79.396701566341761, 35.942766133923591],
              [79.399599110610524, 35.934189013560932],
              [79.403128896055563, 35.918849484745643],
              [79.406083410673901, 35.913443574936295],
              [79.409082197663579, 35.910344160828238],
              [79.412847639574338, 35.904790509672139],
              [79.416858473213935, 35.900467531921244],
              [79.422055272694209, 35.896584614607846],
              [79.425617150565728, 35.895187858331546],
              [79.430210487194586, 35.895033571834738],
              [79.436336264873319, 35.894355673015738],
              [79.4412835957841, 35.893624182519986],
              [79.449285698968623, 35.891483315762812],
              [79.453738967763272, 35.891283635459203],
              [79.470218860676411, 35.889866402833341],
              [79.474360882486977, 35.889558249161247],
              [79.483448885213306, 35.888492548652465],
              [79.495231133396103, 35.887687894516965],
              [79.503228603797879, 35.886706520051348],
              [79.50791674130825, 35.885726619843815],
              [79.51257382543001, 35.884519120801102],
              [79.5165725965429, 35.884050553954069],
              [79.521617749756217, 35.881238966391486],
              [79.525457862855959, 35.879859812468432],
              [79.528742369745459, 35.87727904968083],
              [79.534714155131894, 35.874567904653084],
              [79.540451059914687, 35.871333934622236],
              [79.545631586932885, 35.868336868832657],
              [79.553012532672653, 35.864646908979026],
              [79.556855638111628, 35.863471584163101],
              [79.560689521019029, 35.861817227782126],
              [79.56450479737174, 35.860643577977669],
              [79.570561732468192, 35.859436130180782],
              [79.576322728636868, 35.857525201608922],
              [79.584857454941428, 35.856990352925706],
              [79.590092521821262, 35.855384083429826],
              [79.597179198661763, 35.852515254490747],
              [79.60513451109064, 35.851074393474967],
              [79.614990142932513, 35.848004799802531],
              [79.619691882047874, 35.847707601350869],
              [79.623320141991542, 35.845711733750463],
              [79.629065009407412, 35.844369758555743],
              [79.634187899144607, 35.842854973473393],
              [79.639423874017751, 35.841339324101973],
              [79.643236790873047, 35.840139101486898],
              [79.650668092833342, 35.839136334550822],
              [79.655326715896933, 35.836805263809744],
              [79.665492417186201, 35.835328554281567],
              [79.669846770593466, 35.833206533950694],
              [79.676427272985464, 35.831782012133225],
              [79.683507988265063, 35.828751971548932],
              [79.686802652821697, 35.826921042632364],
              [79.696144597086942, 35.824950351377865],
              [79.702933920877641, 35.821465911124513],
              [79.711996659039499, 35.819546829836199],
              [79.71525791250221, 35.817485532612544],
              [79.718461777019371, 35.811362902812654],
              [79.722812917794926, 35.807915033066713],
              [79.726876492305351, 35.805385079497917],
              [79.735376186221231, 35.803448277300667],
              [79.745234546202497, 35.800829500083424],
              [79.754043621200381, 35.800256101231902],
              [79.758419611479354, 35.799274091996196],
              [79.763412084236151, 35.799653513646057],
              [79.776624796871985, 35.798074588298427],
              [79.785985015169686, 35.798383545184826],
              [79.793942889523194, 35.797343024972029],
              [79.802996930644397, 35.795189579725587],
              [79.815401801168335, 35.793871727826989],
              [79.826305323270176, 35.79056892237481],
              [79.831587364015178, 35.790073110065755],
              [79.837594377431756, 35.789473777418209],
              [79.841146900505208, 35.788045380493358],
              [79.847182843304012, 35.787513529210493],
              [79.855982948904924, 35.785338346175784],
              [79.863950104797439, 35.78475114258962],
              [79.868865180781725, 35.78288926824024],
              [79.875549658388906, 35.785017719955235],
              [79.88256259635088, 35.790522690727485],
              [79.888412687919129, 35.796638122147684],
              [79.899489750594881, 35.807122387130264],
              [79.905225234088363, 35.813033085742042],
              [79.91016878750068, 35.817290412589578],
              [79.913803367592251, 35.819467869121567],
              [79.918546762864736, 35.822312803272709],
              [79.923969801722848, 35.824302426165936],
              [79.929692506775126, 35.827059824109313],
              [79.935539776107632, 35.829200247015052],
              [79.939440739405967, 35.830735017547966],
              [79.946770142432584, 35.833922301346789],
              [79.950280231710721, 35.83548587718569],
              [79.953643449390199, 35.836775617546571],
              [79.960276990414386, 35.838924407368253],
              [79.972197235438188, 35.840732560397768],
              [79.986250625295455, 35.8402672349266],
              [79.999163841867215, 35.837809311168193],
              [80.002667983801047, 35.834369791392284],
              [80.008652351755003, 35.831572453952063],
              [80.013507611097708, 35.827242181010512],
              [80.017577297512489, 35.824020043938603],
              [80.027554383306594, 35.812519784672126],
              [80.032169853842646, 35.806389535621641],
              [80.038228901207987, 35.7998212271604],
              [80.039514586081438, 35.796213635881251],
              [80.043962803951942, 35.786703568991257],
              [80.047615127105956, 35.777867618786011],
              [80.049730251737586, 35.772670240842118],
              [80.051313071276283, 35.768667519000786],
              [80.052775961749688, 35.76546615196628],
              [80.057485404267993, 35.75293517623021],
              [80.058226172388075, 35.749997557573977],
              [80.062259008639316, 35.745450680730045],
              [80.066076814310321, 35.743579655000993],
              [80.069072610393718, 35.741287801645292],
              [80.073618951990028, 35.737164550306609],
              [80.078518098648914, 35.733697239790665],
              [80.081748301157845, 35.730717249775694],
              [80.085268714457698, 35.728187936171395],
              [80.088163003926311, 35.725235528566962],
              [80.08979847878102, 35.722257881417853],
              [80.092298219618229, 35.712321952236373],
              [80.096486800888968, 35.702788840318242],
              [80.099946153213494, 35.697793089688219],
              [80.102551285241731, 35.691073801496117],
              [80.103266710763705, 35.687154284330681],
              [80.105628111657339, 35.683068316487777],
              [80.111066314786697, 35.680068674182003],
              [80.114617378719302, 35.677720821534756],
              [80.119595044435457, 35.676468162696679],
              [80.124434604233045, 35.674210587533139],
              [80.132928728217124, 35.672687510082341],
              [80.139757682856327, 35.670554454728624],
              [80.146339401589856, 35.668607420439315],
              [80.152346127598562, 35.66717361475186],
              [80.159705587158385, 35.665007165514531],
              [80.168204486049063, 35.662591529552401],
              [80.174472436405722, 35.660466823530996],
              [80.183245757373967, 35.658959905535923],
              [80.187875427890376, 35.657298858100482],
              [80.19296041688925, 35.655948393821618],
              [80.196755253944886, 35.654510063748226],
              [80.202092968451808, 35.65320020193996],
              [80.208331726038821, 35.649955806895036],
              [80.215465878973731, 35.648934111332061],
              [80.223963448362923, 35.646538085610437],
              [80.230788508777707, 35.644353959694868],
              [80.234035430822033, 35.642283708249835],
              [80.24097851241612, 35.640372575989716],
              [80.247085706030433, 35.636418860128899],
              [80.250896880502395, 35.634542946336985],
              [80.259591607195262, 35.63010644509157],
              [80.263927845623314, 35.628015009197135],
              [80.271269198157128, 35.624266163319405],
              [80.275312769872258, 35.621723732374782],
              [80.282212950817865, 35.614988726014261],
              [80.285502688720001, 35.611405711821817],
              [80.289589508611883, 35.608404249420381],
              [80.294663473480725, 35.60245582505339],
              [80.297777248419976, 35.594327647390777],
              [80.300608007426192, 35.588172061399817],
              [80.302046014318904, 35.58117222991914],
              [80.305962797065661, 35.572776601657253],
              [80.306814397311371, 35.5626334705088],
              [80.311289423063627, 35.554226851164096],
              [80.312533741276184, 35.549470172285879],
              [80.315953131459807, 35.529673291702132],
              [80.316811971203109, 35.52620429766862],
              [80.317594450140319, 35.52305861961586],
              [80.320130030770102, 35.50476138895808],
              [80.321447058964182, 35.498541309116405],
              [80.327106518500273, 35.47693643661097],
              [80.328640003021803, 35.472631279374227],
              [80.326309102020673, 35.466843218806048],
              [80.321293845408292, 35.465130715107527],
              [80.318012950175472, 35.463570078223519],
              [80.309992272682891, 35.463311451274549],
              [80.305831634860766, 35.462268740483786],
              [80.301428204569419, 35.462581071348545],
              [80.297557180846496, 35.460847606499414],
              [80.291075848091594, 35.45431302254871],
              [80.281066947714919, 35.440916385500806],
              [80.281287857763289, 35.427942875715303],
              [80.282425728442675, 35.418040197554291],
              [80.283173659824797, 35.41454849823959],
              [80.283853200285833, 35.40954963681871],
              [80.28403100286279, 35.396026921867012],
              [80.283542180225609, 35.387937642289593],
              [80.281520217210897, 35.38207356015031],
              [80.274979363488825, 35.363320242445091],
              [80.270916110275905, 35.344292929507638],
              [80.266533586401735, 35.33444419273706],
              [80.256258511306157, 35.31779344883509],
              [80.254524098583772, 35.314349667030626],
              [80.252785748132354, 35.310718813217775],
              [80.248108062394238, 35.301218990957089],
              [80.241253523217651, 35.290545243587189],
              [80.239701633099216, 35.287620965475348],
              [80.235657785055707, 35.276686825883225],
              [80.231666867052724, 35.260099787486162],
              [80.229838064966927, 35.251803048793008],
              [80.228856722732758, 35.237331888141362],
              [80.228678765087153, 35.228154607208388],
              [80.22602271627207, 35.221200323697168],
              [80.222359704387799, 35.214124969694254],
              [80.214909350032116, 35.203846035164119],
              [80.19462094250845, 35.182584795977661],
              [80.190951599939453, 35.177342225225559],
              [80.1835285611361, 35.166785764258591],
              [80.178406931958733, 35.147942511343949],
              [80.178437959488619, 35.139172254722112],
              [80.179851975732987, 35.124467543434378],
              [80.180238884771839, 35.11765927675296],
              [80.183833135523955, 35.091075176983018],
              [80.185865077526771, 35.063276833796081],
              [80.18539165231951, 35.057698032315081],
              [80.183905151745236, 35.040567861149356],
              [80.181215074712142, 35.029758251216371],
              [80.177625309563496, 35.018577769382063],
              [80.17663099240599, 35.011034972896702],
              [80.174746948196315, 35.002386423369771],
              [80.170879566809631, 34.988917008368027],
              [80.16716450542846, 34.982683952789635],
              [80.16028640590028, 34.971077934473662],
              [80.150952947248683, 34.947807617957451],
              [80.148012842277822, 34.942429716120039],
              [80.141517305240441, 34.930378653436655],
              [80.136571775031356, 34.919194185430456],
              [80.130040321978569, 34.908930288030703],
              [80.123659534151926, 34.893482756031055],
              [80.120250191678736, 34.889257818651693],
              [80.11054607104731, 34.872998157376927],
              [80.106842262084314, 34.86809245334122],
              [80.093930361597813, 34.856860838099635],
              [80.090137866846007, 34.85392567516773],
              [80.084015686847167, 34.848854426113078],
              [80.073516012130852, 34.829166854665985],
              [80.071850726010325, 34.821080192005986],
              [80.069649804296972, 34.809175375568458],
              [80.069023748588762, 34.805105884202476],
              [80.068006651128798, 34.796251650079036],
              [80.067014165950553, 34.790697203615991],
              [80.067595821236011, 34.784839952840059],
              [80.06818943681877, 34.778341686297757],
              [80.070669794285379, 34.760183409175717],
              [80.071389866975068, 34.75436995494622],
              [80.072775938565471, 34.746157523423086],
              [80.072678295270094, 34.73744499307633],
              [80.072547334885058, 34.7331362336122],
              [80.071175200124927, 34.723368148625219],
              [80.071061225714146, 34.7197705087586],
              [80.06902823636571, 34.714830392280454],
              [80.065691419807365, 34.712182737431093],
              [80.061837456136331, 34.711127561027581],
              [80.057961957560195, 34.709155422709458],
              [80.051382051319095, 34.706565306288809],
              [80.047533156673211, 34.705715293312913],
              [80.039282356967206, 34.704069601466891],
              [80.032327980909201, 34.702081729522057],
              [80.0263921582618, 34.700902339520738],
              [80.022806147335587, 34.69940454613446],
              [80.01813631583471, 34.699027493896772],
              [80.013339180570341, 34.697942139413215],
              [80.005634196289733, 34.695851812091547],
              [79.998116480963603, 34.694650645027231],
              [79.994807970445592, 34.693103548952095],
              [79.991019091793774, 34.692388386452834],
              [79.986851798440213, 34.692138305966445],
              [79.979739752595052, 34.690426301228129],
              [79.974512510257128, 34.688727347624393],
              [79.965165663081962, 34.68751198913138],
              [79.96076582096272, 34.68556957505885],
              [79.953659719481337, 34.684107134325622],
              [79.950037133633799, 34.68212858083691],
              [79.946232334774123, 34.681963136006381],
              [79.936380213580136, 34.681695190419802],
              [79.932053757387365, 34.682891432690717],
              [79.930766994997668, 34.686079829109545],
              [79.917454050564174, 34.688550523900375],
              [79.903543655011092, 34.690389646066023],
              [79.877909560669821, 34.691461260029662],
              [79.860653941634666, 34.688809435307043],
              [79.857353287258931, 34.687535181786416],
              [79.851824151794645, 34.683335859799598],
              [79.843730525138824, 34.676014932226671],
              [79.840654459023014, 34.673566693055236],
              [79.834059788846233, 34.670073397859568],
              [79.831538699020783, 34.667636501896339],
              [79.824824986195267, 34.661185358024454],
              [79.822309319986317, 34.656433683544464],
              [79.820413740509252, 34.647035581431311],
              [79.816538170907904, 34.643499210865741],
              [79.812135235465206, 34.64244685195262],
              [79.804244819973889, 34.64303192489767],
              [79.795679810777656, 34.637964377058289],
              [79.788419125405326, 34.634250184910243],
              [79.783996277642387, 34.632408622123442],
              [79.78048292082606, 34.630736864455301],
              [79.77589697917918, 34.627648550066915],
              [79.771964785810312, 34.622533748266541],
              [79.774650353453026, 34.618178336981451],
              [79.778762167486803, 34.615234929595076],
              [79.780411641567397, 34.610895172169037],
              [79.782775523948743, 34.607693926520177],
              [79.787310981586103, 34.600681160793243],
              [79.792514132591364, 34.592637755891815],
              [79.792436243890975, 34.589036346201581],
              [79.788297703849665, 34.587268281649884],
              [79.782036015718674, 34.586059752624735],
              [79.777638900216459, 34.585189290663102],
              [79.77100588058309, 34.582130069433433],
              [79.764013780041438, 34.573890829352614],
              [79.758971053954994, 34.566078799152265],
              [79.758020257221702, 34.560425685213261],
              [79.758453887688532, 34.554774867226705],
              [79.761914205569227, 34.552034998539717],
              [79.766839048391176, 34.551726914452608],
              [79.77501874049058, 34.552053116447475],
              [79.78247643675509, 34.544476355899789],
              [79.787079185728984, 34.542130293703472],
              [79.792466104239224, 34.538877050826436],
              [79.798977541619337, 34.537646533291891],
              [79.802736499101357, 34.536002982845972],
              [79.809220915726669, 34.532273066942999],
              [79.814565883736662, 34.521951585251102],
              [79.815216386492637, 34.516225857468868],
              [79.814965861458944, 34.508473091660861],
              [79.812900003911125, 34.503871283942672],
              [79.814535457814401, 34.500125829632211],
              [79.812390766744642, 34.496971187771216],
              [79.805986223417875, 34.496637932994453],
              [79.803277971540652, 34.494296062806036],
              [79.800568613699866, 34.490643595457151],
              [79.797324902189473, 34.486611292964831],
              [79.794025471634143, 34.485104352616354],
              [79.790208803556283, 34.484040278125072],
              [79.782719088943381, 34.482119352438033],
              [79.768842936464296, 34.480552813403058],
              [79.759204879906122, 34.480408070347053],
              [79.755369142884675, 34.480996978073442],
              [79.743526655108838, 34.481391671816695],
              [79.738895154801952, 34.481004798691245],
              [79.733671992593486, 34.47883837244126],
              [79.724921265991881, 34.478746434944448],
              [79.716779217824353, 34.478646399466797],
              [79.706999181402395, 34.479694397222893],
              [79.69577659442011, 34.477850300316042],
              [79.684608450893535, 34.478710996038693],
              [79.680442887783784, 34.48077379513262],
              [79.672997836793826, 34.483618675560017],
              [79.668929135574714, 34.483682739070332],
              [79.665321232998693, 34.481924998208271],
              [79.662010169142945, 34.47972609847487],
              [79.65906208777858, 34.481814137250886],
              [79.654753717114971, 34.485047064086402],
              [79.652385942974703, 34.488458025967446],
              [79.647489844865419, 34.488740637226307],
              [79.643698909732876, 34.490174979344538],
              [79.629234880332646, 34.489705176924794],
              [79.624081988199606, 34.490932555467012],
              [79.608847480272843, 34.49203421727637],
              [79.602885821523515, 34.494420026709015],
              [79.59730063541339, 34.500378693961423],
              [79.593238730054978, 34.500874871791865],
              [79.589088896194085, 34.498228997115753],
              [79.584946515500747, 34.494573084358585],
              [79.580204238448644, 34.489984321445775],
              [79.575001389261786, 34.488730744287587],
              [79.570865852946511, 34.486748830406398],
              [79.56585962307274, 34.485631080720232],
              [79.5625393503922, 34.484347530304554],
              [79.556303381067778, 34.482604020282814],
              [79.552495415260182, 34.481812636432664],
              [79.54564671434116, 34.479892684544552],
              [79.537418570735412, 34.478178448120218],
              [79.528417274839853, 34.476518100737472],
              [79.51697383753951, 34.47601928691904],
              [79.513104030835592, 34.474950407501872],
              [79.508497524349636, 34.47432937243876],
              [79.50945578116567, 34.467979937836432],
              [79.520407981237099, 34.455862316720669],
              [79.525479522479017, 34.448996032329049],
              [79.527297608177776, 34.445594149984501],
              [79.528129357951229, 34.437043157176227],
              [79.528291146225243, 34.428179315597127],
              [79.526920409908271, 34.421681891598176],
              [79.528124070578912, 34.418035684494477],
              [79.530818545644223, 34.415724255716256],
              [79.534586746259905, 34.414544881414557],
              [79.538517093475804, 34.411686171080277],
              [79.541863194172393, 34.410143393338281],
              [79.550607738626965, 34.410222155004085],
              [79.559593161018668, 34.41123739524059],
              [79.56191202548672, 34.405326244662447],
              [79.560718615563104, 34.399466287254924],
              [79.554867820906921, 34.391656375082711],
              [79.553967841873344, 34.388017765901253],
              [79.560450604522444, 34.371437773853025],
              [79.56194884584248, 34.364573627097023],
              [79.562352379359893, 34.358299450916213],
              [79.561251086961889, 34.342953888728715],
              [79.559825202945945, 34.335074923660052],
              [79.562797842892394, 34.324398889888478],
              [79.570286329448621, 34.317076804066154],
              [79.575723033825383, 34.303859813000805],
              [79.590081857037902, 34.286237576951514],
              [79.591895484695939, 34.28283533492457],
              [79.590882392253434, 34.277728655334315],
              [79.590020109436509, 34.273239091829694],
              [79.587984516646301, 34.26389802408562],
              [79.587205351312718, 34.258029953468188],
              [79.585723778241132, 34.244498896214367],
              [79.584222267163042, 34.238412070650249],
              [79.579180070198092, 34.229207844642247],
              [79.572370920687092, 34.222922615830647],
              [79.569203489928043, 34.22053413084496],
              [79.564814948141546, 34.217888292985947],
              [79.560705362149406, 34.216825024791888],
              [79.55200876041944, 34.21566609960378],
              [79.546405055438342, 34.208673124151495],
              [79.54335894428894, 34.206903259395013],
              [79.540074472485244, 34.2055980695648],
              [79.535788443678285, 34.206739131551302],
              [79.531178831457225, 34.209793384856646],
              [79.526135517281219, 34.211843712063995],
              [79.519581517859763, 34.212903748338945],
              [79.514080031463152, 34.211192442761956],
              [79.50721043861158, 34.205846445407033],
              [79.494763359916973, 34.180021626586125],
              [79.49180753609393, 34.166737879720401],
              [79.491055523004178, 34.162014661825843],
              [79.489696123664629, 34.157255221109502],
              [79.489029116216415, 34.151175741646504],
              [79.494031477422766, 34.141155392408464],
              [79.494732362411199, 34.135928388349669],
              [79.48723714488284, 34.126317484540465],
              [79.477674067111323, 34.116779214188306],
              [79.47255324906493, 34.111591769817174],
              [79.46811866537611, 34.107586365606615],
              [79.461226304746361, 34.102032513696798],
              [79.456825650291208, 34.099819222120807],
              [79.450261131331629, 34.09699398269332],
              [79.446196715763918, 34.09659333526826],
              [79.441800536016899, 34.094633096803769],
              [79.434188135928665, 34.093361678099122],
              [79.430336467909171, 34.090956816280716],
              [79.424748936504628, 34.082646727255351],
              [79.420335343056536, 34.078180599117452],
              [79.416335695905474, 34.067594913551261],
              [79.414408265129666, 34.063254572524123],
              [79.414220108530458, 34.055881134356845],
              [79.417935613606559, 34.052425627644062],
              [79.420312097226812, 34.048094156706192],
              [79.424628748665398, 34.045781392884543],
              [79.430019464633816, 34.043453133346461],
              [79.432104708910359, 34.039791368003094],
              [79.435033084774275, 34.0370385269498],
              [79.437884175471154, 34.028608337270086],
              [79.433728755514394, 34.023034368304458],
              [79.427102990224896, 34.018140105952071],
              [79.420530401978709, 34.014622415450518],
              [79.414303624943742, 34.01491665715713],
              [79.407037481476493, 34.020237405309956],
              [79.405742894238443, 34.023404261992013],
              [79.400628083295018, 34.025751980358912],
              [79.392950559519008, 34.028180015603652],
              [79.382275961103716, 34.031201841295982],
              [79.375641477163668, 34.033452817773558],
              [79.366622178561371, 34.034933152857846],
              [79.356307000147154, 34.036544397302116],
              [79.344911487044413, 34.037828007247725],
              [79.33286396861817, 34.039736524537879],
              [79.325096041457243, 34.040301925454557],
              [79.321082880519086, 34.04109165878927],
              [79.3059468013616, 34.043087385067707],
              [79.29698434929206, 34.043207003421436],
              [79.284435491244409, 34.039993834901026],
              [79.274387311696955, 34.03946113718662],
              [79.268991564424098, 34.043393546257718],
              [79.264456342859063, 34.045911609030725],
              [79.260168713765026, 34.048472013391248],
              [79.25348957603066, 34.049870996857251],
              [79.247720660642571, 34.051347883445658],
              [79.237926601603732, 34.051244914829709],
              [79.231164914163585, 34.052666558193863],
              [79.219775569059152, 34.052812535627929],
              [79.213780000975007, 34.052245482804196],
              [79.210255282102466, 34.050911026518669],
              [79.200711745055585, 34.050963924905638],
              [79.193712084631557, 34.054754142351911],
              [79.188695748106099, 34.061826729974619],
              [79.183197375874286, 34.066356428633824],
              [79.179867741217066, 34.070304234362901],
              [79.177201474545086, 34.072613290615173],
              [79.171219369362731, 34.072918512003127],
              [79.167059890488005, 34.068191738511437],
              [79.161073950186179, 34.066473408026077],
              [79.15349006409923, 34.068360136196283],
              [79.149632406809147, 34.065235625808576],
              [79.147287893912605, 34.046143057423983],
              [79.146026361596668, 34.043125326285036],
              [79.143750911211995, 34.035247104356436],
              [79.138816434384239, 34.030182259046107],
              [79.135793141392796, 34.027299705526062],
              [79.132446510879006, 34.024972897629311],
              [79.122374564023005, 34.022821464854616],
              [79.116646755661137, 34.021558315292083],
              [79.112565733810499, 34.019768546863432],
              [79.102335572165558, 34.019872043491191],
              [79.095478222411458, 34.020438004693354],
              [79.089240276849239, 34.021892538575202],
              [79.08408476372496, 34.021953148877685],
              [79.078439332446109, 34.024275308499867],
              [79.071645784415864, 34.025481935075895],
              [79.065732283243975, 34.028287892684538],
              [79.061932530356373, 34.028747051630155],
              [79.05730570516404, 34.03096393032294],
              [79.054132981256657, 34.032701271913552],
              [79.046827954083966, 34.034810085769578],
              [79.042522847200772, 34.038263360789863],
              [79.037437685209682, 34.041266029675043],
              [79.033671718276068, 34.044022323104024],
              [79.030160038794492, 34.045212299964895],
              [79.028027593567373, 34.048408995489169],
              [79.023445824872923, 34.050025873188865],
              [79.014760941165932, 34.05035723292211],
              [79.008454315937783, 34.047258449611014],
              [79.003501991163148, 34.046236129258141],
              [78.999810924977552, 34.044645318271542],
              [78.993180411389062, 34.042010909866391],
              [78.987207031451604, 34.040954100590675],
              [78.980932444346053, 34.038083334829444],
              [78.974691739277432, 34.035649729057113],
              [78.970041426920872, 34.034437128910383],
              [78.965360567401078, 34.033042779491119],
              [78.961818563864597, 34.032187050762559],
              [78.958814479863989, 34.030403883551088],
              [78.953921097421471, 34.029562162810173],
              [78.948974385045133, 34.026906364982736],
              [78.943265462554407, 34.024924702883574],
              [78.937826553062038, 34.020573376662512],
              [78.932495898477512, 34.012149479689263],
              [78.927157854733579, 33.999107299897531],
              [78.923415136621827, 33.993724257084359],
              [78.919686565269728, 33.989212806621794],
              [78.911334921813122, 33.981375156951778],
              [78.906238214213644, 33.977614690173255],
              [78.905085428717257, 33.971970310908404],
              [78.9066707507762, 33.968988420831565],
              [78.911206745373065, 33.964201777773418],
              [78.914424755062228, 33.961684231535251],
              [78.917933784904221, 33.960288019456186],
              [78.921144582020503, 33.957310608259107],
              [78.922723155117239, 33.953889102782966],
              [78.934288761986778, 33.933550932412636],
              [78.936982221211991, 33.927244363903213],
              [78.940198724553156, 33.924723753355174],
              [78.945643790628708, 33.923973189551816],
              [78.948299229557364, 33.92076979527468],
              [78.949342304326947, 33.916688143498],
              [78.943774261258397, 33.908610546131705],
              [78.949677903948995, 33.903348558899587],
              [78.954491663793803, 33.898992762800091],
              [78.955240816060368, 33.893558173512609],
              [78.953527063946595, 33.889276970441202],
              [78.961697442715149, 33.871063588895709],
              [78.967759045033816, 33.859679657874224],
              [78.972800081971883, 33.852147208537595],
              [78.975217705468424, 33.849864677438347],
              [78.979463201717877, 33.842571200639398],
              [78.994946082011282, 33.814722336456079],
              [79.000810385636058, 33.803383792925914],
              [79.004538194909429, 33.798602746400583],
              [79.00832917412977, 33.798099195851712],
              [79.015656204923999, 33.798473567731293],
              [79.019706396382674, 33.796839533575643],
              [79.013084964647916, 33.788289361485852],
              [79.013537766705028, 33.783545022470214],
              [79.016742686370094, 33.778745096869876],
              [79.020193724025731, 33.775784250075425],
              [79.024534788138112, 33.775271905339423],
              [79.028608130994769, 33.7772487756354],
              [79.030880650867672, 33.782007248106403],
              [79.034127043731758, 33.783763248119683],
              [79.037847083576068, 33.776679576918674],
              [79.040746814393557, 33.770754699162978],
              [79.043221448522971, 33.767486226915167],
              [79.047245796322102, 33.766174878659712],
              [79.050802077799958, 33.767680097114585],
              [79.052938374834554, 33.775251745537368],
              [79.053826021477789, 33.778477090399079],
              [79.057231973358455, 33.780967110425422],
              [79.061238698977533, 33.778527095200374],
              [79.061136057228339, 33.77177713585786],
              [79.062259855706287, 33.768106560312305],
              [79.065420292668364, 33.765536080035261],
              [79.068543133869468, 33.760713116401455],
              [79.068480091819438, 33.756493906247883],
              [79.064245942923733, 33.754714419420495],
              [79.059672209321562, 33.752799765194219],
              [79.052420483806955, 33.752181586626229],
              [79.047691002494474, 33.75097294519697],
              [79.042957608892024, 33.749761830637347],
              [79.041400109854237, 33.746825672618861],
              [79.042519200858621, 33.742871652966663],
              [79.043127957429789, 33.738503099417478],
              [79.039038222988935, 33.735173490743627],
              [79.033932305714671, 33.731771496115883],
              [79.026206686928049, 33.722704364243526],
              [79.023083951003002, 33.716183023167673],
              [79.020510951279178, 33.705789949726203],
              [79.02419198112969, 33.69803795964436],
              [79.028968556603985, 33.691861678844475],
              [79.038070614248085, 33.684505907369385],
              [79.0415730243122, 33.683359690295262],
              [79.044539703943272, 33.681254571953851],
              [79.053952582632888, 33.678194942951343],
              [79.060849509334943, 33.677859923424435],
              [79.064750147695804, 33.677628807140714],
              [79.071811305992256, 33.679133894220392],
              [79.07621463362635, 33.682946885212658],
              [79.08058181791904, 33.684456925232581],
              [79.083446438460257, 33.686609284879985],
              [79.086280067601578, 33.688484605910062],
              [79.089820420012799, 33.687981574530909],
              [79.092111052058826, 33.679578323866131],
              [79.091532539373247, 33.675949605966231],
              [79.090469155535303, 33.658541694977849],
              [79.091453998538071, 33.652843547475811],
              [79.096364504140439, 33.637824079106345],
              [79.10530856222185, 33.622546787504348],
              [79.107063701834051, 33.616933667911994],
              [79.105447085819122, 33.613707980502866],
              [79.099484310726709, 33.613779886040383],
              [79.093316275545561, 33.616572268849424],
              [79.087642806462853, 33.617537181081701],
              [79.08390642980703, 33.619423882955132],
              [79.074183191106243, 33.621566932592785],
              [79.069353528266134, 33.623880767625494],
              [79.065358774847965, 33.626875306055844],
              [79.060086817468388, 33.627191295459653],
              [79.047781603151066, 33.627776048569437],
              [79.042870383874259, 33.626452457265266],
              [79.035066162841559, 33.626569068066715],
              [79.030141379285396, 33.626167266725027],
              [79.024449942330719, 33.624208379760802],
              [79.020098860369799, 33.623569380257408],
              [79.014125958156072, 33.621129198376657],
              [79.010330791602414, 33.619033426183464],
              [79.005683516849544, 33.616947332141649],
              [78.999679216268675, 33.612253154367764],
              [78.989908254994987, 33.611237897060604],
              [78.984509203701592, 33.612197467907684],
              [78.979668155965385, 33.613842281608832],
              [78.971866114872682, 33.61595727675148],
              [78.960687181449302, 33.618271623753571],
              [78.953817056976987, 33.620257530419345],
              [78.949756481466508, 33.620764230728902],
              [78.946542795194631, 33.622827354168521],
              [78.941427100046212, 33.62447284863164],
              [78.936002999576033, 33.627710370959591],
              [78.932556202156817, 33.62887599908246],
              [78.92800202671539, 33.631412901334656],
              [78.92421606792675, 33.631914920269779],
              [78.919237419794698, 33.633627932047567],
              [78.914458191583677, 33.6279266585152],
              [78.917048916723672, 33.622466747898159],
              [78.917046508383507, 33.616345035484798],
              [78.915949497208445, 33.602569446681919],
              [78.917158287200962, 33.596639521197169],
              [78.917777061358734, 33.593640777355638],
              [78.918180395505942, 33.587122457127137],
              [78.917019067391408, 33.5805753473159],
              [78.915307065975512, 33.576035422144777],
              [78.915810047578418, 33.572646745254531],
              [78.920937073858411, 33.569873129382515],
              [78.924907867130827, 33.565062999909102],
              [78.92691182058968, 33.561057809142788],
              [78.928779609143547, 33.557077263035595],
              [78.93139252704492, 33.549428733274468],
              [78.940575581192249, 33.526601488604037],
              [78.941573519420999, 33.521364426758268],
              [78.942777979460217, 33.509354330138365],
              [78.94155599026476, 33.500528305262741],
              [78.939794602522511, 33.494351811651967],
              [78.938183297967456, 33.491055214268087],
              [78.932485848477157, 33.478178992342414],
              [78.931465842369917, 33.473906582530716],
              [78.930799366026079, 33.465509100379585],
              [78.932208326461492, 33.448405233804607],
              [78.93289193492673, 33.444322255960138],
              [78.932775147060667, 33.439809619034172],
              [78.93333594959941, 33.432848741676118],
              [78.93693164534514, 33.421130676883145],
              [78.940002374156705, 33.413103835700234],
              [78.943526209305418, 33.410072251231057],
              [78.950004132450673, 33.408407384446214],
              [78.95144586293317, 33.4036254452555],
              [78.951650356409885, 33.390930403760045],
              [78.953652838028859, 33.381166197850433],
              [78.959043836874685, 33.378385614762728],
              [78.966284259781958, 33.376482028463599],
              [78.969707663867936, 33.374187195754295],
              [78.971851467770165, 33.368702764102579],
              [78.972269382757432, 33.364999444843178],
              [78.972556591333046, 33.360540652131135],
              [78.98027959730085, 33.355936713391621],
              [78.983127349375664, 33.34613643543608],
              [78.985891454635095, 33.340022812148234],
              [78.989170376308579, 33.333580264448557],
              [78.992379026710054, 33.331745879272702],
              [78.996392398972532, 33.330570082866046],
              [79.000465966993247, 33.331652419159617],
              [79.006944535274755, 33.332267151224364],
              [79.012380209615088, 33.334691456533577],
              [79.016450446688069, 33.335541943979088],
              [79.021044990453845, 33.332908205133954],
              [79.025790184804762, 33.329326493123517],
              [79.030888797248238, 33.327425029803344],
              [79.035419377656169, 33.324190818492688],
              [79.041868255305701, 33.320958524027915],
              [79.045082367914517, 33.319561008301875],
              [79.053938606491087, 33.316046181596185],
              [79.061932137412001, 33.309820639977161],
              [79.067303906967609, 33.307959060711099],
              [79.071035220605225, 33.306325028622283],
              [79.074608764359567, 33.305221289928028],
              [79.078317257592317, 33.303956479119329],
              [79.086588945296896, 33.300007639450328],
              [79.089240343806608, 33.297716909234317],
              [79.096248513821436, 33.295351856236103],
              [79.102698014530432, 33.294165662093143],
              [79.110749203365927, 33.291992689287099],
              [79.118837148066007, 33.292124990160431],
              [79.123669447517642, 33.290935157078472],
              [79.13420857122, 33.290135441994984],
              [79.140212520865504, 33.292041546071346],
              [79.144225279625203, 33.292729267067855],
              [79.148389376185762, 33.292632218562858],
              [79.158270230370377, 33.291792580636439],
              [79.163863535278537, 33.290224264412181],
              [79.169001299661133, 33.291034773259391],
              [79.176868672119966, 33.294577225974294],
              [79.186315147680958, 33.293994068980275],
              [79.18980054025667, 33.292614136343857],
              [79.194125740322292, 33.292328080959123],
              [79.203825822115974, 33.292204189569986],
              [79.208571381920748, 33.292419345257599],
              [79.213521991227722, 33.293506681813199],
              [79.222345433204211, 33.295052786173102],
              [79.23086239151452, 33.296371027588648],
              [79.234643258613971, 33.297932975868221],
              [79.238417196756927, 33.297423440901923],
              [79.250287452793302, 33.295885165961188],
              [79.255616253167844, 33.293327156301366],
              [79.26153278401965, 33.291452357685841],
              [79.264456830869719, 33.289362954376855],
              [79.275324828643832, 33.285369935998681],
              [79.279411780205663, 33.283909415595275],
              [79.296951986115431, 33.280749037027327],
              [79.306616671610655, 33.277024921613027],
              [79.310057320359221, 33.274675225986691],
              [79.314890666546304, 33.273733985965059],
              [79.327560381232061, 33.27264086069782],
              [79.332973090597307, 33.273487067536827],
              [79.337852753875893, 33.275218537043514],
              [79.341399726231515, 33.275860142793746],
              [79.34974772015957, 33.278442523472009],
              [79.357469159112085, 33.281216509652651],
              [79.365772098040424, 33.282760525783893],
              [79.370046761858831, 33.282702823263719],
              [79.375758156075634, 33.281746395458065],
              [79.379477848979448, 33.279851174243014],
              [79.388976923639234, 33.277692003926738],
              [79.397369612903347, 33.275038681999625],
              [79.406316783209704, 33.27270205373366],
              [79.411189192348672, 33.272402984202394],
              [79.417589202055353, 33.270237403375582],
              [79.423248623132167, 33.269512222479669],
              [79.426455965847055, 33.268084481603424],
              [79.430264024835125, 33.268031702564983],
              [79.434541483795115, 33.266633809033721],
              [79.447441741063656, 33.264836363842853],
              [79.453417327758771, 33.260441724000273],
              [79.455626679147898, 33.255408879748252],
              [79.456083054588944, 33.250446907818741],
              [79.453225998326673, 33.242537092323495],
              [79.452354831448943, 33.230820263236446],
              [79.451186843640343, 33.225374873287791],
              [79.450629882529768, 33.21738588853561],
              [79.44663956752575, 33.205872519100943],
              [79.439345944335585, 33.191873199092164],
              [79.435053662991152, 33.184672675083966],
              [79.430632566094616, 33.177960096379856],
              [79.427440961037505, 33.172564281653685],
              [79.418591445710192, 33.160011602942561],
              [79.411567381355155, 33.151489811434928],
              [79.405383716565126, 33.144063148343932],
              [79.399339161098283, 33.13358997109507],
              [79.393429835352251, 33.124498381244486],
              [79.389006612319847, 33.114230999262098],
              [79.387859640610387, 33.111318982010744],
              [79.381383513527908, 33.097877246274557],
              [79.377376569621688, 33.084791212780715],
              [79.378096825525176, 33.079109042091495],
              [79.381798818999798, 33.074976304570107],
              [79.383483453410804, 33.071218268324515],
              [79.385486493433774, 33.068423179187803],
              [79.391963801737376, 33.057356928123923],
              [79.393521105580547, 33.054152838771202],
              [79.394747638336042, 33.046180373433856],
              [79.395348098887013, 33.043081586867252],
              [79.393750343917532, 33.036231862360317],
              [79.390361620149505, 33.033304648537317],
              [79.383110325056194, 33.028425637354943],
              [79.374462576209808, 33.024925221731898],
              [79.367546012462213, 33.023476887601618],
              [79.362814193212927, 33.021906057791078],
              [79.354270290196794, 33.021169413545422],
              [79.350399543273156, 33.020277110287331],
              [79.346646076105699, 33.019867933067786],
              [79.340962678848655, 33.018562910375465],
              [79.337710499907587, 33.017017130096527],
              [79.332269504752446, 33.013930968880523],
              [79.333304599034108, 33.010505231531404],
              [79.339217078784728, 33.007702093675896],
              [79.344757094504885, 33.005574009891525],
              [79.350407808921574, 33.005057385204267],
              [79.355238539867827, 33.002938136778162],
              [79.357591601194557, 32.999953068498769],
              [79.359691945155362, 32.996512079932991],
              [79.363247480240389, 32.993486825544068],
              [79.367160013790453, 32.992095217829117],
              [79.372489121009806, 32.990430587372771],
              [79.377775693341462, 32.989525817302273],
              [79.381346667948009, 32.988945981151019],
              [79.385794653225048, 32.982309989912309],
              [79.383459697965435, 32.972356717510905],
              [79.385542238660932, 32.968015584253195],
              [79.390644429199753, 32.967482177759457],
              [79.396908877949997, 32.969353431761881],
              [79.402282423934665, 32.970270450779338],
              [79.409251587023974, 32.970171973975397],
              [79.414043556068037, 32.967614230260317],
              [79.419344870173305, 32.962993123221665],
              [79.422290771185246, 32.961128736310549],
              [79.425579145843798, 32.957069010268896],
              [79.428346743094821, 32.95447048599712],
              [79.433105706723509, 32.950087969793181],
              [79.437861382413118, 32.945591663636613],
              [79.445001339868668, 32.938547163181298],
              [79.459034482469022, 32.925865753367823],
              [79.462459962889071, 32.921963704167425],
              [79.469524150683924, 32.912334145602877],
              [79.471074542174776, 32.909012055696536],
              [79.481506231421534, 32.891028548504408],
              [79.484127271440215, 32.888035735443331],
              [79.488839043873796, 32.881392300972102],
              [79.49253555896567, 32.877486413032642],
              [79.496282226403622, 32.87630013720284],
              [79.500659342638158, 32.872267930784155],
              [79.506164882392483, 32.867296106139456],
              [79.508827544940118, 32.863610504390053],
              [79.516055081083138, 32.85579715201731],
              [79.530751281568783, 32.835806295143271],
              [79.542043094381469, 32.822253625012706],
              [79.546700479786537, 32.813068842467686],
              [79.552707676360498, 32.804603261728026],
              [79.564077963765428, 32.793977734099059],
              [79.567980197874959, 32.786857280252967],
              [79.573246106385071, 32.782485241864343],
              [79.577805671237599, 32.78260150950107],
              [79.581554086329305, 32.781667543368705],
              [79.584667873900727, 32.776150519768493],
              [79.587329624550662, 32.774078227424404],
              [79.59148809346469, 32.774660931667903],
              [79.596225103770934, 32.776896896219299],
              [79.601885932648585, 32.777478260577503],
              [79.613896432400054, 32.765085481150933],
              [79.619641867908356, 32.753342856299966],
              [79.621248085427411, 32.750409532048991],
              [79.6222491642623, 32.747208494254124],
              [79.626206671780409, 32.743063347165318],
              [79.627197929634661, 32.739400782682829],
              [79.617518822896287, 32.724316996575347],
              [79.613419607269293, 32.721195039822291],
              [79.600884249978947, 32.707745681415254],
              [79.597162478323355, 32.702885496676465],
              [79.593475683742355, 32.698371104080906],
              [79.584879201335596, 32.686730983817903],
              [79.578410465947968, 32.678775606211559],
              [79.575956462573629, 32.676546668533128],
              [79.567115057559676, 32.673310837818178],
              [79.565045710496378, 32.670619111446527],
              [79.558943441884594, 32.662261081336602],
              [79.5475295591784, 32.648373876914818],
              [79.539149612146005, 32.637694285973303],
              [79.515729596607031, 32.608168058983829],
              [79.502402770624045, 32.596404286828907],
              [79.498323886911749, 32.59387870381012],
              [79.493952749378764, 32.590316480714733],
              [79.490543482928189, 32.58865781378308],
              [79.484279113719694, 32.585816946687004],
              [79.474111059172415, 32.578069585792775],
              [79.469802738739673, 32.576353579378704],
              [79.467179869659532, 32.571521121785807],
              [79.465821947638872, 32.562765458853619],
              [79.461640530432433, 32.553034308485884],
              [79.45578221600816, 32.542474508840272],
              [79.448114012061012, 32.532561720133188],
              [79.439752661491042, 32.529495468736059],
              [79.429005714731886, 32.528540659691139],
              [79.424162408170474, 32.527224207003925],
              [79.41319914140972, 32.527843051310448],
              [79.40680602212197, 32.529735349159985],
              [79.400678568601478, 32.534394205445146],
              [79.396273073414477, 32.556257544420667],
              [79.397438527618277, 32.562153098704655],
              [79.395356001453763, 32.570655516710623],
              [79.389066406984284, 32.573955879427849],
              [79.384818137233296, 32.575562476593085],
              [79.379467554069819, 32.576492283813288],
              [79.376810950297298, 32.578792137978539],
              [79.37229814352132, 32.580933045370742],
              [79.367742955784337, 32.582127381787508],
              [79.360030273235736, 32.583596634760333],
              [79.349618287623201, 32.588037164183127],
              [79.343653202020349, 32.589690333946564],
              [79.340310651705565, 32.59181489669038],
              [79.333882043961481, 32.59190299940893],
              [79.330151215249387, 32.593545983289729],
              [79.322901560520307, 32.593415881336625],
              [79.318026127523837, 32.590295527162105],
              [79.316160960145154, 32.586418766753525],
              [79.311118995920353, 32.571825495322855],
              [79.30883436395942, 32.568830632776248],
              [79.304696547341763, 32.562536234091844],
              [79.295089990034228, 32.550152499956731],
              [79.283948617306407, 32.540302969078375],
              [79.28070559361997, 32.538544637396193],
              [79.277144069747479, 32.534043344395336],
              [79.273633421980037, 32.532496471452099],
              [79.267705626641686, 32.53142143643953],
              [79.261303458713016, 32.532891901623827],
              [79.257040163944367, 32.533619756902645],
              [79.250867121682319, 32.534163598128465],
              [79.246175472410656, 32.525356621871502],
              [79.24333833740782, 32.516757403949697],
              [79.241620549477901, 32.509966130270499],
              [79.237796137186123, 32.505907209073904],
              [79.233470199513874, 32.504393549031832],
              [79.230089543049417, 32.502452081784483],
              [79.226602444271862, 32.500649749101044],
              [79.22323277095164, 32.499283640695147],
              [79.219684364925826, 32.497068510689857],
              [79.213196498541123, 32.493180326803184],
              [79.206992654582479, 32.489958385284254],
              [79.202112561859721, 32.486139893639454],
              [79.195922562745153, 32.483727304001469],
              [79.1830055215177, 32.481168747982423],
              [79.147919328862642, 32.481154858669235],
              [79.141783383243549, 32.478668348143366],
              [79.137401834017993, 32.47698960632475],
              [79.131945459972016, 32.470914232973946],
              [79.131327671583733, 32.466141195670005],
              [79.134153769054876, 32.458830214187103],
              [79.136477402571586, 32.455959085334626],
              [79.140521947668631, 32.453529192147428],
              [79.146534516601179, 32.442990541551126],
              [79.147232527435818, 32.437068426580623],
              [79.145266251712329, 32.431409782076337],
              [79.144142981481039, 32.42387079757119],
              [79.143219789263171, 32.420531746676566],
              [79.138631445402893, 32.417609501519159],
              [79.13487024810324, 32.417219390913246],
              [79.128431875303647, 32.414296750840869],
              [79.12321924453714, 32.409650395409408],
              [79.121495572959716, 32.400107700019262],
              [79.120856435501665, 32.393970695514916],
              [79.118930943321601, 32.388980519970957],
              [79.115077953414058, 32.384268421577673],
              [79.108911871819345, 32.382982793392181],
              [79.105723722241038, 32.384385424257225],
              [79.10237046614337, 32.385628144530678],
              [79.098619208736721, 32.385812866114854],
              [79.091287538885254, 32.386596793858303],
              [79.07953755560608, 32.388358262025285],
              [79.074465403621858, 32.389322213229498],
              [79.071004491525343, 32.390726180867681],
              [79.060558449214341, 32.390623474130969],
              [79.054389742120748, 32.389126508952728],
              [79.049015460690171, 32.388036974643711],
              [79.04419776189053, 32.387862559381915],
              [79.040153648588657, 32.386548448024769],
              [79.033725666755132, 32.3859560119379],
              [79.02832908532676, 32.383295732264372],
              [79.023482342554843, 32.381065967261371],
              [79.014589382297046, 32.377314210319604],
              [79.008618146908759, 32.370545686408548],
              [78.993788705770044, 32.345259047278113],
              [78.989171303298477, 32.339860588235261],
              [78.985394432682611, 32.338078812564966],
              [78.981132891540227, 32.338567859417523],
              [78.977429965799871, 32.342031515608966],
              [78.970605979149283, 32.351674216186154],
              [78.967772356897839, 32.358986892789211],
              [78.961726596722855, 32.36610183922965],
              [78.952600545311228, 32.366878677437292],
              [78.947872063589614, 32.369125955144654],
              [78.944403810533998, 32.371985508997106],
              [78.940675850456373, 32.373830100277523],
              [78.932682527762253, 32.377918571357696],
              [78.920977667795199, 32.383063913473428],
              [78.915395922026136, 32.386638826348467],
              [78.911937196698844, 32.388248851983633],
              [78.908128203471293, 32.390232182071244],
              [78.904813307616323, 32.392440739326652],
              [78.898328323837035, 32.397617845497088],
              [78.894617816179675, 32.400846986869752],
              [78.888104480524447, 32.406048080525025],
              [78.875278348791625, 32.417278799739591],
              [78.872411299659234, 32.420614143013303],
              [78.870118919719516, 32.424171782666583],
              [78.865140085424045, 32.430394600145853],
              [78.862537790785638, 32.437260287881756],
              [78.858854498441872, 32.440695810396747],
              [78.852954843923939, 32.440991303829421],
              [78.846767100251881, 32.440157481327532],
              [78.841957332604821, 32.438594463195905],
              [78.83441548776743, 32.436180871165291],
              [78.827210929589896, 32.438752474996242],
              [78.823070989361341, 32.449029432539888],
              [78.820305343340991, 32.46247787323248],
              [78.816867728380785, 32.46819592114003],
              [78.81385116683218, 32.472802892161624],
              [78.809500390755005, 32.47737504750301],
              [78.807132997923503, 32.481719053730274],
              [78.805092701999399, 32.490379026911171],
              [78.800835135939494, 32.498045489210568],
              [78.798543405430536, 32.502042636057553],
              [78.793154420135565, 32.519372329781703],
              [78.791457329536513, 32.52948186141623],
              [78.790389415771713, 32.533256570960447],
              [78.781952897720814, 32.54676227151856],
              [78.776759968726751, 32.558408552563328],
              [78.775529082975154, 32.568880569155212],
              [78.776399461211994, 32.573190283083292],
              [78.781366660676071, 32.578195414682746],
              [78.78373906661713, 32.580594566421958],
              [78.78695158436399, 32.582616545166779],
              [78.790775373300832, 32.58553014355607],
              [78.794307951081166, 32.589142841883394],
              [78.797095075971555, 32.598418220648064],
              [78.795634947967912, 32.610023763747201],
              [78.79249821425924, 32.618482019459009],
              [78.78881502160398, 32.622375862313113],
              [78.784570877775991, 32.625144788467011],
              [78.780026888066942, 32.627916882323838],
              [78.773959430158456, 32.6352514842511],
              [78.772697478359703, 32.641174018307701],
              [78.765550143938967, 32.649444157983339],
              [78.763175244827266, 32.653530744588224],
              [78.763724143489981, 32.658303769464403],
              [78.765198735195781, 32.662835568436591],
              [78.765846265455806, 32.673286312782842],
              [78.769117349108186, 32.68641068917097],
              [78.769656058245545, 32.690235205057384],
              [78.769347961898404, 32.696193458651393],
              [78.762660256272241, 32.697856985243881],
              [78.75369086756983, 32.689083863608182],
              [78.749562639599205, 32.681625169366079],
              [78.742242291233936, 32.673760561421588],
              [78.733847253038135, 32.667242792583622],
              [78.727901319165994, 32.664787013624412],
              [78.723835724003962, 32.662127043810663],
              [78.714685299318504, 32.658364236661114],
              [78.706708217847179, 32.656942770894233],
              [78.690789986648312, 32.656986381856278],
              [78.68033916189296, 32.658474203462724],
              [78.672671144888966, 32.657834703817272],
              [78.668648976373206, 32.656556300175829],
              [78.662842657452586, 32.654073599340265],
              [78.655405848988849, 32.642719342285041],
              [78.651520534800568, 32.636594137970555],
              [78.647837603422587, 32.631502655936707],
              [78.641529120091491, 32.61600465308377],
              [78.640621379326561, 32.612896620804555],
              [78.639006315706126, 32.60977199951342],
              [78.633760083377567, 32.603679656979757],
              [78.628446798412355, 32.60125984893341],
              [78.623754591403682, 32.598304506173399],
              [78.620086038317993, 32.596768089299772],
              [78.616046708316446, 32.596138052225086],
              [78.608638483826397, 32.606204896015825],
              [78.601912699243726, 32.609014271972192],
              [78.595034675839202, 32.610417458997802],
              [78.592117003299904, 32.612731340351857],
              [78.588901799442596, 32.615252772718165],
              [78.581231833536791, 32.616570937771684],
              [78.573368137928043, 32.617659680976175],
              [78.565848609052807, 32.615235724052987],
              [78.558860456796864, 32.614143328569789],
              [78.554801033809895, 32.61168802687537],
              [78.546722176078134, 32.610329250499717],
              [78.541651673367284, 32.610237612736242],
              [78.535723392482353, 32.608695604134859],
              [78.531966271434456, 32.606443790006828],
              [78.529382085534792, 32.604136760332189],
              [78.518969514177982, 32.593169371568528],
              [78.514899730250065, 32.589557645133276],
              [78.509775641241447, 32.586646719622536],
              [78.506272715415818, 32.585108905107447],
              [78.501679257401037, 32.583532166951102],
              [78.495959272983498, 32.580949292933219],
              [78.487975386167193, 32.58069683045894],
              [78.483172725546666, 32.582584959730895],
              [78.479203860116513, 32.583426457497929],
              [78.47244940399662, 32.583553976466966],
              [78.45982792482549, 32.580059381660668],
              [78.457138771935007, 32.578005723121102],
              [78.453628046511056, 32.57554112098456],
              [78.449308933761074, 32.573984636134696],
              [78.446890209077509, 32.571743261273276],
              [78.443848133425831, 32.569966028480863],
              [78.43660489040181, 32.561622652100027],
              [78.431382299395793, 32.550975324580378],
              [78.429157401359689, 32.540535147427242],
              [78.429908503611259, 32.533692558390698],
              [78.427136584196717, 32.531361159709533],
              [78.416468622894683, 32.529414617776254],
              [78.40543933962168, 32.528824069703873],
              [78.399965454293891, 32.526022112542414],
              [78.411915949672121, 32.524893159405202],
              [78.415455100772064, 32.523429859433513],
              [78.417778470814937, 32.520032221091945],
              [78.418933289890717, 32.514512492929661],
              [78.42278550191908, 32.511456930285796],
              [78.426447655720565, 32.509049893544137],
              [78.432491405959297, 32.50732841846348],
              [78.443190382559663, 32.508355943259041],
              [78.449232526109711, 32.506588341844967],
              [78.453132480475801, 32.504058416083787],
              [78.455928097399266, 32.501654949484688],
              [78.458163229651987, 32.496835490813822],
              [78.462544862613512, 32.494199554573598],
              [78.465131069360496, 32.488702783470536],
              [78.466189161267479, 32.485504705221068],
              [78.463246153938883, 32.478364004451308],
              [78.459062895831025, 32.473969311627428],
              [78.454788277953597, 32.467329802199103],
              [78.45323038383367, 32.462326625311945],
              [78.452871491789153, 32.458827459283405],
              [78.454038506199254, 32.455622412591666],
              [78.45553687222214, 32.452640490682917],
              [78.458928402737655, 32.450952230808547],
              [78.463421228958239, 32.449758197886325],
              [78.47216508122014, 32.446782309969677],
              [78.479412864077133, 32.444217813093466],
              [78.483539079209038, 32.441382217421229],
              [78.485559438128149, 32.438588401537864],
              [78.488269480418367, 32.433545747968559],
              [78.490411334609789, 32.429118819428567],
              [78.492489035223443, 32.426414759045429],
              [78.493968615076426, 32.423661632220913],
              [78.501056131616409, 32.421192772415033],
              [78.50471513194087, 32.421447252835058],
              [78.519996991762895, 32.422396003851659],
              [78.528917411572039, 32.419868811734133],
              [78.531842564090894, 32.418100955498794],
              [78.536158386831204, 32.414662736582294],
              [78.534609728276138, 32.40929357004147],
              [78.522346888402708, 32.399070744989068],
              [78.519436504069375, 32.396659717969158],
              [78.514975471786315, 32.391381423014607],
              [78.513195266118828, 32.38691456200592],
              [78.511284224618763, 32.373430915872561],
              [78.509010012455491, 32.36941525010365],
              [78.502322664691476, 32.363816316772265],
              [78.485231003745483, 32.354106321683766],
              [78.481845482464408, 32.349274697091118],
              [78.480104455211261, 32.345679194066278],
              [78.478509851444002, 32.339071897486626],
              [78.477894999700609, 32.333329435075427],
              [78.481827394548759, 32.316726977636854],
              [78.482482975017192, 32.3083760294519],
              [78.484097717922751, 32.287943328470043],
              [78.483261425038677, 32.280072117966789],
              [78.481411997281171, 32.273817795176441],
              [78.476210362673328, 32.266745659305542],
              [78.473556913053073, 32.263889969078775],
              [78.471028589045204, 32.260110598063804],
              [78.467890653539015, 32.257934037856614],
              [78.465394073091488, 32.254268983778893],
              [78.462486358635459, 32.251787663969886],
              [78.458712185304904, 32.24786302461488],
              [78.456435145981644, 32.244307107999354],
              [78.463752693538922, 32.241832351670496],
              [78.476089775684017, 32.241455545194562],
              [78.481153846436627, 32.241963701870262],
              [78.499890110567179, 32.23911485620161],
              [78.518581143317775, 32.241702532521188],
              [78.522929185618267, 32.243817123020165],
              [78.530953754746889, 32.24540316805566],
              [78.537294216810466, 32.246100169982761],
              [78.540814621501312, 32.246426299768338],
              [78.552763202933619, 32.245778500699082],
              [78.556492031664732, 32.245935661489263],
              [78.560135071792558, 32.244698092667569],
              [78.579290475844275, 32.233259530177335],
              [78.590983265464928, 32.227243704436226],
              [78.609942928923942, 32.214568049719048],
              [78.612192845655272, 32.21165057406678],
              [78.612144172559056, 32.207361352906645],
              [78.608130272146894, 32.199822509697178],
              [78.607485961086212, 32.19350649045883],
              [78.611167593204286, 32.184347065476317],
              [78.61066739533149, 32.178279583403892],
              [78.606453550937033, 32.169804946589032],
              [78.6022530474593, 32.164797258645279],
              [78.594939468166743, 32.161378104807007],
              [78.591483765410942, 32.157402905173292],
              [78.591591600967675, 32.153564713618586],
              [78.596600059337646, 32.150307622182083],
              [78.605192160762456, 32.143194572192634],
              [78.606837794629314, 32.138185725165862],
              [78.609379443885018, 32.135831448455406],
              [78.611080954100657, 32.131486104327486],
              [78.611350155960366, 32.127689647933465],
              [78.61320050112765, 32.119205959474783],
              [78.616137752488228, 32.116702469321289],
              [78.623048307632828, 32.113269158844183],
              [78.626994803426015, 32.113579576893784],
              [78.632781110323435, 32.111582313212658],
              [78.645458628975874, 32.110717306371214],
              [78.656460042345131, 32.107884529693983],
              [78.664729727398083, 32.102889975906393],
              [78.666495598498514, 32.094455868677763],
              [78.667895257292315, 32.089085671679534],
              [78.669222928390383, 32.08399171839325],
              [78.673530064329157, 32.079560996197635],
              [78.674775366067351, 32.076605538182825],
              [78.677598385125378, 32.073989125896347],
              [78.69118192138545, 32.064987253256653],
              [78.697570252584171, 32.059547614408942],
              [78.699325934047366, 32.056574691661957],
              [78.701594404062533, 32.05425180784318],
              [78.704383238324183, 32.049042803570821],
              [78.706852049314762, 32.041409003600798],
              [78.710184668764811, 32.038822457781883],
              [78.71268116404481, 32.035572496870863],
              [78.721937995077823, 32.029350522972535],
              [78.728660731450802, 32.024906450280909],
              [78.733624559531521, 32.020887329850481],
              [78.739306807492383, 32.016041878161445],
              [78.742193304448293, 32.013147414622743],
              [78.743592031187646, 32.008832144841236],
              [78.746396476654823, 32.00648933358098],
              [78.748111483053421, 32.003266475874689],
              [78.753766163223304, 31.999683727417416],
              [78.7672518920714, 31.999239728811887],
              [78.777260145151686, 31.996818436040709],
              [78.785083616422668, 31.995481361831537],
              [78.787700980289998, 31.991997725437518],
              [78.785861433661111, 31.986892424438967],
              [78.777682088886209, 31.95934365076657],
              [78.774106915114857, 31.950211172067796],
              [78.769168824720381, 31.935111386913743],
              [78.766829303150942, 31.930184343911666],
              [78.761944126841456, 31.920567364932261],
              [78.756804643086014, 31.915503056966905],
              [78.754029099482807, 31.912908683257236],
              [78.751431469231875, 31.910652595807004],
              [78.748853470341629, 31.905157610754838],
              [78.745951756871136, 31.902109500857797],
              [78.747888267798544, 31.898441379054823],
              [78.748083756141213, 31.89368420285275],
              [78.744853447002455, 31.885526666395606],
              [78.741222241903714, 31.8805024812422],
              [78.740210502343189, 31.877001555810384],
              [78.740470639775197, 31.870657517039877],
              [78.739782081209697, 31.842446098462684],
              [78.738289824289978, 31.833451281917572],
              [78.736061945675189, 31.830379246135649],
              [78.720137462614375, 31.822291749500042],
              [78.717295781355489, 31.81992943006578],
              [78.710994088069782, 31.81265173002884],
              [78.709286481166671, 31.809767241302659],
              [78.707106186125259, 31.802172592962169],
              [78.707604362981257, 31.788795640363396],
              [78.709484017008947, 31.781962931041068],
              [78.712505313116338, 31.774198052499017],
              [78.717071688244516, 31.769963943067886],
              [78.719549369944758, 31.765820296474629],
              [78.731794974450594, 31.762298888338933],
              [78.738048900114876, 31.760462950863381],
              [78.740245579571891, 31.755433715728262],
              [78.733103445485, 31.749125735085055],
              [78.731345129929053, 31.745715836306115],
              [78.727944010509162, 31.740249593152765],
              [78.727519549601126, 31.736635865892787],
              [78.72951964177787, 31.733886101838323],
              [78.734630140499462, 31.729862452421415],
              [78.736772499789481, 31.727313650260147],
              [78.741818314747789, 31.713146596821609],
              [78.744715621289572, 31.697694306848049],
              [78.748053672816198, 31.693040002851745],
              [78.750486101666525, 31.687312432217045],
              [78.756052979902606, 31.683365066352273],
              [78.763618654529438, 31.680407220189071],
              [78.769702365469698, 31.680367075604547],
              [78.780903991748701, 31.681466139941783],
              [78.787494137360511, 31.683176587342182],
              [78.795758062030728, 31.685151804975877],
              [78.796852662499205, 31.667946214755336],
              [78.800292562413446, 31.656538709854885],
              [78.802581618678033, 31.653731618935467],
              [78.805313859336096, 31.650034976454787],
              [78.808391474359851, 31.64747784226472],
              [78.810618718367976, 31.64512983646194],
              [78.824945877451043, 31.635148978232628],
              [78.832726885499042, 31.631722250864222],
              [78.835903146604764, 31.629020509024244],
              [78.840093952075648, 31.625622379562447],
              [78.842906639786634, 31.623209834470671],
              [78.844332441802322, 31.620291934890002],
              [78.846645927298482, 31.6156698927071],
              [78.847084375953216, 31.610467026975932],
              [78.84354120769855, 31.602436193768856],
              [78.840452525973816, 31.598018110212738],
              [78.834888228566797, 31.592740729513682],
              [78.830965760959387, 31.58885574021814],
              [78.82819015626022, 31.586032315290755],
              [78.825421801289806, 31.58339362634166],
              [78.821052609817457, 31.57844410753146],
              [78.813188962658813, 31.571358902460293],
              [78.807267556325925, 31.568847931529884],
              [78.800662013636156, 31.566587897341289],
              [78.783999925291795, 31.560943936515766],
              [78.779613075710813, 31.55734695820275],
              [78.77705443956954, 31.552702644041275],
              [78.773456184433002, 31.548758338040503],
              [78.765861586388183, 31.544026284906494],
              [78.762413999087954, 31.5429233109889],
              [78.745906718734162, 31.53947157049716],
              [78.737064085002956, 31.536156671929945],
              [78.734956071549902, 31.531955861697696],
              [78.732944762275807, 31.525663688458831],
              [78.724475993920038, 31.519167646714529],
              [78.722532345728993, 31.516292302772875],
              [78.723821211799688, 31.510145306330809],
              [78.730896429331963, 31.502911626076212],
              [78.731800782221583, 31.499050758060065],
              [78.731751606685492, 31.482339068799494],
              [78.734884073978805, 31.479277104747933],
              [78.739461252614404, 31.481192317147038],
              [78.759897787958266, 31.485479961543746],
              [78.763882601563921, 31.486037338071334],
              [78.767222609048346, 31.484091730802863],
              [78.770290140796064, 31.475864912103589],
              [78.776178146746389, 31.471606551265204],
              [78.781272483014533, 31.467560452061157],
              [78.787173931089271, 31.464266549713962],
              [78.78988078671118, 31.461329667033009],
              [78.794796524636141, 31.458114257282599],
              [78.808155249795888, 31.450462949103965],
              [78.811171693920997, 31.447860051081744],
              [78.812614836594079, 31.444184327682908],
              [78.812951971228401, 31.439675199295969],
              [78.811667175687532, 31.434735435124654],
              [78.811273214953815, 31.425728118403509],
              [78.808092348021859, 31.412932806191691],
              [78.805341703981242, 31.41054377964381],
              [78.799190081770092, 31.408040554290903],
              [78.796733075894011, 31.405620577285376],
              [78.79207326236704, 31.401734274314201],
              [78.791619113873111, 31.397455580454448],
              [78.797599843085308, 31.395444222637881],
              [78.810075535397232, 31.391611017781003],
              [78.817305452971226, 31.388891003904497],
              [78.823546782087547, 31.387351319782372],
              [78.826875055167619, 31.38586233792849],
              [78.832302647143464, 31.38345350907073],
              [78.83660641506502, 31.379225430795422],
              [78.842241075045578, 31.376097155320288],
              [78.845684994732892, 31.370563453619564],
              [78.849771646211565, 31.367489516189721],
              [78.851319442146632, 31.364407845546758],
              [78.853105871860549, 31.359457940079452],
              [78.855815867632415, 31.349450126947453],
              [78.855646242890813, 31.345598563096559],
              [78.853263300807953, 31.340032428053757],
              [78.847224330880081, 31.333921491160851],
              [78.844188993684384, 31.327459665648252],
              [78.848929902414042, 31.324108305879115],
              [78.853346711057384, 31.323755046268044],
              [78.861022901282581, 31.319156942758035],
              [78.863852982350366, 31.317317557915811],
              [78.866101633515854, 31.314992496428136],
              [78.868850803112366, 31.311960599870496],
              [78.873694008856418, 31.307941931965075],
              [78.876262727188262, 31.303241008818986],
              [78.879656521193624, 31.300280442649079],
              [78.882900141630273, 31.296335918642857],
              [78.885472510650033, 31.28630983386579],
              [78.893727971955599, 31.267803376820176],
              [78.900343837426476, 31.261727142088613],
              [78.904943482788724, 31.260100512350792],
              [78.922254796034878, 31.254103886094544],
              [78.928469657704682, 31.255630470274372],
              [78.932047478997333, 31.261545257388629],
              [78.932141874037114, 31.26992273543495],
              [78.931425359114371, 31.282097274655634],
              [78.939021646950451, 31.296391065514353],
              [78.940265840493737, 31.301613585894433],
              [78.940666488128457, 31.309304691711283],
              [78.938608088138835, 31.320342073061884],
              [78.940901388911556, 31.326701656263975],
              [78.945759937278268, 31.332839678093606],
              [78.952512963720537, 31.33743862786471],
              [78.967790854288921, 31.343189519958159],
              [78.976802063978496, 31.346987292724084],
              [78.983855702873839, 31.348191453428317],
              [78.996153268175021, 31.351934394925216],
              [79.005283404152607, 31.356786518562551],
              [79.008979904086914, 31.362472100034061],
              [79.008734002027964, 31.369239913661044],
              [79.010226822059494, 31.374235051374281],
              [79.022507135828704, 31.395597470173396],
              [79.027510603214921, 31.401526976901103],
              [79.030488399129254, 31.404037246669422],
              [79.037237288982752, 31.40952803043043],
              [79.04294107517245, 31.415257361755],
              [79.045381334934632, 31.417969691900367],
              [79.047959980923252, 31.42198899804724],
              [79.04976032081926, 31.439586673838569],
              [79.051304707478565, 31.448184683685742],
              [79.052786550567689, 31.452377754934787],
              [79.056343788073519, 31.45716438781567],
              [79.061032447276034, 31.463136419593216],
              [79.063695376112108, 31.465391466346567],
              [79.067924942217729, 31.466629983466486],
              [79.072619917798107, 31.467276930107602],
              [79.076124976565666, 31.463665572612239],
              [79.079293423687716, 31.46103784113977],
              [79.081948318783589, 31.458793153916595],
              [79.092030427368854, 31.45325701634253],
              [79.104985785246228, 31.450224658988855],
              [79.109760349122809, 31.447360017803557],
              [79.115896090084348, 31.442904506039667],
              [79.138358503993729, 31.436480688180328],
              [79.142286074396893, 31.434731436019884],
              [79.145464690809447, 31.433042052613171],
              [79.148696064266815, 31.429677285035513],
              [79.151648700290025, 31.425210620922226],
              [79.157679861190815, 31.414967788635469],
              [79.159485072349824, 31.412164126295334],
              [79.161712064787352, 31.409684732253393],
              [79.164384066858631, 31.406086301952165],
              [79.173623369791002, 31.398995073098039],
              [79.179201519131567, 31.393840631696598],
              [79.1857949157571, 31.381377303932737],
              [79.188021513210316, 31.37703846424726],
              [79.189906706748559, 31.372283145453508],
              [79.192425454005885, 31.369830915359028],
              [79.194588058359642, 31.366225238737993],
              [79.197526580575783, 31.36239781132517],
              [79.201772671515599, 31.358631366628277],
              [79.203883490809758, 31.354887733479071],
              [79.206768131578144, 31.352849721527722],
              [79.209908749838434, 31.349851128756505],
              [79.213849624882599, 31.346836387378541],
              [79.223058923218659, 31.341187156169326],
              [79.226228133777383, 31.339865254876731],
              [79.230718485362914, 31.33754365834211],
              [79.237306291520142, 31.332166346585744],
              [79.238375200738986, 31.326440447425291],
              [79.236533621177159, 31.323297951135089],
              [79.236259746750278, 31.319351466130733],
              [79.236693594552946, 31.31513399108789],
              [79.238709303306678, 31.312216025079017],
              [79.241622305198803, 31.309970098467588],
              [79.254102315597422, 31.299049125779124],
              [79.26367823718283, 31.29145036301621],
              [79.265109270036035, 31.284440810880316],
              [79.263300118613614, 31.280155854382674],
              [79.252657101872984, 31.270557929038695],
              [79.249334762638668, 31.263986355757375],
              [79.248422252091501, 31.25675006104553],
              [79.249412091941821, 31.248840545614513],
              [79.252845376364505, 31.245475721569914],
              [79.258844637079903, 31.24172249305358],
              [79.262950947184535, 31.241690697528082],
              [79.266982171884621, 31.241338122093346],
              [79.270687301862651, 31.24137245734617],
              [79.278304615503799, 31.240086754324601],
              [79.280687799045154, 31.237376940206111],
              [79.281796453432747, 31.234244380670315],
              [79.284128098873992, 31.231396727143622],
              [79.286618860574094, 31.226598535789808],
              [79.292125256467088, 31.217606086552514],
              [79.29425073281098, 31.212256252671164],
              [79.301735776307282, 31.194652246320931],
              [79.303870951211039, 31.19037921418057],
              [79.303579544956449, 31.184272620694955],
              [79.300352998306252, 31.180410959556077],
              [79.29843599834085, 31.176333467846259],
              [79.298118369200083, 31.170226220557478],
              [79.300295549700024, 31.164828644907882],
              [79.304821563064252, 31.158994964763739],
              [79.309100234422488, 31.153823390648363],
              [79.312653968751292, 31.148897633512956],
              [79.314983085008095, 31.143960804953714],
              [79.32296231587587, 31.136802217360522],
              [79.32691480032679, 31.133897658905017],
              [79.333231746908851, 31.133493990563291],
              [79.336658320309297, 31.132169023946094],
              [79.340433337919336, 31.124514212639156],
              [79.345932815102373, 31.123434928249541],
              [79.353275507110638, 31.123957718644444],
              [79.35719900850475, 31.123302178849485],
              [79.361701533879625, 31.12109025729335],
              [79.365728787709727, 31.118462034261466],
              [79.369215945345331, 31.116448081873727],
              [79.37594578423645, 31.114874029624122],
              [79.385289596840806, 31.115089680810325],
              [79.392421468741773, 31.115468147362972],
              [79.39719186802273, 31.11302897917361],
              [79.399395925947971, 31.106988533406604],
              [79.401213349711341, 31.104248938899719],
              [79.404992879509507, 31.093424345838638],
              [79.406522442453834, 31.077097285029438],
              [79.409963915286454, 31.074278138538176],
              [79.41493310508649, 31.074984376602185],
              [79.421521312950063, 31.071639457088981],
              [79.422602749675306, 31.068045567635902],
              [79.424109187877391, 31.051118994946346],
              [79.424984220871238, 31.046994383170382],
              [79.426586873912242, 31.041936154766368],
              [79.428273249303928, 31.032172253568334],
              [79.436941202063608, 31.030450150031847],
              [79.448438555525144, 31.032328197636485],
              [79.472522378231972, 31.034119574075188],
              [79.476316773069271, 31.034972518588187],
              [79.481120845146549, 31.035973314810057],
              [79.487226485097949, 31.034871078491925],
              [79.495047176512841, 31.032678649182373],
              [79.502595126440752, 31.035672490224563],
              [79.508903053934247, 31.035487884862324],
              [79.516504594761741, 31.033752201738142],
              [79.517962197574903, 31.022242105567472],
              [79.519800380678987, 31.019523847506008],
              [79.522973365778071, 31.016401176337748],
              [79.526190170292878, 31.014176217344236],
              [79.529833733158853, 31.011813814836263],
              [79.53230532152952, 31.009467885319122],
              [79.535543845819689, 31.005177091468077],
              [79.537671745964502, 31.002711727317209],
              [79.537842892188465, 30.999109694896276],
              [79.534672541709426, 30.989816278793928],
              [79.538238240742174, 30.987132785285123],
              [79.546516321591639, 30.986364572213031],
              [79.551299322139059, 30.986765002935371],
              [79.552683184100104, 30.981610320668661],
              [79.54841394011099, 30.9779552844664],
              [79.546451674862439, 30.972455836630598],
              [79.546252688945415, 30.968667631585106],
              [79.54944131493157, 30.966441568572105],
              [79.555765093539975, 30.961732725804179],
              [79.55850526206153, 30.958997476596384],
              [79.562512040022185, 30.957166888201225],
              [79.565565403761781, 30.954984104612464],
              [79.568718828797785, 30.953421460060998],
              [79.574696247028484, 30.951259122322924],
              [79.590854593576509, 30.948931852590537],
              [79.595708134236787, 30.944832060161357],
              [79.598626872034345, 30.940100923842369],
              [79.602345399693249, 30.937646324717619],
              [79.607543464628307, 30.938804711415738],
              [79.609446591545975, 30.942442209284589],
              [79.61407217472744, 30.945112558381894],
              [79.618728656453214, 30.947230695517405],
              [79.62130666698539, 30.949978269465259],
              [79.630893986997137, 30.95635028422716],
              [79.639392820031588, 30.959890942639284],
              [79.645498199529854, 30.960915028060576],
              [79.657794957047443, 30.96216011396395],
              [79.66459815709328, 30.96514087537539],
              [79.66501592673005, 30.974413435679867],
              [79.666809167689991, 30.978922722382769],
              [79.677765720904148, 30.981489448921653],
              [79.686459079882979, 30.978809257505318],
              [79.708446166422448, 30.976228685584154],
              [79.712113386951685, 30.97636450668454],
              [79.719996919288064, 30.977944823210468],
              [79.729335970845256, 30.980200162310169],
              [79.740033338374531, 30.985446037526749],
              [79.741711389719299, 30.988185826340018],
              [79.744453801548133, 30.990908302659612],
              [79.747493044234631, 30.996134488542893],
              [79.753358622239318, 31.000664340873431],
              [79.757421884501497, 31.001352434767725],
              [79.760859197124262, 31.000705562621594],
              [79.765846607499597, 30.995751615409315],
              [79.775594510762488, 30.987675437253966],
              [79.79979080931156, 30.981234085593893],
              [79.807601285960956, 30.978793574921866],
              [79.820229453008238, 30.972314586748801],
              [79.824672644698069, 30.971876082858547],
              [79.831303846763021, 30.973836160615267],
              [79.838747269197142, 30.977587351346379],
              [79.845573119889764, 30.978538074566217],
              [79.856311669089081, 30.975419244067098],
              [79.862077944003516, 30.975903376387048],
              [79.867297540077629, 30.97477986801022],
              [79.8712538457318, 30.97188191221856],
              [79.873901877155262, 30.969622035792462],
              [79.874939930322796, 30.965793356644408],
              [79.87732284707738, 30.963532232088468],
              [79.87904579722543, 30.960600441224223],
              [79.880564432473989, 30.956316718944368],
              [79.882130956981257, 30.952926218884457],
              [79.883978946726103, 30.94728825183822],
              [79.885301530248, 30.944355671760785],
              [79.888793479476547, 30.935556173047626],
              [79.889904674304347, 30.924958545956112],
              [79.892803559316903, 30.920906799590384],
              [79.896186403976273, 30.919635272953848],
              [79.907730456035253, 30.918032278845892],
              [79.912711926969848, 30.916262579642822],
              [79.914570019630773, 30.912619474754027],
              [79.917216436757698, 30.910175932777712],
              [79.918279482760013, 30.906323958411612],
              [79.921190966170855, 30.904084622808544],
              [79.923304975646317, 30.897759434503207],
              [79.925927423104127, 30.895061922123816],
              [79.930180255500503, 30.886722349431857],
              [79.936218684772044, 30.885369368127574],
              [79.949513678226282, 30.887486763584363],
              [79.954806024688224, 30.886404584923788],
              [79.958633405491568, 30.88607570481317],
              [79.974954068667103, 30.880074952649604],
              [79.982783590802526, 30.876751323891256],
              [79.995794999051753, 30.868442331240423],
              [80.002696352753915, 30.864494318865788],
              [80.006660696986501, 30.863268585269875],
              [80.009829566308525, 30.861877786209906],
              [80.014282040829926, 30.858794497323792],
              [80.016633594449274, 30.856299824988607],
              [80.023462880624095, 30.850676151638016],
              [80.032909147121586, 30.842352547060464],
              [80.039994546912155, 30.838311344528989],
              [80.04416372771783, 30.838094159348842],
              [80.053327405347986, 30.837434103044064],
              [80.057756089898092, 30.838363736521433],
              [80.061702122841396, 30.835209047294374],
              [80.065407372049648, 30.827299181875514],
              [80.079280683352678, 30.819006637952125],
              [80.081548326485347, 30.816580634778205],
              [80.084535712672562, 30.813811345769],
              [80.085420943226879, 30.806744500259267],
              [80.086657157958683, 30.803511516331561],
              [80.089066001443371, 30.794176266288726],
              [80.098083945403388, 30.78974824986371],
              [80.101612337402187, 30.786317915347464],
              [80.116087209856971, 30.775952499494348],
              [80.122864154690888, 30.773468075418386],
              [80.128082677659265, 30.775293475229692],
              [80.133737015066345, 30.780791574272911],
              [80.137457179691054, 30.78548398528611],
              [80.140311909343126, 30.787969370372899],
              [80.152560251381118, 30.790497351058079],
              [80.152785312208337, 30.799977578139426],
              [80.153695518568128, 30.804502833863801],
              [80.159786001154345, 30.807659202243588],
              [80.171811792247595, 30.807020157925681],
              [80.178617185023597, 30.80444027411361],
              [80.182556507090013, 30.801624953373526],
              [80.184668414123422, 30.797772935203366],
              [80.18727741866968, 30.795527304629147],
              [80.189119330847674, 30.79282320717509],
              [80.191227806202775, 30.789889080424629],
              [80.196213674123271, 30.783791672516145],
              [80.199087973475201, 30.781548719481648],
              [80.200440647124879, 30.774780586603658],
              [80.199932066983479, 30.769108646957065],
              [80.200982084332466, 30.764819615484541],
              [80.203621975749357, 30.761219529809114],
              [80.205464099619817, 30.758261529330429],
              [80.210434999482914, 30.755561669729957],
              [80.222199480634544, 30.751978830181077],
              [80.225810451039294, 30.758527458354198],
              [80.229781478709612, 30.76089793633458],
              [80.235991138744239, 30.760378222013081],
              [80.238862135081902, 30.758547822580077],
              [80.240437607316991, 30.7554038229468],
              [80.242542517040476, 30.752676607789667],
              [80.244521122478361, 30.748157335154922],
              [80.247243321046341, 30.743225724461656],
              [80.249242102705153, 30.740038118263087],
              [80.252256074590264, 30.735109468839408],
              [80.25187088973918, 30.730998564357208],
              [80.247598296442192, 30.723993030197075],
              [80.245791256461956, 30.717011524636568],
              [80.240319167718781, 30.712023311687762],
              [80.238499196022218, 30.709082170982594],
              [80.236174055767563, 30.69895615668274],
              [80.235788452904728, 30.695557562247235],
              [80.234661813182811, 30.691675784758083],
              [80.23207065271508, 30.68963066702576],
              [80.224767834328915, 30.685784465968286],
              [80.213851014716724, 30.684550465128083],
              [80.208214058032524, 30.682151719864418],
              [80.200415138019565, 30.676722676276146],
              [80.197694687703461, 30.674008463336339],
              [80.19604356683179, 30.669231776827441],
              [80.195346684010474, 30.66427141183771],
              [80.197987545453913, 30.659754563080835],
              [80.203219990918868, 30.656618637686435],
              [80.212144956722184, 30.651149478008691],
              [80.21575493040649, 30.649409407572858],
              [80.217963919809563, 30.646614476362217],
              [80.221260870194826, 30.643315071171259],
              [80.223234342045714, 30.639713295671772],
              [80.224175679475962, 30.635858056840835],
              [80.222602618635506, 30.631127780705988],
              [80.217697344674519, 30.625013082348762],
              [80.213998965908104, 30.621931711325864],
              [80.213273706793757, 30.617523486098126],
              [80.21381694867847, 30.613714011464246],
              [80.220609087776623, 30.610786242972051],
              [80.224001571942821, 30.610103581089945],
              [80.22726782451474, 30.607836161485263],
              [80.227018944189183, 30.603337088235687],
              [80.221162470843979, 30.596763931824807],
              [80.220676606112889, 30.591780052560889],
              [80.225655720798372, 30.576685844174868],
              [80.229476626216112, 30.574257468063678],
              [80.235922603609112, 30.570710427484897],
              [80.239051838763601, 30.569339077056686],
              [80.244487264451863, 30.56698260663374],
              [80.24709283792923, 30.563818621814434],
              [80.251762443755894, 30.560610487468185],
              [80.258742841925994, 30.561144569746723],
              [80.262477254743189, 30.562943878905081],
              [80.264450252406633, 30.566895012720178],
              [80.266906163117966, 30.569299773910906],
              [80.271163218611093, 30.569185086488471],
              [80.271312782278301, 30.565434831349311],
              [80.272513240820302, 30.562337769669277],
              [80.276775614894689, 30.562296111123825],
              [80.278248801817909, 30.565490046425587],
              [80.282317659345281, 30.568133265090559],
              [80.286923929258961, 30.568437704095945],
              [80.292694456375884, 30.56885704552656],
              [80.296685904905701, 30.567715264796771],
              [80.30142576757703, 30.566108214729926],
              [80.307123435610094, 30.564353323710488],
              [80.311452514088458, 30.564169784826884],
              [80.316141587382347, 30.562774269681785],
              [80.320300793430164, 30.56188269259895],
              [80.322054411562661, 30.559268516372946],
              [80.326064870634184, 30.554198332992151],
              [80.328163249376487, 30.551263124934671],
              [80.330261245524596, 30.54834843302962],
              [80.33466206306332, 30.545573807466827],
              [80.343011178880872, 30.541127794919262],
              [80.35241505533358, 30.537507762895153],
              [80.35525072283734, 30.535719817847731],
              [80.360234253133626, 30.53223280650386],
              [80.379810402447518, 30.523059938541625],
              [80.382935983188958, 30.52124921135654],
              [80.395963152044956, 30.517879584633569],
              [80.402200793765061, 30.522378678517391],
              [80.40608765603497, 30.524194614495375],
              [80.415215135065552, 30.52554970062948],
              [80.420964849729458, 30.520822839205298],
              [80.42409871402927, 30.513108853934778],
              [80.427199316137731, 30.510195548762109],
              [80.430222534466466, 30.505695493437248],
              [80.438166673280591, 30.500026909475082],
              [80.462677011057806, 30.490749139696891],
              [80.471515486046258, 30.48826833791523],
              [80.486251589754886, 30.48672415081251],
              [80.489771178326237, 30.486240386692696],
              [80.499904053318531, 30.484860124086357],
              [80.504321913423581, 30.483525052907613],
              [80.508767657722927, 30.480332157297347],
              [80.511627436048798, 30.476267617175811],
              [80.518907389325562, 30.464740424120251],
              [80.524146469489565, 30.459778446402638],
              [80.526738151913548, 30.457297123298961],
              [80.534277262487237, 30.451873334643814],
              [80.538562507198094, 30.449804709613144],
              [80.542607787151837, 30.449594182871955],
              [80.543771214956678, 30.453679564772884],
              [80.549640443792839, 30.457944059850039],
              [80.554083078561277, 30.459064618924995],
              [80.558738142985248, 30.457730117339466],
              [80.566302104890639, 30.459053949503918],
              [80.570189272139203, 30.461551834507048],
              [80.575797061493418, 30.470130057180793],
              [80.581010029686055, 30.483003125248988],
              [80.591300096364947, 30.484116363159501],
              [80.598838549328306, 30.481628800160575],
              [80.60820088959079, 30.476633509392244],
              [80.643337374535179, 30.454225230121352],
              [80.64566281203733, 30.451970611664898],
              [80.648278929947878, 30.449901201494676],
              [80.651422625177418, 30.446750525246831],
              [80.658082440477116, 30.441919284932276],
              [80.661808969966017, 30.440421005755297],
              [80.668048404961212, 30.439720307751116],
              [80.675346255784135, 30.440166169540973],
              [80.680527219183062, 30.437815382355573],
              [80.683908139864528, 30.434940191327023],
              [80.691462887765582, 30.429483909683999],
              [80.714358984130854, 30.412748740146135],
              [80.734167023581577, 30.40230567798719],
              [80.745813410417156, 30.396631479601307],
              [80.752016044424167, 30.392553533653938],
              [80.75982570962222, 30.385968708567002],
              [80.763703818003464, 30.382354770432254],
              [80.766050381538165, 30.379869692340346],
              [80.770267391894691, 30.374372347268448],
              [80.77187240990493, 30.371408368372787],
              [80.778506660878506, 30.35993546216466],
              [80.780821817654925, 30.355637115476245],
              [80.783167519876173, 30.353151647973807],
              [80.786894853600856, 30.34251339786929],
              [80.788844249523876, 30.339821370735116],
              [80.79664627071422, 30.33279739060044],
              [80.808194855015259, 30.324684888807493],
              [80.825704956560415, 30.314394872237479],
              [80.83245607789631, 30.31120873296944],
              [80.841293557722082, 30.307897741671525],
              [80.860207281399312, 30.301639594689984],
              [80.867939968687821, 30.300397447218323],
              [80.879394349113014, 30.29854510707532],
              [80.884880938308015, 30.297263768745172],
              [80.897886978716315, 30.294049063843634],
              [80.910857750926795, 30.288357117956497],
              [80.919823992112654, 30.285545548381947],
              [80.931110932993889, 30.282403546097839],
              [80.944328648086326, 30.28012607473773],
              [80.948630186122429, 30.279696742932376],
              [80.954989458448793, 30.278912471824967],
              [80.961633464248763, 30.277004940584529],
              [80.981720591462988, 30.270218532839689],
              [80.986914527761854, 30.26884268372622],
              [80.992689737442035, 30.267554866053466],
              [81.008434883200152, 30.264915119433365],
              [81.025345441994475, 30.257241783770873],
              [81.029447641734137, 30.254079206568747],
              [81.033428095892688, 30.247632551420697],
              [81.034284257029071, 30.244599040640626],
              [81.032967683615681, 30.228419260886643],
              [81.035517554343372, 30.220948472022016],
              [81.040230389684609, 30.213259397843814],
              [81.041823650898692, 30.210015053750297],
              [81.04233063230339, 30.205787895042288],
              [81.042936953352395, 30.200299079406413],
              [81.033641695914739, 30.198092267966654],
              [81.027889908372146, 30.197728626016335],
              [81.010748846396154, 30.192617264980548],
              [80.997331031583812, 30.188176503833052],
              [80.993289787178526, 30.186816053722723],
              [80.985781319454688, 30.188868438098368],
              [80.983445517027022, 30.19135770809946],
              [80.977608702866874, 30.189567152840212],
              [80.973316007380291, 30.184625969584395],
              [80.96318971077676, 30.185103494868589],
              [80.958255789631622, 30.184459045516526],
              [80.951760732842274, 30.182464357456428],
              [80.94188223753639, 30.178645427626211],
              [80.938236574134464, 30.176847101566789],
              [80.927616334568796, 30.17893131603164],
              [80.924988792208794, 30.181557361907757],
              [80.921154422572499, 30.185956661277004],
              [80.919715209914074, 30.189015806807696],
              [80.920916939601952, 30.193187820438194],
              [80.921196357496527, 30.204940646391286],
              [80.919405995351951, 30.213304463190795],
              [80.912697033404683, 30.218539271385186],
              [80.906204222843428, 30.21764503602569],
              [80.902821800393426, 30.216074207329221],
              [80.899800650849514, 30.211814470950838],
              [80.896799102884358, 30.205695772751998],
              [80.88888036988736, 30.196081364667378],
              [80.882985998570334, 30.184280522623315],
              [80.875951721131386, 30.178220145555752],
              [80.872438151032057, 30.176188000200764],
              [80.867890688839381, 30.171980710177536],
              [80.876366172373849, 30.150417861130062],
              [80.877662978378183, 30.143872652463994],
              [80.877638745115405, 30.136181601985665],
              [80.874775184040502, 30.130542730449459],
              [80.867405315770156, 30.125585853114043],
              [80.860172505007995, 30.121937714949954],
              [80.856848417062437, 30.120663313565462],
              [80.851382438106796, 30.1170523517359],
              [80.846080273553923, 30.106279277907234],
              [80.841982825317785, 30.101723906387765],
              [80.838368998204359, 30.100151960454237],
              [80.832911538462099, 30.099250506104692],
              [80.824481642173808, 30.100147869358395],
              [80.818547594448987, 30.098215558284824],
              [80.811978688113157, 30.095043317668683],
              [80.808625642322511, 30.092274131684722],
              [80.805636411752857, 30.087140326515495],
              [80.802784522963265, 30.084395250461217],
              [80.799129860551915, 30.07676097007235],
              [80.79585758621738, 30.074014881271648],
              [80.792239062060418, 30.070259739336983],
              [80.789254132765421, 30.066410870479562],
              [80.782764375900555, 30.062135339287725],
              [80.773431823921499, 30.058325201674606],
              [80.769264690336797, 30.055374975198436],
              [80.762533193728871, 30.047953868606644],
              [80.761837683705679, 30.042493170289617],
              [80.76144823933609, 30.032116792178435],
              [80.754681698898565, 30.018612309680258],
              [80.749744221226663, 30.011599627263539],
              [80.747417481745558, 30.00572781657759],
              [80.744304386163407, 30.002107644517658],
              [80.735213904407118, 29.997171175259485],
              [80.728217113165115, 30.000124539611161],
              [80.724848264942068, 30.000820914073156],
              [80.721081687476484, 29.999452961173688],
              [80.715178229612548, 29.995217614217704],
              [80.711882816490842, 29.991805746599244],
              [80.707086527518612, 29.987064120253411],
              [80.703344649455687, 29.984039642698427],
              [80.692436111184463, 29.974904077899527],
              [80.687903667267832, 29.969701719968043],
              [80.684895449848497, 29.963164081433082],
              [80.681549599959013, 29.960691228639419],
              [80.673286141292351, 29.959603336579242],
              [80.667550414031638, 29.959361744593963],
              [80.661865201823446, 29.958706277408869],
              [80.646630141061578, 29.95905313957477],
              [80.641841908200092, 29.959383641346061],
              [80.635370842563347, 29.961596389622695],
              [80.631398067609609, 29.963715632118088],
              [80.617843171662599, 29.958063981119135],
              [80.614027995825253, 29.957496001630215],
              [80.609160385502804, 29.957756223633698],
              [80.604634227465553, 29.956291952525248],
              [80.600342999433948, 29.953589584778769],
              [80.583132024045057, 29.936921420023005],
              [80.579237912212378, 29.933711650439232],
              [80.572502351333753, 29.923111810094294],
              [80.57197590911295, 29.917902015979866],
              [80.574314743134536, 29.894850045506235],
              [80.572683753067054, 29.890236567900946],
              [80.570948125954331, 29.886727274091815],
              [80.566504876165311, 29.88191030048689],
              [80.562402718100543, 29.87635939579808],
              [80.560851672977918, 29.870920293225886],
              [80.56137713988285, 29.866856526834759],
              [80.560852527536639, 29.862334885562969],
              [80.556435778913993, 29.858275042397079],
              [80.555175011391114, 29.853753592567813],
              [80.550259618124798, 29.852059724499256],
              [80.543899393181434, 29.849354990320244],
              [80.536304909232868, 29.839995784682458],
              [80.528265545111083, 29.833689270067673],
              [80.525428520762063, 29.830269731151301],
              [80.511319983263235, 29.823506268255045],
              [80.508035923878538, 29.820432361335559],
              [80.501104920360746, 29.812447853258334],
              [80.496464822249322, 29.796172298739208],
              [80.490790702040584, 29.795510631622751],
              [80.48727136351819, 29.794386070481721],
              [80.483013535463641, 29.796868131035314],
              [80.47034643843655, 29.801165570929449],
              [80.466300926209499, 29.801097463430661],
              [80.461914899161698, 29.800456167082807],
              [80.45406168518717, 29.797795148436716],
              [80.448885992384817, 29.798921849782328],
              [80.44525760071852, 29.800942082555832],
              [80.443703364299537, 29.804110466051068],
              [80.438132537314118, 29.805326834887925],
              [80.435480983399572, 29.803353642829428],
              [80.43338566263138, 29.799129288728999],
              [80.424588278468264, 29.796075474087946],
              [80.418658059338028, 29.791689833328746],
              [80.411540726059798, 29.790267443332329],
              [80.404247195827338, 29.767469301716766],
              [80.402158688189843, 29.759822655955709],
              [80.398537762625722, 29.757573577910762],
              [80.394678848500945, 29.75738878094284],
              [80.391352664516774, 29.752176225573429],
              [80.387182665771476, 29.748525227639501],
              [80.378121545985707, 29.7503135529074],
              [80.374630356807174, 29.749415576564207],
              [80.371541707471351, 29.743973743363654],
              [80.370078527275751, 29.740184721446258],
              [80.370156031067424, 29.727512128717802],
              [80.372505290896271, 29.720717212922278],
              [80.375553362068828, 29.719065565582792],
              [80.379466297395695, 29.718241975508271],
              [80.38026024698307, 29.714406834586761],
              [80.379217973603119, 29.710322048519505],
              [80.379618556761613, 29.706487479691944],
              [80.381594418517565, 29.702194865817315],
              [80.384435009009835, 29.699027887662542],
              [80.386595179355169, 29.694254014996048],
              [80.390651449299042, 29.685715188823266],
              [80.394798765899338, 29.668748506397925],
              [80.407800422639042, 29.659729894402844],
              [80.41089953533195, 29.657320190764064],
              [80.420669772333611, 29.649536726208655],
              [80.423778049271846, 29.640744427760684],
              [80.424571712605456, 29.635555555188013],
              [80.423660344129331, 29.630803251852651],
              [80.415283976815246, 29.619508063053882],
              [80.413217892183383, 29.615444744163241],
              [80.413123041147514, 29.608168162023834],
              [80.411717533240179, 29.596075332293136],
              [80.410052292044085, 29.593265783157946],
              [80.408430396529198, 29.590351313330231],
              [80.403979603428382, 29.58651592602223],
              [80.4021817028719, 29.579721177307313],
              [80.399589898327861, 29.577698998257198],
              [80.39896809180442, 29.572740546602805],
              [80.393284392476474, 29.569824328985028],
              [80.387490747098965, 29.570924987587777],
              [80.381700775635522, 29.568648365285931],
              [80.376338252162469, 29.563367309345271],
              [80.366883367779167, 29.559622144338661],
              [80.358116637735293, 29.552822158957508],
              [80.351412491288372, 29.550567094848699],
              [80.34937433260481, 29.547397943481094],
              [80.349885734678963, 29.541085945390435],
              [80.348478463469277, 29.537456083190918],
              [80.356872998585558, 29.532479336671045],
              [80.35767104729041, 29.526923395705204],
              [80.355353171962491, 29.520012118039926],
              [80.353473257999141, 29.516590280891421],
              [80.347456585222773, 29.512615383101195],
              [80.340676571607986, 29.510338291378773],
              [80.337063945624905, 29.509165278034086],
              [80.331988650097699, 29.50571925130302],
              [80.328041367222511, 29.502408406007063],
              [80.324987223299729, 29.498112923302791],
              [80.321064671789898, 29.49503568266034],
              [80.318529572944058, 29.492920842086939],
              [80.315453158699256, 29.48704023227263],
              [80.315992529580171, 29.480705008809228],
              [80.312403302423874, 29.480770481461015],
              [80.309387756782968, 29.482421969419274],
              [80.307701451783686, 29.486574249207536],
              [80.303850692096603, 29.486801659303872],
              [80.30126781875758, 29.482963963733393],
              [80.297933197750055, 29.47595808379246],
              [80.293205386143413, 29.471408198119487],
              [80.292825400375051, 29.466908871221495],
              [80.30085197201268, 29.461199991476406],
              [80.303540640050286, 29.454177247591254],
              [80.303444285005781, 29.451100651629758],
              [80.300073453085304, 29.448387970114911],
              [80.294151315374506, 29.450425342459756],
              [80.290042826005262, 29.449504646702849],
              [80.284886418770313, 29.449337576207796],
              [80.282542244724951, 29.454385132261532],
              [80.280465803339226, 29.457390443269411],
              [80.275702962534055, 29.456283778654029],
              [80.273018421679069, 29.451965679218993],
              [80.269410318490642, 29.4501704282339],
              [80.26296826825353, 29.45062089717231],
              [80.25551894159473, 29.446525782147784],
              [80.250595932525414, 29.446978471608709],
              [80.247013164921469, 29.445826497115224],
              [80.246361383243283, 29.441060502505909],
              [80.246252863676673, 29.437468364764548],
              [80.247078533159822, 29.432945118271061],
              [80.248854627023505, 29.425970209020488],
              [80.248873326522343, 29.419862399925886],
              [80.247632823836497, 29.414650046401054],
              [80.248196701450368, 29.409942824218628],
              [80.256403136210977, 29.404718500286378],
              [80.260285055734457, 29.402014451046298],
              [80.268487957669549, 29.397432988755199],
              [80.273435421567896, 29.397048704970036],
              [80.276790553772827, 29.395032542578871],
              [80.279453259035321, 29.387802938234469],
              [80.280144945498961, 29.383305178857928],
              [80.281112915866203, 29.37380121220983],
              [80.278608677181765, 29.371387811913813],
              [80.275684598082094, 29.369272198642147],
              [80.275330137161617, 29.364978392060209],
              [80.280492068990455, 29.361586514823689],
              [80.283062893800832, 29.359108201332464],
              [80.28493044810196, 29.345703472838178],
              [80.291351727990133, 29.340590620161827],
              [80.295093731692162, 29.339675176645738],
              [80.297044255584197, 29.333593770027896],
              [80.296800478870153, 29.326820187801719],
              [80.301720457205562, 29.324895432501958],
              [80.305410282753215, 29.324027280642728],
              [80.311212094369935, 29.325455824067731],
              [80.315216595100551, 29.323553103951536],
              [80.316721774466558, 29.317356676168998],
              [80.317282034252926, 29.312879731849339],
              [80.318600364802975, 29.30810372942036],
              [80.319497145627381, 29.30491301457668],
              [80.319379137546903, 29.299565272002823],
              [80.311268351360468, 29.29133898799077],
              [80.30794248086157, 29.282979348117124],
              [80.307231592084449, 29.274598969229988],
              [80.304669653005291, 29.264219637513023],
              [80.303156625097941, 29.25292104011363],
              [80.303039011808451, 29.247504056531533],
              [80.304231001013221, 29.241168430175147],
              [80.299460125579145, 29.23687054140802],
              [80.298089290873449, 29.221279448396917],
              [80.299903796034485, 29.216299591652319],
              [80.303009469620392, 29.20704898345128],
              [80.303280705060018, 29.202985135847101],
              [80.302247353517657, 29.1984607003759],
              [80.298417878997739, 29.194852860008517],
              [80.291729908316327, 29.195741839403087],
              [80.288350609809484, 29.199252537190294],
              [80.286297687060156, 29.205402920118193],
              [80.28347081903695, 29.207466798193238],
              [80.275165024938033, 29.20764128154492],
              [80.264708474753888, 29.210614741263743],
              [80.261604235331248, 29.218531202464423],
              [80.257708023235693, 29.219881946816717],
              [80.254130524567614, 29.219187856393152],
              [80.250445289467848, 29.202491506904622],
              [80.255658343213611, 29.197264857789488],
              [80.259326018207503, 29.19345781061272],
              [80.261919505282648, 29.190727340059166],
              [80.264018240148246, 29.18733389741967],
              [80.265789078967856, 29.179666056445424],
              [80.265801069456089, 29.175832968782743],
              [80.263777245810317, 29.171306514726112],
              [80.263404428831251, 29.164763216994547],
              [80.265864743205654, 29.162264822994956],
              [80.267413510683411, 29.159234129311237],
              [80.269027665535191, 29.15600247530875],
              [80.271504576103951, 29.152949638961534],
              [80.274255228778898, 29.149164174372647],
              [80.274137049737405, 29.145100349176701],
              [80.2671229042395, 29.14206204017438],
              [80.2630564037011, 29.140288095498622],
              [80.255682820293728, 29.135939271693168],
              [80.252713123786705, 29.133778256246039],
              [80.25016144517663, 29.131594238382199],
              [80.242861556411853, 29.120655360466767],
              [80.232868932552321, 29.119745900234772],
              [80.226057777496152, 29.119645535737511],
              [80.219482881633553, 29.119267944961507],
              [80.213915976935596, 29.121829798713314],
              [80.210256480184384, 29.123317423230745],
              [80.206351869097787, 29.128294377573003],
              [80.201231307658389, 29.129639416299085],
              [80.191694283479265, 29.132792926215313],
              [80.185928337737323, 29.132116039043595],
              [80.184006348778226, 29.12961039192173],
              [80.178619671315161, 29.125078734880745],
              [80.169633175691771, 29.120377510029069],
              [80.166822855900136, 29.118328926299483],
              [80.163095692327815, 29.114411388888737],
              [80.158375307483382, 29.109565731018197],
              [80.154889434446176, 29.106826263143869],
              [80.152236301598407, 29.104685224066074],
              [80.148916111159323, 29.09969720105321],
              [80.144586774161397, 29.09268538289032],
              [80.138123640720508, 29.078138922782575],
              [80.136163456406194, 29.072485549413294],
              [80.135552273270761, 29.068811761276582],
              [80.135827521980289, 29.065345339994384],
              [80.143704968732095, 29.059024515612727],
              [80.138343110748835, 29.049761016353035],
              [80.13417549399027, 29.042037418238717],
              [80.130190677435678, 29.034590754224684],
              [80.133807747538825, 29.030099662995539],
              [80.133566814192292, 29.025322941337443],
              [80.130655608216301, 29.016751790506401],
              [80.137216159375342, 29.012679834047027],
              [80.140822049138336, 29.010436667776432],
              [80.140838725189354, 29.006373285958897],
              [80.138031468906505, 29.004323796314512],
              [80.13365522818269, 29.003626568056685],
              [80.130079971228739, 29.004536049283846],
              [80.125448866369865, 29.002506295280522],
              [80.123819539955875, 28.993113090474843],
              [80.12163186268144, 28.986518599135806],
              [80.11786366223599, 28.983939414397422],
              [80.110906707705908, 28.983463320171779],
              [80.106167874952547, 28.982327837622343],
              [80.102601599495216, 28.981400923647332],
              [80.099157669121595, 28.976411581713858],
              [80.097136166656014, 28.97369670872375],
              [80.094282525782646, 28.970774782413326],
              [80.092011785257498, 28.965808309074326],
              [80.088822426768658, 28.96219690344779],
              [80.08153076886471, 28.944201198953774],
              [80.073698352092052, 28.930956788467991],
              [80.069864214039839, 28.926424703547323],
              [80.066592711723771, 28.918747401069638],
              [80.063329448013675, 28.903814810693479],
              [80.064128131929778, 28.889121211555548],
              [80.064123890745691, 28.884554687054123],
              [80.063606572655118, 28.845291837088848],
              [80.06464673221717, 28.839875605049851],
              [80.070343712220478, 28.829260878318465],
              [80.075720265733963, 28.825898153132634],
              [80.081506409584634, 28.823892803968292],
              [80.089287149641194, 28.824050110620114],
              [80.100557562064097, 28.823549252865739],
              [80.107009694792637, 28.823930645281202],
              [80.111582777551618, 28.825296073702219],
              [80.119022389009601, 28.825979794889943],
              [80.123633020749608, 28.825048105091078],
              [80.133376942645313, 28.822174786996282],
              [80.138704632688203, 28.817594255500016],
              [80.144992020213593, 28.813221817463951],
              [80.151364345493718, 28.80731169600373],
              [80.154968039541146, 28.803921139539352],
              [80.15703342417109, 28.801214338086154],
              [80.164731328685434, 28.795350948411865],
              [80.16708194282748, 28.792693110823567],
              [80.172168486759475, 28.789027903231045],
              [80.17498954018987, 28.785864015055704],
              [80.181170636672775, 28.781353474388627],
              [80.185265844767088, 28.778146536660941],
              [80.198386263026237, 28.767399467400988],
              [80.210686546076602, 28.759957457029202],
              [80.215114036681612, 28.758149730520174],
              [80.222949731722437, 28.755912050086547],
              [80.229372767177665, 28.75591910998963],
              [80.247544504022301, 28.758194351691099],
              [80.254439434148125, 28.756848206061772],
              [80.262147006053226, 28.753481413652068],
              [80.266264597588616, 28.750410105736361],
              [80.268820599214592, 28.747358462836502],
              [80.270235465075629, 28.743755590968778],
              [80.268333400752041, 28.735372732709763],
              [80.265281598848631, 28.72951556744599],
              [80.262094572129897, 28.725906221159164],
              [80.265820456664727, 28.722970409922514],
              [80.270690565394631, 28.719579114335009],
              [80.274791738628878, 28.712350031878763],
              [80.278931296307533, 28.710012217129933],
              [80.282234884952842, 28.70896086610346],
              [80.293492431332794, 28.708281206319356],
              [80.300383778556665, 28.706955897894169],
              [80.319976888852594, 28.69831651665087],
              [80.322917245015603, 28.696572573716001],
              [80.32461820455886, 28.691362209031993],
              [80.323456565788561, 28.688215372009346],
              [80.324243067128918, 28.685047678386319],
              [80.326414538418746, 28.678482310528871],
              [80.328291322469155, 28.675635540706359],
              [80.332441385402262, 28.666728726318709],
              [80.340402886657287, 28.661775813849378],
              [80.35447015812359, 28.656591958726015],
              [80.361883184220204, 28.651613914435142],
              [80.361668916464239, 28.641441198226762],
              [80.366712551495411, 28.638642331983657],
              [80.369263227335395, 28.63632467388166],
              [80.372151664489849, 28.633317838825736],
              [80.38288405018632, 28.630174992647778],
              [80.393637112389186, 28.630820150922332],
              [80.409060767350624, 28.634357142760042],
              [80.415345631926712, 28.636240486243931],
              [80.426356596747254, 28.638537134302364],
              [80.433005935296904, 28.63897172835491],
              [80.438358818313802, 28.637386774846373],
              [80.443999413999578, 28.633988175416533],
              [80.447068673500809, 28.629257205315479],
              [80.453955544210586, 28.626546853947314],
              [80.459358616910478, 28.624936432848092],
              [80.462426267323764, 28.622686456158032],
              [80.465726691123407, 28.620204732184231],
              [80.468308667058693, 28.607781280758466],
              [80.471920133493697, 28.604795524436977],
              [80.473948103956118, 28.601441364877623],
              [80.473769725137402, 28.598295424451489],
              [80.472009287136189, 28.590880051823174],
              [80.480347932051259, 28.584930223256407],
              [80.485333474091036, 28.584995956250928],
              [80.489540535056165, 28.583799656708404],
              [80.49593013693142, 28.579273091438164],
              [80.498243626033272, 28.573164432531019],
              [80.502917094429975, 28.570841462809494],
              [80.505904019969918, 28.568429177841292],
              [80.50870863863662, 28.566152735771624],
              [80.511772354859374, 28.564360290722934],
              [80.514344276957345, 28.561212323436941],
              [80.521743293287969, 28.557808635534453],
              [80.527219656370349, 28.559113830025385],
              [80.530282373570031, 28.5615456751434],
              [80.532825275283912, 28.565768486559271],
              [80.532589836297959, 28.569649206511404],
              [80.529396264256562, 28.57474802897605],
              [80.521736503556596, 28.579255020175761],
              [80.519028700045297, 28.598269894909709],
              [80.518142854155045, 28.606857228519711],
              [80.516869128155705, 28.610693640402879],
              [80.51356588114453, 28.624496212390142],
              [80.509454542095611, 28.642109120296009],
              [80.508436796691228, 28.652398427767501],
              [80.508252091279587, 28.658689190126477],
              [80.508664289766728, 28.665829340262036],
              [80.513469717521588, 28.670029288548704],
              [80.523757156794872, 28.678469307527124],
              [80.537319865214116, 28.686152033434865],
              [80.546025731911556, 28.689540372216367],
              [80.557773992770322, 28.691320766454918],
              [80.565960704432442, 28.68952103259922],
              [80.57331465019216, 28.686619656000381],
              [80.582592375041514, 28.683622648130843],
              [80.591036728134711, 28.679319862360725],
              [80.588903800142276, 28.674224138318916],
              [80.587343612826857, 28.668509680130047],
              [80.584379136179749, 28.66123484278933],
              [80.593575912322279, 28.657387909129746],
              [80.594820441673676, 28.652287389232505],
              [80.594091123007857, 28.646089360485689],
              [80.600976231239997, 28.646906572814562],
              [80.60762733969851, 28.649010219598164],
              [80.610717473837397, 28.645838123468863],
              [80.615547590993629, 28.642224696361406],
              [80.63164976330404, 28.636758838794485],
              [80.63780547636749, 28.63697886785501],
              [80.644693849947458, 28.641169851774428],
              [80.654432636637125, 28.638328350093559],
              [80.660302013679143, 28.637630103413617],
              [80.667734920488499, 28.640324891817812],
              [80.669857424161179, 28.633524834627309],
              [80.670629262178849, 28.626979457786991],
              [80.676910466091698, 28.622695060179062],
              [80.681112880527067, 28.619060579670197],
              [80.682634967167871, 28.610445749097568],
              [80.681616211944913, 28.605052611630651],
              [80.68428831566608, 28.602545101106152],
              [80.691974422048645, 28.602759618576119],
              [80.697584119500235, 28.602977480427022],
              [80.698719777241095, 28.597762490333992],
              [80.696818978650157, 28.594529394112605],
              [80.694886858003883, 28.586243659431148],
              [80.698075047122416, 28.582400715824686],
              [80.699603733657497, 28.579459252745323],
              [80.701884736351829, 28.57674634551406],
              [80.706085422182298, 28.573682017969059],
              [80.713870215740556, 28.570841432382803],
              [80.718749035339613, 28.570371525859485],
              [80.723347045556793, 28.572197262455003],
              [80.726904636638608, 28.572627032156653],
              [80.730014788315373, 28.569679498680397],
              [80.735514042822459, 28.56681964276007],
              [80.739278010777696, 28.566741627231917],
              [80.742246021276983, 28.57215466249286],
              [80.747362106868223, 28.573013655913357],
              [80.756287349769721, 28.569822174774053],
              [80.766509831505431, 28.567546129874575],
              [80.771360554080573, 28.565283204459782],
              [80.772370981084464, 28.551481879550796],
              [80.781547614884857, 28.546267937808366],
              [80.786392226386909, 28.542121444166092],
              [80.786803585435734, 28.528571869660894],
              [80.787106370467612, 28.524553489713938],
              [80.794782005777094, 28.522281352361968],
              [80.803964132558505, 28.520900891823246],
              [80.821598950353746, 28.516807277212408],
              [80.829293130379398, 28.512306471512925],
              [80.831778716456824, 28.510187013489144],
              [80.837392836319438, 28.504085602436813],
              [80.83907001243162, 28.500634362704101],
              [80.841967743533473, 28.497710329839244],
              [80.855995294097795, 28.495185278839983],
              [80.863070408581095, 28.492797662100763],
              [80.867481828076322, 28.493356601766941],
              [80.867752534294809, 28.497420666757183],
              [80.864448360426465, 28.503124503421095],
              [80.867128568938668, 28.505781280730655],
              [80.879016586113977, 28.507324038226184],
              [80.892290865748421, 28.504568049082785],
              [80.895346434838672, 28.502745131321529],
              [80.896606084977208, 28.498905059923572],
              [80.908603851707056, 28.495003471418261],
              [80.910268300846866, 28.48831722589798],
              [80.901666339125526, 28.483503315369013],
              [80.899236104679034, 28.478091664972084],
              [80.900061679407557, 28.468835105937917],
              [80.902395714951041, 28.460997209189806],
              [80.905709574199761, 28.459033540429186],
              [80.909747757410216, 28.457042638855558],
              [80.91561212815202, 28.458146969336092],
              [80.919895207325098, 28.46180768577177],
              [80.921193009484824, 28.455283136326475],
              [80.928870453523842, 28.454426543883045],
              [80.935220356034918, 28.459919209769055],
              [80.937207428653323, 28.464322816804383],
              [80.942301037772239, 28.46623530707382],
              [80.943431360827972, 28.463196636935994],
              [80.943521241312538, 28.459334455703303],
              [80.941175504119101, 28.456190120063219],
              [80.938673050038318, 28.452870358979322],
              [80.943227741162573, 28.450028721752041],
              [80.94799812633002, 28.449895115212563],
              [80.955064891507377, 28.446743958606802],
              [80.958458827415853, 28.445766045494615],
              [80.962930260426873, 28.448940074602032],
              [80.967916292751553, 28.450963491431121],
              [80.977357757701199, 28.451567975186713],
              [80.976068988583606, 28.446843549993165],
              [80.967731759192063, 28.443479736289245],
              [80.965687151802584, 28.437633146036401],
              [80.970213580560937, 28.434928130191608],
              [80.977035899636007, 28.43577262954199],
              [80.98164481988708, 28.440713351661522],
              [80.99058841772117, 28.440215117646368],
              [80.99389472757656, 28.443601130288492],
              [80.997589441076187, 28.44647796890661],
              [81.002115675301638, 28.449903556337645],
              [81.010616510415986, 28.449016064062626],
              [81.013854333387329, 28.448038302292428],
              [81.016967659258029, 28.442605031296893],
              [81.016564655633275, 28.433330669533945],
              [81.021664303640179, 28.431492521469874],
              [81.024628099040058, 28.43329304694813],
              [81.028349614971745, 28.436444645700416],
              [81.035979666871867, 28.432575297765034],
              [81.039779199102739, 28.429850134911835],
              [81.040017787973127, 28.425325674353001],
              [81.036945883379047, 28.422400733037883],
              [81.033613333564148, 28.419476432398813],
              [81.026544714132953, 28.415352470783532],
              [81.023141352236706, 28.413737341090886],
              [81.022375521444999, 28.410479792035169],
              [81.02922447042333, 28.405947454418115],
              [81.03175135773283, 28.402973748793446],
              [81.037130176504817, 28.400239768453972],
              [81.039658784223974, 28.403397816238183],
              [81.040083115696888, 28.411293982070589],
              [81.043768432749673, 28.412197022847277],
              [81.053464096611719, 28.407006284066483],
              [81.058207470141866, 28.40385950362473],
              [81.075527708012828, 28.392091692316129],
              [81.086143011917898, 28.384736275028125],
              [81.089322430052363, 28.38327480997275],
              [81.103340270324338, 28.37778431112687],
              [81.110197699892865, 28.375937021812646],
              [81.124467966864486, 28.374508871167585],
              [81.138732434078705, 28.372182417963089],
              [81.153986451777811, 28.370538995199823],
              [81.15908332493612, 28.369386812836446],
              [81.166516783408866, 28.368863823552392],
              [81.185152611074272, 28.365383721385513],
              [81.189682860003359, 28.364736948637255],
              [81.20068103505875, 28.362379100574596],
              [81.208284786656634, 28.360267476644896],
              [81.214929918609371, 28.357955760590063],
              [81.218711152681891, 28.353640709935124],
              [81.220219697424824, 28.350461515477821],
              [81.223426478072668, 28.345253350930768],
              [81.226018923991958, 28.341631976762596],
              [81.227787758861837, 28.338660398595025],
              [81.230571247828834, 28.336393428658397],
              [81.233600135807407, 28.33194348388729],
              [81.237132830134414, 28.325424164297246],
              [81.237888157300333, 28.322112583989878],
              [81.236518500293116, 28.310363898291705],
              [81.236402318626446, 28.292293194941323],
              [81.236766814635942, 28.288433522597035],
              [81.240421785630957, 28.280971306699268],
              [81.24474786865045, 28.277316256899084],
              [81.249027744571237, 28.270746930055697],
              [81.253325949311645, 28.266884963565037],
              [81.260653094419041, 28.259147845085554],
              [81.264191385320942, 28.254164576374261],
              [81.267742196694215, 28.250973256330731],
              [81.273292694097904, 28.244991683686624],
              [81.276531558799192, 28.241665619386623],
              [81.284842526505699, 28.233548396054843],
              [81.288392249441571, 28.228761795394266],
              [81.293002924724092, 28.223006897335924],
              [81.296568816987033, 28.220757943092611],
              [81.303361196764229, 28.219445494536227],
              [81.308333493959054, 28.213693956920888],
              [81.317586293763881, 28.205998723595908],
              [81.320425959929096, 28.201846092591982],
              [81.322164091727629, 28.195162259350841],
              [81.320659265651571, 28.18468055115645],
              [81.322415730645744, 28.180536896605421],
              [81.325952573171733, 28.174470876374382],
              [81.327358263737977, 28.170965858181571],
              [81.323398058430897, 28.167493140842481],
              [81.307273319063924, 28.164103162819575],
              [81.310468334735475, 28.160904349546765],
              [81.314405311471745, 28.161194455940041],
              [81.317595801807371, 28.156407463363024],
              [81.321524012719138, 28.155428329755065],
              [81.325470817752645, 28.156987234771655],
              [81.328669523144072, 28.154425999686481],
              [81.325759237695422, 28.147451187686933],
              [81.321804981922298, 28.144935286326312],
              [81.318206052699708, 28.142097227088684],
              [81.319588783892499, 28.135413622684851],
              [81.324951071392334, 28.134103163319594],
              [81.330543043467813, 28.137736648887884],
              [81.334842687324354, 28.138587735604808],
              [81.353996737298004, 28.140211174592],
              [81.364230231107484, 28.140139986861449],
              [81.370841727409129, 28.14185530509414],
              [81.376798182695353, 28.143866106368037],
              [81.381122482037469, 28.147944860956503],
              [81.380826372005089, 28.152051440760967],
              [81.379866039837069, 28.156164585652821],
              [81.376917378923622, 28.159413963740622],
              [81.373966532117493, 28.161777477701765],
              [81.373331241373776, 28.165304344920809],
              [81.375661688173409, 28.167922665276198],
              [81.378000767901597, 28.171426750137059],
              [81.381317292713874, 28.173165341149176],
              [81.390562871462464, 28.173100077892816],
              [81.394856372875807, 28.173949468488797],
              [81.416978540298132, 28.173788879526409],
              [81.429170481006665, 28.171056473607447],
              [81.439356406813275, 28.164825726494701],
              [81.443613936625425, 28.160391109601591],
              [81.450180929947166, 28.156528875775596],
              [81.451441836436899, 28.149481285906521],
              [81.454041291005609, 28.144769774913364],
              [81.455626735224769, 28.136543591198098],
              [81.461187351975269, 28.130343436142685],
              [81.474329803139497, 28.123498180421038],
              [81.481537951278568, 28.117575740414846],
              [81.484145009699247, 28.114033971242929],
              [81.47933387891257, 28.091784613828462],
              [81.477987309930157, 28.088569474867892],
              [81.47827743033109, 28.084166278031052],
              [81.481880357018767, 28.081205998631955],
              [81.488786563489199, 28.078511040323427],
              [81.504440784577611, 28.070431540783758],
              [81.509854186244596, 28.068070637079245],
              [81.516557546404584, 28.063957728729992],
              [81.52651376473635, 28.059239156556036],
              [81.536465350448609, 28.054519917879588],
              [81.544466718640678, 28.049815101276099],
              [81.550528559276216, 28.047250338842446],
              [81.564372699075861, 28.040759201199094],
              [81.568258708364226, 28.038020200703944],
              [81.572570811230577, 28.034311379882546],
              [81.574721305875684, 28.031780969669885],
              [81.580773235956741, 28.028253276000413],
              [81.587483206998527, 28.02587465288806],
              [81.601343385404235, 28.021117640377078],
              [81.606105651061725, 28.019336952507381],
              [81.60913160528635, 28.017765309753006],
              [81.618055064807692, 28.011798731890973],
              [81.632866483773256, 28.002758182009778],
              [81.657664051921671, 27.993258272824413],
              [81.667939933110119, 27.990617535414668],
              [81.672113277110924, 27.989751693673135],
              [81.697078433019442, 27.989358303201488],
              [81.702373274324486, 27.987082174743026],
              [81.705879924921618, 27.984224134277085],
              [81.708380275615923, 27.981492699136933],
              [81.716756615258475, 27.975257611948773],
              [81.720851846667856, 27.971936578864945],
              [81.72676271640826, 27.967034742963104],
              [81.738344889743033, 27.956773130328184],
              [81.740666281993001, 27.954339196954088],
              [81.746812532171987, 27.949850063813599],
              [81.75498119703569, 27.943981934097149],
              [81.758483114171355, 27.940987126590588],
              [81.761009714249624, 27.938344267808766],
              [81.766736317855248, 27.93353456086404],
              [81.771754727536845, 27.929903490622401],
              [81.778933292883181, 27.923493095954299],
              [81.78141174155364, 27.921334141206703],
              [81.796042826982017, 27.91000442559827],
              [81.801447106920932, 27.906347547084909],
              [81.806818954243241, 27.902571056550876],
              [81.813648990699619, 27.899769420153152],
              [81.818525705809421, 27.901992620996989],
              [81.822297858766362, 27.902412394431607],
              [81.831495127969106, 27.899148912754612],
              [81.835214674207933, 27.897295677531549],
              [81.840941277829728, 27.892827373541564],
              [81.858613941356154, 27.880082652552712],
              [81.861139475654738, 27.877713464386975],
              [81.870448405052286, 27.871164890880355],
              [81.881775983350053, 27.865165906022575],
              [81.885321934677378, 27.861959108176411],
              [81.890581353328344, 27.857607841876227],
              [81.910348638153351, 27.854454437368201],
              [81.92126442593009, 27.855024985763436],
              [81.928172084997058, 27.858761122643827],
              [81.929068983415576, 27.862377283140756],
              [81.928796197776322, 27.867363432856823],
              [81.927062059760431, 27.873007743914556],
              [81.927368548829179, 27.876862321974713],
              [81.932754596495158, 27.880501027586664],
              [81.939923580641491, 27.88441569532144],
              [81.941366085063081, 27.888236178954745],
              [81.942294381083371, 27.892288301283472],
              [81.94405670207604, 27.894910527111307],
              [81.948389611123119, 27.898858144103862],
              [81.951602914821237, 27.901967393752756],
              [81.955843033676715, 27.906603414339941],
              [81.96080134759363, 27.912977210042133],
              [81.965729291690849, 27.918845770864088],
              [81.967706841568869, 27.922039272836017],
              [81.970304280518448, 27.927358500692627],
              [81.980982310867915, 27.928868289934567],
              [81.99533094260147, 27.926934246036776],
              [82.008120719833684, 27.926098539611537],
              [82.024922665849303, 27.924363673214078],
              [82.029432568769991, 27.923896909600852],
              [82.052656308405432, 27.921992500906427],
              [82.067151057327294, 27.921360347602821],
              [82.073120011677574, 27.92376801200529],
              [82.076755362080704, 27.919912100806108],
              [82.081798612600124, 27.911560670747242],
              [82.084723223350224, 27.908494554719397],
              [82.086197760533835, 27.905100898620478],
              [82.089966817293003, 27.901634764894737],
              [82.092219076205438, 27.898460956033734],
              [82.095693983337711, 27.894331393346739],
              [82.098409628970956, 27.889339047913868],
              [82.101669271671469, 27.886359553085683],
              [82.103929262799568, 27.883851245397846],
              [82.11301167156185, 27.880341866477558],
              [82.120792979401514, 27.87439035101087],
              [82.126006801409588, 27.865715471995152],
              [82.132572191417921, 27.863152700102916],
              [82.140678387754292, 27.86190373361832],
              [82.150065456009514, 27.858295435792837],
              [82.153921972096256, 27.864469513189739],
              [82.159069164374415, 27.865460769043317],
              [82.174048752259807, 27.85817449930385],
              [82.178141158206159, 27.855917841648701],
              [82.181720853237465, 27.853783334217528],
              [82.188066403112671, 27.850486129183434],
              [82.193782852406585, 27.848139870159912],
              [82.201122743199406, 27.847584336886115],
              [82.209267473781509, 27.844127849541302],
              [82.221479478632773, 27.834714606068321],
              [82.225250933099645, 27.830094718694529],
              [82.227982272470783, 27.826683817248203],
              [82.229954551524074, 27.824155556459878],
              [82.239758579366963, 27.817916999890677],
              [82.251634542722442, 27.813947416130713],
              [82.258410895848115, 27.810435310042802],
              [82.266127973037072, 27.804455534885388],
              [82.270811404342851, 27.800670845869757],
              [82.276702723412868, 27.79505863855017],
              [82.278906276492222, 27.790965726901387],
              [82.283661616340964, 27.786836070810864],
              [82.285656670075738, 27.784306940320739],
              [82.288915346382581, 27.781782364641607],
              [82.293960052049954, 27.779692939450392],
              [82.296774970163511, 27.776854460299827],
              [82.316579898772176, 27.768040840826917],
              [82.331823074450242, 27.760917249834488],
              [82.349093393575501, 27.753397338653006],
              [82.359501279895767, 27.747075965022749],
              [82.368573501895881, 27.741069235288197],
              [82.371425793036366, 27.739076453072204],
              [82.376914061441255, 27.734475876964897],
              [82.37913536827763, 27.731712944407999],
              [82.381582405189434, 27.7255695251079],
              [82.38398846276344, 27.720025413513994],
              [82.385499988622215, 27.716490253039719],
              [82.38772543892965, 27.713979703031576],
              [82.393255523640249, 27.710501137161486],
              [82.410954704123469, 27.700098046948678],
              [82.420624360450489, 27.694745421209873],
              [82.424181615234289, 27.691985044044124],
              [82.429878983621748, 27.68783873547962],
              [82.443487401913714, 27.684010076725755],
              [82.456063838578245, 27.677168193720146],
              [82.461858765546481, 27.675817248976891],
              [82.469959947791594, 27.675260662295198],
              [82.474777603212587, 27.675418504811631],
              [82.482957936904228, 27.679361727289361],
              [82.486055912407636, 27.682688724856568],
              [82.491587627967192, 27.680999957295786],
              [82.495988355606642, 27.685250391922832],
              [82.50436793702309, 27.685811754058051],
              [82.516812420291672, 27.689020809157487],
              [82.52579546137305, 27.688837375485946],
              [82.536928005502929, 27.686393529393218],
              [82.543369448112941, 27.685216528812884],
              [82.555575965044738, 27.68661161286057],
              [82.561423087151127, 27.68812717695852],
              [82.565503000600685, 27.688730345519055],
              [82.576990812840506, 27.694427203257359],
              [82.585645004509971, 27.697231269765098],
              [82.591651161928368, 27.697548777162798],
              [82.598572753666005, 27.695878654191304],
              [82.602413728617663, 27.697402558975959],
              [82.603734374536984, 27.701905013796157],
              [82.614203779565585, 27.703986441990779],
              [82.622032292188933, 27.702575850848458],
              [82.632300331726327, 27.708909443103888],
              [82.634106819022307, 27.711795421971633],
              [82.639415929677895, 27.710607603338527],
              [82.645475362059088, 27.709593354238621],
              [82.654912020940785, 27.712769268623195],
              [82.65953092937059, 27.71455260055065],
              [82.660520371946262, 27.720415201947727],
              [82.664708078237211, 27.719887927443313],
              [82.670776591332128, 27.716666061254625],
              [82.675273606303676, 27.716109639134807],
              [82.685193490847524, 27.717531981074966],
              [82.690736856164904, 27.716520537345225],
              [82.699418277008576, 27.720463991556809],
              [82.702372166970406, 27.718740267531956],
              [82.706525229774215, 27.720347479398349],
              [82.70770249077728, 27.723885203786431],
              [82.711257346676092, 27.726504486608796],
              [82.712540088640054, 27.719673004672867],
              [82.708896820229725, 27.711262361833498],
              [82.711591847073436, 27.700357035875971],
              [82.714425748758813, 27.696477411499462],
              [82.716406893806109, 27.69373362975071],
              [82.718613625380698, 27.689404369905496],
              [82.720371416852458, 27.683290594462918],
              [82.719620568312934, 27.677863288521241],
              [82.718181324379259, 27.674053372697323],
              [82.717601833431601, 27.670825090505538],
              [82.718148851493652, 27.66590388352299],
              [82.716092266222304, 27.662126544282657],
              [82.718805055977057, 27.660015385648315],
              [82.720323872923757, 27.654800343771218],
              [82.723878203787933, 27.654878274669951],
              [82.728289806811532, 27.655356342358658],
              [82.733070444609837, 27.65233750744142],
              [82.733812293434497, 27.648216663114244],
              [82.733102302386882, 27.64101846154313],
              [82.737922894702109, 27.641397922388794],
              [82.739888428249913, 27.637990057158959],
              [82.742017574742093, 27.633706446893346],
              [82.743251103259865, 27.628428042710418],
              [82.739935332289676, 27.627359664992756],
              [82.740299096890141, 27.623679049562707],
              [82.737962789831982, 27.618805389886692],
              [82.737832811101399, 27.612265623842799],
              [82.741221000103465, 27.604058164830299],
              [82.744960559947742, 27.60061878379668],
              [82.747809747830814, 27.596393503461467],
              [82.75332158314275, 27.588954093481878],
              [82.755009323926132, 27.583278121740474],
              [82.753863224319744, 27.577420416893958],
              [82.750502902130009, 27.574078780715908],
              [82.747617791130352, 27.568709202518122],
              [82.746516461650629, 27.565099527369771],
              [82.745511265411693, 27.553363840752855],
              [82.741659736659301, 27.549822129967563],
              [82.741068708899789, 27.54464360316631],
              [82.743435868372814, 27.542101539954135],
              [82.74544962771192, 27.537337894130928],
              [82.745402464111635, 27.52852332135112],
              [82.749263102970801, 27.524830292543534],
              [82.748929833338579, 27.521003199273931],
              [82.744800433063844, 27.518891327706665],
              [82.739878254287206, 27.517090822905281],
              [82.737914815121485, 27.513955732747839],
              [82.737340959746291, 27.509672629790359],
              [82.739968090549411, 27.502165919207201],
              [82.745731727040365, 27.499796081318156],
              [82.757113387252232, 27.50070661507781],
              [82.768697841184533, 27.500211992682811],
              [82.774306716665251, 27.500416584585441],
              [82.782187976732686, 27.49986787499012],
              [82.799792872767384, 27.497085578312273],
              [82.806999713532164, 27.496251936641812],
              [82.818268536064963, 27.495436026980514],
              [82.824098877562378, 27.496437000550909],
              [82.83227861853247, 27.500381407264474],
              [82.840781139535409, 27.501287275072826],
              [82.857301971216529, 27.498334369883047],
              [82.862879392202785, 27.4982603702963],
              [82.878275567363303, 27.496861755798911],
              [82.883296756507036, 27.49608499853321],
              [82.893708611809217, 27.497252957853235],
              [82.906927626262359, 27.499931532446826],
              [82.91538338282524, 27.499825351967978],
              [82.925657081472835, 27.500511968355916],
              [82.929533345046451, 27.499062883256784],
              [82.93795207986706, 27.494869641136994],
              [82.94109608191981, 27.489235147969673],
              [82.943647882006204, 27.48246024630215],
              [82.947339270726275, 27.473670926404374],
              [82.950619558148844, 27.472050278279379],
              [82.968871685019352, 27.466341800181901],
              [82.97547628003592, 27.463926127496716],
              [82.989735367457499, 27.461388890334796],
              [83.002422814330956, 27.458651314372027],
              [83.01026103723504, 27.456391704912456],
              [83.023027949379966, 27.452618307523711],
              [83.047707906372594, 27.448547063072564],
              [83.053015267279989, 27.448011023123023],
              [83.079049178200194, 27.449211192275872],
              [83.098342103723368, 27.450056716239612],
              [83.11222978934525, 27.449350823937891],
              [83.161695650883004, 27.454693550644969],
              [83.173908797038521, 27.453877401593719],
              [83.184165840365807, 27.452893522211411],
              [83.189641751918487, 27.449799666277553],
              [83.192872671310212, 27.447301425205456],
              [83.195850370926806, 27.444993382195275],
              [83.199576018533449, 27.441751599990667],
              [83.20324153817046, 27.438165619193537],
              [83.20549696556256, 27.43575490676389],
              [83.207219949811858, 27.432599388538357],
              [83.209312282964063, 27.426634002256428],
              [83.213008183117637, 27.422268782707036],
              [83.21521589057852, 27.418964682270939],
              [83.224134072887594, 27.411666823311812],
              [83.246653860746008, 27.401707152338297],
              [83.261017804891424, 27.38929408552471],
              [83.272416354193467, 27.380636398674234],
              [83.272773975854847, 27.374270248157277],
              [83.270057404577443, 27.366201297214982],
              [83.269942779097775, 27.361474489826076],
              [83.27123764217734, 27.356697254100332],
              [83.272777340554171, 27.353496233587816],
              [83.276695207173802, 27.349880828748084],
              [83.278668721577986, 27.346604996528253],
              [83.283180611498679, 27.344261882718644],
              [83.293129802858687, 27.337300211027962],
              [83.296835875995441, 27.334705978374412],
              [83.30282999203331, 27.333227654197533],
              [83.311843041208675, 27.329185462549656],
              [83.319367396443909, 27.332378047647381],
              [83.326859270763066, 27.333185906940109],
              [83.330640453454635, 27.332418912707624],
              [83.336931228539626, 27.332517353229996],
              [83.341271723073831, 27.333548773790088],
              [83.357607080063445, 27.339977121082278],
              [83.363769925908741, 27.344137252553338],
              [83.367170557403654, 27.34858757125059],
              [83.373649634264979, 27.355014261151435],
              [83.373606726508456, 27.358389338933133],
              [83.373861517900778, 27.363342329572056],
              [83.37725027638497, 27.367332991335843],
              [83.386968312431364, 27.369811613863334],
              [83.391150996049845, 27.372706082005049],
              [83.392076105586327, 27.383749872444099],
              [83.3949818661509, 27.388874547394163],
              [83.405863678963769, 27.398580090330096],
              [83.406888311301088, 27.409413541909178],
              [83.405311096478329, 27.415002733484641],
              [83.398171694741634, 27.421146587378811],
              [83.393996211178731, 27.424633755471532],
              [83.391537419632073, 27.426936458600601],
              [83.391688125088777, 27.434736016318094],
              [83.392956887993847, 27.438175021749075],
              [83.401282086593056, 27.446145640044161],
              [83.406783987201919, 27.454152410059745],
              [83.406157199198432, 27.459810935081908],
              [83.403534476621999, 27.461772930242081],
              [83.398774548392197, 27.463528712020718],
              [83.39577734117367, 27.464947200923486],
              [83.394042279153567, 27.475450497615341],
              [83.401307739449763, 27.477083665957029],
              [83.422338877791162, 27.478214161028976],
              [83.428909870032641, 27.47784247581837],
              [83.441482136915056, 27.475938923666217],
              [83.451325808016534, 27.474851910009864],
              [83.458427182513248, 27.475154022476932],
              [83.463661085880403, 27.474765663138147],
              [83.47854173332793, 27.473657762367811],
              [83.523645430181659, 27.471368601085913],
              [83.534823719710502, 27.471255791030465],
              [83.543122963625848, 27.471161153010279],
              [83.570878424668621, 27.469982556226302],
              [83.584318901866737, 27.470778609788937],
              [83.608615733690101, 27.470036896668791],
              [83.613598087705512, 27.46895931526047],
              [83.633229416999356, 27.460403259571681],
              [83.641182438967903, 27.457121035282537],
              [83.649164873895288, 27.453952939209291],
              [83.673409416525956, 27.442391676458634],
              [83.691537875969161, 27.433726778926019],
              [83.695582316414928, 27.431413837727654],
              [83.705977626735887, 27.425469422559335],
              [83.741804728648134, 27.40880502548918],
              [83.745127353863367, 27.407279741409546],
              [83.751865414490624, 27.403148228848689],
              [83.767632807042602, 27.397580858517419],
              [83.782357896834824, 27.390663655358882],
              [83.796803705645075, 27.385746818098006],
              [83.801781760134844, 27.383810892927645],
              [83.819615249519615, 27.376215892589641],
              [83.823354921267978, 27.375001102943035],
              [83.839534955253384, 27.366251195800803],
              [83.853937970889618, 27.354926669550032],
              [83.857299355679928, 27.35133309319281],
              [83.859702164978017, 27.349046458796554],
              [83.862714295402768, 27.346908811442486],
              [83.86656487476418, 27.344931191057398],
              [83.869348631869116, 27.34856258663968],
              [83.871698239578933, 27.352748145041282],
              [83.874759467348284, 27.356674782872712],
              [83.878843488703978, 27.359982666504756],
              [83.881991892555234, 27.364721361152007],
              [83.884463607405195, 27.367733556423726],
              [83.885921477529337, 27.370914041590385],
              [83.886333227244563, 27.37606203458029],
              [83.884755234526594, 27.37946713578949],
              [83.882165629257571, 27.38303819267535],
              [83.879179044335288, 27.386060269014347],
              [83.874379763694165, 27.388694895528118],
              [83.869389481757594, 27.39078717237749],
              [83.865300260623869, 27.393252283612171],
              [83.862619290412198, 27.396098095856033],
              [83.861029164541776, 27.400134756437726],
              [83.857282368439897, 27.406121854579901],
              [83.854294637232286, 27.40914337717971],
              [83.849898205487321, 27.411783924554491],
              [83.844675428179755, 27.415313827498554],
              [83.840675308438193, 27.418500790650739],
              [83.837070358900519, 27.421965594783753],
              [83.834933873898507, 27.428158364978611],
              [83.837784773582669, 27.432620761524809],
              [83.841441999453835, 27.437098953000124],
              [83.845300410962352, 27.441758458829614],
              [83.850885782097976, 27.445993323142996],
              [83.856463833250316, 27.445174391600695],
              [83.860656600903724, 27.442621172962962],
              [83.864958398808511, 27.439618602297671],
              [83.869457160986016, 27.436889228051378],
              [83.874347638018634, 27.434887859823814],
              [83.881124373782384, 27.434896864721036],
              [83.88705780910044, 27.436700552865144],
              [83.892281942505193, 27.438581432040397],
              [83.897429175472809, 27.439110037373872],
              [83.90419511420302, 27.439749902221131],
              [83.909765182519308, 27.439292121506398],
              [83.915416052549944, 27.439915124625514],
              [83.920439872708826, 27.44179290700739],
              [83.926244547813596, 27.445216172222551],
              [83.931962380738625, 27.447827089897693],
              [83.935990346178357, 27.448875794660385],
              [83.941385038374861, 27.44687997311329],
              [83.947091921318659, 27.444436761639718],
              [83.950282649061506, 27.441144616699326],
              [83.955633640495762, 27.441671108200318],
              [83.962315014557959, 27.441317159988085],
              [83.966910062928648, 27.444540336996901],
              [83.970639237641663, 27.445405816271091],
              [83.976261470088744, 27.44187603692588],
              [83.98197695731389, 27.43889159557984],
              [83.987202600813077, 27.440769329380473],
              [83.989693815429092, 27.442968509767041],
              [84.000091336022351, 27.444755296023082],
              [84.004146520694462, 27.443442741165423],
              [84.008127103385931, 27.441333909077972],
              [84.011593095293733, 27.439578399675266],
              [84.016270045952908, 27.438200170364023],
              [84.019624923002667, 27.437073026659533],
              [84.025722627380205, 27.435354726185931],
              [84.02995409405699, 27.436223857569559],
              [84.034843111569785, 27.440171822408335],
              [84.037732481214647, 27.442737268724834],
              [84.040739803172229, 27.444313348054639],
              [84.046494559027565, 27.444932622855053],
              [84.049944290276287, 27.444258454474451],
              [84.053501403259929, 27.443224453652945],
              [84.054341882848263, 27.447385188113348],
              [84.056399271126921, 27.451474925625771],
              [84.060829102949981, 27.452616298222651],
              [84.063619945493286, 27.455090642779112],
              [84.065187488272514, 27.458180486216037],
              [84.065033329708754, 27.461336468743458],
              [84.066449391507206, 27.467579904603152],
              [84.068524234614017, 27.470495345000806],
              [84.069986854054591, 27.473763337807217],
              [84.070642118304093, 27.477110802706562],
              [84.07017386283627, 27.480893344464345],
              [84.074686497347614, 27.483390788512011],
              [84.079404588820736, 27.485529348932758],
              [84.083355905535655, 27.485222315597127],
              [84.087791920905346, 27.486183651493004],
              [84.090794034331495, 27.488119424574549],
              [84.09419109127272, 27.490872248908428],
              [84.097794614596225, 27.493176624028955],
              [84.101657824452815, 27.498369432117226],
              [84.102730414937412, 27.507044805157179],
              [84.102072066968816, 27.51019357448115],
              [84.101909809970536, 27.51389160294519],
              [84.104094040675264, 27.516628109794009],
              [84.106379472916899, 27.519094483095742],
              [84.111201450934047, 27.521322520006748],
              [84.11717788687146, 27.520950849147447],
              [84.120272393657814, 27.517293909905298],
              [84.123694274634545, 27.512286449328556],
              [84.129079781385826, 27.510821992568072],
              [84.134224678303397, 27.511882715033071],
              [84.137524425684859, 27.514272937427656],
              [84.141633945082276, 27.516851951700602],
              [84.146263749146371, 27.51835568756287],
              [84.151008615757348, 27.519049180126039],
              [84.156217281384102, 27.516139108629581],
              [84.156885102833442, 27.512268728323537],
              [84.155826392165949, 27.508826167328685],
              [84.153019143613577, 27.507075062575044],
              [84.151041220563826, 27.504253686225084],
              [84.149669914952568, 27.501348222185214],
              [84.148935156494275, 27.496646975085287],
              [84.151251535851287, 27.490810777226724],
              [84.155162056496252, 27.486622742143599],
              [84.1593511247587, 27.483969830558117],
              [84.163428787792228, 27.482037314468261],
              [84.169099177360508, 27.481658637133304],
              [84.17159084762396, 27.477540149644039],
              [84.176083272968839, 27.47489177400103],
              [84.181669086818047, 27.473519147480157],
              [84.18676348748744, 27.471146979389751],
              [84.195275019210101, 27.470082495413074],
              [84.201138732259025, 27.470336274728009],
              [84.205819717148302, 27.468502174653207],
              [84.211094403061907, 27.46748429725579],
              [84.211149398642789, 27.463876993920536],
              [84.210810451245337, 27.459542392011187],
              [84.211172328956366, 27.455666582003637],
              [84.211934630516282, 27.452157290254068],
              [84.213004742556265, 27.448289897000809],
              [84.215818162155429, 27.442822134900968],
              [84.218496016784044, 27.439607475585778],
              [84.223964403030422, 27.439133134378931],
              [84.226190379296852, 27.445747635915357],
              [84.229568842557356, 27.4496695520839],
              [84.234103240318106, 27.450809205859397],
              [84.240965505696281, 27.451796259936238],
              [84.24663429638909, 27.451414785785424],
              [84.250485583791018, 27.450921185281352],
              [84.255155821227575, 27.449715148846227],
              [84.257423003411361, 27.44676529382863],
              [84.259749053180215, 27.439934524321188],
              [84.259495872795625, 27.436593360640337],
              [84.265217351883564, 27.432603756581472],
              [84.272044583216697, 27.428986252548103],
              [84.274526444019642, 27.425137037981809],
              [84.276539130844796, 27.418845610467532],
              [84.277411761842316, 27.414433680907315],
              [84.278499724506659, 27.409122656985961],
              [84.278861985657073, 27.405248717507739],
              [84.278108389597861, 27.401448300331751],
              [84.277366881138548, 27.396749420513601],
              [84.280735618082261, 27.394442470896422],
              [84.284598824895781, 27.392865742701073],
              [84.288187976656474, 27.389388358684357],
              [84.291776971790284, 27.385913175510662],
              [84.296618035354811, 27.386603245633253],
              [84.299906634780001, 27.3897992761529],
              [84.303727850697967, 27.391289690700344],
              [84.307683891319584, 27.390163616648433],
              [84.3160248130485, 27.386471294733088],
              [84.319820872855104, 27.38254671294586],
              [84.325298924312889, 27.381076162401303],
              [84.329264123506007, 27.379499096588681],
              [84.33424188681613, 27.377571529050542],
              [84.340540138349354, 27.37538758364283],
              [84.34630380632332, 27.375184829545045],
              [84.355218563123771, 27.373662085791654],
              [84.359954760871545, 27.374528689713362],
              [84.364417769311771, 27.373317758254395],
              [84.368570811659367, 27.372733959835049],
              [84.372510882234025, 27.372867761176842],
              [84.376231203093269, 27.374174176217238],
              [84.382893918820258, 27.374700918620217],
              [84.389707736858028, 27.371528485420825],
              [84.393277115298702, 27.369222878393522],
              [84.398438019316416, 27.36873787236906],
              [84.402572008890772, 27.369327469299527],
              [84.408944400629892, 27.368945436096336],
              [84.415096512984931, 27.369825532214005],
              [84.420031309207118, 27.37123409994426],
              [84.424377228314114, 27.371192667152719],
              [84.429744755449349, 27.370347354855326],
              [84.435517236401481, 27.369419791899116],
              [84.441692894249272, 27.368584569531173],
              [84.445861893313364, 27.36646375692224],
              [84.451358536598121, 27.363545653172988],
              [84.454799630002427, 27.363041848786715],
              [84.460257934135797, 27.362917783963766],
              [84.464438072289454, 27.36007716370446],
              [84.468924062575127, 27.356965122304494],
              [84.472289029802113, 27.354564362004542],
              [84.477721772786012, 27.35642744937315],
              [84.483138455085907, 27.359554237780614],
              [84.487481546260682, 27.359779914499985],
              [84.494581089236874, 27.357689666216611],
              [84.502269164604598, 27.356867186589476],
              [84.507334442645316, 27.356017103638781],
              [84.512401687688268, 27.354624605181069],
              [84.516457644507241, 27.353493909540017],
              [84.520810839175866, 27.352817868335798],
              [84.52678587825767, 27.351796381172729],
              [84.532852558178917, 27.351496924356947],
              [84.538515931467046, 27.351104928028018],
              [84.546299934589527, 27.350731362245426],
              [84.553489843773576, 27.349360693386956],
              [84.560260071504189, 27.349248679733194],
              [84.566423982403194, 27.349309366663004],
              [84.571593981143465, 27.347825962140156],
              [84.578174647732553, 27.346629511745583],
              [84.586810527707641, 27.342653476555164],
              [84.592582659861392, 27.34144669037185],
              [84.601393784210828, 27.339638182196644],
              [84.606865233341665, 27.338337025135225],
              [84.610595809609777, 27.338824465835184],
              [84.615134253934443, 27.339679832703766],
              [84.618869548348215, 27.339895881704475],
              [84.626181279807824, 27.336536990213556],
              [84.632740938296237, 27.328117099841364],
              [84.636656387270321, 27.321475802954094],
              [84.642601965131334, 27.313773283175443],
              [84.645393093907671, 27.308023605946012],
              [84.648786552559983, 27.302550936682366],
              [84.651668211202946, 27.297704852451226],
              [84.655057760737122, 27.292682398501515],
              [84.659071388819385, 27.285682426536102],
              [84.660333553385144, 27.28127238461909],
              [84.666478318116532, 27.273296345989632],
              [84.66915998639999, 27.26817739989389],
              [84.67194111416876, 27.263150899949675],
              [84.676053060309457, 27.256509322689425],
              [84.67915787327442, 27.249319424743728],
              [84.682463528711509, 27.242401729693565],
              [84.686888671508868, 27.234591617562696],
              [84.689883629679272, 27.228209755944977],
              [84.691450784438516, 27.22335273592898],
              [84.691282314754545, 27.220280959026724],
              [84.690455104384199, 27.21260380699615],
              [84.688899781912895, 27.207174954901273],
              [84.685619010478462, 27.202543006696185],
              [84.686190567524633, 27.196321758314287],
              [84.685543030629688, 27.190902577976946],
              [84.685495679221333, 27.186029258573896],
              [84.685947568216491, 27.181430061600476],
              [84.684570086202612, 27.178169621917107],
              [84.679179594088481, 27.172886222079452],
              [84.679115610421363, 27.169635534746671],
              [84.680884829119691, 27.164508278651088],
              [84.682840116043593, 27.16100715745457],
              [84.688069715064699, 27.162499087072852],
              [84.686906967686681, 27.15797557251334],
              [84.687846310858063, 27.154916840197426],
              [84.686566695267473, 27.152017759376168],
              [84.685802368351119, 27.14822049488226],
              [84.68514280695716, 27.143791733206037],
              [84.684296457893865, 27.138189474376215],
              [84.68211917575627, 27.134379445578443],
              [84.682068136633973, 27.129687440194694],
              [84.68019874283253, 27.125246999792523],
              [84.678431003194049, 27.120990942864267],
              [84.678278597874439, 27.116477556337454],
              [84.679825374982968, 27.113242923124755],
              [84.67609474502521, 27.113299485353529],
              [84.674618037283608, 27.110035819462858],
              [84.677270026738952, 27.107083477011759],
              [84.67832747363299, 27.102579319263182],
              [84.676447595746367, 27.099313299381613],
              [84.673860191754613, 27.096222443599547],
              [84.671979856143238, 27.093045991583338],
              [84.669702338633059, 27.089055759030725],
              [84.665810631150748, 27.085589256415922],
              [84.66158996846535, 27.084288606123565],
              [84.658588100142012, 27.08245474078014],
              [84.655501456762138, 27.078907715165215],
              [84.653212754073778, 27.07617915607948],
              [84.65052619914016, 27.073084931357581],
              [84.648284084946582, 27.066207024525511],
              [84.650030608530059, 27.063063379482436],
              [84.649192299864154, 27.057009859721255],
              [84.649536343269531, 27.053223267024542],
              [84.64694985835763, 27.050221462180083],
              [84.646182764159761, 27.046694868221692],
              [84.657003839250294, 27.043094807148059],
              [84.665701622956959, 27.040106865790587],
              [84.671974089850465, 27.037637704894767],
              [84.679272090582131, 27.033553420260791],
              [84.685031119956022, 27.032071585073219],
              [84.690386340748205, 27.030676885751145],
              [84.695328748084876, 27.030268206904431],
              [84.701589368389008, 27.028972527402662],
              [84.704526667450594, 27.027464845625701],
              [84.70827306534386, 27.025511069604438],
              [84.710714687455734, 27.023278589491174],
              [84.718191958921523, 27.021177485033281],
              [84.722231516591734, 27.020220422952619],
              [84.723073285465063, 27.016889158431486],
              [84.726117019239808, 27.014749418265126],
              [84.730448558742154, 27.014607632486683],
              [84.734273902485342, 27.014911239388706],
              [84.738525765202667, 27.012872064698939],
              [84.742770135218279, 27.011556925233666],
              [84.751067459358453, 27.007927492214527],
              [84.760498005695823, 27.001691876445523],
              [84.764795781336261, 27.005066466588193],
              [84.766669273193941, 27.009053623264549],
              [84.768846895147149, 27.012860703428043],
              [84.773045222775707, 27.016236789140979],
              [84.777559045323144, 27.018078689181703],
              [84.78040773904651, 27.015396585704462],
              [84.784152603196787, 27.013440977869699],
              [84.787598227152202, 27.011304399007443],
              [84.791563600214602, 27.007726536927425],
              [84.79222604493701, 27.001596096394547],
              [84.792970306216404, 26.997542046625583],
              [84.797310786101775, 26.996674203896568],
              [84.803691818211405, 27.000454315549753],
              [84.806707124402038, 27.004151748925253],
              [84.810295059381986, 27.007972197244413],
              [84.813801841612886, 27.009985068703713],
              [84.815974531605718, 27.014425995951424],
              [84.816231633960413, 27.019390762683688],
              [84.825788528471122, 27.020731785849485],
              [84.833159452193073, 27.018896010790503],
              [84.836199764956277, 27.017025399326158],
              [84.857835684970354, 27.008441837744485],
              [84.855979594119077, 27.002290160882577],
              [84.857416741535076, 26.999234556568535],
              [84.855131344498631, 26.995876483129944],
              [84.857983623034755, 26.99219982169312],
              [84.86151816067877, 26.991234503494809],
              [84.867372667011267, 26.989836060262657],
              [84.873027879937723, 26.988254849652751],
              [84.878083455438741, 26.986038499319484],
              [84.884754938628433, 26.983020009525056],
              [84.890411625604344, 26.981077242864309],
              [84.894157350283393, 26.978939587002021],
              [84.896503161512726, 26.975618548255841],
              [84.900955294107547, 26.973306793865714],
              [84.907301459525584, 26.972812603198506],
              [84.912638787616544, 26.972851743109516],
              [84.918782832545148, 26.972717122064477],
              [84.924928274849577, 26.972310993956686],
              [84.932083066253185, 26.971731795842029],
              [84.938642010884209, 26.970246242945336],
              [84.943993113838872, 26.968569255931417],
              [84.947429935202607, 26.966879706761024],
              [84.955607754920806, 26.964319473141234],
              [84.961660552410876, 26.962828658350588],
              [84.965908763481366, 26.960422299395681],
              [84.971086892213833, 26.955134059259493],
              [84.975866987635413, 26.949301452892261],
              [84.97942150097208, 26.945356167155836],
              [84.981269381095075, 26.940946629037338],
              [84.979793298313695, 26.936873647577706],
              [84.976192833401328, 26.93396267270975],
              [84.973697597857523, 26.931145641345879],
              [84.971812690033872, 26.927884855871866],
              [84.9709333093992, 26.924628021962654],
              [84.971473089934008, 26.920211043296739],
              [84.97560229826523, 26.919788097551191],
              [84.981341866030746, 26.919467832115572],
              [84.987385321794847, 26.918877218144114],
              [84.994641907817069, 26.91775292392196],
              [85.000546171218687, 26.916058724508989],
              [85.005558785301574, 26.911602078295083],
              [85.006810095084788, 26.906104623687487],
              [85.002596169106823, 26.9044518752203],
              [85.000909250912258, 26.901336983463032],
              [85.004559929141962, 26.897966068537855],
              [85.007896100020901, 26.895824070136793],
              [85.016670744542722, 26.893265025216888],
              [85.021601739368606, 26.893388667376058],
              [85.025735267933769, 26.892332098710973],
              [85.033592629553311, 26.891210460854122],
              [85.04094076844882, 26.890987951950724],
              [85.047685224614696, 26.890399792220261],
              [85.053732996049519, 26.888994983216204],
              [85.05656434772132, 26.887119199233382],
              [85.058798144458692, 26.884604403602044],
              [85.057020372221928, 26.879900948246917],
              [85.053102052705611, 26.879333448713712],
              [85.046958238684397, 26.87992630379372],
              [85.043543709588661, 26.879091316613891],
              [85.040332992660751, 26.877987935855629],
              [85.036021562047878, 26.875885045487841],
              [85.032914723295775, 26.874510530978799],
              [85.030331742096337, 26.870070575237555],
              [85.029166075280173, 26.864649174240999],
              [85.028386879091144, 26.86112381950376],
              [85.02771484559959, 26.857148086216931],
              [85.034082927699245, 26.853128454510159],
              [85.039317997084837, 26.852530660518894],
              [85.043848832959057, 26.85174862808806],
              [85.049287104077237, 26.850971838185188],
              [85.056734761562296, 26.85029830104888],
              [85.06156710385504, 26.849696102038557],
              [85.065190125369668, 26.849538074720922],
              [85.068587010220213, 26.852628256027991],
              [85.073511671573186, 26.853290629919929],
              [85.079137369073962, 26.85431844094115],
              [85.078714805765983, 26.857384369957238],
              [85.082837968614228, 26.857229930570579],
              [85.087185723819445, 26.854098380561609],
              [85.090791933052273, 26.856287362207091],
              [85.092682141633318, 26.859367574884143],
              [85.087308695135746, 26.865110357150837],
              [85.09414588333928, 26.865964382761774],
              [85.099767319341822, 26.867623754722235],
              [85.102669345485893, 26.869715989424741],
              [85.110403089174255, 26.871567739036106],
              [85.114728213684188, 26.871684349201907],
              [85.118452487969734, 26.871346080668705],
              [85.122275744962153, 26.871279332408285],
              [85.126912482888144, 26.870313498255243],
              [85.131046649499979, 26.868621872705884],
              [85.134373103352871, 26.867649738485497],
              [85.137885947829872, 26.869023360874472],
              [85.141196330696275, 26.870396355039603],
              [85.146727779621045, 26.870878782400041],
              [85.151959565561768, 26.870548594356151],
              [85.158402449107427, 26.869954791986785],
              [85.164850776632505, 26.868454815165009],
              [85.168569542798267, 26.868927005408271],
              [85.173296575019094, 26.869224711124978],
              [85.178425890891688, 26.86961529114264],
              [85.183257839632333, 26.869190991977607],
              [85.188084301992888, 26.869667858796301],
              [85.193012216791814, 26.869694212622395],
              [85.19645742662135, 26.865833099889727],
              [85.195977775913263, 26.861769021726865],
              [85.194197188931156, 26.857246294408721],
              [85.193718475605351, 26.852910871330614],
              [85.193946263531672, 26.848942702890326],
              [85.194083042846614, 26.842895727282777],
              [85.194308181523112, 26.838925272215185],
              [85.193831560229839, 26.834771354425236],
              [85.191750672681636, 26.829705111472716],
              [85.188755811975142, 26.825988556444653],
              [85.186156930295539, 26.823537599345062],
              [85.183464539181728, 26.819913650054975],
              [85.180672051421411, 26.816379038477425],
              [85.180113043197949, 26.809336666687887],
              [85.182241117678302, 26.806640350768021],
              [85.184373972485517, 26.803221969554109],
              [85.184605975515254, 26.797989000437013],
              [85.188043193249783, 26.795300493371588],
              [85.191081049353187, 26.791615282387372],
              [85.194694337017964, 26.792357994073161],
              [85.196323020333594, 26.789388793253707],
              [85.195743448122997, 26.785413810918641],
              [85.194557567991723, 26.781977668208597],
              [85.195080433115606, 26.778642384547926],
              [85.197216383083003, 26.774770709081068],
              [85.200254354392186, 26.770816218528687],
              [85.203796034972484, 26.76713647268366],
              [85.206836406222322, 26.763089798224172],
              [85.209162707527653, 26.760485483456495],
              [85.213395773014895, 26.758433001394963],
              [85.217418705074124, 26.758093056430614],
              [85.220830558177425, 26.759103719095634],
              [85.227353409022626, 26.760671158739353],
              [85.231268021269429, 26.7615034092969],
              [85.236387509123318, 26.762972904803913],
              [85.244332558791868, 26.761751198222811],
              [85.249463656066922, 26.760874784459734],
              [85.252392594773454, 26.758632105570928],
              [85.2575699981101, 26.756179457137129],
              [85.264473804368166, 26.754631129779323],
              [85.269503665656813, 26.754114840524679],
              [85.275335689160599, 26.753420697611677],
              [85.280462088321968, 26.753173356132127],
              [85.285588527132802, 26.75292814519489],
              [85.290718129295428, 26.752411382866764],
              [85.295745623637586, 26.751712652231639],
              [85.301672046822603, 26.752190485360792],
              [85.307804502705892, 26.752219986694168],
              [85.314043700684422, 26.750262690003531],
              [85.317568899652855, 26.748833902162858],
              [85.322297189709758, 26.747772746885527],
              [85.327638972153991, 26.744819886747749],
              [85.334079438636593, 26.743041443323829],
              [85.341808945047347, 26.744790057176438],
              [85.34530915384488, 26.748146075118306],
              [85.349811934689257, 26.752407235200558],
              [85.354012093629265, 26.757028817155039],
              [85.358914973444442, 26.761382309494923],
              [85.361822052498042, 26.763108917835279],
              [85.372198811460265, 26.75782779807194],
              [85.377209893045119, 26.760644764022523],
              [85.381216018572289, 26.764092538939419],
              [85.384501273220224, 26.771416269493102],
              [85.388003607729758, 26.774589597836833],
              [85.39483569461477, 26.775157045090314],
              [85.399452010117955, 26.777252943836437],
              [85.403961415331167, 26.780700701280921],
              [85.405253501592597, 26.783682424755924],
              [85.408245876046948, 26.789289766395203],
              [85.414372759767531, 26.790938541045634],
              [85.419101674003954, 26.789964188129698],
              [85.422124954927838, 26.788261228941238],
              [85.425650791011435, 26.786197750210036],
              [85.432583339211206, 26.787037285873257],
              [85.437602847086083, 26.789222112205756],
              [85.444251120455021, 26.785636653665488],
              [85.451201053424896, 26.782322474337132],
              [85.454725483259637, 26.780980326876026],
              [85.458741870781196, 26.782078309280568],
              [85.461245258765132, 26.784524756691447],
              [85.467266557259279, 26.78716250760883],
              [85.470581300096498, 26.788075646377948],
              [85.475302509909838, 26.789355358647331],
              [85.47920944892779, 26.793069525170399],
              [85.479292692820067, 26.797583454434946],
              [85.480180415283954, 26.802279566649489],
              [85.485517980250421, 26.799590571481247],
              [85.489245037334015, 26.798158102575933],
              [85.492969449279471, 26.796725600129317],
              [85.496387730142757, 26.796826545770021],
              [85.49707672101438, 26.800892408167616],
              [85.498271095468795, 26.804144549129468],
              [85.498257746266034, 26.808476645844017],
              [85.501058430363798, 26.812727602772728],
              [85.507484232717132, 26.815455931126657],
              [85.511405674034037, 26.815108462216163],
              [85.517338642622093, 26.815217078487059],
              [85.522575767204444, 26.812885487280877],
              [85.545022762467994, 26.837411986684266],
              [85.554989892584857, 26.833921781709581],
              [85.557193465134688, 26.837267816645159],
              [85.55898649870359, 26.842869434299985],
              [85.563416237900711, 26.842159693680127],
              [85.567341068375853, 26.840817519819403],
              [85.569337011968827, 26.846688005109261],
              [85.571330536405654, 26.853101095403204],
              [85.57634182478246, 26.859613276815825],
              [85.584894629564388, 26.858103171432177],
              [85.588124909485884, 26.854139199060988],
              [85.588342835452565, 26.848273586604336],
              [85.595177361543364, 26.850368191282165],
              [85.60311457320725, 26.853637383245207],
              [85.609442237318333, 26.856993752580841],
              [85.612752697492496, 26.860881427792627],
              [85.617366248803677, 26.866488684089486],
              [85.624390916488636, 26.873907080522869],
              [85.63717212298431, 26.872312633800238],
              [85.640004989072111, 26.865098894266961],
              [85.642132513822261, 26.85797267612384],
              [85.643250776296028, 26.853102321315962],
              [85.655226338987987, 26.849878764309445],
              [85.662172437587813, 26.847907453210031],
              [85.666498758974086, 26.846383283199824],
              [85.678069167043333, 26.844691791747675],
              [85.683004376957285, 26.84199407125681],
              [85.694678789988814, 26.836691349965292],
              [85.706054711145228, 26.831206213354498],
              [85.71350346208601, 26.826164921852154],
              [85.721860180165379, 26.819862384625676],
              [85.72639059830874, 26.816710618843427],
              [85.729015168496787, 26.809945735905153],
              [85.727409945854305, 26.806783164568557],
              [85.73124009316588, 26.801284083725509],
              [85.735973444576061, 26.794885013649107],
              [85.736281949257389, 26.789198179795768],
              [85.735896899892168, 26.777556240907877],
              [85.734500211533614, 26.770603814694773],
              [85.733904545307723, 26.765007346298319],
              [85.731599924180273, 26.759136468121387],
              [85.730000141903872, 26.753446528672644],
              [85.729907410093219, 26.748392176422609],
              [85.731924167950552, 26.744605249459351],
              [85.735449186749534, 26.73838399038064],
              [85.733744916218129, 26.735311017107534],
              [85.732342736856339, 26.731970985237808],
              [85.730236966250459, 26.729259338119544],
              [85.727229664925645, 26.724108575822985],
              [85.727134001144506, 26.720948977358045],
              [85.728444453278797, 26.717884728845583],
              [85.726143192081963, 26.711742096920915],
              [85.727154591676637, 26.706960252228594],
              [85.725055458120579, 26.700368920771318],
              [85.725059329630113, 26.696848148263516],
              [85.724161167085015, 26.692603713777014],
              [85.724170649870715, 26.687098211505486],
              [85.724079748058926, 26.681052350524684],
              [85.726796378199396, 26.676634591836915],
              [85.72841390819508, 26.669324634641082],
              [85.732234117736269, 26.667796457217761],
              [85.736054938173595, 26.664644598200788],
              [85.736264333033816, 26.657604877547119],
              [85.737279717439762, 26.65038491701663],
              [85.742307677675413, 26.644888237796856],
              [85.749540571498457, 26.640838059016691],
              [85.758681025264963, 26.637870965279383],
              [85.762197564910338, 26.636070992369866],
              [85.766116701243277, 26.633097585822064],
              [85.777965847328772, 26.629774445005729],
              [85.791419615425994, 26.626903729034748],
              [85.802264546742293, 26.625201347292503],
              [85.804678013491596, 26.620872057183622],
              [85.807088412741507, 26.6163610976113],
              [85.808499825258323, 26.611308601951443],
              [85.812816732716215, 26.607160530498927],
              [85.815829551285589, 26.604998944344096],
              [85.818952840979733, 26.603025488383491],
              [85.824063584400633, 26.602479979531825],
              [85.83028610568725, 26.602574088256343],
              [85.830483585922678, 26.608171686017403],
              [85.830679635443005, 26.61304484342153],
              [85.835700204968347, 26.611875618347742],
              [85.843932318799858, 26.610891968616471],
              [85.849251453681177, 26.609450496085227],
              [85.85387194470772, 26.604309455970277],
              [85.855277695970855, 26.598716102541939],
              [85.856183719844665, 26.594022758367849],
              [85.856285428017841, 26.588877706735801],
              [85.85367759569796, 26.585986504671798],
              [85.851371044682153, 26.582735963234295],
              [85.849064038426803, 26.579214002684463],
              [85.848061554131093, 26.575602464806469],
              [85.847560683106636, 26.572082087505851],
              [85.85077223176782, 26.56901556934039],
              [85.855388108073129, 26.568478848519241],
              [85.861308452282984, 26.571550641391458],
              [85.867025866843065, 26.575255098400941],
              [85.871842613898067, 26.578689513737281],
              [85.875957408679653, 26.581579964183629],
              [85.878364968698108, 26.585101351391753],
              [85.883483404856165, 26.582667749669628],
              [85.888097872805858, 26.585738687168085],
              [85.889302418568263, 26.588809070913165],
              [85.892514654460911, 26.593772990216141],
              [85.89592487283663, 26.594769187297295],
              [85.900041043175577, 26.596755095744875],
              [85.90054326599325, 26.600185533451153],
              [85.90496033986318, 26.603707041061906],
              [85.908371834362342, 26.605064016821348],
              [85.912487820832382, 26.608765305514943],
              [85.917908760832532, 26.610391573589411],
              [85.921421676367956, 26.611294953907684],
              [85.925034204509444, 26.612108365902337],
              [85.927744955986, 26.615359163537256],
              [85.932263162603235, 26.614185619000036],
              [85.934171468310211, 26.616803274810536],
              [85.939991707572318, 26.614548074946889],
              [85.944508491722061, 26.615632688603345],
              [85.945616361370369, 26.621048591950046],
              [85.947727154985472, 26.624567121738711],
              [85.951944727468927, 26.627365550212353],
              [85.952146897923001, 26.633595336172696],
              [85.952752002744319, 26.637565692760653],
              [85.95355603411133, 26.641266536201186],
              [85.954563004533753, 26.644334394273155],
              [85.956774694117684, 26.649749837180188],
              [85.960087975901828, 26.651917683455245],
              [85.964508769325406, 26.65381137573501],
              [85.968022574639789, 26.655346135918684],
              [85.971941904887402, 26.658054938795335],
              [85.975959883163981, 26.659498553156563],
              [85.979976376150589, 26.658775695770014],
              [85.983085880238178, 26.65696957528851],
              [85.986600865787508, 26.656337477733246],
              [85.990717893666258, 26.655885459636284],
              [85.995738715711411, 26.655522990195927],
              [86.000255389884288, 26.656622106325372],
              [86.007286208048384, 26.656603534836375],
              [86.010801345146078, 26.656060580280901],
              [86.014717583139685, 26.656059231445148],
              [86.017030768184895, 26.660390324875298],
              [86.020345383696238, 26.6618324354389],
              [86.026172789470706, 26.663725124098875],
              [86.030193450012334, 26.6664321854302],
              [86.033808568293807, 26.666610593525618],
              [86.038327625584671, 26.666156189383525],
              [86.042743319517072, 26.664710800355774],
              [86.047059704947586, 26.66344493194941],
              [86.052882648699963, 26.661905420219309],
              [86.05780225366891, 26.660458064732978],
              [86.063322098348038, 26.659372166949382],
              [86.068442994410916, 26.659096768852244],
              [86.071857263254543, 26.659003528440337],
              [86.07546566200277, 26.654128385186272],
              [86.076764129953077, 26.650336657454734],
              [86.084088699420462, 26.64753105316753],
              [86.088703049964906, 26.644188638187],
              [86.093920316286201, 26.641927371716875],
              [86.097931632153802, 26.640447219778238],
              [86.105356742626611, 26.637221657404464],
              [86.113683466486833, 26.633242989805275],
              [86.119402539111363, 26.631250547634348],
              [86.124117676816084, 26.629712095127768],
              [86.127025911642534, 26.628172786802811],
              [86.134454099195679, 26.627983911000303],
              [86.139372826036848, 26.628610760095182],
              [86.142671764099006, 26.621655954516577],
              [86.140452242875469, 26.61615330546919],
              [86.139430816228256, 26.608392577655145],
              [86.141230527177214, 26.604508647601499],
              [86.146755205521956, 26.606398035593212],
              [86.150070526845155, 26.608559656439041],
              [86.154790936124002, 26.609635164931962],
              [86.159613996222532, 26.611885400193835],
              [86.165642788610427, 26.614223039938583],
              [86.174281836922134, 26.616557641801332],
              [86.178289585343109, 26.613934653347801],
              [86.1821034435131, 26.613658119906539],
              [86.190136284901484, 26.614368138473441],
              [86.194551469279872, 26.614631821358874],
              [86.196148698030584, 26.611017161191043],
              [86.198449572091832, 26.607944821864642],
              [86.199636598452571, 26.600994554079275],
              [86.198522023571684, 26.596934967768608],
              [86.201124964979542, 26.594493857369059],
              [86.206245283374685, 26.595748008266717],
              [86.2117616674457, 26.593752883479997],
              [86.215871345759183, 26.59239112801751],
              [86.221684063847121, 26.58985405135104],
              [86.226904333682455, 26.590115812875005],
              [86.230817572468638, 26.589927387250828],
              [86.236541097356493, 26.590547848816378],
              [86.237053546784878, 26.594699406403191],
              [86.239476874310455, 26.599296067197333],
              [86.244103568873399, 26.602446085353986],
              [86.24732869658142, 26.607133585680547],
              [86.250047749947953, 26.609925706331602],
              [86.256483038159146, 26.613343687783004],
              [86.260901619262569, 26.614235620626598],
              [86.266025420705049, 26.615398037184789],
              [86.273154966464645, 26.616466507721341],
              [86.27897783441577, 26.61627312216924],
              [86.283288595550701, 26.615180141871271],
              [86.290211336223777, 26.613539443625399],
              [86.296531025151893, 26.612984491272112],
              [86.301257919619559, 26.615410172755322],
              [86.306992158733863, 26.618555542978008],
              [86.310911834087761, 26.619809393541949],
              [86.316730665200524, 26.619343314633184],
              [86.322050044622358, 26.61924040111316],
              [86.329478284744098, 26.618768552921992],
              [86.33660249578223, 26.617939055311812],
              [86.345629596522116, 26.616559660258957],
              [86.343899512362668, 26.610066222065765],
              [86.3431813856958, 26.605916076842238],
              [86.353013895269683, 26.605438526933042],
              [86.358933547716461, 26.604429828636682],
              [86.367053852355923, 26.602239433379822],
              [86.375473589864342, 26.599688325760621],
              [86.380283038353696, 26.597959962290677],
              [86.386399940985115, 26.596677874188863],
              [86.396429015645879, 26.594662477594525],
              [86.398723538105401, 26.591405476305781],
              [86.398294667906299, 26.585540625237453],
              [86.402201429939154, 26.583995594178035],
              [86.407413503679294, 26.582174525460001],
              [86.413827065093585, 26.580257323952239],
              [86.42053996657674, 26.577979475898225],
              [86.427751064632645, 26.575250210590514],
              [86.435769139226792, 26.573146406628396],
              [86.443589843640979, 26.571767746400326],
              [86.448299921339213, 26.570396547138397],
              [86.455016530017346, 26.56920046946966],
              [86.460324499344964, 26.56701601370731],
              [86.466623769311269, 26.562843298213352],
              [86.471524068244605, 26.559485432458633],
              [86.477326945476449, 26.556124599075883],
              [86.482328357227786, 26.553398343490787],
              [86.488431184207116, 26.549855957706718],
              [86.495832121070009, 26.545496253057333],
              [86.501030868111698, 26.542227714100644],
              [86.507040246642546, 26.54040095602581],
              [86.515266889801822, 26.540368700368703],
              [86.521699020116159, 26.542869879867801],
              [86.52631772024759, 26.543573768182181],
              [86.53363703109261, 26.542552334575063],
              [86.538343886316653, 26.541360151272034],
              [86.545334137592519, 26.535735523283606],
              [86.550923462497408, 26.530569923346214],
              [86.552911817508758, 26.527402035514033],
              [86.553881143588598, 26.521712637461921],
              [86.55595072692951, 26.515475901225088],
              [86.558941408238923, 26.512032568814256],
              [86.564822445470611, 26.505781225781185],
              [86.569501107138905, 26.500165123825205],
              [86.572998687874573, 26.497893681563461],
              [86.578707488073192, 26.496606491941517],
              [86.58882055689557, 26.494306668092932],
              [86.595327078028404, 26.492112095315093],
              [86.60352999760967, 26.48918642007694],
              [86.611039798266731, 26.48752757594885],
              [86.61804985964001, 26.486051043876376],
              [86.621235377583758, 26.482336054684506],
              [86.62483201779834, 26.480154772030339],
              [86.628128305773117, 26.478152518149425],
              [86.629002783296272, 26.473817799890362],
              [86.63187597653851, 26.468568119385996],
              [86.635473194186048, 26.466837435871078],
              [86.641876007506099, 26.464731301485948],
              [86.647681000918581, 26.462987733319167],
              [86.653783828720478, 26.461423730895756],
              [86.659987238352684, 26.459679345495836],
              [86.664993916362661, 26.45848111330373],
              [86.682502643504407, 26.453702096920882],
              [86.690007698415968, 26.451857714005143],
              [86.697307000271508, 26.449294448930374],
              [86.697181914350722, 26.445504503742583],
              [86.698960272011107, 26.441974876728331],
              [86.702846406192279, 26.438706261062595],
              [86.708146962942934, 26.436782258268245],
              [86.713754983288339, 26.436121058330848],
              [86.720162054429196, 26.435095054440815],
              [86.723552947673241, 26.432820900819053],
              [86.727827275670663, 26.427924825065965],
              [86.732013599012433, 26.424924717719243],
              [86.741454540509139, 26.427760868873044],
              [86.74710289974368, 26.432423279617776],
              [86.748427927488578, 26.435663812071198],
              [86.751156823485104, 26.43871905965856],
              [86.754389871640853, 26.442129340746249],
              [86.755326509864688, 26.446727472099976],
              [86.76304111073857, 26.446414595732765],
              [86.764672474792917, 26.449834294208245],
              [86.766111283724655, 26.454520579042182],
              [86.76854102977785, 26.457754855158768],
              [86.77285555149065, 26.45836181678553],
              [86.778354445520321, 26.456346590305419],
              [86.781548047442115, 26.454613282288349],
              [86.785741539856417, 26.452421405314102],
              [86.790337895297142, 26.450410328816481],
              [86.795230463455766, 26.44812545577258],
              [86.802335004936467, 26.446550168443331],
              [86.808633435919461, 26.444345936516367],
              [86.818032785884427, 26.441762995235969],
              [86.823335340799744, 26.440467675799926],
              [86.830546680541971, 26.439702227378991],
              [86.836861360033424, 26.439753307250502],
              [86.84287551504282, 26.439898561251987],
              [86.84883426251622, 26.445277094043682],
              [86.851261304948608, 26.447787839164061],
              [86.855273495142526, 26.448305280767077],
              [86.858097395148363, 26.450361871390044],
              [86.860823772044952, 26.452872374333225],
              [86.866160277958215, 26.455455823281753],
              [86.870861651439355, 26.454343256783446],
              [86.875894342638617, 26.456928933716572],
              [86.882222743090523, 26.458240860396025],
              [86.887355328412369, 26.460556175717564],
              [86.891264610990049, 26.460710110954093],
              [86.896786322100937, 26.461577328016737],
              [86.89615162661535, 26.469433304494601],
              [86.894695980553621, 26.47476807035682],
              [86.892743319633269, 26.481006381530744],
              [86.896404221672384, 26.486758530392567],
              [86.906038240126591, 26.487687689510143],
              [86.93191411752251, 26.488507932812571],
              [86.931493248245786, 26.497535114166642],
              [86.932350713047384, 26.503666878566261],
              [86.933127023410705, 26.511784287488641],
              [86.934265893319107, 26.515746841446493],
              [86.940485053042721, 26.516066038888098],
              [86.946816129190495, 26.517285590721379],
              [86.951148392094893, 26.519511360057663],
              [86.957069609249544, 26.519922148707415],
              [86.963709999049613, 26.522042269128129],
              [86.968116105546756, 26.521377977392742],
              [86.977829086161307, 26.519415317687809],
              [86.986635349455867, 26.528015432093014],
              [86.999714642672004, 26.527290040269026],
              [87.015981504720799, 26.533756711484521],
              [87.018720949342665, 26.536986401787086],
              [87.027464266313473, 26.548924376046507],
              [87.037859013485047, 26.56130329161341],
              [87.040866008356389, 26.564797709591176],
              [87.046066433636952, 26.573059460626862],
              [87.045704898896645, 26.587230841346177],
              [87.072392262044445, 26.586483995238794],
              [87.074806664296602, 26.577261154990374],
              [87.073723193142015, 26.559671612000891],
              [87.074941751838509, 26.541432038396572],
              [87.078409517480779, 26.537072644611911],
              [87.082259711017173, 26.521340078694923],
              [87.083394410564267, 26.514562249016141],
              [87.083498150718384, 26.505356095610548],
              [87.088963411958133, 26.471111388606694],
              [87.092475439746082, 26.452132865611375],
              [87.114837577419806, 26.433903142568777],
              [87.130251455472489, 26.422588821227116],
              [87.138817174483279, 26.417464227652204],
              [87.14498878685049, 26.413623579423611],
              [87.152252415843506, 26.408870033614644],
              [87.157527843962129, 26.405757845693717],
              [87.163824471857097, 26.404261538442913],
              [87.169532763455848, 26.403944106182081],
              [87.178151983980811, 26.404139869686418],
              [87.19088333814264, 26.404663525999617],
              [87.188344053399263, 26.410550829220419],
              [87.187680807960092, 26.414077190013533],
              [87.212822773847478, 26.413047989733712],
              [87.213368427673444, 26.408170137374714],
              [87.218134882327831, 26.404336501291883],
              [87.222361497399248, 26.406015509260101],
              [87.225705012996386, 26.40914362417265],
              [87.230667755094828, 26.413793694942157],
              [87.239999690379975, 26.414703156348512],
              [87.246312012530922, 26.41464571958943],
              [87.251998053543446, 26.41260949406071],
              [87.2572045860787, 26.412202173856116],
              [87.261896269984192, 26.410534942523366],
              [87.265574357635742, 26.408153862821237],
              [87.267109952098565, 26.40236570891382],
              [87.267750644798099, 26.397304867835018],
              [87.266142373134301, 26.388295214072279],
              [87.266401187132644, 26.384683039768614],
              [87.266772907828056, 26.373761130356005],
              [87.271882794021664, 26.373894962722879],
              [87.277795788503084, 26.374111973287224],
              [87.286910098164768, 26.374027251918662],
              [87.290522068779183, 26.37444583211429],
              [87.303147812034098, 26.366567094948941],
              [87.313632320143938, 26.371883370816139],
              [87.318540993811638, 26.363805189161891],
              [87.326105193690466, 26.359854335856753],
              [87.329890091503273, 26.358192773147653],
              [87.341187330899757, 26.348337874808315],
              [87.349972562525082, 26.354119461769542],
              [87.358266888579337, 26.360536394688641],
              [87.354611161460241, 26.372574719866137],
              [87.355774998662739, 26.385556943432569],
              [87.360882668277128, 26.393178078953603],
              [87.365114485824421, 26.402973682870744],
              [87.370181580324683, 26.407434153568378],
              [87.378305844789523, 26.408167454206794],
              [87.388763803692498, 26.418712284350569],
              [87.399001557555607, 26.419963078074495],
              [87.41114663093461, 26.421464783708146],
              [87.428780145534489, 26.421014827811316],
              [87.43354080852535, 26.424754469435385],
              [87.444068648249072, 26.432676908209327],
              [87.451615704335794, 26.434855513606418],
              [87.458767298374184, 26.437579108616244],
              [87.462905105914075, 26.439701224246537],
              [87.4729310463225, 26.439774186053782],
              [87.478543237053913, 26.439805549740868],
              [87.493840406611696, 26.43693576712986],
              [87.517904063419678, 26.430359010211539],
              [87.536821073297943, 26.421399511076359],
              [87.549709716425966, 26.418641557058518],
              [87.555328541411825, 26.405134306910352],
              [87.576235895481332, 26.395785927311664],
              [87.586727880688485, 26.393862694909199],
              [87.590369637997583, 26.382451767249297],
              [87.609384717965696, 26.381061937885832],
              [87.614237911870646, 26.390840779660451],
              [87.619164316828474, 26.39204688527742],
              [87.629106221999422, 26.393465882787822],
              [87.645548198831747, 26.39302270463871],
              [87.652842678788744, 26.392825908562479],
              [87.651533627010508, 26.405654518807495],
              [87.6786531969572, 26.41624979397907],
              [87.679257578438879, 26.42300964395697],
              [87.679149777411766, 26.435552984099161],
              [87.694085008067972, 26.435645170584905],
              [87.700392893273118, 26.428801654993045],
              [87.715406271214931, 26.427353990041581],
              [87.717756828594986, 26.423986474266229],
              [87.722357083136316, 26.416893681286087],
              [87.72458438649231, 26.41199326086133],
              [87.729665253638828, 26.410124942463586],
              [87.735637077890374, 26.407616228914648],
              [87.737091782240071, 26.410846842885654],
              [87.738176480254452, 26.41606553042212],
              [87.740324665058324, 26.418745956203317],
              [87.747642867913498, 26.41892593881682],
              [87.752039381343863, 26.411832757459376],
              [87.754080648378789, 26.407928263854593],
              [87.758399014225347, 26.408415985813029],
              [87.766625986119081, 26.409033369417635],
              [87.767338714903119, 26.415881150151534],
              [87.771490233573914, 26.41853561111019],
              [87.775951714586441, 26.421818280899],
              [87.776339694296468, 26.427136084552007],
              [87.778497255592598, 26.430448507603582],
              [87.780066850209224, 26.434486818488303],
              [87.779427087300093, 26.43828456765738],
              [87.778894797370498, 26.442533982015458],
              [87.778445859712292, 26.44569640222397],
              [87.77703528593581, 26.451487842105095],
              [87.78301089918962, 26.455202209489151],
              [87.784386979946589, 26.459696299886165],
              [87.789317041485731, 26.460715198972974],
              [87.792059733092898, 26.462935641494251],
              [87.789233636100334, 26.467845212833506],
              [87.795858202294255, 26.468391586975699],
              [87.805715371248112, 26.464203778780643],
              [87.816076033415442, 26.460192201165032],
              [87.82549039223899, 26.453573269322835],
              [87.831041387162529, 26.449801771322761],
              [87.829578778937218, 26.440347299130028],
              [87.839561069047292, 26.437779506655737],
              [87.850549961641718, 26.4356497864201],
              [87.852223241173917, 26.43977791919453],
              [87.852795491017687, 26.443921906975884],
              [87.857750363487426, 26.446472715014927],
              [87.86127297321552, 26.447238284433588],
              [87.863815646367556, 26.449368371118108],
              [87.862880008410926, 26.453350189574785],
              [87.861023909915303, 26.45617209725356],
              [87.860688705770116, 26.460147487778123],
              [87.861649554695305, 26.463563426449632],
              [87.864969099342701, 26.464239873250797],
              [87.865232165226004, 26.467935078348294],
              [87.871285752812057, 26.470110572585902],
              [87.887230784348944, 26.476033272303354],
              [87.891415226663199, 26.486171663618698],
              [87.901888811596095, 26.47718633839062],
              [87.905294250910273, 26.471187253736041],
              [87.91139061406507, 26.458472398612454],
              [87.900695776606696, 26.448874541429355],
              [87.913907696769485, 26.44770133769369],
              [87.920018627703456, 26.447437978415383],
              [87.924421937768912, 26.447015827552278],
              [87.927270711049204, 26.443639969218232],
              [87.925807514982907, 26.440231836208799],
              [87.923038027572659, 26.436659123711809],
              [87.919198278291987, 26.434908135471005],
              [87.919842106916363, 26.431560565405949],
              [87.925917346080212, 26.429401940847633],
              [87.927016074710536, 26.423431884444152],
              [87.927860623682349, 26.420173290152956],
              [87.932125979852543, 26.417588160803767],
              [87.955460198366069, 26.405447194199017],
              [87.967451435190199, 26.397880764021998],
              [87.972135651636478, 26.396461418929469],
              [87.975740234715687, 26.396321401272399],
              [87.982626677478066, 26.394780730141896],
              [87.98631802678905, 26.393827013843516],
              [87.990808654094778, 26.392860997345124],
              [87.992866971740028, 26.390395439978402],
              [87.992913678902809, 26.387328013936788],
              [87.993348429869243, 26.383711747809933],
              [87.993026369972398, 26.376950644998221],
              [87.993368341687457, 26.373696944738239],
              [87.994293379202318, 26.369534774055882],
              [87.997931728211, 26.365694286668731],
              [87.999342776565456, 26.362790780083621],
              [88.010259113305565, 26.355052341034742],
              [88.020036266171232, 26.35283708787648],
              [88.031203601110349, 26.355472334024817],
              [88.033158102253282, 26.363744861835819],
              [88.032772281625483, 26.369976374386955],
              [88.033405684009111, 26.377275579327726],
              [88.0395570014973, 26.384854214292055],
              [88.049275811934621, 26.390216290272136],
              [88.061356183035826, 26.398609455678553],
              [88.076758738619432, 26.413089093661217],
              [88.087057478989635, 26.422410249466633],
              [88.098411728176529, 26.434508911587852],
              [88.103446829016264, 26.446162945914146],
              [88.100732698979911, 26.451074318594042],
              [88.096773693477346, 26.453659020534054],
              [88.103908235841033, 26.459778887252927],
              [88.10882915964541, 26.465478550610008],
              [88.106425282673115, 26.470835802282977],
              [88.104493630067722, 26.474745372244868],
              [88.108445527451153, 26.48208228425889],
              [88.107486729368176, 26.489675242427481],
              [88.104420719403777, 26.497120209526596],
              [88.101402174824855, 26.501946543806358],
              [88.099724498405607, 26.508646775481836],
              [88.106293676404704, 26.516397030505249],
              [88.108972924836024, 26.525378170149004],
              [88.105308875722528, 26.533011913535649],
              [88.112254446629933, 26.538878473052261],
              [88.111620027002374, 26.54375897919169],
              [88.110460831504867, 26.547840684237148],
              [88.106655426679495, 26.550750688063967],
              [88.106617787180653, 26.555276451607156],
              [88.10986323616838, 26.55778248856582],
              [88.114474532772789, 26.559105208783528],
              [88.113379164497928, 26.564562832723208],
              [88.114565799806655, 26.568891169097974],
              [88.121335629662752, 26.571655116202432],
              [88.125319402073686, 26.574647438072098],
              [88.131362688659777, 26.572650493679095],
              [88.133823214487762, 26.580594663849791],
              [88.135274741057458, 26.583980442338021],
              [88.135217600955556, 26.590987582309022],
              [88.13318443422817, 26.595727145048411],
              [88.132104435081786, 26.602495805375355],
              [88.139354566699581, 26.609099242722824],
              [88.14043777786442, 26.616756483826997],
              [88.139991555940867, 26.621279627541927],
              [88.144243293198954, 26.625952244501882],
              [88.152003000177288, 26.629775985467404],
              [88.159748360633245, 26.635714650678249],
              [88.161977176267129, 26.641152014515072],
              [88.162913867189644, 26.648395893212168],
              [88.165372216331406, 26.653858646742282],
              [88.16729159544002, 26.666070896623012],
              [88.167048242173152, 26.673740698650352],
              [88.166656646313655, 26.680997486538988],
              [88.174825229202582, 26.697781709065119],
              [88.177233180453683, 26.700556196548924],
              [88.180443094580568, 26.705059290766975],
              [88.186754321728401, 26.718220486167681],
              [88.188913903178658, 26.729308699494467],
              [88.189332608554537, 26.740845142815989],
              [88.188090849364883, 26.767989367035597],
              [88.185405607676955, 26.777388369397951],
              [88.18394139732969, 26.78445209448806],
              [88.184835594789277, 26.797117262403013],
              [88.181700784667996, 26.81133759132258],
              [88.17814245255596, 26.81471026412877],
              [88.176030115414534, 26.828938245980755],
              [88.171204787410645, 26.833635108704463],
              [88.168889481791027, 26.838373503382165],
              [88.16911713302909, 26.841774156289475],
              [88.172831586739477, 26.847453420394082],
              [88.175843633143032, 26.851770618081154],
              [88.176724655321337, 26.859976860225977],
              [88.173702002881001, 26.866203907172928],
              [88.16418202971326, 26.87497974366886],
              [88.16124715930458, 26.876979110761621],
              [88.155159502786674, 26.882355036695298],
              [88.150122469170043, 26.884500967794931],
              [88.146178921033851, 26.887503446560441],
              [88.142706868453573, 26.895401303351886],
              [88.143191212635571, 26.898552478129748],
              [88.144208537269179, 26.927731138121672],
              [88.141382904195837, 26.933799768606736],
              [88.13881979348983, 26.936722568543228],
              [88.135574345224427, 26.938970334735764],
              [88.129953492612046, 26.942994617646466],
              [88.125381889630177, 26.944316212018457],
              [88.12348401002491, 26.947470415166659],
              [88.123323639802493, 26.951306802823385],
              [88.125259500906964, 26.958558031670268],
              [88.128713647374454, 26.965085184344129],
              [88.133184738016112, 26.975570522440712],
              [88.135165895479716, 26.980777035240799],
              [88.13489207474538, 26.985758691863239],
              [88.132108592500671, 26.98755343097729],
              [88.125236078358242, 26.988005425089323],
              [88.119914454245389, 26.986816441700622],
              [88.115907135496926, 26.987841928133296],
              [88.110520655087342, 26.991407528021675],
              [88.106546762569565, 26.994294677139028],
              [88.102727380741811, 27.000007317964222],
              [88.096634844844729, 27.004922402410745],
              [88.09305471617742, 27.006938187383234],
              [88.090755370533458, 27.011653019541775],
              [88.08895206963453, 27.015474502559268],
              [88.085892444511828, 27.033552722345171],
              [88.081464171155488, 27.035791878574564],
              [88.076440652223084, 27.032558866022114],
              [88.069147024260545, 27.031145341007072],
              [88.063058044012493, 27.032452106435404],
              [88.056746011855665, 27.032860969373331],
              [88.045849800423298, 27.038216341673792],
              [88.040483637292596, 27.044487923683366],
              [88.037664671299225, 27.049886367538654],
              [88.034358828233024, 27.052202913653197],
              [88.028251301153617, 27.05545941120269],
              [88.024116597652736, 27.066727024240539],
              [88.023825997217529, 27.073065501366024],
              [88.025368340474884, 27.080658534573072],
              [88.025199552704777, 27.084814174527583],
              [88.02215440676477, 27.086855851275892],
              [88.019610682910056, 27.089982259624417],
              [88.016043300419895, 27.092662466911605],
              [88.01449001831817, 27.096946859010234],
              [88.010659516032462, 27.100313150188093],
              [88.005513390111602, 27.101855110657091],
              [88.00028616837912, 27.103855371497438],
              [87.993166334506626, 27.107836464888607],
              [87.991384465344467, 27.111657749464278],
              [87.991334769059378, 27.116666488214683],
              [87.992550415487088, 27.120879565198514],
              [87.994239482755304, 27.126613189015647],
              [87.996741715366298, 27.130471308872462],
              [88.002745564547382, 27.135736760776481],
              [88.006103723706048, 27.141415725363746],
              [88.00769077910131, 27.147309388246892],
              [88.011384434393761, 27.155265980155182],
              [88.013897811637094, 27.158203406668012],
              [88.015374916360145, 27.162052003966014],
              [88.018297564965025, 27.173172361713128],
              [88.016505391067952, 27.177911637721849],
              [88.015155129891355, 27.184906107827732],
              [88.016852142828554, 27.190066222388104],
              [88.018097127352661, 27.193891347674676],
              [88.018309687780004, 27.198714877856435],
              [88.017264012400005, 27.208424959466392],
              [88.017081640513439, 27.219516218927811],
              [88.020315928728763, 27.224964628234222],
              [88.023510997748318, 27.231952883790832],
              [88.028808321358483, 27.23936880530426],
              [88.033250990293709, 27.247674980243342],
              [88.032538047488359, 27.268710883776627],
              [88.035227798191514, 27.280471009795665],
              [88.038980552426196, 27.285625254900857],
              [88.042207487772117, 27.289578535535622],
              [88.04371098326456, 27.293657619191986],
              [88.044415970260999, 27.300669189582916],
              [88.048835501458925, 27.311799029861017],
              [88.051017440870524, 27.314826391225321],
              [88.055065296831685, 27.321796801126386],
              [88.060624066887215, 27.326825807819965],
              [88.065044843483093, 27.33793190414297],
              [88.064855780448781, 27.341859561056651],
              [88.063962800734728, 27.346515564828458],
              [88.061355452941115, 27.353270028881589],
              [88.057203865217161, 27.357163603864251],
              [88.05006761078306, 27.361493463998496],
              [88.047369989823196, 27.363769736245796],
              [88.045537537243405, 27.367383151501894],
              [88.044325661692056, 27.373138634520831],
              [88.044260472529729, 27.382763404205821],
              [88.046760385372934, 27.398587228015337],
              [88.048970620871344, 27.406988716262784],
              [88.050941430466338, 27.410840093260635],
              [88.054098432478455, 27.414496481607259],
              [88.057627236243206, 27.416936080370721],
              [88.062764115558537, 27.420447292031067],
              [88.067558069990966, 27.422506978551009],
              [88.070822376982207, 27.425701361432395],
              [88.069724890959236, 27.432905292715674],
              [88.070792407001321, 27.442998589047459],
              [88.068840731707439, 27.450768588330213],
              [88.064225507149601, 27.454569252588726],
              [88.060598758556708, 27.462463132852076],
              [88.055364347613775, 27.466372291104864],
              [88.052443282759924, 27.470528224309298],
              [88.048021324640501, 27.480668288578851],
              [88.04739286508115, 27.492883590305482],
              [88.051886443488527, 27.502405908335344],
              [88.054900035117583, 27.504911122856356],
              [88.060147009463151, 27.511270863895689],
              [88.061998920315872, 27.517050400292376],
              [88.063081854839865, 27.522388138556458],
              [88.068141934748752, 27.526724828635519],
              [88.070107315613342, 27.531265358006237],
              [88.067313913312219, 27.535469164434861],
              [88.064309762318217, 27.537076445762775],
              [88.066309515462208, 27.543661565915222],
              [88.067162473072216, 27.549088404558709],
              [88.070426933243496, 27.55253758625631],
              [88.08001573745679, 27.5575755522161],
              [88.082383429758565, 27.560764738993548],
              [88.083590462096367, 27.569593683274473],
              [88.081395535857808, 27.572953842674288],
              [88.079818934923026, 27.579280768187871],
              [88.083536052313491, 27.586773943343267],
              [88.086059233307054, 27.589963894602139],
              [88.094377788575855, 27.596346238753405],
              [88.105068560704098, 27.602516989679952],
              [88.111263298709673, 27.607111640286607],
              [88.114005750350188, 27.611864889064094],
              [88.117258251405175, 27.617864866971324],
              [88.12225554294865, 27.63813568170136],
              [88.124366021562849, 27.644512857266609],
              [88.130255902677661, 27.652000781029436],
              [88.134437334923732, 27.65441986070492],
              [88.140782654495595, 27.657269683084227],
              [88.147418334055402, 27.665245108492357],
              [88.151076783184692, 27.668670114875212],
              [88.153507543025384, 27.676797196752396],
              [88.155240114161501, 27.685422518929233],
              [88.154655418023168, 27.693549514860674],
              [88.152079368971556, 27.699409512883342],
              [88.152040782584734, 27.703936536994526],
              [88.156746637337676, 27.717773492357704],
              [88.157907871911206, 27.730208208395339],
              [88.160442763751263, 27.735533535997199],
              [88.168232716908378, 27.741814698687488],
              [88.174814894371181, 27.744803195637374],
              [88.180867066158612, 27.749347361531086],
              [88.184324623389415, 27.762029637676424],
              [88.187062300714359, 27.768180717553907],
              [88.19008846178366, 27.773784951271356],
              [88.193177031177825, 27.778033023487993],
              [88.195474786302398, 27.781126107820988],
              [88.198850135299693, 27.78813211113194],
              [88.198294149353913, 27.793136276218284],
              [88.196741618969185, 27.796961396884555],
              [88.193669984391946, 27.800016283045334],
              [88.189982621782192, 27.802539018428565],
              [88.189043043796403, 27.806850219274953],
              [88.186437891696059, 27.812920146708002],
              [88.183118240086273, 27.814734277660747],
              [88.179316527559649, 27.815372147222604],
              [88.176858145831488, 27.819190903194002],
              [88.185071472510387, 27.825127951270954],
              [88.193157486568737, 27.831297040124941],
              [88.197704431213737, 27.834267486842492],
              [88.201237184961897, 27.838104792097692],
              [88.202727885675841, 27.84220581991914],
              [88.202404157616044, 27.850332692010042],
              [88.191690061108403, 27.856138212533988],
              [88.18324597723128, 27.861957759007005],
              [88.180662332944749, 27.865245780938967],
              [88.173032306730093, 27.866202730307013],
              [88.166688384288435, 27.868177779845226],
              [88.163144377947518, 27.868726991672204],
              [88.151942044191486, 27.870559434980628],
              [88.141906357620854, 27.869666538268202],
              [88.134055160361996, 27.873084272522458],
              [88.13571966105161, 27.875756573871701],
              [88.138814480082843, 27.881436468266934],
              [88.138548809894488, 27.885456470174642],
              [88.136007732678834, 27.890805378499859],
              [88.134914058935536, 27.894609212354613],
              [88.131585372374261, 27.8970886601046],
              [88.128239032259728, 27.901586147625594],
              [88.126192370215307, 27.905109605575316],
              [88.122567695798381, 27.911697114094036],
              [88.122329839660722, 27.915345895483117],
              [88.125499466419285, 27.925291991416422],
              [88.134575120099313, 27.93395028003901],
              [88.137592280037211, 27.937808471366814],
              [88.137528281269326, 27.945043943490695],
              [88.132413743702159, 27.947486611547834],
              [88.138704493634606, 27.955457182056033],
              [88.141837354214047, 27.96113041860276],
              [88.147792675856962, 27.962990474694433],
              [88.162400242454581, 27.957309060300414],
              [88.175922477708951, 27.947806131583501],
              [88.182310960857336, 27.944246245720159],
              [88.191421176726877, 27.943093481407359],
              [88.197340081485777, 27.943227581720762],
              [88.203421566622652, 27.945751586457302],
              [88.205815643464689, 27.950039574359106],
              [88.207928426532177, 27.957518470955343],
              [88.211280058146528, 27.965029174821183],
              [88.218503495339505, 27.967330933851514],
              [88.222809012700935, 27.965546821507679],
              [88.226699777435371, 27.964010929931334],
              [88.230246752279427, 27.963575229177369],
              [88.234823965320629, 27.966777475291174],
              [88.238359794760157, 27.967465580947486],
              [88.241452393311917, 27.96544375081255],
              [88.243818613049129, 27.95369913904451],
              [88.246373844525422, 27.951029687232928],
              [88.252523446720431, 27.948108198355037],
              [88.256827100099841, 27.949721461504808],
              [88.267458844316224, 27.955900602804256],
              [88.273843500699925, 27.956172006501713],
              [88.27915668820475, 27.957882586547832],
              [88.283457412809881, 27.960092649457319],
              [88.285343301001262, 27.963940070085282],
              [88.288139469484932, 27.966896628062432],
              [88.298705578146482, 27.968526862465339],
              [88.302486743698566, 27.967655172137221],
              [88.313436003664236, 27.969538036642643],
              [88.317502935703871, 27.972273466543506],
              [88.32255759780827, 27.977954091945101],
              [88.331536626002801, 27.980925227772477],
              [88.336135532763407, 27.981527380777671],
              [88.340461734766535, 27.984355250276209],
              [88.343652024716647, 27.986626445760987],
              [88.35382604044311, 27.989098195652744],
              [88.358842107867915, 27.989241839830608],
              [88.372376917806065, 27.98775893117514],
              [88.383346853797562, 27.98329689163069],
              [88.390250207156853, 27.979501129022808],
              [88.397373124166009, 27.977474613091605],
              [88.402610243692024, 27.979363404140035],
              [88.409287462842585, 27.982983758708365],
              [88.412860212118375, 27.986377824697819],
              [88.417377291579115, 27.992077249521422],
              [88.42030817478097, 27.995262726511395],
              [88.432094385855265, 28.005269559014266],
              [88.435130395756786, 28.007768066600615],
              [88.441197420076136, 28.010049279079496],
              [88.459536172326494, 28.014670998230873],
              [88.464464949681187, 28.016855214739678],
              [88.470193369395787, 28.019477688917032],
              [88.473227603729114, 28.022869317113809],
              [88.4777799890864, 28.032515060582281],
              [88.480266916075365, 28.036477980851924],
              [88.486600528210104, 28.04225269296116],
              [88.49046899551864, 28.044683901716439],
              [88.498291784245978, 28.047752706295586],
              [88.509749967533622, 28.048611130124108],
              [88.515612368621035, 28.046157980264791],
              [88.525302052887582, 28.043701212775332],
              [88.529430320661589, 28.040781166903447],
              [88.536308176186608, 28.036516229844597],
              [88.540115126443212, 28.036074467989263],
              [88.546572154562313, 28.038170195030006],
              [88.549539251119782, 28.040182271102395],
              [88.551307180853001, 28.04381997342298],
              [88.55146146227429, 28.049378437343517],
              [88.553639318261133, 28.053568957346407],
              [88.559013941114657, 28.060825591783662],
              [88.560883603652314, 28.065106816320288],
              [88.561082646722255, 28.077326134803005],
              [88.563068211389535, 28.084545568366767],
              [88.566887817046393, 28.087273284507784],
              [88.575553168434638, 28.088688293762587],
              [88.579369006019178, 28.086223506988599],
              [88.583464073909738, 28.085323134116081],
              [88.594132877451045, 28.089891245788632],
              [88.597700280950036, 28.09126169272929],
              [88.603790096904149, 28.095353095947441],
              [88.611416430281636, 28.098116663502239],
              [88.622064090457997, 28.102293211876269],
              [88.622194992418855, 28.10842433059409],
              [88.620197485842922, 28.11551487525265],
              [88.619486296759405, 28.118473762353347],
              [88.615532576621945, 28.122546441177203],
              [88.615387470803, 28.125920498600028],
              [88.620474721625342, 28.129340717532887],
              [88.629895497315985, 28.130709847672701],
              [88.63553172202316, 28.126895094230356],
              [88.637587638793988, 28.124424451775624],
              [88.64037136834186, 28.120827458843021],
              [88.645005228457038, 28.108420276517521],
              [88.646288854457097, 28.104106991367878],
              [88.649839782053348, 28.101451731775242],
              [88.653834573085405, 28.098862784693345],
              [88.662675395899669, 28.089593628358148],
              [88.669633408638063, 28.079389677152445],
              [88.675312787410775, 28.073829676485726],
              [88.681328957659673, 28.072588584679703],
              [88.685636437065781, 28.077126554656367],
              [88.694326411591831, 28.078740881636129],
              [88.703728684334976, 28.076728865039176],
              [88.712395450128056, 28.077906641497499],
              [88.722836123328904, 28.07545896199596],
              [88.727932356360498, 28.076141431274809],
              [88.737616732387636, 28.075048268326523],
              [88.748821390730981, 28.075771676787827],
              [88.759544155358398, 28.073093562471012],
              [88.776477557601098, 28.061039164778187],
              [88.779175167130688, 28.058911134105681],
              [88.781743381210433, 28.05664381744295],
              [88.790688253622449, 28.050558246995536],
              [88.792715238488753, 28.047394748344715],
              [88.794015966560991, 28.04402332794211],
              [88.803090986945548, 28.03683524400299],
              [88.805844822772073, 28.032571824602531],
              [88.813671758136437, 28.02650500713127],
              [88.82758066811985, 28.019534980754088],
              [88.833667510644787, 28.016862387846789],
              [88.837370258336094, 28.014965608012979],
              [88.841180494479772, 28.011345227602131],
              [88.842911450647051, 28.000210416639568],
              [88.845039182760829, 27.996655525942813],
              [88.849138311210979, 27.990809364431712],
              [88.848028990555491, 27.965038478265328],
              [88.851216150876212, 27.961416859904794],
              [88.852262144087547, 27.956228444239873],
              [88.847924180346013, 27.952589452061613],
              [88.844627393140058, 27.947163384310436],
              [88.844402135197541, 27.931798250016374],
              [88.847713467243594, 27.930221156570521],
              [88.861678695105013, 27.926530734283382],
              [88.867084506802513, 27.925073967204934],
              [88.872921456805443, 27.912867671890396],
              [88.878316625157524, 27.902245249657952],
              [88.887734451362633, 27.895490470479714],
              [88.889447282393434, 27.892347697935726],
              [88.889425772223348, 27.888857404587835],
              [88.888021490998327, 27.880127110553381],
              [88.888788197503061, 27.869953145957787],
              [88.892592685091458, 27.865206867545261],
              [88.893762949128586, 27.861145132454059],
              [88.890980562204575, 27.857303626773458],
              [88.888971964103888, 27.838766217868983],
              [88.885799604682319, 27.836049393196198],
              [88.884640824708953, 27.833176025331149],
              [88.880986857907203, 27.827197692552097],
              [88.876266178557216, 27.824338755301532],
              [88.870305806474789, 27.821547256468492],
              [88.863702978984563, 27.817926014815448],
              [88.862081194430871, 27.814753007978123],
              [88.865264250205186, 27.811132668982271],
              [88.865400556435588, 27.807961584114011],
              [88.864772722827411, 27.798681691908122],
              [88.860218111533399, 27.778117600393028],
              [88.860496447954603, 27.768149833016441],
              [88.862190818917, 27.760161832714097],
              [88.863796876093872, 27.756742902602372],
              [88.866385920347085, 27.753485881277438],
              [88.869205749668268, 27.748738362430338],
              [88.870205612461561, 27.738796308885064],
              [88.868897328395846, 27.735623261277098],
              [88.862122564303291, 27.729958647660098],
              [88.859348858007067, 27.723844451667862],
              [88.858327969257729, 27.717985231110234],
              [88.849080312025961, 27.711854759445711],
              [88.846431834867701, 27.708013021465721],
              [88.848190624587772, 27.705077064083749],
              [88.853309449095548, 27.700103523919225],
              [88.853295344153679, 27.694225774877797],
              [88.851915277470326, 27.688731316419169],
              [88.852754479578365, 27.681407243058128],
              [88.854469773530226, 27.675371641755106],
              [88.854354663401097, 27.668686531529399],
              [88.85083339902684, 27.662799601555534],
              [88.846151694657237, 27.658493972597579],
              [88.839954625133529, 27.650117767033191],
              [88.83372803701414, 27.645257819954793],
              [88.830047801033885, 27.642630384952724],
              [88.823240249840893, 27.642450730874554],
              [88.818394676936308, 27.642600010918148],
              [88.814852554394591, 27.636046357473482],
              [88.814115169301459, 27.63197887954075],
              [88.815924482227146, 27.618913212803836],
              [88.816169516516837, 27.614113548672918],
              [88.813154242941735, 27.60303517418167],
              [88.809632092940248, 27.599627857508825],
              [88.805569308026136, 27.596241440517101],
              [88.802227542553382, 27.593773444897582],
              [88.799453008710216, 27.59038888266609],
              [88.796185401842862, 27.587855483700736],
              [88.793203647066363, 27.576064563548616],
              [88.789912609991774, 27.573136549609828],
              [88.775862174807585, 27.567676662924168],
              [88.774709945316602, 27.564734756318686],
              [88.775496174880956, 27.559753034610615],
              [88.780718204158916, 27.544286972026583],
              [88.782669114277709, 27.537378813242725],
              [88.786723320575206, 27.533785535324725],
              [88.791807053292729, 27.529297092207287],
              [88.795620879554122, 27.528847911762092],
              [88.796503875054427, 27.525910404072103],
              [88.79456167525052, 27.52062261519448],
              [88.793701406597137, 27.514878937402727],
              [88.793555233321825, 27.511272849688421],
              [88.792692267057674, 27.506239745793359],
              [88.790736890707521, 27.496266089128639],
              [88.793039259578876, 27.492207366847893],
              [88.792923805029631, 27.487452417371951],
              [88.790646427801562, 27.482484619317908],
              [88.788920094952942, 27.472969923405799],
              [88.788936406670246, 27.467549233431207],
              [88.790848948320217, 27.45533681148456],
              [88.794797162486958, 27.451075924848805],
              [88.80216754938273, 27.446800814236727],
              [88.801423600233178, 27.436394914029087],
              [88.802334622808942, 27.432561241049303],
              [88.810555623131975, 27.426933504845355],
              [88.81336879011819, 27.414032698948446],
              [88.816681988657905, 27.404991966312853],
              [88.819107214937119, 27.402815087731035],
              [88.824797954551471, 27.400510712702491],
              [88.828174715031764, 27.39716561939716],
              [88.829699588062482, 27.393884529642907],
              [88.832689578304766, 27.391250580879461],
              [88.838510353315442, 27.388555947978556],
              [88.840802365873387, 27.38631084566325],
              [88.842046486600054, 27.382708278777685],
              [88.845603861882566, 27.378628121169424],
              [88.849644248139541, 27.377742045687427],
              [88.85447223879153, 27.380669253044456],
              [88.856242179736398, 27.383407304629497],
              [88.860018312594022, 27.38612708015124],
              [88.86382357635371, 27.3865939769499],
              [88.868896802934685, 27.383436237938003],
              [88.870418699808653, 27.380499753741166],
              [88.874481397869062, 27.368059863596347],
              [88.886396175918406, 27.364251160168394],
              [88.890445708313052, 27.357482721851881],
              [88.89226394712307, 27.346623462195055],
              [88.895800790672794, 27.338271739708382],
              [88.901131600324149, 27.333755903622251],
              [88.907712216012627, 27.334228989218495],
              [88.915046226403874, 27.329949144533256],
              [88.91910584870304, 27.330852018509571],
              [88.929498223676489, 27.326140482980286],
              [88.925571803817675, 27.322044170380572],
              [88.92200440398706, 27.318477097403839],
              [88.919627890624156, 27.309171902426449],
              [88.916600403743104, 27.305767277832643],
              [88.916272656214446, 27.301540306689251],
              [88.916997236424777, 27.298095166262588],
              [88.917650280649696, 27.292882061713549],
              [88.914374893759799, 27.283367591599472],
              [88.910837318835732, 27.278630386280721],
              [88.90629602388853, 27.274783543187901],
              [88.899976425556432, 27.272958084226687],
              [88.890374674741139, 27.268872289503388],
              [88.886962198174899, 27.265925482735636],
              [88.884322412456626, 27.262749322109702],
              [88.880270383348758, 27.258880338556921],
              [88.870913726101648, 27.262030490079404],
              [88.863334941544892, 27.261116456495277],
              [88.854214857921704, 27.26153190876126],
              [88.850928852427984, 27.260651273892272],
              [88.842342451581601, 27.262880638714201],
              [88.838026419114044, 27.262180177974468],
              [88.834255551474627, 27.260379490764898],
              [88.830329101605571, 27.258555558105876],
              [88.827173181243424, 27.256272612927457],
              [88.819348704156596, 27.252188343797393],
              [88.808236349443206, 27.247403971719514],
              [88.806720987981564, 27.236994535005742],
              [88.807247426522594, 27.232930370992726],
              [88.807792383180072, 27.220504137257631],
              [88.806314554975643, 27.215539728938424],
              [88.80227701578076, 27.208293625152372],
              [88.799000207814942, 27.204310799276808],
              [88.796721748307704, 27.201708665448734],
              [88.795987612783335, 27.19830836403623],
              [88.796266015304681, 27.189741620604231],
              [88.79525024905557, 27.185649540102037],
              [88.791742394606587, 27.181802986156306],
              [88.785922093438529, 27.179765170620708],
              [88.781891314559289, 27.179524809740691],
              [88.776987412530076, 27.179119508614846],
              [88.773036182377595, 27.178348730040639],
              [88.768834615122088, 27.175695471278221],
              [88.765968351870995, 27.172471745574097],
              [88.76536323294556, 27.168725240779541],
              [88.767732178907423, 27.157913060149831],
              [88.766789940761285, 27.154831996518134],
              [88.760871073084758, 27.15164502452442],
              [88.75872525633649, 27.148031305898936],
              [88.758048219995146, 27.142746522115523],
              [88.766832350486808, 27.140593171152265],
              [88.77330762447842, 27.138497296202914],
              [88.782265272510045, 27.137904462208272],
              [88.790098407235448, 27.135675732415194],
              [88.803207293150166, 27.137297265377015],
              [88.807008437666468, 27.136642899365409],
              [88.811303643382487, 27.133047796481598],
              [88.813570175870439, 27.129885474837632],
              [88.816370966248286, 27.127617846782371],
              [88.826368873304332, 27.12132741227461],
              [88.833076743268322, 27.117486582393692],
              [88.842675128377635, 27.115465982613994],
              [88.849986228165662, 27.116633980069057],
              [88.854303558207619, 27.11414083224366],
              [88.855798478797439, 27.110997586849916],
              [88.863656971401625, 27.106925758701781],
              [88.871709268527269, 27.109196880667987],
              [88.875762727735932, 27.109229130698889],
              [88.877525762974912, 27.099517283516864],
              [88.879593903138783, 27.092055752985313],
              [88.878338531236523, 27.077582241495957],
              [88.881627833568643, 27.061145076469803],
              [88.884223873899614, 27.045485602614811],
              [88.885487707225934, 27.040962247749729],
              [88.884270145406774, 27.034711533351285],
              [88.882225514624835, 27.03123948652409],
              [88.87884495968197, 27.016324288010978],
              [88.87805858906593, 27.011798522886966],
              [88.877975723084958, 26.976700486603161],
              [88.878839420513856, 26.964518522341368],
              [88.879372886165072, 26.957019458599706],
              [88.881637715832753, 26.951418716575187],
              [88.8854045544809, 26.95076126584172],
              [88.887934810946248, 26.955061273637355],
              [88.892924726052954, 26.958036138723624],
              [88.89583951925232, 26.961189373742318],
              [88.898588722453624, 26.97183012268999],
              [88.900475444482723, 26.977025563636076],
              [88.908565149635351, 26.981336340877235],
              [88.912835986304856, 26.986767309932176],
              [88.916341126984051, 26.990172558419864],
              [88.918000094656662, 26.99424112358437],
              [88.923407764706951, 26.995378917695525],
              [88.928971572608916, 26.993138852187105],
              [88.933258803352132, 26.989079668246468],
              [88.936804577157119, 26.983872700034713],
              [88.943625927656015, 26.980508908025822],
              [88.953162991673068, 26.977263945062756],
              [88.956244842985384, 26.972606171770998],
              [88.959015615206596, 26.969947820119884],
              [88.962308407299247, 26.960650945996775],
              [88.962058807227365, 26.954081146104173],
              [88.957527753355293, 26.950236701942398],
              [88.953994791666176, 26.949541755398823],
              [88.947774132494729, 26.946153783532541],
              [88.946447258848309, 26.942293826321077],
              [88.947989698486879, 26.938458825448006],
              [88.956425313750643, 26.932618183847708],
              [88.968910725074736, 26.924024772202635],
              [88.977726800257571, 26.920409508060882],
              [88.991094866160651, 26.920659520453182],
              [89.000672385830995, 26.923843347202418],
              [89.012015944690276, 26.929739014124696],
              [89.015037419349412, 26.931534724823944],
              [89.022078406754915, 26.934278273612929],
              [89.02586757522208, 26.937222223458804],
              [89.031426182646527, 26.940169724626479],
              [89.03393891644852, 26.937896490940325],
              [89.037734973661131, 26.929771490392795],
              [89.046575120358796, 26.924588759778995],
              [89.052364747296906, 26.920048740879857],
              [89.054749726099274, 26.91600892595385],
              [89.052756137783305, 26.904682281744961],
              [89.055908400735461, 26.902435067813069],
              [89.067123611246274, 26.903960388563466],
              [89.07283645145958, 26.903392510930551],
              [89.078829885156694, 26.900871838469794],
              [89.092222997775849, 26.89725285246864],
              [89.096730541858307, 26.89388035726186],
              [89.098267739781633, 26.889585742223922],
              [89.10151891654904, 26.887337655497873],
              [89.101288805759481, 26.883019344154977],
              [89.097857419797776, 26.879869858864858],
              [89.095194808392691, 26.876423204571381],
              [89.093967821048878, 26.871942779831379],
              [89.096732467418875, 26.870130957552639],
              [89.104592002268475, 26.867517843743858],
              [89.108100510850264, 26.862696498689349],
              [89.110480562136274, 26.859758042573581],
              [89.110096762882478, 26.856588048626438],
              [89.106564001358819, 26.849121309841131],
              [89.108330027466678, 26.836236390868191],
              [89.115112981151441, 26.832633376080967],
              [89.117135031623889, 26.825904356988875],
              [89.118898340809778, 26.822461961073962],
              [89.122174752143707, 26.821107319343824],
              [89.127471551428968, 26.8222361737702],
              [89.130746652461269, 26.818860723122171],
              [89.133023160622372, 26.812522552864728],
              [89.135275713784949, 26.809124397960037],
              [89.138320828498479, 26.80777069055166],
              [89.148375622138147, 26.809131076302187],
              [89.154928877496516, 26.811614877945768],
              [89.167011374524009, 26.818186570870541],
              [89.173740803853192, 26.820369265673836],
              [89.178424899323318, 26.82145078514375],
              [89.185153547327957, 26.818878126339001],
              [89.18916956990175, 26.814125651380408],
              [89.191443161527516, 26.80913990574745],
              [89.195972303838644, 26.808451213994253],
              [89.200732841190387, 26.81038243639027],
              [89.206312717473963, 26.813228725239476],
              [89.219675479230986, 26.81773073664365],
              [89.239793599361008, 26.820437884339583],
              [89.247368540535618, 26.820205562276257],
              [89.258189107100179, 26.816365803723052],
              [89.261720843711217, 26.816800794957519],
              [89.270809718376313, 26.819965740000416],
              [89.275343821346212, 26.82359229983102],
              [89.284233740398591, 26.829030457359316],
              [89.288538152889231, 26.831509609930219],
              [89.295758779000138, 26.834191420203027],
              [89.303086544643563, 26.838276478167629],
              [89.310363854865471, 26.843254253721238],
              [89.316568434218183, 26.848440515178286],
              [89.319643364116018, 26.850757491964472],
              [89.322234034677507, 26.852731055817699],
              [89.326022361255141, 26.853187194690904],
              [89.330291269495177, 26.849323790903878],
              [89.331048511054647, 26.844201953138981],
              [89.334444029939959, 26.840063861082445],
              [89.337011052786366, 26.842910608739647],
              [89.34003775601164, 26.845938351615569],
              [89.344139004147053, 26.848644167415507],
              [89.35198001222372, 26.853391149092403],
              [89.35826370762021, 26.858574408921868],
              [89.365853040530553, 26.863297978831831],
              [89.371131313300737, 26.865220562910753],
              [89.377945740784725, 26.866681811854438],
              [89.38324381296917, 26.866216344002503],
              [89.389966453854811, 26.86207245390526],
              [89.391803137292499, 26.859428902691256],
              [89.394222416775264, 26.854465477267219],
              [89.39554800054502, 26.841785533562479],
              [89.400075324363058, 26.840883918884323],
              [89.406627394873723, 26.840643860656165],
              [89.412184087887255, 26.841325174089629],
              [89.427508655896119, 26.838591236816647],
              [89.433155787705132, 26.83605668985831],
              [89.436841200123141, 26.835635790454774],
              [89.444137957793913, 26.836498192179789],
              [89.450431822031931, 26.835842726006774],
              [89.453960961055969, 26.834687693632553],
              [89.457227063107382, 26.831512668121416],
              [89.460336559289587, 26.826775226623415],
              [89.458967151277321, 26.822920486067964],
              [89.457174821863973, 26.814335018736383],
              [89.459416719935049, 26.810725164140457],
              [89.461685841290304, 26.808446689259284],
              [89.465210523103949, 26.806188991786406],
              [89.470987991704533, 26.804592729466673],
              [89.48635921232858, 26.80252027998705],
              [89.496184494773559, 26.802269748142326],
              [89.502201643209617, 26.802946557866459],
              [89.505992589195003, 26.804751682529542],
              [89.509535542165622, 26.80812231364148],
              [89.51193633986513, 26.813766495255358],
              [89.516373609459009, 26.816465747464385],
              [89.52289539727704, 26.815349828164802],
              [89.528227355813542, 26.817817103934782],
              [89.534271432631613, 26.818928769556646],
              [89.543563876779928, 26.813257107686805],
              [89.551875869648811, 26.811881232014443],
              [89.561356129645631, 26.814980937774695],
              [89.564736526980042, 26.815478605663181],
              [89.567746979126198, 26.813655370082454],
              [89.572586887146812, 26.801654672317234],
              [89.576492984813811, 26.799716623761316],
              [89.585543604729324, 26.798015471119619],
              [89.599875914372745, 26.792991806419021],
              [89.617003486121178, 26.789336505043792],
              [89.623433629223143, 26.78546066799472],
              [89.62602554637283, 26.78187019683909],
              [89.62751322110239, 26.776857798940014],
              [89.631039000417033, 26.775951943878784],
              [89.634686268342833, 26.778882119838933],
              [89.640276108440091, 26.782079001695934],
              [89.645655060322383, 26.783142818769271],
              [89.650452795957634, 26.780876196423574],
              [89.651205040689163, 26.777246071593737],
              [89.654954738701747, 26.775212270285898],
              [89.65921065399418, 26.771800055301068],
              [89.660193707081447, 26.763437078255219],
              [89.655138769705204, 26.760514015844251],
              [89.652825641672166, 26.75259735205826],
              [89.649533739887943, 26.748542904620418],
              [89.642769117424933, 26.745785722938798],
              [89.638209709694891, 26.744721056864105],
              [89.633647751066491, 26.742254424348747],
              [89.630927770587434, 26.740310368396976],
              [89.621533080665813, 26.732574278432121],
              [89.619981667097917, 26.728743055956944],
              [89.619967493476167, 26.725573761744695],
              [89.626375844823656, 26.723558562371995],
              [89.637838050143102, 26.719183564244513],
              [89.642652934831261, 26.721096762639629],
              [89.647672048553787, 26.722781150837246],
              [89.655681858420238, 26.718897814177762],
              [89.660203218462712, 26.717528147633661],
              [89.664245753109654, 26.718410244332745],
              [89.668049212535607, 26.722027379322807],
              [89.670090072224966, 26.726338439552006],
              [89.675164483729958, 26.73918228213422],
              [89.67944115910143, 26.740317288238614],
              [89.685999567697579, 26.737355356349557],
              [89.694020385115095, 26.735718759478381],
              [89.700313706328998, 26.73615796092523],
              [89.708885770887022, 26.737046599658733],
              [89.712173095398995, 26.734990242023549],
              [89.721689166993428, 26.73089128162448],
              [89.725212990017212, 26.729983270474893],
              [89.727716575970959, 26.724760522203702],
              [89.731208470658487, 26.72249563535852],
              [89.735739995116447, 26.723605041702104],
              [89.738931489737553, 26.727197796478432],
              [89.745346362815326, 26.726945426311865],
              [89.749114312270279, 26.728308589648595],
              [89.751619176650323, 26.732570442111964],
              [89.758233773918576, 26.735942858640556],
              [89.76222522982745, 26.73638758767747],
              [89.765250894042197, 26.733090627603072],
              [89.763934369531157, 26.72643566673166],
              [89.760653921280266, 26.720570880733487],
              [89.762140831814932, 26.716728487820106],
              [89.772675217170971, 26.708097868158639],
              [89.775416150752022, 26.704688069534768],
              [89.776368158473701, 26.701286401557898],
              [89.779886927105593, 26.699481733050778],
              [89.786960478655459, 26.7026207054842],
              [89.792743626036653, 26.703700815751844],
              [89.796797185170902, 26.705955760463507],
              [89.800612057131687, 26.711153304030667],
              [89.803643263584988, 26.713161958306085],
              [89.807331796667626, 26.714272152504542],
              [89.812702897882019, 26.71493694090919],
              [89.826302369362921, 26.714212413490159],
              [89.837865518248009, 26.711451989970168],
              [89.862351160207012, 26.703696078353406],
              [89.86514139946695, 26.708533775272244],
              [89.864726106865064, 26.71294289636257],
              [89.863637988700674, 26.720137040257089],
              [89.865038891232473, 26.724314540801203],
              [89.863856269793303, 26.731144975357203],
              [89.867833079980855, 26.736908382702254],
              [89.873021699825898, 26.734580415560792],
              [89.878928137373492, 26.731636000771275],
              [89.8866612046141, 26.728095237598154],
              [89.894803222770577, 26.724294017945191],
              [89.90286710996395, 26.72355611324555],
              [89.911715575389678, 26.723556387957171],
              [89.926223086143182, 26.722496496222472],
              [89.936964693170168, 26.72316399054256],
              [89.945218428525564, 26.722879363119748],
              [89.952856160660588, 26.723033081924708],
              [89.963111434464352, 26.723058073394235],
              [89.972626589149385, 26.724600499371434],
              [89.989972146739376, 26.726657463627085],
              [89.999647830770513, 26.729914616011314],
              [90.007384951712723, 26.734216525565408],
              [90.011522281928663, 26.73366666703442],
              [90.02497580677074, 26.730411252060609],
              [90.039174312726018, 26.729605402548255],
              [90.050454729614344, 26.728922832663571],
              [90.055864107534035, 26.729747801540427],
              [90.060504381756473, 26.729207621071183],
              [90.072804776401853, 26.731968477286841],
              [90.082889938957948, 26.735047556256266],
              [90.090980583878178, 26.737367828668852],
              [90.100280259020266, 26.739620618137824],
              [90.119564275634815, 26.744945653329584],
              [90.133047314224427, 26.748897805690728],
              [90.151318939405058, 26.754743568341993],
              [90.166074978035695, 26.760339835846022],
              [90.178644083449214, 26.76490219054649],
              [90.193907857624637, 26.770416467190103],
              [90.192343196381046, 26.781573291181459],
              [90.190509518756357, 26.787043083577903],
              [90.188238543831659, 26.798275682077495],
              [90.187806089673742, 26.803953068082915],
              [90.189286656473811, 26.809571993933037],
              [90.192198363414946, 26.814227410021918],
              [90.197136540343195, 26.827127700963764],
              [90.199923993676379, 26.832862331802804],
              [90.209747209256918, 26.843416136028875],
              [90.22008752228389, 26.853527786767984],
              [90.231460038211651, 26.858065867756928],
              [90.24958694798741, 26.85776089037001],
              [90.258164571122194, 26.856833106584471],
              [90.267563476383472, 26.855198486376466],
              [90.282534294173374, 26.851945379187434],
              [90.295602114358658, 26.848298697703768],
              [90.306679801237607, 26.848044160531849],
              [90.316888870268372, 26.850657699866222],
              [90.346124007811497, 26.87191808028043],
              [90.350964899500013, 26.876242393191763],
              [90.354647127737678, 26.887494035583948],
              [90.357961695517986, 26.892603880851144],
              [90.360308313351652, 26.895891056972662],
              [90.369228485239233, 26.897849325790808],
              [90.385316113733467, 26.899028360839225],
              [90.396166744156687, 26.900115285824171],
              [90.404913531046574, 26.900805299071521],
              [90.41486539703925, 26.901695012136582],
              [90.427231717304963, 26.89793479552538],
              [90.446177793696819, 26.882643322802636],
              [90.459080246292558, 26.872211008914423],
              [90.468679698844525, 26.865692784912664],
              [90.488170430949651, 26.852838826940296],
              [90.505607420097135, 26.841753649709151],
              [90.519073634129995, 26.83276785010576],
              [90.533755199017975, 26.82325865297128],
              [90.543760639969761, 26.816019886740396],
              [90.55370894264145, 26.811666566269157],
              [90.558661399654056, 26.805519666999107],
              [90.56479184615344, 26.800742869602086],
              [90.568642425941292, 26.799360388310951],
              [90.573183174415945, 26.798619410532613],
              [90.577915799411031, 26.7985125956817],
              [90.585584679123102, 26.797280018078517],
              [90.593817017337429, 26.798220006941584],
              [90.606312313334797, 26.797242280859468],
              [90.622365781046057, 26.794331568308596],
              [90.635096885067782, 26.791367262427471],
              [90.641831987260034, 26.786325903552545],
              [90.653836087854302, 26.773967154239344],
              [90.66164750785893, 26.775889426309902],
              [90.667233410171391, 26.77831895929911],
              [90.674538861252586, 26.780413663954469],
              [90.684104726964094, 26.779925579394938],
              [90.687073065235609, 26.7770827666793],
              [90.69825262804379, 26.77093109682],
              [90.704548668798893, 26.767684440850918],
              [90.716928417019204, 26.767236085565862],
              [90.72164989875121, 26.767576879720789],
              [90.727690302267476, 26.767213074411217],
              [90.733611578034797, 26.768021019693101],
              [90.738623427943182, 26.768996897057971],
              [90.741674112933723, 26.772739716385782],
              [90.745660871939776, 26.774693755829055],
              [90.751300890608078, 26.77432375755966],
              [90.767013678238143, 26.773197140737949],
              [90.776763355460645, 26.773515280317103],
              [90.791343476853115, 26.773813055078421],
              [90.806737238439865, 26.773669941893917],
              [90.8228086131314, 26.774887490370403],
              [90.841394745087513, 26.77631859683764],
              [90.852953047407553, 26.776838642166506],
              [90.875242936392752, 26.779217385338807],
              [90.901414598261198, 26.778217270648753],
              [90.931433124593994, 26.781683044477653],
              [90.959198960011875, 26.783392450129316],
              [90.96529262828922, 26.784202647169028],
              [90.980368754251259, 26.78493828040893],
              [90.991802648607461, 26.787069902670137],
              [91.000429883891613, 26.787807135453939],
              [91.007611005763366, 26.786187797288449],
              [91.018192765213058, 26.784966798051485],
              [91.03526410504935, 26.780397592068663],
              [91.045853762163233, 26.778543103217515],
              [91.058320828548375, 26.778965701590526],
              [91.061899665632723, 26.781808531826105],
              [91.079932726463127, 26.799989015031933],
              [91.093445947717029, 26.81793203263242],
              [91.100970720639609, 26.819287504748925],
              [91.110110811856316, 26.813710191660718],
              [91.121208113624959, 26.811676175469177],
              [91.134041012606303, 26.807946321782769],
              [91.148321588277938, 26.808475120031801],
              [91.184608490153678, 26.81088009419706],
              [91.206582441160947, 26.808149505401691],
              [91.221471440444901, 26.80831576237156],
              [91.241090135657188, 26.808351662948585],
              [91.253299713939228, 26.80568744474413],
              [91.26649721519837, 26.804387440089332],
              [91.28099322744832, 26.796239290660427],
              [91.293674134424379, 26.788250222703912],
              [91.299156776511765, 26.784518064765383],
              [91.31406594080407, 26.782688461047581],
              [91.33150703591032, 26.779801374120343],
              [91.34036908718285, 26.778990224035756],
              [91.345269846855189, 26.781116988741516],
              [91.363681315461733, 26.788797618587491],
              [91.376774052509006, 26.795518130685515],
              [91.383650289989504, 26.800822127197932],
              [91.388785818218295, 26.808637396818895],
              [91.393915377443975, 26.816812201046055],
              [91.402014811510526, 26.829169543733791],
              [91.406175117888722, 26.834446449765604],
              [91.412410675035602, 26.834867082832723],
              [91.424477793248812, 26.827132398032752],
              [91.440605470214493, 26.816546747447966],
              [91.445562477886853, 26.814336149223134],
              [91.451537103661693, 26.811144858040027],
              [91.458527821827232, 26.80705806553679],
              [91.471720530608053, 26.797251619543978],
              [91.482154059151085, 26.791031914210535],
              [91.496664862174541, 26.788999316385475],
              [91.514836871160085, 26.792053506924869],
              [91.53482187489648, 26.795032241433013],
              [91.564052098786235, 26.799080480762655],
              [91.594584349178675, 26.803946824950131],
              [91.604102604394257, 26.807729917438561],
              [91.615988349315245, 26.815954323180897],
              [91.627613749278197, 26.820475367034092],
              [91.636170195981492, 26.820005049355441],
              [91.657359851283175, 26.814217913964185],
              [91.683016808188569, 26.803859590422221],
              [91.690961171532223, 26.804193538121037],
              [91.700958012456354, 26.810952680779188],
              [91.705886696557641, 26.810898773256824],
              [91.713231927179933, 26.811047527561637],
              [91.722691597781179, 26.810576374953158],
              [91.730630484847964, 26.811629846697361],
              [91.762774556612513, 26.828480907748595],
              [91.778588388710858, 26.837806061801672],
              [91.80564204289864, 26.851088355864334],
              [91.821143442154195, 26.862753669159691],
              [91.835529764369568, 26.875402101860754],
              [91.857173515662168, 26.911301215872903],
              [91.861488741839551, 26.913043722704789],
              [91.869947639955527, 26.913281407414729],
              [91.881719172313069, 26.914531160544723],
              [91.887150858666359, 26.91519814669428],
              [91.892587791202985, 26.915505198501741],
              [91.90094827317904, 26.915106926656339],
              [91.912976540012252, 26.909315579563639],
              [91.927026039913628, 26.902540538917389],
              [91.94562005472271, 26.893807919808442],
              [91.957555167410717, 26.886656951791469],
              [91.963469133717396, 26.876488892246204],
              [91.973385628857571, 26.869413950130053],
              [91.976331180493148, 26.865821049977775],
              [91.982098926709938, 26.861790405331327],
              [91.989078408400175, 26.857136235102292],
              [91.997653746610183, 26.854115061880112],
              [92.006723725233712, 26.852541152515517],
              [92.020428924194505, 26.849910183337098],
              [92.032515443211537, 26.848800983862645],
              [92.048935226426451, 26.846362450548018],
              [92.058593526900054, 26.846863125717423],
              [92.0643159116688, 26.848970812939871],
              [92.074339657156628, 26.855523595789833],
              [92.079968722395421, 26.856454612441347],
              [92.085879591360765, 26.860909058708575],
              [92.092327340137132, 26.859768403165742],
              [92.100836102137649, 26.867394086053991],
              [92.102061483674987, 26.880673252928627],
              [92.105356835204987, 26.886200981656927],
              [92.111316649433562, 26.892614576054264],
              [92.111219340579225, 26.89842069699662],
              [92.112324721864439, 26.906211570947107],
              [92.117046331869048, 26.91832010462381],
              [92.120539070892008, 26.931217352645501],
              [92.118268640045358, 26.941013672624372],
              [92.115462886441904, 26.948180745012795],
              [92.120924426533975, 26.959040617713683],
              [92.116792332206984, 26.97457860432397],
              [92.107669645103357, 26.976555582180328],
              [92.105717524215578, 26.981844658120163],
              [92.106906124686702, 27.006603261015258],
              [92.100890736574783, 27.008384212631725],
              [92.091823441281349, 27.015869849378781],
              [92.083461663279948, 27.0194873154303],
              [92.082434359727685, 27.031658073890991],
              [92.080331239674052, 27.038748519404162],
              [92.074335978047685, 27.044309936127945],
              [92.067701836200996, 27.051123822751595],
              [92.057416402528162, 27.051086865169797],
              [92.048650032306966, 27.050899091332564],
              [92.045601226783532, 27.05932326527746],
              [92.037514077900283, 27.063756562763288],
              [92.039991489517334, 27.069136540138096],
              [92.03674187306072, 27.073762748563041],
              [92.031596680741686, 27.077535394631425],
              [92.03224273456803, 27.0835114837842],
              [92.031400706081868, 27.096136538704343],
              [92.026361564269791, 27.107135582608283],
              [92.026079443329309, 27.113903254669392],
              [92.032106119261115, 27.122429188880425],
              [92.034846511206439, 27.129351721948712],
              [92.038319115778435, 27.131505047493807],
              [92.040382113673047, 27.137417956161304],
              [92.034496290386386, 27.146141867267289],
              [92.032380732463466, 27.149709161437929],
              [92.028247705523384, 27.153232314755378],
              [92.027322963920028, 27.161339806554697],
              [92.029190143769185, 27.170773377246299],
              [92.039351057429656, 27.175777876033564],
              [92.044983864212625, 27.180322361168663],
              [92.05499996480907, 27.183335706119987],
              [92.060211604891393, 27.188593026884064],
              [92.061264120055512, 27.202072401680851],
              [92.06674595921497, 27.208599805216643],
              [92.070743171418016, 27.213922909097331],
              [92.073642974278656, 27.22265381603636],
              [92.072353787009916, 27.233193765674699],
              [92.070091464040573, 27.238472775135595],
              [92.069844134415362, 27.243975200990782],
              [92.065527805374956, 27.246683657751547],
              [92.056527262822343, 27.250826896444313],
              [92.053771043315763, 27.255646456358964],
              [92.044035128302383, 27.260856195770945],
              [92.04370255326856, 27.26572580008413],
              [92.052965856273673, 27.27061853981737],
              [92.074132906444305, 27.276396254809065],
              [92.082258149929984, 27.27485340967095],
              [92.087208382568619, 27.271074426729186],
              [92.09910552439419, 27.272048283798217],
              [92.105674936933255, 27.268121012476026],
              [92.113931267138057, 27.272989742411831],
              [92.119205559861243, 27.272286848961198],
              [92.123076218274335, 27.274896415832604],
              [92.123860095391649, 27.279699113220435],
              [92.124690386110203, 27.286580987230511],
              [92.121422154627055, 27.291839952956359],
              [92.111151733995698, 27.298036920821211],
              [92.106742879583535, 27.30047352477407],
              [92.082148746484606, 27.309349103853108],
              [92.071322448946006, 27.317336036344976],
              [92.062998279813726, 27.326281527525428],
              [92.064434854740739, 27.344372719679704],
              [92.06109882497833, 27.348093408204981],
              [92.052658624771169, 27.357395326361704],
              [92.050668730618526, 27.367469000860719],
              [92.050376632743067, 27.378387655264167],
              [92.054231275186694, 27.389216670399215],
              [92.058817428113286, 27.399248055260752],
              [92.057292847264904, 27.403278733047905],
              [92.051664361822375, 27.405687386867001],
              [92.046437442385042, 27.411987417990819],
              [92.048326136748713, 27.42449128575711],
              [92.047161325751233, 27.430154501784898],
              [92.043165989307795, 27.4356687072918],
              [92.03737337524818, 27.436627134294124],
              [92.028355738137535, 27.44076800695635],
              [92.023637123117524, 27.446806548254283],
              [92.021230091178239, 27.457229739905149],
              [92.024294927736207, 27.467318822450519],
              [92.023269712943659, 27.478948025938408],
              [92.01572216766013, 27.481041670383153],
              [92.001266013185472, 27.476573166800904],
              [91.993656753237431, 27.473518672140102],
              [91.98675541296204, 27.46686601241047],
              [91.983588240148038, 27.464179027016854],
              [91.977615844436116, 27.46422774297465],
              [91.969974470251231, 27.466046564785668],
              [91.959192465464284, 27.460662727723317],
              [91.953945903026806, 27.460095966667303],
              [91.943930449617511, 27.459873580690832],
              [91.936419638579409, 27.464222313297945],
              [91.927332538231468, 27.470613239480826],
              [91.913570362410269, 27.470486530297833],
              [91.903125361224326, 27.467543875295444],
              [91.895595225647412, 27.472520313110874],
              [91.876870522127348, 27.472121455679744],
              [91.867708216154341, 27.481373050911966],
              [91.853823773753192, 27.481868078559803],
              [91.844302522580037, 27.47506022780415],
              [91.833159956499173, 27.468302254328631],
              [91.822605154870473, 27.469233981807431],
              [91.814124234365423, 27.471928560114549],
              [91.793369444040835, 27.468558593916217],
              [91.778525672718914, 27.463877869410869],
              [91.767538791616758, 27.465788208025941],
              [91.761361507476892, 27.47268641967317],
              [91.75455119583647, 27.473609682595409],
              [91.746667557159157, 27.473245190623452],
              [91.738067993807164, 27.46960912323491],
              [91.724802990150167, 27.469748408558594],
              [91.718632419210678, 27.473032002638483],
              [91.717439660248644, 27.482395324260281],
              [91.715471932169393, 27.490655114016807],
              [91.704813728191411, 27.494916507264463],
              [91.694975170714486, 27.502174889734547],
              [91.68850477051096, 27.501840271034041],
              [91.684733533838113, 27.499311469633493],
              [91.679329300648817, 27.493853059929204],
              [91.67235215202632, 27.490254417594681],
              [91.665301353727614, 27.48566082073831],
              [91.658112216650011, 27.48241528595214],
              [91.652286660283693, 27.484171619591685],
              [91.651153745662114, 27.491458365622339],
              [91.649016878564765, 27.498449599917539],
              [91.643811163628442, 27.503107483876146],
              [91.633142641184349, 27.507543961431676],
              [91.625488225784238, 27.512774200689289],
              [91.620952435137511, 27.521874756633146],
              [91.61428105659401, 27.541123604327154],
              [91.610467884988452, 27.543197453065325],
              [91.606203542083762, 27.540294100409508],
              [91.59945507227556, 27.539044962563541],
              [91.5964856867392, 27.543304683805189],
              [91.586588190000654, 27.561840685042245],
              [91.571901754145586, 27.574570526003281],
              [91.567154398820662, 27.583752654328656],
              [91.581976918896075, 27.599109390704296],
              [91.581296525739319, 27.607851488372052],
              [91.568362064363328, 27.619539114039362],
              [91.562968001674008, 27.633038519720195],
              [91.57210400564351, 27.652047140528879],
              [91.59502278823409, 27.671397058207678],
              [91.595507269144917, 27.678631520565176],
              [91.597100679663598, 27.682824933069337],
              [91.603793658727142, 27.686149217171675],
              [91.601678248592549, 27.692146770924463],
              [91.607789631048362, 27.694555668906673],
              [91.615362125286794, 27.692484052044698],
              [91.619829907199403, 27.695574784436573],
              [91.621368966527342, 27.701571054672097],
              [91.629055490884852, 27.705551896576356],
              [91.628664841594116, 27.714931466597157],
              [91.634444024501022, 27.731417206465313],
              [91.634989293767461, 27.746598961252566],
              [91.641801746541191, 27.752724406655844],
              [91.645408744746561, 27.757599799515301],
              [91.644981595438821, 27.764813153525242],
              [91.636562592448769, 27.771197185705262],
              [91.635569017671784, 27.777043339083821],
              [91.635804748081625, 27.782556804951046],
              [91.635053435511594, 27.793734042567028],
              [91.633626209225881, 27.80047168716834],
              [91.624761479766946, 27.807928819722171],
              [91.620608005553194, 27.810896893172028],
              [91.60436567366439, 27.820520068054631],
              [91.589703648646164, 27.818443113667399],
              [91.583560085989816, 27.813593959079935],
              [91.578521384325086, 27.812384891309762],
              [91.571026722771123, 27.814999217914828],
              [91.566061011702644, 27.821105308041716],
              [91.561683584410929, 27.831018475210538],
              [91.551437093683788, 27.846561973317868],
              [91.549536830811746, 27.855273287700967],
              [91.558176598976317, 27.858288487571585],
              [91.564389235391872, 27.851401296031796],
              [91.570045787482485, 27.85244462364831],
              [91.575379982344515, 27.86043338871378],
              [91.58275540135412, 27.861701344491916],
              [91.590048644025728, 27.855921224682959],
              [91.599719381892058, 27.861759583020842],
              [91.604887664361087, 27.858997739825014],
              [91.612977181098586, 27.853688198609223],
              [91.620503837499925, 27.85658360330369],
              [91.627185564419122, 27.8573785278423],
              [91.632837710767717, 27.855260504693891],
              [91.637426969759289, 27.854739528641819],
              [91.647408536903427, 27.853804702304188],
              [91.659611672706433, 27.856726154781949],
              [91.667499422865276, 27.857910622548985],
              [91.674860758728286, 27.856372404934877],
              [91.68510069095673, 27.84379841442205],
              [91.695003928176561, 27.828777106408751],
              [91.699584773538945, 27.821753642746003],
              [91.707667868958183, 27.816439007897337],
              [91.714983154183628, 27.81291083848674],
              [91.726542960031608, 27.810115587961597],
              [91.751634631979002, 27.80294640023947],
              [91.763474716495011, 27.800876695983899],
              [91.776473403598075, 27.800819585168099],
              [91.784034940536543, 27.802623630887432],
              [91.793937532216361, 27.804208765833284],
              [91.804393185579158, 27.807793503451421],
              [91.809450728747947, 27.808451207522609],
              [91.815818340643162, 27.802548843913037],
              [91.820577107461432, 27.802930136425253],
              [91.829511634570281, 27.809907998241933],
              [91.833249030499005, 27.807104994474056],
              [91.834177634402025, 27.796200296792442],
              [91.836635846598753, 27.788491523696159],
              [91.838727792729713, 27.779419853729333],
              [91.85042176384718, 27.775172837977312],
              [91.854087131391339, 27.767761161849105],
              [91.856412572223135, 27.764564277829862],
              [91.858102851702924, 27.758824480237042],
              [91.862756594923979, 27.741773389588243],
              [91.865651312361294, 27.73642081022609],
              [91.875565369683144, 27.733937420410406],
              [91.878418747555202, 27.729938229073216],
              [91.880881320101153, 27.725480007578927],
              [91.883740820683244, 27.721300730929645],
              [91.893513346263873, 27.723688647241268],
              [91.907331710644456, 27.72652912052752],
              [91.913440573490021, 27.725761740100737],
              [91.920062969294889, 27.717602906838021],
              [91.923802473267941, 27.714525377993873],
              [91.939042665817738, 27.721005154572715],
              [91.950102432525711, 27.728114991241789],
              [91.954871687363266, 27.738964866136662],
              [91.960648513448007, 27.750110106937861],
              [91.966121640010144, 27.750412028542947],
              [91.970878093190422, 27.75087635117157],
              [91.977949172958446, 27.759340576342122],
              [91.984006375241492, 27.76416720256961],
              [91.988933888846617, 27.769424034883251],
              [92.000040046934402, 27.767858945642391],
              [92.005345448786059, 27.766892666170509],
              [92.015773775858605, 27.764137852967615],
              [92.042774771959785, 27.756594684773987],
              [92.053638294910826, 27.75637620554992],
              [92.060379697272381, 27.758507127703403],
              [92.072627732288666, 27.767254911791856],
              [92.089561591213155, 27.779174092390278],
              [92.104223303380252, 27.792755868922498],
              [92.124982722423212, 27.809988068342161],
              [92.143909858340606, 27.823838591852482],
              [92.161147991612353, 27.836384354501899],
              [92.175924834674376, 27.842287133505032],
              [92.194375124394242, 27.851425348266165],
              [92.205316720131236, 27.856433117691807],
              [92.215424244028284, 27.858354383173086],
              [92.239203290434062, 27.861994407776127],
              [92.251269675370011, 27.862868273978485],
              [92.260140792097204, 27.861510791914554],
              [92.268983949172494, 27.857261206180794],
              [92.272335886222862, 27.853264027925128],
              [92.276022009236911, 27.843946113306536],
              [92.282301051564033, 27.82447365834005],
              [92.289546578861518, 27.806827416650972],
              [92.312178962229481, 27.778465126145875],
              [92.320730993536458, 27.777458287970134],
              [92.333692565165464, 27.782767759727545],
              [92.355037752619481, 27.789861873510716],
              [92.368973956568311, 27.792839418236426],
              [92.374363446048903, 27.792490580267412],
              [92.379431796623081, 27.792857888462319],
              [92.384574964496977, 27.794219266256057],
              [92.387735053783672, 27.814779374407895],
              [92.40274551360865, 27.81966796293468],
              [92.411541292304591, 27.821278620100117],
              [92.418624756520373, 27.822225765577961],
              [92.432088571735179, 27.811188235529922],
              [92.44849671635609, 27.799936342887893],
              [92.459605429857874, 27.8023998867362],
              [92.464174927528745, 27.806727426258067],
              [92.471712064153337, 27.814362368869681],
              [92.48141352090326, 27.820681724794497],
              [92.489270076298567, 27.827778961872003],
              [92.497205574960901, 27.835959495808584],
              [92.506033924717926, 27.840636280764077],
              [92.519774310524028, 27.839348017109604],
              [92.53104879147169, 27.830250088579586],
              [92.539124793812363, 27.823440920071164],
              [92.54852028941302, 27.81656625504316],
              [92.558859430825734, 27.817382135952336],
              [92.565295112385996, 27.820115788109689],
              [92.569925597719759, 27.826427879847625],
              [92.580874215603359, 27.840888756821169],
              [92.590389906472922, 27.855955775471401],
              [92.609737902601339, 27.876613681694028],
              [92.625026769699986, 27.883560522078639],
              [92.636241955499656, 27.886373342853194],
              [92.656236838015687, 27.89204324713716],
              [92.673863145717235, 27.899205722950374],
              [92.678816461236536, 27.905069160458979],
              [92.691028531050478, 27.918550657841841],
              [92.70596585296714, 27.932887472320896],
              [92.718548977826387, 27.948358284545282],
              [92.734540831444448, 27.971018851585939],
              [92.737876981619578, 27.977035879520702],
              [92.744240777950992, 27.988517364012178],
              [92.738310822847282, 27.994830940635378],
              [92.732596034821654, 28.000607081110982],
              [92.726078513813476, 28.015488410932186],
              [92.714427892081702, 28.032451752753037],
              [92.700371533478716, 28.047568903102896],
              [92.686213083580427, 28.057806916651032],
              [92.667908662188722, 28.062011207991574],
              [92.666172088192084, 28.066950052256477],
              [92.672253890801272, 28.077526565048423],
              [92.678166043160118, 28.095960322606917],
              [92.685240243905398, 28.117300300381132],
              [92.692097271159113, 28.125091474122804],
              [92.700849051149476, 28.13002265016415],
              [92.70968711889617, 28.135858922845284],
              [92.72600665213983, 28.144259271298136],
              [92.741652095421998, 28.15083712885631],
              [92.763432412459039, 28.166184947675273],
              [92.788144600051254, 28.183019796550326],
              [92.804778734888686, 28.20152630096926],
              [92.81268831646085, 28.20336966705807],
              [92.821297891551197, 28.200886611902586],
              [92.824438111537646, 28.19669333337178],
              [92.822768164844447, 28.183571539284973],
              [92.826341229754661, 28.173155215311748],
              [92.833010960997356, 28.170732242198063],
              [92.844668487362313, 28.1785897686437],
              [92.852341692089496, 28.18205147744365],
              [92.900305489085724, 28.203832809216035],
              [92.910389532842572, 28.214461107887288],
              [92.918054996859681, 28.234265214284626],
              [92.928000762202302, 28.241820118926622],
              [92.946843219485601, 28.247882215499931],
              [92.960623804042513, 28.257568807333048],
              [92.969629837973088, 28.261043493938853],
              [92.979560180191626, 28.258840640706509],
              [92.991032297331614, 28.250521334759409],
              [92.991910459704712, 28.241684997262656],
              [92.995017368246593, 28.233603311084817],
              [92.999682465322138, 28.229427402834947],
              [93.005379276395757, 28.229960139236955],
              [93.014994985357077, 28.239040378955202],
              [93.025366348567843, 28.251471487753772],
              [93.03882794444722, 28.26231769154462],
              [93.03794383658375, 28.266008576999205],
              [93.030750100852316, 28.28586111190425],
              [93.027036307920042, 28.299172334107499],
              [93.028811381850943, 28.302448204981616],
              [93.03737049964576, 28.302933146276999],
              [93.051364158449076, 28.301686491816028],
              [93.066785998472994, 28.306150104566907],
              [93.077146583697981, 28.308461315272808],
              [93.092192713903287, 28.305420864170667],
              [93.100438141240119, 28.30625805039249],
              [93.117219842774858, 28.314704612366047],
              [93.129875070699654, 28.325986187330304],
              [93.134165373655065, 28.3256810272709],
              [93.141537599790425, 28.324066519794115],
              [93.16000736676601, 28.317633568401902],
              [93.184814910125326, 28.316337984279361],
              [93.198774181164097, 28.317152181879813],
              [93.211945667985376, 28.32238213249633],
              [93.224013114348566, 28.332832865506663],
              [93.22776788225606, 28.34019472408416],
              [93.224369165731048, 28.360648253395379],
              [93.227360285351992, 28.377121935392442],
              [93.236681866824028, 28.399904531705243],
              [93.231044322662328, 28.40750803951763],
              [93.221256963536675, 28.412891157280367],
              [93.209830487320986, 28.418522579690375],
              [93.195628903266069, 28.425289592805729],
              [93.186325296026396, 28.432028329072903],
              [93.187938159874946, 28.43927376717933],
              [93.195628981043171, 28.443438368451485],
              [93.206166552049993, 28.448271907091286],
              [93.212854123206696, 28.451519211677162],
              [93.218882285833956, 28.457465861409492],
              [93.227771347738567, 28.469591165848065],
              [93.23438407970626, 28.477260799190471],
              [93.240639313292959, 28.482035425454558],
              [93.259291739901528, 28.490852701991798],
              [93.268195010792212, 28.49620053030808],
              [93.274971886244742, 28.500439888639097],
              [93.281248702763136, 28.504129962235485],
              [93.284680148570956, 28.513111245190004],
              [93.287012760197811, 28.520545833049859],
              [93.294321890622385, 28.542757891107229],
              [93.302886838385731, 28.556951377346348],
              [93.310724066389426, 28.565625732161987],
              [93.308818082295389, 28.576257174236066],
              [93.303057156291231, 28.591445868773402],
              [93.305390098276618, 28.598969165755044],
              [93.311912941888835, 28.600401884557183],
              [93.316881755844207, 28.603173296600463],
              [93.325112537415748, 28.606432821161501],
              [93.333172654057066, 28.607704801355165],
              [93.335410291722198, 28.615045744943796],
              [93.336515163675656, 28.622913505299735],
              [93.337889993880751, 28.633133863894155],
              [93.342497141776306, 28.639599605201241],
              [93.347509278797219, 28.639569485747348],
              [93.356428690041611, 28.638322190117478],
              [93.367345282767531, 28.640258598743927],
              [93.375268840109484, 28.643963137969809],
              [93.395247866278154, 28.648892450609601],
              [93.41739771178618, 28.65230879051737],
              [93.435370663563333, 28.661722774749787],
              [93.443042911111846, 28.668853876835971],
              [93.446885844689007, 28.671966730152761],
              [93.451237575840068, 28.675445542736352],
              [93.462296639841085, 28.667804165276337],
              [93.468087029490334, 28.656402107851765],
              [93.472251344356522, 28.651482658453755],
              [93.479698374082858, 28.653007863734143],
              [93.481008307523567, 28.661690600797844],
              [93.484715976337881, 28.67437383271043],
              [93.489146450507562, 28.679477142922813],
              [93.496664669674999, 28.683352318684062],
              [93.501065321732739, 28.683400712244694],
              [93.506414691036994, 28.681470999254223],
              [93.514736373674339, 28.679213697916246],
              [93.523927064259439, 28.673172929402945],
              [93.525677279413983, 28.66497555110843],
              [93.529931638153997, 28.660595584746083],
              [93.539276402320283, 28.658166153451162],
              [93.566688223969763, 28.658905629676891],
              [93.61237142228542, 28.65512816156998],
              [93.625446455145692, 28.656972822993779],
              [93.644220163006935, 28.66113135218837],
              [93.658992836529904, 28.666061342971293],
              [93.674791392735486, 28.671177180105495],
              [93.690869809643303, 28.678553464705516],
              [93.704985935422442, 28.679137396675735],
              [93.719162574639128, 28.683063469210321],
              [93.730368683350108, 28.687409411733775],
              [93.736905941083705, 28.688462958741468],
              [93.752637760894032, 28.682373027359713],
              [93.766550762148952, 28.673739583281165],
              [93.780435973193121, 28.66763327406268],
              [93.790533812927549, 28.670519967277237],
              [93.802612756334256, 28.679382440425879],
              [93.824045829805726, 28.694011728280966],
              [93.840829698497046, 28.70363371097514],
              [93.84929403974229, 28.7065023903012],
              [93.854929485453624, 28.706097279866785],
              [93.863130474949116, 28.704900530099398],
              [93.870523909907064, 28.702794735611942],
              [93.909284597973411, 28.675656837758659],
              [93.924698983923122, 28.669365699577714],
              [93.931232379228121, 28.670770660159995],
              [93.939675509129032, 28.676070990086199],
              [93.948663150658007, 28.688148567392307],
              [93.962126223256632, 28.703686724036185],
              [93.965466885608706, 28.712063061000556],
              [93.967723270459132, 28.717722476675011],
              [93.970751308236345, 28.722260786460563],
              [93.970358764860805, 28.742028836890075],
              [93.97376031148913, 28.750450654850798],
              [93.982900650324467, 28.758372283493784],
              [93.995642680760596, 28.764694913279023],
              [94.003373129674756, 28.770708031658252],
              [94.00671606007225, 28.774614319855214],
              [94.006943745083376, 28.783372994830803],
              [94.003733447664032, 28.78714186290544],
              [93.990625456163258, 28.797432194056444],
              [93.990956497894032, 28.805920423737096],
              [94.005384895505159, 28.818935064112878],
              [94.003437649926795, 28.830295475957161],
              [94.000370540591462, 28.840566452419569],
              [94.008311595713892, 28.84622032355195],
              [94.020267359883576, 28.850366023527489],
              [94.035520456868056, 28.852640333741217],
              [94.039654796610861, 28.860160197834205],
              [94.049485022716027, 28.873047845682979],
              [94.063618581591399, 28.886776178227421],
              [94.072054248228682, 28.89531820155684],
              [94.084381009514274, 28.905058490151664],
              [94.099687478076888, 28.91436510294966],
              [94.12602707512508, 28.929516332869838],
              [94.142052923282179, 28.939636284634133],
              [94.160715720513451, 28.954012384171875],
              [94.162524784773339, 28.958627519099768],
              [94.163952966400288, 28.973352146617817],
              [94.172416009824872, 28.980441876123148],
              [94.17859476150133, 28.99113046394578],
              [94.177483440859632, 29.002500653424452],
              [94.177654601150081, 29.007104362431885],
              [94.180944882956524, 29.019852679612033],
              [94.185197269909082, 29.027913133553525],
              [94.190765605072869, 29.038506846255032],
              [94.197780558099694, 29.048205572624266],
              [94.204784422473978, 29.059528665315327],
              [94.211599911617355, 29.068774904888809],
              [94.220533627155163, 29.083537912436508],
              [94.230557752126288, 29.089460600220317],
              [94.238939200765941, 29.095736026195404],
              [94.243944505932774, 29.099914120408929],
              [94.251703122383972, 29.107446334891637],
              [94.263564009443741, 29.116264672744407],
              [94.274798331529183, 29.126613666454958],
              [94.283481712224741, 29.134871438931416],
              [94.29367802354345, 29.147651496245597],
              [94.29829406310887, 29.149118510812741],
              [94.303529746066147, 29.150045596406702],
              [94.313397370950284, 29.150363348189305],
              [94.32440184282585, 29.149601707386147],
              [94.337250414291319, 29.149752892123889],
              [94.356061481227016, 29.149656885923267],
              [94.362834264270347, 29.152032036671216],
              [94.369592837416633, 29.156666607139083],
              [94.37354864926283, 29.165800059740224],
              [94.376034218758548, 29.181247519897774],
              [94.378247138727772, 29.189742472978988],
              [94.382853129661896, 29.194004560943],
              [94.405523839716295, 29.204478633687373],
              [94.419884221099124, 29.212208764175219],
              [94.431761412047678, 29.223087927159003],
              [94.437196060932038, 29.226357321287455],
              [94.447489619708861, 29.224953049482174],
              [94.460664063936164, 29.223466641595699],
              [94.472916612038318, 29.221163149774807],
              [94.484656161199268, 29.218224785452367],
              [94.500403730856704, 29.216111262782974],
              [94.519946954651445, 29.21662739632454],
              [94.538969484247502, 29.218129518644346],
              [94.551706369426242, 29.222681935871577],
              [94.563822607345273, 29.228312447969021],
              [94.573347944633255, 29.240254123247016],
              [94.578044644049342, 29.250016711169806],
              [94.579434004699962, 29.264371648415068],
              [94.579913163634501, 29.274664913388023],
              [94.583804048933459, 29.280269997947386],
              [94.589867989119867, 29.282183315770194],
              [94.595002542714028, 29.285806897542432],
              [94.599931465615953, 29.28934068827348],
              [94.611436701312996, 29.296499005228718],
              [94.616775030369141, 29.300664707816441],
              [94.625078603245058, 29.312328493502786],
              [94.627209641566182, 29.322081634283585],
              [94.629843627857994, 29.336350589511351],
              [94.629711677408338, 29.345196109731063],
              [94.634338775149004, 29.348184499185642],
              [94.647628673615174, 29.346500081816249],
              [94.672078709357208, 29.331296339274989],
              [94.683314487783207, 29.327347113769168],
              [94.687649636651912, 29.32329234248126],
              [94.700647781410893, 29.313388335179926],
              [94.710443318172764, 29.3071775053014],
              [94.717038967979718, 29.303758894463609],
              [94.742511893570693, 29.281323819385655],
              [94.754069886587956, 29.26554598910575],
              [94.772309581025837, 29.252031205001572],
              [94.783133477178765, 29.240310925848359],
              [94.788494508392134, 29.232374958664135],
              [94.796529287550953, 29.225343039194701],
              [94.801067523298101, 29.217856216532642],
              [94.803548952085734, 29.209102702359473],
              [94.802131546267006, 29.194571389217966],
              [94.798451369863784, 29.179401616439232],
              [94.798467893432928, 29.168751051172066],
              [94.803512616093258, 29.163613071939043],
              [94.815024502221775, 29.165701161862032],
              [94.825813064191067, 29.169953759983613],
              [94.838146336194384, 29.175740539421625],
              [94.852121928139667, 29.181978938695934],
              [94.857983702569257, 29.182704629435204],
              [94.877313950402325, 29.183258516388062],
              [94.886674608733415, 29.180733900510372],
              [94.898091520322879, 29.174962435968432],
              [94.9123874783552, 29.165400869529645],
              [94.924211544876542, 29.16116117746963],
              [94.932230592390667, 29.161613317186543],
              [94.943640800819409, 29.159807583158852],
              [94.962249268664465, 29.159176113042019],
              [94.973043195685094, 29.158543261499521],
              [94.976332278185566, 29.155023204935752],
              [94.986920049253442, 29.148702105902395],
              [94.99185147449495, 29.145451008905606],
              [95.000382205240257, 29.139670825697078],
              [95.010245790260768, 29.134432901386059],
              [95.0164113912207, 29.132083783161679],
              [95.028024703254985, 29.129279460399012],
              [95.030902285539042, 29.132255151614821],
              [95.023509530780075, 29.141646934682214],
              [95.015703585897711, 29.150586228874669],
              [95.009538804739492, 29.156455546222222],
              [94.997306837715314, 29.16458434797952],
              [94.99206630273396, 29.172347209628256],
              [95.002862810868436, 29.171801972830913],
              [95.010264267850971, 29.169270187145109],
              [95.016225516451499, 29.165838134950931],
              [95.025576445993792, 29.15987739570846],
              [95.034519186866419, 29.155990188395261],
              [95.044999951815171, 29.151109582042526],
              [95.059595025378684, 29.148750410058067],
              [95.07079620400205, 29.146575030055491],
              [95.083335401188336, 29.144215814025134],
              [95.103582284851967, 29.142389023292804],
              [95.107686650917714, 29.138684020088938],
              [95.114044124720778, 29.127575381548528],
              [95.118654930520393, 29.119718408758672],
              [95.126868676947169, 29.114743644829456],
              [95.151016330148309, 29.114079174280445],
              [95.159952165318558, 29.111809392705361],
              [95.182549330559397, 29.106987061685469],
              [95.201657115625551, 29.105961371277825],
              [95.221695778556651, 29.106824191812375],
              [95.245438267803834, 29.109030368786716],
              [95.255711360701142, 29.108195546577178],
              [95.252789230693224, 29.092046134762406],
              [95.256259770531415, 29.084006782886618],
              [95.254587479431848, 29.074805414580545],
              [95.254977081552511, 29.0667725720661],
              [95.262352466066844, 29.060167416294128],
              [95.27137861809328, 29.055813974331375],
              [95.277198440046789, 29.056776289378256],
              [95.282679746294633, 29.057683658573257],
              [95.291009047575812, 29.06036816350213],
              [95.302310329742213, 29.061331903267213],
              [95.307545784265869, 29.06104816901701],
              [95.313492298571305, 29.057422702216215],
              [95.323026405157506, 29.053155071151131],
              [95.335852047002177, 29.049509980619781],
              [95.350209315368119, 29.044142963537155],
              [95.378531857411147, 29.039272945366399],
              [95.389301298677779, 29.035990989222118],
              [95.404590137624467, 29.033323780210868],
              [95.414748932184537, 29.032024920172784],
              [95.421131643981312, 29.036063300527577],
              [95.426178655719738, 29.039113250965659],
              [95.433981878245092, 29.039178187287931],
              [95.443307167465079, 29.035081501518878],
              [95.452030334697142, 29.033877977660964],
              [95.458915116603322, 29.034843124942356],
              [95.463873406939115, 29.040961236202801],
              [95.469475089701803, 29.052490077184128],
              [95.474847212781398, 29.058786991882243],
              [95.478672782364072, 29.0638259669612],
              [95.487633640328383, 29.069023348454863],
              [95.490537412862849, 29.074155888115161],
              [95.49379044317557, 29.087679504230628],
              [95.496665602335682, 29.10715746748042],
              [95.496640670890343, 29.121686587487478],
              [95.501145447815219, 29.138362816201504],
              [95.50835520349051, 29.141038906909323],
              [95.518610996268734, 29.136936398630645],
              [95.532566770426371, 29.132725092919213],
              [95.543025810759389, 29.128527684394157],
              [95.551546615411937, 29.126595338357703],
              [95.551335936577573, 29.143741320623786],
              [95.551882240190778, 29.149332195631253],
              [95.551618059065987, 29.156734102134649],
              [95.551157638533923, 29.166120512988776],
              [95.550202679064185, 29.178667418932676],
              [95.546490954578687, 29.195106909001613],
              [95.542134633041044, 29.206405683303501],
              [95.542682400940151, 29.212177659915547],
              [95.549993658341663, 29.213770872088034],
              [95.565325028799876, 29.214691388972177],
              [95.584669465039198, 29.215502489433401],
              [95.590741647818078, 29.216105764591568],
              [95.590599098865127, 29.226302327204724],
              [95.592643379436666, 29.240550182915282],
              [95.598067517826678, 29.252434884920927],
              [95.603774753992937, 29.260076684484417],
              [95.610158573518163, 29.260675919999564],
              [95.625649630606787, 29.253108115825491],
              [95.636209197145021, 29.247189831845674],
              [95.643003387336535, 29.247966837125169],
              [95.647881576733511, 29.254165859812264],
              [95.657276581773715, 29.258628664860765],
              [95.665233085367362, 29.263367869043432],
              [95.678241858023966, 29.269251913088294],
              [95.688167675982257, 29.275421410778183],
              [95.697291863017611, 29.284664594370227],
              [95.702395478876255, 29.292755155330166],
              [95.706965533169239, 29.29859430251123],
              [95.71139630186147, 29.298841218771528],
              [95.720229818278526, 29.29644414714674],
              [95.73210092636522, 29.300614757961],
              [95.748577104763356, 29.314410058433879],
              [95.750531914095376, 29.327300592496968],
              [95.7702214044984, 29.342787788836112],
              [95.77810810899625, 29.350047494554659],
              [95.782781224810492, 29.354618990835682],
              [95.788238934880752, 29.354584649441513],
              [95.79207965898145, 29.345539018418553],
              [95.796118411381769, 29.336038783894278],
              [95.801563467851025, 29.334469946651467],
              [95.807666011387028, 29.337497803237834],
              [95.824356743012288, 29.350199234611189],
              [95.83190726349109, 29.353849289971745],
              [95.845381319202829, 29.351862267792928],
              [95.853355454317224, 29.35677049126728],
              [95.864045538686327, 29.365629781657105],
              [95.880384621189322, 29.383738901444627],
              [95.88600333924694, 29.389654846543891],
              [95.894450826097412, 29.38950311259396],
              [95.914717142293711, 29.386199366008469],
              [95.940439918735322, 29.382308214065713],
              [95.962163723653191, 29.380701219664115],
              [95.970969088707378, 29.3854141656909],
              [95.983052216551314, 29.398492160660638],
              [95.992290703709401, 29.404913012723199],
              [95.998310632476645, 29.408498115376393],
              [96.007597581942861, 29.410115353657577],
              [96.019648940758188, 29.419398271787525],
              [96.030702793175166, 29.431487805493305],
              [96.03987847311933, 29.441064364685705],
              [96.049239016549038, 29.448564452295429],
              [96.060769571189425, 29.4564952192909],
              [96.074627563656477, 29.460347889618316],
              [96.085777778952803, 29.461424633339846],
              [96.092356943793362, 29.459652561699986],
              [96.097967915026715, 29.454462516349736],
              [96.106294920397573, 29.443293553674547],
              [96.118254158267689, 29.425417333727978],
              [96.128962595238718, 29.415488958266607],
              [96.144201685845715, 29.40560885303876],
              [96.15492289958307, 29.397032663301911],
              [96.162662461462759, 29.380814425742926],
              [96.168664991919186, 29.374354497194911],
              [96.180055776610857, 29.362162382959781],
              [96.185098995545957, 29.353095303243361],
              [96.190524339492228, 29.342039585095606],
              [96.189842885200747, 29.336632539604171],
              [96.187728955456805, 29.306703300011584],
              [96.193026686866247, 29.302053263500888],
              [96.207818149918026, 29.291001274099404],
              [96.214586894836856, 29.272173176189767],
              [96.230661472664082, 29.257046184340894],
              [96.238584764850316, 29.240641031843314],
              [96.247945446790112, 29.232253526661115],
              [96.255226158898196, 29.230378092248547],
              [96.27008181884365, 29.233657513755109],
              [96.287145735178981, 29.232404975589191],
              [96.297335903597855, 29.232844589374693],
              [96.31698870305631, 29.256187197512379],
              [96.324536662773497, 29.258724291746578],
              [96.34972422442975, 29.264415500173662],
              [96.355138678136214, 29.268959162051694],
              [96.362784129096738, 29.278619284784099],
              [96.367575039340977, 29.282716463702588],
              [96.373451690471086, 29.283377318927403],
              [96.37938454332226, 29.280786243636133],
              [96.386488057992793, 29.273403875681637],
              [96.391867787495812, 29.260808347581243],
              [96.397117951730834, 29.253446581370856],
              [96.396045731174851, 29.243086092162716],
              [96.391959679502278, 29.230592245680597],
              [96.384452353332364, 29.223458088280111],
              [96.375589747380332, 29.214893162271395],
              [96.370505957831881, 29.204305036959866],
              [96.367192673678701, 29.195229618292839],
              [96.362644013675634, 29.178411737360637],
              [96.350467844301448, 29.167805043895395],
              [96.336671345601061, 29.166324447341164],
              [96.311773326913766, 29.165228227385541],
              [96.294729391385559, 29.158995696112061],
              [96.276615524979846, 29.157552655972637],
              [96.270862951136735, 29.157971517206992],
              [96.264374431557627, 29.157041797749354],
              [96.259671598950092, 29.151045110238307],
              [96.253041707025872, 29.147050835038215],
              [96.24222549650041, 29.145259941767598],
              [96.231920933999604, 29.143284642831983],
              [96.221643668513266, 29.134993944971704],
              [96.219219340998706, 29.130145309866755],
              [96.212797178766877, 29.117577700554019],
              [96.209125348040246, 29.111296683315601],
              [96.204398190258573, 29.102771716691656],
              [96.189671432618141, 29.091451756935925],
              [96.173561179054758, 29.084472365985444],
              [96.159566974265658, 29.082525051740443],
              [96.128281357633426, 29.077571033550779],
              [96.118588362675439, 29.074498476893631],
              [96.140729944901423, 29.061313800396494],
              [96.154361909376306, 29.049915703927002],
              [96.164747023876686, 29.033223092891614],
              [96.169071727698224, 29.016767267173226],
              [96.172683535212187, 29.009516123642118],
              [96.179410317726635, 29.000074162653608],
              [96.184022227834248, 28.99597230622653],
              [96.188611330559851, 28.984653213756694],
              [96.188284278183943, 28.974284255188508],
              [96.184171862222712, 28.965030023687603],
              [96.165906549779749, 28.956172684018306],
              [96.15888214794461, 28.952087290575729],
              [96.157752223102307, 28.942984700733255],
              [96.154018873205118, 28.939590827840579],
              [96.148928607151618, 28.933951331959065],
              [96.158980207204237, 28.924750816276138],
              [96.166601424383089, 28.918458176590519],
              [96.169173608424671, 28.910406401170942],
              [96.170105694051117, 28.902278926702483],
              [96.178291641254418, 28.900581938339688],
              [96.18955943498689, 28.908327920750679],
              [96.208208270556796, 28.915464592053262],
              [96.219027485275205, 28.919601643742677],
              [96.231718908338706, 28.925616837615678],
              [96.251887786379896, 28.939137429885001],
              [96.259274983544259, 28.95557383480179],
              [96.264273875019271, 28.961478626381133],
              [96.271840068312869, 28.967628358014679],
              [96.285546100555848, 28.980033629254883],
              [96.290268868179098, 28.988376482664503],
              [96.297394814021473, 28.995087302896803],
              [96.304772365967963, 28.998603186889685],
              [96.312822612133388, 29.00195019945409],
              [96.325236037603688, 29.009130421697339],
              [96.340996443290294, 29.020876802464567],
              [96.350444500590243, 29.028625387872374],
              [96.361149796945654, 29.03058900771763],
              [96.372454543109697, 29.031281709300337],
              [96.392670720569626, 29.03043621274977],
              [96.408091218854779, 29.031621762374513],
              [96.424543995216823, 29.033247111157756],
              [96.439441347302477, 29.033806551735335],
              [96.453472996491826, 29.038520527935521],
              [96.46256137711778, 29.042026793939922],
              [96.470280538725376, 29.050238646791403],
              [96.480847272838005, 29.056342227665809],
              [96.49531099204107, 29.062038724768168],
              [96.504014028637869, 29.067079720902679],
              [96.51186371918881, 29.069965483430927],
              [96.522308941240453, 29.074623872395364],
              [96.528896703310636, 29.075448819734785],
              [96.515346011122404, 29.04872900620855],
              [96.509024194497357, 29.037980065535496],
              [96.50239720959982, 29.02741283894472],
              [96.496380922830681, 29.016388954780652],
              [96.492128455649876, 29.006515624804244],
              [96.487763168993979, 29.001368451051754],
              [96.480902293086913, 28.990047110923413],
              [96.485022806112951, 28.977102876703775],
              [96.487774225244436, 28.968775325214388],
              [96.490949840705071, 28.96125236619158],
              [96.496650013233278, 28.958209577529949],
              [96.504161238446954, 28.959568768991026],
              [96.516779085844604, 28.96618677042845],
              [96.522227886089624, 28.966845593544374],
              [96.524603132479015, 28.961044318679555],
              [96.525996806088173, 28.951288434635046],
              [96.527014048949951, 28.943790184211885],
              [96.533616186604775, 28.932709481744794],
              [96.538743085998306, 28.925705269353877],
              [96.541990769125448, 28.916648335707162],
              [96.540076741686505, 28.905305573417202],
              [96.539272805198451, 28.892778364271244],
              [96.540612287888393, 28.879684517772979],
              [96.550001984698383, 28.870013559639979],
              [96.556289370501958, 28.858576167633487],
              [96.562841552950459, 28.851372984699854],
              [96.565896574045723, 28.843398762458097],
              [96.570008138641938, 28.837307530426525],
              [96.57885068496411, 28.82583760108237],
              [96.587215623266786, 28.816809820095425],
              [96.598082916508361, 28.810456312444853],
              [96.606726227075086, 28.799617579264272],
              [96.611236301314861, 28.793250603181004],
              [96.614082841010102, 28.785187370649798],
              [96.618818535846216, 28.773675234941734],
              [96.618295253528018, 28.759883795723873],
              [96.616372195077062, 28.754855380328856],
              [96.612173969572268, 28.748412827312531],
              [96.600874974495838, 28.733038761093482],
              [96.588644137283168, 28.716589630213353],
              [96.575023951012824, 28.709717893997322],
              [96.562696431630556, 28.706885383310528],
              [96.534951973455335, 28.70657784492964],
              [96.525086216787216, 28.704077961735059],
              [96.510743418414165, 28.696213530483885],
              [96.501101191742094, 28.68766398130834],
              [96.49326415982371, 28.683603618066329],
              [96.487016354523774, 28.683402306158278],
              [96.475450917138758, 28.683352360278789],
              [96.473248968355591, 28.679677649279085],
              [96.477679279183505, 28.674576989931705],
              [96.481066162437358, 28.667955126887406],
              [96.486584074344506, 28.660316210025009],
              [96.489456188019261, 28.653791504886094],
              [96.493740644656327, 28.645715694823565],
              [96.497733398077983, 28.638724325700608],
              [96.496628250263186, 28.633144700447449],
              [96.486816594474632, 28.626490554907225],
              [96.475435310323135, 28.617417395712316],
              [96.460791896514465, 28.608829008351574],
              [96.446975591782802, 28.600952672879671],
              [96.441894611234858, 28.59577507406248],
              [96.437545627281196, 28.591944074422443],
              [96.430560650494613, 28.582095280611469],
              [96.425011016112776, 28.579991245140949],
              [96.417593834815477, 28.583407106364024],
              [96.409903723380268, 28.589443106748817],
              [96.40345990337039, 28.589330463790784],
              [96.402487693014464, 28.585460230944069],
              [96.40865708519091, 28.572858265324484],
              [96.409183660981938, 28.566447636726405],
              [96.409083808332184, 28.55896172192935],
              [96.403233172175433, 28.557310758781991],
              [96.396697185890744, 28.557648978442952],
              [96.388839019744566, 28.558632193356559],
              [96.373307432241816, 28.559153695838038],
              [96.35711047511333, 28.555620973250178],
              [96.345742490717043, 28.546085949079966],
              [96.33730470111017, 28.533540199740457],
              [96.328150075101362, 28.529030703171525],
              [96.326776688232826, 28.525345906545468],
              [96.33357499850942, 28.521579297184747],
              [96.344539651320773, 28.516147692236597],
              [96.355393855513441, 28.509814491544937],
              [96.363293320569156, 28.504593556783828],
              [96.36894983258199, 28.499572605418152],
              [96.374055713682367, 28.491583112802854],
              [96.375255753667972, 28.481827748556899],
              [96.369233922415972, 28.47431404305409],
              [96.343678639238618, 28.464829382493132],
              [96.337356967687128, 28.457585995565942],
              [96.326129054595654, 28.449848716437703],
              [96.311919517477008, 28.440516316251646],
              [96.29938101615187, 28.433962850384738],
              [96.287027237320487, 28.42560260527771],
              [96.276737177411661, 28.418842891968897],
              [96.268178447271012, 28.411887818216126],
              [96.265992842295148, 28.408210521889725],
              [96.269629028193947, 28.405017799999754],
              [96.279206119396676, 28.403665841965211],
              [96.290024716419452, 28.403472069976861],
              [96.301430262778737, 28.401377741482698],
              [96.306815393302486, 28.39943077405195],
              [96.312441751061257, 28.392248303842425],
              [96.317439196153515, 28.383076869771685],
              [96.321996558664225, 28.38078881849691],
              [96.332627848546338, 28.382398270746666],
              [96.363931958602222, 28.388308927627627],
              [96.373022362894119, 28.388849132192917],
              [96.376912506205116, 28.381772625468813],
              [96.382018011390159, 28.358537813923796],
              [96.394139393458374, 28.357060866459964],
              [96.401346105841981, 28.338854861780618],
              [96.41463847444335, 28.341061284944217],
              [96.42479487743843, 28.345283670624699],
              [96.42894210235653, 28.357779938981615],
              [96.43069711417283, 28.366870457515827],
              [96.431933991192707, 28.375426814748529],
              [96.432512694508944, 28.380473044152154],
              [96.434018760508295, 28.386138291441362],
              [96.441187725691407, 28.395444098432353],
              [96.449027443407303, 28.401584556731528],
              [96.455882304863493, 28.410078845558353],
              [96.460321668388403, 28.41363877303019],
              [96.471803182305024, 28.417211941676488],
              [96.482038411908533, 28.41899547266534],
              [96.49876533459917, 28.417907437564146],
              [96.508309322366131, 28.414374563406632],
              [96.512266842282415, 28.412615441409788],
              [96.522138856531924, 28.417644382259873],
              [96.53588188077201, 28.428944012097897],
              [96.553144511606106, 28.436504702635062],
              [96.561575575585181, 28.447320243727219],
              [96.581640058014344, 28.457367733964482],
              [96.600683056405018, 28.460480007589823],
              [96.623427375500469, 28.458584076116818],
              [96.641194522376495, 28.458278275398055],
              [96.662063430620719, 28.460456326537873],
              [96.666547029401741, 28.459860263711764],
              [96.677330995290404, 28.450796955773175],
              [96.683369873974826, 28.445220332917302],
              [96.689243365628741, 28.442262537484694],
              [96.70806227205388, 28.431383080838874],
              [96.71870799216093, 28.426828757428659],
              [96.735823370869966, 28.424623390798477],
              [96.741788946096619, 28.421029755097099],
              [96.752825515018188, 28.415477079435743],
              [96.759252972865752, 28.409171041322704],
              [96.764884593631379, 28.397912529226033],
              [96.769030481434186, 28.383338679853988],
              [96.772350311225281, 28.374368110891609],
              [96.776012987316435, 28.367646762749796],
              [96.784216166303224, 28.363930185211654],
              [96.798707910621346, 28.364009768003481],
              [96.813156440475524, 28.361561480830442],
              [96.828037268830471, 28.360640094796583],
              [96.853771096301074, 28.36173311014176],
              [96.864047569254936, 28.371694100423291],
              [96.871133352241131, 28.374211534885781],
              [96.881576288028256, 28.376139419063421],
              [96.895515408125618, 28.379461837915805],
              [96.900204686140469, 28.37921547774658],
              [96.905710068666878, 28.373187276822964],
              [96.911779246365953, 28.364625798569623],
              [96.921429901874689, 28.356553087954278],
              [96.921252553661503, 28.352407862183458],
              [96.922350906251523, 28.345358011345184],
              [96.927319840319427, 28.338163126233081],
              [96.943689267654591, 28.335134038557676],
              [96.954157933939143, 28.333000961185174],
              [96.963293797436563, 28.32502413079219],
              [96.97538068973256, 28.316641095132692],
              [96.981063892265709, 28.315206911381448],
              [96.988304923361014, 28.315101980360758],
              [96.997780308898314, 28.309100231540537],
              [97.005571280135811, 28.311240587526509],
              [97.02397602683196, 28.3190830608612],
              [97.028434300728435, 28.322892395609426],
              [97.037677709004427, 28.33150186489188],
              [97.04267611928438, 28.342066170125637],
              [97.046647321569964, 28.346966377367174],
              [97.053152053233148, 28.350924725144495],
              [97.062440555822121, 28.351143805492409],
              [97.067462055439989, 28.352330594586746],
              [97.080632354862345, 28.357899792758161],
              [97.093886558843806, 28.362474763432797],
              [97.099555074968791, 28.360223426532269],
              [97.105485943394626, 28.355713365252829],
              [97.114077126456706, 28.35161183519801],
              [97.122221109818767, 28.350674315983913],
              [97.127185785644684, 28.348883509585434],
              [97.131066725914607, 28.344043928525206],
              [97.140207999084936, 28.33695779332751],
              [97.153159061012431, 28.326562648256292],
              [97.159949583898424, 28.319422609843226],
              [97.166500110332692, 28.305432966935459],
              [97.170462367196933, 28.294641803501147],
              [97.174969402802787, 28.29143208740215],
              [97.179051270792584, 28.289652153972749],
              [97.184107147445019, 28.288653459648685],
              [97.193652624430769, 28.286695978652908],
              [97.203773386692006, 28.287885913738222],
              [97.215059515965152, 28.291308102530014],
              [97.225274666047, 28.292134569329694],
              [97.229036219935935, 28.286661551825723],
              [97.235173493974372, 28.272947215426615],
              [97.242190487731861, 28.267243821183271],
              [97.255370720242382, 28.268558555608472],
              [97.269069552910082, 28.270313864469305],
              [97.282993362583611, 28.268277429271194],
              [97.293476151930648, 28.262601974912332],
              [97.307194717262448, 28.255881582920086],
              [97.308495250335767, 28.249997345574037],
              [97.31386417046653, 28.243687659130256],
              [97.322833899721246, 28.243713927286592],
              [97.328213132271955, 28.242630562261457],
              [97.334568111206252, 28.239548363087387],
              [97.342497275239595, 28.233912949441386],
              [97.352108983102326, 28.225995062083527],
              [97.365703346489241, 28.223234687714037],
              [97.375354115436508, 28.217208695527709],
              [97.381943230445358, 28.211045291551468],
              [97.390343188550105, 28.203874568323528],
              [97.40118327431864, 28.191966873938224],
              [97.401026647008663, 28.184939017030356],
              [97.392824944089128, 28.182647588382952],
              [97.387805280332572, 28.185981652075416],
              [97.382858105348802, 28.188050387587023],
              [97.372654529099549, 28.191924175463701],
              [97.364213854815262, 28.188013231081705],
              [97.359859828544344, 28.17997524725968],
              [97.352475949894597, 28.173071107124688],
              [97.341884225553514, 28.163785810148894],
              [97.331395586623842, 28.154499089800229],
              [97.327642914966404, 28.145817886755768],
              [97.325270150821751, 28.139729289598197],
              [97.327265170654982, 28.133113946267784],
              [97.332227987782119, 28.12716912956801],
              [97.335491856659942, 28.12269760889426],
              [97.34053839823855, 28.115938560768878],
              [97.339512026923529, 28.110908343455151],
              [97.327688888162825, 28.100831635001736],
              [97.31741986727863, 28.091901118936342],
              [97.310648517420034, 28.084621638702398],
              [97.308552777527808, 28.077085833783901],
              [97.308165717228007, 28.06843577468441],
              [97.312182738589982, 28.061247957296551],
              [97.319244537196667, 28.058334104985192],
              [97.332029582164026, 28.056585360118543],
              [97.345689028119011, 28.057793709607694],
              [97.357107966616709, 28.058770505555621],
              [97.36637763080428, 28.059244154910669],
              [97.373852436533269, 28.061369344793501],
              [97.37429490290063, 28.053697964972695],
              [97.368273417882691, 28.043523810245247],
              [97.377339743798899, 28.030116879374436],
              [97.382448891670052, 28.031199362393529],
              [97.390017110378238, 28.028364271787041],
              [97.398793707485623, 28.025055541047941],
              [97.405823754668802, 28.020967414353841],
              [97.411762703440189, 28.018158234519493],
              [97.415353289591522, 28.014940440693628],
              [97.414126547358137, 28.010095567875478],
              [97.411799572597999, 28.005988279472842],
              [97.402395897957831, 28.00389816794382],
              [97.391386169070074, 28.002829758089394],
              [97.389023571718042, 27.997100077068595],
              [97.382925370996375, 27.983321895389366],
              [97.378209716727369, 27.977003510582868],
              [97.378348101864319, 27.969337660129071],
              [97.37862253310422, 27.95400824933024],
              [97.375671178860358, 27.935126777786156],
              [97.382704552175412, 27.926803251967144],
              [97.387669082057059, 27.921398773630379],
              [97.387679815440464, 27.917252542947161],
              [97.381055495309894, 27.911775629619523],
              [97.378550240143909, 27.908664092325328],
              [97.379752005294577, 27.903233349631279],
              [97.387483747220813, 27.894266019679058],
              [97.388947415783448, 27.886938925416867],
              [97.378412870209388, 27.883694906062829],
              [97.371269008089712, 27.877506035888626],
              [97.36472869838741, 27.875724515894795],
              [97.343487135766878, 27.884740668667529],
              [97.335545458720034, 27.883883876984626],
              [97.321144238317459, 27.880247208336606],
              [97.322860486367986, 27.89419272241291],
              [97.323957003928129, 27.902649039748749],
              [97.32222061605205, 27.90700639340567],
              [97.314790308126149, 27.916056097725331],
              [97.308793334021544, 27.9208445573239],
              [97.301823178540701, 27.917984435136546],
              [97.288196094976897, 27.912711013837995],
              [97.280832024603129, 27.910488519012343],
              [97.256544021646235, 27.900518996709703],
              [97.247284382728381, 27.89489895638836],
              [97.241318594807439, 27.886429825774648],
              [97.236837139781613, 27.880913838433308],
              [97.22652247710532, 27.873145327863508],
              [97.220532213939521, 27.86837242050494],
              [97.212502490307116, 27.863001416532583],
              [97.20259905012864, 27.855404279535467],
              [97.195632368538639, 27.847399283035838],
              [97.189523044589507, 27.841456738453111],
              [97.186993537137312, 27.836896949193502],
              [97.181835013409909, 27.832740030574374],
              [97.174457466683904, 27.829428968869831],
              [97.167816454327905, 27.827279933753221],
              [97.168898248558293, 27.820410041303624],
              [97.160338360339253, 27.813600370267196],
              [97.152251609824503, 27.810208674719156],
              [97.144289431641155, 27.807989264892857],
              [97.137350820958588, 27.806112377902338],
              [97.133933658451184, 27.797508032724433],
              [97.127840530698094, 27.792102038736708],
              [97.124237392226803, 27.789540045806234],
              [97.114851940159809, 27.786979957246572],
              [97.102436255129106, 27.784501516760564],
              [97.098370444878611, 27.779653266503612],
              [97.100086566802432, 27.773856879164327],
              [97.104712744522544, 27.766213894086825],
              [97.101110871739522, 27.758242970506593],
              [97.097977312393112, 27.748280370480135],
              [97.096315405318336, 27.740911046111954],
              [97.09131664663748, 27.739454107926111],
              [97.082251688945959, 27.742925908542034],
              [97.067483828365667, 27.750809873289786],
              [97.061962263664086, 27.748547531363872],
              [97.056485720034274, 27.743126288911817],
              [97.04801387122896, 27.740456879814563],
              [97.037311833937466, 27.743317772177701],
              [97.028532756775121, 27.740291005630411],
              [97.015696889257342, 27.7318192364392],
              [97.013164427407801, 27.726534329166839],
              [97.010246532111978, 27.716658333017346],
              [97.005400897599912, 27.706628470966916],
              [96.999062434125051, 27.692650645006321],
              [96.992487859046278, 27.6766927122782],
              [96.99271934517202, 27.666860597519769],
              [96.990707251082213, 27.662109889830248],
              [96.977442724134221, 27.663019602607353],
              [96.958526547304331, 27.665448284588127],
              [96.948641891907059, 27.662610132308803],
              [96.942186428164135, 27.658642777021548],
              [96.938304558646664, 27.65111977782772],
              [96.933811490424134, 27.643425939163563],
              [96.930772581203982, 27.637698016334667],
              [96.925393068004638, 27.63136724972253],
              [96.919263405999644, 27.622613208048747],
              [96.912911734415161, 27.618641842530199],
              [96.900392567191403, 27.615475210781309],
              [96.897396081088957, 27.611998884685857],
              [96.898872063013869, 27.591596782721826],
              [96.898959962052814, 27.58474102149788],
              [96.902746085023125, 27.580992652288387],
              [96.909836983925857, 27.580986837805757],
              [96.913761654850163, 27.579490633058867],
              [96.913793511078566, 27.575432165068694],
              [96.912946413054598, 27.567327495536947],
              [96.913906710629774, 27.558296404299526],
              [96.915474748871148, 27.549256138380123],
              [96.919985742659478, 27.546579323717424],
              [96.924163295270361, 27.542194824118514],
              [96.928263253862241, 27.533209810152428],
              [96.933238576044999, 27.528091041175209],
              [96.937265435646623, 27.520911712611316],
              [96.935934060693583, 27.514076601203225],
              [96.93307094433213, 27.506539069939407],
              [96.930372192802977, 27.502699906866926],
              [96.925259334490121, 27.493841886822914],
              [96.919909943420649, 27.48877329948116],
              [96.915064918335887, 27.483608242671732],
              [96.913158654457945, 27.478672761588811],
              [96.910724499983061, 27.472304381169216],
              [96.910301951973693, 27.465364243535532],
              [96.910393067864362, 27.458779598190176],
              [96.911314231256966, 27.453446706187648],
              [96.917016505573301, 27.4495823689156],
              [96.925374300066181, 27.447124385018025],
              [96.93275980669209, 27.441161692564847],
              [96.936415808834397, 27.430200556916368],
              [96.940750690927189, 27.417513778250918],
              [96.948234248018338, 27.411459751945092],
              [96.964826282645191, 27.405820955553782],
              [96.968231059003813, 27.392246344471808],
              [96.974805684749398, 27.386383388655279],
              [96.968263993758114, 27.376642971342235],
              [96.970968571530335, 27.369302548434536],
              [96.976187247670367, 27.367065983381746],
              [96.981190014106588, 27.364020435120665],
              [96.984231519295818, 27.352884107952672],
              [96.988709088103278, 27.348763167028451],
              [96.996633018279752, 27.3453159524467],
              [96.997570718745621, 27.3410656694194],
              [96.999400008696014, 27.330127398960158],
              [97.002457588053133, 27.3200743795982],
              [97.008647353707033, 27.315749802913306],
              [97.015927523143858, 27.310144734400208],
              [97.039352942306706, 27.297819292827882],
              [97.042565446756882, 27.279646907847312],
              [97.050590396921166, 27.276375940829634],
              [97.055625122237387, 27.275491445903668],
              [97.057790279469614, 27.266623853166358],
              [97.062252335796373, 27.262050805784934],
              [97.06742035985171, 27.257287388776554],
              [97.072569855603234, 27.251619738913817],
              [97.080705294191787, 27.243567021546472],
              [97.088224618572568, 27.240480887935],
              [97.092915819302604, 27.237527555729542],
              [97.094813703422503, 27.230826517166062],
              [97.093945907146349, 27.211000274952262],
              [97.099281645947556, 27.2045206360572],
              [97.106818075456076, 27.202607788381943],
              [97.115428549981345, 27.198691599959108],
              [97.118977784336352, 27.194042298760575],
              [97.122623868141332, 27.189298033196867],
              [97.124403841632102, 27.181787031187479],
              [97.12598654696194, 27.174549143816115],
              [97.132266161777764, 27.170308613222016],
              [97.138964929692122, 27.166783031913447],
              [97.148568279178591, 27.167631135494187],
              [97.151510393425895, 27.157668495846384],
              [97.154621638078538, 27.151400888746643],
              [97.165799226478981, 27.14464945341475],
              [97.170735645940667, 27.133483241253359],
              [97.170288955222986, 27.125915824874177],
              [97.164453980587595, 27.121404716695491],
              [97.154457181138795, 27.115513660682897],
              [97.15090206792793, 27.108803445521676],
              [97.148630429795418, 27.100633307071817],
              [97.144937885382916, 27.091941630483589],
              [97.138455341535334, 27.090413522291481],
              [97.129524526950391, 27.09289091287112],
              [97.120900712577125, 27.101224632891523],
              [97.1132790380763, 27.10918149141623],
              [97.107150170976297, 27.110532278562076],
              [97.097822243111494, 27.107873692795035],
              [97.087849055169158, 27.103150475749121],
              [97.077693171205084, 27.099329375864663],
              [97.070114107933804, 27.09853483853745],
              [97.061274298362335, 27.100555688778567],
              [97.051224725603547, 27.10836561512998],
              [97.046567749735715, 27.113210216534487],
              [97.044201450883705, 27.116309714617334],
              [97.040648452818871, 27.120780096641095],
              [97.033690566504831, 27.126648952458929],
              [97.028930929485114, 27.131315460526281],
              [97.01971251236165, 27.135052203469609],
              [97.011867154252045, 27.136514812966595],
              [97.005563523356258, 27.139488747717355],
              [96.997764279443103, 27.143654467478118],
              [96.991331277814865, 27.150958965158615],
              [96.983454823834222, 27.156478355640044],
              [96.972327594479012, 27.160870163738146],
              [96.96256429860162, 27.162448339869346],
              [96.954103591454015, 27.16355516743786],
              [96.943514044404878, 27.163967709171505],
              [96.926881365113417, 27.165093063450268],
              [96.917297930411053, 27.16549361861529],
              [96.901641742074787, 27.170841916389271],
              [96.895830060976024, 27.173443060564995],
              [96.881918280921752, 27.180661490382143],
              [96.874600953254401, 27.183732569947271],
              [96.865210556113482, 27.189896913101553],
              [96.863006495672423, 27.19714091577935],
              [96.862588070356622, 27.202466789349998],
              [96.862398368734773, 27.209506089537257],
              [96.865297376387787, 27.213887103406982],
              [96.873120422384403, 27.216942258428166],
              [96.879347875275911, 27.221010036808895],
              [96.884224758479206, 27.222839757719978],
              [96.889041940001874, 27.227105545500748],
              [96.890420770844116, 27.2311450770516],
              [96.891743504313879, 27.23789074358303],
              [96.886104259815397, 27.2450006579211],
              [96.886987647842417, 27.249678550457677],
              [96.887866801598975, 27.253906306298774],
              [96.884200682127798, 27.258282950485416],
              [96.874187117788651, 27.257512628941559],
              [96.86533012338991, 27.259432290823046],
              [96.860841448310751, 27.262918114177388],
              [96.854806957126343, 27.270752271495809],
              [96.852953524653202, 27.281147892588638],
              [96.850989041889477, 27.290913918236129],
              [96.848963335684346, 27.296802214153569],
              [96.835492511970628, 27.301126266493117],
              [96.830505203696276, 27.305246987470234],
              [96.82413204735343, 27.31110142001959],
              [96.820861083067996, 27.315110636268212],
              [96.816395552545529, 27.32021874678852],
              [96.812057128871061, 27.327128042941325],
              [96.807945914308334, 27.335658108181207],
              [96.805203459173754, 27.341194690391657],
              [96.801729931714959, 27.345208455609978],
              [96.794180904530336, 27.347286517192323],
              [96.784715942653264, 27.34965987335255],
              [96.779004833802631, 27.35298025472655],
              [96.772377146370047, 27.355857552341128],
              [96.759209828886512, 27.354216098604685],
              [96.753602642598864, 27.353700633503877],
              [96.747191794369286, 27.354995030962382],
              [96.740119966567548, 27.355443369839733],
              [96.72790726669146, 27.363438612985945],
              [96.722011127378892, 27.368018958378929],
              [96.71205884815673, 27.371837552351373],
              [96.708235965620617, 27.366291542250739],
              [96.705848466157363, 27.362260340274808],
              [96.698587647178229, 27.356666041780112],
              [96.693229414675031, 27.356637930481085],
              [96.682663986276893, 27.360100894212756],
              [96.675719162709939, 27.362077300489517],
              [96.669671815331384, 27.363500790379504],
              [96.660358615481741, 27.362616342072535],
              [96.655571223978214, 27.36014784702046],
              [96.645648215555227, 27.359088432577057],
              [96.638691339836683, 27.360521525874862],
              [96.629933377099462, 27.363147337548028],
              [96.620040355755535, 27.364162143387915],
              [96.612104891851487, 27.360733279631926],
              [96.608508902367433, 27.356536026446392],
              [96.60207567369207, 27.35200633987656],
              [96.597870516673538, 27.347814618548899],
              [96.597500254873268, 27.342857980098167],
              [96.600334704866725, 27.335970827972304],
              [96.595859897176069, 27.333945087981757],
              [96.591184478546452, 27.332194216649146],
              [96.585469529295864, 27.328197724434915],
              [96.579461776907436, 27.325015774863374],
              [96.574953089504845, 27.320555985780725],
              [96.56551977263544, 27.318042191199069],
              [96.561357150955729, 27.316644848992681],
              [96.55573596993213, 27.312015080640752],
              [96.549997261057825, 27.306123410772649],
              [96.544776762230725, 27.301128217351653],
              [96.537126376227874, 27.295708642822621],
              [96.530273335221949, 27.289466685379267],
              [96.521832952859285, 27.285405923536175],
              [96.516567912537326, 27.29204746735142],
              [96.511358372984077, 27.295531046403973],
              [96.504940077730325, 27.299116737319117],
              [96.49960675651181, 27.300886042396748],
              [96.493605104475833, 27.297790552551366],
              [96.485609588976345, 27.296790930605237],
              [96.47877422821982, 27.299658708168579],
              [96.470343668683853, 27.304074881013211],
              [96.466283127975018, 27.302672677659363],
              [96.461207558182096, 27.300740213561433],
              [96.452123255078405, 27.301462630048221],
              [96.445763266109239, 27.301978024603613],
              [96.439397969020092, 27.30204330564333],
              [96.433127730216455, 27.301653881196181],
              [96.424594277218389, 27.297860007120295],
              [96.415727365619162, 27.291632138208943],
              [96.408249532744009, 27.291705877370827],
              [96.401362737202419, 27.290330225525018],
              [96.391211929831314, 27.286368778597645],
              [96.38245878039676, 27.289338591150365],
              [96.373382631368557, 27.29077859769211],
              [96.363797651400873, 27.292042868909821],
              [96.361200891406256, 27.285934113476429],
              [96.354888270873445, 27.281751291621646],
              [96.347393206013123, 27.28028806215853],
              [96.340865266298408, 27.283507300768566],
              [96.335459626216604, 27.287887045778636],
              [96.320126414897516, 27.290014632636769],
              [96.310575564505768, 27.294071320260443],
              [96.303065455256558, 27.291251835139342],
              [96.290178633223832, 27.286133748242516],
              [96.281903971700373, 27.278087773416932],
              [96.27839764122271, 27.271441730525929],
              [96.2671682910687, 27.269916886031289],
              [96.253970052857952, 27.273100536586391],
              [96.241176173466116, 27.276458811281778],
              [96.234111361245425, 27.277059610558783],
              [96.226892506152055, 27.27279248802051],
              [96.21788800267656, 27.261770689763193],
              [96.205629947070392, 27.258353411265787],
              [96.196126000794337, 27.257438925045857],
              [96.181875387783634, 27.246508137095429],
              [96.163495643821904, 27.246787548423796],
              [96.15021840558633, 27.241839357269814],
              [96.114313832878395, 27.22569818068855],
              [96.098847928999632, 27.223828906656916],
              [96.091936761448522, 27.219098928925849],
              [96.086193330132105, 27.209486456882171],
              [96.068794238498569, 27.205644960181779],
              [96.057089540543117, 27.195263076802089],
              [96.036235715383086, 27.188554723263561],
              [96.029604036242219, 27.180298985840796],
              [96.022757265511316, 27.158870285788314],
              [96.016702525779039, 27.147271899770764],
              [96.004069819326773, 27.132918885222718],
              [95.98931285398217, 27.11767817371253],
              [95.97890423855452, 27.103219606311015],
              [95.9716454691726, 27.091264794437468],
              [95.962736123199136, 27.074447801513109],
              [95.956777997945053, 27.060679135258624],
              [95.945620363683176, 27.052178124595134],
              [95.935890767275353, 27.045470809882644],
              [95.922854001666408, 27.041400450220948],
              [95.915467955543932, 27.037836945377599],
              [95.908878787180512, 27.032823825653757],
              [95.900347372316773, 27.024301665696026],
              [95.88882833398992, 27.02039896948013],
              [95.87678268243053, 27.013071287500765],
              [95.867120333949657, 27.014930587909454],
              [95.857444773807131, 27.014986941199464],
              [95.837642071754544, 27.007969991483616],
              [95.827684646531338, 27.010732698587258],
              [95.815014763042257, 27.01495294859906],
              [95.807645527738458, 27.013186642696926],
              [95.804566095012547, 27.004719978076906],
              [95.779335114743745, 26.982739517525339],
              [95.772636933368901, 26.975282991258652],
              [95.771403788606918, 26.971410311560238],
              [95.766735728689952, 26.965657149341443],
              [95.760535484807974, 26.956752390896675],
              [95.763337392518594, 26.937695421271378],
              [95.760197379232153, 26.934733608049246],
              [95.756358803493924, 26.932946121274774],
              [95.752169774784946, 26.922949879385001],
              [95.754152394733325, 26.917704687188209],
              [95.756842377347652, 26.913087797549633],
              [95.757716575507388, 26.907579550395738],
              [95.754550999528647, 26.900555454078226],
              [95.744643646597723, 26.893564105610956],
              [95.735533485173235, 26.885393797775397],
              [95.730370789673998, 26.880183965118324],
              [95.720684027617025, 26.876347207123551],
              [95.711125775943273, 26.877114957750255],
              [95.703087753448457, 26.879949876678548],
              [95.698200301682121, 26.888004909706595],
              [95.691883365913327, 26.892725378612848],
              [95.680937968276282, 26.897829021040835],
              [95.67301300711928, 26.903097724903439],
              [95.667866995924769, 26.901226032859029],
              [95.662613776982667, 26.897818689983566],
              [95.657444764742536, 26.890981628783937],
              [95.655002705065598, 26.885846430276533],
              [95.650627397995208, 26.876748502587727],
              [95.64609256374591, 26.875774296349878],
              [95.641864967838998, 26.875971681173162],
              [95.636409865046232, 26.872204710434968],
              [95.633763335241071, 26.866167926057724],
              [95.634535953914821, 26.859484749092612],
              [95.633169811833653, 26.848027464348451],
              [95.631834337870217, 26.842347491491392],
              [95.627275260990658, 26.83613752449353],
              [95.621611602853079, 26.830111282334524],
              [95.617551989674581, 26.822726030878869],
              [95.611071876431367, 26.814087037901537],
              [95.598701169059282, 26.81512749220731],
              [95.591862664534489, 26.815963848059077],
              [95.584318541189646, 26.815722667389924],
              [95.57436906955428, 26.818645528554924],
              [95.568151835052021, 26.822911551227229],
              [95.565250309100691, 26.82680227927429],
              [95.562346491304325, 26.830242831037438],
              [95.554408784935546, 26.83261819815041],
              [95.545344560292278, 26.830934121206102],
              [95.532438693714226, 26.824298298471483],
              [95.529905496258607, 26.81988276653583],
              [95.524646418890811, 26.81304024068568],
              [95.519901393875784, 26.80863319156618],
              [95.514460578465616, 26.806301980230437],
              [95.506147150047823, 26.789721493321139],
              [95.501769915354103, 26.775832933048161],
              [95.495495011143603, 26.76501975566131],
              [95.488721187087876, 26.754750420265065],
              [95.483064461842133, 26.748086247532761],
              [95.475415129672072, 26.745491520099282],
              [95.465254480935172, 26.743535182897428],
              [95.461015267151723, 26.739122175772639],
              [95.458072390516563, 26.730826557727102],
              [95.453731913866918, 26.725602284875322],
              [95.44587620881407, 26.720569248048943],
              [95.441537147008603, 26.715977273200565],
              [95.439310976488315, 26.71110897746302],
              [95.436887216780121, 26.707594682149391],
              [95.435059348569538, 26.70136888053711],
              [95.431927676565948, 26.696684465862592],
              [95.42840166782473, 26.693172325574889],
              [95.422862087647474, 26.689846808046369],
              [95.405980989559922, 26.689796108831956],
              [95.394206405424171, 26.684228287650456],
              [95.383144454053607, 26.681272755884955],
              [95.377707156637285, 26.676590711046988],
              [95.371065055244557, 26.672542646399229],
              [95.365432619308876, 26.670839647446243],
              [95.355385166356868, 26.670407288396365],
              [95.346242630793697, 26.671238704556472],
              [95.324019462630929, 26.662433181729888],
              [95.317482782510211, 26.660186730164806],
              [95.308021050444879, 26.651085976414247],
              [95.30218981499489, 26.649379273694784],
              [95.298880927035796, 26.651732109180017],
              [95.292756199142175, 26.654631409921389],
              [95.282512467629672, 26.656270947635925],
              [95.271663497218412, 26.656287054765645],
              [95.265642252293659, 26.661351604165706],
              [95.261734249628603, 26.667134874633884],
              [95.261343808379252, 26.67498881939488],
              [95.25974330935513, 26.67986503264359],
              [95.256232054381911, 26.682850436718223],
              [95.250509141123857, 26.685926161195301],
              [95.243676632620023, 26.687470066894548],
              [95.24015752063076, 26.685216576214891],
              [95.23734476213707, 26.679869182216176],
              [95.234222315581903, 26.676639912809346],
              [95.231392905359399, 26.671178363250462],
              [95.227778445429905, 26.666635200720929],
              [95.224445166485083, 26.661093762377284],
              [95.219174897954076, 26.654231312354256],
              [95.214547135282359, 26.649253986099012],
              [95.209537827971474, 26.645096155505016],
              [95.205868829835879, 26.642718385501855],
              [95.196690726526199, 26.640978855617476],
              [95.190970685968239, 26.641346145997741],
              [95.181735970822629, 26.636895130049673],
              [95.174012607928674, 26.627813639652043],
              [95.171115424758156, 26.623709869083662],
              [95.158015505262455, 26.616883943757255],
              [95.154422951656969, 26.613150145416856],
              [95.153415752843216, 26.603234437278385],
              [95.152151949752593, 26.595489987031137],
              [95.151864686497817, 26.591251611427573],
              [95.152687411573808, 26.587263850164419],
              [95.15586250606124, 26.580438720581384],
              [95.154131011900503, 26.574416856540498],
              [95.148379994714702, 26.568190630315783],
              [95.14412857847293, 26.561489365710909],
              [95.144027055424829, 26.556614084115456],
              [95.138154224119177, 26.554092366128174],
              [95.133473874008459, 26.555975306219924],
              [95.12644598515439, 26.556000245551221],
              [95.124321438345234, 26.550255855969411],
              [95.120935909737241, 26.546607817412699],
              [95.11441151448102, 26.541657682471154],
              [95.118658737872479, 26.533281381007352],
              [95.120362659816848, 26.528106596646534],
              [95.1203680921151, 26.52341159632623],
              [95.112716666564211, 26.512337444976318],
              [95.106430922599543, 26.5090988470978],
              [95.103066946959544, 26.50653392884519],
              [95.104196524775602, 26.502723653737785],
              [95.101970694564443, 26.496800295533223],
              [95.095554391200082, 26.492117461542584],
              [95.090560036744449, 26.488224995728128],
              [95.087472102303678, 26.484301901422256],
              [95.083564890632104, 26.47957683712886],
              [95.079972938659637, 26.47539102354958],
              [95.075575815732876, 26.471307212707394],
              [95.074990034919466, 26.466982614275178],
              [95.071500891995328, 26.463065108404013],
              [95.068338022190289, 26.460316393914578],
              [95.066733750392345, 26.455194887992914],
              [95.065837871687108, 26.450422789808858],
              [95.065911428872397, 26.444008460490721],
              [95.071227650628458, 26.444015925511799],
              [95.07457670079684, 26.446037742434385],
              [95.081113918546293, 26.446836278679175],
              [95.086504375282743, 26.445576143558057],
              [95.090022282110283, 26.440824189170129],
              [95.096285440495905, 26.432957414176233],
              [95.099425286130256, 26.42956473374467],
              [95.100964710379685, 26.426200109583267],
              [95.105623369251333, 26.423506485874281],
              [95.108105185364806, 26.417233615409877],
              [95.107104895444465, 26.41228319662709],
              [95.105225097307965, 26.408522071406896],
              [95.104844822030302, 26.404554143408511],
              [95.104353115939617, 26.399955857287768],
              [95.104147140321373, 26.394723867462073],
              [95.121027297205956, 26.391468998743296],
              [95.124382904883291, 26.388886499382433],
              [95.130199954399998, 26.384004355660128],
              [95.135057044035037, 26.381216656709189],
              [95.135263263649549, 26.37660801357584],
              [95.133908810441142, 26.369042964980231],
              [95.13122255570056, 26.360056485665584],
              [95.129024158707693, 26.355398494200863],
              [95.127571449921575, 26.348017100685773],
              [95.130916479293077, 26.339834460708516],
              [95.132740803539008, 26.335923142002475],
              [95.126796140487244, 26.329245574240076],
              [95.127290299183429, 26.324000467931342],
              [95.127984923979923, 26.318662235269457],
              [95.12861218614853, 26.314948682819974],
              [95.129123733894886, 26.310515018618766],
              [95.130430363273447, 26.300651382962464],
              [95.130733125953768, 26.295861074330592],
              [95.130012114334036, 26.289822008226807],
              [95.130330752485733, 26.28575324590253],
              [95.128953306099248, 26.281982108017448],
              [95.126274090407662, 26.27823283622002],
              [95.120452519740226, 26.272639379235592],
              [95.119862865338874, 26.268134324351028],
              [95.121841486741346, 26.261960196378311],
              [95.124056488373782, 26.25750068366775],
              [95.127880359477032, 26.253464514519571],
              [95.128799760138392, 26.249384274347683],
              [95.12742626266818, 26.245795182890792],
              [95.124889687570146, 26.239063484541649],
              [95.122020421360162, 26.235768957800151],
              [95.120340629839774, 26.23191456277593],
              [95.122229871381961, 26.22619351018897],
              [95.127464149352164, 26.222678160102596],
              [95.132292450410063, 26.21880647205704],
              [95.139650588574582, 26.211279559340646],
              [95.141572512640991, 26.207366234584711],
              [95.137268272661359, 26.202379780105296],
              [95.133234882879719, 26.20081896731482],
              [95.127339482338826, 26.196310604323333],
              [95.123705621470833, 26.189777447933512],
              [95.126755119868946, 26.187108931811331],
              [95.124828967221873, 26.175851336333583],
              [95.121999095994127, 26.169485923157186],
              [95.119216258092067, 26.165377863978399],
              [95.117048854604192, 26.162070253168295],
              [95.115830207052042, 26.156130253961216],
              [95.119475071201478, 26.148214294202425],
              [95.122758576811506, 26.142201981817621],
              [95.126817360129081, 26.130035125664694],
              [95.124303185995075, 26.124386781093598],
              [95.122129826395877, 26.120719328003581],
              [95.119817865244116, 26.115067711806862],
              [95.119474233970735, 26.102791383705672],
              [95.122164653489335, 26.097239958072898],
              [95.125600436149298, 26.094023370862438],
              [95.130385271098334, 26.09331242041857],
              [95.136931436384771, 26.09555268812279],
              [95.143096875864899, 26.093918568488156],
              [95.146836738800403, 26.090876741188445],
              [95.150476802598916, 26.087836307166651],
              [95.156302178226269, 26.089094854096867],
              [95.164758349694907, 26.09193710014781],
              [95.169812755342761, 26.089684370973824],
              [95.175820762192757, 26.085160715429453],
              [95.178969853822281, 26.082671649168979],
              [95.184165814262215, 26.07752796059631],
              [95.18447692854798, 26.073186239651157],
              [95.182358925100942, 26.067352408688354],
              [95.179093010132519, 26.064156980405034],
              [95.176317305102287, 26.060409419186133],
              [95.171802263618645, 26.054614462189651],
              [95.166823623497805, 26.050632838335222],
              [95.164335485094142, 26.046248540959297],
              [95.163957706383528, 26.037404826571208],
              [95.163741334953386, 26.031719290098845],
              [95.163464365041804, 26.027840816226089],
              [95.161392753064732, 26.024262095474086],
              [95.147647806606514, 26.011665368519111],
              [95.141393067798148, 26.003729578478335],
              [95.139407012095162, 25.999337090822696],
              [95.135364150543424, 25.997054332258191],
              [95.130287719745525, 25.992982889321322],
              [95.126696299019486, 25.988164459262887],
              [95.116255491143576, 25.980657413971635],
              [95.108826122437762, 25.96858723392203],
              [95.105181454339146, 25.961058327594134],
              [95.092064778997923, 25.9544061216709],
              [95.087196200223957, 25.950509954154107],
              [95.07767605271907, 25.943798602840065],
              [95.072149126520188, 25.941988084163768],
              [95.064232728484129, 25.94066937376466],
              [95.056131324188783, 25.939984948105831],
              [95.051790170249106, 25.93752428324369],
              [95.048692666634281, 25.932244607952043],
              [95.043615063543783, 25.927807997564855],
              [95.035430029732893, 25.928116032363793],
              [95.034562630182506, 25.924517932018322],
              [95.035078416797035, 25.920083002666534],
              [95.031832126181499, 25.917426015435087],
              [95.026754140193816, 25.9128988415872],
              [95.020577877805025, 25.903060040848871],
              [95.018798059270225, 25.898752846173132],
              [95.018011680730311, 25.894068978149097],
              [95.018986257206649, 25.887551050763268],
              [95.020852924607723, 25.880567863879968],
              [95.017705606390052, 25.877816840063069],
              [95.014233787010255, 25.873716053453428],
              [95.014071699051925, 25.865050069033646],
              [95.01688742951437, 25.86085199302692],
              [95.020068931511929, 25.854841951334219],
              [95.022997924584843, 25.851454352029698],
              [95.026158985071788, 25.844452389181431],
              [95.031851897954255, 25.839488050241251],
              [95.032811017812534, 25.826827816869816],
              [95.033374757704138, 25.819775529781719],
              [95.036043693257966, 25.813140179568588],
              [95.038875270439533, 25.809935836741861],
              [95.042390446787365, 25.805906936249677],
              [95.047920079325806, 25.802930791121529],
              [95.050320604602504, 25.798018053074045],
              [95.050006308497345, 25.791970404089792],
              [95.04609753138908, 25.780562095960743],
              [95.044009428301806, 25.775629267272965],
              [95.04412920581035, 25.771471962284348],
              [95.05100527004042, 25.755469114031797],
              [95.042850932086111, 25.746113533519306],
              [95.039151975931063, 25.740391818220164],
              [95.032157243063963, 25.734269972798145],
              [95.025661669490916, 25.733466233275887],
              [95.017346878322627, 25.731336209681878],
              [95.007878513265567, 25.731393461523922],
              [95.000890160127184, 25.725537817675097],
              [94.997787371724115, 25.719534230944575],
              [94.997196918415312, 25.714576955985091],
              [94.991675862440474, 25.707165493165405],
              [94.987493142254664, 25.701991516658808],
              [94.982122534543109, 25.697194142925863],
              [94.978391010444028, 25.694812488974531],
              [94.97475893924593, 25.69242936352876],
              [94.97161978191366, 25.689676843510931],
              [94.952244942339306, 25.676421776150221],
              [94.941334999320361, 25.668273538868],
              [94.936040177497745, 25.662031309685606],
              [94.933568577824119, 25.657551942158968],
              [94.932610621975201, 25.654043732912484],
              [94.931089455725001, 25.647022082671334],
              [94.928266896184823, 25.639658409021933],
              [94.925068854602259, 25.633564401528954],
              [94.923925400992786, 25.625360525714626],
              [94.920697814072298, 25.617462084044657],
              [94.919329595200253, 25.607816632096252],
              [94.918069178686096, 25.604132489392136],
              [94.915616057106263, 25.600647104797059],
              [94.909863288872728, 25.596306802273247],
              [94.901857898483328, 25.594073917670443],
              [94.894134800919275, 25.591026963172617],
              [94.887379362821633, 25.586157062337318],
              [94.886087709989184, 25.580666191997807],
              [94.890270677040306, 25.575096491763251],
              [94.895465392920485, 25.570415139498696],
              [94.902521458982989, 25.564169118075927],
              [94.903346875522274, 25.560093887270813],
              [94.88619467842841, 25.55844641808395],
              [94.855896635685554, 25.556442329610203],
              [94.851416091481653, 25.556416727640734],
              [94.841830253634896, 25.548875585527504],
              [94.835268994809667, 25.54363866284098],
              [94.832319051070243, 25.539888308009587],
              [94.8281965014462, 25.531544785162279],
              [94.828002929327624, 25.526128894368178],
              [94.827223005465754, 25.521262933140999],
              [94.823717796073922, 25.514085761507062],
              [94.820471351671173, 25.510338960480656],
              [94.818620012557076, 25.506841664502485],
              [94.817010739102244, 25.500001817222788],
              [94.81391006875397, 25.493088992595968],
              [94.810847143652168, 25.488525076838762],
              [94.804247882439029, 25.486541032779193],
              [94.795499284912609, 25.486931658675704],
              [94.7881951836643, 25.484413730459885],
              [94.782905739535053, 25.483401915154705],
              [94.777334383206963, 25.477517317474824],
              [94.771117211512092, 25.474532319306384],
              [94.765465558085694, 25.475693933940782],
              [94.762929016936269, 25.478707971049239],
              [94.76074252490703, 25.48478908247197],
              [94.755080545477497, 25.485318061589648],
              [94.753819024024963, 25.481180051126653],
              [94.749950344148914, 25.475812763176705],
              [94.744920508143778, 25.472449410661419],
              [94.737620933762514, 25.470109071729787],
              [94.729331951474578, 25.46805309176343],
              [94.720242156080701, 25.465824528225639],
              [94.713058875037547, 25.464386141222199],
              [94.700883836864662, 25.462017088817703],
              [94.694112292455557, 25.461565254034483],
              [94.68711002408206, 25.458946439996989],
              [94.680897867939279, 25.45318751433113],
              [94.680506230607364, 25.443948109621662],
              [94.678090874027149, 25.435851755976472],
              [94.677543664548722, 25.426375496627013],
              [94.67654893565394, 25.419974029067795],
              [94.674666870386673, 25.414037999050901],
              [94.672210521648097, 25.409643809977801],
              [94.669368618194952, 25.405976589672786],
              [94.65469696220147, 25.402374031771114],
              [94.647600937602164, 25.399844519969779],
              [94.642854322115085, 25.395119625299841],
              [94.638733189775635, 25.385688081176358],
              [94.635668290514602, 25.373894409620892],
              [94.636079757657427, 25.368288111337502],
              [94.63586829994054, 25.361064568968445],
              [94.634345997507964, 25.352594190039113],
              [94.63210454717985, 25.349008999037405],
              [94.629446440815713, 25.344166281058712],
              [94.626605921034795, 25.340227930227883],
              [94.622521435185178, 25.333142625999788],
              [94.619983775902028, 25.329562974184629],
              [94.617336656813421, 25.325440025280049],
              [94.613558036585047, 25.318713078564063],
              [94.611523604390328, 25.315487330598572],
              [94.607919251513025, 25.3070432501029],
              [94.600246222512652, 25.292235126422376],
              [94.597022328749816, 25.282609180663083],
              [94.597198956912564, 25.274658362137895],
              [94.596406373892066, 25.268165861534218],
              [94.597580386707392, 25.260383212565078],
              [94.595447511876131, 25.250474122683293],
              [94.591810204143329, 25.239680216894794],
              [94.590189333390981, 25.230937676579504],
              [94.586999756148799, 25.223390376414716],
              [94.584843004996628, 25.218538420450518],
              [94.583613725378584, 25.209250938118771],
              [94.590308807245719, 25.198961846623703],
              [94.595784549528929, 25.193473764526125],
              [94.599879029753865, 25.188636494157617],
              [94.607062245970241, 25.184480438282218],
              [94.611306461204464, 25.182893119829778],
              [94.615577546611306, 25.183200481583551],
              [94.620859839119319, 25.184670505850693],
              [94.629083336517596, 25.183753304353711],
              [94.632010094456902, 25.18055402430462],
              [94.636291423545885, 25.174900849482977],
              [94.641671890484048, 25.169864586924099],
              [94.645904516239156, 25.167731867232256],
              [94.655797302594692, 25.165708239690314],
              [94.665058176466559, 25.161434335569993],
              [94.675526179473252, 25.158227630492274],
              [94.679237072531805, 25.154477643424961],
              [94.685237471261672, 25.151057045522801],
              [94.691710940331703, 25.152687869122818],
              [94.69668812475382, 25.15379679361655],
              [94.701536932227654, 25.152921942175325],
              [94.706205643124463, 25.146989616149522],
              [94.711598380571886, 25.143033281506046],
              [94.72687644419392, 25.136780812159618],
              [94.733805568595272, 25.135874302150405],
              [94.739902523452045, 25.132450330015651],
              [94.743624539831515, 25.129601159644537],
              [94.74317112936042, 25.119852134369733],
              [94.743634886572707, 25.111716581256118],
              [94.743216017794538, 25.10422466261516],
              [94.743457403197411, 25.094646929498666],
              [94.746045203052702, 25.082869476257962],
              [94.747669665928072, 25.072913907156742],
              [94.74888516836134, 25.068381127497613],
              [94.748510215930949, 25.063598458003483],
              [94.748593501804137, 25.056462356247369],
              [94.747114127728736, 25.05088122244609],
              [94.745587972738619, 25.042230382758738],
              [94.743527309059687, 25.037381277935548],
              [94.742853529003128, 25.032422189290408],
              [94.74081783363323, 25.023055379912027],
              [94.740046787825776, 25.018187492593636],
              [94.737294016014118, 25.013437076929005],
              [94.733008015023202, 25.005635658861401],
              [94.723906631674183, 24.994284468635737],
              [94.711005933179663, 24.986687117716539],
              [94.703613076531838, 24.976575976332395],
              [94.700953378833603, 24.971283512511544],
              [94.699709922941835, 24.961453478653976],
              [94.701614299032116, 24.956549848671763],
              [94.703533530566702, 24.952640977996925],
              [94.706940117299766, 24.94880357282868],
              [94.711351003494116, 24.945943987434156],
              [94.714913833418009, 24.939394225833745],
              [94.716831072422323, 24.93539514223141],
              [94.712427305686546, 24.932472220984089],
              [94.703629856013819, 24.927258422932645],
              [94.699266111386933, 24.92053952142529],
              [94.690738908995158, 24.900870628389097],
              [94.689822217253763, 24.892841437231894],
              [94.686677898001619, 24.88800463321996],
              [94.677444644897832, 24.879904369905002],
              [94.669748271716699, 24.875217666562666],
              [94.659381740144738, 24.870472773797371],
              [94.654570949500254, 24.866648232314692],
              [94.655659097266437, 24.860222103726873],
              [94.653812316443478, 24.855909011830217],
              [94.645876224141119, 24.848151172827802],
              [94.638951056728928, 24.841826018170309],
              [94.635587971353587, 24.835455622709318],
              [94.632520965187723, 24.822395991444058],
              [94.633119183942114, 24.816155760251466],
              [94.632498782236368, 24.807852405141443],
              [94.630164665343685, 24.803999659053268],
              [94.625021202102545, 24.797377626215049],
              [94.622520319312358, 24.788918767769054],
              [94.62304525753602, 24.777891494214455],
              [94.627284004802632, 24.770342658703765],
              [94.630678700237311, 24.765871889868297],
              [94.630957650578807, 24.758009951119792],
              [94.622683052322571, 24.747094415711135],
              [94.61885725618319, 24.742444092304133],
              [94.615315932221122, 24.737157941205339],
              [94.610017457398854, 24.726656452453899],
              [94.60897042147883, 24.722695637461744],
              [94.608464606875486, 24.715203095329976],
              [94.59699222348857, 24.708389410749859],
              [94.588626625368633, 24.704066234140111],
              [94.58215912496199, 24.708029536113337],
              [94.584146626261528, 24.715502546601559],
              [94.583468158371815, 24.723188980526693],
              [94.579336144175954, 24.724504430583707],
              [94.575266214002482, 24.723381217327528],
              [94.572232592461603, 24.718810735320609],
              [94.571093129503879, 24.715210887405277],
              [94.573019093312453, 24.711755708370781],
              [94.574209614883841, 24.705236134968906],
              [94.568271578735661, 24.704766959059928],
              [94.565044417938026, 24.707154390010714],
              [94.560164342547168, 24.711550907706201],
              [94.554343084016452, 24.7124328028756],
              [94.548670720775988, 24.709791978247559],
              [94.544290350697906, 24.700720515701235],
              [94.548427559167067, 24.69281233350388],
              [94.550603435654608, 24.686011538028378],
              [94.54836964021473, 24.668151923272905],
              [94.544790063968293, 24.65970379110999],
              [94.538215923882035, 24.642258129499794],
              [94.529088689479678, 24.625653542578487],
              [94.518396826603961, 24.610063370407897],
              [94.505144490463209, 24.594861194647706],
              [94.500035298559638, 24.589681921325763],
              [94.495836768753023, 24.58611778779186],
              [94.487492070907535, 24.582511508160547],
              [94.48295203800167, 24.575607734372589],
              [94.475896595027791, 24.572436930330209],
              [94.470153637678251, 24.571329309791022],
              [94.463109320394551, 24.568970509825096],
              [94.457165788853843, 24.560185580414775],
              [94.453455397411091, 24.54875370279948],
              [94.44775727237257, 24.536172513291582],
              [94.443064207170039, 24.524933288985917],
              [94.43807899437698, 24.513877063633458],
              [94.43416835140161, 24.509405415082501],
              [94.432723137848484, 24.504542325098502],
              [94.429966088894147, 24.497707861907784],
              [94.427157393297151, 24.486807964443315],
              [94.419126498776862, 24.484007406027185],
              [94.406581657144955, 24.483151878921195],
              [94.401030974020017, 24.481317038269044],
              [94.409082054756567, 24.463161363616486],
              [94.400732628457902, 24.458555468752792],
              [94.398031844363089, 24.455602994925052],
              [94.405519765923628, 24.447300409472],
              [94.406477371255761, 24.437623361460329],
              [94.405026239108437, 24.424720744834151],
              [94.401439952016119, 24.414643612364159],
              [94.396700098980332, 24.406653952941081],
              [94.389161091584029, 24.403213959737933],
              [94.380948530374354, 24.401135956071723],
              [94.371938239410298, 24.39834306731473],
              [94.364344322415334, 24.398153200514216],
              [94.362900482857711, 24.393289511690135],
              [94.373855612389519, 24.386395816594163],
              [94.383610746655052, 24.378160677352305],
              [94.380881587561746, 24.372950191422682],
              [94.375056635388361, 24.364613112200576],
              [94.366853268894417, 24.355485455134858],
              [94.353252171304177, 24.340092832661909],
              [94.34925145718087, 24.33561980708712],
              [94.344588438826918, 24.333048735546082],
              [94.332354638788019, 24.332274237223519],
              [94.32388423619993, 24.332633820428697],
              [94.322741234981919, 24.327858920317933],
              [94.324372212173799, 24.324319309162892],
              [94.32540944105439, 24.312653735726908],
              [94.325741285331119, 24.299732212512222],
              [94.325472276751682, 24.286091723238474],
              [94.319258208528012, 24.26962441497194],
              [94.312260867597288, 24.253437065498215],
              [94.310712805931203, 24.24776100998918],
              [94.301251429176574, 24.23918686258871],
              [94.292614195109877, 24.233584945710579],
              [94.28906205570847, 24.216817724157487],
              [94.285103224498627, 24.207008804150881],
              [94.28251268953133, 24.196376066736615],
              [94.281889015282729, 24.185361481579061],
              [94.281156195820969, 24.173623072899407],
              [94.277171733821888, 24.169688077781462],
              [94.263936676448452, 24.166027070931317],
              [94.260143228028682, 24.161549515974045],
              [94.257539949625738, 24.14955872751565],
              [94.255418763305912, 24.13675287488697],
              [94.256467435932151, 24.125449601747],
              [94.256621725363161, 24.113612423560795],
              [94.254104608533822, 24.100447682703955],
              [94.255716910839169, 24.095370999395211],
              [94.257424384979515, 24.090025533000503],
              [94.257051236847374, 24.083342232323709],
              [94.251400712333748, 24.071472827794903],
              [94.247579720699164, 24.064284358940963],
              [94.244535283745222, 24.056363538321868],
              [94.237296458859106, 24.059777934586812],
              [94.230424806234083, 24.060750065775082],
              [94.232590563262477, 24.052507402485062],
              [94.240923126192016, 24.041763380696587],
              [94.242648800643607, 24.038043445848899],
              [94.228913328645859, 24.015321066822096],
              [94.222929191930916, 24.00797227329997],
              [94.217626153252837, 23.999891816126297],
              [94.212710981797954, 23.99135736642895],
              [94.207638292277935, 23.986257766280026],
              [94.198629412233828, 23.971888854197129],
              [94.191799024381268, 23.958945010122584],
              [94.190857062346225, 23.945129564359359],
              [94.19411803303602, 23.937962411510323],
              [94.193260292433308, 23.931645902464997],
              [94.187716562953014, 23.927995349255045],
              [94.17911313411787, 23.931779705611326],
              [94.17421069190199, 23.932821756981888],
              [94.16807848491267, 23.929083357398881],
              [94.16682700215587, 23.922682593287185],
              [94.16550501680986, 23.883122414768316],
              [94.162290627731537, 23.85884874422165],
              [94.158720000227717, 23.846774550587682],
              [94.152716358118468, 23.845477417871223],
              [94.144420551167414, 23.850160070972482],
              [94.1365628846562, 23.849961686056613],
              [94.132431219229417, 23.840152315541648],
              [94.12611357028689, 23.836866421714337],
              [94.119927810408228, 23.836832648887011],
              [94.112077598834233, 23.846571086869304],
              [94.111442606931121, 23.860763282127206],
              [94.10893527986002, 23.865031206362314],
              [94.101537162955012, 23.871331646767246],
              [94.098323066563637, 23.883195247365684],
              [94.0934624866143, 23.887757676575731],
              [94.087969800937458, 23.8887097244838],
              [94.082848638418625, 23.887400052871619],
              [94.073123889868313, 23.887304220830025],
              [94.065881970629263, 23.889897869561121],
              [94.058337093407147, 23.891590778289842],
              [94.054018035853645, 23.891899055717477],
              [94.048546003215179, 23.89474739176563],
              [94.046750571122516, 23.901719202317199],
              [94.04435512827088, 23.907703066554266],
              [94.040670333728855, 23.912341948141108],
              [94.035390305097408, 23.91491580521404],
              [94.03157495449031, 23.916484622079174],
              [94.025227750099944, 23.920424467412261],
              [94.018995258199737, 23.925898493052156],
              [94.015187931902474, 23.928369677033537],
              [94.010870036206924, 23.928946882148178],
              [94.005552127170148, 23.927636159209491],
              [93.999047154019635, 23.925614328000538],
              [93.992961742266402, 23.926024719001298],
              [93.987168724452061, 23.926525162554942],
              [93.979124093438671, 23.927765563453352],
              [93.973935355587273, 23.929796265098759],
              [93.966947324516141, 23.928497157677679],
              [93.959807220125327, 23.931717485117392],
              [93.959374097250148, 23.937955132496803],
              [93.957539560899136, 23.941492748342711],
              [93.95138160283534, 23.944795237807085],
              [93.939222388730855, 23.947420039093888],
              [93.933428983066918, 23.9480084990054],
              [93.92401557431495, 23.950071209807966],
              [93.918623317321462, 23.951466521317261],
              [93.911554283382173, 23.95215584110143],
              [93.904672192353303, 23.951846027247072],
              [93.899744856553241, 23.950348758247685],
              [93.893743510796597, 23.949581784029824],
              [93.888705096888415, 23.94654713724702],
              [93.884736593396866, 23.94224164743839],
              [93.879229302188136, 23.941920934978221],
              [93.874707769375973, 23.941685221532985],
              [93.870849062219961, 23.938731721847351],
              [93.863917935620051, 23.932731127437691],
              [93.846332254923112, 23.932950721543452],
              [93.835277919468453, 23.926977183575101],
              [93.825938060897428, 23.926322765592897],
              [93.813742609787013, 23.924784074676822],
              [93.805813342326019, 23.928092566382901],
              [93.803490590322994, 23.932354189128866],
              [93.803080915445392, 23.94220463863471],
              [93.801342981240211, 23.946102241940807],
              [93.798923348438251, 23.950546808564599],
              [93.795002489525885, 23.951657815999024],
              [93.792103393035816, 23.95782111145995],
              [93.791356170833836, 23.962524708483773],
              [93.783413516139561, 23.964476703323086],
              [93.777191570620602, 23.972921655798348],
              [93.771331254062076, 23.977480330380853],
              [93.768147424778434, 23.985090354588099],
              [93.764468513627151, 23.992072992702663],
              [93.760101857712414, 23.999240047751563],
              [93.754836489397221, 24.00460699892859],
              [93.744506523976838, 24.003681369320301],
              [93.742288195200828, 23.996378074136288],
              [93.737847093771663, 23.994330064977195],
              [93.730691146774689, 23.996997294969471],
              [93.724711556636223, 23.999024211591074],
              [93.718139042220855, 24.000782102407509],
              [93.710664398414721, 24.000469523020524],
              [93.704087915767218, 24.001686517554841],
              [93.694953905765487, 24.002738318942498],
              [93.684450634366883, 24.004972953740722],
              [93.675514888275174, 24.006384978141792],
              [93.672445515144361, 24.003421927438378],
              [93.665545304924379, 24.000753222064979],
              [93.660820420769582, 24.00005993733534],
              [93.656808618523257, 24.002613318054685],
              [93.652994085455759, 24.005347916823908],
              [93.650464005186365, 24.008885560035537],
              [93.642995013386937, 24.009472468710726],
              [93.633356089210793, 24.008807907794083],
              [93.625701751673134, 24.010660105320905],
              [93.618715310061518, 24.009707630957994],
              [93.614364446953985, 24.006210160924915],
              [93.614706342382419, 23.998436346266658],
              [93.618122437469623, 23.994984540944028],
              [93.618781120247661, 23.990734864839908],
              [93.618950803935249, 23.98666784687806],
              [93.613967520913022, 23.97693973930193],
              [93.610303533049958, 23.97262315630433],
              [93.607329849601626, 23.968935590707758],
              [93.601503509292797, 23.965085489521165],
              [93.595199445641697, 23.962770606268226],
              [93.590683838135163, 23.963519359615333],
              [93.581940195494454, 23.964019862766662],
              [93.578119717414339, 23.96584981931769],
              [93.575221330764464, 23.973454192860341],
              [93.570537403610771, 23.978811920573129],
              [93.566936540964917, 23.984251609125256],
              [93.561634451864933, 23.98518362681294],
              [93.559348889932181, 23.98122146465764],
              [93.555377927144505, 23.975279886901106],
              [93.555612096726804, 23.965701246983706],
              [93.553025252284129, 23.960837791603485],
              [93.544463151024416, 23.958894688031389],
              [93.537586516089419, 23.958932998406461],
              [93.528627335497532, 23.956450740021236],
              [93.522301357692271, 23.950429515550674],
              [93.517556407553428, 23.945755835159563],
              [93.513214021424758, 23.942888115861017],
              [93.506837458991782, 23.944636071404599],
              [93.500687935033525, 23.951533923513608],
              [93.494112913999473, 23.952922021110652],
              [93.487554167504925, 23.957292968446772],
              [93.483953869785182, 23.963363367774125],
              [93.47620254601064, 23.965298591035367],
              [93.470409653691675, 23.966502195720714],
              [93.467087471380594, 23.969770205345274],
              [93.464366168337335, 23.975023459378704],
              [93.464905566902416, 23.983423208194402],
              [93.465617491993967, 23.987846338037965],
              [93.465266257585682, 23.99507704555041],
              [93.461358359407413, 23.99943277972778],
              [93.45706695742463, 24.005505585001121],
              [93.455622316873303, 24.010933246978308],
              [93.451537841310738, 24.018722711859944],
              [93.442322488624612, 24.023645771538249],
              [93.439411592145206, 24.030614875902533],
              [93.438280039452195, 24.039474327408239],
              [93.431200526210787, 24.057575913790291],
              [93.423090907445854, 24.067641956143106],
              [93.418590917945892, 24.071998879823429],
              [93.413788270485981, 24.075184068011875],
              [93.40888109908586, 24.077644687719495],
              [93.402601554422674, 24.08029279021655],
              [93.389537357378799, 24.084235286246685],
              [93.381773636743432, 24.085352968141802],
              [93.368902347144072, 24.088297668914191],
              [93.364871517916185, 24.089037992990395],
              [93.359989348867174, 24.096285327068557],
              [93.355212090841746, 24.105159915178863],
              [93.349914153814879, 24.108522795327108],
              [93.345391307629498, 24.109084210913412],
              [93.347517613724492, 24.10121479806833],
              [93.349371083977857, 24.097684592470991],
              [93.352304325017258, 24.093787925592487],
              [93.345293477140203, 24.088394733735115],
              [93.342055643214081, 24.090486893434544],
              [93.337820179849388, 24.089329264940716],
              [93.332495131832545, 24.086277419345965],
              [93.334437496612551, 24.081121767019106],
              [93.336081438971704, 24.075062000297685],
              [93.337330540242775, 24.068460951036208],
              [93.34045271801719, 24.063568879839906],
              [93.335800633393518, 24.057083734774658],
              [93.334796791481537, 24.052841323763509],
              [93.335822483652436, 24.049541116170392],
              [93.336732529693336, 24.046327987924684],
              [93.340640732201678, 24.040712468748108],
              [93.334437359101074, 24.03874905017673],
              [93.331669912365825, 24.035958308442147],
              [93.336068264038687, 24.030341251209428],
              [93.340575563209526, 24.026799280073313],
              [93.335332405450544, 24.019953784684212],
              [93.336198020649519, 24.016064881883885],
              [93.338719636753325, 24.008556463613814],
              [93.337649568679097, 23.998343860637451],
              [93.337364106353562, 23.992027277456014],
              [93.332799766593311, 23.983101290471708],
              [93.335827836685965, 23.978934393632418],
              [93.340738578245237, 23.978461960737619],
              [93.345744805235185, 23.976815897000286],
              [93.349957002375334, 23.974087573435614],
              [93.35150143144871, 23.968120237823705],
              [93.354200255305912, 23.957357725084762],
              [93.358198256406027, 23.950743908127112],
              [93.360733465223163, 23.946848570390468],
              [93.36326451919463, 23.942050386685629],
              [93.366101971956169, 23.939509074078956],
              [93.369329485409708, 23.936603798153048],
              [93.374032453197813, 23.933875142967754],
              [93.379526201753421, 23.93222389145695],
              [93.389242534825499, 23.930013238591176],
              [93.39698457091778, 23.926276798145025],
              [93.397838212793431, 23.92039949998864],
              [93.39741801298463, 23.914979758636196],
              [93.395814554719649, 23.908934473734394],
              [93.394955854736807, 23.894664027632778],
              [93.393816981343704, 23.883283187399048],
              [93.393664101385184, 23.872713507778013],
              [93.394616069485323, 23.866928173706597],
              [93.395071715420428, 23.859787024189512],
              [93.394748253573056, 23.854549457882637],
              [93.394904409811573, 23.846689182905386],
              [93.395247306064647, 23.836930195696819],
              [93.398262881277631, 23.831314293611769],
              [93.397321464808527, 23.820205123072764],
              [93.399555033988392, 23.815407395906849],
              [93.405040575343222, 23.813124849657243],
              [93.407964851943774, 23.809587383259789],
              [93.409113352379165, 23.803708640950859],
              [93.408181875513904, 23.794769937975559],
              [93.405683854777138, 23.786197648163565],
              [93.402562512707178, 23.771033485809223],
              [93.402335246940282, 23.764980283182982],
              [93.403375941311509, 23.757566652740202],
              [93.405208644058888, 23.751595242163333],
              [93.4086065680508, 23.744622228254755],
              [93.41250214171022, 23.739455160166951],
              [93.413458300849911, 23.73439218042942],
              [93.415779728243166, 23.728508780639562],
              [93.413885930748421, 23.722824957144006],
              [93.41298242700185, 23.718582353626584],
              [93.4135473738516, 23.714063686565424],
              [93.414985282557581, 23.708093857764126],
              [93.417123670337844, 23.704379147602278],
              [93.421317142086622, 23.699933220824832],
              [93.427577215938555, 23.6966514084924],
              [93.434515120043486, 23.692101256422141],
              [93.436651394353675, 23.688116114323456],
              [93.439374689250144, 23.684218607605754],
              [93.442676849519714, 23.678330431938512],
              [93.43892735832236, 23.674102591131657],
              [93.43408899302176, 23.66770875401123],
              [93.431416153078928, 23.663113693156671],
              [93.4283380979806, 23.656169795256492],
              [93.426244429158558, 23.649494020766884],
              [93.42659119944723, 23.64109023901382],
              [93.430662361020339, 23.61468862206511],
              [93.431318189692377, 23.591014280535774],
              [93.432657212756624, 23.58477202267397],
              [93.430956780424097, 23.578367183246336],
              [93.425018721540127, 23.567641637558207],
              [93.421870880629584, 23.565306543035028],
              [93.421927775914639, 23.557536587427286],
              [93.42511635656669, 23.548938414206845],
              [93.425954280509558, 23.541163050588288],
              [93.425624229244917, 23.53420741870465],
              [93.425504909084893, 23.530324265393347],
              [93.42343082577321, 23.527171966878583],
              [93.419784622840979, 23.523121073949319],
              [93.414070347664804, 23.516462387068088],
              [93.409037379778042, 23.509255934741958],
              [93.405486516182535, 23.504483903691582],
              [93.405157204421087, 23.497978680309856],
              [93.406009498272709, 23.492463736303815],
              [93.402229397585458, 23.481005744387872],
              [93.403774918727194, 23.477023488659423],
              [93.404921686681035, 23.471327137093006],
              [93.403801707712674, 23.46328962841044],
              [93.399244916310181, 23.453010028512672],
              [93.397627753523594, 23.442898547665788],
              [93.396335034921961, 23.438927670622451],
              [93.395010974055253, 23.429355555887348],
              [93.395170010284474, 23.422217926980814],
              [93.394662155628552, 23.418516345279091],
              [93.395409774013487, 23.411554126134213],
              [93.396072779532105, 23.407305314703137],
              [93.401698801763402, 23.39770285677303],
              [93.403538134048674, 23.393629257173856],
              [93.407518303236756, 23.387919337354663],
              [93.411999540105867, 23.384012671384443],
              [93.402387439593227, 23.379537813226634],
              [93.399432004678033, 23.37557599593443],
              [93.394218401456669, 23.3700877123791],
              [93.394285262700677, 23.364123446480765],
              [93.3965157288592, 23.360318618460564],
              [93.387605225128993, 23.358823241229736],
              [93.374106740761391, 23.35870026694834],
              [93.369397339513682, 23.355919911502664],
              [93.365278125251152, 23.354220227316759],
              [93.363598847108321, 23.350612996657087],
              [93.365826737500569, 23.346085910473636],
              [93.369807107171425, 23.340376991250217],
              [93.373117944321152, 23.337108559332748],
              [93.375545360741668, 23.333665835617587],
              [93.377085667886604, 23.328778772769553],
              [93.375296121238961, 23.322914043255462],
              [93.37447775226785, 23.315600131553943],
              [93.374737210928345, 23.308912476496523],
              [93.375391260630522, 23.302675764015735],
              [93.377514044528425, 23.297334012875268],
              [93.378944082003002, 23.289738874368119],
              [93.378924443149828, 23.286033181152067],
              [93.375975528999163, 23.282883694818164],
              [93.373119805333204, 23.278740936402933],
              [93.372785740895111, 23.270700263884088],
              [93.374982549695559, 23.260299272459651],
              [93.376115320664809, 23.252252891144401],
              [93.380946172991671, 23.240938794458174],
              [93.386077506219223, 23.231066390694458],
              [93.392373546687693, 23.220376661835886],
              [93.392448874270102, 23.215677588069884],
              [93.38507765908939, 23.207306902270027],
              [93.384248141369952, 23.198095361571077],
              [93.382906830107444, 23.184094786300076],
              [93.379130310594789, 23.171010986843264],
              [93.378209684120904, 23.163062810959328],
              [93.375751659229039, 23.159638935627164],
              [93.373675638854763, 23.155040837048929],
              [93.371581687198315, 23.146466738811789],
              [93.376724558470798, 23.139757983301859],
              [93.38053959333277, 23.140825944511981],
              [93.388272172303473, 23.144044110637655],
              [93.392063259198935, 23.14050335579396],
              [93.391252246365212, 23.134725112696046],
              [93.379574127213274, 23.123660781297779],
              [93.373698973046601, 23.120162429878647],
              [93.369883452534765, 23.118824151040084],
              [93.366651220133932, 23.11675849627234],
              [93.362627306910412, 23.112890353411309],
              [93.361631194412624, 23.108920549626092],
              [93.3615996029652, 23.102414214490871],
              [93.360691127990265, 23.096273694862372],
              [93.359594457487404, 23.09157924980563],
              [93.354985063145833, 23.087170408474105],
              [93.350073355518745, 23.080867012947884],
              [93.348684394311704, 23.076536199427622],
              [93.355798721382612, 23.07415697984819],
              [93.354994811351105, 23.069008757580313],
              [93.350563153831644, 23.061075907388624],
              [93.342755305767383, 23.061019207842229],
              [93.338220268113659, 23.051458579237774],
              [93.334358768455672, 23.039909852810268],
              [93.330223728423533, 23.031975269910163],
              [93.327178036776147, 23.027920379293644],
              [93.321682090389331, 23.021255779583985],
              [93.318838180261537, 23.018195021910241],
              [93.312595842973593, 23.018491458624876],
              [93.30935902495159, 23.015069488380458],
              [93.303776379926134, 23.010032142153136],
              [93.299557335418953, 23.004717657624312],
              [93.295349674157578, 23.002203736942068],
              [93.290956724605095, 23.001405630052414],
              [93.285785170276711, 23.001064811802799],
              [93.2762265641027, 23.002093514164873],
              [93.271562538295797, 23.006719283869934],
              [93.265718836673287, 23.008818009005338],
              [93.256726510037396, 23.005237525542881],
              [93.250864381837076, 23.002997475050524],
              [93.245413278084996, 23.006089431580442],
              [93.238894404526405, 23.010629715759912],
              [93.235492076025764, 23.014165517819897],
              [93.231800191375854, 23.018424726307867],
              [93.229383819246209, 23.023675001663893],
              [93.225890972338377, 23.02937891737006],
              [93.217937237814226, 23.041784037774104],
              [93.211803569272234, 23.045959671302633],
              [93.203926496638232, 23.053485298303936],
              [93.198954303674597, 23.054406128360036],
              [93.192227982116279, 23.056957151208671],
              [93.188705674920115, 23.05488864374913],
              [93.184897407048211, 23.053818005937963],
              [93.180800455067043, 23.054643778954873],
              [93.174535192511186, 23.049693703089535],
              [93.169940229524158, 23.047537408561045],
              [93.16564098387407, 23.045742616992616],
              [93.159793875882784, 23.048652503857273],
              [93.153471778272177, 23.054816313056889],
              [93.145188105790567, 23.058454057933016],
              [93.139718061354159, 23.057384099624322],
              [93.138142155295384, 23.053231897805549],
              [93.134715507713338, 23.050169099815744],
              [93.130795160863627, 23.044308818465119],
              [93.132922249129351, 23.038428058789549],
              [93.133683367188695, 23.032012299180263],
              [93.132205690763925, 23.02803994841296],
              [93.129457388704651, 23.022717341930015],
              [93.13197537720778, 23.016655537321007],
              [93.133610248085375, 23.009693103623736],
              [93.128028530368042, 23.003294182513358],
              [93.127035737917183, 22.997605111557455],
              [93.131215518895772, 22.992894919165359],
              [93.135208066872835, 22.990985703216875],
              [93.140379097151353, 22.990518724514523],
              [93.142796636463387, 22.984549506763894],
              [93.14540741149159, 22.977402143811442],
              [93.145879601702731, 22.972342332315929],
              [93.144302973898121, 22.967647671620604],
              [93.140491644859139, 22.96539861239059],
              [93.140283219270444, 22.961243232163625],
              [93.143976871393463, 22.957981585878994],
              [93.146596460167004, 22.953274525052247],
              [93.149402673162143, 22.946759341896939],
              [93.150348543980527, 22.938265382554349],
              [93.151190087238518, 22.927418939624744],
              [93.154980178208135, 22.923521731074807],
              [93.159457867693803, 22.921250451419748],
              [93.163838905746346, 22.919249404298757],
              [93.166069885861717, 22.915900703606852],
              [93.164205817833718, 22.91265231183112],
              [93.160492722284275, 22.910313508465155],
              [93.156300841819572, 22.910416149515154],
              [93.150058091215243, 22.909713284895751],
              [93.143722483225659, 22.909730567321873],
              [93.136507912403644, 22.910022227060217],
              [93.132977614847064, 22.904069173440071],
              [93.136561991608019, 22.897009914405654],
              [93.136052567363734, 22.890234845273557],
              [93.134871104685502, 22.886444219880122],
              [93.133289449103586, 22.879399136437446],
              [93.130925122289099, 22.872088174576998],
              [93.127984535645083, 22.866313575561762],
              [93.121636897770244, 22.862807025286685],
              [93.119386222744922, 22.859648945466656],
              [93.118580962981952, 22.851701740890984],
              [93.119226351859496, 22.84031366895351],
              [93.118525607585312, 22.834261670283119],
              [93.113344414589164, 22.828401754387919],
              [93.108949925110338, 22.825160492701979],
              [93.11039176388492, 22.819103991527104],
              [93.114286272569188, 22.81782801010419],
              [93.113880949335865, 22.813220762606576],
              [93.106953673895532, 22.809804824371916],
              [93.101982686969308, 22.808734747892757],
              [93.097008531022951, 22.807392260088783],
              [93.100559667336455, 22.789129793560214],
              [93.101734073719541, 22.784085959268285],
              [93.105654531543095, 22.767251134123708],
              [93.109011604110123, 22.749981793736254],
              [93.110348675871109, 22.741215100924673],
              [93.106822935246598, 22.734809158419896],
              [93.102227860669188, 22.728675466264303],
              [93.099586676258923, 22.724435290865308],
              [93.098492261726363, 22.71657652765105],
              [93.096722669949244, 22.71134192581227],
              [93.093111459832727, 22.708098685016839],
              [93.089406956943378, 22.70639085263722],
              [93.095613553573756, 22.698332558793325],
              [93.101829117668586, 22.693166679888481],
              [93.104524154045507, 22.683310039204155],
              [93.104316333786286, 22.678792415224333],
              [93.100803258647119, 22.675729285962117],
              [93.101177562343921, 22.671120534880771],
              [93.102431596490533, 22.667230120494686],
              [93.105041014867226, 22.661169059955942],
              [93.10823736980916, 22.656101713617712],
              [93.112117087380213, 22.651933220453682],
              [93.116095609805654, 22.648489362111189],
              [93.112360611319019, 22.636210946231504],
              [93.114489049270361, 22.632138504560519],
              [93.121867368379284, 22.627059472248114],
              [93.127120004982814, 22.626230330540452],
              [93.133909624254258, 22.619886933824311],
              [93.136617320937859, 22.615180405896293],
              [93.140474865448823, 22.604597907046418],
              [93.141905120972368, 22.595828785222945],
              [93.143127524910739, 22.583082464425594],
              [93.133483822780519, 22.578501680074279],
              [93.131232705041441, 22.574351463388943],
              [93.126747926816535, 22.571473770088964],
              [93.121960420393037, 22.564076216033094],
              [93.11911832263614, 22.557036763299109],
              [93.115322446081194, 22.555962397148189],
              [93.11307229205562, 22.551811939811294],
              [93.114016253152698, 22.542864272438525],
              [93.113513031198863, 22.537534958168834],
              [93.11194543378457, 22.533923227311373],
              [93.109208933776927, 22.528871007706513],
              [93.11736688114496, 22.525775919212204],
              [93.123295798469883, 22.525580444633718],
              [93.128343792053045, 22.523126586481744],
              [93.131142557280043, 22.516972608025725],
              [93.128110128586499, 22.511018870368936],
              [93.126347156108778, 22.506865197345839],
              [93.128086059701374, 22.502975886517362],
              [93.130209157132128, 22.498813535262677],
              [93.132728305070017, 22.496005135552046],
              [93.135241855960174, 22.492111844575259],
              [93.135797602269648, 22.48361750578097],
              [93.133734083401947, 22.476664435971813],
              [93.131969877891194, 22.471880620411326],
              [93.135643474757757, 22.466357213946779],
              [93.139511647049616, 22.460292918238039],
              [93.143189060590856, 22.455491750591353],
              [93.147165734117408, 22.452949759596567],
              [93.154148872385335, 22.449135377600857],
              [93.160178712462439, 22.450743371907517],
              [93.172802862611945, 22.448264377873524],
              [93.175505613409499, 22.44355741290337],
              [93.179559402917192, 22.435684095208302],
              [93.185274991653017, 22.430604118093807],
              [93.188165186131144, 22.424178938616734],
              [93.186402182767438, 22.420208449947697],
              [93.185609148962286, 22.415875271489206],
              [93.186270027892959, 22.410450898698315],
              [93.19159594086311, 22.405824320651309],
              [93.192836979229142, 22.400218432175972],
              [93.19058704486028, 22.396069341465285],
              [93.188826588152978, 22.392821485854395],
              [93.189585258281227, 22.387759334729655],
              [93.193736853259907, 22.381058284512761],
              [93.194694148275772, 22.376898092400516],
              [93.189902184547392, 22.367788132749272],
              [93.191817069541656, 22.360370642528792],
              [93.194420269175879, 22.355573695064262],
              [93.197278310537925, 22.340563511444131],
              [93.19676895500892, 22.334149875319696],
              [93.199958460254635, 22.330613977925417],
              [93.203828289801052, 22.326445701252869],
              [93.20012888846054, 22.324198478930793],
              [93.193614815097149, 22.321598599770088],
              [93.196793657214926, 22.314722450467752],
              [93.197843162657833, 22.310109831768592],
              [93.198594451581343, 22.303057935325139],
              [93.198958940640267, 22.296822078617105],
              [93.198348143472387, 22.288961430727731],
              [93.198811642255137, 22.283447900151838],
              [93.199178100786668, 22.277844594562115],
              [93.201197730075748, 22.2726867338368],
              [93.204571041067823, 22.266622620990287],
              [93.206499035412165, 22.263180106990031],
              [93.205800215203283, 22.258032189297872],
              [93.193651104006122, 22.252650370613441],
              [93.187611438989919, 22.246706743467975],
              [93.180914371978673, 22.246184415819577],
              [93.168204990295251, 22.246766815915596],
              [93.16325555571126, 22.245969021471971],
              [93.157621284504032, 22.244178050054089],
              [93.148794030809157, 22.245199291741546],
              [93.144423063272214, 22.243677083158801],
              [93.143725914810403, 22.238256539639718],
              [93.149234598541014, 22.231823885263509],
              [93.153772164673072, 22.225846002779718],
              [93.154918884730819, 22.220240845837463],
              [93.153541423793726, 22.214552009445931],
              [93.156328305118265, 22.206953237355563],
              [93.163198673868294, 22.202321882810235],
              [93.167060387814601, 22.197160054842112],
              [93.163642976182643, 22.190754089629863],
              [93.160209145600206, 22.179468463049382],
              [93.151661606050183, 22.175339331616033],
              [93.145642738200067, 22.174001429383857],
              [93.135944664034398, 22.173939059288571],
              [93.128000452848084, 22.176311839493611],
              [93.124809467039839, 22.179573809888414],
              [93.120078236206552, 22.186273785600875],
              [93.117197931394841, 22.195769466586881],
              [93.114491049661012, 22.198579968307502],
              [93.108862474456927, 22.19796215821745],
              [93.099544902192662, 22.196089281616239],
              [93.094601045911077, 22.196644254007392],
              [93.08617108221874, 22.199920789321826],
              [93.083269146254779, 22.202456410468159],
              [93.078913914702653, 22.205721962869205],
              [93.074359038601742, 22.207450552225009],
              [93.068920834557531, 22.205565950850236],
              [93.065034832072925, 22.203768291597687],
              [93.057171461195964, 22.201347594983147],
              [93.051253024447803, 22.200640368928138],
              [93.044060236494516, 22.195053226164543],
              [93.041915663994203, 22.191172197394504],
              [93.043943214187564, 22.187463932651983],
              [93.051081466791771, 22.173258115988254],
              [93.052313730338824, 22.162864340737052],
              [93.049381137746579, 22.154105294200487],
              [93.048200610357497, 22.147602840253789],
              [93.045376770037834, 22.143270733121145],
              [93.044291887558444, 22.13613566484295],
              [93.051447434586152, 22.129159272003879],
              [93.056574448662573, 22.124990674793988],
              [93.059949088316088, 22.118295405703982],
              [93.063804577747121, 22.110696760140502],
              [93.062900577003177, 22.099492383162818],
              [93.057079925626255, 22.09724797972218],
              [93.049420219138497, 22.096724055320703],
              [93.043611202394132, 22.098816132769567],
              [93.036544306922195, 22.102447462166815],
              [93.029564174942706, 22.10246380140546],
              [93.020358403547036, 22.103205669032178],
              [93.013377959681804, 22.10304121397596],
              [93.010654814690085, 22.09979328793127],
              [93.010644887652631, 22.095636333141808],
              [93.012959189747718, 22.090661059927474],
              [93.011875240528255, 22.082803449875918],
              [93.00914530196053, 22.076933580218803],
              [93.005441464817835, 22.067545022612805],
              [93.00115711783198, 22.058787454293846],
              [92.998139320055003, 22.053282478584137],
              [92.997352897268527, 22.048041871014277],
              [92.997327197497683, 22.037198581168244],
              [92.998956004908635, 22.029785087473392],
              [93.00580453695737, 22.017572377468543],
              [93.007722168190369, 22.008801137741504],
              [93.006927515400079, 22.000308701451416],
              [93.007492019758672, 21.993439165914165],
              [93.007190484218114, 21.989375274749321],
              [93.006590256744914, 21.981605114357173],
              [93.003964775255199, 21.977542377243005],
              [92.996310028914067, 21.975660929534673],
              [92.989732365482425, 21.97856666701594],
              [92.985377884786161, 21.980654547595769],
              [92.983166772325106, 21.987796189020472],
              [92.979124121638478, 21.999644103071624],
              [92.976905938684467, 22.004166153866585],
              [92.970520427576318, 22.007703321536127],
              [92.966848329174056, 22.011866987429357],
              [92.964342273874067, 22.018016411151631],
              [92.963970781803624, 22.024883204216025],
              [92.958358141587425, 22.027966562463586],
              [92.953223413632003, 22.027704754590939],
              [92.948564165116153, 22.023737927962262],
              [92.945844443601203, 22.02066899394751],
              [92.939538947592808, 22.016163532464887],
              [92.932082733604048, 22.017893026383014],
              [92.929074535233411, 22.015366433986426],
              [92.93313581028346, 22.010570771118829],
              [92.93651686280316, 22.00640833545096],
              [92.929628074827349, 21.999733485473442],
              [92.925161194766957, 21.993776248212388],
              [92.922238391933476, 21.985015594881776],
              [92.919709635032291, 21.978693975913352],
              [92.91688844797406, 21.971740283234663],
              [92.91319216906723, 21.962980236527368],
              [92.911919002079216, 21.954577993699502],
              [92.913551925986368, 21.94734804508423],
              [92.908318521434282, 21.944192947774667],
              [92.903296035413462, 21.951520297078165],
              [92.902179187832587, 21.978720789916778],
              [92.89880530861943, 21.988303995851727],
              [92.893887800658504, 22.001867350625947],
              [92.891768794376162, 22.009912462684945],
              [92.886935008812742, 22.01615457595555],
              [92.883259425053737, 22.019503750361658],
              [92.877066815637846, 22.023939228788979],
              [92.872227718788977, 22.028101439125106],
              [92.870009364338529, 22.0345214171072],
              [92.868860340542184, 22.044643004728179],
              [92.867709400963165, 22.052234848257388],
              [92.867718931309113, 22.058741294954256],
              [92.865302786068355, 22.06335191835058],
              [92.860846995305863, 22.065616367317183],
              [92.854569692125835, 22.063651350057331],
              [92.84659569831318, 22.060393103411844],
              [92.842235659338812, 22.061482106908162],
              [92.842243009497508, 22.066181255644061],
              [92.839047905233173, 22.070069484077543],
              [92.834111990068266, 22.074412739788109],
              [92.830137451414686, 22.074508814458053],
              [92.823261407684072, 22.077767552417789],
              [92.817940441691746, 22.088437156743559],
              [92.81474935902348, 22.093679495626432],
              [92.808062566664688, 22.095765151134636],
              [92.800992052592733, 22.100380132903528],
              [92.792853313846521, 22.104362520891261],
              [92.786457784967453, 22.107077266768528],
              [92.780834782008384, 22.106809670531526],
              [92.775115298341021, 22.107989103711603],
              [92.771431978016764, 22.109258439734614],
              [92.766977734930023, 22.114049668315598],
              [92.767854079340509, 22.121276604638968],
              [92.763397079920495, 22.124532922632],
              [92.749051621680621, 22.130956526483107],
              [92.740909639849974, 22.134213678428392],
              [92.735579461028991, 22.137288881606292],
              [92.730541219220044, 22.14786335025298],
              [92.71570752628034, 22.1509413346384],
              [92.70581784135895, 22.15184842791901],
              [92.70126082993994, 22.152120742046513],
              [92.697185398330191, 22.146699098794187],
              [92.698445026081984, 22.136758482922161],
              [92.697471042654541, 22.120764919847741],
              [92.696792414574873, 22.116609850225728],
              [92.694946117531117, 22.097723845898216],
              [92.695330831972157, 22.084623310996331],
              [92.694747115310165, 22.079291372581842],
              [92.69135656257528, 22.075677101945484],
              [92.689127614803937, 22.079562625540053],
              [92.688449872558465, 22.093207772256065],
              [92.687386493991752, 22.105497724137628],
              [92.684283633327112, 22.107847836200094],
              [92.681665795580784, 22.103781563852586],
              [92.682344115829324, 22.090498769628066],
              [92.683119000460934, 22.083992733160017],
              [92.683600917570828, 22.074956996231514],
              [92.684667767992508, 22.068358761427124],
              [92.685053896281502, 22.061582551262546],
              [92.68408395185017, 22.057065075695942],
              [92.684471142452196, 22.048479295225135],
              [92.687762833692204, 22.039443125682563],
              [92.687278744281784, 22.034203493041471],
              [92.685728794881186, 22.030860445286368],
              [92.686211567330361, 22.027064111605561],
              [92.685048916558586, 22.022366507476587],
              [92.682142030214465, 22.016403019680553],
              [92.678555532212371, 22.012698724289606],
              [92.674585218478285, 22.012608197824203],
              [92.669352025680567, 22.013241618519679],
              [92.661021945802744, 22.014054562104594],
              [92.657049908158811, 22.013333609773824],
              [92.642521859726301, 21.996795778245605],
              [92.638842787610159, 21.990830811595647],
              [92.635743231666595, 21.987308271787644],
              [92.627897276852352, 21.983601012997958],
              [92.615985922249763, 21.980075807758965],
              [92.610176754174063, 21.978989164876598],
              [92.608915705409302, 21.98404912959402],
              [92.61307954644009, 21.984953929439669],
              [92.615693534896351, 21.988478756688941],
              [92.615401372329544, 21.992635127969809],
              [92.610264504679648, 22.001669839070804],
              [92.599992743270789, 22.011063040631186],
              [92.602603004105148, 22.021274515940942],
              [92.605217987967293, 22.026336642728936],
              [92.60385762695941, 22.032931484483523],
              [92.599107900787203, 22.037719657523244],
              [92.598913121736004, 22.042598523156073],
              [92.600170590219363, 22.046484486181441],
              [92.602589348295965, 22.052176764235188],
              [92.602684699413302, 22.056876034479235],
              [92.601132726703426, 22.062025731786569],
              [92.595800912332422, 22.066090739561112],
              [92.59482476136013, 22.078920163189796],
              [92.583958758679898, 22.098522870299],
              [92.58124354404049, 22.102318369238677],
              [92.578717440935193, 22.110176499476143],
              [92.573671070786844, 22.120205292267073],
              [92.56969203467311, 22.125171552709304],
              [92.565037079493166, 22.128241662074636],
              [92.564160228546072, 22.132667481847772],
              [92.569780304912115, 22.138272616553635],
              [92.574915846407919, 22.141982012527958],
              [92.584320442292849, 22.144062575612999],
              [92.592371939678543, 22.139731103399637],
              [92.595088083070678, 22.133858059404695],
              [92.597225833926586, 22.126901552226894],
              [92.600717503032882, 22.124373711120562],
              [92.608567861933807, 22.126543372153463],
              [92.60992128029217, 22.13576130272337],
              [92.612437871687035, 22.146153106112312],
              [92.614277701818708, 22.155099183544593],
              [92.614466085638497, 22.169105371699676],
              [92.612234521320573, 22.173892306090853],
              [92.607576470223179, 22.176781614824289],
              [92.602437370158214, 22.176057738782283],
              [92.599719633309604, 22.180846285290013],
              [92.600685293167629, 22.19078646962879],
              [92.60203878194605, 22.199912402709192],
              [92.600386253846878, 22.206597336845107],
              [92.594755253887556, 22.213012051851308],
              [92.592911313211928, 22.217889211512581],
              [92.592811415007873, 22.223763498731508],
              [92.593098183391675, 22.227828797280978],
              [92.594551305483819, 22.234695183991324],
              [92.593673732078017, 22.239936223409472],
              [92.592695871678998, 22.2546639213842],
              [92.589295599277449, 22.26189141027745],
              [92.585601820033119, 22.271105943304008],
              [92.579871125144479, 22.278692638898306],
              [92.579868035634931, 22.282397476716007],
              [92.582001612835001, 22.28709757457688],
              [92.583256143939195, 22.297396577353002],
              [92.583441236524791, 22.313210957403147],
              [92.581787318260183, 22.31754616262878],
              [92.580518135818181, 22.328388979168363],
              [92.578958386717886, 22.335886756368293],
              [92.57604120352191, 22.345012155892036],
              [92.574286291120174, 22.354859483820871],
              [92.568741289499869, 22.36614897200818],
              [92.565430360588678, 22.378436284290878],
              [92.565519059533045, 22.3880139302386],
              [92.563764612312198, 22.39524129245434],
              [92.560555017927953, 22.401021409439601],
              [92.556946943134264, 22.416106161735538],
              [92.556354427017425, 22.428847606768414],
              [92.555853112882033, 22.444657369581542],
              [92.552248012523322, 22.457124307003696],
              [92.550098084363782, 22.469411234334512],
              [92.549604764541868, 22.478715764562697],
              [92.549690809658756, 22.490643725125391],
              [92.548116304541239, 22.508622165329118],
              [92.547324409357131, 22.523619168766313],
              [92.54312702171741, 22.541778088798541],
              [92.538935660849191, 22.551894208371351],
              [92.534843091122369, 22.557942943961148],
              [92.530171411148444, 22.562547561507504],
              [92.529388299689515, 22.567786557350683],
              [92.530062951851178, 22.572485609320783],
              [92.539296971644333, 22.57710169236902],
              [92.53909548644674, 22.585324267206612],
              [92.538401833622885, 22.596074151315282],
              [92.53498174263278, 22.610166953892392],
              [92.530597478415189, 22.616847548209137],
              [92.526895149061218, 22.621813962807224],
              [92.529224895389191, 22.625881014050123],
              [92.535059512355701, 22.629773614264966],
              [92.53554224846819, 22.633567366980657],
              [92.53252262891003, 22.636365030993161],
              [92.527945763519725, 22.637987377458437],
              [92.527067111037596, 22.642233544763673],
              [92.527052743394222, 22.653527222109922],
              [92.526466031427063, 22.657231414630044],
              [92.526459405741065, 22.661929477144319],
              [92.527429001740813, 22.666086507902975],
              [92.522246904755733, 22.685144529142949],
              [92.520670009957584, 22.701225942525273],
              [92.51783331662412, 22.712334716553418],
              [92.515291401621482, 22.720283527657998],
              [92.510502515443278, 22.735096374662032],
              [92.503286381450124, 22.742406288690077],
              [92.497049567398449, 22.745472091833445],
              [92.490915360849584, 22.745825060694663],
              [92.485654662173943, 22.746269732549376],
              [92.480584148247445, 22.750692302669137],
              [92.47744712873866, 22.76487262272655],
              [92.475572686277133, 22.77968590725941],
              [92.472246766015786, 22.788987645694188],
              [92.469019501133303, 22.796391898165595],
              [92.467058284903501, 22.804248888613632],
              [92.465199479109515, 22.808855459824137],
              [92.461198216121062, 22.812552499087587],
              [92.456515081177415, 22.817065119535158],
              [92.455821017256838, 22.823749639439409],
              [92.456105822648809, 22.828356076542235],
              [92.462728098250068, 22.830715842208555],
              [92.46242722667057, 22.835593519162568],
              [92.45881251796547, 22.840828915775866],
              [92.464748575498277, 22.846980225743867],
              [92.462305146737265, 22.850953009424352],
              [92.459957751285188, 22.855286169108616],
              [92.463065796649317, 22.861886429743866],
              [92.45848165184978, 22.863866787083516],
              [92.457011140682653, 22.869104388017121],
              [92.458659829261251, 22.873443769786938],
              [92.454459155452909, 22.878315421328523],
              [92.451528893894633, 22.882286900196373],
              [92.449181464326145, 22.887252373572235],
              [92.44868422892236, 22.892672188813965],
              [92.443319427214249, 22.89347765675938],
              [92.440887462514269, 22.890491631034202],
              [92.436701710574724, 22.888316386802845],
              [92.429074312228309, 22.900230344118746],
              [92.422324961000271, 22.911331035155079],
              [92.421729578888957, 22.916660489762013],
              [92.415778318500088, 22.918186146356138],
              [92.403895001375943, 22.912745133754576],
              [92.402424049624315, 22.916356991768819],
              [92.401339069406973, 22.922587813802235],
              [92.401814969651326, 22.927829902173698],
              [92.397520112937045, 22.929539102026091],
              [92.389232731920018, 22.929252248231101],
              [92.383869875923551, 22.928790372434921],
              [92.375471449081957, 22.933741132407921],
              [92.375262154843767, 22.9401565467099],
              [92.374861565020666, 22.944671393283976],
              [92.377090793480917, 22.950188458905693],
              [92.377854026801657, 22.957326915755857],
              [92.378428350322679, 22.962656975230971],
              [92.376076767768211, 22.96680884158765],
              [92.374020006650298, 22.970688915105981],
              [92.379277285938457, 22.975216624820888],
              [92.383853572216481, 22.978297200131784],
              [92.386182903110267, 22.983994370396974],
              [92.385780657079138, 22.989141915770517],
              [92.387918207929431, 22.99321322829498],
              [92.389072381482109, 22.999990291389512],
              [92.391205695014222, 23.005504636668913],
              [92.385920847491448, 23.012812017469106],
              [92.38435054512901, 23.017418449709094],
              [92.385120596174104, 23.021756431361876],
              [92.388331003526801, 23.025826030561184],
              [92.391052831228762, 23.029896670710109],
              [92.387333158380486, 23.035762761826099],
              [92.388687833094892, 23.039922286353896],
              [92.393068702680722, 23.044897523747014],
              [92.396764818792406, 23.051320731654343],
              [92.396756323149518, 23.055024058331547],
              [92.393029532214157, 23.063056087832546],
              [92.391165688063438, 23.0663968714871],
              [92.38920354266385, 23.070820080161184],
              [92.387826838918883, 23.075514891451622],
              [92.386737948613984, 23.081565853688442],
              [92.386136351953681, 23.088158318930041],
              [92.380669163130534, 23.088691011003117],
              [92.376670479938227, 23.087237287944948],
              [92.373240770681633, 23.092199011438943],
              [92.373809928100428, 23.09933709137351],
              [92.369506889101729, 23.101675899028237],
              [92.36666774209813, 23.105193640062328],
              [92.366463237421243, 23.109078815287873],
              [92.36801092396081, 23.115314548157553],
              [92.371023996054646, 23.120831685453332],
              [92.373743347547915, 23.126167987297396],
              [92.372562518562063, 23.130140566927032],
              [92.366992904825338, 23.13166533523319],
              [92.363461047129078, 23.138434305596704],
              [92.365793992891795, 23.142774457315326],
              [92.368023745726077, 23.14901223468782],
              [92.367517532396207, 23.155877422230027],
              [92.365549847410392, 23.162105814799002],
              [92.364162705397703, 23.170326051616133],
              [92.365508464515031, 23.178186955106113],
              [92.365301496649792, 23.182794867995767],
              [92.363728232581295, 23.187398904685246],
              [92.359518574871359, 23.190822779455459],
              [92.358920927114099, 23.19488708896294],
              [92.359886159317895, 23.199133545809133],
              [92.361728292330326, 23.205732620451354],
              [92.361511804780065, 23.213231360372475],
              [92.360033763717851, 23.218378268491755],
              [92.358640470601273, 23.228131674937547],
              [92.357451498355587, 23.234182252902862],
              [92.362427404163782, 23.237624796343681],
              [92.368585128775919, 23.237276985076392],
              [92.373568561248845, 23.238460994862287],
              [92.38822792449713, 23.238490717334084],
              [92.393989345109716, 23.240308904583706],
              [92.39790400457052, 23.238871104613139],
              [92.405918927996851, 23.238254071238991],
              [92.405516852776955, 23.242499212155604],
              [92.401304479427878, 23.247459558360195],
              [92.398946064304226, 23.252424706055933],
              [92.397959501128767, 23.256488126546007],
              [92.395705150370887, 23.259915561769308],
              [92.393152602035329, 23.263614942897071],
              [92.39627164430874, 23.267776580399783],
              [92.399881623961591, 23.271669163975282],
              [92.397420379948514, 23.278259555854053],
              [92.393894242747393, 23.281413665888159],
              [92.39173239175858, 23.286379088550103],
              [92.388096159646381, 23.294411495369047],
              [92.389351696364258, 23.300828888579442],
              [92.391877210012694, 23.307247344917887],
              [92.388832020227113, 23.313113275999363],
              [92.387061098202267, 23.317537131177932],
              [92.38353262962633, 23.321053516104268],
              [92.376783406993496, 23.321400416826009],
              [92.373148160329336, 23.328529673556496],
              [92.375681837897076, 23.332237665485948],
              [92.379684776862263, 23.334776671040707],
              [92.384854125591502, 23.341019702199805],
              [92.386016821908115, 23.345991442894874],
              [92.386590709101796, 23.351321906336892],
              [92.38618694299673, 23.355839489524399],
              [92.38539368631281, 23.360083517851844],
              [92.381367375981924, 23.36648934146621],
              [92.379006103861542, 23.372174477549702],
              [92.37068734508324, 23.372879469321852],
              [92.365497702107163, 23.375127904707348],
              [92.367834212536479, 23.37974057696421],
              [92.36508494681371, 23.38370893618961],
              [92.359891021847432, 23.386317561092397],
              [92.362225829164174, 23.391472932543927],
              [92.362019166975557, 23.395808473689257],
              [92.357710189531332, 23.396881691038711],
              [92.357014724727307, 23.401488212184429],
              [92.359056186100617, 23.406100312843289],
              [92.361395811833432, 23.409807974727151],
              [92.361189723896388, 23.413963413900678],
              [92.35580428461607, 23.414313289971229],
              [92.35099532579153, 23.419633215551556],
              [92.351466364155087, 23.42622886314626],
              [92.349890127825873, 23.43065044716786],
              [92.348017307117701, 23.434711244908769],
              [92.342445884420727, 23.432079132514726],
              [92.336679163908784, 23.429536256084706],
              [92.332567894055217, 23.429526452907762],
              [92.33215915507121, 23.43557922862367],
              [92.331947236689999, 23.441087717271866],
              [92.331538432451879, 23.447140494214846],
              [92.33171757567419, 23.453192667993022],
              [92.33424502388003, 23.459792072199221],
              [92.334817957544871, 23.464220107488995],
              [92.329032959898697, 23.467278401787109],
              [92.324040699568044, 23.46762806742224],
              [92.32304885738624, 23.471328721166277],
              [92.329009007480266, 23.4763130083013],
              [92.329386905423746, 23.480650389979317],
              [92.325654451952346, 23.484885264560845],
              [92.325055074082826, 23.488769421114803],
              [92.324550517739453, 23.494096860722284],
              [92.325207419154921, 23.503764042754639],
              [92.323918578627541, 23.509271536692122],
              [92.321147959144838, 23.518118043744003],
              [92.322510592670568, 23.521555450805561],
              [92.324256480298857, 23.527069910612944],
              [92.319738842850029, 23.531304589019857],
              [92.313166618654975, 23.534359912115715],
              [92.312958258352708, 23.538603058266059],
              [92.312940204697441, 23.544294580420495],
              [92.315067159478673, 23.553876247132486],
              [92.313752062842738, 23.567060934562466],
              [92.3105670710639, 23.583222864227224],
              [92.310057212805646, 23.590448088590815],
              [92.304070385725623, 23.592872298008555],
              [92.299265977338493, 23.593944527626636],
              [92.295043968980522, 23.596641684629969],
              [92.293933288256454, 23.60684823987318],
              [92.294886391602532, 23.615251230630708],
              [92.298503213731891, 23.617698871739062],
              [92.301831234235323, 23.619695008513474],
              [92.302307453812389, 23.623762632547606],
              [92.298674411328122, 23.625559037795391],
              [92.290931944457725, 23.625176280345919],
              [92.284166382155647, 23.626241636780101],
              [92.284727350462461, 23.634193231104046],
              [92.279913862910036, 23.637793045867763],
              [92.279305316450916, 23.643482668720601],
              [92.283589050419579, 23.652527064735363],
              [92.288948411451528, 23.662389950923341],
              [92.292941563796205, 23.671072858038173],
              [92.294682551238651, 23.678755630454415],
              [92.296026303786263, 23.687430092289713],
              [92.294829477919777, 23.693660381899935],
              [92.292057797796232, 23.701873513566294],
              [92.28782944862472, 23.704662981209381],
              [92.285164409370282, 23.709713175145229],
              [92.28240042208968, 23.715035433388657],
              [92.276601179684789, 23.719174494432284],
              [92.268523921041179, 23.72440826198152],
              [92.260105804614753, 23.723101760301986],
              [92.254125856162304, 23.722090537429793],
              [92.24923733738143, 23.717919596531374],
              [92.246796760259883, 23.714389953442495],
              [92.244066291633871, 23.710046406058485],
              [92.246341941814123, 23.704903121796704],
              [92.246943763194707, 23.700659238108944],
              [92.246764759546721, 23.696052229320316],
              [92.244814929070714, 23.692794362166911],
              [92.240019962106956, 23.689978865587641],
              [92.237689281223808, 23.683738685564148],
              [92.238699165352202, 23.675522524212838],
              [92.238522715320798, 23.670372891055333],
              [92.236770856455863, 23.666663099300184],
              [92.232579777719678, 23.660055906627107],
              [92.224468583995076, 23.652894025503659],
              [92.220257684877737, 23.651707842065587],
              [92.215443494808966, 23.654310623878807],
              [92.211886177645511, 23.661256539613813],
              [92.214980679401023, 23.673008963398949],
              [92.216921083505639, 23.678162904652819],
              [92.217594817729079, 23.681778828059517],
              [92.217775494937968, 23.685753210758268],
              [92.216872703951395, 23.69099116664615],
              [92.212923926434229, 23.697753163536952],
              [92.208481544352324, 23.704873489251842],
              [92.200929651380008, 23.705211797275606],
              [92.197190571008264, 23.707998263894673],
              [92.192674685703565, 23.708975980122673],
              [92.181398985016841, 23.708125978596041],
              [92.178335560890133, 23.713262903333156],
              [92.178908556983345, 23.717331140829501],
              [92.177319964296103, 23.721841158156028],
              [92.176314356973762, 23.727708822502326],
              [92.178458207924336, 23.731600867852372],
              [92.177255327237503, 23.737830223884455],
              [92.171270597124462, 23.737808632857803],
              [92.162349080491225, 23.736151719703773],
              [92.154608792951265, 23.734046481910045],
              [92.151088440344708, 23.731233534569167],
              [92.146196268122793, 23.728414677348191],
              [92.14115618622489, 23.714484458160491],
              [92.136773162887081, 23.707333642729051],
              [92.130028632994012, 23.702610642456619],
              [92.125842993611116, 23.695277987889853],
              [92.115085929957814, 23.688461370585991],
              [92.11100235887686, 23.681038537578871],
              [92.106806426693097, 23.676505990340452],
              [92.100633946418725, 23.675580209325293],
              [92.095823620142582, 23.676823850900011],
              [92.089843736353899, 23.676438867957174],
              [92.086129958983548, 23.673805891260411],
              [92.084888859221081, 23.666845640064562],
              [92.085117742101048, 23.659709833970354],
              [92.082990580546792, 23.653468230524432],
              [92.081248321476423, 23.648853841814756],
              [92.077246161102067, 23.645496524402002],
              [92.070474782876147, 23.646642641969425],
              [92.063710421824695, 23.646525435971611],
              [92.057731362430985, 23.646679344935652],
              [92.051948496005409, 23.646293850582769],
              [92.042137427783771, 23.647696474003869],
              [92.036146542888318, 23.649929917990139],
              [92.026315995065133, 23.654582578591494],
              [92.02080773324947, 23.658170856490642],
              [92.012446049725767, 23.663102373238885],
              [92.005613523308284, 23.675445988270077],
              [92.000166959442879, 23.685175760340353],
              [91.996684471500359, 23.694642890097509],
              [91.99191243703747, 23.706181489949255],
              [91.988800789527517, 23.718813825261687],
              [91.983927207878253, 23.730714137118362],
              [91.975959890546108, 23.73456040206386],
              [91.970954909365901, 23.734716289278996],
              [91.962333146275171, 23.732866778434943],
              [91.958813294490781, 23.731044405878887],
              [91.956474613528883, 23.728050998542006],
              [91.954550222962439, 23.721900911732298],
              [91.953518681838617, 23.713405408650789],
              [91.957701219063111, 23.702857578652843],
              [91.962021750308793, 23.701705765064123],
              [91.961651513265664, 23.69800015055808],
              [91.952255094877586, 23.694972891907877],
              [91.944918081645937, 23.691504055924483],
              [91.940723773930983, 23.687961954558368],
              [91.938997710616334, 23.68117799134216],
              [91.939608489891356, 23.677477765671718],
              [91.941903889843559, 23.67071595469152],
              [91.940471542819139, 23.664296021718428],
              [91.941277128997811, 23.660686959030336],
              [91.943946838446379, 23.656815726784966],
              [91.9459378432054, 23.651677697663082],
              [91.949499423632901, 23.646275743057739],
              [91.949136488284537, 23.641124836743341],
              [91.946622938235407, 23.635241621225369],
              [91.948241445992309, 23.626758106848776],
              [91.951905115900871, 23.620183844129429],
              [91.958136308709896, 23.610550057722765],
              [91.959734845639531, 23.605047308697834],
              [91.957136868891027, 23.596725593898732],
              [91.955992040733989, 23.591570302833762],
              [91.955435368473772, 23.586148152403673],
              [91.956439472503291, 23.581907448522852],
              [91.957053774059602, 23.577124393282471],
              [91.956697712883397, 23.570890584817416],
              [91.959376654460286, 23.565213453178604],
              [91.962534819805427, 23.561344468869063],
              [91.964143732201237, 23.553673706310864],
              [91.965263171038586, 23.546542650535095],
              [91.967073706261388, 23.538242421997179],
              [91.966899415828422, 23.534085505848136],
              [91.964958624999937, 23.530916420422589],
              [91.961748540535638, 23.527287819442609],
              [91.95941346000501, 23.524294446824275],
              [91.961797153239061, 23.518795734066114],
              [91.967196174270228, 23.516384300765274],
              [91.971040443141135, 23.511886284276528],
              [91.972827178187529, 23.507649634887926],
              [91.975213164122735, 23.501248064572383],
              [91.976825402447659, 23.493216805657244],
              [91.978525141321157, 23.487171632746914],
              [91.978746140967587, 23.482204115758229],
              [91.97455649921487, 23.478843042396367],
              [91.967222338135926, 23.477183031152531],
              [91.95988926093726, 23.474980224855639],
              [91.953924274938558, 23.473777168945489],
              [91.946795208640069, 23.470671863240305],
              [91.943980456437743, 23.466592563911288],
              [91.943225279452747, 23.461439579552692],
              [91.945713712720192, 23.454408676930051],
              [91.945741974659768, 23.449620039853521],
              [91.946653586055874, 23.44447604349395],
              [91.946096047278019, 23.438963984253991],
              [91.942493630199451, 23.43569542578631],
              [91.93672336511321, 23.434853022580747],
              [91.927802705387478, 23.437068260548834],
              [91.921630832055655, 23.438300920463359],
              [91.916836134376695, 23.437915874597213],
              [91.912031770300942, 23.439336133661662],
              [91.90801910181797, 23.439135375604575],
              [91.90372327755351, 23.437125010190393],
              [91.898154125684485, 23.435471856046654],
              [91.892586860970894, 23.433546049003649],
              [91.884511135593087, 23.426005971549667],
              [91.87693753556681, 23.416210470881595],
              [91.8667175042672, 23.407576100756579],
              [91.861929200492909, 23.406104288713596],
              [91.85693424639723, 23.406981286249795],
              [91.852637777997984, 23.405331986802331],
              [91.84805858440771, 23.402327650954554],
              [91.842906002472134, 23.397331599126918],
              [91.840195059122507, 23.392708583404133],
              [91.839953357597508, 23.384669715483707],
              [91.841754418400839, 23.378809116953192],
              [91.841397847273612, 23.373477881936395],
              [91.838880016900831, 23.369218594917356],
              [91.835086455222708, 23.366036315875022],
              [91.830820167927598, 23.360140412750166],
              [91.824734708232839, 23.348365941917027],
              [91.820735666055967, 23.346717491949459],
              [91.815765801803266, 23.343797565333592],
              [91.813241278678845, 23.340985398241976],
              [91.80945178306456, 23.337439990384258],
              [91.806551730693869, 23.332364856108498],
              [91.808057139689623, 23.326682998898484],
              [91.802343241020395, 23.31816107217703],
              [91.795054997428821, 23.311616486982253],
              [91.791841573900115, 23.309429909864658],
              [91.78853627611096, 23.306519912084472],
              [91.787697634514629, 23.300462756776788],
              [91.784821782831543, 23.29213640319248],
              [91.782308605607568, 23.288058445453167],
              [91.780491080390561, 23.28226725086175],
              [91.777794641725876, 23.276380173688885],
              [91.77725127382223, 23.270054819916144],
              [91.777913031032043, 23.259128837559668],
              [91.778554155000137, 23.251183522041963],
              [91.780345725118707, 23.246679044735949],
              [91.784596338139977, 23.239840270641537],
              [91.788625282288237, 23.23643113033835],
              [91.791592747989512, 23.231299310250961],
              [91.791824347582306, 23.226151893797791],
              [91.791129111169695, 23.21314148117883],
              [91.792555166567283, 23.204658636188842],
              [91.793168579223206, 23.200869019381372],
              [91.797993617537045, 23.195386701084779],
              [91.799383336396062, 23.191962466214818],
              [91.802250723641308, 23.18701220811435],
              [91.805423721309552, 23.179893638925293],
              [91.806651061447511, 23.171771893788968],
              [91.809346176610248, 23.163024717747888],
              [91.810956580788812, 23.155718264051927],
              [91.811181893718881, 23.15129354885239],
              [91.810828586810771, 23.145782260811835],
              [91.811048499303581, 23.14208023578793],
              [91.811486498151737, 23.134586302034005],
              [91.81307972114088, 23.130167968251062],
              [91.814494089454541, 23.122950273885639],
              [91.815399946921247, 23.118982431654626],
              [91.81904914752198, 23.113312043669708],
              [91.820360831518457, 23.106724010467762],
              [91.819016650289612, 23.103194509779897],
              [91.821289185257285, 23.099322995860739],
              [91.825871831087753, 23.100342395746576],
              [91.834070819323543, 23.100387039332837],
              [91.835369700301712, 23.095786673746129],
              [91.833441178525206, 23.092253541421062],
              [91.827128652841751, 23.086889856487034],
              [91.822157298168918, 23.085870250794258],
              [91.816519745269858, 23.08213571129442],
              [91.820351586535338, 23.078271987055551],
              [91.814824140186929, 23.072552545225179],
              [91.810939297828583, 23.069459335478022],
              [91.80704351866062, 23.068171410767793],
              [91.802162120038986, 23.068234667017592],
              [91.79610841532751, 23.068562542266658],
              [91.792481236273048, 23.070709328253511],
              [91.787677835330683, 23.073933303446502],
              [91.782413363817597, 23.072818244741619],
              [91.779017124073519, 23.069909756902131],
              [91.777301369732825, 23.06393694962907],
              [91.78017809963076, 23.057179519041249],
              [91.782452075771374, 23.052858535556503],
              [91.783557347336867, 23.047987341657855],
              [91.785739809790002, 23.042850638563632],
              [91.780727700095923, 23.033427741420418],
              [91.774045060896952, 23.040999971014955],
              [91.768120758506399, 23.036156160439354],
              [91.765217014964193, 23.032615811156401],
              [91.757182080580534, 23.023354159032674],
              [91.755257199149526, 23.019460050678088],
              [91.748276636802871, 23.013005715090262],
              [91.73923388435945, 23.00843479826155],
              [91.730602846866574, 23.001157850460174],
              [91.726944179486068, 22.994360710182082],
              [91.71587137648882, 22.987608560848241],
              [91.710213896811865, 22.987483304927942],
              [91.703554690565895, 22.990873997277088],
              [91.696633864716659, 22.990018932325185],
              [91.691601257733112, 22.984658706800854],
              [91.681379301146038, 22.981703611533689],
              [91.677380283326755, 22.981586849188496],
              [91.674670454377846, 22.978861108207447],
              [91.670575856509387, 22.97856334617137],
              [91.664799008476948, 22.981053878900735],
              [91.659634622862924, 22.980480038087578],
              [91.654488539506758, 22.977193492121597],
              [91.63865382033751, 22.968689517286819],
              [91.63614427967174, 22.965422035287574],
              [91.62979095215951, 22.954721121845875],
              [91.621582556991214, 22.944190616971138],
              [91.616900994013633, 22.94442939295039],
              [91.61501152912416, 22.948840936500158],
              [91.611860543727289, 22.952704639999514],
              [91.607430607342366, 22.957913660842671],
              [91.610699383053785, 22.963715613353148],
              [91.60891567767473, 22.967135076560787],
              [91.605089037364962, 22.970090657937664],
              [91.600478377293172, 22.973400264736913],
              [91.595473458929703, 22.976976903957098],
              [91.590793268524408, 22.976674764450358],
              [91.586808581844323, 22.975020263659722],
              [91.579239610733651, 22.970001278617499],
              [91.572970928760697, 22.97320686515457],
              [91.56454338629635, 22.977934866267503],
              [91.558268217915639, 22.981774760000835],
              [91.557646446553591, 22.986105715129042],
              [91.559174268321684, 22.989909192458445],
              [91.560304777787934, 22.994614490353857],
              [91.560957350111636, 22.998410725823309],
              [91.558876744535667, 23.002189693380842],
              [91.552852857631819, 22.999075003897584],
              [91.548693519652531, 22.994802292894882],
              [91.545936807194295, 22.997760562694467],
              [91.547545424920372, 23.003824981838456],
              [91.549632708770744, 23.010703848157174],
              [91.549774821872518, 23.017026550664209],
              [91.543565250060041, 23.024207389265388],
              [91.547518840170696, 23.029743871665431],
              [91.549931002679685, 23.033194274188077],
              [91.551733066605465, 23.039168117980058],
              [91.548397949821307, 23.041221300466614],
              [91.541976448112109, 23.039097857861506],
              [91.53728531614999, 23.039694526543244],
              [91.536252634858457, 23.046462433158382],
              [91.537779656425982, 23.050356209989712],
              [91.538599782197537, 23.057227101483939],
              [91.534493461761201, 23.057918476377871],
              [91.53026609702583, 23.061589310771193],
              [91.534536687818388, 23.064330468403615],
              [91.535761620924632, 23.069306964451538],
              [91.532967501466359, 23.076512972520447],
              [91.529304225437812, 23.08244660394341],
              [91.531913169481655, 23.085444296478144],
              [91.533731635534622, 23.089702927283433],
              [91.527068689991054, 23.092453329381772],
              [91.524855878211511, 23.099844250976357],
              [91.523653733243734, 23.103357634828569],
              [91.517762140968358, 23.107286835753097],
              [91.517140950690418, 23.111345276067237],
              [91.519910554433395, 23.118410416293024],
              [91.517234070340152, 23.122816690540162],
              [91.507917696291557, 23.127351955873884],
              [91.507090840994948, 23.132493848209688],
              [91.512415486347379, 23.137682702315846],
              [91.517827118473576, 23.144225049865323],
              [91.512922078388257, 23.146896977033339],
              [91.504904578550352, 23.147649597392551],
              [91.50555398678425, 23.151448611069309],
              [91.501139897444219, 23.153674115829851],
              [91.496554278785155, 23.153005128805948],
              [91.49408627725019, 23.155877311531324],
              [91.495483378401673, 23.163563877690478],
              [91.498835233730119, 23.171084596058883],
              [91.498502786807677, 23.175417959787111],
              [91.496995495481997, 23.180103848535442],
              [91.502827062076847, 23.183669388617364],
              [91.507588126626374, 23.186415546104005],
              [91.504428946953666, 23.190184820428282],
              [91.491622324867933, 23.19098869216246],
              [91.483028405196606, 23.19065221799757],
              [91.477332152504374, 23.193769036385028],
              [91.475532559005828, 23.198362107158939],
              [91.479218549654874, 23.201189924291732],
              [91.487784794470286, 23.204867246516773],
              [91.486765582751133, 23.209374904356721],
              [91.485454010186473, 23.213880005271861],
              [91.48286802693994, 23.218919053611792],
              [91.478085505357839, 23.218250097459695],
              [91.463936352686503, 23.216151559569223],
              [91.458425108223324, 23.220082133488333],
              [91.461520169276042, 23.223810089366427],
              [91.466192462749703, 23.225741664586739],
              [91.470723326899829, 23.232550576239312],
              [91.462874454448468, 23.24639631099015],
              [91.454754025497181, 23.247055388149054],
              [91.453640253604931, 23.251381724174024],
              [91.457190810007546, 23.2582726967327],
              [91.45344208856919, 23.261945834709312],
              [91.44874138833444, 23.262902125979991],
              [91.431544542753386, 23.26195156595838],
              [91.424911596383438, 23.260544033153099],
              [91.422629920143834, 23.263864812621101],
              [91.422004218176269, 23.268015283651316],
              [91.419688513772869, 23.275039153379758],
              [91.416198699487225, 23.282237098469103],
              [91.411606238365195, 23.281837985993654],
              [91.412731215721038, 23.27660917127379],
              [91.416692461542837, 23.261197897597583],
              [91.413694998558483, 23.257742200268648],
              [91.409262809135825, 23.261407973111247],
              [91.406192968688103, 23.265266341118064],
              [91.402109224072063, 23.26315580016491],
              [91.402749513501121, 23.257472463089972],
              [91.409045476961026, 23.253368694882134],
              [91.405671094026829, 23.248736330135657],
              [91.401109010909053, 23.245356306054152],
              [91.401464575186438, 23.238947594711828],
              [91.402867138226284, 23.23534687798951],
              [91.403209764554433, 23.230383364324929],
              [91.39540643809714, 23.228783919537804],
              [91.391626325205564, 23.225500777815164],
              [91.391414598700607, 23.21728125670565],
              [91.388521496961062, 23.213103471979338],
              [91.388559663139077, 23.209310170602127],
              [91.391548648320992, 23.203375904275749],
              [91.387084636528627, 23.200358718741906],
              [91.384497345204764, 23.195188345148793],
              [91.385224439959018, 23.190771132015204],
              [91.384807957092136, 23.183270329746794],
              [91.388125590158268, 23.173907938785412],
              [91.389240875401057, 23.169582118910306],
              [91.388545712818754, 23.160815662656685],
              [91.395769221098007, 23.151301996855402],
              [91.396902833243672, 23.144990675602674],
              [91.398814119766712, 23.139498855233072],
              [91.402051116638148, 23.117759972650514],
              [91.406271134634395, 23.115537843807484],
              [91.407872618496242, 23.111396365614354],
              [91.407716902445756, 23.107241277433101],
              [91.406290281813753, 23.103344768676724],
              [91.406917807864403, 23.099016649165545],
              [91.4087260638386, 23.093701786224347],
              [91.411311623874965, 23.088756419759449],
              [91.414878439335268, 23.083277251822857],
              [91.419512253680367, 23.078347951000424],
              [91.421627733640051, 23.071500263563134],
              [91.418447836302335, 23.067050315666879],
              [91.414277885455391, 23.064216753147942],
              [91.404142467292999, 23.062508972261107],
              [91.39311607717201, 23.062237646857412],
              [91.385569437659328, 23.065336285571867],
              [91.381630095919633, 23.068735757285797],
              [91.377993781077521, 23.071325031184479],
              [91.370735719595018, 23.074875770328951],
              [91.368355395499222, 23.078739449576986],
              [91.366262915542407, 23.082966056208299],
              [91.362114603940768, 23.087808343824896],
              [91.35885123511558, 23.092023846341661],
              [91.356471632862451, 23.095525023993694],
              [91.35378667855052, 23.100470826105457],
              [91.352181586432792, 23.104791819793828],
              [91.350563382560011, 23.110285687623715],
              [91.348568642947484, 23.114602900451413],
              [91.344579903792862, 23.122697287047352],
              [91.339648175347392, 23.137194402156339],
              [91.338576619794026, 23.146666875567607],
              [91.33496720003312, 23.155757473933853],
              [91.327945207929872, 23.164455004486285],
              [91.327942335133486, 23.174297931356001],
              [91.328064766765124, 23.181433696677001],
              [91.327404416536297, 23.188652053422288],
              [91.327142760212041, 23.195061508162642],
              [91.326749712275443, 23.204720721515677],
              [91.32738948334935, 23.209150690550658],
              [91.328100881974578, 23.216109652335618],
              [91.327718578602671, 23.224596139795256],
              [91.327257421310406, 23.231636188417344],
              [91.326699207673457, 23.2384030034018],
              [91.323297970760436, 23.245777697135139],
              [91.329090895122803, 23.252873067749807],
              [91.325921842874635, 23.25690880681773],
              [91.320060205072181, 23.256587043006078],
              [91.318817798343275, 23.26325725352666],
              [91.315847265976487, 23.266934514136683],
              [91.315192502840333, 23.273340315300473],
              [91.31944449659828, 23.278163097247376],
              [91.318124943936354, 23.283029119669276],
              [91.312739715040109, 23.28379457193919],
              [91.308617911749195, 23.285112500231548],
              [91.30469033950952, 23.286702239316764],
              [91.302963213674715, 23.292827375726141],
              [91.304087482364778, 23.29771469846575],
              [91.309995998537985, 23.303094159637148],
              [91.315256987050532, 23.304766009374092],
              [91.317956435490231, 23.308583267852892],
              [91.316142359852691, 23.313804836490448],
              [91.311816867851817, 23.316023554246332],
              [91.306240935633653, 23.316064332021107],
              [91.302036982007976, 23.315935770405655],
              [91.294558870893553, 23.320293764839853],
              [91.29539380897269, 23.324455872144664],
              [91.297019491968726, 23.327900624570006],
              [91.299026975916092, 23.332524146743101],
              [91.300220062056596, 23.33994070034559],
              [91.304465467318053, 23.345486602125575],
              [91.309053182645187, 23.346249284247328],
              [91.314013650783536, 23.349003303163506],
              [91.316030839536964, 23.352633940603187],
              [91.317033661159812, 23.36002977265515],
              [91.310793541336068, 23.357734711116866],
              [91.306620238138393, 23.354355679823925],
              [91.304219442466746, 23.350180766505492],
              [91.299716709512012, 23.350501774620884],
              [91.298681983704611, 23.355910849600981],
              [91.295205058811163, 23.360755949344711],
              [91.291878460144659, 23.370116324776685],
              [91.297325110204923, 23.373055857726538],
              [91.29666928414639, 23.379641574613494],
              [91.292839430801934, 23.380961848424842],
              [91.290250344410907, 23.375972187060999],
              [91.286133706133938, 23.376566839553373],
              [91.284277044104286, 23.38548903906419],
              [91.280538884948527, 23.396560760773266],
              [91.280485271306333, 23.401616903771323],
              [91.282684899352972, 23.406332825207095],
              [91.281848426764071, 23.411383574140164],
              [91.277567756338783, 23.418025984379248],
              [91.273816673762269, 23.421062115143535],
              [91.270852365466126, 23.423563477832971],
              [91.270397458776216, 23.429518444608785],
              [91.272512826813539, 23.432878372954615],
              [91.259422847125606, 23.448380126193758],
              [91.254470774705837, 23.462510252561646],
              [91.251945307288281, 23.469712051234623],
              [91.249765757111632, 23.489737140042937],
              [91.242712223991617, 23.490033157680561],
              [91.23992618845034, 23.493978846163607],
              [91.238002973202342, 23.499468820842175],
              [91.232429160170113, 23.498874120169031],
              [91.225080777236542, 23.499076388891247],
              [91.223259205485206, 23.504386950207763],
              [91.220436691565681, 23.5114929857675],
              [91.213590221616187, 23.510704534907287],
              [91.208169624030504, 23.5135419901403],
              [91.205644902058125, 23.520380545101016],
              [91.208052770414582, 23.532412566706402],
              [91.212013761661211, 23.537235472065756],
              [91.214750894898174, 23.546562000707311],
              [91.213338376953061, 23.550071148541651],
              [91.205916818987035, 23.548013391961394],
              [91.199800804466548, 23.551656067386457],
              [91.198511027973936, 23.561666187546738],
              [91.195520147106492, 23.566151582857348],
              [91.182381637741415, 23.583720159109049],
              [91.17841898106974, 23.587294597985011],
              [91.178911027879536, 23.595695348650011],
              [91.174866949779641, 23.597913345291683],
              [91.166630772322776, 23.598101208203463],
              [91.163259326863638, 23.60140899221518],
              [91.163352628423539, 23.61016819958521],
              [91.163259293373528, 23.618022673872218],
              [91.160700790858741, 23.627208602946478],
              [91.161252171525774, 23.638588909381127],
              [91.163735920224639, 23.644212352483663],
              [91.161264354530601, 23.654209766142539],
              [91.16154636005065, 23.66351366166165],
              [91.165357927658675, 23.664634688684782],
              [91.172149137669422, 23.662445953277846],
              [91.18320921474826, 23.655602886792035],
              [91.195888845936622, 23.652927402906855],
              [91.197430473526069, 23.646803638347951],
              [91.203131417719533, 23.645505058375946],
              [91.207400208874375, 23.649608347782056],
              [91.208477490174459, 23.658107660759228],
              [91.208289084387644, 23.665961126708154],
              [91.206462247813747, 23.671451579135436],
              [91.207612328938808, 23.68220754840965],
              [91.204780614483454, 23.689673474648412],
              [91.195668468617598, 23.688863257241039],
              [91.18604957074146, 23.689490337686532],
              [91.174879093736408, 23.688657280993048],
              [91.164879290434243, 23.68846840930917],
              [91.157806701340363, 23.68939083521909],
              [91.156653854964404, 23.695518436998903],
              [91.156768156002485, 23.702382199548442],
              [91.155147739865711, 23.706788997064482],
              [91.152539752922891, 23.711547926511258],
              [91.154921537041048, 23.725748614106752],
              [91.154878531198122, 23.729359523139838],
              [91.158621931151757, 23.736259636163517],
              [91.164099972618288, 23.745884225431112],
              [91.167401073732691, 23.748717844688404],
              [91.175563258699469, 23.74717374525283],
              [91.190129462247157, 23.75174123869958],
              [91.200009185572142, 23.754367732674115],
              [91.205803019818148, 23.754062755383494],
              [91.214184634228559, 23.750353083981171],
              [91.22282336726596, 23.741496221783724],
              [91.227585894069307, 23.745334035199868],
              [91.23016998954138, 23.759715651372524],
              [91.231018595303198, 23.771373424447688],
              [91.22993201175926, 23.780573203833072],
              [91.228388122222867, 23.786877353740991],
              [91.231829518348391, 23.794947811193712],
              [91.234805373515584, 23.800845264995207],
              [91.234729255313013, 23.80761685959056],
              [91.238880386468509, 23.813706300916429],
              [91.245851388067194, 23.822260025908861],
              [91.247673578170932, 23.826069795496164],
              [91.254022192529888, 23.837687901637121],
              [91.252684380586146, 23.843183846609524],
              [91.250270864284701, 23.848126492564148],
              [91.245852548135687, 23.856752580085306],
              [91.24262724304613, 23.864035167999759],
              [91.241272414657359, 23.870883995327681],
              [91.24012518871173, 23.876742014179555],
              [91.233245154533606, 23.885705439394119],
              [91.234700721392102, 23.89583147142854],
              [91.236971931932629, 23.903529568057373],
              [91.24341098344901, 23.907383695344201],
              [91.247083105874225, 23.912655270934199],
              [91.246119841298679, 23.919508121039271],
              [91.242548325458429, 23.922635492080101],
              [91.238299038059878, 23.924850815206774],
              [91.241993019730103, 23.928316990118553],
              [91.261870579471946, 23.925618138838555],
              [91.268949033091417, 23.925233492468013],
              [91.276674583724215, 23.928376250582524],
              [91.276033137399764, 23.932976481594256],
              [91.273242716276812, 23.93656022088264],
              [91.26917056755488, 23.940406090098342],
              [91.265460553432632, 23.946961637373281],
              [91.269217212559127, 23.953768874213505],
              [91.270448450300989, 23.95784497468874],
              [91.274144233924261, 23.961310361768106],
              [91.277802699325306, 23.96820643653848],
              [91.280488293694489, 23.97410240251822],
              [91.284549976155432, 23.980099478548055],
              [91.289763181809079, 23.979785604784375],
              [91.289610752899549, 23.97581260182363],
              [91.29075131031739, 23.970404504397671],
              [91.297438692161606, 23.969924748527244],
              [91.301726210824398, 23.973397436165143],
              [91.304621303981634, 23.978209767627497],
              [91.304739492824808, 23.98543344026481],
              [91.307349162703119, 23.989520150520544],
              [91.316767735315764, 23.990961639529207],
              [91.324041022563733, 23.991208835112786],
              [91.32824862094445, 23.992962207937733],
              [91.334467246038372, 23.990670569264548],
              [91.338262907392519, 23.985017089655567],
              [91.34085245241269, 23.981790485576997],
              [91.350004881657242, 23.980698923177282],
              [91.357059636017851, 23.982928287281268],
              [91.363324710088165, 23.985242545854895],
              [91.36809695392401, 23.980227628224657],
              [91.37293619601779, 23.978011809743368],
              [91.3799335022061, 23.97608818610945],
              [91.385440831030394, 23.975953753943131],
              [91.382658253276304, 23.988302287681961],
              [91.38034700974751, 23.9930677291396],
              [91.379504889503153, 23.998386889271242],
              [91.383546495014471, 24.006729411854757],
              [91.38663133394995, 24.012717044467873],
              [91.391284074536671, 24.019259164277454],
              [91.39567210438635, 24.022637923549244],
              [91.396906003957142, 24.026893062808455],
              [91.395972231043999, 24.03167110654822],
              [91.399355181076174, 24.037388752233362],
              [91.400498022090659, 24.041010330626907],
              [91.402519201488971, 24.045272499520109],
              [91.404198999772518, 24.053955652351217],
              [91.397062897847931, 24.059310373024825],
              [91.393486219857905, 24.06289143040641],
              [91.386244305183538, 24.068877345526047],
              [91.384040635100476, 24.07265090844793],
              [91.382696594313046, 24.078780600500284],
              [91.381661839308066, 24.083737694022343],
              [91.382340185208292, 24.094217352445654],
              [91.380698548513166, 24.10061439005926],
              [91.382127901687269, 24.104961478500726],
              [91.387694046393577, 24.108983724271614],
              [91.393607369233791, 24.108132296472508],
              [91.397748248541873, 24.107174742027858],
              [91.405911687456864, 24.107606146727235],
              [91.414260262953306, 24.108851764944969],
              [91.428232664443129, 24.108791269300454],
              [91.43573387887443, 24.106416896298128],
              [91.438917233368358, 24.102921401918248],
              [91.449740553544558, 24.103013586440362],
              [91.456051446895742, 24.101350696927064],
              [91.462674663148547, 24.098154624786403],
              [91.469771165169234, 24.09685796377234],
              [91.480681862074306, 24.09793932702512],
              [91.490228065422727, 24.097655381335429],
              [91.496635265730916, 24.096353993849842],
              [91.497952559379144, 24.092391309688125],
              [91.498577894456687, 24.088693008153236],
              [91.5015541226674, 24.086099571475476],
              [91.507367624836533, 24.084970638744778],
              [91.516624933734079, 24.083779939917566],
              [91.521058340760121, 24.083093827464975],
              [91.527761094163353, 24.081791169375418],
              [91.536824324700376, 24.080325168891125],
              [91.546383950377589, 24.07823237035802],
              [91.553488902158819, 24.075848983995357],
              [91.563921148587156, 24.075297423315188],
              [91.569619556965606, 24.075883099959782],
              [91.573918675516197, 24.078985794050233],
              [91.578532347593736, 24.080192721862932],
              [91.585041707245068, 24.078255810907315],
              [91.590976442989842, 24.074506261288686],
              [91.596468880658932, 24.076444507486329],
              [91.601664564487592, 24.078378086966744],
              [91.605579615067526, 24.080664071486535],
              [91.603467058974914, 24.085886883559592],
              [91.602647710573109, 24.089674107554057],
              [91.602989687103957, 24.095456092100935],
              [91.610763216759167, 24.095333378992358],
              [91.615884675002263, 24.094737515163384],
              [91.620310432753143, 24.094858953652828],
              [91.624930069952555, 24.095254223901151],
              [91.629837604066083, 24.096644280514401],
              [91.638341607002133, 24.103207723313208],
              [91.642517247558118, 24.109468533620859],
              [91.644344892877072, 24.114448630380831],
              [91.644887529834037, 24.120231839006671],
              [91.642568402699268, 24.126716597984622],
              [91.640858781461944, 24.131130019323312],
              [91.640319392304406, 24.13663513440693],
              [91.640375988145635, 24.14160202615761],
              [91.640542020447185, 24.145306729476321],
              [91.644236434293035, 24.15066093632543],
              [91.646864823472924, 24.153929205512135],
              [91.647324670042593, 24.157726181734613],
              [91.648648961903589, 24.164237813321986],
              [91.648211002511999, 24.169381192385782],
              [91.6495480617303, 24.174177507248331],
              [91.651577909350024, 24.178616385567576],
              [91.656867581911698, 24.181906216758179],
              [91.662644952234047, 24.185557436352941],
              [91.663895620973207, 24.189089946797456],
              [91.663071669793922, 24.1932377629218],
              [91.659982441147505, 24.197641330769713],
              [91.658470270991401, 24.201873983560912],
              [91.656859994446435, 24.20610817344938],
              [91.65552976551443, 24.211967669955673],
              [91.654482420311908, 24.219456910507638],
              [91.658283205345441, 24.224178840190003],
              [91.662687041265244, 24.227642022354882],
              [91.667481503355717, 24.231378147465389],
              [91.671404639604134, 24.23312228212427],
              [91.675648161707244, 24.23215782915668],
              [91.673915840104499, 24.227178943062359],
              [91.673164372650021, 24.222929681495188],
              [91.671728541848566, 24.218042840599924],
              [91.671370566114916, 24.213704147879422],
              [91.672975226774412, 24.210104718856645],
              [91.679812709415074, 24.204822883966138],
              [91.683411535565924, 24.19816453106257],
              [91.685769699235067, 24.186713131824348],
              [91.690282615587137, 24.176627732454328],
              [91.694593852846396, 24.166813339183395],
              [91.69896285247745, 24.162327980343164],
              [91.702226527321216, 24.160273104519714],
              [91.706460639769958, 24.160120495602197],
              [91.709984158523298, 24.162491150089391],
              [91.713251505805843, 24.159985811107433],
              [91.715656792466916, 24.154583574101121],
              [91.720483402142037, 24.154252252554659],
              [91.726316692976539, 24.150859298143757],
              [91.731354706705261, 24.148363488945719],
              [91.739140703591517, 24.147059082861013],
              [91.745950467008498, 24.144484815795735],
              [91.749806464989589, 24.142162729628168],
              [91.755809815442774, 24.142200797953294],
              [91.761425318155332, 24.141333333555011],
              [91.766247099278914, 24.141543147472323],
              [91.767864489926765, 24.148958540454217],
              [91.76535344349692, 24.155626167490986],
              [91.762507353367539, 24.167710399180233],
              [91.761110584989254, 24.182965304590553],
              [91.757436066288776, 24.200010418122154],
              [91.756545305277029, 24.213550666921883],
              [91.753521240020618, 24.222742779744237],
              [91.751247267989996, 24.236636211141722],
              [91.749806661405486, 24.244845991022167],
              [91.764812578254023, 24.240063284821851],
              [91.77460904320634, 24.234166453093589],
              [91.779953738966142, 24.230405865396769],
              [91.785692865776937, 24.226739907124429],
              [91.792887796265447, 24.225879225197282],
              [91.798139478876024, 24.221666958752792],
              [91.803747203917808, 24.222243275216481],
              [91.807765037611162, 24.224977211073437],
              [91.81467544276876, 24.222760599622475],
              [91.817164352381312, 24.218892841666634],
              [91.82241384129459, 24.21449980923714],
              [91.831381572822423, 24.213468339850753],
              [91.835999884794788, 24.215029975521595],
              [91.8439293056515, 24.22176066804569],
              [91.848040942767085, 24.22521683152986],
              [91.851983779651107, 24.22451594701063],
              [91.854770025235553, 24.22046917916494],
              [91.855199936024007, 24.214962948772683],
              [91.850799763702383, 24.210692411305907],
              [91.848963976148625, 24.205532476236264],
              [91.850486255386073, 24.199039921290908],
              [91.855758373221747, 24.191212506011471],
              [91.865469270447406, 24.181693911334587],
              [91.872020148002946, 24.173963535059649],
              [91.874239315071065, 24.170615112718661],
              [91.876792277844658, 24.166765124116633],
              [91.87939266380819, 24.16317511470313],
              [91.882654808939478, 24.158670041232988],
              [91.885461241447075, 24.1510094773774],
              [91.889956763309613, 24.140648176426083],
              [91.895698520740723, 24.135530407204396],
              [91.902390993829542, 24.135566702073351],
              [91.907398656883004, 24.136948618331804],
              [91.913182519212214, 24.14041264049504],
              [91.915400271166035, 24.14773973195992],
              [91.916707045641843, 24.158855216175663],
              [91.918720607829471, 24.167446330529273],
              [91.919351022968897, 24.176662327148488],
              [91.920689028874207, 24.182809258234183],
              [91.923794575763921, 24.190051115526106],
              [91.925412649584914, 24.198820063241602],
              [91.929579345326673, 24.209411064672533],
              [91.930904542744301, 24.217995832391487],
              [91.93192348677897, 24.228026659369561],
              [91.935034437770582, 24.234727952558966],
              [91.939390939300623, 24.246580373394512],
              [91.944050273692895, 24.257713791983477],
              [91.944006915270933, 24.264757811194638],
              [91.944733155175115, 24.274696737886909],
              [91.943201421747972, 24.283270337103477],
              [91.939811336454639, 24.289755680309714],
              [91.937700096143629, 24.296698145595037],
              [91.934692296488649, 24.304720947403975],
              [91.933275579457927, 24.310584448502922],
              [91.929593019018981, 24.316525272835126],
              [91.927490336612493, 24.321662249883239],
              [91.926231779630982, 24.333575633885591],
              [91.92797171495819, 24.339094108897406],
              [91.936631196120643, 24.341307864606822],
              [91.950482352499179, 24.348605793650485],
              [91.95371778714437, 24.351421610504232],
              [91.962353497035011, 24.357969598934059],
              [91.969782584262987, 24.352135595902368],
              [91.972982525230151, 24.344655831402278],
              [91.975873958235823, 24.338889959707213],
              [91.981524013133395, 24.333588563926693],
              [91.991805003133649, 24.328310987904292],
              [91.998608051896397, 24.327983439342464],
              [92.004886403435734, 24.333161748429102],
              [92.004955172260125, 24.338038409868382],
              [91.998806826501024, 24.344603250853588],
              [91.992362022395611, 24.350893992086721],
              [91.988085461168239, 24.357375717695998],
              [91.986774505214044, 24.362337441031737],
              [91.983491202462119, 24.367468921171312],
              [91.978621288274184, 24.373947324229142],
              [91.975645268851991, 24.377002356219389],
              [91.97462597520817, 24.382778082018429],
              [91.979730759462385, 24.386415896496516],
              [91.983775718987857, 24.385804529597156],
              [91.98734957929517, 24.381847345833904],
              [91.991289116534773, 24.382770406361171],
              [91.994030659451184, 24.385855300395871],
              [91.995383958193415, 24.39046827993176],
              [91.998718032938541, 24.393553773548657],
              [92.005918929004807, 24.393047912461764],
              [92.008011929249051, 24.389172845086165],
              [92.010307884908286, 24.384668313782758],
              [92.014742439579379, 24.385050796608596],
              [92.020948595424429, 24.385984542119022],
              [92.024893370801962, 24.385641713766422],
              [92.028549965996092, 24.384122124293768],
              [92.031228858159039, 24.381244654425483],
              [92.036674065393044, 24.377295520153552],
              [92.041901591124002, 24.376958403013798],
              [92.046146703109144, 24.375623744463351],
              [92.058079082520749, 24.375315812704713],
              [92.069421647221404, 24.374554039249741],
              [92.078197436773962, 24.374319931368984],
              [92.08235399940159, 24.374337889910404],
              [92.085787121827892, 24.374352476643637],
              [92.0945615360435, 24.374389861071315],
              [92.102037376182153, 24.37785410167826],
              [92.104584832712675, 24.380936114734215],
              [92.109814120878738, 24.380234221347578],
              [92.113960870258325, 24.379257248628289],
              [92.118296924541085, 24.379728636996212],
              [92.124200594354221, 24.382189909125767],
              [92.127033190927321, 24.387800804324396],
              [92.125613751399143, 24.395743831578301],
              [92.130299036695163, 24.405518439580128],
              [92.133630239160794, 24.410408571040385],
              [92.136366160251569, 24.41538638980786],
              [92.139294757574802, 24.421720081393829],
              [92.142535384084013, 24.424714252925451],
              [92.147561966399962, 24.425545533090073],
              [92.153875494288087, 24.425209150138823],
              [92.160786440700846, 24.423882097053159],
              [92.165433305849234, 24.421370530442058],
              [92.171842226856711, 24.421574080787725],
              [92.17251381464115, 24.426182569834481],
              [92.169129427747365, 24.433125245053926],
              [92.166336923203687, 24.439617822373695],
              [92.164420127536658, 24.449094323752004],
              [92.162106589809852, 24.458659311515952],
              [92.160209660104186, 24.463889992856345],
              [92.159976375602483, 24.471477877821851],
              [92.157152633102299, 24.484653749360092],
              [92.156239298274059, 24.490338594197027],
              [92.156016264328429, 24.495758556186757],
              [92.154913748453794, 24.499367174076752],
              [92.154304329892526, 24.503247853327601],
              [92.154850172946965, 24.512914381271393],
              [92.156497799869257, 24.519694732939563],
              [92.158843227183894, 24.524670314339698],
              [92.163178126327367, 24.526403272470873],
              [92.170476455077562, 24.527515454330842],
              [92.174727253740784, 24.526267176234786],
              [92.180756669901768, 24.524573278974685],
              [92.187680856005585, 24.520894998132608],
              [92.196285039704833, 24.517314988936061],
              [92.204896192638202, 24.51147447127331],
              [92.212712057058511, 24.507255696225069],
              [92.216866360715798, 24.504740869809361],
              [92.22112539662767, 24.501323441416506],
              [92.227747810416659, 24.498637231885755],
              [92.233459531129867, 24.501726060039999],
              [92.234035261592894, 24.505793730232892],
              [92.233779675393777, 24.520152855348215],
              [92.233751429856028, 24.527378852327686],
              [92.232329820343352, 24.53704020202229],
              [92.232499818717557, 24.543904455733752],
              [92.23414245472452, 24.552309380418983],
              [92.23410581337393, 24.561523055828221],
              [92.234062834161861, 24.572179621812545],
              [92.23343431253069, 24.581028722952837],
              [92.231525653200038, 24.588700481186176],
              [92.229132859083691, 24.594382594840912],
              [92.224079571242655, 24.598609759161874],
              [92.221581056797987, 24.605286533619019],
              [92.222555054339693, 24.608900693566948],
              [92.227173542173901, 24.614245927742193],
              [92.231800284642873, 24.618325731676581],
              [92.234254027952673, 24.622127606288448],
              [92.23758417260126, 24.629545403268875],
              [92.239924171796503, 24.637049798578392],
              [92.240091974713749, 24.644006329021948],
              [92.239680044630589, 24.648250352031965],
              [92.236302858978647, 24.652933951872605],
              [92.233122008065976, 24.657168202030594],
              [92.228950269629706, 24.662663725122261],
              [92.227453596840022, 24.666453540210245],
              [92.225450844908892, 24.672677174084821],
              [92.226210029609149, 24.679995878560533],
              [92.228760221916403, 24.68452071989039],
              [92.231401742127375, 24.691395819961343],
              [92.233751336823701, 24.696822459667867],
              [92.239464872069888, 24.701628424113814],
              [92.244499256196775, 24.703361408973556],
              [92.249443080199683, 24.702563872485896],
              [92.257454207142928, 24.701326442924014],
              [92.261002430649683, 24.704408803946464],
              [92.263558790532116, 24.70785031819463],
              [92.266110462577899, 24.712464532919146],
              [92.267262449290371, 24.721409385215029],
              [92.267236034053127, 24.728002551008242],
              [92.267912253051236, 24.732700221312875],
              [92.27054207937654, 24.742645033785848],
              [92.270623068099979, 24.747703169790967],
              [92.269718803630568, 24.751313012908831],
              [92.268106177279108, 24.758803470046416],
              [92.264525057276273, 24.764121796645739],
              [92.264803432307204, 24.769090568999804],
              [92.265872879920792, 24.774152015160695],
              [92.268033001492626, 24.777772193213281],
              [92.270296874132001, 24.780759994803386],
              [92.273552648601608, 24.782936183621079],
              [92.278884469301715, 24.785211526331878],
              [92.283130202798858, 24.787213006701116],
              [92.283116826882335, 24.791275767481672],
              [92.279641024876895, 24.79478719471313],
              [92.274668131041622, 24.801456278617064],
              [92.274254362697604, 24.80633267448291],
              [92.273720393133971, 24.816626664843941],
              [92.272706767877111, 24.822856170389468],
              [92.271793044593494, 24.828723583648831],
              [92.264162926600889, 24.831408196399163],
              [92.258927119903305, 24.829405129493445],
              [92.253288932828667, 24.82929568228074],
              [92.247533542527805, 24.833070927034488],
              [92.247507902544044, 24.839211368429918],
              [92.248874850592301, 24.843913767693646],
              [92.249052132950496, 24.849332205613891],
              [92.246957007941688, 24.853027783642357],
              [92.24179707079422, 24.856894658377119],
              [92.23702781567718, 24.861033093069295],
              [92.236314667450813, 24.865728271009026],
              [92.243130255628174, 24.86963495100137],
              [92.246382475318512, 24.872536630758194],
              [92.249627976791203, 24.877695685748652],
              [92.25347399978061, 24.881501630465117],
              [92.253652772562006, 24.88601756638764],
              [92.252047581970558, 24.891702138986933],
              [92.247178257432111, 24.895930496953117],
              [92.243498591804055, 24.900072731806091],
              [92.243679850525993, 24.903958448655956],
              [92.250498300497441, 24.907682391759952],
              [92.258710023649812, 24.908793330909763],
              [92.270192985237713, 24.909734498904086],
              [92.276530357222398, 24.909303112181721],
              [92.280695162619594, 24.907781648662557],
              [92.285547816906472, 24.907707322009088],
              [92.292270299322951, 24.910436641240487],
              [92.298684593715947, 24.915784829400071],
              [92.303240288062526, 24.915979037233161],
              [92.307694397806642, 24.916262981499504],
              [92.312665400210818, 24.910228091213167],
              [92.312684762168487, 24.904898067948903],
              [92.315175266816695, 24.900750520643793],
              [92.324494123793741, 24.897345957001225],
              [92.332030395159734, 24.8933032711697],
              [92.337988404375011, 24.888080526630691],
              [92.343153489441093, 24.882945320163429],
              [92.348895648815656, 24.882961584390291],
              [92.350957363936999, 24.887755117254795],
              [92.355702030036539, 24.890205984136095],
              [92.357498214770118, 24.88578345262318],
              [92.362759587836692, 24.881192645352105],
              [92.365641215121357, 24.877495551514187],
              [92.369310897911845, 24.875067817267563],
              [92.374262012013858, 24.874628575762888],
              [92.379317049548945, 24.872472007923175],
              [92.381997954769787, 24.869678924362805],
              [92.385483551798416, 24.861920288209827],
              [92.396093357290624, 24.855082138538464],
              [92.402723838023817, 24.855366444047807],
              [92.407464367617067, 24.8591707947839],
              [92.41081705235959, 24.863514183800572],
              [92.416655820939525, 24.863980633505896],
              [92.420525123323088, 24.860194844035551],
              [92.424093770430048, 24.858035628860922],
              [92.430430943639777, 24.857415394451287],
              [92.43804611133514, 24.859600292804426],
              [92.443366347985588, 24.868552757179128],
              [92.451173308058628, 24.874167613962381],
              [92.457404392952071, 24.87580613496576],
              [92.464433074978842, 24.875278440455332],
              [92.473549518636389, 24.871501987374756],
              [92.481376468494844, 24.86817499674417],
              [92.487217054162315, 24.866829169777681],
              [92.493355998993692, 24.866750704456557],
              [92.497806772358658, 24.867931767946594],
              [92.49898283496853, 24.873986521114066],
              [92.497784588246148, 24.879132005591625],
              [92.494603485503987, 24.884908675252358],
              [92.49429374970363, 24.890958375118721],
              [92.495471695608373, 24.896200543783674],
              [92.495548279632231, 24.90613604019374],
              [92.491368462692762, 24.916605763035435],
              [92.490071700123693, 24.921390778603492],
              [92.486493113893914, 24.927616484500422],
              [92.484406761313423, 24.931044907656418],
              [92.487866435739662, 24.93376162416769],
              [92.489838011767489, 24.937378045085918],
              [92.488738012316674, 24.942343479995575],
              [92.48437920454829, 24.942967537230981],
              [92.478436333648219, 24.943228254162904],
              [92.47150574996931, 24.942491821807142],
              [92.465368211463158, 24.94157665161838],
              [92.460120907841798, 24.941115551253148],
              [92.45506694052186, 24.942279814000052],
              [92.451489285866899, 24.947239687529354],
              [92.451673182820045, 24.952570098197839],
              [92.456026210066881, 24.954384572498636],
              [92.461176994650856, 24.955207813161401],
              [92.464636581727177, 24.958015048553932],
              [92.465911767951383, 24.962532890720436],
              [92.459562517720812, 24.966946961845114],
              [92.454109860804422, 24.969102849466459],
              [92.448958104685744, 24.969454137152919],
              [92.443509410589414, 24.969082204680287],
              [92.43766709512775, 24.968166659938909],
              [92.431028467783747, 24.969598783073856],
              [92.422989658637519, 24.974457779055427],
              [92.419903936264248, 24.980230466056877],
              [92.419884008063107, 24.98736772443489],
              [92.420269142831501, 24.991793575726867],
              [92.422529929934271, 24.998481383573896],
              [92.422713616542367, 25.003449316815242],
              [92.425175076083832, 25.00923731083844],
              [92.42703667438775, 25.017549025353222],
              [92.426819607309497, 25.024593350270845],
              [92.425387888415472, 25.029536487968283],
              [92.418369563130284, 25.033878212526254],
              [92.411436136011346, 25.032598974602575],
              [92.404794169937006, 25.033035252010652],
              [92.397048486138942, 25.038163452698825],
              [92.392379116033098, 25.041404106521927],
              [92.386823647167773, 25.043467255526942],
              [92.379191207555451, 25.043629781505064],
              [92.372744524420099, 25.044607672338518],
              [92.367974408351429, 25.048929695455101],
              [92.359948869081322, 25.047555315554302],
              [92.352216815443427, 25.047803945714193],
              [92.347947371214772, 25.049959399297162],
              [92.345550595712155, 25.055102346218767],
              [92.346422306154494, 25.061064720203429],
              [92.347001345006234, 25.065943613796481],
              [92.345500665301188, 25.070546457270581],
              [92.34408813856399, 25.077497193758472],
              [92.336537745942138, 25.081902692778648],
              [92.331677172250167, 25.082338700306362],
              [92.326726281977983, 25.080429097423991],
              [92.321094840019043, 25.07535489045128],
              [92.316146465493745, 25.072810200718138],
              [92.311590130412739, 25.071261470897383],
              [92.305148002802895, 25.071151512743505],
              [92.300387120682288, 25.071499139902937],
              [92.293238130056722, 25.074006519080392],
              [92.286490595644921, 25.076152203929112],
              [92.281624240265486, 25.078123889764175],
              [92.277252042810701, 25.08072942137801],
              [92.271989168418173, 25.082247187221995],
              [92.265039252828103, 25.084753779191843],
              [92.255506313290013, 25.08842382273146],
              [92.247167076718199, 25.09083489197274],
              [92.240213783811257, 25.093880482415301],
              [92.232465852350245, 25.096563023701901],
              [92.225206489681042, 25.101686459134541],
              [92.216053453545427, 25.108335395372869],
              [92.21237016532676, 25.111121781041291],
              [92.218107890675299, 25.114485111363408],
              [92.225744099284995, 25.114512874223657],
              [92.227813288023427, 25.117952511102331],
              [92.222343397769805, 25.121092749284358],
              [92.20983483736515, 25.123666634847794],
              [92.202788675740138, 25.124815115619771],
              [92.198206844528485, 25.128772613739883],
              [92.194908990220526, 25.134087383322111],
              [92.190739219913112, 25.135426176997182],
              [92.187379739396121, 25.132613444275577],
              [92.191270309550063, 25.127481268379444],
              [92.192884103045031, 25.121707733329742],
              [92.186936868648843, 25.120962417258067],
              [92.178995052730457, 25.122736492798936],
              [92.171537300295498, 25.126681859958563],
              [92.166859746073428, 25.129733234944084],
              [92.161289612957447, 25.132783158783941],
              [92.152837408184268, 25.137083654701094],
              [92.142700522153206, 25.140924312165843],
              [92.138624162691542, 25.142714680132862],
              [92.137663506161218, 25.156257242416412],
              [92.125512155355253, 25.165327912348733],
              [92.114773900774708, 25.169616582844043],
              [92.107910622120045, 25.172926610633176],
              [92.102441289150775, 25.174980031094687],
              [92.096976325122625, 25.176673025212882],
              [92.090508426914056, 25.179894092632221],
              [92.084534002890749, 25.183299552569121],
              [92.077674739058764, 25.185615744930658],
              [92.065260834671392, 25.187273585401744],
              [92.060405082595892, 25.185986152964734],
              [92.054668860766242, 25.182979290645193],
              [92.04961552154586, 25.181690543197838],
              [92.042455493565996, 25.184186198236397],
              [92.038384017857652, 25.184616761541836],
              [92.033236069897413, 25.182604558976429],
              [92.029264275350997, 25.182947662820684],
              [92.019216936477093, 25.187143008512066],
              [92.013949554745437, 25.188559442358873],
              [92.005224438095254, 25.187071013921159],
              [91.998695501828763, 25.18405809326271],
              [91.993953952834048, 25.18042179468236],
              [91.990021924246548, 25.174711985735104],
              [91.986273269073862, 25.170990534566442],
              [91.977734660866176, 25.171938773349407],
              [91.972549893429459, 25.175973999044587],
              [91.967072477896508, 25.178925089929745],
              [91.962396797282636, 25.180615375349024],
              [91.955342880947569, 25.182112621083011],
              [91.950179406203802, 25.182717297419089],
              [91.938768370923327, 25.182473152472443],
              [91.930237183798127, 25.182156250599654],
              [91.916442052094027, 25.182259693081832],
              [91.908713272086757, 25.180678936243059],
              [91.901870823834415, 25.180097658351304],
              [91.895422377453514, 25.179790775760107],
              [91.885818186711489, 25.176933189240376],
              [91.879078915742326, 25.175811402961678],
              [91.87472260358895, 25.174520975091781],
              [91.86231936466767, 25.174445366332989],
              [91.854774737011752, 25.174942677199713],
              [91.844232332811259, 25.17812900683947],
              [91.83927885665733, 25.177014045885212],
              [91.833154679599943, 25.173364224197542],
              [91.824916945251402, 25.173583497564476],
              [91.819382545428425, 25.170839219437497],
              [91.815215873658516, 25.170720889625802],
              [91.809475436514589, 25.168789867951318],
              [91.804815676635542, 25.168488007945626],
              [91.798867121799205, 25.167907831161649],
              [91.791224618504828, 25.167949181826454],
              [91.785769633145975, 25.167821696027104],
              [91.781608177865138, 25.167072351333552],
              [91.774964865145606, 25.166486784362501],
              [91.769109008564428, 25.166718566849557],
              [91.760364015812939, 25.168555932403066],
              [91.755590800636526, 25.169789227269639],
              [91.749725943332663, 25.171102757758476],
              [91.746886245686781, 25.166568887886761],
              [91.749212605820418, 25.161167100247685],
              [91.750536875996659, 25.157021134466671],
              [91.750665594388565, 25.153319675204614],
              [91.747038356777239, 25.148058049544314],
              [91.739981958717507, 25.149455649219753],
              [91.733620490823427, 25.151127502974152],
              [91.729642010395409, 25.152273071574964],
              [91.724255863642028, 25.155576361303691],
              [91.71918606243581, 25.156806447323053],
              [91.714218768068079, 25.157584695975054],
              [91.707882158331074, 25.156183467545649],
              [91.705657630405909, 25.149575641385585],
              [91.700946301990442, 25.143492987135545],
              [91.697208692361798, 25.139854346590909],
              [91.691971385527012, 25.137559994822631],
              [91.685332221066005, 25.13669822761468],
              [91.68106265971393, 25.137210270754238],
              [91.674918334777416, 25.136623871711389],
              [91.66812709918139, 25.130522866299867],
              [91.663876575166498, 25.128867145563586],
              [91.659695690670731, 25.130551851997541],
              [91.653647403390451, 25.130325412967899],
              [91.650015316537363, 25.126146251824132],
              [91.645076707926762, 25.123760221440847],
              [91.637723929792813, 25.125420822902395],
              [91.631131076616867, 25.130247060347315],
              [91.629267109042701, 25.138720684828236],
              [91.627047372877229, 25.14303884212524],
              [91.621661489474789, 25.146068528650268],
              [91.617298854339239, 25.14585332814206],
              [91.612853047541293, 25.143922341911747],
              [91.608103248157178, 25.142531458412609],
              [91.604000168581507, 25.146382689215027],
              [91.606821120792191, 25.152364062840213],
              [91.604469723793713, 25.159568784437653],
              [91.604607822339418, 25.16607208004044],
              [91.611283328189828, 25.171696172981829],
              [91.605930383737572, 25.173124573277736],
              [91.595728911724379, 25.171149242846965],
              [91.587797795948063, 25.170545656256191],
              [91.582644762511023, 25.169601098161767],
              [91.579104190009801, 25.166593473200052],
              [91.57745241871504, 25.162878247156232],
              [91.572024442675612, 25.159945878727811],
              [91.564109561324003, 25.157444027422979],
              [91.560078717331677, 25.153799700819981],
              [91.556833292961244, 25.150794107820637],
              [91.550508348931459, 25.14839396886633],
              [91.544764871612273, 25.147263253802087],
              [91.540115486894791, 25.146053270377884],
              [91.531005761651812, 25.144262493093937],
              [91.522183856479444, 25.143646001090143],
              [91.515829023259514, 25.144136567335742],
              [91.510864486959548, 25.144545937719705],
              [91.507209587573016, 25.143070807195123],
              [91.506751958890391, 25.139364510031946],
              [91.503307603486718, 25.136626146890883],
              [91.496092767447692, 25.134126352578487],
              [91.488750453537349, 25.134245164613173],
              [91.480513730310079, 25.134536133143008],
              [91.473955756271806, 25.135563367989441],
              [91.470494721110754, 25.143929316534621],
              [91.469847842104784, 25.148888909732065],
              [91.466357641786814, 25.150664258400351],
              [91.459611235928207, 25.150696693496766],
              [91.453873241742755, 25.149112533712678],
              [91.449009926523701, 25.149248449601192],
              [91.442337913884927, 25.151628275739849],
              [91.43913156445285, 25.154578126602683],
              [91.43485946121119, 25.155173387857946],
              [91.426941335039544, 25.162596821839646],
              [91.423927461451314, 25.166000483269837],
              [91.421808146917343, 25.169231922877554],
              [91.416917191995708, 25.171896395112046],
              [91.412009260484254, 25.166885698509368],
              [91.406965591211048, 25.165575827610887],
              [91.399593341136793, 25.168035510360287],
              [91.391140741046243, 25.169764716343249],
              [91.386110896933147, 25.167189385912714],
              [91.379370498219473, 25.1665859328055],
              [91.375267044701502, 25.169526477597536],
              [91.371361899320291, 25.172650926124138],
              [91.365573911292728, 25.175575650308968],
              [91.359509021482623, 25.176692510584946],
              [91.35506090410243, 25.175204217957972],
              [91.348350488938365, 25.171889839822228],
              [91.341391807317336, 25.173087712088229],
              [91.336514289411809, 25.174394853075675],
              [91.330730644743909, 25.176868208336892],
              [91.329773843953888, 25.182276796404132],
              [91.323891241034929, 25.18447675533012],
              [91.319331008142655, 25.1841612419333],
              [91.315270697092714, 25.183400329764709],
              [91.310012351315748, 25.18334801428459],
              [91.304348519071183, 25.183924189708886],
              [91.298483752556848, 25.184770550756916],
              [91.294495014529915, 25.186354972537032],
              [91.293521806278534, 25.193025772449076],
              [91.288713670680266, 25.196771867629206],
              [91.281917673173297, 25.200586377060759],
              [91.277309707522861, 25.204059438844293],
              [91.267657815906105, 25.206220271880397],
              [91.259204066138295, 25.19936493739792],
              [91.255066460353802, 25.196974213572073],
              [91.244854345790273, 25.196148238847883],
              [91.233333550223676, 25.196751221810466],
              [91.225176816053036, 25.198202046550662],
              [91.215926817449301, 25.19982136652952],
              [91.196181830975618, 25.199253258982772],
              [91.18855668043777, 25.197909955240643],
              [91.183925540957304, 25.195332255471968],
              [91.176892264169297, 25.194354526588519],
              [91.169941009497151, 25.194732285273354],
              [91.161777876453812, 25.196629825717203],
              [91.152559421086337, 25.195718174792205],
              [91.144154721405457, 25.193279602644182],
              [91.137716790273544, 25.1923963654746],
              [91.128284362704164, 25.192563695782166],
              [91.124009397002453, 25.193148069973091],
              [91.118145244752696, 25.193805278799658],
              [91.11037953359471, 25.195524430302761],
              [91.102104657456294, 25.198320132671682],
              [91.097122558538729, 25.19980093545264],
              [91.091063563429316, 25.200182592672498],
              [91.084496702509668, 25.201373310175747],
              [91.075323053441124, 25.197117509237351],
              [91.071003185271891, 25.193817244285054],
              [91.066765523615601, 25.191602834596843],
              [91.062300911201703, 25.191550901830972],
              [91.058243133409789, 25.190693243939464],
              [91.053181221360219, 25.19072446413071],
              [91.048131563591724, 25.189853121744935],
              [91.03862994861818, 25.188028898098199],
              [91.027951215629258, 25.185285833392896],
              [91.022719050775549, 25.183328955445614],
              [91.017080153136021, 25.181999815319397],
              [91.01164411091591, 25.18049031151125],
              [91.004815895920061, 25.179147026289339],
              [90.998881727814677, 25.177721440631103],
              [90.990965745258691, 25.176184889737762],
              [90.9839412701767, 25.174746041112673],
              [90.978003826090145, 25.173591979740628],
              [90.972593144301996, 25.172033553074879],
              [90.968517069735171, 25.170858742867406],
              [90.958513164706673, 25.169746060812052],
              [90.947809225518242, 25.168802390789626],
              [90.937714505711313, 25.167144811499103],
              [90.927633117928195, 25.164402002763783],
              [90.916945713568211, 25.162555948140351],
              [90.911502624420095, 25.16149540812647],
              [90.901838400252359, 25.164081380098438],
              [90.894573885578922, 25.165615538666341],
              [90.889805752029346, 25.165917428982631],
              [90.879852433062311, 25.161457810411743],
              [90.87234646402861, 25.15910544902621],
              [90.857761814306954, 25.159100037764173],
              [90.844034526842592, 25.161271720347901],
              [90.837283144589165, 25.161544765961526],
              [90.822475645287511, 25.162976094246602],
              [90.811798531450009, 25.16680856541495],
              [90.803978556056862, 25.171849591636253],
              [90.798819576302449, 25.178009306937813],
              [90.793100519074073, 25.181814115455143],
              [90.783055099092735, 25.183215071318497],
              [90.77801760280326, 25.181704862125471],
              [90.774415197090363, 25.177505195643505],
              [90.769780600772833, 25.169589365321517],
              [90.763410703161469, 25.164630980655893],
              [90.755673020175905, 25.164525156479225],
              [90.744360447165377, 25.164644215618132],
              [90.742434751468167, 25.16100617887362],
              [90.743198453143563, 25.156865576678658],
              [90.740283029299476, 25.153126679100218],
              [90.735006300610578, 25.154137384218949],
              [90.729661411518308, 25.159389804250658],
              [90.723626943465234, 25.16427047893761],
              [90.717772242313657, 25.164280177691822],
              [90.711471319473503, 25.161305765136568],
              [90.704160037444083, 25.15949014656351],
              [90.696425691323398, 25.159201344250199],
              [90.691837392368868, 25.160582244042402],
              [90.686983501435932, 25.165929968960686],
              [90.682857774825095, 25.16939203318471],
              [90.677836708178305, 25.166973882518835],
              [90.671404268840448, 25.17184703669621],
              [90.669711542735385, 25.177869941334606],
              [90.667919400204596, 25.184073606147148],
              [90.658048021863124, 25.192597320888716],
              [90.654921242817665, 25.189754190049772],
              [90.654305436643853, 25.185142695357271],
              [90.652690538492649, 25.180969838177401],
              [90.646670290986719, 25.17898703812736],
              [90.639844474980166, 25.177717668821124],
              [90.639236757899866, 25.172653753832289],
              [90.633097201337947, 25.171936019159666],
              [90.622579056312944, 25.171964893138743],
              [90.615111812633089, 25.17339096305966],
              [90.599534376064611, 25.173165126647085],
              [90.57624335758527, 25.171560401575686],
              [90.5612842057227, 25.170076773936191],
              [90.54947309752167, 25.170352102864094],
              [90.52251880622309, 25.168231726624082],
              [90.513295714198506, 25.167912061947305],
              [90.500075153053956, 25.163742327566396],
              [90.492880165000145, 25.161105861921683],
              [90.48745775831209, 25.159217925220474],
              [90.483151210861976, 25.156083538536095],
              [90.475456718929138, 25.153618949347159],
              [90.469728322141805, 25.152265935520568],
              [90.460509818781205, 25.151763111111045],
              [90.455679334228748, 25.150155262003306],
              [90.453262781901557, 25.146778383836988],
              [90.447473123719192, 25.143258419261283],
              [90.43830946816594, 25.145190553344666],
              [90.432837119659382, 25.146097777169128],
              [90.42795802523213, 25.147013965233963],
              [90.423541691669584, 25.149652353146156],
              [90.418558454133887, 25.150836732091364],
              [90.412315472866027, 25.155520045650636],
              [90.401156434069563, 25.157869672486438],
              [90.392208377662513, 25.158901960074278],
              [90.386437455652427, 25.159710724813603],
              [90.380254809678817, 25.161235522200311],
              [90.376642728248882, 25.163254833692342],
              [90.369041868011266, 25.166379868617113],
              [90.360927419674752, 25.170219286943386],
              [90.355004689324559, 25.173642458734736],
              [90.351067583261838, 25.177098804362913],
              [90.345324896209078, 25.181427079740825],
              [90.338947666840312, 25.187728144092929],
              [90.334611484209717, 25.191177850817926],
              [90.326818826521958, 25.188704332157862],
              [90.317715206339827, 25.187379845300452],
              [90.311873365020006, 25.186651872344328],
              [90.30780848915154, 25.186404582206748],
              [90.303825811319996, 25.187150985468072],
              [90.299348598406681, 25.187617210328678],
              [90.294262049361222, 25.188885960172261],
              [90.288023330436374, 25.193024156525709],
              [90.284508423401832, 25.195130471614618],
              [90.278306964440858, 25.197463488807827],
              [90.273858459852889, 25.196576508438298],
              [90.269699783686889, 25.196056587924623],
              [90.263169852247387, 25.194953217497019],
              [90.257697738170918, 25.195674222942245],
              [90.249766944053007, 25.199961037664497],
              [90.242677008390828, 25.202005692590919],
              [90.236498576750023, 25.203254577346407],
              [90.228283544745182, 25.202031974970232],
              [90.22381534661281, 25.202135872461],
              [90.217351866970958, 25.202656849673069],
              [90.210413663778354, 25.206957968953354],
              [90.2051929788, 25.209754562224287],
              [90.198890433657326, 25.21208271331939],
              [90.19067260382181, 25.21572914804047],
              [90.180789995575864, 25.218354356089392],
              [90.172090577070378, 25.221179208962607],
              [90.162523304991581, 25.222998181084652],
              [90.153775085208977, 25.223475584814917],
              [90.142140444275626, 25.22435336532963],
              [90.134399598712847, 25.224214199023542],
              [90.127087297938743, 25.222641399025377],
              [90.121924432203187, 25.222550592944039],
              [90.115248342368389, 25.223693854413902],
              [90.109703491009569, 25.227654310337641],
              [90.103600996441727, 25.234220843242145],
              [90.096979439573715, 25.237439601025088],
              [90.090305570840556, 25.238311916408648],
              [90.084538776645843, 25.238659403661455],
              [90.080743402851013, 25.239763531624963],
              [90.075200040999249, 25.243452858511674],
              [90.068901555687958, 25.249924338950347],
              [90.062720605339891, 25.255495034150474],
              [90.054998732223567, 25.258782996806726],
              [90.046203048168422, 25.261326536789028],
              [90.034530579806145, 25.263638589010611],
              [90.021612619828204, 25.268450650353607],
              [90.012409429506647, 25.271347527452662],
              [90.006692267711557, 25.273768525364616],
              [90.000867849354378, 25.276545193746571],
              [89.994752315344613, 25.279048543658607],
              [89.983793840795855, 25.284795570740037],
              [89.980906320259336, 25.289432127627553],
              [89.980802732527323, 25.294031153331499],
              [89.979325887973701, 25.297792815299502],
              [89.975090998927811, 25.300509516348722],
              [89.964881026554636, 25.299504631538397],
              [89.95265546735645, 25.299722792470725],
              [89.944226864148902, 25.299021488463829],
              [89.93210689756053, 25.299059747163746],
              [89.923655043167187, 25.30358821880915],
              [89.916746078567797, 25.30589151314777],
              [89.910951269086851, 25.307312438366178],
              [89.902668841568854, 25.304628468564356],
              [89.896639665366621, 25.299008069173748],
              [89.893560576050859, 25.294799740207868],
              [89.886707063276589, 25.290516307805788],
              [89.877460832028234, 25.286727732656075],
              [89.872196579503481, 25.286626728644901],
              [89.86528746374529, 25.288925452243681],
              [89.858892217103246, 25.2905132439898],
              [89.853584238176765, 25.29230375100197],
              [89.847995676369734, 25.293366148621356],
              [89.842727432169937, 25.293533993052019],
              [89.837711900805417, 25.295509637347187],
              [89.839991136611445, 25.304032523951445],
              [89.84277198924724, 25.312294863944693],
              [89.842935517375594, 25.317981630109241],
              [89.841443454353069, 25.32210202019715],
              [89.838176750989987, 25.32573602459809],
              [89.831920573667162, 25.329670955604225],
              [89.829452330417382, 25.333139904653937],
              [89.823152968015322, 25.346993754188688],
              [89.818290700478173, 25.363132334406405],
              [89.816843497272956, 25.36941874460156],
              [89.818575728652121, 25.388123469668535],
              [89.822255989745628, 25.396315086586455],
              [89.828946116330684, 25.403303666936811],
              [89.830614723800039, 25.408298762431478],
              [89.831372355729229, 25.413996683368747],
              [89.832117028071963, 25.420144639653422],
              [89.833412399639855, 25.424137593399617],
              [89.835176357047629, 25.429314457287408],
              [89.837044186536858, 25.434403075997686],
              [89.841239254639447, 25.441883664366856],
              [89.844938660156004, 25.449262462486583],
              [89.851128990124948, 25.456602616935761],
              [89.855854740474228, 25.462737702923985],
              [89.857525174201967, 25.467732338502017],
              [89.85611518185955, 25.476634872405111],
              [89.854394369327494, 25.482013296916481],
              [89.855578197847549, 25.490694466352657],
              [89.857063955132361, 25.499203587113481],
              [89.859515040641583, 25.508993454985344],
              [89.862512566925716, 25.516720669820756],
              [89.863255176725033, 25.523048069395106],
              [89.861130641970803, 25.528598963165923],
              [89.856236468989323, 25.537523258283652],
              [89.858431215600532, 25.541444932865431],
              [89.864027513181085, 25.544622694156196],
              [89.870125110034536, 25.547809401990083],
              [89.87477606895574, 25.557192276919693],
              [89.876268019056667, 25.565520915296108],
              [89.879197364918312, 25.576221548374054],
              [89.87423152739494, 25.588030286429181],
              [89.875333679373753, 25.591931051611361],
              [89.879072365475707, 25.597866443494365],
              [89.883235031910473, 25.615267625607231],
              [89.883085677557787, 25.621490131396616],
              [89.881152137642417, 25.631462520006572],
              [89.871935893511349, 25.6541023821704],
              [89.866209239021074, 25.664271125412156],
              [89.848029238308186, 25.690517002894794],
              [89.849294220855398, 25.695863450611725],
              [89.851988163209583, 25.699796596854544],
              [89.856532819599707, 25.705569366801232],
              [89.856504947296969, 25.714859097089683],
              [89.84713766500667, 25.714671153288407],
              [89.840259646621078, 25.714714211019619],
              [89.836098450011136, 25.7176983764056],
              [89.829830805012065, 25.729297892270367],
              [89.827322269095546, 25.737995741719864],
              [89.828516872981808, 25.742078434020488],
              [89.834151148972083, 25.748144756686688],
              [89.840957909259501, 25.755227767271673],
              [89.843405167892854, 25.761048965904656],
              [89.841893251394538, 25.765798019430754],
              [89.838308012910389, 25.7736630660761],
              [89.835354836322608, 25.784157336909796],
              [89.833478529277912, 25.791516655878223],
              [89.831055422880127, 25.804725796460239],
              [89.827286361783834, 25.811864559964377],
              [89.821480108098442, 25.812739622864687],
              [89.818876745435091, 25.81710764236929],
              [89.822960153993023, 25.821337527472501],
              [89.82984867243448, 25.829324503623678],
              [89.83522868002558, 25.837732771949625],
              [89.834766763199028, 25.85224353765901],
              [89.836181081489542, 25.867696438735024],
              [89.838355512628667, 25.872611826668944],
              [89.840523666971663, 25.877794749277832],
              [89.851001115811783, 25.890092478026453],
              [89.873996641165377, 25.913103466547987],
              [89.883465618427707, 25.930161495544514],
              [89.885176247350998, 25.933712700855729],
              [89.887569566691738, 25.937998792140569],
              [89.887068882302287, 25.94204904232933],
              [89.879520194302856, 25.944424142941145],
              [89.868854250028747, 25.943578993439683],
              [89.857537655988864, 25.940736267778448],
              [89.851242181017852, 25.940878800326228],
              [89.844656156470293, 25.940565735121147],
              [89.838212640151454, 25.942689587308372],
              [89.833977873814689, 25.944227442459706],
              [89.831211353947182, 25.947057493069195],
              [89.841106635889119, 25.95483476373543],
              [89.848364624373488, 25.956155468443296],
              [89.847422180330099, 25.961907215174548],
              [89.845249053337653, 25.965020884185734],
              [89.841382412112083, 25.967828155708244],
              [89.844768153420645, 25.972226042656466],
              [89.851160962320776, 25.972355401370052],
              [89.859330297935671, 25.969183341619676],
              [89.8681934076277, 25.97035302336808],
              [89.871549215413324, 25.97610421829868],
              [89.861812707721541, 25.986009356303271],
              [89.857674228580976, 25.987639645672981],
              [89.854856452478629, 25.992453828292764],
              [89.850105770374881, 25.994702225503154],
              [89.846753417337865, 26.000858592823331],
              [89.84345386518288, 26.004941131423504],
              [89.835203218209969, 26.007208563660608],
              [89.833675194259854, 26.00032356068332],
              [89.833804797516223, 25.995184320095532],
              [89.835510819253258, 25.990889560796408],
              [89.83522717257695, 25.98628480721645],
              [89.828174681623835, 25.984517702241583],
              [89.822427933735995, 25.986654061799744],
              [89.818670258509684, 25.989012876211426],
              [89.821282057246293, 26.012335898992518],
              [89.820950701044083, 26.01756118744504],
              [89.821498993998546, 26.023615386897497],
              [89.818322576860766, 26.030676623407274],
              [89.817429383866681, 26.034356618471403],
              [89.813131735799288, 26.038327140120394],
              [89.809772676649189, 26.032754854888761],
              [89.806217052812244, 26.027090976575813],
              [89.799046772763575, 26.018193975485577],
              [89.79227940269918, 26.017062888325377],
              [89.793456007038074, 26.021867058287945],
              [89.79675304650732, 26.025903955415799],
              [89.800484928127887, 26.02850456870916],
              [89.802181508799251, 26.032508593013336],
              [89.804692622808432, 26.035988027893435],
              [89.803303120121697, 26.039566065228204],
              [89.798254277065993, 26.037660333985762],
              [89.796165333373466, 26.0332866040198],
              [89.792239761373281, 26.038011923037498],
              [89.787529013233765, 26.038791095908319],
              [89.778546892183968, 26.035487175073104],
              [89.786281934661844, 26.044536440329175],
              [89.792855831232757, 26.045484006941113],
              [89.791548646462175, 26.049788018408968],
              [89.788161316632809, 26.053235375888622],
              [89.797019680074087, 26.058737990098351],
              [89.801219791484129, 26.058645273115701],
              [89.801990224226955, 26.063801311240137],
              [89.801367128019479, 26.068568676800467],
              [89.801351074744304, 26.073169725169539],
              [89.796072683833373, 26.080185583902189],
              [89.797453731320729, 26.088393157657684],
              [89.789805114871925, 26.082850868070377],
              [89.786124457177564, 26.086022460133314],
              [89.786493713561299, 26.095047670697944],
              [89.788826003608975, 26.101590625326278],
              [89.787513680639336, 26.106072007018916],
              [89.778901805887983, 26.106435141154545],
              [89.771292988620147, 26.106637234216937],
              [89.765041002259409, 26.112550801750363],
              [89.768878462325233, 26.122732134262577],
              [89.770549589826913, 26.127817809104023],
              [89.769942491292412, 26.131952797125095],
              [89.762674508792585, 26.138384299631031],
              [89.757213469718963, 26.144492883733399],
              [89.753093376078752, 26.152884023010373],
              [89.748195555116141, 26.156568662808045],
              [89.739146058534558, 26.158183452441357],
              [89.732599549043371, 26.155969837353872],
              [89.727997159908583, 26.15596299913808],
              [89.724055497677611, 26.157503406125944],
              [89.722720904953192, 26.165569000411264],
              [89.719141010604886, 26.166683653172033],
              [89.716192909222698, 26.156980449081559],
              [89.713935882031237, 26.153816732281538],
              [89.709686034426582, 26.15360304748295],
              [89.70667216694595, 26.156092190012654],
              [89.704582197678803, 26.160601716674467],
              [89.700553665022994, 26.163115492453411],
              [89.693365748976987, 26.16530591834502],
              [89.688691955691837, 26.168003200919443],
              [89.689969066028425, 26.172021690955482],
              [89.695801968485412, 26.17303310154103],
              [89.699914060275447, 26.172606763821282],
              [89.698795086563777, 26.177561103251236],
              [89.692194807745139, 26.183566578646413],
              [89.688585283006333, 26.193480395026398],
              [89.684834364566086, 26.198029837769855],
              [89.677424255799735, 26.202282477226031],
              [89.679054502754298, 26.208467020609348],
              [89.688092485199007, 26.209882997794267],
              [89.694274396927241, 26.211821646159382],
              [89.687552588548712, 26.216485275581938],
              [89.689228497470324, 26.220039472461799],
              [89.69609659209064, 26.221872848524299],
              [89.688227641100653, 26.2258191373183],
              [89.683461220725846, 26.230146624610192],
              [89.675737237769241, 26.228311027716067],
              [89.66855936236523, 26.223463308735525],
              [89.664429997266865, 26.222235885180755],
              [89.658170276175767, 26.222943930624016],
              [89.648777176685854, 26.228738678741976],
              [89.644439782000717, 26.22698199089055],
              [89.642338862420431, 26.222414086183534],
              [89.641400586556685, 26.219044443707027],
              [89.641079359457393, 26.215531721694902],
              [89.643040672665208, 26.210106126196866],
              [89.647554516927073, 26.206027136534313],
              [89.649294285929699, 26.20193199341545],
              [89.651913230717383, 26.19560794841999],
              [89.649251409783659, 26.192447169255392],
              [89.645740172963229, 26.192688368019553],
              [89.637357525307792, 26.196661977426636],
              [89.635082302217484, 26.194235199923718],
              [89.635720311210633, 26.188881260910978],
              [89.640595978300524, 26.186157389970155],
              [89.647339396032805, 26.186091868780398],
              [89.653464881693466, 26.184075586343287],
              [89.658735283051172, 26.184519437957956],
              [89.660203039162369, 26.177279660898037],
              [89.657619009807675, 26.174347795769435],
              [89.656401082650632, 26.169388762892083],
              [89.649862659344365, 26.169707239177345],
              [89.644405081663464, 26.172800874219959],
              [89.6412031700673, 26.17999875724443],
              [89.636649065304027, 26.180127316306592],
              [89.633916437431537, 26.177815023770485],
              [89.628402945682112, 26.179989489851827],
              [89.624897152640912, 26.181676393068585],
              [89.619188596569288, 26.179923853888674],
              [89.617701242576786, 26.177172741718501],
              [89.617764357259432, 26.173841501980817],
              [89.619482610894153, 26.171081233196432],
              [89.619106795412861, 26.166603670568986],
              [89.616799262890126, 26.162473787997573],
              [89.613280514650924, 26.160234071709468],
              [89.605561723466536, 26.164318834743128],
              [89.598527454277473, 26.161720423998982],
              [89.59726954286721, 26.158782885941974],
              [89.600262689106685, 26.156637858474081],
              [89.601230226836122, 26.15045715761979],
              [89.603439006618956, 26.143057362897029],
              [89.604948609643884, 26.138987575126752],
              [89.607769098685296, 26.1256590458487],
              [89.60836081186261, 26.120924512135414],
              [89.612889175619927, 26.120913092656821],
              [89.615642104044383, 26.122697328322435],
              [89.619146604209035, 26.121056609843173],
              [89.622625995750568, 26.119509166817767],
              [89.62503325244613, 26.123567402485506],
              [89.629378083241889, 26.128401465398589],
              [89.630706675142264, 26.124010812499737],
              [89.630382882292153, 26.119256453893254],
              [89.628631996012359, 26.114530447211816],
              [89.61862613035629, 26.11207831560094],
              [89.610086060538308, 26.113432832786433],
              [89.604710586391803, 26.111861657254458],
              [89.603291751252542, 26.106697683454104],
              [89.599166198587369, 26.105330249444663],
              [89.598157936287677, 26.101267931760237],
              [89.60475946150622, 26.098311023895103],
              [89.607234099302772, 26.094263064519176],
              [89.613265834545942, 26.089170687839431],
              [89.614533434507848, 26.094404229904971],
              [89.619123286698311, 26.097008511698132],
              [89.620058332830951, 26.101668584188847],
              [89.627079811326951, 26.102315684197325],
              [89.630074476273165, 26.106557059873218],
              [89.63563697761974, 26.105209063115623],
              [89.63905410240389, 26.09550567806463],
              [89.638899089583973, 26.088639945495043],
              [89.639187064945176, 26.079552706220458],
              [89.641551733027001, 26.076923764773092],
              [89.649182414864796, 26.071776760382345],
              [89.653388744295995, 26.06830858970288],
              [89.647824606588301, 26.063198558635694],
              [89.637665312833889, 26.063226857114959],
              [89.631721635077994, 26.061933254505895],
              [89.628276331696469, 26.058368049588751],
              [89.625630355151287, 26.056348429059348],
              [89.621547090575277, 26.058386322748223],
              [89.619721439821802, 26.063158474242641],
              [89.614706592318257, 26.0629336757587],
              [89.609974499190031, 26.067474500410583],
              [89.606803376503279, 26.066053770029875],
              [89.607177051214734, 26.061046330465832],
              [89.61335778539501, 26.055785228919188],
              [89.614782695811158, 26.049344286948291],
              [89.604623065171424, 26.049133249723102],
              [89.600789612622648, 26.047118187241526],
              [89.600102504491261, 26.040444066522994],
              [89.592993696091781, 26.044038484870288],
              [89.5908718951883, 26.041301719150994],
              [89.589724036787146, 26.034332119452028],
              [89.582832489638193, 26.02600436519063],
              [89.583474739141323, 26.020997618210046],
              [89.585698163553374, 26.016342311953185],
              [89.58643657656151, 26.002992164784406],
              [89.590505979313235, 25.998094756106479],
              [89.589945519616123, 25.989513798746181],
              [89.590516977435669, 25.983968980709097],
              [89.59129105479731, 25.979556819883545],
              [89.585353792632105, 25.978381053721197],
              [89.582314660350818, 25.976481195412795],
              [89.581491279800062, 25.968138651561052],
              [89.576216304187184, 25.967674361497583],
              [89.572271043497167, 25.970068447948663],
              [89.572555061238432, 25.975311326052392],
              [89.568326813487687, 25.97329625466892],
              [89.561973997603999, 25.966277299515557],
              [89.554065536166036, 25.966651920753666],
              [89.548279682006935, 25.970717179734248],
              [89.547776957720856, 25.977751157935103],
              [89.544768007859346, 25.985030910466246],
              [89.547438663884876, 25.994560063547677],
              [89.550224166925446, 25.998845452515418],
              [89.547734042416465, 26.00361914839911],
              [89.541682581232095, 26.007922566870882],
              [89.536668179811841, 26.006502151552066],
              [89.53290012971496, 26.003828124107034],
              [89.522886002012896, 26.006352912184663],
              [89.51536454457117, 26.005294736408423],
              [89.509159427842036, 26.003041767643701],
              [89.503761384973785, 26.005434863749858],
              [89.494384293908922, 26.001518980541555],
              [89.48474784071395, 25.997603495210814],
              [89.477292615728359, 25.996008243339503],
              [89.458058372042586, 26.002833964132744],
              [89.445946263561495, 26.010123111416409],
              [89.431979065260506, 26.015267772881643],
              [89.436283002880174, 26.022474567339255],
              [89.429865188340372, 26.04048174922098],
              [89.42578229439502, 26.042871409539543],
              [89.410210999055977, 26.040867128327232],
              [89.404925196394544, 26.036223916324005],
              [89.402927594064181, 26.027881864897122],
              [89.395792873866355, 26.022644395638341],
              [89.395369582594938, 26.010367088921992],
              [89.385873587562628, 26.010140401768815],
              [89.381917932576371, 26.011336738015743],
              [89.372223659370633, 26.009976172907006],
              [89.357717462887791, 26.011180193633013],
              [89.344804053235947, 26.016794547957115],
              [89.337562127819439, 26.02347435117467],
              [89.329271401460488, 26.035281707525403],
              [89.325649750706134, 26.038800891713848],
              [89.313519679502662, 26.042146018342258],
              [89.301656840665714, 26.050021817553105],
              [89.294930802701728, 26.051096844635389],
              [89.286619919645076, 26.05014750160074],
              [89.282400652093798, 26.053009469320664],
              [89.283863917323913, 26.062305688155693],
              [89.281491304921119, 26.064692045855669],
              [89.276081360387778, 26.06302387342123],
              [89.270470186361521, 26.061535336302633],
              [89.262823098965825, 26.066187175760451],
              [89.259667333181483, 26.074650699714073],
              [89.264428758809558, 26.084424300272762],
              [89.269577926599865, 26.088120242988811],
              [89.268395885596973, 26.093007211192134],
              [89.259819804296924, 26.094558328527402],
              [89.249797996985279, 26.10206968844675],
              [89.245842310956618, 26.106958662125333],
              [89.243470572809258, 26.110058182768832],
              [89.235228153956712, 26.117628536584977],
              [89.224279236777917, 26.126210410323417],
              [89.216622745577894, 26.12621024316735],
              [89.190352538520557, 26.130141138716397],
              [89.176689000044519, 26.131387671343766],
              [89.161509806840044, 26.139606704842759],
              [89.157287219983402, 26.149620031360232],
              [89.154385361444312, 26.154503972999791],
              [89.153858311569877, 26.169524306750716],
              [89.147125788033065, 26.17560145350625],
              [89.140853764852395, 26.185431465140386],
              [89.140723445617851, 26.193418895047241],
              [89.151028627188012, 26.207251835618255],
              [89.15119346724326, 26.214122619695136],
              [89.148471327389629, 26.222228624263824],
              [89.144323801557917, 26.228106250503686],
              [89.14246595417859, 26.236927751706151],
              [89.140429063046597, 26.242116797600627],
              [89.137195847843714, 26.243699221858439],
              [89.134929753226331, 26.246179171671091],
              [89.130424078903559, 26.24888802956178],
              [89.127647314165742, 26.254329367123834],
              [89.126170754859004, 26.262872809042822],
              [89.124896709217182, 26.265836874931654],
              [89.121459548566946, 26.269806821531503],
              [89.116136066084735, 26.279405008460287],
              [89.11287296184878, 26.282344411330808],
              [89.106605777690802, 26.289344049326722],
              [89.106860233029181, 26.292975132439956],
              [89.109230967105248, 26.29612306122473],
              [89.109484095502069, 26.299728855695886],
              [89.105610895764158, 26.30268888667316],
              [89.106579445295779, 26.306388754876266],
              [89.10956034179938, 26.30783725230981],
              [89.114144825245788, 26.306762765101556],
              [89.117661150689358, 26.303134934064481],
              [89.119139844298672, 26.299346610294965],
              [89.121153555745011, 26.292984914754381],
              [89.124412752413349, 26.292067214490348],
              [89.129406028313099, 26.298871430978441],
              [89.136872388613355, 26.316884149894427],
              [89.129204589493312, 26.319292742383666],
              [89.125102321479162, 26.319542070125816],
              [89.12138224696686, 26.320045564933704],
              [89.118374077074236, 26.323947281920653],
              [89.109633289914001, 26.323044396789644],
              [89.106600443865858, 26.326649958357649],
              [89.103238597477358, 26.325934807204444],
              [89.099823526467148, 26.32257873616134],
              [89.096128151343763, 26.321471051468087],
              [89.088944350904256, 26.321995214411885],
              [89.091082819494872, 26.325968965278928],
              [89.097325332476601, 26.329351057623576],
              [89.099821497821338, 26.33162762093734],
              [89.101450692650062, 26.339002089617086],
              [89.101960258897748, 26.345181766747377],
              [89.099460689057906, 26.355907325971742],
              [89.098084375133766, 26.359674457127277],
              [89.094311195400707, 26.362357733458701],
              [89.090028468707828, 26.361918928326492],
              [89.085771502868539, 26.362809632638168],
              [89.087783917716266, 26.365980887517342],
              [89.09229487562969, 26.368030295210932],
              [89.093669918758181, 26.371637918062749],
              [89.09303267767315, 26.377747457054998],
              [89.092599194403107, 26.381331215818268],
              [89.094687434590725, 26.384524237493451],
              [89.098179256199501, 26.390867600606182],
              [89.097821454787436, 26.394933698007328],
              [89.092313464981927, 26.396742382861454],
              [89.091292929521913, 26.399659702763735],
              [89.086755712789085, 26.399218495495223],
              [89.079743470943498, 26.397857820916435],
              [89.074212540993699, 26.394221870338512],
              [89.066433986401449, 26.396258993907391],
              [89.055138268595044, 26.396246566184068],
              [89.047104881085758, 26.398029440889793],
              [89.043332417622935, 26.397128882677098],
              [89.039356879323989, 26.394826066119794],
              [89.036501347594637, 26.400586051019062],
              [89.035681674961552, 26.406086270677022],
              [89.031812644553, 26.407549614903051],
              [89.028148624687503, 26.406993758367303],
              [89.024077527688561, 26.408088416519966],
              [89.022853852720857, 26.411937518816568],
              [89.019189503855017, 26.412115885489346],
              [89.01287931964572, 26.410640130821065],
              [89.009620566995181, 26.412835269462455],
              [89.009208003822636, 26.419986103386751],
              [89.005136874300334, 26.419979766764953],
              [89.000048857952791, 26.418506289915314],
              [88.996795769764063, 26.414650621502719],
              [88.995784417883556, 26.408047010828195],
              [88.98987988259573, 26.408771553414169],
              [88.986014653641021, 26.407298213372261],
              [88.981128392462949, 26.407106676959071],
              [88.980920228317217, 26.412240736303659],
              [88.983213592121515, 26.415580146068155],
              [88.984586273345329, 26.418960647762368],
              [88.984828380210388, 26.429618244722946],
              [88.986863284463809, 26.435961952807123],
              [88.98777853562548, 26.438925402353988],
              [88.988079111683135, 26.443866244564383],
              [88.984550115173079, 26.449486910899733],
              [88.979038160455644, 26.45152403627996],
              [88.970615779457489, 26.456264473850961],
              [88.967752900635872, 26.458901348148618],
              [88.964109591673022, 26.4562296955059],
              [88.964599665930564, 26.452395553572277],
              [88.957968535903731, 26.450360939903916],
              [88.953941696509517, 26.448102079076257],
              [88.954210301272155, 26.439947471182172],
              [88.952941144702052, 26.434294565985226],
              [88.950063679462275, 26.431533268104619],
              [88.93261783056073, 26.431614713763846],
              [88.932643079816074, 26.416087810683056],
              [88.932648590795566, 26.413009549875603],
              [88.931147806392886, 26.410064827885716],
              [88.920595211097748, 26.407332248279985],
              [88.916799251489564, 26.406314605219499],
              [88.915555999951906, 26.402177317973837],
              [88.917855790359894, 26.399860857108067],
              [88.919312446340257, 26.396946265163397],
              [88.91963161976777, 26.390147515538999],
              [88.916534523034628, 26.382905948959301],
              [88.9178663860245, 26.379393655355408],
              [88.918801135790318, 26.369588436643181],
              [88.921181491689737, 26.362999854939311],
              [88.924192685591294, 26.36165086886475],
              [88.930584564308376, 26.365062704476767],
              [88.93826185769278, 26.36229775325863],
              [88.9430045383791, 26.361021163647521],
              [88.94654667497538, 26.361717911558912],
              [88.953073153674666, 26.36058043122447],
              [88.955923459222006, 26.363527169365625],
              [88.959825956869381, 26.362637409330389],
              [88.959884524525137, 26.357836782497689],
              [88.956521817339421, 26.354912914362284],
              [88.954819508915975, 26.351786154779855],
              [88.954088179108965, 26.347490323992609],
              [88.957349980716472, 26.346576150052361],
              [88.960867133701967, 26.346124812670205],
              [88.960159166114892, 26.342723554341667],
              [88.958766839044102, 26.336861616566871],
              [88.959229622240045, 26.333187157237379],
              [88.962901223948961, 26.332344376967527],
              [88.965624083822789, 26.334140882746926],
              [88.967884130880336, 26.340256492566738],
              [88.968613239890772, 26.348411136168611],
              [88.971259424800806, 26.350897054864394],
              [88.976924164190834, 26.34730122916212],
              [88.98191299055712, 26.351812036139268],
              [88.985687099547022, 26.350920426930621],
              [88.989692874904819, 26.347092062446912],
              [88.992221737124396, 26.342111713870469],
              [88.991943425633877, 26.338870908921667],
              [88.991717576610782, 26.335793519333983],
              [88.995747035570872, 26.334213300608518],
              [88.99900958988384, 26.333323511354603],
              [89.002785397580652, 26.329928655800614],
              [89.004163024827051, 26.326325793016604],
              [89.001133613608417, 26.323473043462187],
              [89.001520807124919, 26.320303676293758],
              [88.992603590199806, 26.319047629406413],
              [88.990503447026484, 26.306158213098904],
              [88.996775524852026, 26.301205718101357],
              [89.00406950633608, 26.295106523797177],
              [89.006663880695669, 26.298280397448767],
              [89.010710678481772, 26.300783492329028],
              [89.014719310995048, 26.293767452638264],
              [89.017854531224927, 26.291519830305663],
              [89.021517646321826, 26.297291013578793],
              [89.02398408930938, 26.303544175340718],
              [89.02611739027148, 26.308990280614417],
              [89.028541906358683, 26.303640776947734],
              [89.028752751598404, 26.29762410558336],
              [89.026859546565603, 26.290976792484447],
              [89.029792699538518, 26.28665423152486],
              [89.036136195684392, 26.286442249390515],
              [89.040203553127284, 26.286226715238563],
              [89.044517996331805, 26.281903728125236],
              [89.050861416322078, 26.280958931250865],
              [89.05289286323152, 26.283455255134509],
              [89.051179919722429, 26.292989084828299],
              [89.053944634440668, 26.296219010680403],
              [89.057522354163822, 26.295783388912714],
              [89.059721624969541, 26.293070633434411],
              [89.062896408484747, 26.288748000643199],
              [89.063305008094389, 26.283560316218548],
              [89.060861527858094, 26.279814043248322],
              [89.058851150566966, 26.276642209733108],
              [89.063513854068958, 26.273269955335667],
              [89.064585022405922, 26.268745299480912],
              [89.064995861041169, 26.263324855318469],
              [89.064107737819839, 26.254709585942209],
              [89.05830422776414, 26.255675355248655],
              [89.054432318775113, 26.252195117005289],
              [89.052097052946309, 26.24339413608261],
              [89.049219232260185, 26.240910639474468],
              [89.036687622075064, 26.247234795616414],
              [89.031544294136893, 26.247411266738336],
              [89.020673924564235, 26.244043645249878],
              [89.014128791030103, 26.244033902459233],
              [89.010154958031009, 26.244762704886508],
              [89.003353628704318, 26.246728104875611],
              [88.995588182855741, 26.245798331175951],
              [88.988081905666121, 26.24261618331094],
              [88.980061499723718, 26.241360889699081],
              [88.972040646594095, 26.24125648724257],
              [88.964293320222694, 26.245997836523177],
              [88.956468325112823, 26.251382318977271],
              [88.954452370130554, 26.254110811992138],
              [88.94955457448556, 26.259569391033754],
              [88.947945697787418, 26.262461547871663],
              [88.943404766563759, 26.266517897462467],
              [88.941412743338475, 26.270580535367269],
              [88.9356481130025, 26.275761641587017],
              [88.933886743983479, 26.278489982389829],
              [88.930876794386378, 26.280665865174512],
              [88.926972386054331, 26.284472339807248],
              [88.919174144608149, 26.287419762493244],
              [88.91130361746086, 26.287264016341251],
              [88.907022422579018, 26.28815103881449],
              [88.896989581972036, 26.285854546354081],
              [88.87887664035442, 26.28583602030653],
              [88.875698162889535, 26.283553865270786],
              [88.874711499559496, 26.280380851404765],
              [88.872833534591308, 26.277207911984526],
              [88.869407067915944, 26.271800659108351],
              [88.867226574036451, 26.255715112483461],
              [88.869272005962415, 26.25236487442945],
              [88.872025551847258, 26.250305040012211],
              [88.874526434893525, 26.248060565575724],
              [88.878562909245318, 26.242395995758368],
              [88.885219937997547, 26.236896628502606],
              [88.869282332819267, 26.235756738404678],
              [88.852510344676531, 26.232726995197442],
              [88.848001672698061, 26.233060686449328],
              [88.841704244970217, 26.236445127357605],
              [88.837214103468085, 26.240728691027122],
              [88.83694842069896, 26.245230087266165],
              [88.840448654013954, 26.250340136310545],
              [88.834922544746263, 26.250853831541153],
              [88.827638809531251, 26.250877803219229],
              [88.824389052121205, 26.256497314330581],
              [88.821862875500699, 26.258765053571977],
              [88.823480206990098, 26.263294573684387],
              [88.822961515777607, 26.266899754562004],
              [88.822288700877209, 26.271676657307314],
              [88.821040151220672, 26.28113866082078],
              [88.824041727224412, 26.292263714844356],
              [88.823268010188713, 26.296305877270576],
              [88.814741026905409, 26.30328807957628],
              [88.805939914708844, 26.307558068821852],
              [88.800943519209369, 26.308899189936447],
              [88.79213439744764, 26.306162862013437],
              [88.78488896525387, 26.30118017380746],
              [88.779874309007468, 26.299118645468457],
              [88.772838750896753, 26.30068320920422],
              [88.768067841664745, 26.303378754636359],
              [88.765714463070665, 26.306335512291717],
              [88.760784183307948, 26.31036150456174],
              [88.756530553566265, 26.310117316221941],
              [88.753784977674442, 26.308065019589925],
              [88.752266480838344, 26.304684190250629],
              [88.751065262268227, 26.297902995952789],
              [88.746672482499307, 26.293591855250494],
              [88.743804191881125, 26.290181729999961],
              [88.739806293138358, 26.290170112362802],
              [88.734754470316176, 26.2921976043651],
              [88.729513693453967, 26.29013503618857],
              [88.727259474420094, 26.286060432079516],
              [88.720782037785597, 26.280846071873103],
              [88.711768627541673, 26.280354212710861],
              [88.707747948689075, 26.278986730505999],
              [88.699953196686252, 26.278934536162726],
              [88.695965782271514, 26.276209294914032],
              [88.696619599950523, 26.271272815937291],
              [88.697268418225434, 26.268081658601734],
              [88.687737269098989, 26.262395984544643],
              [88.683478137267187, 26.264194536137012],
              [88.675706490185462, 26.265291319105334],
              [88.674176547746342, 26.272521362098868],
              [88.670754745257312, 26.281077667372564],
              [88.66984751789991, 26.285391661376266],
              [88.673591330318274, 26.291747040176485],
              [88.67684441320516, 26.294011533658036],
              [88.680328973335918, 26.295333662582937],
              [88.705822791022769, 26.290258380385218],
              [88.694640441310824, 26.296788337319338],
              [88.692156510935419, 26.300592142561033],
              [88.689165287636825, 26.303061612387058],
              [88.687560218648215, 26.309878089905606],
              [88.684288278575664, 26.312601180142959],
              [88.681758363977522, 26.314864249756084],
              [88.680007571880012, 26.319796709921313],
              [88.683387962924542, 26.322085534136818],
              [88.687763635469636, 26.323914994280862],
              [88.689766238069055, 26.32686351680147],
              [88.693276109699724, 26.328209604778497],
              [88.697424081716861, 26.322573404658044],
              [88.695805895129638, 26.31964992926931],
              [88.695817393107689, 26.316479326383753],
              [88.700336037057042, 26.31424354892178],
              [88.711650067742042, 26.313366516260093],
              [88.715874396876856, 26.315471067818475],
              [88.720148986632623, 26.316544259083777],
              [88.725922626672158, 26.312497141256706],
              [88.732207507937687, 26.315251548525129],
              [88.735177915408229, 26.318270650767296],
              [88.742809592461256, 26.321696375972536],
              [88.749454394293252, 26.323900456129991],
              [88.751810611315065, 26.32760881479344],
              [88.747954631053531, 26.330719918591495],
              [88.741685504821589, 26.330398878344212],
              [88.744649737562455, 26.336222122062164],
              [88.748535051284421, 26.340621904901941],
              [88.749325250754879, 26.347837329232707],
              [88.747860895106854, 26.351485038242966],
              [88.744843788390213, 26.354624203119943],
              [88.740945718911107, 26.354173112831422],
              [88.738226695952662, 26.351431100861486],
              [88.735082806920573, 26.346941596698084],
              [88.733077061181064, 26.344200976484846],
              [88.725307525186835, 26.343255552507703],
              [88.719683789244314, 26.340753314083823],
              [88.715799705909163, 26.336260718301507],
              [88.712237509570357, 26.334466148526957],
              [88.706360552125304, 26.336730584974369],
              [88.703515469057479, 26.348987263930081],
              [88.699766296432642, 26.35270252435636],
              [88.700020782682401, 26.35606882091993],
              [88.702274034689893, 26.360166653487635],
              [88.69651743973094, 26.365316882717945],
              [88.693644979861403, 26.373695196055202],
              [88.695212028033183, 26.377283771880716],
              [88.700354946988071, 26.378888945570392],
              [88.703101190930198, 26.380942055719402],
              [88.705099474608588, 26.385476596579583],
              [88.704833775403003, 26.388621091724051],
              [88.696568314668013, 26.389511753187481],
              [88.691008223291405, 26.390180310472793],
              [88.688779331202369, 26.393088778980566],
              [88.684239861862849, 26.393531554386861],
              [88.685448489327015, 26.398710070317367],
              [88.692115739319874, 26.40113890628685],
              [88.690896927852663, 26.405703015911325],
              [88.687278713344256, 26.409419008421395],
              [88.681006493124386, 26.408913672611632],
              [88.672049093244098, 26.411888194587462],
              [88.669110974924735, 26.415229399000722],
              [88.660564891992706, 26.416070170399973],
              [88.656561707848297, 26.416031160131901],
              [88.654771751479373, 26.423719902158485],
              [88.652493725642586, 26.425962236873094],
              [88.648989102828452, 26.428268196639628],
              [88.645694744629679, 26.429563795847887],
              [88.632890582336387, 26.435392573442961],
              [88.633098454674368, 26.440586046392919],
              [88.633411615082707, 26.445250201242541],
              [88.633290704026521, 26.455496360882297],
              [88.629114219215353, 26.466344781347768],
              [88.626188241162083, 26.469962923521607],
              [88.617393541880062, 26.474197628050877],
              [88.608502030150106, 26.471634059344506],
              [88.604708615554927, 26.469665081153561],
              [88.599862682946892, 26.463739864524637],
              [88.600769350371451, 26.460573431728335],
              [88.603257226354728, 26.45766710279327],
              [88.600900346703469, 26.454005376311471],
              [88.596160713317744, 26.452858740790806],
              [88.590851349901698, 26.453294314382866],
              [88.581552253023816, 26.456629893134835],
              [88.572768127114486, 26.457970601941874],
              [88.569108256210626, 26.460778321366529],
              [88.56672231521236, 26.463594618665905],
              [88.561391745476769, 26.473953026892655],
              [88.559130652050897, 26.477113789394778],
              [88.557076730517878, 26.479584504149944],
              [88.554310148955153, 26.482075831938356],
              [88.546042017994537, 26.481807409831063],
              [88.539252000786846, 26.482671382427668],
              [88.532700048943127, 26.486268772253435],
              [88.52939592178727, 26.493926379621232],
              [88.52584223284191, 26.500273087141],
              [88.522301297251474, 26.504091892857037],
              [88.518487135784099, 26.511056841743365],
              [88.51571655592457, 26.513547522912202],
              [88.507449007184093, 26.513276964308304],
              [88.503935897730457, 26.511676050529537],
              [88.499146707303652, 26.514821105176793],
              [88.496473572470677, 26.518322389947919],
              [88.495570063683545, 26.524751488981021],
              [88.492750615929012, 26.531743360066578],
              [88.489484725640125, 26.536021652882809],
              [88.486453959556016, 26.539199162826726],
              [88.483685293642409, 26.541550988212769],
              [88.476634934686487, 26.542296244834152],
              [88.473865255256555, 26.544532843797583],
              [88.469807525010864, 26.548808855072277],
              [88.464541309524577, 26.545610909222457],
              [88.463575933289221, 26.540184586418398],
              [88.459125513255316, 26.536966577120715],
              [88.455576188270612, 26.537315526166363],
              [88.453032716895493, 26.540129322728429],
              [88.448210834752729, 26.543731995123505],
              [88.441694987329797, 26.545029029731349],
              [88.437162173346451, 26.547279945558852],
              [88.432757876061203, 26.558259648644796],
              [88.429485991344393, 26.567360620111266],
              [88.428576585937805, 26.582769386099546],
              [88.428373709410479, 26.586789116043082],
              [88.426824446716338, 26.593786887066706],
              [88.424151617955658, 26.622281789609648],
              [88.421590001391991, 26.627458975324853],
              [88.41830752813749, 26.629485182702563],
              [88.41253509553259, 26.629222169927221],
              [88.404534227642557, 26.625708534141431],
              [88.401993227076474, 26.623718181801596],
              [88.400005408193564, 26.618538548338666],
              [88.395268801015675, 26.616214321619445],
              [88.393753721919865, 26.613289021571223],
              [88.393649500049747, 26.609452318508641],
              [88.399652000148208, 26.605626274091541],
              [88.40491390846131, 26.601590913486323],
              [88.395069452407327, 26.599146358864129],
              [88.389847542000439, 26.59697985661062],
              [88.386193263883612, 26.596958596461725],
              [88.384065551154706, 26.594465491367369],
              [88.38087160153384, 26.582499531248494],
              [88.378518911451394, 26.57903970040735],
              [88.377583729798403, 26.569317464861136],
              [88.37384524555695, 26.563184466618551],
              [88.369013829892651, 26.552106265353938],
              [88.367546971376498, 26.546193625584223],
              [88.36800439563423, 26.538547911974195],
              [88.366042569852922, 26.534033925225685],
              [88.362774014216299, 26.526272660813568],
              [88.36010452587432, 26.513161204346378],
              [88.359233923587979, 26.509527926247085],
              [88.356291181328558, 26.506913236146968],
              [88.351130019464989, 26.503826957076441],
              [88.348748693612379, 26.501332034672931],
              [88.345110249350455, 26.49738283247892],
              [88.341287909697058, 26.490879349382787],
              [88.340063533672208, 26.487011685839146],
              [88.34035748220451, 26.477756604826091],
              [88.342402716658071, 26.473243127504084],
              [88.345729410406491, 26.468072301404582],
              [88.354026199109782, 26.46339007312983],
              [88.356311077567582, 26.457499414008119],
              [88.356354701101651, 26.45072156514707],
              [88.360175682091722, 26.44757638241229],
              [88.363150595340272, 26.449177042622708],
              [88.364363873175577, 26.458672677575059],
              [88.367816169598697, 26.465034345145334],
              [88.366769295606147, 26.473160288916052],
              [88.364455552227525, 26.479694349694192],
              [88.367187506216155, 26.48356958278881],
              [88.375215212133597, 26.484971212275624],
              [88.389603767040498, 26.477382756798708],
              [88.398413207775477, 26.476286216490582],
              [88.403517926572306, 26.480379140989704],
              [88.408174048081307, 26.482220858907112],
              [88.411435460307104, 26.478839632925677],
              [88.41408109605679, 26.476282241254694],
              [88.418556075889342, 26.466015116140458],
              [88.423080678981265, 26.464662461282789],
              [88.426203262930912, 26.467183462580522],
              [88.428940273003548, 26.470369318989654],
              [88.432066703789587, 26.472406691314134],
              [88.436093760670502, 26.472887849151164],
              [88.439603266709412, 26.470632793598242],
              [88.441168161725614, 26.464991375052708],
              [88.448457155624695, 26.461629824008089],
              [88.456479713073861, 26.464291145682747],
              [88.463765029182099, 26.466029617996973],
              [88.467317153868436, 26.464922997180452],
              [88.479948398676285, 26.463721291896739],
              [88.487184350350418, 26.459892831988558],
              [88.484386777751837, 26.453149616164215],
              [88.48398795508939, 26.447503820955934],
              [88.488899246721957, 26.444588665156179],
              [88.494052586812757, 26.444305734112273],
              [88.495280305341268, 26.439671901716604],
              [88.495186166905569, 26.425211273830492],
              [88.498647607025589, 26.419968922952464],
              [88.501578813511671, 26.417752410137396],
              [88.500440670911502, 26.411062227293559],
              [88.50046254127993, 26.40720110654016],
              [88.505012301996146, 26.404949417790025],
              [88.510269466698801, 26.404081482987841],
              [88.512811766109479, 26.400923315959226],
              [88.511068724825876, 26.397743352150169],
              [88.511215529661172, 26.393932213629075],
              [88.517130068602427, 26.389203968863676],
              [88.525656606283746, 26.391981190688124],
              [88.52422771589994, 26.387310396830731],
              [88.523179073740735, 26.383123226470307],
              [88.519627456744146, 26.379613628613768],
              [88.516145018341035, 26.372820803838728],
              [88.52448148311781, 26.372770011025313],
              [88.528018850841121, 26.373819333333518],
              [88.533117699531346, 26.373477399701599],
              [88.530362866892659, 26.368914943885343],
              [88.52704024211458, 26.365729696442738],
              [88.523128504178501, 26.363160569622263],
              [88.525308312482665, 26.360528206063691],
              [88.527950532154875, 26.357349335835416],
              [88.525081902135554, 26.355084275610714],
              [88.519014592642662, 26.350390511729348],
              [88.512430777354609, 26.347073909384758],
              [88.512758666902883, 26.352564287087247],
              [88.513779762718386, 26.357072735051624],
              [88.512993985115898, 26.360929046472606],
              [88.507513135800366, 26.361336894976183],
              [88.503982613346921, 26.358815883573946],
              [88.496592883578714, 26.358573057682374],
              [88.495357763609903, 26.350871390188683],
              [88.488220786136168, 26.351064262740564],
              [88.486216633105741, 26.353994975707927],
              [88.482107345011954, 26.355235871822643],
              [88.478412058148351, 26.355078327732574],
              [88.474092165679238, 26.357101189100771],
              [88.468848364367446, 26.360451245137313],
              [88.466707345020893, 26.369630118957517],
              [88.463549706742, 26.373310257007684],
              [88.459347091498032, 26.368419794758889],
              [88.45380222437845, 26.362003226334515],
              [88.449520272442015, 26.352974595591469],
              [88.447987781387951, 26.349267265136138],
              [88.441909807965629, 26.337909221862606],
              [88.437388320956885, 26.335404566829631],
              [88.430467880175783, 26.333550992892448],
              [88.424375569835505, 26.333769357577804],
              [88.418238254891222, 26.333047837213243],
              [88.416244414066568, 26.33009575341638],
              [88.416648482238628, 26.326467395793681],
              [88.420887907938706, 26.324928178166811],
              [88.423088543885839, 26.319197902100662],
              [88.416708585155888, 26.316543450259374],
              [88.409177289194545, 26.318751702352362],
              [88.404693841251557, 26.318795133230569],
              [88.398381240614611, 26.317771581138807],
              [88.395386846713407, 26.315732638360437],
              [88.394175695722865, 26.309845437211514],
              [88.387891355259598, 26.308408266104681],
              [88.37888651459393, 26.306149653831159],
              [88.376280890055938, 26.303194403398521],
              [88.366045335239605, 26.294311865520203],
              [88.362675130500449, 26.291580905635495],
              [88.360809689542336, 26.288399567424605],
              [88.358363454168824, 26.284684763112548],
              [88.354246556493862, 26.275701843922903],
              [88.350810957711602, 26.26368692337099],
              [88.350848670572233, 26.25780599057742],
              [88.35393415310476, 26.249464455064388],
              [88.357447620391909, 26.245854536508745],
              [88.35835877414614, 26.242688919225788],
              [88.359428565473237, 26.235046172860645],
              [88.356332974141552, 26.229352537499992],
              [88.354853685709472, 26.222338389697299],
              [88.340382819361551, 26.215930679612026],
              [88.33463340315673, 26.211806194888812],
              [88.330423836983925, 26.205438947394647],
              [88.326230235742557, 26.204609845933916],
              [88.318909885672696, 26.206745755094477],
              [88.312610357935483, 26.208269105677854],
              [88.308620993304515, 26.203740993676071],
              [88.305628257728259, 26.201907428910403],
              [88.299096018969607, 26.204139484598929],
              [88.292113477295587, 26.201819738048901],
              [88.285583541563469, 26.196470303867802],
              [88.282899565365554, 26.194522585455985],
              [88.277388279451372, 26.192833595322767],
              [88.271159778507439, 26.191965159470232],
              [88.261600300098252, 26.193923607214455],
              [88.252852989330776, 26.192531608708649],
              [88.2403638827723, 26.184727818055823],
              [88.238416049413033, 26.179980486946135],
              [88.227146687859815, 26.175883919405496],
              [88.222904173376122, 26.174957353404242],
              [88.218159199315295, 26.173042375034786],
              [88.213698087959912, 26.167381933519636],
              [88.213985417559499, 26.16329344563907],
              [88.210994623309134, 26.161711256314973],
              [88.206729402592515, 26.163701948198067],
              [88.202965259475832, 26.163469478949043],
              [88.196479445721195, 26.159792869720025],
              [88.193763732517056, 26.155683220380606],
              [88.18637527804492, 26.150690680091188],
              [88.182813259977365, 26.14747307989531],
              [88.178761667563876, 26.135703933610483],
              [88.177156678026918, 26.132751683650572],
              [88.177211280876975, 26.125951258778585],
              [88.176055683035685, 26.117810509754396],
              [88.171465822811527, 26.113042504385959],
              [88.168097222467139, 26.108262900995744],
              [88.163188491882721, 26.105056626693834],
              [88.161635262693068, 26.102104432213459],
              [88.16193010581793, 26.09735025662323],
              [88.163972498268251, 26.093300539219619],
              [88.164001625336894, 26.089694121523909],
              [88.1627789347353, 26.086719634577236],
              [88.162839796461711, 26.07950665207396],
              [88.173772022509468, 26.076463433938692],
              [88.177401436686836, 26.074397302845934],
              [88.183938345262405, 26.070839035381908],
              [88.186207504129385, 26.067019340869287],
              [88.186262980531737, 26.063181546934825],
              [88.17682053556301, 26.054933899287406],
              [88.174305539697912, 26.051538654630669],
              [88.174090668105393, 26.034353537203888],
              [88.177232842085715, 26.032354944541137],
              [88.180254718595208, 26.029665746950876],
              [88.181916001336035, 26.02535895353871],
              [88.179574175846966, 26.022424242465515],
              [88.165340343176226, 26.019608145806401],
              [88.154853002911196, 26.015210793150288],
              [88.14561173539559, 26.014016819155867],
              [88.143766030804628, 26.009936175163006],
              [88.146176391988689, 26.007244079693145],
              [88.148374475763035, 25.999792126826307],
              [88.147536261487446, 25.993675573450854],
              [88.141814551625217, 25.99115218723518],
              [88.13833725467515, 25.987725145318382],
              [88.137092020461608, 25.984566986070895],
              [88.136445318980606, 25.977072860636234],
              [88.130014462602034, 25.971441115945634],
              [88.126428281879711, 25.968750240333367],
              [88.125539268084964, 25.962769014796159],
              [88.127076952217678, 25.958255666859944],
              [88.124619501043043, 25.951435832580987],
              [88.125911801311858, 25.945794698826955],
              [88.124955165556969, 25.941950404829615],
              [88.118729188187118, 25.939420688070147],
              [88.117146928492232, 25.934422062594361],
              [88.11105427051514, 25.930998061911708],
              [88.103325041597515, 25.929123060686344],
              [88.099590671946373, 25.926384404431747],
              [88.096222618791217, 25.919486892093374],
              [88.095451661790364, 25.91481773986273],
              [88.097447071608002, 25.907251954799815],
              [88.09767938796513, 25.903968720069965],
              [88.093841409684345, 25.898514722545492],
              [88.093870502544618, 25.895345345622779],
              [88.098396623540182, 25.891566990258372],
              [88.100678076741715, 25.88908068306629],
              [88.102964287089833, 25.885951744223092],
              [88.103100072223199, 25.882091991408746],
              [88.101031678488766, 25.87775681760008],
              [88.099496043054927, 25.871574815823617],
              [88.108199544879398, 25.866824111651386],
              [88.113161374357787, 25.86472969023405],
              [88.116317747764242, 25.860815651871633],
              [88.118212637084739, 25.858141562719361],
              [88.119266996075623, 25.855136685892109],
              [88.118869267708249, 25.851889557738307],
              [88.116016914671107, 25.848612268888768],
              [88.113250751560386, 25.84670388705074],
              [88.108787287341684, 25.845218997664844],
              [88.104929549186267, 25.844424024145606],
              [88.106334469806896, 25.839862718372011],
              [88.107251962013507, 25.836494843388259],
              [88.107914865865851, 25.833284314310156],
              [88.104697411741668, 25.829859951539994],
              [88.105094808446509, 25.82487760828111],
              [88.106491138952208, 25.821946829897975],
              [88.109279092845696, 25.819281456859173],
              [88.108577535702253, 25.815208004907575],
              [88.108353443781695, 25.811806587534676],
              [88.113843877845127, 25.810699785121788],
              [88.11647507668232, 25.808698967573477],
              [88.116153434822522, 25.804859262510377],
              [88.113161223727133, 25.801665647762789],
              [88.113712542574731, 25.796453760177577],
              [88.121966966561033, 25.795392249498761],
              [88.131224543943119, 25.795462825505552],
              [88.141480460181256, 25.791703193772875],
              [88.144899051582655, 25.78642392289337],
              [88.14487560505053, 25.773854284619826],
              [88.148614842560221, 25.772757766219886],
              [88.154825560930561, 25.776180353637525],
              [88.158142912512304, 25.782777619517212],
              [88.16801853466076, 25.785124233036839],
              [88.171981613537511, 25.784234746757093],
              [88.179699971917913, 25.789505494895998],
              [88.181426317296186, 25.79268835296936],
              [88.185139418767292, 25.794507277235798],
              [88.192437728959376, 25.795663008292756],
              [88.195645240048165, 25.794192785310671],
              [88.19792335878428, 25.791658817814007],
              [88.207705372863103, 25.786306281695285],
              [88.211687623292619, 25.786336115033212],
              [88.212288822427297, 25.790634380201833],
              [88.212237233624208, 25.794012275264418],
              [88.215845582881514, 25.796541611825301],
              [88.220837752414397, 25.797242412550087],
              [88.230818243183379, 25.795751429545017],
              [88.234298602650469, 25.798255543018101],
              [88.235521497825161, 25.801204714862919],
              [88.241010457966595, 25.803264313896769],
              [88.243731790109948, 25.805533853689042],
              [88.25222746344221, 25.806281827412366],
              [88.257966026347717, 25.808802874472352],
              [88.261793553215895, 25.809240661500635],
              [88.267433554228958, 25.808405602044445],
              [88.271188555338568, 25.808454610291108],
              [88.274934704167165, 25.805998467130003],
              [88.276612511129287, 25.802149612454119],
              [88.277535319533939, 25.793562111709765],
              [88.278178912822227, 25.788810786039058],
              [88.276071595039667, 25.785533737145634],
              [88.273127297722056, 25.78245852398328],
              [88.271658619679897, 25.778612184342112],
              [88.282173196277924, 25.773029469559908],
              [88.285703739494593, 25.772364063609881],
              [88.290171698689022, 25.771934699545891],
              [88.293692624559014, 25.769015011679027],
              [88.294206951964838, 25.76428716566322],
              [88.297213342247034, 25.762284010467837],
              [88.300147831473041, 25.759754044562385],
              [88.313526248848362, 25.754232585318203],
              [88.31727655046592, 25.751086501284863],
              [88.320076144254131, 25.742051285400215],
              [88.320875635171603, 25.736634570684238],
              [88.325878991752759, 25.735081548703878],
              [88.329343100550275, 25.736688471747257],
              [88.332897731878077, 25.739604298232983],
              [88.336760947748573, 25.738134214849261],
              [88.34219147363595, 25.733873423060277],
              [88.34366172997052, 25.730204724913818],
              [88.347700224528708, 25.72894366838597],
              [88.351056111402002, 25.727609062766394],
              [88.354137836961229, 25.725468037235284],
              [88.361809209317798, 25.723286562112243],
              [88.362919230961282, 25.720258780392165],
              [88.376168124814342, 25.713905430666493],
              [88.377902730356197, 25.708378458777727],
              [88.37488948498715, 25.703582862351706],
              [88.374990335295465, 25.699700454972326],
              [88.378397645198604, 25.698296293545102],
              [88.381747345787801, 25.697672840460601],
              [88.38673408705526, 25.698826769131298],
              [88.389768937756202, 25.695673536979587],
              [88.390778326300051, 25.692532147183531],
              [88.39055396455089, 25.687546079665367],
              [88.398338568160696, 25.683066433136212],
              [88.403071807662485, 25.683988448389542],
              [88.407836730470308, 25.679720210861742],
              [88.408859455665308, 25.674325689596486],
              [88.410639958221083, 25.668890662564888],
              [88.417664930055523, 25.663946094061842],
              [88.421016700639171, 25.662930123047293],
              [88.427368335928961, 25.664459301616795],
              [88.432846272117118, 25.667659608438285],
              [88.449571181440092, 25.663225960053982],
              [88.453071279972249, 25.662785819859618],
              [88.457830478888454, 25.659204765352058],
              [88.457995275994804, 25.652518804885052],
              [88.458908235883072, 25.648114076268524],
              [88.460218001922399, 25.640355541207505],
              [88.459253309251224, 25.63168736806368],
              [88.458276880593431, 25.625295184614423],
              [88.454809945274221, 25.620291686273752],
              [88.455344433476071, 25.615538708216857],
              [88.456956634980685, 25.61260650194885],
              [88.451645748127319, 25.606696100883088],
              [88.450302930729464, 25.602391906700863],
              [88.457417487959944, 25.598364989335472],
              [88.459937186208961, 25.596355413311041],
              [88.468201463618726, 25.59051814103983],
              [88.47147000363023, 25.585549723436056],
              [88.477457395788605, 25.583766071567922],
              [88.486666714443842, 25.584963920012587],
              [88.493892877264983, 25.583620763051862],
              [88.497908607791373, 25.580930654761602],
              [88.497587107706849, 25.569971247153983],
              [88.498597059253697, 25.565564218950851],
              [88.497890179850671, 25.560805237932371],
              [88.502698319500212, 25.556188433585941],
              [88.504615506200238, 25.55309766121416],
              [88.506276389997112, 25.550211079327781],
              [88.509778846528306, 25.548435763848452],
              [88.520277985429701, 25.544650594151658],
              [88.523277637828002, 25.542184340268193],
              [88.524290618884351, 25.537410662039175],
              [88.52753609570145, 25.536530202858948],
              [88.535247052544563, 25.537923996094218],
              [88.538024194940505, 25.534789606170246],
              [88.540010996919236, 25.532089252572348],
              [88.542527568885276, 25.524863404348647],
              [88.542665053319197, 25.517535105174083],
              [88.542770297099764, 25.512898517172783],
              [88.546098424346624, 25.509533362230254],
              [88.550339872446727, 25.511459681512118],
              [88.553580721384463, 25.516047136926918],
              [88.557550568973596, 25.517077191259343],
              [88.559792963806288, 25.514077796996041],
              [88.563262773161853, 25.513428918735041],
              [88.567294287875356, 25.511609079800028],
              [88.575454578923058, 25.50937234750387],
              [88.593637483626139, 25.50676714161883],
              [88.598156700553986, 25.509290795802588],
              [88.600647062182489, 25.512241557193335],
              [88.607370298387437, 25.514523752230797],
              [88.609859467081506, 25.512489737730913],
              [88.612359172213758, 25.507767081295864],
              [88.623885744395551, 25.498994377938683],
              [88.635105232692823, 25.496996936041658],
              [88.641300724024177, 25.497918141699351],
              [88.643388703173272, 25.495262634535692],
              [88.644945358160655, 25.491616304002644],
              [88.647587844047067, 25.483035333735518],
              [88.651339127263768, 25.481234410926888],
              [88.660070429970389, 25.480811394693397],
              [88.662082348578423, 25.477877813453361],
              [88.669304832415733, 25.47475940164864],
              [88.676262460971472, 25.474787187175043],
              [88.680486307347209, 25.475192732518465],
              [88.68842682077522, 25.475912477449093],
              [88.694148425598314, 25.475016041268621],
              [88.700681932111692, 25.473294188081514],
              [88.703915757605515, 25.474660995128172],
              [88.707119287492304, 25.476948177444424],
              [88.707603205068793, 25.482831330915971],
              [88.711964181348804, 25.487579257913598],
              [88.712203321783264, 25.491648536277939],
              [88.710592297104768, 25.495915330310851],
              [88.715775303514278, 25.497312752737891],
              [88.722254818481019, 25.496670459386245],
              [88.726244366162589, 25.499165069246072],
              [88.729987995841824, 25.499638498381881],
              [88.735205606091654, 25.498506760774536],
              [88.739170137728323, 25.501002135255646],
              [88.744167270009356, 25.497184479567299],
              [88.742896081265286, 25.491711122703109],
              [88.748675255995295, 25.488628687311298],
              [88.752434936313023, 25.491330757295522],
              [88.757894531917387, 25.49339200871189],
              [88.764369330334191, 25.494104968640393],
              [88.768588151994209, 25.496600047045611],
              [88.768566966000634, 25.503147808362932],
              [88.767060936264372, 25.507207938011547],
              [88.765304849709565, 25.510143275639646],
              [88.762817703791697, 25.51241016342242],
              [88.761539450593162, 25.516702151424738],
              [88.762791476294979, 25.52097829970355],
              [88.768987732133155, 25.521917489502723],
              [88.772130357811136, 25.520711503662447],
              [88.776769744141404, 25.518336670367319],
              [88.785489167803405, 25.514297490327909],
              [88.788954976682163, 25.514975174293703],
              [88.795670985506092, 25.519958710519678],
              [88.80189095989023, 25.522482736753609],
              [88.804150257757271, 25.520236724819814],
              [88.805118443878783, 25.517298633645616],
              [88.807331595188487, 25.513951155537477],
              [88.812913009941354, 25.499218655262961],
              [88.814937559357659, 25.490631583453428],
              [88.819906578453725, 25.486810281268088],
              [88.827373291604658, 25.485705483652062],
              [88.833630601134828, 25.483013389182666],
              [88.836244112427295, 25.480057788131457],
              [88.838281872577255, 25.464922534637317],
              [88.837672721744326, 25.456098539082589],
              [88.83658202337628, 25.447710401765416],
              [88.829992120466144, 25.442957946025803],
              [88.82939387815469, 25.439786720179359],
              [88.835245611718676, 25.436195362743639],
              [88.837228984424783, 25.431675510112836],
              [88.837135529488407, 25.428505063866986],
              [88.833021073802939, 25.425574084614606],
              [88.831563504511166, 25.413347760997095],
              [88.827844468373826, 25.413154524718966],
              [88.823119078844982, 25.412404214875703],
              [88.818396213075289, 25.410368154080491],
              [88.818884631596703, 25.406969353112387],
              [88.823623673194447, 25.403606951743757],
              [88.8291176016143, 25.400658065490436],
              [88.840299718909449, 25.397978707088111],
              [88.843288578205815, 25.396194954985553],
              [88.845570817782217, 25.393721259402643],
              [88.845934914190494, 25.389862428296517],
              [88.842703581766585, 25.388106784601977],
              [88.84262624227695, 25.378318983999772],
              [88.846726768203794, 25.365902223049265],
              [88.850376599225513, 25.361845111907499],
              [88.857081293857178, 25.359152548014123],
              [88.85931913086884, 25.354402001833975],
              [88.863567768680198, 25.3530596192264],
              [88.86756213073437, 25.352838853511766],
              [88.871797506624048, 25.346531960074742],
              [88.872189676796523, 25.341088907103352],
              [88.880290263235565, 25.334538783178782],
              [88.882779402479954, 25.328686863604762],
              [88.888015805155277, 25.32621700884464],
              [88.891545474376926, 25.32985688694361],
              [88.893230444439766, 25.333698583944926],
              [88.897672234292529, 25.33708577548045],
              [88.902167324743189, 25.337556011903004],
              [88.906645994606208, 25.334856649568433],
              [88.911904064874335, 25.322185472332844],
              [88.914636380347289, 25.319503837775997],
              [88.916869488175266, 25.315420592504079],
              [88.921848231050646, 25.314534638860046],
              [88.928695759005663, 25.314597115331527],
              [88.930872602154778, 25.311684266878427],
              [88.93752673533406, 25.306872857985311],
              [88.962646179691617, 25.303754974469499],
              [88.969389006876625, 25.303997744931973],
              [88.977571824035181, 25.3060577399945],
              [88.983786132166173, 25.306505718638022],
              [88.986771169521475, 25.304260597207939],
              [88.988744922297045, 25.301554161702839],
              [88.992991529372674, 25.300367125113429],
              [89.005169255616849, 25.300019526891965],
              [89.008658509573664, 25.29685486590914],
              [89.009420309417067, 25.293456460000733],
              [89.008420724495721, 25.286218549753301],
              [89.009309417665165, 25.282083987532985],
              [89.01078067785015, 25.275353979387052],
              [89.01242793719922, 25.27244074839545],
              [89.012534925714263, 25.267224044122187],
              [89.009024502410028, 25.26531162073405],
              [89.00295981123385, 25.269046796721216],
              [88.999243250412832, 25.271935973407039],
              [88.993031969319503, 25.271096850063582],
              [88.98805766287596, 25.270123318548777],
              [88.985078939657953, 25.267407592971594],
              [88.97813993186648, 25.263764403709168],
              [88.974159410183631, 25.256978548084319],
              [88.964464572320296, 25.254684657895424],
              [88.958259827516187, 25.250168894693882],
              [88.956045107660316, 25.245639542889236],
              [88.956050761810133, 25.24177995728742],
              [88.956738959623522, 25.238173092535487],
              [88.958011369210823, 25.232777325292673],
              [88.959203774855894, 25.229080942237765],
              [88.961162828833636, 25.219870893196315],
              [88.96318762451827, 25.217372008959011],
              [88.964031075920289, 25.210617548238702],
              [88.956843024073095, 25.2062842183546],
              [88.945661724573128, 25.205364834647323],
              [88.940464482743835, 25.203540445204883],
              [88.939464399748587, 25.197656806836243],
              [88.944694820268253, 25.194726327389851],
              [88.948411016841376, 25.191103297848343],
              [88.949380026651411, 25.186465330361248],
              [88.949565605580148, 25.181157466126493],
              [88.946844073842399, 25.178694436202232],
              [88.941749709966089, 25.176178858789296],
              [88.938265515999277, 25.17706786875641],
              [88.934275751787141, 25.178207567793791],
              [88.930115323870368, 25.176474637181137],
              [88.927266150017999, 25.174217456103289],
              [88.924879135485781, 25.169593925962822],
              [88.921403150347757, 25.16641539149888],
              [88.916176826259019, 25.167298899282411],
              [88.913672818690031, 25.17025642682259],
              [88.909469114724374, 25.176771350454821],
              [88.902972915058783, 25.181305504377036],
              [88.895043506319666, 25.183308815208708],
              [88.891794025413446, 25.181508931905302],
              [88.889582355242482, 25.176310305105204],
              [88.882112873424077, 25.176267181150656],
              [88.879128122842857, 25.179201699905629],
              [88.877013315276827, 25.188249388401033],
              [88.874634040005745, 25.1907237083513],
              [88.867446984064145, 25.188453080207193],
              [88.864839967683537, 25.190697725634706],
              [88.863935584044597, 25.199954090930703],
              [88.857977477583034, 25.200397972209398],
              [88.852998952130108, 25.201968699421244],
              [88.852737084792793, 25.206493914057411],
              [88.849751637865694, 25.208966985393587],
              [88.841571224474919, 25.209635279952582],
              [88.83521361351653, 25.207870235021915],
              [88.83335248898463, 25.205314318134675],
              [88.833505913856087, 25.194471682567968],
              [88.824635562450894, 25.189826538678368],
              [88.821273936457615, 25.182622585382909],
              [88.81523459700955, 25.176575651100496],
              [88.808999079785167, 25.173972451895221],
              [88.798400591269427, 25.174456963144802],
              [88.787609202967943, 25.177179502124307],
              [88.780603359368229, 25.178189419018349],
              [88.778698897820036, 25.182489209878305],
              [88.777546047635298, 25.188170699256826],
              [88.772436144239222, 25.187982021076387],
              [88.768850050220919, 25.185385662860206],
              [88.761475327872859, 25.183639118402294],
              [88.758644729986813, 25.181389675155383],
              [88.757141493855983, 25.17828503557287],
              [88.752591050133717, 25.180679403937432],
              [88.747652663185818, 25.186864467956525],
              [88.737232875879968, 25.189756106935288],
              [88.734750542043486, 25.196292221044075],
              [88.726975905236202, 25.200915735344587],
              [88.71788150188074, 25.203467283639238],
              [88.707966106732144, 25.205291267245482],
              [88.691972912414769, 25.208676936888963],
              [88.686767293581539, 25.210012424241725],
              [88.680915756729917, 25.208726130155824],
              [88.675090902842157, 25.207026070454823],
              [88.671113964233754, 25.204091897326382],
              [88.65520986571093, 25.20423293807303],
              [88.648767964062927, 25.205562705001139],
              [88.643039006499009, 25.205308784311416],
              [88.636354571784452, 25.203720216416347],
              [88.632087037353912, 25.204299424204926],
              [88.624885109210283, 25.205921091813945],
              [88.618932445466868, 25.205208173779802],
              [88.609531169158856, 25.201559797104245],
              [88.603566305669631, 25.197902496369313],
              [88.595879121268212, 25.195410420792097],
              [88.593162412440719, 25.193351356886406],
              [88.590323941107357, 25.184494146363392],
              [88.588723496437296, 25.181339202288733],
              [88.579555318309318, 25.177690666804594],
              [88.568389631829376, 25.17467473427228],
              [88.563915983657807, 25.176009600919858],
              [88.56337898628135, 25.182577605013279],
              [88.564363868083589, 25.18756741068858],
              [88.562380885120021, 25.190476019592161],
              [88.554163369240555, 25.193379230713628],
              [88.548692747140549, 25.192018897760732],
              [88.542757348073792, 25.187901926869056],
              [88.537783170994302, 25.187877176047706],
              [88.535774465044597, 25.191037620208],
              [88.539230878226817, 25.196247956215345],
              [88.537473719009469, 25.199178914584241],
              [88.53003697307166, 25.197350360752733],
              [88.526042227442133, 25.198663859338936],
              [88.523376096219806, 25.201752764963995],
              [88.517599458698214, 25.200897247128839],
              [88.514126619003221, 25.198834136875597],
              [88.508612368813417, 25.201194841906634],
              [88.504914153161934, 25.203566562215507],
              [88.501913713554842, 25.207364853378909],
              [88.494683916447372, 25.209165858449147],
              [88.487211515979212, 25.21363060396817],
              [88.48051338506481, 25.210884081831633],
              [88.476345654762127, 25.201832023015609],
              [88.47270645527918, 25.198367379905317],
              [88.467165952440055, 25.196108657084654],
              [88.459967216651322, 25.196964527612444],
              [88.456473353492143, 25.198531742423395],
              [88.454982090417076, 25.203510128051377],
              [88.452713381576288, 25.207334477259725],
              [88.447698846379978, 25.20978959579439],
              [88.444244447685023, 25.209332194133118],
              [88.44305499501823, 25.201191974855682],
              [88.444160804501053, 25.197301004480877],
              [88.448130111299903, 25.183345447812336],
              [88.450045581248162, 25.170901325347611],
              [88.45367830506342, 25.166626085759798],
              [88.455708624370288, 25.160546942135767],
              [88.460949289931264, 25.148560380905863],
              [88.461750806134162, 25.1449790428832],
              [88.460087809013189, 25.131621879427634],
              [88.45763300609822, 25.128459875168328],
              [88.452777383717432, 25.126066124697665],
              [88.448481057841306, 25.122964673504232],
              [88.446504388726737, 25.120243326368648],
              [88.445768560727771, 25.116631649672858],
              [88.44643885558304, 25.109832753226247],
              [88.448888542193373, 25.105159801039633],
              [88.45007244666391, 25.101030315755938],
              [88.451739911015835, 25.096053551580258],
              [88.450156103832114, 25.08634896955791],
              [88.450937250088188, 25.082263881041307],
              [88.4541804552983, 25.07979931257168],
              [88.452014992689698, 25.070298662399956],
              [88.449663074103782, 25.067344161012326],
              [88.446363043940067, 25.062132191948816],
              [88.443154831996807, 25.058943744842956],
              [88.438701342567086, 25.053014797397136],
              [88.438092662803072, 25.049404611535248],
              [88.442469828303857, 25.046717893378972],
              [88.443948640225514, 25.043783282020545],
              [88.449461321589425, 25.041101988389478],
              [88.451717261595803, 25.034566088133346],
              [88.451734794183722, 25.031395162615802],
              [88.449730792765536, 25.025136110393316],
              [88.446209357666845, 25.019371165728238],
              [88.444107820827753, 25.016648023841128],
              [88.443183982175995, 25.01099122511965],
              [88.438709296165001, 25.008737882613595],
              [88.433262332579588, 25.00957991279946],
              [88.430495147719881, 25.012736281783745],
              [88.427914869229951, 25.009986774612599],
              [88.426346998775472, 25.002511233196309],
              [88.423210449770764, 25.000310080025077],
              [88.414138040588426, 24.995938584689814],
              [88.412519408050358, 24.992941547937146],
              [88.416996068592979, 24.990048549231059],
              [88.416025397595106, 24.983932736591527],
              [88.412346607137792, 24.980074316458285],
              [88.412151639608467, 24.974857058527071],
              [88.402980284964613, 24.970737883866668],
              [88.400901530753131, 24.964635634028543],
              [88.403038986104335, 24.961224740207264],
              [88.403316204269913, 24.956953229128562],
              [88.401609898067036, 24.951727153357275],
              [88.397930687974309, 24.944030001488507],
              [88.393985479961017, 24.942398603567529],
              [88.383825399528263, 24.94369443169154],
              [88.374555667808053, 24.947452620084924],
              [88.371880221738138, 24.952101796467709],
              [88.366520027094523, 24.951288377840726],
              [88.364200009663563, 24.947872794027038],
              [88.354546790244527, 24.944666929127973],
              [88.346893526966454, 24.940092699979719],
              [88.345062705020069, 24.935209863191858],
              [88.340805564749147, 24.923763646836939],
              [88.337609708639448, 24.919676325569625],
              [88.332166043404698, 24.916471395402844],
              [88.3319426487149, 24.912402568009007],
              [88.334681096153531, 24.909479413634646],
              [88.33470527358935, 24.905872728996464],
              [88.345917885562557, 24.901186775616786],
              [88.347662431012466, 24.896463330326633],
              [88.346623508805607, 24.885817876432839],
              [88.344056440839907, 24.882172511029715],
              [88.342590934864248, 24.878991024584728],
              [88.340064377494315, 24.876724018742191],
              [88.336190211205476, 24.872173750083693],
              [88.332977876093068, 24.870796476218832],
              [88.328260991876789, 24.87235390482163],
              [88.325230616160326, 24.880926812611559],
              [88.31828374738285, 24.880446406116185],
              [88.313593786665635, 24.878143111723212],
              [88.30688859710979, 24.879133763224239],
              [88.303894247862104, 24.882606038813286],
              [88.299410734952616, 24.886413193131396],
              [88.295671895475522, 24.888206135093846],
              [88.291217473212825, 24.887717291158353],
              [88.287765665548477, 24.888152835421192],
              [88.284046752400954, 24.890357079020582],
              [88.28095670172371, 24.893026378194826],
              [88.277436764822539, 24.892381608840633],
              [88.275803204697411, 24.884695297022688],
              [88.274184265836624, 24.879010481916247],
              [88.271733502616712, 24.876511236696054],
              [88.266257671657598, 24.878268056013336],
              [88.265810271681303, 24.884628940445086],
              [88.265809750478596, 24.887983478724887],
              [88.266685861986502, 24.895481740305975],
              [88.267328498596228, 24.900678631386274],
              [88.265316721592143, 24.907441625606193],
              [88.264535315774438, 24.914467981435877],
              [88.261996318146188, 24.917162858414059],
              [88.260260860667486, 24.920069322494406],
              [88.25650377307349, 24.924110561628474],
              [88.254967744409214, 24.927640131802008],
              [88.252462843821945, 24.936076991661434],
              [88.249713662279376, 24.93991823359729],
              [88.246939380289234, 24.943714351898933],
              [88.238713106382576, 24.952273919920948],
              [88.230751858678687, 24.955850614064509],
              [88.221083453131399, 24.958263096171898],
              [88.212903675795616, 24.957081028287874],
              [88.208973885678361, 24.957029403247262],
              [88.204698518008428, 24.956102288317325],
              [88.194335063560402, 24.950719561515168],
              [88.187666802940896, 24.946697158421166],
              [88.183973466100554, 24.945566469100594],
              [88.176013312546715, 24.945509470827009],
              [88.170613542760961, 24.943308617727951],
              [88.166653981275005, 24.940891118686263],
              [88.164195461450447, 24.936367836975094],
              [88.155823224037945, 24.931550487602888],
              [88.143411190046649, 24.930789193071607],
              [88.142716652277443, 24.926464947590265],
              [88.145936612695294, 24.924007681217628],
              [88.148247275831167, 24.918603114200614],
              [88.152203785644957, 24.915231701401115],
              [88.155451777111281, 24.912314629312789],
              [88.156984551531906, 24.909613332118681],
              [88.160757161756692, 24.907000050272099],
              [88.163701694153687, 24.904242333126483],
              [88.1694692898254, 24.897941341052057],
              [88.170626362524303, 24.894895487126398],
              [88.171012596771092, 24.890737722649558],
              [88.160781615905492, 24.891766093810411],
              [88.158622686081344, 24.887935698402732],
              [88.161639730309574, 24.885223471528761],
              [88.165643823061885, 24.882082403921519],
              [88.167041051436229, 24.877358965738427],
              [88.164673699060998, 24.874446988783248],
              [88.161250070538983, 24.8712039176093],
              [88.164755735423157, 24.867368534033556],
              [88.175944556875621, 24.862718950142941],
              [88.177076331964031, 24.859786888784871],
              [88.170141581686977, 24.858149761155634],
              [88.166362942576683, 24.852239265214184],
              [88.161669542721569, 24.850413132527986],
              [88.156404101464233, 24.851980260408311],
              [88.149291351648714, 24.853097841647795],
              [88.146413785879886, 24.850798015526223],
              [88.146661865392829, 24.845058395484745],
              [88.146101716022997, 24.840316281645311],
              [88.144145880113371, 24.835689639480659],
              [88.144730336884408, 24.832178281396082],
              [88.137294077328548, 24.833478728146364],
              [88.135463969506759, 24.829625692530247],
              [88.137142784178764, 24.82428532813212],
              [88.140112846592544, 24.821298813740249],
              [88.141126407173246, 24.817468562910129],
              [88.139898401783071, 24.813851933315409],
              [88.139711408151484, 24.809092598974004],
              [88.141241450243228, 24.803658983231966],
              [88.134321923795767, 24.803376745494333],
              [88.130030503317201, 24.811041920024959],
              [88.129474544122559, 24.814416176933193],
              [88.129435223022782, 24.822112732065154],
              [88.127787413067509, 24.826626984736357],
              [88.124490318680529, 24.822654680962369],
              [88.123127432889376, 24.818635508243251],
              [88.117762086338672, 24.818668647171826],
              [88.117282135226844, 24.81298786958304],
              [88.114229180820274, 24.80797813778835],
              [88.112525201842615, 24.801394331567373],
              [88.109333686286561, 24.797760806835853],
              [88.107677380960467, 24.791428477632106],
              [88.108333886067513, 24.788354421972731],
              [88.109106567192995, 24.783052488789792],
              [88.105293058556285, 24.778957388197018],
              [88.100104668292019, 24.779812379581646],
              [88.091329535149811, 24.776341629228838],
              [88.086676701366684, 24.773157021708169],
              [88.081373476517641, 24.769714547286949],
              [88.07341246239578, 24.771005109115556],
              [88.071362400911852, 24.766922694442954],
              [88.071683170286292, 24.759021523260255],
              [88.072482283408178, 24.751099186697868],
              [88.070925087809513, 24.744997545359723],
              [88.072973672450232, 24.738212480345425],
              [88.073855385894447, 24.735141182387725],
              [88.068413107033209, 24.722135570042187],
              [88.06375792880516, 24.716653384145651],
              [88.058452269985821, 24.713899138089648],
              [88.05576631709755, 24.710477362063305],
              [88.048018673371288, 24.705450246308185],
              [88.044866492742514, 24.698162155591529],
              [88.041466451227748, 24.695952363404881],
              [88.03627534650893, 24.691794411380567],
              [88.031564833240125, 24.689919110100355],
              [88.027651813875949, 24.686277624299585],
              [88.024500716376906, 24.681723856447704],
              [88.020048783838817, 24.679434922176213],
              [88.017139278929207, 24.673297987989987],
              [88.013699183025622, 24.67009848279308],
              [88.013751296460413, 24.664470243302411],
              [88.016274207586363, 24.66083752048937],
              [88.019265221529835, 24.657944458877115],
              [88.022308692044348, 24.655097663881765],
              [88.035449954474743, 24.647003444901376],
              [88.042671473193508, 24.640697805752318],
              [88.047162642003656, 24.635793823431019],
              [88.04892680775653, 24.632406829166211],
              [88.051658213057053, 24.630615341481953],
              [88.054164561035876, 24.625648528903188],
              [88.057660028764033, 24.62252974075961],
              [88.059927325087656, 24.618917744901371],
              [88.064373816934818, 24.610473664182059],
              [88.06633214104798, 24.607961204770497],
              [88.068463310036137, 24.605428081263582],
              [88.069852549229196, 24.598866780324361],
              [88.073248396558, 24.592804640361049],
              [88.076756607076732, 24.58784851366649],
              [88.078523571369061, 24.584230557881508],
              [88.082276327352872, 24.580193152472305],
              [88.08577813886977, 24.572983662363562],
              [88.088587373222623, 24.567812894799879],
              [88.091589197013832, 24.563309530446261],
              [88.095060297731308, 24.559729880695869],
              [88.096568369129486, 24.556568890579392],
              [88.099318494838556, 24.552294193418724],
              [88.101797080115432, 24.550267461034526],
              [88.103082692663264, 24.546670516089929],
              [88.105898052514533, 24.543568171072629],
              [88.110552920493276, 24.539261447634786],
              [88.114057226922853, 24.534760643268562],
              [88.121761131332363, 24.529168829992464],
              [88.12576286848838, 24.52513179864048],
              [88.127721624772079, 24.522044651953632],
              [88.132218656384282, 24.518632862733288],
              [88.134324967204918, 24.516005170737937],
              [88.146672874964466, 24.50718305324714],
              [88.16598520127522, 24.500113225758678],
              [88.170957257192981, 24.496771040408941],
              [88.177907805558362, 24.490687938963127],
              [88.181149353297201, 24.486873376922105],
              [88.18318353028684, 24.483717867673729],
              [88.185164724205663, 24.480562150486946],
              [88.189626831249072, 24.474963250145777],
              [88.193679955989964, 24.466834519383415],
              [88.200632032364254, 24.460314675990695],
              [88.203736623771533, 24.458129540760225],
              [88.215508652398455, 24.454329353011772],
              [88.219199427374733, 24.45412718326638],
              [88.2243344085323, 24.453857277181953],
              [88.227709254487181, 24.453681510888082],
              [88.231927646119473, 24.453250291296357],
              [88.239759971146484, 24.452799135258836],
              [88.243428951948019, 24.452044245892822],
              [88.249146069785667, 24.449141463701153],
              [88.270172772044333, 24.442253203859675],
              [88.273651340917979, 24.440025989287751],
              [88.276887340070587, 24.436644927675299],
              [88.278389627072016, 24.433484349618979],
              [88.281120240555254, 24.430584669478399],
              [88.284578577856877, 24.427436289940385],
              [88.286585512771993, 24.42404990650142],
              [88.289939255257806, 24.421497869330238],
              [88.293319693021431, 24.41867044731028],
              [88.295296935480124, 24.415971826293529],
              [88.300399161091889, 24.410995246339013],
              [88.306226843235081, 24.406092418416478],
              [88.321961438434158, 24.393855492133255],
              [88.331994457045312, 24.386336007854869],
              [88.343210946541916, 24.377836016209077],
              [88.354578616041636, 24.372688659592384],
              [88.36595104861955, 24.370713361423192],
              [88.369914746256569, 24.370738122727957],
              [88.375833790769576, 24.370315293986142],
              [88.380794000968336, 24.371056585104796],
              [88.391871272787839, 24.372018192882543],
              [88.403683757736701, 24.375925683283057],
              [88.420290544499849, 24.37903299067478],
              [88.427359770657048, 24.379670881930068],
              [88.437219719570493, 24.378852742804483],
              [88.44415289290454, 24.376916895020756],
              [88.453075543909989, 24.373060576824969],
              [88.473223859511322, 24.362140610430757],
              [88.477071020725461, 24.360047392486067],
              [88.485266662610101, 24.356482447247362],
              [88.494882332128896, 24.353799578274945],
              [88.49835772410772, 24.351129253330967],
              [88.507994060271386, 24.344630703329663],
              [88.521360002789123, 24.344008806453111],
              [88.525100084400421, 24.34345367634306],
              [88.531491991261063, 24.338637626131455],
              [88.533216083439513, 24.334784910918401],
              [88.535934904914598, 24.332546822422948],
              [88.537955794735879, 24.329591707250909],
              [88.542893250964582, 24.32488308717884],
              [88.544671058325619, 24.320364212183691],
              [88.549874072977829, 24.307522767496643],
              [88.551402216332974, 24.302751700227425],
              [88.554146005398309, 24.300281710000959],
              [88.560297883854417, 24.29782978960051],
              [88.567437091820537, 24.303516647018714],
              [88.568221947534994, 24.30683163797255],
              [88.573008588294485, 24.322549207833735],
              [88.579164807667411, 24.324853025775244],
              [88.58334978857286, 24.324848926414578],
              [88.586568645270987, 24.322818924187242],
              [88.588103299998991, 24.316277260661025],
              [88.592305249165861, 24.312919005145574],
              [88.595522758591287, 24.311117003411105],
              [88.605881596882639, 24.309349122005219],
              [88.608937455154702, 24.31524653346705],
              [88.619414740454147, 24.315293292805912],
              [88.625325750448624, 24.316239217172907],
              [88.628565329278572, 24.314873434053172],
              [88.63006760178564, 24.309457295044563],
              [88.635743879450104, 24.306771637615789],
              [88.640683037788492, 24.306332370637005],
              [88.649796650716851, 24.308623065151735],
              [88.654990193382673, 24.307312698893558],
              [88.658911926658632, 24.310500629710788],
              [88.660527737411215, 24.313447362483657],
              [88.664734499969001, 24.314454130294493],
              [88.675409970166498, 24.315071551386001],
              [88.686993187411304, 24.314129959795515],
              [88.69283536476901, 24.313350110702348],
              [88.703822521851748, 24.311347702138384],
              [88.712455934553432, 24.308002313627039],
              [88.72509390489023, 24.299664355316931],
              [88.727309281340965, 24.296960741439509],
              [88.729547350810208, 24.294693989345248],
              [88.730515541580075, 24.291609362137699],
              [88.732023943341289, 24.288613980864355],
              [88.733514560852484, 24.285471857896546],
              [88.735984254882908, 24.281964121540323],
              [88.737729299413601, 24.277100686892528],
              [88.741089789123251, 24.269184013749978],
              [88.741867634446422, 24.261742478005214],
              [88.74002756955737, 24.250866559468964],
              [88.736907122876417, 24.233897752582521],
              [88.735963711491664, 24.224150914562316],
              [88.736275221974438, 24.207192753895612],
              [88.735953330450087, 24.198902859354359],
              [88.735817216035144, 24.19542634916062],
              [88.736096595182275, 24.187294430720168],
              [88.735540140447924, 24.181683715011221],
              [88.734257311389314, 24.176210887657906],
              [88.734021775871582, 24.172464459967983],
              [88.734783302299633, 24.169434848592047],
              [88.737119300181988, 24.166730230994393],
              [88.738634223564262, 24.163794276768886],
              [88.741848211316409, 24.160636158618914],
              [88.743588314059465, 24.157012646323491],
              [88.747030932495207, 24.153187492241372],
              [88.749285043207749, 24.146185529028131],
              [88.748955068374002, 24.140302093780591],
              [88.738359701324498, 24.134839903761709],
              [88.73576513793077, 24.132718200980722],
              [88.732700588896776, 24.128708726094757],
              [88.726058651489254, 24.124913705153268],
              [88.720058382146689, 24.122777397376716],
              [88.717086071911211, 24.12120434777183],
              [88.70775223787976, 24.121167944209521],
              [88.701599591060045, 24.119763596599821],
              [88.698656467824392, 24.117730280357666],
              [88.702117701040422, 24.109127533526234],
              [88.701807467950587, 24.098739681777005],
              [88.707825135334161, 24.095385920826825],
              [88.714214900686144, 24.099683616045215],
              [88.717663082307922, 24.100615876764873],
              [88.725545118624453, 24.101104788957581],
              [88.72950991967511, 24.097489834342685],
              [88.728534145327203, 24.090708161515078],
              [88.728406759409822, 24.085030132693742],
              [88.728278447716292, 24.078803598549108],
              [88.727740674597413, 24.075079594672665],
              [88.726294148683863, 24.067398934521975],
              [88.734084259102687, 24.064233631196458],
              [88.739485576099185, 24.064943598619628],
              [88.741499872949035, 24.061065941700541],
              [88.741212525887022, 24.057962469181525],
              [88.735313351718602, 24.056218842651287],
              [88.731641109581773, 24.05544666833703],
              [88.727181512144213, 24.054158108049972],
              [88.730458556053208, 24.050570908306561],
              [88.73731387355825, 24.049813461501262],
              [88.741877354900495, 24.03985886782344],
              [88.743039691016264, 24.036256018289265],
              [88.741329339248324, 24.024920066703789],
              [88.741581669636844, 24.017245425580104],
              [88.738921821210951, 24.01247846619766],
              [88.735602341244743, 24.010651449615622],
              [88.733291857715884, 24.006804808060213],
              [88.731910580657711, 24.00176721656042],
              [88.731031370238497, 23.996202806934267],
              [88.741217762055683, 23.999963690833308],
              [88.74598333693244, 24.002485224399209],
              [88.748801624473316, 24.005046280482784],
              [88.752646194615352, 24.006693151664955],
              [88.762561847210051, 24.00985382079379],
              [88.766247658003024, 24.006925330404261],
              [88.768855748074827, 23.997215065907362],
              [88.772468850611872, 23.993434508176016],
              [88.775107933528432, 23.989215204257508],
              [88.772700454665028, 23.983531815469679],
              [88.764392091357792, 23.98598469547732],
              [88.758938209002736, 23.987665878786718],
              [88.751887736717094, 23.98745579397519],
              [88.744917437790434, 23.986280739659072],
              [88.740007761630778, 23.981944713060383],
              [88.738540452772867, 23.979204261187675],
              [88.73908559247063, 23.96679639442441],
              [88.738222371793697, 23.963851898167992],
              [88.738234593073912, 23.960474770104732],
              [88.74279714146779, 23.956194462793285],
              [88.744668075854875, 23.950755642392945],
              [88.743583629380069, 23.94645413465997],
              [88.746079226207058, 23.940349338895071],
              [88.745720332463151, 23.935822279974879],
              [88.739677476382738, 23.934006998518441],
              [88.736762994221479, 23.931491546726132],
              [88.736275529793758, 23.928341515769514],
              [88.737518153270031, 23.923359094367544],
              [88.737068499593448, 23.916118595664503],
              [88.731650129379275, 23.915202116468969],
              [88.727144827695625, 23.91713792436644],
              [88.716906274243215, 23.915812567102037],
              [88.708284480949615, 23.915780186815464],
              [88.704844855065758, 23.913513041930255],
              [88.706186473844483, 23.909404719150789],
              [88.708723223910027, 23.905670422839709],
              [88.708737383844294, 23.901832257623951],
              [88.70171582965402, 23.902425494811165],
              [88.695898425578449, 23.901483761728588],
              [88.69120594924334, 23.89383403921935],
              [88.689193663409895, 23.890840411715264],
              [88.683308639945594, 23.888333905808235],
              [88.67726826884882, 23.887136175997838],
              [88.670777260616063, 23.885801118732346],
              [88.668318548714893, 23.882596208742118],
              [88.668602807650672, 23.874003035075255],
              [88.6624743831442, 23.869909148466995],
              [88.659026622574856, 23.870123677731218],
              [88.649436813586661, 23.869968883672509],
              [88.645271128424739, 23.868501821721914],
              [88.641840247092858, 23.865087495697964],
              [88.637675233148968, 23.863481920873802],
              [88.633253922520112, 23.86367124353545],
              [88.629798448982314, 23.865494190363819],
              [88.628436270698344, 23.868406486885217],
              [88.626308244175831, 23.875406013813027],
              [88.621877603102405, 23.877429990855891],
              [88.616112335281585, 23.876049749825818],
              [88.611351516881797, 23.868764914184119],
              [88.607665058374863, 23.866266669270484],
              [88.60399087592171, 23.866708684480631],
              [88.596096667764826, 23.872326878253283],
              [88.591180504963972, 23.871614389816592],
              [88.587283921859566, 23.86596490748952],
              [88.581033120049725, 23.862557661970982],
              [88.579439805124238, 23.856207438563118],
              [88.584868859984795, 23.85395966470659],
              [88.590043536247876, 23.853315223800479],
              [88.592022524786813, 23.846753662984487],
              [88.591377261812866, 23.840132233771168],
              [88.591570211945381, 23.836341821977108],
              [88.595306101143208, 23.828222561830618],
              [88.603366785049559, 23.823710293388192],
              [88.605612083868749, 23.818757254918097],
              [88.5997587837347, 23.815741623409703],
              [88.593467984705271, 23.815346704093319],
              [88.590358180239292, 23.813263475343554],
              [88.59122073975945, 23.810324635819516],
              [88.593677009631605, 23.808084614501762],
              [88.596049311318083, 23.802672203750621],
              [88.592313649940309, 23.800542248048508],
              [88.588873435874646, 23.799835350164241],
              [88.585859331547326, 23.798098249323882],
              [88.584697834422457, 23.790623202315935],
              [88.579042423962591, 23.788460310338237],
              [88.567483586148711, 23.788518975858988],
              [88.563470736866705, 23.787326756007062],
              [88.563587205398903, 23.783742494758894],
              [88.569653328825041, 23.778900309219743],
              [88.572580591062703, 23.777260364579455],
              [88.576886251620877, 23.77475214346882],
              [88.580092785559216, 23.772055986054809],
              [88.581709808602639, 23.767996891823511],
              [88.582505515129739, 23.758715959144759],
              [88.579678067426528, 23.754864195137429],
              [88.57775174182342, 23.75055878151246],
              [88.57762766506697, 23.745548962834548],
              [88.578536079274883, 23.738337483169197],
              [88.576662747008811, 23.733294566676538],
              [88.575172826067373, 23.72657802725551],
              [88.569544578794478, 23.719311007693616],
              [88.568425381124413, 23.713675557417353],
              [88.56968303019255, 23.706237092280862],
              [88.57336323269368, 23.693315169353312],
              [88.574601037364971, 23.690380995765935],
              [88.575275120859956, 23.684820577115811],
              [88.577757124184274, 23.672079087891298],
              [88.57276386912433, 23.667965513960681],
              [88.571535216983591, 23.664558890371303],
              [88.57218040003211, 23.660057609180541],
              [88.567257492607681, 23.651736976584768],
              [88.565482955534179, 23.647821370946907],
              [88.565499318354739, 23.644190674197112],
              [88.568957710397171, 23.640598759269583],
              [88.572353410394783, 23.639673760442435],
              [88.579764772767788, 23.638605814454642],
              [88.593522915002495, 23.639796769120451],
              [88.596828713817459, 23.636664810684763],
              [88.596991764569964, 23.62850806082141],
              [88.594784690214411, 23.620820075056216],
              [88.594105505613243, 23.616956609923516],
              [88.588488614776949, 23.613091783915873],
              [88.586607111099013, 23.610372597176355],
              [88.585436752189793, 23.604760211678823],
              [88.591182927669578, 23.602120076565914],
              [88.596130910291023, 23.604741425555744],
              [88.602757379221316, 23.605690575807678],
              [88.604476054834194, 23.600734750982852],
              [88.609130801074755, 23.602112251710945],
              [88.618220094032822, 23.604221815930213],
              [88.624072736174739, 23.605099849044123],
              [88.630197408866934, 23.606943096370056],
              [88.640761275211489, 23.60857479434512],
              [88.647382315464341, 23.610626279045956],
              [88.649001852458284, 23.605231669971474],
              [88.642995264614456, 23.599299894241014],
              [88.642413495601573, 23.595460007558803],
              [88.645247781579556, 23.591174246689672],
              [88.648444660883001, 23.589624604640466],
              [88.651646571221164, 23.586906126597206],
              [88.653182744822232, 23.58321143441108],
              [88.654739600991931, 23.574899250624483],
              [88.656140215924466, 23.567688644912952],
              [88.659113455727308, 23.559796377992988],
              [88.662570959339646, 23.555743510343675],
              [88.66527334961215, 23.55281369939707],
              [88.668196674108756, 23.550779990741955],
              [88.678050266919016, 23.548111442313274],
              [88.680850014615089, 23.545916932953226],
              [88.687895558532261, 23.541164795829342],
              [88.689853833529725, 23.537541069716013],
              [88.690376395591812, 23.531431052964166],
              [88.696022475340413, 23.527823087780543],
              [88.698992982913751, 23.519699535641152],
              [88.702213833979712, 23.517691249816075],
              [88.709069804992524, 23.516569613202297],
              [88.714457859116493, 23.514567227100365],
              [88.720029759249641, 23.510131820557874],
              [88.728718932092065, 23.511452425916588],
              [88.734392735708909, 23.499018623481511],
              [88.739735492002907, 23.495682762943598],
              [88.742483432214584, 23.493878845157333],
              [88.746455377233957, 23.483022466219055],
              [88.749649173155859, 23.481678116460706],
              [88.753085463731878, 23.481922570759327],
              [88.75684962674643, 23.480831724420209],
              [88.759920201272351, 23.485715857706847],
              [88.763124955759579, 23.488277560423267],
              [88.768588991005387, 23.485516104473657],
              [88.773954568635759, 23.482021238482595],
              [88.775633108931004, 23.486508174591844],
              [88.77415142814688, 23.490201878862592],
              [88.773764362623169, 23.49399220752947],
              [88.782936905482771, 23.499884279371464],
              [88.787420873022711, 23.49964810536887],
              [88.790290569002778, 23.497888596898086],
              [88.799876997205033, 23.498586697816709],
              [88.802831337966651, 23.493771431579521],
              [88.798767004864217, 23.487507892007422],
              [88.799525655454545, 23.48371704982414],
              [88.803589257619237, 23.482766128629095],
              [88.803102274799684, 23.479385740479266],
              [88.800618839436254, 23.477057782944303],
              [88.794057990186772, 23.472783887456707],
              [88.792203654379122, 23.468480133576126],
              [88.791805172369152, 23.461147440605721],
              [88.792881863192534, 23.451063849279382],
              [88.794862534884587, 23.447232459784999],
              [88.794401390609863, 23.443622725184884],
              [88.787036084701739, 23.441989001228723],
              [88.784359639372113, 23.438576878059589],
              [88.778602125087858, 23.440075108700743],
              [88.77650310214122, 23.44241102431884],
              [88.773329676534814, 23.445799544400174],
              [88.768775975148188, 23.445093465160152],
              [88.766477217001835, 23.440099259132779],
              [88.763837452871002, 23.42586594517412],
              [88.760891001498948, 23.421326802447719],
              [88.761883129495445, 23.415241682641724],
              [88.763387540681435, 23.412282341973043],
              [88.763525471235468, 23.408214986463108],
              [88.7617722661427, 23.404185369620279],
              [88.757899366479151, 23.401413631178229],
              [88.756069461546275, 23.397776887496253],
              [88.756389128054252, 23.391917511959484],
              [88.76079484641312, 23.384441126040652],
              [88.762994673747741, 23.377433512660922],
              [88.763769248012238, 23.373605299648911],
              [88.766221124005085, 23.370006922720613],
              [88.765745026245, 23.364122890692389],
              [88.762818269526448, 23.36137619557628],
              [88.759136071558217, 23.360903292372527],
              [88.753639668643814, 23.360446120044216],
              [88.750854483692336, 23.352967923866224],
              [88.746628422346134, 23.351871135830958],
              [88.739093670128412, 23.350899750725524],
              [88.737047265835827, 23.345470001263784],
              [88.74109449157865, 23.340957962192014],
              [88.741493695999452, 23.333926573938566],
              [88.740037226857439, 23.330773360998844],
              [88.742237407843376, 23.327907925990623],
              [88.748271883328357, 23.323563614541197],
              [88.750349044023011, 23.320401556772133],
              [88.750733257395538, 23.316793540440429],
              [88.749506064757824, 23.312240425716624],
              [88.747081047395255, 23.309081765928781],
              [88.743424238842664, 23.3090684042653],
              [88.739264947321033, 23.310868054027878],
              [88.735804653256835, 23.318069275671085],
              [88.731869584373584, 23.319434705464218],
              [88.729068192616865, 23.317147494304585],
              [88.728708624190446, 23.313768302616459],
              [88.731178807094381, 23.311732386450149],
              [88.730101344994196, 23.306972015149405],
              [88.728870902978812, 23.303497592137827],
              [88.726191480054354, 23.301486157027362],
              [88.720144902571477, 23.302451218170543],
              [88.716704289279207, 23.304734848831863],
              [88.713164119485342, 23.311086230464291],
              [88.707292137310034, 23.307318138636823],
              [88.703399927676713, 23.303946804762631],
              [88.700859092222842, 23.298950996330714],
              [88.700251224849467, 23.295338379784226],
              [88.702849554743622, 23.292156401645588],
              [88.707009231289987, 23.290608954115264],
              [88.7116844654104, 23.290398545540242],
              [88.714443533745069, 23.284295951442527],
              [88.716222515856344, 23.281154427941239],
              [88.718322750225397, 23.277761320401478],
              [88.720771817407964, 23.275037337174503],
              [88.725925184749229, 23.273035254172214],
              [88.727194620361416, 23.266465711414867],
              [88.723027040318129, 23.263738605957382],
              [88.722298823775702, 23.258771519223338],
              [88.72377911842942, 23.255170574276772],
              [88.728690563443323, 23.251786910609713],
              [88.73463775140759, 23.250201185916197],
              [88.7376024511412, 23.24844289298629],
              [88.750511906528118, 23.239896672295078],
              [88.760787607219797, 23.237431196649773],
              [88.765454932975018, 23.23926382765444],
              [88.767509970038589, 23.241751717765347],
              [88.77081469673827, 23.242224906675141],
              [88.780159305659978, 23.235249644878394],
              [88.781362970033058, 23.232310355479086],
              [88.781384096389672, 23.225968674990657],
              [88.7870425132664, 23.221461865812397],
              [88.790476844963507, 23.219886700326505],
              [88.793905749729404, 23.220358441062285],
              [88.800027949304337, 23.218105370665416],
              [88.803708043099249, 23.217657546429514],
              [88.811257511980131, 23.219521357401785],
              [88.81590972466357, 23.218158513209595],
              [88.818199902615902, 23.22540639180686],
              [88.813684430422896, 23.230146789794055],
              [88.812051298161123, 23.235587959829559],
              [88.81119073167774, 23.2407802169676],
              [88.811374251479975, 23.245905052946117],
              [88.812003714685787, 23.251399486501601],
              [88.821195394290783, 23.253475289127088],
              [88.823141111110814, 23.25100027253773],
              [88.82832478756481, 23.247386729954322],
              [88.834215761189938, 23.247175622600754],
              [88.831346224847294, 23.243074761827813],
              [88.826979604053292, 23.239912209006853],
              [88.825769983444104, 23.23696770157564],
              [88.829082033885371, 23.234726406645684],
              [88.833700333322639, 23.236556879254241],
              [88.837645000672239, 23.239947927223167],
              [88.841047109725267, 23.240417537654281],
              [88.843740613151454, 23.237943230650416],
              [88.845244151938601, 23.233192051014925],
              [88.854555558861065, 23.228463145097109],
              [88.858930211323766, 23.228270857508857],
              [88.865235387894188, 23.23152955924084],
              [88.869933201074886, 23.232117606638734],
              [88.875332132736943, 23.230113060503569],
              [88.884158733366945, 23.228783249636532],
              [88.892136588234479, 23.229655690903027],
              [88.898476960602721, 23.229373323792103],
              [88.90468949490166, 23.229737271376472],
              [88.910077902252311, 23.231818687533739],
              [88.916663162292423, 23.232481031641147],
              [88.920846653443959, 23.229114752437059],
              [88.922576891565754, 23.223006265327935],
              [88.920849234289776, 23.217347635103518],
              [88.917696782972087, 23.215752867600951],
              [88.920863234149991, 23.211234157861011],
              [88.926401245380191, 23.214214036416219],
              [88.930050723059793, 23.21521207024265],
              [88.933583512490443, 23.214440478209927],
              [88.938012670767023, 23.211210025656566],
              [88.942892231981617, 23.207684609819175],
              [88.951098518417083, 23.205844337064864],
              [88.954901509787774, 23.205002277583024],
              [88.958800964502672, 23.206804183267732],
              [88.960285487327269, 23.20952082028003],
              [88.971261767645473, 23.214325036847598],
              [88.975353025873915, 23.219229566880564],
              [88.978951513279966, 23.222939518033538],
              [88.982752166110316, 23.224510266200102],
              [88.987502943076194, 23.22240689304061],
              [88.993274061448091, 23.219800125171737],
              [88.995988011063446, 23.217301298853439],
              [88.997215294557208, 23.211878759740593],
              [88.992793597962489, 23.210767940658965],
              [88.989842296133602, 23.207222243700787],
              [88.991340851447049, 23.203271765779313],
              [88.990231344887491, 23.197984205451807],
              [88.98549316747696, 23.192872346183538],
              [88.985533945931394, 23.184712944602666],
              [88.980613831155225, 23.184703440213891],
              [88.979163281322016, 23.189225552436131],
              [88.975403828931519, 23.193101975628895],
              [88.971797845911397, 23.19463397281849],
              [88.966530110233194, 23.193494312068175],
              [88.962768451072819, 23.186246473060645],
              [88.959716383036124, 23.184193913264028],
              [88.958607716828269, 23.179687562128372],
              [88.955456010058825, 23.177632566665171],
              [88.95202611149584, 23.177602483706856],
              [88.948649650153499, 23.176191492079511],
              [88.941033308225784, 23.171714480333062],
              [88.939353163515605, 23.167183369594735],
              [88.936535491171711, 23.160624971525202],
              [88.934285859917949, 23.154944224865769],
              [88.93373038945883, 23.147932399911536],
              [88.934610262829054, 23.142971182940101],
              [88.931808730199876, 23.141148752592549],
              [88.928849251272013, 23.142726392450776],
              [88.924692665907898, 23.135108560868552],
              [88.924605726528199, 23.130053099992885],
              [88.921333372761936, 23.127101736355513],
              [88.914479575961707, 23.126163921018126],
              [88.91167764564419, 23.124133725524285],
              [88.90814029365265, 23.118010989737055],
              [88.904996556271499, 23.11441730677932],
              [88.900589549110762, 23.108707282596324],
              [88.89446370747639, 23.105541310642824],
              [88.891030342117162, 23.107621421749123],
              [88.887379495031581, 23.107334904125679],
              [88.884962132502537, 23.101675029016839],
              [88.877391614480146, 23.100297837326334],
              [88.873248144196936, 23.098698702609937],
              [88.872515809240625, 23.094170338513045],
              [88.874617143076918, 23.088522880767275],
              [88.87129935525553, 23.08490418548212],
              [88.869618588938934, 23.081474296151505],
              [88.869209273314453, 23.076878341829936],
              [88.869645642901517, 23.071548130943643],
              [88.87184315821348, 23.067256273419179],
              [88.87627387975796, 23.063179243288232],
              [88.877252411397663, 23.059112947346517],
              [88.877875190824057, 23.04849834965497],
              [88.879969673371093, 23.045333508520354],
              [88.88243512668393, 23.042167987270062],
              [88.881594952567823, 23.0317786028386],
              [88.87771244619401, 23.025883089364925],
              [88.875145098885866, 23.021119688433558],
              [88.874906093858186, 23.017486454905708],
              [88.87652694147819, 23.014320017232269],
              [88.87654710099585, 23.007104795997265],
              [88.873971856642797, 23.004591335352686],
              [88.86811335507052, 23.005494467771886],
              [88.86103423552855, 23.008091208909928],
              [88.856388326445412, 23.009755098552318],
              [88.851849731079852, 23.008821026768189],
              [88.850021592843007, 23.005874777561196],
              [88.861054669132059, 23.000392000060717],
              [88.864486594949312, 22.998471595767633],
              [88.871102062411964, 22.99238067880265],
              [88.872317686794361, 22.983327501573868],
              [88.871855402919522, 22.971584316630295],
              [88.870425316810781, 22.967924273822309],
              [88.865303778454319, 22.963174804439596],
              [88.864597083752969, 22.957979288794647],
              [88.869963898170582, 22.954823523166553],
              [88.876788560071631, 22.953924926544627],
              [88.89119810305624, 22.954978053068533],
              [88.894870054521249, 22.95489684552345],
              [88.897924948631342, 22.953596605267883],
              [88.900362351799288, 22.951305570672165],
              [88.900751537805093, 22.944504630179765],
              [88.899308348186992, 22.935903788455398],
              [88.900044194880792, 22.929587292890627],
              [88.9078941189738, 22.925287088558001],
              [88.913252155708165, 22.92463781952743],
              [88.91692897443869, 22.921474186355937],
              [88.91644495806689, 22.91694637161865],
              [88.912784711320398, 22.91309779695985],
              [88.906696849215606, 22.907428009766239],
              [88.90684072198998, 22.899292198220611],
              [88.908888708923399, 22.893851810272377],
              [88.912367611003447, 22.880302330345017],
              [88.917780165602437, 22.876916771778955],
              [88.924603100608337, 22.874660659238071],
              [88.932420170338162, 22.871831057415829],
              [88.935571869586866, 22.870850547768995],
              [88.940700620651114, 22.872013094240604],
              [88.945968964651115, 22.877290228320618],
              [88.948986657744925, 22.880330686985904],
              [88.951199751634078, 22.877233095084684],
              [88.95364509128747, 22.870001388045292],
              [88.956008401451371, 22.866880710224013],
              [88.959269078143748, 22.859835147277291],
              [88.962698992598817, 22.855314826284673],
              [88.966124684359741, 22.853048799135124],
              [88.969683629789401, 22.846761453311405],
              [88.970019129767167, 22.839773766118721],
              [88.969340669468593, 22.831820772299249],
              [88.966187689760716, 22.822321801849007],
              [88.964028629846112, 22.812802586576012],
              [88.96205329283832, 22.808958748471944],
              [88.961444342498595, 22.803648599746637],
              [88.961383321011169, 22.797190872625674],
              [88.953583966687376, 22.795125830550212],
              [88.944547253073651, 22.791058771777642],
              [88.941308184718537, 22.78900345214069],
              [88.935545894169707, 22.784230706855663],
              [88.932638048674718, 22.776985755256415],
              [88.93004221838693, 22.774910073001649],
              [88.92472819784723, 22.769056303682582],
              [88.922163649332646, 22.764752630607106],
              [88.922184073561908, 22.755903546394197],
              [88.924180360667421, 22.749589531859023],
              [88.924191073118322, 22.745292894346729],
              [88.922469856079459, 22.740529022793119],
              [88.923715056009826, 22.736925147576638],
              [88.92614898676112, 22.734887291295003],
              [88.929199632195591, 22.732298050568872],
              [88.9339656476333, 22.727669002143834],
              [88.937504029896402, 22.718645356146844],
              [88.939715095253121, 22.715135471739924],
              [88.941651879025187, 22.712543883811598],
              [88.945573771294136, 22.708600701079668],
              [88.948651119898059, 22.705551165137351],
              [88.951330618390443, 22.70282402201093],
              [88.962071628164693, 22.694278612844411],
              [88.960893124391632, 22.688851875683117],
              [88.957092093464738, 22.684084740862822],
              [88.951644265099574, 22.673430529687057],
              [88.950181141227461, 22.663015455839545],
              [88.941686072252111, 22.65373134853326],
              [88.935976660271734, 22.650544612904948],
              [88.932452200151062, 22.644446043157938],
              [88.931718140013857, 22.640812746997582],
              [88.934174715106209, 22.637646674185174],
              [88.938955794190505, 22.624765768169244],
              [88.941762887130523, 22.620682374820397],
              [88.946394884394564, 22.617960414479203],
              [88.95003404774063, 22.61753323807919],
              [88.956545782546115, 22.615570635496944],
              [88.958829592757141, 22.609086319073732],
              [88.955163527996987, 22.602238897865188],
              [88.94803394051732, 22.595181418584261],
              [88.944363845445821, 22.59094984675178],
              [88.943944995110499, 22.584513523408344],
              [88.94525853860921, 22.578684661709062],
              [88.94982106890393, 22.570250061957498],
              [88.949190707693958, 22.562406089582257],
              [88.951147671101722, 22.558186337505621],
              [88.962850410989503, 22.550776585452233],
              [88.969791246299621, 22.543755491068918],
              [88.974801126827998, 22.528083513003761],
              [88.979791069413224, 22.513082975762195],
              [88.98120881289168, 22.496608304684017],
              [88.982709651941917, 22.488016446624474],
              [88.9863077223674, 22.481130138550302],
              [88.989302735633842, 22.478977705836062],
              [88.992225407597658, 22.477190383708514],
              [88.995023186215462, 22.474692016134028],
              [88.995658995681907, 22.465201983317979],
              [88.992517697502251, 22.453427326515989],
              [88.992282591733073, 22.447542879198409],
              [88.993726223690729, 22.441894363912603],
              [88.998139372379143, 22.435170658359002],
              [89.000075724120265, 22.429934895896899],
              [88.999861726846348, 22.426072991160815],
              [88.99692512436593, 22.423125102721283],
              [88.992827937834889, 22.420862234950825],
              [88.983764146970913, 22.417966480270433],
              [88.981275449324443, 22.415179727952566],
              [88.978344241005047, 22.410553516682029],
              [88.977766456172702, 22.402737571617468],
              [88.980711860484845, 22.400011426370771],
              [88.982399179503645, 22.39707360881836],
              [88.993827542592257, 22.389653034649108],
              [88.994093907657501, 22.379933751277019],
              [88.990947545865453, 22.372432453158492],
              [88.990955047032358, 22.367468029267148],
              [88.992448083063863, 22.362713849099439],
              [88.992984618750299, 22.340330108678568],
              [88.993463601522592, 22.336263471443214],
              [88.989824190802125, 22.328554652188267],
              [88.989238079437101, 22.324256089658373],
              [89.004925037035548, 22.321373654968269],
              [89.007252482941539, 22.318438202507661],
              [89.011480017163777, 22.314815493209718],
              [89.015739366952474, 22.308091560351166],
              [89.017844535000464, 22.305546495809335],
              [89.020836283158673, 22.30318610799107],
              [89.023487073759568, 22.296962928688323],
              [89.018527217124017, 22.296469477412437],
              [89.012745561095826, 22.298065001402474],
              [89.005192379695998, 22.297380186438907],
              [89.000338456818639, 22.292610946802242],
              [89.000354366987693, 22.284705699304311],
              [89.001222573250402, 22.281535985099456],
              [89.005821541772391, 22.278534597983825],
              [89.012763068980107, 22.275908430527789],
              [89.017657866484484, 22.272058716987395],
              [89.016926624724064, 22.266172333687912],
              [89.015132614780327, 22.262169649261384],
              [89.014722183697259, 22.256538033031937],
              [89.019393036902812, 22.253744888961755],
              [89.024174741485098, 22.257180145909146],
              [89.031770706837506, 22.261470791522758],
              [89.035896675864976, 22.258538834535901],
              [89.038450648286059, 22.251557135829128],
              [89.04100704588673, 22.243381549637412],
              [89.041579389812853, 22.239796733754627],
              [89.042751279856802, 22.232996865271275],
              [89.044186279272907, 22.229805116830576],
              [89.047848104659224, 22.22461758488712],
              [89.051182757107028, 22.222187575620474],
              [89.059852002273658, 22.216323679898107],
              [89.062916354621365, 22.213800013879304],
              [89.065341979590741, 22.208612169104363],
              [89.067788545455585, 22.206340804844508],
              [89.069992243638552, 22.200485738878612],
              [89.071433187001674, 22.193018615096339],
              [89.071442350514488, 22.186673931558978],
              [89.07039008928237, 22.181570331151626],
              [89.070752650165304, 22.169252094882424],
              [89.073929478505349, 22.155675343321004],
              [89.079533034875311, 22.151871006667665],
              [89.082787864474085, 22.152313052055479],
              [89.085943177983722, 22.155262342915474],
              [89.090917769149172, 22.16092386469904],
              [89.095774091386303, 22.162060196029337],
              [89.098316896527663, 22.159581004832901],
              [89.097369511798945, 22.148020167363725],
              [89.091681371064183, 22.142609005442118],
              [89.089736046760606, 22.139663011489183],
              [89.079558527260232, 22.134196999057753],
              [89.073349858144169, 22.129611571213058],
              [89.06938528470306, 22.126499471715441],
              [89.062686297333343, 22.120832781419061],
              [89.058695194532092, 22.118320823538792],
              [89.053597328679089, 22.114035359350396],
              [89.051681766942437, 22.10973260067454],
              [89.04852968962328, 22.106992289330162],
              [89.045138032849835, 22.100433216905842],
              [89.044898467639456, 22.096801172364451],
              [89.045154970063962, 22.090940720091943],
              [89.053182036463497, 22.06560762748666],
              [89.054556983603305, 22.052968623653339],
              [89.056860066138498, 22.047298364363673],
              [89.059302473042692, 22.044589536872415],
              [89.063425897713302, 22.04073744935884],
              [89.068780009282392, 22.035783778925058],
              [89.071444524364779, 22.033306304919325],
              [89.073889082450606, 22.031060302052669],
              [89.077270066980731, 22.027205732656231],
              [89.079224454774419, 22.02224507852485],
              [89.081027060730747, 22.019512885776127],
              [89.081897292397144, 22.014250486192445],
              [89.083146595412046, 22.000992800237281],
              [89.08295963024662, 21.993268351176084],
              [89.083483791379209, 21.988282619083126],
              [89.084151958770278, 21.951440588252549],
              [89.082242293029751, 21.944428548056784],
              [89.079590619919614, 21.938538927362298],
              [89.072805329687228, 21.931055029339273],
              [89.069678096364015, 21.929623196979474],
              [89.06261745210395, 21.926322422520055],
              [89.058999006143324, 21.924247462269541],
              [89.052451273590265, 21.924233367619426],
              [89.046297610410861, 21.922725909100087],
              [89.033819293445305, 21.918768916937996],
              [89.030179244597093, 21.916277258650936],
              [89.026549371367594, 21.907879504499878],
              [89.024870146152509, 21.897257268806332],
              [89.02584625859798, 21.889331681031749],
              [89.027575414843866, 21.886163604939131],
              [89.029624135433721, 21.883109648921554],
              [89.037040939243894, 21.87804727695492],
              [89.039433701597687, 21.875799704275689],
              [89.041259874876118, 21.873069333062713],
              [89.044308903797798, 21.860411009406043],
              [89.045072999109323, 21.845933222057489],
              [89.044687102968254, 21.840806222463172],
              [89.044351848780821, 21.836209113400646],
              [89.033522273347458, 21.808582151382637],
              [89.031362319351587, 21.792280558830409],
              [89.031373360386439, 21.786397906310878],
              [89.032904928378883, 21.782699952326446],
              [89.036241818518505, 21.774431838368589],
              [89.038656209821056, 21.771932169488167],
              [89.039892637235511, 21.768764033291056],
              [89.042553521065386, 21.766310387695079],
              [89.045658454660526, 21.762202407898457],
              [89.047582889498386, 21.758760128956173],
              [89.051767816907812, 21.756124448826725],
              [89.055416245881176, 21.752548397532923],
              [89.061793625298918, 21.746609536870793],
              [89.067286271994575, 21.742253257577243],
              [89.069969549700247, 21.740097582303015],
              [89.073590001029459, 21.737531534378522],
              [89.078980808362928, 21.733679559127886],
              [89.083288860691354, 21.730196237731771],
              [89.084966302673365, 21.72658998415481],
              [89.087875445937613, 21.72227605737271],
              [89.090536536789514, 21.718441455520296],
              [89.093218939230525, 21.715965144398208],
              [89.094922935402806, 21.711670956346634],
              [89.097830742179482, 21.705562122251102],
              [89.099903178716545, 21.701704408744789],
              [89.100939960437458, 21.697936962815543],
              [89.105259924174717, 21.68521132579755],
              [89.10627309907531, 21.681514096967092],
              [89.111667426286331, 21.673225693174842],
              [89.114570417740083, 21.670978196216051],
              [89.115533989387046, 21.667601202355222],
              [89.120232540960828, 21.662736742253934],
              [89.122325200797704, 21.659914558967792],
              [89.124249097950596, 21.655160435454384],
              [89.12887485778252, 21.651559387643957],
              [89.130548965346136, 21.648160192826285],
              [89.13369768713072, 21.646142593161468],
              [89.135520088157762, 21.641754856224846],
              [89.137220057032422, 21.638656178284855],
              [89.138404163853707, 21.634635038163182],
              [89.138580241108343, 21.630521152161844],
              [89.137149369763975, 21.614086302455625],
              [89.133073785745509, 21.58925507252026],
              [89.137397022028253, 21.590480822843826],
              [89.139686371312209, 21.587543144656127],
              [89.133302878265326, 21.583026191603899],
              [89.127011811785238, 21.584349399707087],
              [88.879337560467519, 21.532380464400429],
              [88.872561914722397, 21.531439255692948],
              [88.637741925257714, 21.54959515710204],
              [88.549402971949732, 21.53256971112955],
              [88.546001439162268, 21.53050425843513],
              [88.539963291724206, 21.529575999882745],
              [88.533224038399979, 21.527266040939566],
              [88.525478302996348, 21.528834370282716],
              [88.52376011014357, 21.533559158171649],
              [88.520490558056892, 21.53400258724399],
              [88.518467478349905, 21.531277947348258],
              [88.512644377861562, 21.531707418617231],
              [88.436595124304517, 21.546119970177482],
              [88.336398022784024, 21.542193145027372],
              [88.239132199193037, 21.48608531801549],
              [88.231422654682476, 21.482858247242952],
              [88.063753586183608, 21.507344846318503],
              [88.053544101388482, 21.508175038494873],
              [88.049253812811244, 21.506979658188808],
              [88.003702775768744, 21.5123618479026],
              [88.000497435362533, 21.510771764297687],
              [87.994344534314763, 21.512170716151363],
              [87.993837271285997, 21.515626780681071],
              [87.953737616711166, 21.59174683396078],
              [87.947232427877083, 21.590999842549433],
              [87.946925365651239, 21.597777996423581],
              [87.906178174381637, 21.683408013819037],
              [87.904579298249203, 21.686107650523386],
              [87.906152020916181, 21.693751970361447],
              [87.907111981361425, 21.698886980726606],
              [87.907446006950238, 21.702429798053025],
              [87.93443248695722, 21.743626664793577],
              [87.934829141521888, 21.747063437375502],
              [87.940463944963312, 21.755118955626287],
              [87.944846931075404, 21.759739022079447],
              [87.947662984350629, 21.763944060131102],
              [87.951820112623636, 21.767048180554699],
              [87.957404645654094, 21.770521887276438],
              [87.995691178347897, 21.811417069154849],
              [87.986860836719316, 21.808528153633567],
              [87.981795307912023, 21.805564527885227],
              [87.974032521671433, 21.806853445826164],
              [87.973674586874395, 21.810919017173699],
              [87.977304068047872, 21.817779364401549],
              [87.981053053718085, 21.822269478475377],
              [87.982948920995653, 21.824792355109157],
              [87.986664207078277, 21.827558550745884],
              [87.990039354328502, 21.829840667772341],
              [87.99388903568989, 21.834195236415631],
              [87.995529653971857, 21.837819888448614],
              [87.99536963420968, 21.841884643925432],
              [87.989491514702053, 21.838663249540172],
              [87.986603152338731, 21.83705276384277],
              [87.982705896370533, 21.837937542005687],
              [87.985276339662903, 21.847684408526145],
              [87.990428886696421, 21.854739864179013],
              [87.996085866532582, 21.858073717956593],
              [87.995413499126926, 21.86183411274309],
              [87.992118201752362, 21.863651069209926],
              [87.984252752997875, 21.856309404044495],
              [87.97812206177376, 21.848410352556371],
              [87.972210905784237, 21.840276700762299],
              [87.96428560763745, 21.831722737532466],
              [87.960950424095302, 21.82606882374289],
              [87.951797633504938, 21.817772440198858],
              [87.940800700355837, 21.80663007676198],
              [87.926277224755481, 21.794849523520497],
              [87.915588859518309, 21.78943298580911],
              [87.911973554023206, 21.786857047022824],
              [87.90452083725225, 21.784053641417248],
              [87.898235579813445, 21.782915457507748],
              [87.897090170670964, 21.776674974868879],
              [87.894215998029026, 21.771087104494587],
              [87.889425328469869, 21.767847273542376],
              [87.88652290044169, 21.765362709310168],
              [87.875119324305388, 21.754384147954315],
              [87.871632937548881, 21.748856681277225],
              [87.869765824590644, 21.745965326614865],
              [87.864473729121229, 21.741618128690085],
              [87.860656374870814, 21.73705452189926],
              [87.85548094684934, 21.733375012194976],
              [87.852023098846075, 21.729732300521615],
              [87.844305260905287, 21.724463011526399],
              [87.840850518900837, 21.72082226556865],
              [87.836641528203572, 21.7162318832215],
              [87.829582875789612, 21.711567428577464],
              [87.822242503356875, 21.705704484335108],
              [87.814546567700845, 21.700870566046721],
              [87.787044200233254, 21.688053930411396],
              [87.779623015878471, 21.685381793451615],
              [87.77501201221763, 21.684188346440944],
              [87.764742454584621, 21.681281513499535],
              [87.76125424038888, 21.683383940943958],
              [87.754726622472148, 21.682194071148221],
              [87.753808439248445, 21.678551372560719],
              [87.748392251263112, 21.672337599266132],
              [87.744233053200929, 21.668042424750237],
              [87.730792719913481, 21.658412385748342],
              [87.706759535666365, 21.644581871481929],
              [87.695915064384806, 21.640630766768616],
              [87.68011355357639, 21.635894143720574],
              [87.676610115158439, 21.634960020090293],
              [87.66744667031378, 21.632426590212983],
              [87.655143010577433, 21.631836669506306],
              [87.632934492328374, 21.626842854820346],
              [87.610970023780823, 21.62412338361969],
              [87.604673415771344, 21.622467274132557],
              [87.597662147940056, 21.62328758777095],
              [87.585113793414095, 21.62043750579981],
              [87.574019933418114, 21.617143419723408],
              [87.570407857384282, 21.617102055568456],
              [87.568430724692931, 21.620023630295712],
              [87.564074064546773, 21.620663610219118],
              [87.559966276768549, 21.619033011527449],
              [87.558813924280315, 21.614721128035082],
              [87.550623682462586, 21.611228364028424],
              [87.543905333820092, 21.610048162815545],
              [87.534180053442981, 21.607571258775568],
              [87.528119056080641, 21.606789902312219],
              [87.521197686927962, 21.606159589665332],
              [87.516706945689279, 21.605649483195457],
              [87.508811101530497, 21.604501662663445],
              [87.503016070572329, 21.604066490424458],
              [87.498986056981209, 21.604089358556863],
              [87.490218973548167, 21.602650014909731],
              [87.485393594117625, 21.601370589777662],
              [87.474418676780289, 21.59988410271766],
              [87.468749591541069, 21.597907195808723],
              [87.460825521154987, 21.59344215746113],
              [87.457490199800745, 21.591444673302298],
              [87.447587838830358, 21.587168104100993],
              [87.437654649402148, 21.580637804003988],
              [87.434449176699502, 21.57741479566182],
              [87.431282040049439, 21.574878815940004],
              [87.428627389475437, 21.572708828831985],
              [87.422050327292709, 21.560707765578282],
              [87.417526658578623, 21.551985139617358],
              [87.416612938359421, 21.548858955164306],
              [87.413088388636638, 21.546524340763018],
              [87.410096663376592, 21.544875071905167],
              [87.402798278188314, 21.547916323929467],
              [87.399771029502773, 21.554405210961082],
              [87.396306965521518, 21.561835325966008],
              [87.394769357578838, 21.564621230600348],
              [87.390390564885081, 21.56890190342876],
              [87.384495640127554, 21.5728959022351],
              [87.380248331444747, 21.572997079319606],
              [87.373856252133223, 21.575557821572314],
              [87.365127884219589, 21.575102348295047],
              [87.357185517138845, 21.576356812203702],
              [87.347290902431553, 21.580463945546157],
              [87.340760392084164, 21.577994867681234],
              [87.338483119053947, 21.572404541663268],
              [87.343753685538729, 21.569553572402462],
              [87.357038003306513, 21.567584863285589],
              [87.362861920043372, 21.566246995658013],
              [87.373133218377859, 21.562721727893109],
              [87.37467216345722, 21.559475512905259],
              [87.376060259291819, 21.556213950308607],
              [87.380899916366261, 21.554417778282975],
              [87.388246613008675, 21.547422475443216],
              [87.390903850168542, 21.545294230476088],
              [87.395446213994916, 21.5422027101278],
              [87.397449251278047, 21.539370206610851],
              [87.398494089496765, 21.534357049288715],
              [87.394111372765423, 21.531601526335098],
              [87.387732675083029, 21.532207587120244],
              [87.380954350902599, 21.534418674989592],
              [87.373906217951657, 21.537562379327142],
              [87.361451364142496, 21.541147083321331],
              [87.354709759364738, 21.540528224385341],
              [87.349442338172537, 21.541240468510033],
              [87.345285285390759, 21.540750356678497],
              [87.328811799835137, 21.540111813177727],
              [87.32207347410538, 21.540481438810186],
              [87.305089166198371, 21.539496882001899],
              [87.296596824640588, 21.539211114549051],
              [87.281552516984462, 21.538662176183042],
              [87.275482050718935, 21.538193526488762],
              [87.267334727986011, 21.539268564386536],
              [87.254463703082109, 21.538039933735234],
              [87.248853300277304, 21.538304738821726],
              [87.237970172017214, 21.537486580116646],
              [87.223558252693323, 21.5349942739733],
              [87.204683387110961, 21.530458532467765],
              [87.20070671392449, 21.528277503089157],
              [87.190305284875365, 21.523663446166452],
              [87.186744059730302, 21.522335729002869],
              [87.169580664510235, 21.515807393589327],
              [87.165541790631323, 21.514272276284562],
              [87.160800296807594, 21.512448034799256],
              [87.150255974854673, 21.507884596192596],
              [87.134947277792207, 21.498344400383527],
              [87.128615503904371, 21.494823726698723],
              [87.121696437755475, 21.489538545436123],
              [87.112679385488534, 21.483612985740205],
              [87.103958790281553, 21.474522829982835],
              [87.097181309158699, 21.465021116233935],
              [87.091355523017484, 21.460395258922851],
              [87.088380225624078, 21.458946537307096],
              [87.081384831604112, 21.45950066400383],
              [87.073582284805553, 21.462344734111191],
              [87.070179925338834, 21.462065753537818],
              [87.068453592035908, 21.454651044159327],
              [87.067844230994766, 21.445644775132557],
              [87.065394444840351, 21.440768438744442],
              [87.062577116430973, 21.438162857319593],
              [87.055016712998878, 21.431777739474573],
              [87.052666549534962, 21.428711990695643],
              [87.041550114280128, 21.419708473361595],
              [87.037941069992669, 21.417849590025188],
              [87.035259061868047, 21.415927364841021],
              [87.022797012255538, 21.408777089923646],
              [87.014110306508726, 21.403772177563681],
              [86.996732054674439, 21.395073288235146],
              [86.986603162027464, 21.388800349987619],
              [86.981951741903345, 21.384875334815423],
              [86.971727312177578, 21.37674463479819],
              [86.966834017632081, 21.373356667676102],
              [86.960929271093562, 21.367050791751936],
              [86.957404970163424, 21.364499040935137],
              [86.955548907068632, 21.360950737686508],
              [86.95150185595341, 21.357755434233553],
              [86.948004678667189, 21.352442560818339],
              [86.939430763265534, 21.338325899741218],
              [86.937721168894967, 21.334335290685139],
              [86.93558690029127, 21.331074513791226],
              [86.931246068723169, 21.322741380321325],
              [86.929767773028033, 21.319866470239852],
              [86.928437416318431, 21.31647798688947],
              [86.923469405358745, 21.306979846930787],
              [86.914010650747699, 21.292762441135249],
              [86.911871054954517, 21.28892848086074],
              [86.909284995594334, 21.285435948836557],
              [86.901544228678375, 21.269783159006877],
              [86.899261595403175, 21.266508500668447],
              [86.895055409941307, 21.257845899262033],
              [86.893065574747411, 21.254511007718715],
              [86.89018047891733, 21.251398590608229],
              [86.888292137762249, 21.248610472668009],
              [86.884017561789662, 21.245630627869541],
              [86.877143207870574, 21.238467687013642],
              [86.865654445317631, 21.221786878521268],
              [86.862736934770084, 21.212423735076534],
              [86.861226170085956, 21.208859012312001],
              [86.859093880139611, 21.206011798684845],
              [86.855294196773755, 21.199469081124885],
              [86.853970839729286, 21.19665321052382],
              [86.850332656925602, 21.189414719194545],
              [86.845489119233662, 21.173123734174933],
              [86.843607928098791, 21.161506156941694],
              [86.843200364822678, 21.156948373318521],
              [86.844337133134204, 21.151012782117974],
              [86.844968316065732, 21.135374096903551],
              [86.847025194346969, 21.124568768353395],
              [86.848521256247835, 21.118476675762157],
              [86.853415962974125, 21.102877737044533],
              [86.854248493492065, 21.095828997695723],
              [86.858954512436895, 21.088813728768894],
              [86.860459029898465, 21.081043616466403],
              [86.863988667278932, 21.069804075599635],
              [86.867307322184189, 21.064437696110414],
              [86.869098152441026, 21.061666214623145],
              [86.872051915867218, 21.053994068006965],
              [86.873061114393039, 21.05077614454213],
              [86.874956836117093, 21.044873603543056],
              [86.878371923841996, 21.040422167976658],
              [86.880554386221164, 21.036254714458526],
              [86.882481016818488, 21.031867728214579],
              [86.884792563864579, 21.029741951445459],
              [86.888636421956761, 21.025039307017629],
              [86.889422515749374, 21.021372925649306],
              [86.892520912979748, 21.016473565739016],
              [86.896295249431745, 21.010440538698603],
              [86.901585606107119, 21.000684965780525],
              [86.903556497268795, 20.997193861463046],
              [86.905592049534079, 20.994457757802078],
              [86.907188251888385, 20.990318393375045],
              [86.910071570052139, 20.982302907771768],
              [86.911500434321425, 20.978284071400576],
              [86.914390214102667, 20.974083886666808],
              [86.919343925393676, 20.962136587128402],
              [86.921581013894311, 20.959506463767678],
              [86.924804314131663, 20.951912315628931],
              [86.927505886340597, 20.946961003677853],
              [86.930019269838823, 20.941238024601969],
              [86.932618523909866, 20.937627031190157],
              [86.934643273417421, 20.93516711585109],
              [86.935737698157155, 20.930818584684012],
              [86.938135753002612, 20.926157878726002],
              [86.940339810055733, 20.922472350010828],
              [86.948100709158069, 20.913729519680135],
              [86.950293031992487, 20.907975480351052],
              [86.953725313848082, 20.897405509288774],
              [86.957380138197109, 20.893837511569249],
              [86.958936631898126, 20.890870441335078],
              [86.963735052902294, 20.886332483217611],
              [86.965215973140701, 20.88240137718331],
              [86.969556012239309, 20.877929058717346],
              [86.972371279924403, 20.871917136678775],
              [86.975357760220689, 20.864539533133581],
              [86.9785569031785, 20.861197898435403],
              [86.981030276603462, 20.853406968634932],
              [86.981269635840107, 20.849098251002939],
              [86.980854622023941, 20.839369238244508],
              [86.980109908483726, 20.822435161470327],
              [86.978096499266201, 20.812043876006122],
              [86.97534749071292, 20.800237823771806],
              [86.974238847282152, 20.793069084841765],
              [86.97053069205225, 20.790892361145456],
              [86.966141812858552, 20.791113884586913],
              [86.958774936035667, 20.787217378277973],
              [86.955468003217504, 20.788493422813229],
              [86.949663092862409, 20.788732548685804],
              [86.941942022945767, 20.792047799550158],
              [86.92836151225201, 20.790407168445995],
              [86.915065557336234, 20.793258938133473],
              [86.908797183745193, 20.793081403273092],
              [86.903436154133644, 20.791965031126228],
              [86.896841762682442, 20.792100245528523],
              [86.8921679984375, 20.792494578543842],
              [86.885262157640369, 20.794137364322815],
              [86.883039874442517, 20.801226558849468],
              [86.88236931238427, 20.808061550142305],
              [86.875972351490503, 20.805405227840417],
              [86.87507684433092, 20.797100350390036],
              [86.871791951127193, 20.793614325498922],
              [86.86636094685619, 20.791649871257835],
              [86.861275834642456, 20.790704812820287],
              [86.856851758717639, 20.788833891727695],
              [86.849928216402091, 20.783049443919509],
              [86.832318647039116, 20.77525956705189],
              [86.825258367458886, 20.771044249054565],
              [86.82048117868456, 20.764680940135083],
              [86.820063383084729, 20.756560934499618],
              [86.818656568780881, 20.752990468353754],
              [86.815400654207551, 20.751575521193526],
              [86.806755874819245, 20.754875400324249],
              [86.80231653681804, 20.754956869136294],
              [86.798527331225173, 20.754550308759377],
              [86.795901028441463, 20.752413017523384],
              [86.794457296641596, 20.745234745127139],
              [86.796352951847538, 20.742667322730792],
              [86.798049905974011, 20.738532512834791],
              [86.802066041791164, 20.734483231671337],
              [86.811254411549342, 20.73069566629345],
              [86.819930986145792, 20.731206900248516],
              [86.823120456365544, 20.732421381340259],
              [86.825349629174369, 20.740576030025647],
              [86.826774377180087, 20.744972959167697],
              [86.828959599936553, 20.751842911811408],
              [86.830783019261972, 20.754956936655208],
              [86.833480678683657, 20.757021161879489],
              [86.836527561429378, 20.759736708397547],
              [86.845845391442396, 20.766954658476624],
              [86.849327622911474, 20.769051917034311],
              [86.857212662160777, 20.772654943203026],
              [86.863266405535512, 20.773947144751041],
              [86.871169598272246, 20.774099843262388],
              [86.881284240046966, 20.773049170138325],
              [86.885541644019071, 20.771732281159927],
              [86.890816767924406, 20.766507335263327],
              [86.895368056611673, 20.763750565317977],
              [86.904749238874302, 20.761812260510993],
              [86.921807343311201, 20.766010821106509],
              [86.931475477581571, 20.766724700716136],
              [86.937956545821109, 20.765420494424408],
              [86.941265724989989, 20.765593198280598],
              [86.951241736400405, 20.76289028670249],
              [86.955896191238153, 20.76449536813502],
              [86.971735829121016, 20.768698725540311],
              [86.979296979348646, 20.771206333011584],
              [86.985167236788072, 20.772204072494564],
              [86.993657666663822, 20.769105973035444],
              [86.999346450413142, 20.762961308030008],
              [87.000286203081799, 20.75622960401634],
              [87.000502131768528, 20.745943034702048],
              [87.005557565256112, 20.73893121657213],
              [87.009740718132761, 20.727429509951996],
              [87.01007884014561, 20.719942665054432],
              [87.008124690415229, 20.714376705693169],
              [87.000196703953804, 20.710438092011618],
              [86.985060351357689, 20.710665684384896],
              [86.98131629275646, 20.712421612185661],
              [86.976232078172814, 20.712812742941445],
              [86.971920644581516, 20.712617783623415],
              [86.968106067830433, 20.713020531682258],
              [86.963406865892836, 20.714290016168917],
              [86.952700496781347, 20.716061927472783],
              [86.948869719673027, 20.716165610792775],
              [86.944042219540961, 20.717281116466015],
              [86.934123308309793, 20.716371688514371],
              [86.928507656898887, 20.714118972673656],
              [86.924913502233949, 20.714534065302818],
              [86.914646245195826, 20.714903710302043],
              [86.90774614943723, 20.712822390619991],
              [86.903666645096905, 20.710960149246553],
              [86.909585794616234, 20.70637163613214],
              [86.925287553504134, 20.703412380870049],
              [86.929126406927253, 20.703009922603293],
              [86.940308065424048, 20.705678336163],
              [86.950770728497886, 20.705780162925844],
              [86.968956833443784, 20.705970194483236],
              [86.97338497691544, 20.703286488543394],
              [86.972197470116541, 20.699270772221887],
              [86.965402205257476, 20.695946224977909],
              [86.962302425820369, 20.691786823498546],
              [86.965840345847056, 20.688454146559092],
              [86.973343145059118, 20.694092732148061],
              [86.977059711651123, 20.696498916969375],
              [86.981656841614623, 20.696566859109737],
              [86.985299519881423, 20.697067943465132],
              [86.995241987846086, 20.698433306286823],
              [87.001457610094761, 20.697713810623711],
              [87.007053807857034, 20.694516094357997],
              [87.012074690591987, 20.693828062460558],
              [87.022890608308316, 20.698300660005426],
              [87.033211217271386, 20.70452055981017],
              [87.042520269888257, 20.710095139081304],
              [87.054374844965253, 20.71525423996971],
              [87.056163809359447, 20.710735877025776],
              [87.039272869607288, 20.70180638562049],
              [87.030825516668713, 20.695916255172804],
              [87.028111611875701, 20.692637894491597],
              [87.024826775928673, 20.690097671138641],
              [87.019141286949989, 20.686080268444382],
              [87.015136102463771, 20.683297122351672],
              [86.986587470027615, 20.666248748953024],
              [86.975088862398025, 20.657941621253293],
              [86.953730961199838, 20.645114056629531],
              [86.946479224533419, 20.639556277067072],
              [86.943035823733425, 20.638125182542527],
              [86.938942923995924, 20.635987297782879],
              [86.932133165697635, 20.631833808484263],
              [86.918818004755352, 20.620892133094799],
              [86.91413888750472, 20.618274826258173],
              [86.909075734639288, 20.613398153696565],
              [86.905672301863078, 20.610837671271248],
              [86.901757866651039, 20.606943430426249],
              [86.891845558991264, 20.60081253648028],
              [86.886707098226267, 20.596834906410074],
              [86.881568890707527, 20.592789250304328],
              [86.87927681569532, 20.590523250282779],
              [86.873807616731611, 20.586698660380289],
              [86.855622225322193, 20.573921978426597],
              [86.822770501801415, 20.556391627067974],
              [86.809930305722631, 20.545419329134507],
              [86.800312458307985, 20.538671981107708],
              [86.796604767553617, 20.535823492946655],
              [86.793179176247222, 20.532802557109317],
              [86.788713487628996, 20.529918387834059],
              [86.784402432418091, 20.525763965573745],
              [86.778053938174963, 20.518525432766495],
              [86.769696493070171, 20.505305646512472],
              [86.762840802672983, 20.507217234630723],
              [86.762088625497668, 20.511158587463409],
              [86.761039529207423, 20.514515928226093],
              [86.758317749282526, 20.517601023518651],
              [86.754558948384357, 20.517099527095002],
              [86.755831376942098, 20.505662272670119],
              [86.756795956390008, 20.502056957952231],
              [86.760036499363792, 20.495269239640507],
              [86.756557956565175, 20.487789151905979],
              [86.751517093632643, 20.473547791035177],
              [86.748798172028927, 20.471851546563414],
              [86.745727725254469, 20.472882953840855],
              [86.742135279411485, 20.47515571837981],
              [86.739725659476377, 20.477674969052629],
              [86.735368200019295, 20.481706191189531],
              [86.727471265511056, 20.481845755977954],
              [86.726164504663004, 20.476751875001305],
              [86.730613165677653, 20.473084937660047],
              [86.735840081211919, 20.467430005730535],
              [86.73860227762917, 20.460295860008429],
              [86.736234105205739, 20.451111640916711],
              [86.732802665362357, 20.440638582332305],
              [86.732494845711713, 20.434536920514702],
              [86.733636991659068, 20.42386393347147],
              [86.733270898427619, 20.412774218495375],
              [86.729636615051049, 20.40116136730401],
              [86.724846838482179, 20.39709468040375],
              [86.721466721023461, 20.396782945515216],
              [86.71799527140017, 20.39898104261594],
              [86.713989324909534, 20.400282816681678],
              [86.71205870571049, 20.395376834860624],
              [86.714572892317562, 20.393013597186336],
              [86.719251504862441, 20.390533656448738],
              [86.721996013199757, 20.387930721111619],
              [86.723821287057675, 20.381090325176803],
              [86.727117258958884, 20.377335977998246],
              [86.730120794964506, 20.379826076624141],
              [86.732411739301654, 20.382714751780576],
              [86.732814751419184, 20.38683623440274],
              [86.734078825530617, 20.389655089724187],
              [86.735401859500996, 20.394125789890058],
              [86.738678615245178, 20.396258658219889],
              [86.745929832101893, 20.391641161533503],
              [86.747189469921508, 20.38620644480914],
              [86.745030132598274, 20.38011679278215],
              [86.751286416663291, 20.379491267928518],
              [86.756049125442573, 20.382251500379645],
              [86.764690168953251, 20.388058515376468],
              [86.77370744569707, 20.390398405275437],
              [86.780863994842036, 20.384886354819049],
              [86.781022164494303, 20.380810251497557],
              [86.778287062591659, 20.376860099326233],
              [86.77382119892971, 20.373884094340053],
              [86.772677097276741, 20.370554614443321],
              [86.780674497846405, 20.371559246749161],
              [86.782810200456098, 20.368958577080218],
              [86.782505112984992, 20.36536311376673],
              [86.779788225764563, 20.358929654225758],
              [86.7797053149569, 20.354863670664233],
              [86.781576118708728, 20.347079395401494],
              [86.777828461853431, 20.343841434670711],
              [86.782864009065577, 20.337740671643044],
              [86.783687780588991, 20.332040388971688],
              [86.785691708068086, 20.328779305221818],
              [86.783865551553234, 20.325939948467916],
              [86.770015918260967, 20.316156617145342],
              [86.763690310284431, 20.312044036440149],
              [86.757026687978112, 20.307944287235824],
              [86.752276664265892, 20.305601386674695],
              [86.749051406989082, 20.303489279706053],
              [86.738668135721809, 20.297598210376552],
              [86.714415092815358, 20.285299859562514],
              [86.708530826294549, 20.282613177016202],
              [86.704810295588345, 20.27983164874372],
              [86.699915346626284, 20.277469929461116],
              [86.692683572777511, 20.27415241479957],
              [86.688588773973422, 20.273111680871512],
              [86.678690052805223, 20.270314213500519],
              [86.67300562928267, 20.268071842274644],
              [86.672265857611563, 20.265053647144825],
              [86.675042495040287, 20.26188856278905],
              [86.673692108936336, 20.258346792946085],
              [86.666460680691387, 20.254503789409782],
              [86.655956449307425, 20.249879532849665],
              [86.645786802000657, 20.245743187775947],
              [86.639533883137332, 20.241966245023931],
              [86.633214554562798, 20.238790177150417],
              [86.624903787852276, 20.235722734127812],
              [86.621594555922783, 20.233818854743738],
              [86.618707034969532, 20.232058229171169],
              [86.608213594146065, 20.227221229602378],
              [86.597030403990985, 20.219746505695102],
              [86.586353340501702, 20.214548115312269],
              [86.582544359130537, 20.210411019598464],
              [86.575142593340928, 20.205991996441682],
              [86.567783372103179, 20.199960545080074],
              [86.558545253240439, 20.194308135516653],
              [86.554934264128391, 20.192139652800538],
              [86.542685665723894, 20.183671731843429],
              [86.539368110949553, 20.18059375043881],
              [86.536636230502808, 20.177973879910386],
              [86.532674626843189, 20.174140459981416],
              [86.529623921737723, 20.17001716839987],
              [86.527115969868973, 20.167524878943983],
              [86.523316502440892, 20.160994927833432],
              [86.518085804498085, 20.154111657073425],
              [86.512724847107663, 20.144521296822688],
              [86.510631690614872, 20.141528812765625],
              [86.508701804570705, 20.138896966491561],
              [86.503674590980395, 20.129130832468995],
              [86.498058026110101, 20.121711583402789],
              [86.490075001336734, 20.1071944557678],
              [86.486452394987168, 20.10327756089017],
              [86.479830377515171, 20.091669125733084],
              [86.473950021292893, 20.086305831624941],
              [86.470819942222406, 20.083471741897558],
              [86.466631616758733, 20.080934860069746],
              [86.462727439777638, 20.077650192216126],
              [86.460254611531141, 20.075316997508256],
              [86.45669959565025, 20.071258444805359],
              [86.451449908622351, 20.064834083116121],
              [86.446981957263617, 20.055938901677568],
              [86.442974011616101, 20.052497150594931],
              [86.438400219596716, 20.051998868168678],
              [86.438603716672276, 20.055693164004264],
              [86.433191750064111, 20.055965722441595],
              [86.429025691719062, 20.052806495998873],
              [86.427308843177443, 20.049981375548612],
              [86.425646835888955, 20.045291240891917],
              [86.41714853546236, 20.03143537675588],
              [86.415246647143761, 20.028296121160167],
              [86.410625903030976, 20.017174832395746],
              [86.408781190584918, 20.010169320399015],
              [86.407220395913242, 20.006003826236402],
              [86.403669568228096, 20.001966129175198],
              [86.400924279632392, 19.999482787904931],
              [86.391659280263795, 20.000996403021539],
              [86.388914701053849, 20.003617571789082],
              [86.383441105556329, 20.002029210026446],
              [86.379668988392382, 19.995379045350862],
              [86.379119769545326, 19.985927230191656],
              [86.378557743929775, 19.982295443644336],
              [86.374048355115974, 19.977975011595479],
              [86.37054704757756, 19.976799603457057],
              [86.370716822684557, 19.958636218724884],
              [86.376565057582724, 19.956369162950047],
              [86.376345701316694, 19.953319361081363],
              [86.366621238807269, 19.947699170403126],
              [86.350722647117237, 19.945646080582105],
              [86.347100972288942, 19.944623128581618],
              [86.343429093058063, 19.943028017621572],
              [86.338611251317118, 19.942445468624761],
              [86.332773990966118, 19.941836102453149],
              [86.323425987806104, 19.9400147256639],
              [86.298759446985798, 19.934455451946562],
              [86.290389321639807, 19.931188974758651],
              [86.286646411998973, 19.930147398385529],
              [86.281247466599964, 19.928023540090972],
              [86.270275023092935, 19.923621663423692],
              [86.263610794003867, 19.919387678716948],
              [86.259733721914486, 19.914969147749463],
              [86.256335203349892, 19.911980403985581],
              [86.245860664628438, 19.908338418288483],
              [86.241610073752696, 19.909410017399487],
              [86.245449278862253, 19.917164211486053],
              [86.246309697132702, 19.922578265026303],
              [86.232493516348924, 19.933192495666987],
              [86.228126395109427, 19.932841852154926],
              [86.222733420379228, 19.925127705146867],
              [86.222059160757013, 19.915358106855642],
              [86.221137133645229, 19.908657366207642],
              [86.230563852381763, 19.902362959896134],
              [86.232484638769165, 19.898260575414671],
              [86.228714357814269, 19.894550907855994],
              [86.212977705122142, 19.888498947386271],
              [86.20175746211919, 19.885460114115606],
              [86.196630790895924, 19.883391209206071],
              [86.166751183194037, 19.878277205151392],
              [86.1506912350264, 19.873543830445026],
              [86.146355961221957, 19.872270597833214],
              [86.141774520626925, 19.870891466312777],
              [86.130812523423245, 19.866594491793844],
              [86.115911966961008, 19.862732061797381],
              [86.104967531190766, 19.860847268168904],
              [86.095302846682117, 19.85513986157763],
              [86.083290251649316, 19.852216442638909],
              [86.078831343764378, 19.852969580325105],
              [86.068478327026682, 19.852348453400825],
              [86.064295321582335, 19.850122960417657],
              [86.059625178049444, 19.846813175053597],
              [86.045488721301638, 19.841487747002855],
              [86.027682600436208, 19.838790828397769],
              [86.023858043853167, 19.838504691132535],
              [86.009480235583297, 19.837510198405987],
              [86.00232068404668, 19.837057036486708],
              [85.993563781141091, 19.835172031080916],
              [85.974558417826287, 19.833321486974882],
              [85.95408437218515, 19.829019676184604],
              [85.933314755029116, 19.824612600878659],
              [85.928017956087331, 19.823463156623866],
              [85.912191537272037, 19.820354470784892],
              [85.908743263543442, 19.819868207823909],
              [85.904635469603321, 19.81867063272119],
              [85.897831587681253, 19.816957530886569],
              [85.886329954920896, 19.810619936691079],
              [85.866227234398593, 19.804154735351705],
              [85.859612217652298, 19.80229485360589],
              [85.854082059063714, 19.800829456663273],
              [85.849631402017508, 19.799576097356521],
              [85.846115939134876, 19.798584562381517],
              [85.838815090144493, 19.795485577098365],
              [85.82071618687128, 19.79142173233225],
              [85.805246062794467, 19.78635781400008],
              [85.79715730989885, 19.78409283326312],
              [85.79131899619334, 19.782153886675847],
              [85.780491247454705, 19.778313518865097],
              [85.77052350816102, 19.775244581605541],
              [85.758352759638498, 19.770050976454943],
              [85.747214586336924, 19.766841189690286],
              [85.740968817900011, 19.766158421860929],
              [85.732590369116494, 19.763257334373705],
              [85.714264798937862, 19.756085459997923],
              [85.702710555818598, 19.753280382654228],
              [85.69638698268092, 19.751333839359635],
              [85.691540013067737, 19.748710430799409],
              [85.682167420953462, 19.743038152675389],
              [85.672198247310135, 19.73867493653297],
              [85.666562284148625, 19.735919736670525],
              [85.651740403535499, 19.726501075493069],
              [85.643848845019889, 19.72420025613869],
              [85.629588643327253, 19.714179883564501],
              [85.569814322127783, 19.688166931330759],
              [85.563474033643686, 19.68240350400535],
              [85.551364681610721, 19.677238420274072],
              [85.545039520899579, 19.6745505393407],
              [85.539916159620574, 19.672716107950375],
              [85.536606843601618, 19.671319739511191],
              [85.530949270928275, 19.668354630046998],
              [85.528184168600887, 19.666616599332173],
              [85.521183910018706, 19.664596306687407],
              [85.515586312482924, 19.661857845651035],
              [85.503455896685679, 19.656668894795452],
              [85.49857847004705, 19.654914622632372],
              [85.494415342443972, 19.65338810740834],
              [85.488808302660445, 19.651547279802848],
              [85.479538517286315, 19.647446171466228],
              [85.467637920588558, 19.640728089653464],
              [85.44485495651314, 19.632402973744153],
              [85.426284641275402, 19.622105035826685],
              [85.415851806783181, 19.617307884648639],
              [85.396233669331409, 19.607390101458378],
              [85.377949438622991, 19.596226580738399],
              [85.368385062482446, 19.591877558691444],
              [85.350935646164615, 19.583855554179831],
              [85.336785597738128, 19.575184408116613],
              [85.330120619996364, 19.570546285573506],
              [85.302961376443562, 19.55258347393217],
              [85.29195202187779, 19.545913082433284],
              [85.278439550697215, 19.536731230456684],
              [85.255126569789098, 19.521822885667603],
              [85.249368508864308, 19.517286886497494],
              [85.241147051843527, 19.512355372839941],
              [85.237436831970896, 19.509312201776055],
              [85.228634912152884, 19.503779391063357],
              [85.214163635605843, 19.494051563591913],
              [85.204879634759948, 19.486716715348194],
              [85.200226200835218, 19.483061412491377],
              [85.185863655001299, 19.471717497477147],
              [85.177987258505055, 19.463764167928506],
              [85.1731190419993, 19.460177062797406],
              [85.163004725152888, 19.453168974132598],
              [85.13415403919376, 19.431904023456926],
              [85.127086348739013, 19.427134352816378],
              [85.099676158805735, 19.403398734029793],
              [85.096599154923609, 19.39784626401244],
              [85.09526336646762, 19.387931631666262],
              [85.093550123487205, 19.383137392594108],
              [85.092322475329937, 19.379660529220956],
              [85.090081829854839, 19.37748285822877],
              [85.085086998501652, 19.374250841517796],
              [85.08089196347801, 19.373474423039955],
              [85.0762026208929, 19.371196937047767],
              [85.066507140105799, 19.365364280036466],
              [85.063314049891247, 19.362990049440253],
              [85.058981347331297, 19.361780665601039],
              [85.048427708965519, 19.35443622979108],
              [85.0385942226699, 19.349343105511451],
              [85.034172388563235, 19.34588193047394],
              [85.02719347202941, 19.341357849196569],
              [85.023758807114348, 19.338301130388949],
              [85.01986948302978, 19.336638403194133],
              [85.012145769575056, 19.33101273821995],
              [84.997082748195524, 19.320850313255221],
              [84.973305538768443, 19.307484504313148],
              [84.967145010359872, 19.304011630428043],
              [84.963702999264058, 19.301390178830395],
              [84.955403637615944, 19.295781439057738],
              [84.950270591633398, 19.292572217428408],
              [84.941928399170934, 19.28650439148835],
              [84.938258467780528, 19.284142989245115],
              [84.932559350673259, 19.278790474704035],
              [84.928188517553821, 19.275877813840111],
              [84.915045575181608, 19.265689643718257],
              [84.911208489160501, 19.261709775732736],
              [84.890894966137111, 19.244044854887512],
              [84.886477892721331, 19.238556858619138],
              [84.882029713359245, 19.234862693058595],
              [84.873375369269993, 19.226777052134082],
              [84.871179116482466, 19.223676165015611],
              [84.866479784475857, 19.219047370174447],
              [84.862177751680989, 19.215348754290748],
              [84.849525686535074, 19.202494362962362],
              [84.839253747941314, 19.191218041228908],
              [84.835458206252724, 19.185454185982614],
              [84.825135670575335, 19.174638498989285],
              [84.822884839500404, 19.17137632273397],
              [84.815972251823567, 19.16118405162095],
              [84.808758373895373, 19.153278302607209],
              [84.79963394789101, 19.138189046547641],
              [84.79491731579165, 19.126565847974263],
              [84.793910436051974, 19.121607515446055],
              [84.79039952701315, 19.11436156427343],
              [84.78844452797496, 19.111181980513916],
              [84.782465394892185, 19.098680372169589],
              [84.780215282260301, 19.096038902088754],
              [84.776336772203535, 19.08799974143583],
              [84.76859409493467, 19.080023640590728],
              [84.76859409500338, 19.080023640550746],
              [84.766261962835983, 19.075136125284068],
              [84.762154305394972, 19.069379534982186],
              [84.76161421468629, 19.068011078008684],
              [84.760395245393681, 19.066739061006878],
              [84.755457532999174, 19.054760700725616],
              [84.753576273824592, 19.053793655927617],
              [84.749527507088658, 19.054376171145375],
              [84.74346315461338, 19.058511598735599],
              [84.740380982767249, 19.058201343831371],
              [84.739112537715528, 19.057801263587265],
              [84.732859097098071, 19.055295188111941],
              [84.72797643954658, 19.051331196009375],
              [84.723100483290011, 19.038063149116009],
              [84.723195779489743, 19.034557296115409],
              [84.724533149585113, 19.031356877147161],
              [84.725029609803698, 19.030012914393978],
              [84.727987034951468, 19.028616766468346],
              [84.730817356427167, 19.02939558615142],
              [84.732535634138912, 19.03103617032286],
              [84.733739067962802, 19.037727188014756],
              [84.73401880008646, 19.039014405422261],
              [84.734922327851791, 19.03999513460781],
              [84.736033751789023, 19.042644317578045],
              [84.737320393645007, 19.045123838221404],
              [84.738420670339508, 19.047105223502996],
              [84.7407618869766, 19.049560643833722],
              [84.742701672601129, 19.049856455008889],
              [84.744794625860209, 19.049143947254265],
              [84.745623766103961, 19.046959282012644],
              [84.746106337030824, 19.044945174211239],
              [84.745712958451179, 19.042948454910736],
              [84.745305580900094, 19.040621442681598],
              [84.744915706180223, 19.038794537665872],
              [84.744537014859588, 19.037630835443871],
              [84.743406442590697, 19.034995859805459],
              [84.736450694590928, 19.028429673261847],
              [84.734469879355345, 19.025989418853165],
              [84.733818782696801, 19.025191130828297],
              [84.732876037093263, 19.022755808486629],
              [84.731703099541392, 19.021576911848719],
              [84.717554005593342, 19.01013497193712],
              [84.713691907691612, 19.004384597323327],
              [84.71089387744621, 19.001830550818525],
              [84.70772504306575, 18.996326783427861],
              [84.705989758095427, 18.991297198817332],
              [84.703470652940723, 18.988314476140989],
              [84.703143257436977, 18.987156707901462],
              [84.698369987304545, 18.979589948294635],
              [84.696209841651637, 18.976800309021442],
              [84.695646631960301, 18.975429930542322],
              [84.692129441814245, 18.969457268874137],
              [84.691400050316474, 18.968818664751542],
              [84.689573957600658, 18.966910030677607],
              [84.687274795668714, 18.965470168950485],
              [84.686409156073864, 18.962966812976774],
              [84.683541584835609, 18.960364335135154],
              [84.67283199891267, 18.951995628782022],
              [84.671599148154996, 18.949689371469454],
              [84.670069365906556, 18.948338686485851],
              [84.669175728050959, 18.947557211323979],
              [84.668605428417834, 18.94641644191023],
              [84.661629258345783, 18.940832702257616],
              [84.66084576598098, 18.939640663298452],
              [84.654966934959305, 18.933650213400945],
              [84.652951245956956, 18.932348266403459],
              [84.651700331052837, 18.931540976496311],
              [84.637481728618923, 18.920388134903316],
              [84.632682216877811, 18.916332039602587],
              [84.631013619783175, 18.914012670783428],
              [84.624728575790186, 18.907964236878236],
              [84.623015806979652, 18.906332965276142],
              [84.622420632920466, 18.906110561108811],
              [84.620045459223832, 18.902417409298629],
              [84.619132833298409, 18.901497178622957],
              [84.618303527745809, 18.901014971754758],
              [84.616145395898741, 18.898177439889942],
              [84.613351759344994, 18.893163951435763],
              [84.612131236163634, 18.892028805662587],
              [84.611484104949398, 18.891115332953365],
              [84.609014624655913, 18.888246515130465],
              [84.6076476267977, 18.886394441122558],
              [84.605709673656804, 18.883448522521409],
              [84.597843739858092, 18.874690335895668],
              [84.591768793706649, 18.87135556669887],
              [84.586294041511053, 18.872124907648722],
              [84.57988943590874, 18.874064616973158],
              [84.573700092910087, 18.87529575730008],
              [84.571883730296349, 18.875499453852512],
              [84.569320433202506, 18.875727571666886],
              [84.558064818541368, 18.87452377270915],
              [84.55750125446724, 18.874049279156207],
              [84.557710491597447, 18.871115026303475],
              [84.557610515059082, 18.870423684327097],
              [84.558813500379188, 18.869790143280639],
              [84.571174881646527, 18.86946230153891],
              [84.572073048124082, 18.869280311987854],
              [84.580253322627414, 18.867665717942586],
              [84.581212567768148, 18.867025917275882],
              [84.582153338395244, 18.862296886934711],
              [84.58306106324909, 18.857107183831229],
              [84.579798267452134, 18.84300818187241],
              [84.573025678267413, 18.838137123122451],
              [84.571315959640117, 18.836459492074148],
              [84.569325680682084, 18.828940691669047],
              [84.565684454786719, 18.823420654279381],
              [84.560723145301722, 18.807435304982878],
              [84.55660834720868, 18.801672157273039],
              [84.555078748460403, 18.786263418334055],
              [84.553603353888036, 18.7833058518579],
              [84.550387848179412, 18.78043795841911],
              [84.543517576764543, 18.775654940063966],
              [84.534362055531119, 18.770003306353477],
              [84.53107173276095, 18.767983044804279],
              [84.527196120207066, 18.764683167420156],
              [84.526432578052891, 18.764432336036375],
              [84.526210781611951, 18.763783318693836],
              [84.516636792724228, 18.756029170759334],
              [84.515596763681799, 18.754646047911638],
              [84.50983900681922, 18.749064918201267],
              [84.508558922950613, 18.74836271735991],
              [84.507544056047777, 18.747416233188581],
              [84.507291545492876, 18.747179590849985],
              [84.505900613951212, 18.745440984792111],
              [84.500672338129505, 18.740700720209432],
              [84.493335398292857, 18.733926270804623],
              [84.492346177551269, 18.731625544255127],
              [84.489299611745935, 18.728898284109707],
              [84.488912490981875, 18.728152223288266],
              [84.482229345551559, 18.721372098335053],
              [84.477936343334932, 18.714498942234059],
              [84.474263741030143, 18.710168993834046],
              [84.473570903019549, 18.709943118526269],
              [84.473351436729445, 18.709271096644901],
              [84.46854807246433, 18.704059421543853],
              [84.466946766492413, 18.701303102895292],
              [84.46625534505057, 18.700364780178024],
              [84.455392329736412, 18.689355043151433],
              [84.454060381656802, 18.688007463007249],
              [84.448284213520481, 18.677025321559661],
              [84.445549124737113, 18.673570714947424],
              [84.442931696978292, 18.673267563187096],
              [84.439117780321283, 18.674284948755016],
              [84.437792934862557, 18.678084288487987],
              [84.437073240673158, 18.678753460350634],
              [84.434937436975702, 18.678462870879923],
              [84.433885530408872, 18.678203735574701],
              [84.4323731307598, 18.67724209882973],
              [84.429970574345873, 18.670856586159804],
              [84.42858701342368, 18.669692060045513],
              [84.421707094976284, 18.668485754596361],
              [84.419473951163525, 18.668659976541161],
              [84.418138412614269, 18.668685271749066],
              [84.41599704788996, 18.668341740209978],
              [84.413449396116164, 18.667625119259167],
              [84.411698288501668, 18.666894314694215],
              [84.411147974671621, 18.666141614083202],
              [84.411666081037083, 18.665369190366214],
              [84.413519701062739, 18.664572671218867],
              [84.416562522868276, 18.663247379370546],
              [84.419609984736553, 18.662049278564243],
              [84.421874535746383, 18.661754094453858],
              [84.424316836615105, 18.66143875390658],
              [84.428870530543008, 18.66221055695749],
              [84.437046437467814, 18.664279569728944],
              [84.438480708671477, 18.663861311414873],
              [84.441889784302305, 18.661246992561253],
              [84.442173373165645, 18.659899053290449],
              [84.443358883201199, 18.659702807944466],
              [84.443393778654297, 18.658578075375708],
              [84.44193216014969, 18.656032738331255],
              [84.441367434767699, 18.654891534697274],
              [84.437557190163034, 18.651177064823372],
              [84.436864983523662, 18.650169869895681],
              [84.424962929997605, 18.641768313015856],
              [84.422585310634702, 18.640713005654021],
              [84.419407261200774, 18.639176384549135],
              [84.41231351713202, 18.636424698244014],
              [84.409799202896295, 18.633641675059007],
              [84.403917896699227, 18.624652892086409],
              [84.402984843035711, 18.624419160845477],
              [84.400096358224005, 18.622084865900941],
              [84.391506764485541, 18.613362246747219],
              [84.38923510989946, 18.611321758178903],
              [84.388053676864899, 18.610644622119128],
              [84.387305174691903, 18.609957042745993],
              [84.386067967207737, 18.607899801667859],
              [84.385503511469039, 18.60673553318243],
              [84.381637292607365, 18.603362643725315],
              [84.381215315670943, 18.602224745921429],
              [84.379289558733376, 18.600676362273468],
              [84.37782281237844, 18.597600817291781],
              [84.376263788577546, 18.595833166049896],
              [84.375461314254608, 18.59535057449715],
              [84.374435501650169, 18.593529605273947],
              [84.369447668853581, 18.586816177437722],
              [84.365274521191679, 18.579481732577051],
              [84.362527166405016, 18.576462194807327],
              [84.361592638089292, 18.574068556921418],
              [84.358617848432914, 18.565481970765656],
              [84.357247181117941, 18.563858012986579],
              [84.354001876902714, 18.562179059135666],
              [84.350217310482662, 18.563080009228091],
              [84.348460644557235, 18.565235485391728],
              [84.348154757011173, 18.570304033608579],
              [84.34911386293868, 18.571917431600866],
              [84.350349370860386, 18.573929005943501],
              [84.351079059747292, 18.575213437473163],
              [84.351024260554027, 18.578405106977531],
              [84.348154327858651, 18.583078693000388],
              [84.344073909369172, 18.579606292432654],
              [84.340331486643663, 18.574672980198923],
              [84.339141792586588, 18.574179140319789],
              [84.334408651816091, 18.573812434665403],
              [84.33360445291288, 18.573352602235616],
              [84.333160915791382, 18.572190881509623],
              [84.333134285801066, 18.569272363205968],
              [84.334423277522603, 18.565932798047196],
              [84.334445073359575, 18.558466029233788],
              [84.33303903434421, 18.557277106623641],
              [84.330185809205545, 18.55765359765876],
              [84.323705032765986, 18.559947427001216],
              [84.323675210118495, 18.560865425415802],
              [84.322468229094568, 18.561726240148534],
              [84.321521641404388, 18.561928065837645],
              [84.314918163098355, 18.56061066824827],
              [84.313889226911783, 18.559662237386412],
              [84.313383592203479, 18.557395839990427],
              [84.310038668578102, 18.554357284027805],
              [84.309819879949998, 18.553662243989891],
              [84.309984245947419, 18.552310922992891],
              [84.311544251494581, 18.551000850562634],
              [84.312203596282757, 18.549204820158756],
              [84.311411053618031, 18.544656055813682],
              [84.310743557130763, 18.543739818970668],
              [84.308660318402247, 18.541886924771884],
              [84.297465557636372, 18.535839698382176],
              [84.289328667462655, 18.531375157347338],
              [84.284509067389649, 18.526248810367907],
              [84.283474869981433, 18.525528528158407],
              [84.279216182328412, 18.522825831114101],
              [84.276541455152483, 18.520361243147509],
              [84.274308891141686, 18.518728143142383],
              [84.272913692439317, 18.514569431072612],
              [84.274174196203603, 18.511621041217097],
              [84.276349851081932, 18.51032716781101],
              [84.279896946136205, 18.512353929279826],
              [84.284820847121807, 18.517290613868258],
              [84.28839923958202, 18.520995682463735],
              [84.290638969293241, 18.5234599278199],
              [84.292886129978342, 18.525932062306893],
              [84.296434003813772, 18.52796535409372],
              [84.297717968757524, 18.528943146725872],
              [84.298894762506052, 18.52984002450501],
              [84.303771595319688, 18.53223322180277],
              [84.321064762420519, 18.536595814658053],
              [84.325255434335077, 18.538072444004719],
              [84.335799076355329, 18.545592478984691],
              [84.336472370850345, 18.546416765177266],
              [84.338855249255118, 18.547910153209479],
              [84.340091231148506, 18.548451408305692],
              [84.344401999886202, 18.551401684677167],
              [84.347772912347011, 18.555198298272398],
              [84.349074902972006, 18.548366159886864],
              [84.343119127102568, 18.54265749818228],
              [84.342418938568585, 18.541947214454275],
              [84.334898965770833, 18.536974144685633],
              [84.327121431797934, 18.530981796019006],
              [84.324467187919197, 18.52892828102236],
              [84.323221096019097, 18.527927185057333],
              [84.319247294853483, 18.524227965960414],
              [84.307397320571283, 18.514692970918865],
              [84.298385444294638, 18.507513327837572],
              [84.287111389780819, 18.49858844761388],
              [84.282566591046873, 18.494989022322734],
              [84.281317789173556, 18.493366116437699],
              [84.274236103876717, 18.48686300496669],
              [84.270548974456801, 18.484043638745295],
              [84.26494178193002, 18.478823668360281],
              [84.260557310297145, 18.475248756900726],
              [84.256006022923657, 18.470886178922122],
              [84.255208929047228, 18.469507354728414],
              [84.25384085462639, 18.467904458330011],
              [84.252212250872503, 18.466960315611566],
              [84.251715794264726, 18.464441627668961],
              [84.251249184031451, 18.463991196569726],
              [84.250317608186037, 18.463044436700315],
              [84.241730555398931, 18.457022889234693],
              [84.238993237671423, 18.454576051545573],
              [84.233602405702868, 18.452394099608803],
              [84.227494147331072, 18.446353813405189],
              [84.22291975757787, 18.442794620381605],
              [84.221531715140941, 18.441833947539173],
              [84.215210915982937, 18.434936457180427],
              [84.213733826270015, 18.433813086487241],
              [84.212049042074625, 18.431602330969895],
              [84.21065918634315, 18.43066568267912],
              [84.209157367834848, 18.429494485242639],
              [84.208715756800871, 18.428355574749805],
              [84.207888440029876, 18.427871446112686],
              [84.206022691966837, 18.42531132707488],
              [84.200465946717827, 18.419492445486533],
              [84.199171151716087, 18.417891531485708],
              [84.192532191932401, 18.412706584024669],
              [84.19129353307585, 18.410854820626557],
              [84.190854386556168, 18.410381210691952],
              [84.185463743320042, 18.404567169844487],
              [84.181970601960018, 18.401751166171017],
              [84.174782960025937, 18.395078514045469],
              [84.171542018950618, 18.391189969354905],
              [84.161586256491944, 18.381699088867723],
              [84.158301654413606, 18.377739897458174],
              [84.157295756969688, 18.376124188970774],
              [84.149221518970421, 18.368665557114838],
              [84.147857768194967, 18.36703896999585],
              [84.143449102027205, 18.360011724005673],
              [84.142824957412302, 18.35852112475175],
              [84.14194490799423, 18.356794617274655],
              [84.141612528787618, 18.355979674957634],
              [84.137975076575117, 18.351802905210743],
              [84.136594906144353, 18.350635105859983],
              [84.134957778168427, 18.349919301644768],
              [84.129799320758536, 18.348843901646568],
              [84.116712446355223, 18.350263586050158],
              [84.104199942958985, 18.348963564937772],
              [84.096325812986549, 18.347116272404953],
              [84.092477887322787, 18.345665536191259],
              [84.085340339057609, 18.340501879255495],
              [84.078535476631885, 18.337564297175511],
              [84.070198443450579, 18.335839120052775],
              [84.067579958637793, 18.335758898844055],
              [84.061081941070029, 18.335881923352119],
              [84.0462606295618, 18.34020755106021],
              [84.039477489705234, 18.344504505650605],
              [84.028071674308194, 18.347393827406179],
              [84.026592854560818, 18.347739752698846],
              [84.01968105748125, 18.34865198174295],
              [84.01438887386422, 18.350765100075506],
              [84.010216097177363, 18.353233107850183],
              [84.001779174343028, 18.357062500138973],
              [83.996314245568101, 18.359551097295423],
              [83.992673526936301, 18.358256594774016],
              [83.990839171329696, 18.352280536821564],
              [83.992998163937159, 18.34969469536912],
              [83.999687444728636, 18.347368519153584],
              [84.010500468247869, 18.344944635732343],
              [84.012002998076468, 18.344577913232531],
              [84.012515346985367, 18.343673224027448],
              [84.013220610863016, 18.343465259609587],
              [84.019945389868155, 18.341627243817534],
              [84.020985247334806, 18.341475425072623],
              [84.024952474440568, 18.340862689574486],
              [84.026440792806341, 18.340195637369394],
              [84.028786446482229, 18.339854996427619],
              [84.040775455081132, 18.334615324425595],
              [84.041979119437769, 18.333870657639796],
              [84.042216777173564, 18.333234514348472],
              [84.050232673544031, 18.32810294405887],
              [84.058606000340774, 18.325187821157215],
              [84.064405204382922, 18.325089585302624],
              [84.072781754510743, 18.326311196723324],
              [84.079282881465588, 18.329682043599391],
              [84.082576968399621, 18.330448427962327],
              [84.086481689204277, 18.333738673797257],
              [84.091139009362109, 18.336156013623658],
              [84.095215629301151, 18.337199947730344],
              [84.108783728059791, 18.340048274403998],
              [84.111841967297096, 18.340600707165258],
              [84.119448522167318, 18.339039021309922],
              [84.121145688350225, 18.337941513453789],
              [84.121423418654047, 18.336824277886809],
              [84.121701126269159, 18.335705897539846],
              [84.122886645276765, 18.335512284330292],
              [84.123147585653953, 18.334853885404367],
              [84.125572793544677, 18.3328814047333],
              [84.127267794025443, 18.331806796114687],
              [84.127397793081059, 18.328639495077446],
              [84.126765474458352, 18.320991349781689],
              [84.126120539391934, 18.312996103782378],
              [84.123858674831922, 18.306585690165537],
              [84.118371629043168, 18.300995500548744],
              [84.11191339298324, 18.29712149785783],
              [84.101867474336984, 18.291898648694556],
              [84.101193880111225, 18.291188304080158],
              [84.09347046061248, 18.288471105732377],
              [84.075217958030919, 18.278628232377041],
              [84.074341638726139, 18.277520550198219],
              [84.071044512410538, 18.274753688429364],
              [84.058499900951745, 18.263958660866127],
              [84.053895368313931, 18.261495168779373],
              [84.039879668319202, 18.256535773695415],
              [84.030107859416148, 18.251913362735817],
              [84.006251033187141, 18.243728494579944],
              [83.992060243795038, 18.236255600482494],
              [83.976876917384175, 18.230358283965451],
              [83.976148006015364, 18.229899227869502],
              [83.973820376822516, 18.228401275349842],
              [83.964840897627312, 18.222535403467507],
              [83.959592830765132, 18.217176579253113],
              [83.954284821273973, 18.213608845674699],
              [83.94898919333906, 18.214522584645742],
              [83.942817685065791, 18.216420842621766],
              [83.939217927007007, 18.218330891296919],
              [83.93869024660205, 18.219670922713249],
              [83.93866623803109, 18.220336065920101],
              [83.937697827753254, 18.221225682327265],
              [83.935513985803311, 18.222512958525417],
              [83.932112911527042, 18.224911987096807],
              [83.929736649958556, 18.225503630470222],
              [83.927039408793235, 18.224958899499306],
              [83.925789302890848, 18.224277160087183],
              [83.925452054685877, 18.219484482051019],
              [83.927227423888951, 18.216138309603643],
              [83.933274746060874, 18.212260485257033],
              [83.933601477525372, 18.209788351781363],
              [83.932697585721087, 18.208150774682519],
              [83.927165827215106, 18.206137053991831],
              [83.897605395050959, 18.197113521694206],
              [83.886461960714087, 18.191336417649318],
              [83.881141699841692, 18.187536011422871],
              [83.880242934052262, 18.186380660426735],
              [83.878921634262156, 18.182960108061085],
              [83.876157238454766, 18.17958430101476],
              [83.874461802502083, 18.175806322078454],
              [83.869443551124107, 18.170888842617174],
              [83.855657717526753, 18.165231444383149],
              [83.839279394602727, 18.160870529680363],
              [83.835301771937338, 18.159156218316408],
              [83.820405636166583, 18.154357614381759],
              [83.809069674096406, 18.150154571698142],
              [83.805428904157907, 18.148474325052799],
              [83.78809323636699, 18.142697307854529],
              [83.777382423637675, 18.139202941440313],
              [83.776669392624569, 18.138949085851326],
              [83.776454015245179, 18.138252570313441],
              [83.771130657644733, 18.135276092245881],
              [83.759265651152987, 18.129787565314341],
              [83.751629842724185, 18.124988283623612],
              [83.740444287987543, 18.120003704302967],
              [83.738640157359157, 18.118036615561056],
              [83.728339686100639, 18.114506517427685],
              [83.71538625471112, 18.107967379687928],
              [83.703048761267723, 18.101701987889122],
              [83.692069157044898, 18.091822782958396],
              [83.67980601700674, 18.08420139171001],
              [83.678407309054933, 18.083695916285389],
              [83.674648502989953, 18.082652312134439],
              [83.669957571017164, 18.083354180622045],
              [83.664171123747565, 18.084813161127681],
              [83.660761620642631, 18.084103316741928],
              [83.657344459560363, 18.081598895544918],
              [83.660874725206952, 18.079669442056375],
              [83.66628739486481, 18.077456204352881],
              [83.668124343582065, 18.075816177012964],
              [83.669017904944212, 18.075017638654575],
              [83.669068219108965, 18.073662551825599],
              [83.667932300971813, 18.072498526192771],
              [83.661692312840614, 18.068429892490329],
              [83.647686615517273, 18.061230325807934],
              [83.634344600663098, 18.053707042241083],
              [83.630166250028026, 18.051752588688689],
              [83.627536803039163, 18.050078852145923],
              [83.618813662816024, 18.044340075122957],
              [83.616278270032694, 18.042094475686731],
              [83.609882165860483, 18.037742567160155],
              [83.604540714387895, 18.033402993907067],
              [83.603184525765187, 18.031771151292265],
              [83.602450833770035, 18.031516732889354],
              [83.602234405439674, 18.030843027420438],
              [83.600867164841929, 18.029486297921746],
              [83.594240648185121, 18.02358598181922],
              [83.592622241725223, 18.021232735186519],
              [83.590517070353826, 18.018426402819831],
              [83.587312733700173, 18.014824094152328],
              [83.582687225926918, 18.011956598783279],
              [83.581519962881941, 18.011687266308403],
              [83.577947835997691, 18.012234333122649],
              [83.576747950535093, 18.012861348585183],
              [83.576233938054884, 18.013764034725742],
              [83.575462310666182, 18.015784370884031],
              [83.574055404859223, 18.015507228406534],
              [83.573068882204893, 18.01492193744933],
              [83.571591918683282, 18.01397635585796],
              [83.570583315613078, 18.013344306693831],
              [83.566765392768389, 18.014596117304581],
              [83.566354877830577, 18.015341836581108],
              [83.559690059226227, 18.020222792241757],
              [83.557542134490177, 18.01987427312665],
              [83.556046578380972, 18.019388205843732],
              [83.55537326831319, 18.017502397487473],
              [83.556631149851, 18.014003488802196],
              [83.55738439430462, 18.012441784355008],
              [83.563656780741212, 18.009065035978477],
              [83.563754475275061, 18.008401715673617],
              [83.564752826228073, 18.007331230221943],
              [83.565427440914334, 18.006641154449376],
              [83.566050235474108, 18.00210972872031],
              [83.563214413937715, 17.991160854416577],
              [83.562536214083593, 17.981618017907536],
              [83.560984825364756, 17.972965673699502],
              [83.558915923017935, 17.971102841001589],
              [83.554262942576088, 17.962553283226452],
              [83.536586804415435, 17.948620212984007],
              [83.524095725112261, 17.94049536648189],
              [83.519512623483195, 17.937857274645189],
              [83.51633984879777, 17.934805838328955],
              [83.500759272443702, 17.92588386207618],
              [83.497349359314057, 17.923400452963744],
              [83.490600833674421, 17.919436289763727],
              [83.483469666391045, 17.915247724774666],
              [83.482222775167372, 17.914607278639938],
              [83.474720013414696, 17.910534342073433],
              [83.472577190015954, 17.910690981138895],
              [83.460137137797915, 17.91477419985781],
              [83.458698368033822, 17.915413979368072],
              [83.457522735288535, 17.916040829095579],
              [83.456297054900745, 17.916688786556726],
              [83.453390972835962, 17.919326118744582],
              [83.452174741200565, 17.920411585070084],
              [83.450927196162638, 17.921035659303811],
              [83.448312372623093, 17.92161361078945],
              [83.44679434166153, 17.921124459440122],
              [83.446006336302617, 17.920408160277024],
              [83.445560920177286, 17.919496026758637],
              [83.446570140790129, 17.911826444040205],
              [83.447539549706846, 17.910939368166446],
              [83.448499698738601, 17.910305559665506],
              [83.449018199953514, 17.902872318865345],
              [83.450740492786679, 17.898561646520065],
              [83.451813380366502, 17.897516595024797],
              [83.452342238970004, 17.896179053879873],
              [83.453800046848187, 17.895101552863313],
              [83.454852703972449, 17.89196370249428],
              [83.454645283701097, 17.884713117768978],
              [83.453425843807679, 17.880140622894821],
              [83.452382067004919, 17.879208134726191],
              [83.450581555606846, 17.876662144679511],
              [83.45004975479651, 17.87549434250932],
              [83.441099489577425, 17.866656222979714],
              [83.438439360712152, 17.864012025919525],
              [83.423377531054882, 17.853099711316119],
              [83.42016081614139, 17.850021909757828],
              [83.415812764477437, 17.844444037947895],
              [83.415487463909074, 17.843536508009709],
              [83.414271831074871, 17.841447386199601],
              [83.410691841663493, 17.842244647423559],
              [83.409492691483592, 17.842870118871733],
              [83.408961237050789, 17.84420855181023],
              [83.407237999991082, 17.845966183725306],
              [83.405148768329809, 17.845434027998696],
              [83.403897388153439, 17.844263833877005],
              [83.403682239495254, 17.843588906132371],
              [83.404446329225379, 17.838625131362488],
              [83.404951248792202, 17.837952499896549],
              [83.412157110285989, 17.834590284204591],
              [83.416086707315628, 17.830884740772508],
              [83.417062962215482, 17.830458393190227],
              [83.419376965195283, 17.825087966367473],
              [83.419351277967507, 17.816278646052663],
              [83.418639138198444, 17.815426444146254],
              [83.416260586118369, 17.807340937060964],
              [83.412141008924152, 17.804024499005713],
              [83.411815830465741, 17.803117024453673],
              [83.411052992070665, 17.80220802298069],
              [83.408098608756632, 17.79868789472081],
              [83.400962439964587, 17.792692359025008],
              [83.399287460514358, 17.790747414834577],
              [83.398739207165136, 17.789993245251068],
              [83.395734750086831, 17.788279674418984],
              [83.388481638081942, 17.781036321410287],
              [83.386067029356013, 17.776422711819382],
              [83.381148712196762, 17.770823594808085],
              [83.380046673889069, 17.770141012909484],
              [83.378107405539765, 17.767544406037075],
              [83.373235948619936, 17.763902029613305],
              [83.372308268145446, 17.763663300300166],
              [83.370788249562622, 17.762069448919213],
              [83.358432010320371, 17.755360354137075],
              [83.355790199038836, 17.752969296454665],
              [83.353094834126239, 17.748803493054865],
              [83.349257471703936, 17.738228891268303],
              [83.348494546319159, 17.734360315986159],
              [83.347921189372926, 17.733673836655843],
              [83.347118153975259, 17.73272605137555],
              [83.346378797642103, 17.72138458586468],
              [83.343684055842459, 17.717909415333057],
              [83.340279259863792, 17.71415553349107],
              [83.333491375600772, 17.709272228184616],
              [83.332699168659815, 17.70867016143027],
              [83.329926954584096, 17.707215661114155],
              [83.318568561971176, 17.703345281574883],
              [83.314580871304599, 17.701710158314945],
              [83.30443335251897, 17.695695571578202],
              [83.300791184833486, 17.691933882250012],
              [83.299602583809701, 17.689844156071906],
              [83.298822856311801, 17.685791446579273],
              [83.298041877972935, 17.684338270340209],
              [83.294541755387229, 17.670667522408372],
              [83.293149659802964, 17.667007365897494],
              [83.292428627652725, 17.665809043438816],
              [83.289920999112155, 17.661902190019511],
              [83.283524433961929, 17.65624870875455],
              [83.27755378950252, 17.652634144406946],
              [83.273936738053408, 17.651332661167348],
              [83.269005539234342, 17.648719876347212],
              [83.261868802513504, 17.643706356631558],
              [83.260282083879872, 17.642614981570134],
              [83.259380487025624, 17.641731849088359],
              [83.255062383794723, 17.636910299724814],
              [83.253176955841923, 17.635531714891322],
              [83.25044682800791, 17.634239308467649],
              [83.244080523364801, 17.627917745903176],
              [83.241352908705153, 17.625312961982445],
              [83.235805180853617, 17.625621936958904],
              [83.232573777190566, 17.626151747330635],
              [83.227755643571072, 17.628693984098391],
              [83.223359926580656, 17.639394473645602],
              [83.222374582425573, 17.640049631646225],
              [83.220104771705905, 17.642360908859349],
              [83.219862304703383, 17.643020189042531],
              [83.218886782976654, 17.643445087611479],
              [83.218620608885033, 17.644125174807282],
              [83.216479808650149, 17.646188006315558],
              [83.215530342079035, 17.646592057739849],
              [83.214408832075549, 17.646459340884718],
              [83.207992676405013, 17.645655709012779],
              [83.199855862066784, 17.639913460609261],
              [83.198155436284708, 17.638058603605042],
              [83.197963352586612, 17.637407489284254],
              [83.196557629499182, 17.630525768717874],
              [83.197211460336632, 17.626684577564465],
              [83.200328023462816, 17.624772144548437],
              [83.201296977514744, 17.623885991114694],
              [83.201580812316763, 17.62276956200008],
              [83.213822296482135, 17.617341178232703],
              [83.215568032515193, 17.616804620668798],
              [83.225004198368538, 17.614472873122999],
              [83.227097896710006, 17.61544468978855],
              [83.231062861735268, 17.615769910965462],
              [83.23149826368018, 17.613232359661687],
              [83.232340969696793, 17.608223932818422],
              [83.230437948291069, 17.603532827476364],
              [83.229609097081891, 17.602721102719439],
              [83.226241941285195, 17.598760136545707],
              [83.225457886520132, 17.597352635981458],
              [83.220005138161298, 17.592189564099968],
              [83.219544500345592, 17.591712740241494],
              [83.21887712659003, 17.591021908282233],
              [83.217271231714847, 17.58981469852144],
              [83.216637969267367, 17.589492486903179],
              [83.207345621064633, 17.584491295826069],
              [83.20408558421741, 17.583317007000062],
              [83.19780689926273, 17.580976557575593],
              [83.188609091348837, 17.575447977139447],
              [83.182318265698939, 17.572738338468167],
              [83.173928233639401, 17.567445146998157],
              [83.173547314648658, 17.566741783584231],
              [83.172084352919683, 17.563767558943404],
              [83.168439459413207, 17.560231393608113],
              [83.155536932439247, 17.552728004446255],
              [83.146964687227239, 17.549037727691505],
              [83.139740808906652, 17.546959934118224],
              [83.131451184304979, 17.545855124362319],
              [83.123778091303791, 17.544818404838207],
              [83.111801899206739, 17.540634673999662],
              [83.10994895150094, 17.539670990422085],
              [83.105925512600095, 17.538888502670382],
              [83.106622688716413, 17.541831230680987],
              [83.108479793464255, 17.545920382295122],
              [83.110196240892037, 17.548273844871346],
              [83.110892137510234, 17.551043738235077],
              [83.107332162760201, 17.550641294770227],
              [83.103108367526261, 17.54903820920941],
              [83.09939999597492, 17.547109444696311],
              [83.096575367825949, 17.544062344829698],
              [83.092134474487523, 17.53711416329979],
              [83.091171255538484, 17.535469323103342],
              [83.087996637528249, 17.532178587677862],
              [83.087098100256128, 17.531443393356604],
              [83.085723932205099, 17.530324760899873],
              [83.07368819335511, 17.524641075394154],
              [83.066884613561513, 17.523495477763159],
              [83.060168780542597, 17.520742774284155],
              [83.058712352016357, 17.520352600549742],
              [83.044531192274576, 17.516558407644855],
              [83.039226899522362, 17.513856558457995],
              [83.035089097584432, 17.510760523682933],
              [83.03367839113929, 17.510708642568609],
              [83.031798080867361, 17.510409341548723],
              [83.026277424222656, 17.507745211294367],
              [83.016136488461484, 17.501482887452305],
              [83.014067564627055, 17.500510408050769],
              [83.007003480236904, 17.494590290849143],
              [83.005872313924328, 17.492961061621681],
              [83.005342241943879, 17.490663766703513],
              [83.005168533478809, 17.48430827118197],
              [83.004676180866454, 17.482264879864644],
              [83.002192379196345, 17.480309508100625],
              [82.999935360607424, 17.478685668279237],
              [82.995990439108425, 17.475595443749448],
              [82.993243854061916, 17.471283651580297],
              [82.991030711482324, 17.469752126699895],
              [82.979910036742524, 17.465268631638079],
              [82.968695757635032, 17.462599261384725],
              [82.951478318774832, 17.455587450593146],
              [82.949514410053325, 17.454456652499061],
              [82.945054685891591, 17.452864598478204],
              [82.942989511325834, 17.451222712417263],
              [82.937923638845405, 17.449216549128291],
              [82.931937366766135, 17.445152281601661],
              [82.919274374021768, 17.439847786337683],
              [82.91789404630174, 17.439059765983085],
              [82.914388251612365, 17.436973255137225],
              [82.910182159316776, 17.434469795602233],
              [82.908850690173438, 17.433660792730432],
              [82.865546292709098, 17.415034518299557],
              [82.856616395637673, 17.409267950772939],
              [82.855024123809017, 17.407849975266487],
              [82.848997398309166, 17.404816423145856],
              [82.840023281160938, 17.399576849756144],
              [82.825198233528226, 17.394024153391889],
              [82.822805607861255, 17.393427557477029],
              [82.819552193320249, 17.392222270603131],
              [82.810381391502574, 17.390034526308103],
              [82.809576642178001, 17.389819221526103],
              [82.807281801119643, 17.388604946930226],
              [82.788889103459098, 17.381395040118871],
              [82.771273178391084, 17.373983148832064],
              [82.76467959483233, 17.370855475741703],
              [82.753101469823719, 17.366155525320742],
              [82.736722769068933, 17.35782124104626],
              [82.734410040159901, 17.357042026860658],
              [82.724923832315767, 17.3504423386191],
              [82.723191049720356, 17.349547939150327],
              [82.719165326039501, 17.346838284801734],
              [82.718624798954238, 17.346035264090638],
              [82.717797573217922, 17.345773809260933],
              [82.714707345744728, 17.345286497759055],
              [82.707910766877376, 17.342471011444715],
              [82.705865548747056, 17.341035480999963],
              [82.698991077151902, 17.336673900900237],
              [82.697600215039643, 17.336160966186721],
              [82.686777174216445, 17.330105583668395],
              [82.680386636172443, 17.325072648396318],
              [82.670672939747135, 17.321107525952833],
              [82.662419693306731, 17.316002298004292],
              [82.661257906212825, 17.315727174390997],
              [82.656629199309691, 17.313752227560521],
              [82.648138506491023, 17.308614148292154],
              [82.643903219157039, 17.306355584738412],
              [82.63862774733974, 17.303274097214789],
              [82.637795411645357, 17.302597992767865],
              [82.62992745223994, 17.299139543779848],
              [82.623046703310706, 17.295004801014841],
              [82.620544670682023, 17.293089551014809],
              [82.606323076500757, 17.284389505537703],
              [82.604045609174761, 17.282252240847665],
              [82.59001574339112, 17.274132437664424],
              [82.58545212390635, 17.270663046695081],
              [82.579240217521487, 17.267704667435797],
              [82.573462951851184, 17.26354289839157],
              [82.571374798126612, 17.262034943631974],
              [82.560195866173103, 17.256096080034748],
              [82.551757970144138, 17.24984979839472],
              [82.549516602060123, 17.248035504668497],
              [82.548571199333139, 17.247767869718206],
              [82.54695690922324, 17.245817326439614],
              [82.538693500493139, 17.239416448907697],
              [82.524754829737219, 17.229315942610199],
              [82.523295877633188, 17.227671286249588],
              [82.519131844628191, 17.223847471199697],
              [82.517982165982971, 17.223341249400672],
              [82.517496380858461, 17.222401335986358],
              [82.516305899941244, 17.221181303756783],
              [82.512078456174493, 17.217169923227324],
              [82.50792522708457, 17.21256439714897],
              [82.486962807797966, 17.196336662767301],
              [82.462488158181827, 17.175179894226506],
              [82.445540531886593, 17.164102186376937],
              [82.441153611220614, 17.159991313230528],
              [82.437926841780154, 17.15613427862543],
              [82.432614227878446, 17.150784756469118],
              [82.429453122613438, 17.147601211720065],
              [82.425603685979468, 17.143811029305439],
              [82.425287667696807, 17.142831569053364],
              [82.424409816716434, 17.14102436683168],
              [82.422638426050469, 17.139986196122962],
              [82.419990418139378, 17.137119052682447],
              [82.41837146415304, 17.135327684024816],
              [82.410025988820053, 17.126660782737972],
              [82.399032681305812, 17.118969680124778],
              [82.395138373351642, 17.115130990652467],
              [82.389583523615556, 17.110442164170205],
              [82.387762964790056, 17.109448377663984],
              [82.386933007067967, 17.108748224597047],
              [82.384132856243298, 17.105021958744192],
              [82.381655448257163, 17.102643451351675],
              [82.379701230144178, 17.101437168295892],
              [82.377363124837984, 17.09862700718848],
              [82.371106888987754, 17.093610009192819],
              [82.367063156607685, 17.089373087579428],
              [82.366062077046365, 17.088204297911357],
              [82.36498893677657, 17.085445750998293],
              [82.36169963848846, 17.082527988114396],
              [82.360994848369558, 17.082268933733967],
              [82.360567201367985, 17.081123873006824],
              [82.360065935724435, 17.080021315993839],
              [82.356654545527647, 17.077167825034458],
              [82.355644477299961, 17.075677602886248],
              [82.354241201364914, 17.073894370597653],
              [82.349161871675051, 17.069315337819489],
              [82.3472796177536, 17.067582385404666],
              [82.336516361695828, 17.059136636013445],
              [82.331137727323608, 17.053256197694552],
              [82.327045656887719, 17.050144074445718],
              [82.323238951965777, 17.045455144677895],
              [82.31424271295424, 17.037239829506444],
              [82.305855151117896, 17.029579812551965],
              [82.302280767520585, 17.02559113219856],
              [82.301149370803671, 17.024163840846771],
              [82.296210773161533, 17.013765241670662],
              [82.292101569760348, 17.008395975738519],
              [82.290467775503487, 17.005383402018595],
              [82.288830561939278, 17.003521344794564],
              [82.283615957168706, 16.995596960524313],
              [82.283228964143177, 16.99355518811662],
              [82.281079733647744, 16.986538653913897],
              [82.280648548605768, 16.985509088704983],
              [82.279645653309558, 16.983879080858948],
              [82.278787082733459, 16.970930704162665],
              [82.272393594609298, 16.951402846338485],
              [82.270314165655634, 16.935872074019791],
              [82.269683147534352, 16.933405580730213],
              [82.269032594744374, 16.932458825614518],
              [82.266256817942235, 16.930986516912377],
              [82.259362951446235, 16.932983986344858],
              [82.253173852141174, 16.932040009174454],
              [82.252847015755833, 16.931335043423093],
              [82.251636028852033, 16.924725544395525],
              [82.250991535564822, 16.923110930775657],
              [82.251127809032198, 16.912020342796328],
              [82.25038550074413, 16.908860011047629],
              [82.249813899864591, 16.906143053891331],
              [82.248742283032016, 16.896959812913025],
              [82.249491223636994, 16.890867650820713],
              [82.251282379645772, 16.887097123417522],
              [82.254392882598722, 16.885866043921098],
              [82.26056688814748, 16.884990786409393],
              [82.262281257912775, 16.883472749314446],
              [82.264831588606228, 16.877660986676943],
              [82.266640726706555, 16.8718654631028],
              [82.267376132726895, 16.871434222330254],
              [82.269040834149621, 16.868348715228517],
              [82.269718661071011, 16.867041774117432],
              [82.272439390029945, 16.865979147776944],
              [82.273640733475645, 16.865798545927781],
              [82.277952377953682, 16.868691068773696],
              [82.27958577676759, 16.868987512714202],
              [82.281772663869901, 16.867051073345877],
              [82.282071772601682, 16.862989377562808],
              [82.282738229092558, 16.861427450369902],
              [82.28629460620391, 16.860329804641594],
              [82.299819587790694, 16.857820570335814],
              [82.303633673366278, 16.85684774704772],
              [82.309675766344355, 16.852996991667013],
              [82.311125674520497, 16.851513336898776],
              [82.311653764758319, 16.850360908731925],
              [82.315863395538656, 16.839897657694429],
              [82.318509713297885, 16.838877836182416],
              [82.3194732856428, 16.838685952010387],
              [82.320848611783049, 16.839410064681203],
              [82.322477669533839, 16.841984574524396],
              [82.322314573264521, 16.847295501358168],
              [82.322763905613101, 16.849017456411705],
              [82.325267191436183, 16.850684559370325],
              [82.326901666827098, 16.850981605055658],
              [82.335328721593271, 16.849297890565119],
              [82.33620420288878, 16.849471949452425],
              [82.337315911857559, 16.849148124083769],
              [82.340552238540795, 16.850453134822015],
              [82.343821141914759, 16.851001134537668],
              [82.352106624180351, 16.849288203345967],
              [82.353338034908575, 16.848440338210168],
              [82.357138880908508, 16.841780600452765],
              [82.357132361090009, 16.839754726713828],
              [82.354412258607226, 16.831058799147534],
              [82.354954036001345, 16.828502315035799],
              [82.357927587949348, 16.821671057312756],
              [82.35823112307844, 16.820187541621156],
              [82.358426871842482, 16.815200314046596],
              [82.362983133218847, 16.818491851933096],
              [82.364861735952672, 16.826256611532891],
              [82.364942274921759, 16.831484498417876],
              [82.365222726220566, 16.847908105498391],
              [82.365580276039452, 16.850615686481429],
              [82.365829763485976, 16.854193609636521],
              [82.36542172923464, 16.86184228738459],
              [82.366857306743043, 16.866665847310625],
              [82.367046069528726, 16.873232754213529],
              [82.366868656642055, 16.891939961016181],
              [82.366784815735002, 16.903099848003322],
              [82.366024181306159, 16.928020975954237],
              [82.364738916564249, 16.933379126262803],
              [82.362487069168765, 16.938972993769223],
              [82.361572910619884, 16.939672792598078],
              [82.358754418618162, 16.944047937981857],
              [82.356065988960609, 16.945987046834887],
              [82.355511007154803, 16.950476731971762],
              [82.354276902727804, 16.955191090464378],
              [82.350865124716961, 16.957815735325983],
              [82.349864500465571, 16.957774675174804],
              [82.342375196343824, 16.963549027823849],
              [82.341901323663706, 16.963990744459668],
              [82.340008852646292, 16.965754756085154],
              [82.335476046772385, 16.973236175751577],
              [82.333760917390009, 16.977471365129773],
              [82.333343055974012, 16.981528651265066],
              [82.334594426826811, 16.982937001931578],
              [82.336817014556459, 16.983464825781986],
              [82.343530694980188, 16.980145364714723],
              [82.34760617585647, 16.976535714138219],
              [82.349993858918253, 16.973824300991208],
              [82.35116514275154, 16.972720227006864],
              [82.354996222043212, 16.964887812799855],
              [82.355664999836733, 16.964339566855944],
              [82.357294563749349, 16.960423489301942],
              [82.361259093521369, 16.953885258664489],
              [82.367876939492476, 16.939651368808921],
              [82.372135855706119, 16.922606085515302],
              [82.37276188895305, 16.90833651397617],
              [82.372511592419357, 16.905863908668486],
              [82.372490077763359, 16.903652577092501],
              [82.373490831350523, 16.902588930674774],
              [82.375460300122597, 16.879465592470243],
              [82.37518212523787, 16.869488231596058],
              [82.374746097892796, 16.86854951995462],
              [82.375648965419145, 16.842528828955437],
              [82.372795714403765, 16.830329444778627],
              [82.371714359738974, 16.825612863188429],
              [82.369911642295904, 16.82100560854736],
              [82.36915114223757, 16.819847149300248],
              [82.367890611075097, 16.815951924502951],
              [82.367130156593134, 16.814793466633926],
              [82.36290615119276, 16.801247907384944],
              [82.361008887884168, 16.791204090944994],
              [82.357653845447601, 16.781768749539431],
              [82.355855823282297, 16.772211992657247],
              [82.353593257490672, 16.767793628908038],
              [82.351171402283455, 16.757244111338469],
              [82.350735480356491, 16.755224188918923],
              [82.349942821640354, 16.754271617443191],
              [82.348895184499099, 16.751512454050324],
              [82.348695905111072, 16.750606475165863],
              [82.348842486100352, 16.737008372129573],
              [82.351086999596646, 16.728282851949952],
              [82.351176702290104, 16.723521997481797],
              [82.35045723894325, 16.721444602042833],
              [82.348639864036329, 16.720472825554712],
              [82.344847798825015, 16.721008740319093],
              [82.332171708552096, 16.727613802975132],
              [82.330298622647547, 16.728589609041471],
              [82.324250335492025, 16.72728410693033],
              [82.320219041689768, 16.724587485890769],
              [82.320240199091131, 16.722493455444777],
              [82.321408224946708, 16.719825419352645],
              [82.328922681586732, 16.714929283808178],
              [82.33912189196667, 16.712397139580787],
              [82.341301098222971, 16.711105076750865],
              [82.341569820599261, 16.71042552221931],
              [82.34252778907944, 16.709796931793569],
              [82.342937008808804, 16.703229639990351],
              [82.34270781875631, 16.700297358573756],
              [82.340936610780091, 16.697739012380389],
              [82.339276622426553, 16.692676229779622],
              [82.339525443059983, 16.689739468643772],
              [82.339931804336004, 16.688628745334697],
              [82.345414945357959, 16.687032947882869],
              [82.347747844283731, 16.687127994105836],
              [82.352591712372543, 16.689212510048261],
              [82.356440850516947, 16.692245649723187],
              [82.357115712402447, 16.693170921018144],
              [82.357686254201838, 16.695910288701196],
              [82.357666596225101, 16.697452165364659],
              [82.357596776838534, 16.7033648199046],
              [82.358564747263983, 16.705223187806251],
              [82.360887901097556, 16.705546645113937],
              [82.361710542673904, 16.705810922661897],
              [82.36315439527192, 16.705523888631198],
              [82.36397703805784, 16.705787010458348],
              [82.364832993553478, 16.704763068799672],
              [82.367874182341723, 16.701756327681831],
              [82.367538203907145, 16.698566055486943],
              [82.364065005397379, 16.69347608823653],
              [82.363225170090459, 16.692521542047949],
              [82.35831178370114, 16.68711962781294],
              [82.357880044101876, 16.686641802410925],
              [82.356976890275519, 16.685477092547444],
              [82.354731349127633, 16.683405885861337],
              [82.354275725980244, 16.682927134268418],
              [82.352931035043696, 16.681514158628495],
              [82.35182794188853, 16.680042471220261],
              [82.345130609288049, 16.674545106967919],
              [82.343449137101686, 16.67265873207695],
              [82.33466734567196, 16.666891567797833],
              [82.333431303515681, 16.665712665386252],
              [82.331953113327131, 16.662476009591856],
              [82.331149831095274, 16.66175325866217],
              [82.32806319297066, 16.657690516389618],
              [82.327640548433692, 16.656476617453396],
              [82.324481675793777, 16.651859731177062],
              [82.323766596916755, 16.650793910136613],
              [82.323816714776342, 16.646951611597665],
              [82.324715346299286, 16.64496339501466],
              [82.328397461664792, 16.641476440746438],
              [82.32997091546207, 16.63769592323403],
              [82.329981539779851, 16.634749766121264],
              [82.334543450617048, 16.624301223623583],
              [82.336072587321951, 16.616651504532513],
              [82.336194344893102, 16.611730562233927],
              [82.336374171563989, 16.604417813300138],
              [82.336196569744857, 16.603051528255133],
              [82.334553600295862, 16.597621701656266],
              [82.333470403556078, 16.595689580550705],
              [82.333234484382444, 16.591306737007802],
              [82.33287143287555, 16.583878990052394],
              [82.332313945937699, 16.579782651652895],
              [82.329820936732062, 16.577401283420521],
              [82.328358269357807, 16.573291029450186],
              [82.327222541043568, 16.572553142556647],
              [82.324689728633984, 16.573255807528462],
              [82.32079909429126, 16.575008084729195],
              [82.31999454202662, 16.577023205020986],
              [82.315376045228334, 16.582290637105068],
              [82.313169545803021, 16.585860522893665],
              [82.318381451468099, 16.584945402247332],
              [82.324399035935642, 16.582521127316536],
              [82.327031494514188, 16.582283297138794],
              [82.328008294800213, 16.583911698999177],
              [82.328017852869209, 16.586398140246047],
              [82.325955139112409, 16.591010059639448],
              [82.325905441533905, 16.596969335404456],
              [82.325568319829131, 16.599212077707225],
              [82.326558234095273, 16.603787585101543],
              [82.327584614078773, 16.604289227810746],
              [82.327319601390002, 16.611369034980981],
              [82.322455297218767, 16.623808435266792],
              [82.321238183198886, 16.62490931717721],
              [82.320166753920262, 16.625969875284351],
              [82.317978531019776, 16.627469402550595],
              [82.317060426319074, 16.627201701970282],
              [82.314670847967363, 16.625723545361506],
              [82.312827161094162, 16.617291630200558],
              [82.311656695279908, 16.616001679721165],
              [82.311650960803547, 16.615052068145111],
              [82.31103507791255, 16.611627436678109],
              [82.310626997411248, 16.609915342085962],
              [82.310818758106961, 16.608772200871822],
              [82.310407020806679, 16.606492188210439],
              [82.309413613356355, 16.605356140633198],
              [82.308416664429558, 16.604218953792465],
              [82.305657724578566, 16.604807538855884],
              [82.302909607612946, 16.606539918059376],
              [82.29957133487153, 16.609413909348728],
              [82.297067917022332, 16.612555833407779],
              [82.294730379673922, 16.617909766495718],
              [82.292771236448459, 16.619625552521725],
              [82.292296976043133, 16.620112174137578],
              [82.289782315221146, 16.620377731170088],
              [82.287668669082507, 16.618587778062651],
              [82.288217882082733, 16.61319977841325],
              [82.288981289443882, 16.611021351637348],
              [82.28949736751963, 16.610144994349998],
              [82.290688681973506, 16.608006862431026],
              [82.29461907602888, 16.604299988516868],
              [82.295861182032866, 16.597790869066852],
              [82.302256826479265, 16.596003161065163],
              [82.303224323189056, 16.595145273983075],
              [82.304583425615704, 16.591356699281604],
              [82.30448623169417, 16.588175662626185],
              [82.303554868119136, 16.587677105740088],
              [82.303228601196849, 16.586973891924572],
              [82.303418229368333, 16.585393174744468],
              [82.302485651171764, 16.580613033338221],
              [82.300661456271769, 16.578765685614012],
              [82.299236853480465, 16.577556249447511],
              [82.298194991069579, 16.576339165945289],
              [82.298216472756224, 16.570470486421105],
              [82.297070772593713, 16.569963203267459],
              [82.296396931431673, 16.569037892644804],
              [82.289037732650456, 16.5662497578098],
              [82.288096399537494, 16.565980813896129],
              [82.282649236472366, 16.565757214828619],
              [82.277704419906343, 16.56493372218663],
              [82.2701264988562, 16.56386243599648],
              [82.264752362600234, 16.560925456306858],
              [82.263973733753119, 16.560202446894486],
              [82.263468600528086, 16.55815579736748],
              [82.263648433824983, 16.556804909955396],
              [82.264843833949669, 16.556186883168685],
              [82.280643872180292, 16.554556598123973],
              [82.283143787489394, 16.554613474817362],
              [82.286099673512979, 16.554596289980857],
              [82.296288871940874, 16.555888831712171],
              [82.299753782776634, 16.556744430994261],
              [82.309741405250577, 16.559914909552241],
              [82.316180421182935, 16.559280676494215],
              [82.314332442272246, 16.556327589809193],
              [82.313234124071585, 16.554763438135229],
              [82.304447638903866, 16.551917517385888],
              [82.299984007397143, 16.551550837608954],
              [82.294620927652431, 16.551055582846796],
              [82.288427384453769, 16.548315443213184],
              [82.283445922989984, 16.547811029866757],
              [82.281999115615292, 16.547659580919703],
              [82.280587242596766, 16.547786841308397],
              [82.271865861867184, 16.546714449848817],
              [82.257616137695891, 16.544563659529494],
              [82.250293717471948, 16.542581453824162],
              [82.248835834803856, 16.54215319495523],
              [82.230426939664881, 16.53391125156951],
              [82.221427503888037, 16.527876544872484],
              [82.219088681547476, 16.525293376573813],
              [82.212879852727667, 16.522411965373358],
              [82.210387329037303, 16.520605823916689],
              [82.20143706176043, 16.516183205530186],
              [82.198297124736825, 16.512876526422588],
              [82.190880023022146, 16.50826387708808],
              [82.189235589722728, 16.506146705692295],
              [82.185236725243726, 16.503954841942303],
              [82.183052395372954, 16.502712296707315],
              [82.168336710191966, 16.496207655849091],
              [82.165885800488525, 16.495599245137424],
              [82.159290109473147, 16.493943172870424],
              [82.157782257912345, 16.492617280767785],
              [82.155824646473889, 16.491466651853106],
              [82.15385763324656, 16.489303804710744],
              [82.150688617392916, 16.487001666608908],
              [82.149790175351086, 16.487297339580312],
              [82.149797372689477, 16.488455764880182],
              [82.152810630066597, 16.49018001541949],
              [82.153119981030272, 16.49148093711128],
              [82.154329325842298, 16.492779771019798],
              [82.1550881812841, 16.493628951079753],
              [82.157972449418651, 16.498331645445276],
              [82.164870935478518, 16.504397398868271],
              [82.165584536697168, 16.504933556917472],
              [82.167144212111623, 16.506816876287814],
              [82.168418091019589, 16.510277154227033],
              [82.168072276199212, 16.51795174101176],
              [82.169090782929572, 16.520733732115009],
              [82.171363281111894, 16.523198929939021],
              [82.17367237006323, 16.52642613024727],
              [82.175142672531138, 16.527616037316513],
              [82.178027026924497, 16.531304095837303],
              [82.182820746927291, 16.536521915241007],
              [82.184185243777222, 16.53904183054539],
              [82.187570697574131, 16.543234174606432],
              [82.192301402986118, 16.547735495646801],
              [82.198695050929985, 16.556610612551985],
              [82.19901152874138, 16.557520839095023],
              [82.20001644006993, 16.558483828452854],
              [82.199804250604643, 16.563239684794087],
              [82.198135209720476, 16.564298883712709],
              [82.197639410334261, 16.564739465635466],
              [82.194919153206399, 16.564810535096907],
              [82.188753572181497, 16.56413991214075],
              [82.180192729599128, 16.561069076685389],
              [82.170147546805083, 16.554987590119808],
              [82.164282673422065, 16.549748650526734],
              [82.154560143216429, 16.531225697188823],
              [82.148963313784179, 16.524821885810571],
              [82.143223784554152, 16.517377259516927],
              [82.141541039331344, 16.504022004114105],
              [82.140785171822984, 16.498028192493226],
              [82.140722504004316, 16.487827310238838],
              [82.140711824039499, 16.484373742097254],
              [82.138201654669047, 16.48454521882238],
              [82.131714485965801, 16.481556913541787],
              [82.129011305798485, 16.479187662439458],
              [82.127174361317316, 16.478719740466499],
              [82.119127597879526, 16.474906302667875],
              [82.117766286698952, 16.47392836529017],
              [82.107792912233435, 16.470610540654725],
              [82.103898901676985, 16.469296182227456],
              [82.089922011857936, 16.462355190999713],
              [82.078974833254165, 16.455309688506748],
              [82.071392672241871, 16.451813418590351],
              [82.06938273544921, 16.449932940585022],
              [82.05716838054235, 16.445112991200364],
              [82.047309385255119, 16.440391850219108],
              [82.046414228477261, 16.43966333656207],
              [82.036709191054342, 16.436766899157981],
              [82.033745775533703, 16.434384754799424],
              [82.030523574232916, 16.433488753546669],
              [82.025489128720551, 16.432147512582148],
              [82.021730711274984, 16.430468939557588],
              [82.018168650428379, 16.427140782346232],
              [82.007287355938217, 16.422926701243508],
              [82.005749819813843, 16.421641707434912],
              [81.998199840068764, 16.416992768778133],
              [81.994009096234322, 16.413337424074047],
              [81.98835701485558, 16.409367760776991],
              [81.978879404116014, 16.404175217919349],
              [81.970272585339899, 16.397684736888387],
              [81.967531071609244, 16.3962084103729],
              [81.966603329891655, 16.396169365797348],
              [81.964445855387339, 16.39699810406648],
              [81.964048012288799, 16.397879797945468],
              [81.962544770126215, 16.407784838609508],
              [81.964501121925537, 16.416479013987757],
              [81.966327690128196, 16.419734909174444],
              [81.969371237724715, 16.432780502813632],
              [81.96934448066537, 16.435957254031038],
              [81.968935849750494, 16.437067495537367],
              [81.967953215747002, 16.437717260272951],
              [81.965623684895604, 16.437617348919741],
              [81.964945482138546, 16.437357882149467],
              [81.96436197773869, 16.437103004774745],
              [81.960688898551382, 16.433078849105478],
              [81.956780314472951, 16.425889279143838],
              [81.955287676166336, 16.415395902774115],
              [81.952374123153788, 16.407834417863473],
              [81.951401279943354, 16.404638114165703],
              [81.950331363135604, 16.398421755591322],
              [81.945137994303195, 16.394331911570518],
              [81.938228657007301, 16.391319439812641],
              [81.928217326668687, 16.390016178202995],
              [81.92655695508995, 16.39038314031248],
              [81.909595373437526, 16.386939039237355],
              [81.902823990934451, 16.384576069564265],
              [81.894391294678485, 16.381059147368322],
              [81.875650117207044, 16.37596972040491],
              [81.873595741922259, 16.375098769489476],
              [81.867486345308578, 16.373361835985897],
              [81.864543898737566, 16.372106189316415],
              [81.860950055952401, 16.371560286450084],
              [81.854571683576012, 16.370502148124643],
              [81.851410348303148, 16.368339161510107],
              [81.840340045861126, 16.364222617787345],
              [81.834666612385035, 16.36079904402926],
              [81.832717736574807, 16.359195563771447],
              [81.826691063682006, 16.355710779379212],
              [81.808092551122968, 16.347674500417046],
              [81.799514042320084, 16.34276569006845],
              [81.794760547250007, 16.340048927381158],
              [81.793022064195611, 16.339051724681827],
              [81.783863967704463, 16.334831067213379],
              [81.777056871267916, 16.32974552434176],
              [81.771365997632472, 16.327240202212788],
              [81.770157058223788, 16.326635303774264],
              [81.765505783815001, 16.32429128870184],
              [81.76232113824193, 16.322678150172628],
              [81.753948235274379, 16.318997216418488],
              [81.750268224003207, 16.316786862526477],
              [81.745523260318635, 16.314944585297237],
              [81.735143864919507, 16.31092108605641],
              [81.733188473340533, 16.309983364605852],
              [81.730391718121837, 16.308732300645541],
              [81.725788134354616, 16.30742526997842],
              [81.723167051583744, 16.30998182458837],
              [81.722864332816357, 16.312870525125305],
              [81.725811073029433, 16.319515784129877],
              [81.727544573472699, 16.322631062931325],
              [81.728058148330035, 16.324268558354166],
              [81.731431540392578, 16.333134821280112],
              [81.734676248719325, 16.342704465282512],
              [81.73498946408921, 16.34890544763519],
              [81.734727389170473, 16.356514839230012],
              [81.724800001052017, 16.35570382759267],
              [81.723327459726875, 16.351484370713845],
              [81.723006346332681, 16.343029974394252],
              [81.724088489013184, 16.340799254622372],
              [81.725610076110911, 16.337664843399342],
              [81.724423257790363, 16.332033372468334],
              [81.720236445814976, 16.328435933487626],
              [81.718863324020617, 16.327255844033409],
              [81.716210889590457, 16.320782209473304],
              [81.715842063221885, 16.312203788939172],
              [81.708752359894049, 16.302740931158304],
              [81.706390542448389, 16.302867525569642],
              [81.701626251196956, 16.30493741950184],
              [81.700119078568093, 16.31164128712404],
              [81.700023132679178, 16.318683900673303],
              [81.697059123704037, 16.321961109041467],
              [81.695769883216315, 16.32252715928864],
              [81.692657394656294, 16.323909352155383],
              [81.683197570948437, 16.328121531341758],
              [81.664617502666658, 16.334349898046622],
              [81.660778682276714, 16.335999304604407],
              [81.650372793444376, 16.338027044979722],
              [81.646384711593271, 16.338289248895162],
              [81.639116875021443, 16.338427920289874],
              [81.631114488633045, 16.338994937309014],
              [81.619847143135189, 16.339624998263773],
              [81.617711038320181, 16.33999059339618],
              [81.616060490180416, 16.34014729324447],
              [81.610185173105265, 16.340555428487633],
              [81.599529916191671, 16.34132603336672],
              [81.594995222497857, 16.341561350381312],
              [81.592769473856492, 16.341808698720452],
              [81.581640890662698, 16.34449196098614],
              [81.572817128371526, 16.348017172885296],
              [81.570734408018893, 16.349751625000359],
              [81.568950663767566, 16.351195699857143],
              [81.567167870253343, 16.353072620831714],
              [81.565088417549816, 16.355958276815628],
              [81.572693439751504, 16.356512970388074],
              [81.576771216620159, 16.357299211650542],
              [81.579351348586215, 16.358460216707844],
              [81.580480615208671, 16.360166379658821],
              [81.572162464081316, 16.36585291667167],
              [81.566446451973377, 16.367855363737743],
              [81.564382638179723, 16.370215757574588],
              [81.561265101064691, 16.37497608364178],
              [81.556821089138964, 16.384779686414948],
              [81.549529389536247, 16.390269612611931],
              [81.548182143694817, 16.387968480188675],
              [81.547930927997299, 16.387008255967668],
              [81.547579224380854, 16.385666229037405],
              [81.54772036773528, 16.3830750364354],
              [81.548310891324604, 16.380912425397245],
              [81.549798256341546, 16.379468736402941],
              [81.55124076792265, 16.377982638489566],
              [81.553925052234263, 16.375219959923292],
              [81.555459778211855, 16.36757446681354],
              [81.554460747318103, 16.36013723394494],
              [81.553361583338585, 16.358730198086214],
              [81.548292816862499, 16.355716523881298],
              [81.531282877889566, 16.351432490873311],
              [81.528627141150821, 16.350738671790577],
              [81.514757681855997, 16.351499543086],
              [81.503522677825231, 16.349959881100357],
              [81.497447434658909, 16.348558281361903],
              [81.484760942163632, 16.346515364367026],
              [81.476599828612279, 16.345917556985636],
              [81.474745914619973, 16.345374110455325],
              [81.473570586440871, 16.345551468633282],
              [81.471715511072887, 16.345006837690295],
              [81.468890580784091, 16.345340354602136],
              [81.459822488952852, 16.343802931425596],
              [81.442310103134218, 16.343082637360371],
              [81.434126651402323, 16.341975284566001],
              [81.433426730397059, 16.342174718550343],
              [81.415984109894794, 16.339058868671607],
              [81.411817513112737, 16.338087353993831],
              [81.410073151355618, 16.337731978256986],
              [81.404619649965241, 16.336771041361963],
              [81.403207778886554, 16.336937727662782],
              [81.401998644582363, 16.337804183550841],
              [81.402050624897754, 16.339164615422696],
              [81.403857048498139, 16.342632530699991],
              [81.40324012283611, 16.346012896798658],
              [81.402741966893814, 16.346451196916785],
              [81.401522958772546, 16.347523718043611],
              [81.398880968803667, 16.348970185941042],
              [81.392384511323996, 16.351807696279256],
              [81.390732468920476, 16.352470088212364],
              [81.391061467359634, 16.354027026501811],
              [81.391717887551636, 16.35617581287536],
              [81.393600830454034, 16.357597602461119],
              [81.399025799445383, 16.36010075360047],
              [81.401366764104864, 16.360437025400437],
              [81.402090138868857, 16.359778694685684],
              [81.403172164826572, 16.356649118450822],
              [81.404392173906274, 16.356037354889846],
              [81.407918696247805, 16.355505769535558],
              [81.409297000860988, 16.356028737033188],
              [81.407844720609376, 16.371140259971174],
              [81.411994524128318, 16.372939955843187],
              [81.413751108221618, 16.375506623731873],
              [81.41314317695435, 16.378196289134106],
              [81.41045531721727, 16.380562338195322],
              [81.408558615548088, 16.381374754466687],
              [81.404593242186195, 16.380642481481637],
              [81.400087914311314, 16.37732883944161],
              [81.399319950064978, 16.376004183383142],
              [81.397638911767956, 16.374338821191387],
              [81.397325859765715, 16.373427220091866],
              [81.394560223319615, 16.370100071910571],
              [81.393270591294481, 16.368245563299535],
              [81.387913235041992, 16.364339881356528],
              [81.386512292391558, 16.362802384048326],
              [81.385182348382955, 16.361268603807609],
              [81.383814415310155, 16.360031611116707],
              [81.381968509921649, 16.359325961582385],
              [81.375095059762714, 16.360602152831902],
              [81.372991899268982, 16.360276760341407],
              [81.372312741638041, 16.360038560874823],
              [81.371894612213055, 16.358868358499617],
              [81.369666262868407, 16.35671725672243],
              [81.368083265153246, 16.355977165527701],
              [81.363572616018132, 16.356693094334435],
              [81.356456342195486, 16.359524068999228],
              [81.353816294096248, 16.36140720962457],
              [81.351303671802725, 16.363595829640104],
              [81.347415541116504, 16.365675479570211],
              [81.343426096911685, 16.36641483312339],
              [81.340835657529396, 16.36629693624462],
              [81.330854523436983, 16.364459481186088],
              [81.325336092370776, 16.362410192750236],
              [81.322577638788573, 16.361363776264533],
              [81.32197078397985, 16.361589386400986],
              [81.315958396882138, 16.361360312936814],
              [81.312753416956468, 16.360199689536511],
              [81.311970690243641, 16.359173788760973],
              [81.312512402084906, 16.356389538447498],
              [81.313364968582675, 16.355530103526885],
              [81.313159262810416, 16.352456824548781],
              [81.311202278992255, 16.351585301690942],
              [81.303962894629876, 16.348719652733397],
              [81.302531714597592, 16.346835193933565],
              [81.302338819033878, 16.345927440804171],
              [81.30241543948415, 16.344365412151788],
              [81.302817526586068, 16.343462791681887],
              [81.304241291253106, 16.343090410687719],
              [81.308253941234454, 16.342813684206945],
              [81.311237157502262, 16.343996160233484],
              [81.312965894157969, 16.344366354663126],
              [81.317100972542391, 16.345154397295996],
              [81.320403341554425, 16.344752947151633],
              [81.321643504678434, 16.343948969258292],
              [81.32123034053626, 16.342354966423187],
              [81.319156781319293, 16.341159814737473],
              [81.317091162244196, 16.339568369266011],
              [81.315437601277665, 16.338372852356933],
              [81.311353380895468, 16.336460063351844],
              [81.305910133015686, 16.333400919892593],
              [81.300833345614706, 16.33158020686248],
              [81.300117683983615, 16.331132511819682],
              [81.298501310426843, 16.330114022029367],
              [81.291303314639322, 16.325476742960586],
              [81.287140916108058, 16.323950101341037],
              [81.258342146864038, 16.318987136112199],
              [81.254747150506546, 16.316104594792993],
              [81.25324167375959, 16.308550415612654],
              [81.251230017766318, 16.306407972827479],
              [81.246069814640521, 16.30437375417889],
              [81.24554720928387, 16.302437646357774],
              [81.245622708206383, 16.301404529921271],
              [81.25342631164466, 16.298609105951272],
              [81.260594586722164, 16.297119918380538],
              [81.265619485769946, 16.294195564113998],
              [81.266444909934364, 16.290018960439518],
              [81.265960002546308, 16.285873487803649],
              [81.263166105841606, 16.278859268592313],
              [81.260700845850238, 16.27625802916835],
              [81.252587971780258, 16.269965795062504],
              [81.24884165748449, 16.267766638565377],
              [81.245106921202648, 16.265420149946333],
              [81.242623468973193, 16.263431784608709],
              [81.240971487323407, 16.262235622880105],
              [81.241379967212652, 16.260640236051412],
              [81.243031508992431, 16.260637397098151],
              [81.246751895045691, 16.260633818629085],
              [81.250056820876637, 16.262224379190744],
              [81.252950403537227, 16.263816189662627],
              [81.253132579645012, 16.263795426425823],
              [81.253775222014724, 16.264746494141029],
              [81.256777761391334, 16.266104703449447],
              [81.26320241028958, 16.269970691788291],
              [81.267117701174129, 16.270704113099548],
              [81.266040318498085, 16.26747621608266],
              [81.261940823746613, 16.262795422032912],
              [81.257611745179304, 16.258427410003293],
              [81.248429219555703, 16.252109182720453],
              [81.247647605567067, 16.251082037207283],
              [81.245452301077762, 16.248332502741096],
              [81.243857027707463, 16.247383347618396],
              [81.243319679531908, 16.246230709208952],
              [81.237981740311852, 16.243012580473835],
              [81.23755416340822, 16.242533053133929],
              [81.237415579413096, 16.241951128241126],
              [81.230066145451246, 16.235185945855928],
              [81.229637445549315, 16.234705255536618],
              [81.22940555678889, 16.23411827266429],
              [81.228704959390313, 16.233855374539889],
              [81.227857272950303, 16.232227214308196],
              [81.224179092966949, 16.228694319285122],
              [81.223790077533749, 16.227894122057887],
              [81.222625687780464, 16.226895686604607],
              [81.221823424510205, 16.224371441348936],
              [81.218954329238443, 16.220368944332638],
              [81.216287876287424, 16.21322077058235],
              [81.21154187669157, 16.204847743795206],
              [81.210503123783894, 16.193238621624253],
              [81.207594042678124, 16.182877787696381],
              [81.207169536803235, 16.182327464823086],
              [81.205893964621623, 16.177386132587209],
              [81.20241639093399, 16.172227312618105],
              [81.201250582392333, 16.169363333621078],
              [81.200821096076311, 16.166050163318701],
              [81.199897551016193, 16.163588259297651],
              [81.197616093375416, 16.14639306617326],
              [81.19435389599596, 16.132169141333005],
              [81.193313262731806, 16.129195311709381],
              [81.189024409961291, 16.102693733158389],
              [81.186275471460817, 16.089645001584515],
              [81.18489854561011, 16.08435350810419],
              [81.181023137251088, 16.075789257640309],
              [81.180390850039544, 16.07511568557765],
              [81.179010155782464, 16.073254242364577],
              [81.177566313901593, 16.071690346983715],
              [81.177210449086431, 16.071189539239903],
              [81.175085567703775, 16.068051199710293],
              [81.170829954787166, 16.063753636919852],
              [81.161001055352187, 16.050167461909588],
              [81.155763203018068, 16.039397117370381],
              [81.154871685240096, 16.036798843824499],
              [81.152303345456403, 16.032072545779663],
              [81.148328631439654, 16.021269765817951],
              [81.147578278166066, 16.019161988005141],
              [81.145989630887073, 16.008654147060287],
              [81.146465619941125, 15.99916407352457],
              [81.147078094764368, 15.995944835985584],
              [81.147708547253842, 15.992864952967414],
              [81.151410314888835, 15.983501315951663],
              [81.153070469458783, 15.979295441908688],
              [81.152847449586829, 15.974747710365982],
              [81.15138350458659, 15.97359688119719],
              [81.148111285305845, 15.972983233074297],
              [81.144616838182856, 15.973948718916461],
              [81.143019459166624, 15.974519041733155],
              [81.133941684997069, 15.97969192662587],
              [81.131736520444804, 15.981017405968393],
              [81.129417839096561, 15.982376413404143],
              [81.127699449549993, 15.984316428130308],
              [81.124838848428851, 15.988476057643791],
              [81.122551529105408, 15.99262999608222],
              [81.119690013226375, 15.996514564175852],
              [81.117401913641743, 15.999286459474634],
              [81.113679941138173, 16.003166895440604],
              [81.108817576709612, 16.005108161993931],
              [81.102520189203744, 16.007049571913893],
              [81.098755582090234, 16.008002103612068],
              [81.094364610388084, 16.007137190767409],
              [81.091933266977719, 16.006332307984351],
              [81.087245301347309, 16.004546625917257],
              [81.086569300020756, 16.003823402979041],
              [81.083751634562645, 16.001875864521761],
              [81.083682575847945, 16.000739896426563],
              [81.085363600551375, 15.999920781323866],
              [81.088263609688966, 15.999434534860731],
              [81.09229090717929, 15.999231438661608],
              [81.094417768578637, 15.99949346518766],
              [81.103613428478866, 15.999072163972501],
              [81.109198666385851, 15.996270471137349],
              [81.110665457693472, 15.994979579659036],
              [81.111867525858145, 15.991396643652068],
              [81.112585524905739, 15.988942854264597],
              [81.114732041996547, 15.987249815476829],
              [81.115564776421081, 15.985466614497826],
              [81.119002955293013, 15.982333192862029],
              [81.12215669798718, 15.980108662426787],
              [81.123361387813475, 15.977884911046962],
              [81.12504132633228, 15.975683416770098],
              [81.126657381977111, 15.973317203665347],
              [81.138769671536181, 15.966374643834525],
              [81.140912501512048, 15.965345433632828],
              [81.141099134481578, 15.963995422494914],
              [81.140597614090495, 15.962152950181361],
              [81.139718981164435, 15.96119035151942],
              [81.129655445199887, 15.954777918740543],
              [81.126221945127725, 15.952176161108969],
              [81.124571129414392, 15.950993187799087],
              [81.110889353541268, 15.943304887800663],
              [81.102614258512006, 15.936328923576578],
              [81.097607240096977, 15.933376853351874],
              [81.090459381413893, 15.929977673040266],
              [81.079371214891523, 15.923698421591489],
              [81.074540788228603, 15.920063277390254],
              [81.07254672207074, 15.918149640452782],
              [81.067138926172163, 15.91278198235983],
              [81.064423612194958, 15.909637063445206],
              [81.063095194879622, 15.908192002649441],
              [81.051290423719195, 15.900611281838115],
              [81.045288368784554, 15.897149125152316],
              [81.04293014417641, 15.893974307437007],
              [81.041197372263639, 15.892073477652904],
              [81.040431182082784, 15.891714733308932],
              [81.038611691278561, 15.888243364604158],
              [81.037815001583738, 15.885694937843287],
              [81.036806321168797, 15.884955784817278],
              [81.035596123430878, 15.883539857241278],
              [81.034368206303952, 15.879635442666892],
              [81.0312472421802, 15.876539926828388],
              [81.028061655944327, 15.870953337259012],
              [81.023885650584702, 15.867578001859563],
              [81.02369411529321, 15.866669708052433],
              [81.022471955496428, 15.865484108273938],
              [81.021627848631795, 15.8638549568958],
              [81.017985099861619, 15.859812254114191],
              [81.012853022173999, 15.853281457128869],
              [81.011206621362078, 15.850163741718015],
              [81.009973798688804, 15.84918336031145],
              [81.009382091444138, 15.847727040437873],
              [81.00883180513199, 15.846411328153126],
              [81.007834502952505, 15.845465624624698],
              [80.999365935900641, 15.832649869814578],
              [80.996036747058497, 15.824315135466922],
              [80.996357818210413, 15.817996330630224],
              [80.997786565854483, 15.812788354230442],
              [81.000074209219747, 15.800021036798512],
              [81.000972222759174, 15.798705116746438],
              [81.002069112819356, 15.796292058056357],
              [81.003375429277582, 15.790203980942961],
              [81.004594700764528, 15.789571259361011],
              [81.004630365799187, 15.788881387713738],
              [81.005172598830825, 15.787548213792595],
              [81.007111214596023, 15.785843590156231],
              [81.011619621141847, 15.775621994837589],
              [81.011963217390928, 15.76884321619697],
              [81.010702566776956, 15.765628345037443],
              [81.008710474783584, 15.763714511583435],
              [81.007132599552392, 15.762510667308854],
              [81.005712896637135, 15.762880797551599],
              [81.004934085769776, 15.764203153151575],
              [81.001300950883717, 15.767002446033487],
              [81.000355727460999, 15.767395175013288],
              [80.999802582499512, 15.768935788120222],
              [80.99748105049963, 15.771152036155254],
              [80.993450201586825, 15.77432371309046],
              [80.990922576224818, 15.778257428895275],
              [80.976934917027904, 15.786232274884682],
              [80.976334487273959, 15.788690788736846],
              [80.97455450536296, 15.790080163084282],
              [80.974281791582655, 15.790782047956945],
              [80.966777110839701, 15.797772793925592],
              [80.964068185800727, 15.800131926271709],
              [80.963691537264026, 15.801012161487655],
              [80.963089522441351, 15.802089277808602],
              [80.961849095299726, 15.802674751580087],
              [80.961577825175482, 15.80332987439402],
              [80.960359574598101, 15.803940591560655],
              [80.960088120880243, 15.804618526897332],
              [80.956789199064701, 15.806902620347717],
              [80.949157764922518, 15.811301175816213],
              [80.948139591038625, 15.810245473333786],
              [80.939986086159536, 15.807162205379047],
              [80.939545055341455, 15.804631123233005],
              [80.941935980912604, 15.80338573808446],
              [80.949515114588451, 15.801926902061249],
              [80.954579124826978, 15.798551477534575],
              [80.955087141521972, 15.797447493647061],
              [80.959489135796844, 15.794016989656015],
              [80.960598044216169, 15.790891416682607],
              [80.963068742866824, 15.788083554009191],
              [80.965291808148891, 15.785448431755499],
              [80.966296624860149, 15.783906533784377],
              [80.971158734842902, 15.780290848508256],
              [80.971205719286786, 15.779371805630886],
              [80.972423693329461, 15.778762173295496],
              [80.97339516289685, 15.778346986195153],
              [80.980902672743866, 15.772208305314377],
              [80.981147712310474, 15.77157468368901],
              [80.982095545991172, 15.771159280520942],
              [80.982863575309693, 15.770528174748678],
              [80.986459871456248, 15.767519183266039],
              [80.989019718374152, 15.765268285232779],
              [80.989408403626157, 15.76415887853768],
              [80.989355118317349, 15.760539333396384],
              [80.988809831516789, 15.760053066373471],
              [80.987146963539033, 15.755412929256444],
              [80.980627351820999, 15.750566646493064],
              [80.979535497216943, 15.749154934195612],
              [80.975079728857168, 15.747146989359795],
              [80.974755378276427, 15.746442985922387],
              [80.974331108864646, 15.745522098205786],
              [80.96938835938596, 15.741901223849489],
              [80.964686713408355, 15.740064614905434],
              [80.9641859124647, 15.738704928801717],
              [80.963013925014366, 15.738419424913561],
              [80.960998202500832, 15.736964525825753],
              [80.960132111262453, 15.735793837781682],
              [80.948667049671485, 15.729742992222313],
              [80.945496334787777, 15.728141550432168],
              [80.944139171199481, 15.728214964730926],
              [80.939901290963803, 15.728933471046169],
              [80.937913170178092, 15.729277095952121],
              [80.936847773787633, 15.729686748109373],
              [80.936044883035152, 15.73146809535894],
              [80.93299916070481, 15.733925322183611],
              [80.932715488528231, 15.734810585026025],
              [80.930912213376246, 15.736199077410543],
              [80.930357063463759, 15.737760974252804],
              [80.928642293767894, 15.739268717319186],
              [80.928145400010635, 15.739706453388965],
              [80.92594491712174, 15.741420456257151],
              [80.924466870336005, 15.742916224413559],
              [80.923791264975364, 15.744058641219043],
              [80.922930073898158, 15.745584057897325],
              [80.920292288304097, 15.747024444600223],
              [80.909833823209624, 15.7546785123933],
              [80.908320337231316, 15.757324771407715],
              [80.907586659415585, 15.757750414447981],
              [80.90568166263904, 15.759709356525731],
              [80.904487107640705, 15.76031972090056],
              [80.902914067419204, 15.762294825675957],
              [80.899830321745469, 15.765947779152766],
              [80.896387114535969, 15.771496004829492],
              [80.894918349536056, 15.772347186581557],
              [80.889588587907383, 15.784138723957966],
              [80.888941906842092, 15.784706409607381],
              [80.887296583338696, 15.788981682555852],
              [80.886314844285096, 15.789602694818903],
              [80.883853465910875, 15.792225694553009],
              [80.882836353824075, 15.79399624819059],
              [80.882102399258656, 15.794421799208779],
              [80.879057629617307, 15.800057468645708],
              [80.876948358235893, 15.803665299935448],
              [80.875457595867772, 15.805412802053587],
              [80.874333810706503, 15.806948675783785],
              [80.872964140500244, 15.811858123790326],
              [80.871526381163278, 15.820427828870082],
              [80.87036746157986, 15.822628531026979],
              [80.869207169895446, 15.822573889265842],
              [80.868484069242641, 15.823229924406688],
              [80.8629164870772, 15.822041184852276],
              [80.861944242651248, 15.820634988036744],
              [80.861043240299409, 15.820154516647642],
              [80.859868620398515, 15.81758770284223],
              [80.860858689229872, 15.812198501067973],
              [80.863048923022632, 15.810253531265182],
              [80.865165993097776, 15.80604815492276],
              [80.866869786116638, 15.804771256004567],
              [80.86857384453333, 15.803032346539773],
              [80.869556036065489, 15.801951722597265],
              [80.871222675121089, 15.800027706098401],
              [80.872057134535339, 15.798569489451596],
              [80.874322473033999, 15.795615465589169],
              [80.874606838840634, 15.794707377905338],
              [80.875319289874085, 15.7943090293794],
              [80.876049686662668, 15.793900641298038],
              [80.883858345063459, 15.777806357345201],
              [80.888957152573312, 15.765910782311035],
              [80.891543756460294, 15.760852448848867],
              [80.894501306956386, 15.757814683822046],
              [80.896034711202276, 15.754778628674423],
              [80.896787867183036, 15.753985921230189],
              [80.897078809563482, 15.753400718785823],
              [80.897776490190495, 15.75320412028084],
              [80.90531233052269, 15.747459979674902],
              [80.907074865476091, 15.745033534456452],
              [80.911221970711836, 15.741016749679286],
              [80.912730993743878, 15.738900889323395],
              [80.913625514087869, 15.737192176184569],
              [80.914680049518608, 15.7360914308057],
              [80.915519089089059, 15.734541980135877],
              [80.916754717000856, 15.730799946476063],
              [80.916292063363301, 15.728704762657399],
              [80.915014239968286, 15.727238782817818],
              [80.905207579937951, 15.725433993525742],
              [80.890475953366547, 15.72385338759063],
              [80.880608732899191, 15.722321352354134],
              [80.878330309629916, 15.722303801741608],
              [80.869541279673115, 15.720569475074999],
              [80.861216256329385, 15.716737446393232],
              [80.859906682519295, 15.715914011202059],
              [80.857889439745009, 15.713122219209989],
              [80.855955086066729, 15.711969948989459],
              [80.854947639742477, 15.710791881378348],
              [80.850575070926482, 15.707656423431146],
              [80.846219081862841, 15.70606518633179],
              [80.838736536975489, 15.706626059448062],
              [80.833245664324863, 15.708619014530122],
              [80.827694881037985, 15.712221661719928],
              [80.823885255048936, 15.713373600861528],
              [80.812234251950258, 15.71281246808746],
              [80.810690431258536, 15.712829506576167],
              [80.80467452258614, 15.714866165462661],
              [80.804012918303329, 15.716192834087712],
              [80.803915694391549, 15.719896408567786],
              [80.805725652248952, 15.723923627164927],
              [80.806559598290391, 15.727533404562966],
              [80.807392967956844, 15.733909031246426],
              [80.806405879246142, 15.740126111851449],
              [80.805562778916169, 15.742666088825976],
              [80.804592440913495, 15.743056179825299],
              [80.804191745592675, 15.74483333008107],
              [80.804821703049697, 15.750093195771793],
              [80.810347364504139, 15.750563926268537],
              [80.8107440107608, 15.748973759569918],
              [80.812801334700112, 15.746839412026414],
              [80.815615823767871, 15.74199892226013],
              [80.817047242219871, 15.741400362697261],
              [80.818456951578924, 15.741675290631388],
              [80.819333081495813, 15.742639344205402],
              [80.819725490499934, 15.744247319085558],
              [80.819027298293634, 15.74626390348141],
              [80.818111012676525, 15.750205182360343],
              [80.817658331149062, 15.751611281336976],
              [80.814808996335785, 15.757601374794669],
              [80.81230477085137, 15.770195196739227],
              [80.812364872001581, 15.773169367723421],
              [80.813661860749619, 15.780212151259457],
              [80.814206603382672, 15.780699097285014],
              [80.813875202532643, 15.78710932579502],
              [80.812889151216666, 15.794686962621055],
              [80.813114430631344, 15.797231458161964],
              [80.81460156257333, 15.805203599168715],
              [80.815882944549003, 15.80934239372265],
              [80.814147917117907, 15.820384580309293],
              [80.807737371511223, 15.835485479881111],
              [80.806067635520151, 15.836533899522763],
              [80.804741882143901, 15.839210810813226],
              [80.799370305510479, 15.843857729521035],
              [80.798573434982302, 15.845478002200958],
              [80.796868484010815, 15.846755362866945],
              [80.792642415541764, 15.85175612437331],
              [80.792358765606593, 15.852641366215975],
              [80.788947165077559, 15.855217633384955],
              [80.787160367090507, 15.858517013391582],
              [80.785691975685779, 15.859805381847002],
              [80.782886984459822, 15.862134473484112],
              [80.781668016306355, 15.863203563899198],
              [80.777130382978953, 15.866415944818],
              [80.761944904292704, 15.876553588365367],
              [80.755865523147406, 15.880151623808141],
              [80.743949906041223, 15.884525253360101],
              [80.73757355717629, 15.885598508323477],
              [80.730534403156469, 15.886177377846689],
              [80.72564129577637, 15.885709050663385],
              [80.706741753904964, 15.885019829652634],
              [80.705340795073027, 15.884558980799659],
              [80.702169649764699, 15.883414889143223],
              [80.691386343476609, 15.883349165932367],
              [80.684478547198694, 15.881422589480408],
              [80.672854411149103, 15.880186403435669],
              [80.672132180608628, 15.880381765843911],
              [80.669608958423112, 15.879566910263675],
              [80.668708468073305, 15.879062365968121],
              [80.661669337652711, 15.879640178856851],
              [80.654884938288433, 15.879008317850316],
              [80.640686326205753, 15.878381263002604],
              [80.632065900234124, 15.876047149887173],
              [80.621653463219104, 15.872586590816042],
              [80.617028537222609, 15.870631666741764],
              [80.609588939883395, 15.869344570188677],
              [80.60547752735755, 15.867576742450398],
              [80.603568786500318, 15.868173402322482],
              [80.594968885208061, 15.869003392052123],
              [80.594400116392535, 15.86905837043072],
              [80.58282368906788, 15.866920990395469],
              [80.579092304727169, 15.866506971272635],
              [80.56325553061248, 15.860957281028222],
              [80.559237565901697, 15.859238154511319],
              [80.545828360924702, 15.85334328673501],
              [80.540840826597105, 15.851398361618049],
              [80.536851981223322, 15.850422796194627],
              [80.534191661581758, 15.850095978445333],
              [80.532856707278938, 15.852022032371694],
              [80.534183040667472, 15.853639484749955],
              [80.537171477684581, 15.855580544528234],
              [80.540496036268735, 15.857843232797594],
              [80.541823552509129, 15.858812613726844],
              [80.543821731312732, 15.859457832369262],
              [80.545150453387294, 15.860428339157313],
              [80.547147552801505, 15.861399803649256],
              [80.549469890145986, 15.862051605679957],
              [80.551135744238366, 15.862695697871224],
              [80.553795383608417, 15.863669104698193],
              [80.555790456171053, 15.865287337838581],
              [80.553792271566579, 15.864962874352809],
              [80.552792660434761, 15.864960926368102],
              [80.551130566860195, 15.864958083845272],
              [80.546804078208027, 15.863654242891473],
              [80.543144932857956, 15.863006137020466],
              [80.542102530450904, 15.86292838683676],
              [80.531978951746453, 15.860308651260199],
              [80.525541626104143, 15.860749011905877],
              [80.523756165303098, 15.860822188618316],
              [80.512431748027154, 15.858002950489769],
              [80.505658356467563, 15.857597006361461],
              [80.501890462457254, 15.857437340882463],
              [80.49823059995299, 15.85710185239636],
              [80.496563885575426, 15.856457151004376],
              [80.496235076240453, 15.855489693645175],
              [80.495906284306557, 15.854841689026497],
              [80.497569423778714, 15.854203990223052],
              [80.501231638758327, 15.853245743708946],
              [80.504893836058272, 15.85260685684892],
              [80.505893355896546, 15.85260913367456],
              [80.509889551459423, 15.853545697976074],
              [80.517400150705612, 15.853019999797533],
              [80.519994454719154, 15.852480519485924],
              [80.521196107556136, 15.851342717829308],
              [80.522067823725592, 15.848345347133799],
              [80.521222970581732, 15.845930661024139],
              [80.516344092073041, 15.842071656869267],
              [80.506710212193639, 15.837861487948292],
              [80.499498419459599, 15.834117212790941],
              [80.490523412896039, 15.828718380901863],
              [80.488247026777344, 15.827292677227932],
              [80.48623607231201, 15.826271272599364],
              [80.481764693393472, 15.824596745779191],
              [80.470120214161625, 15.818925897227627],
              [80.459771307819608, 15.815692085959757],
              [80.454763508167332, 15.812954712536142],
              [80.447957479422826, 15.809205534848958],
              [80.439168848484599, 15.806269862294483],
              [80.433444179984633, 15.804356877345848],
              [80.431171103838835, 15.803344484931012],
              [80.422115367355843, 15.798607101179932],
              [80.419592507893526, 15.797813136931097],
              [80.41688254784998, 15.796087383472729],
              [80.409853817885505, 15.792095713405194],
              [80.392526866499111, 15.783532388833684],
              [80.372569791548301, 15.771358263815831],
              [80.369791522927244, 15.77001993657073],
              [80.367576371130497, 15.76838788007756],
              [80.359705366630408, 15.763753771969682],
              [80.351039789008894, 15.75580695122758],
              [80.349866289926467, 15.755541563048963],
              [80.345158216505922, 15.752148285833576],
              [80.342098761833938, 15.748123519057257],
              [80.337642024300749, 15.744051967544832],
              [80.336624773940741, 15.743539609413926],
              [80.335996394129438, 15.743300878316274],
              [80.335800850531086, 15.742531008058256],
              [80.332230425243552, 15.737858113805002],
              [80.330612101627082, 15.735749975430418],
              [80.325758163373791, 15.730229632499874],
              [80.321321336351787, 15.724913608120444],
              [80.320499096676656, 15.723882169810061],
              [80.317164362501615, 15.720995648204982],
              [80.310838128887326, 15.716827740593802],
              [80.305484223170367, 15.710913362251535],
              [80.304786911337203, 15.710647477044679],
              [80.304373752169852, 15.709498710419716],
              [80.303611536858227, 15.708676627404046],
              [80.29756786199755, 15.702796216392237],
              [80.29498644351645, 15.698311168193253],
              [80.29420620126109, 15.697810464985318],
              [80.292599368963863, 15.695056707241188],
              [80.287556053881303, 15.689572137249382],
              [80.279552726214774, 15.683960095665004],
              [80.277448235882559, 15.682056849181469],
              [80.273330654115625, 15.676157518941894],
              [80.271955715688478, 15.671319430886896],
              [80.270950107303861, 15.670600413356556],
              [80.270645316807361, 15.669663921634157],
              [80.267904348935474, 15.666368561017093],
              [80.266688192689912, 15.665178304261758],
              [80.265724769152541, 15.661052231481181],
              [80.265124511750003, 15.660307232802593],
              [80.262994667125952, 15.657573368638051],
              [80.261529249984505, 15.655724391514475],
              [80.259760010321486, 15.650289846913768],
              [80.256446877536291, 15.64705826788636],
              [80.255153968386253, 15.645080197427637],
              [80.253080480657729, 15.640459680548075],
              [80.252382328999261, 15.640193882737844],
              [80.251685592244598, 15.639928619398555],
              [80.251165489574817, 15.639003247699158],
              [80.247702256196874, 15.632007799460498],
              [80.244413438609911, 15.621359824621019],
              [80.243326096162889, 15.619990881837515],
              [80.241420365895976, 15.617023620000255],
              [80.239563160865657, 15.614132198995909],
              [80.23665794406844, 15.600831226061622],
              [80.234513415840013, 15.59097758154836],
              [80.233699505505115, 15.584140150862213],
              [80.231431870514086, 15.578288503027441],
              [80.231003187386818, 15.576146596152649],
              [80.23026073356715, 15.574980284132694],
              [80.228431321775361, 15.568920840423795],
              [80.226724913400233, 15.560195047244589],
              [80.224583375361931, 15.554649569379926],
              [80.223477116026743, 15.547105658150224],
              [80.222983525444135, 15.545721251684435],
              [80.222310835378721, 15.544995908558617],
              [80.218669528999783, 15.543474910811954],
              [80.206761097251558, 15.547381489330647],
              [80.205739354300476, 15.549149714647205],
              [80.205702071357564, 15.549839016719361],
              [80.202045637544586, 15.552508426812842],
              [80.200715314630713, 15.553408614676435],
              [80.200420454832056, 15.554452730477241],
              [80.199698193447318, 15.555084532245973],
              [80.198478453748749, 15.555712446324783],
              [80.196160518970089, 15.557737060079655],
              [80.195662042152378, 15.558609911316475],
              [80.183802374313302, 15.565951779950412],
              [80.181883829201354, 15.566750983919031],
              [80.180513418873772, 15.570551085087841],
              [80.176899635972575, 15.572854547574906],
              [80.175479329432108, 15.57324262732563],
              [80.171081090764062, 15.572096210628478],
              [80.16929767309432, 15.570437620988361],
              [80.168898584833073, 15.569496520186801],
              [80.169223107809216, 15.566172489474861],
              [80.169109254322223, 15.561328855608412],
              [80.168565017951209, 15.560863663229215],
              [80.168273670976021, 15.559697052576292],
              [80.164324622940967, 15.559033838439182],
              [80.156835087091679, 15.559340381514932],
              [80.153768530443983, 15.559874949687414],
              [80.145908311473875, 15.559148958614102],
              [80.137954365044209, 15.558832930756697],
              [80.135649049028586, 15.55848414052817],
              [80.134659128751821, 15.557073635981954],
              [80.13597162260038, 15.552602942429221],
              [80.137192904126039, 15.551536629240339],
              [80.137230206781965, 15.55087128021748],
              [80.140307992997521, 15.550106915365353],
              [80.146469391770381, 15.550654209562365],
              [80.151870878561567, 15.552083151216474],
              [80.159064240540204, 15.552866493945602],
              [80.16591520766076, 15.551651098136155],
              [80.169840546182002, 15.552312821216058],
              [80.171435648088561, 15.553085374581139],
              [80.171865758201591, 15.553518810633021],
              [80.178517382381017, 15.560221415456343],
              [80.182168187180821, 15.561560036829214],
              [80.185545388895548, 15.559682247247427],
              [80.187162539525843, 15.556148647073014],
              [80.190326936821862, 15.553361726272028],
              [80.190850344521266, 15.552028609170671],
              [80.190887385914152, 15.551363245638282],
              [80.19400952086437, 15.549356723416956],
              [80.200079887406275, 15.545935345119149],
              [80.200920804014231, 15.545309585205269],
              [80.202509173428041, 15.544009014254954],
              [80.203399602506579, 15.54292554101295],
              [80.207367075530328, 15.54063964483287],
              [80.210556853323851, 15.537831048882955],
              [80.210594108489715, 15.537141765489691],
              [80.210879692888511, 15.536258309085207],
              [80.211839496359516, 15.535615724447155],
              [80.212786573075277, 15.535226072012582],
              [80.213191133916268, 15.534325837499011],
              [80.213481525016562, 15.531185132266051],
              [80.212971972191951, 15.52878590501774],
              [80.213094323610335, 15.526534685833138],
              [80.211936018165886, 15.519080608614741],
              [80.210900226894694, 15.51718455293644],
              [80.210334000370153, 15.516695354991656],
              [80.20652928013601, 15.509060592006678],
              [80.205737885062604, 15.508352007696475],
              [80.204504169648317, 15.507482917004225],
              [80.202131543565713, 15.50533434842613],
              [80.200897878346836, 15.504465233459063],
              [80.197047387057296, 15.500720569147846],
              [80.195331816110297, 15.499135236126724],
              [80.186927221411736, 15.495826174668483],
              [80.185240139229848, 15.494587640448064],
              [80.184697592159807, 15.494099802747826],
              [80.18383757989875, 15.492465765856847],
              [80.183960134835274, 15.490675302721],
              [80.184469483870203, 15.490033040832369],
              [80.186824750928565, 15.489462842998538],
              [80.187631281061556, 15.489458086419742],
              [80.194274255178129, 15.489842880870071],
              [80.196264328681821, 15.490751054125289],
              [80.197523213664567, 15.492013775431628],
              [80.200900855432451, 15.495401390854997],
              [80.20417209065613, 15.499830706545938],
              [80.208589280311401, 15.502422805103302],
              [80.210738398078547, 15.502429905358065],
              [80.21024699070955, 15.498747456387346],
              [80.210135329491663, 15.495066296768291],
              [80.205470837075893, 15.491000706707423],
              [80.202358661164908, 15.484681201145742],
              [80.201996894488957, 15.483050054945574],
              [80.201791828408545, 15.475944733558318],
              [80.198856225555119, 15.46759401536921],
              [80.198322306800435, 15.465654166296476],
              [80.197554694715052, 15.464947043142859],
              [80.197261828845171, 15.463803540001303],
              [80.196690943796796, 15.462530063664282],
              [80.190384348683608, 15.455572617408743],
              [80.189246270431397, 15.454270412524183],
              [80.187941123035898, 15.452983216274173],
              [80.18465895734164, 15.450120006735158],
              [80.184210246197836, 15.449659606339697],
              [80.178801728684164, 15.441895839406516],
              [80.176515029801294, 15.439059812194138],
              [80.1752691917128, 15.436255083165431],
              [80.172603058942912, 15.433861060581714],
              [80.171830572901058, 15.430642851726178],
              [80.171041306999712, 15.429910296987389],
              [80.170192862936062, 15.428507946652793],
              [80.169700240295583, 15.427123757290449],
              [80.168898817323509, 15.426160810785293],
              [80.166992483335264, 15.424174093200177],
              [80.16591582245411, 15.423059494454295],
              [80.161672107867446, 15.417866708866748],
              [80.160942441754457, 15.41646926612839],
              [80.158594385459821, 15.414321884544906],
              [80.157460173192248, 15.413826532733278],
              [80.157074168203053, 15.412216894388113],
              [80.156593065134018, 15.410602635092888],
              [80.154601239152555, 15.408450620841048],
              [80.153604280234958, 15.405888407920306],
              [80.150477311645318, 15.403239829549239],
              [80.149594802430443, 15.401604512937006],
              [80.147525101653116, 15.399148295269461],
              [80.146873967844385, 15.398908630714693],
              [80.146678513085874, 15.398160778377518],
              [80.142655054994179, 15.392863415554007],
              [80.134647039534912, 15.385425884953381],
              [80.130487063505996, 15.380466199440079],
              [80.126078241220625, 15.371831371228334],
              [80.125288057488319, 15.371122586049848],
              [80.124796424537237, 15.369714511436879],
              [80.122075643635014, 15.365728329999365],
              [80.121141840883581, 15.364619954348294],
              [80.120155580993696, 15.362288111391049],
              [80.119184875744679, 15.359681835914323],
              [80.1161551714697, 15.356577085962474],
              [80.114933005242051, 15.353818270801799],
              [80.111878726022155, 15.350298354358152],
              [80.11136233311737, 15.348912772819547],
              [80.109044679198632, 15.346235426197845],
              [80.106567114538677, 15.340441618036232],
              [80.102695920761789, 15.334137371094529],
              [80.09992508174787, 15.325908098177207],
              [80.099605393892659, 15.324831652428832],
              [80.098397614118198, 15.320069889667476],
              [80.097532611028214, 15.31599406392176],
              [80.097217869589258, 15.315240171507849],
              [80.095030556319045, 15.308493266140298],
              [80.094443982931296, 15.304500950364739],
              [80.091772108071268, 15.293212966048422],
              [80.091081611317804, 15.291126763429226],
              [80.08627757042774, 15.282262907496266],
              [80.083875783501753, 15.277830993097576],
              [80.080515585860212, 15.267015238221498],
              [80.079620829212047, 15.257430877026476],
              [80.080890387700606, 15.242983360928923],
              [80.081714417124715, 15.239201676438071],
              [80.082370778732411, 15.233314779116355],
              [80.084510582665587, 15.227988683400838],
              [80.08728602555567, 15.215875728665004],
              [80.087386258991785, 15.211895627388728],
              [80.087347912110602, 15.210442681527486],
              [80.085053038516321, 15.199634899180243],
              [80.083753177691278, 15.195282208089289],
              [80.081587444363663, 15.192452491613341],
              [80.080690964048301, 15.191969041197222],
              [80.079958060908154, 15.19236828632353],
              [80.078813695268764, 15.192078610526279],
              [80.071286474228145, 15.193302396219886],
              [80.067454261635362, 15.195362196552267],
              [80.067403729881278, 15.196281938318954],
              [80.066174252247436, 15.197116486304319],
              [80.063947867507238, 15.199259123943342],
              [80.062964770135011, 15.200337297646589],
              [80.06214329064295, 15.20234489067583],
              [80.059575382784487, 15.20382449971035],
              [80.05910707510958, 15.204583746224584],
              [80.051516818706261, 15.209512549041873],
              [80.051467688264665, 15.210408415632505],
              [80.048543520963278, 15.21274543487859],
              [80.047574764839283, 15.213132254342314],
              [80.043290523361406, 15.213509710041501],
              [80.034760129068786, 15.213159753297074],
              [80.031879710692294, 15.211697877915253],
              [80.030202605583781, 15.210758083672474],
              [80.030246392207005, 15.209102322360394],
              [80.031833357850871, 15.207825206618915],
              [80.032061673607927, 15.20712316060021],
              [80.040112766242828, 15.205443653013909],
              [80.041492796249202, 15.205745937854951],
              [80.043096266234045, 15.205437217090706],
              [80.043752811513912, 15.20509893737689],
              [80.050287904038782, 15.201731545618006],
              [80.05056267471133, 15.201055168047565],
              [80.053485384763974, 15.198718160872014],
              [80.05791256619483, 15.191459740590133],
              [80.059928232083621, 15.189698300420966],
              [80.060376345201234, 15.18928396037102],
              [80.061074717529948, 15.189089394754291],
              [80.062294031130591, 15.187147561896179],
              [80.062804644885261, 15.186046035057769],
              [80.072296763792508, 15.183126528779178],
              [80.073646266549531, 15.181836780172331],
              [80.073415172035823, 15.180005481708855],
              [80.072416343747875, 15.178801875741586],
              [80.070530280489379, 15.17305981166635],
              [80.067871545752155, 15.169305405923781],
              [80.066144940159063, 15.165829949663607],
              [80.064986502989598, 15.163650328976809],
              [80.062101072287362, 15.150255704926296],
              [80.061521807741372, 15.147023476744199],
              [80.060557902229334, 15.145614195081055],
              [80.059201969123478, 15.14142056508085],
              [80.059133643422285, 15.136647386180456],
              [80.058380065194171, 15.135710189458511],
              [80.05629828837516, 15.128806489804097],
              [80.055770296420803, 15.128088717632833],
              [80.055385373015326, 15.122171394110085],
              [80.053499336129164, 15.120737256109518],
              [80.052289768891171, 15.114777073727618],
              [80.051032598427071, 15.112661204752779],
              [80.051127871076233, 15.104488754737703],
              [80.050139450168444, 15.103100859034168],
              [80.048785227101632, 15.089876613320969],
              [80.048447981135894, 15.084837363678433],
              [80.047495807356029, 15.083221104802401],
              [80.047196061230693, 15.080487361187041],
              [80.046740659167654, 15.073713411560751],
              [80.046000096084754, 15.057526285996399],
              [80.045657611234674, 15.049583655589801],
              [80.048062968788884, 15.022247032673068],
              [80.048821350091544, 15.018358598686733],
              [80.050996236687354, 15.007217047833976],
              [80.053456902005962, 14.999926809097811],
              [80.054276924132978, 14.998770794059942],
              [80.05576981081623, 14.996589997763072],
              [80.056539635329159, 14.995501619987298],
              [80.057993045584055, 14.994447449580695],
              [80.05921265638375, 14.99335825827675],
              [80.061142429256677, 14.989680423315255],
              [80.063182178382704, 14.986997998209738],
              [80.064500612179131, 14.982389816705439],
              [80.065688787182523, 14.977129859859691],
              [80.066323781301492, 14.974627961235052],
              [80.06743893476937, 14.962498785658978],
              [80.073925437134619, 14.924960028280141],
              [80.078388812607443, 14.906990684504883],
              [80.083476039868174, 14.886679867109484],
              [80.084986198605463, 14.878118848271793],
              [80.085780541477448, 14.876132948250657],
              [80.085869513365481, 14.875377225321831],
              [80.088392196274413, 14.85654660527365],
              [80.093146249922086, 14.833201944555361],
              [80.093333756915285, 14.828050146731307],
              [80.093281428292414, 14.826849954312925],
              [80.091727588456081, 14.82543310858353],
              [80.090088813635361, 14.825579937844783],
              [80.088190270703763, 14.826148948759064],
              [80.087377443684943, 14.825877604790104],
              [80.085669382514197, 14.825121000367814],
              [80.085862173290423, 14.82245826157672],
              [80.088793486014708, 14.814270209480812],
              [80.075231058177224, 14.817141616414165],
              [80.074545969026985, 14.813695704437944],
              [80.07681201049985, 14.809021310374357],
              [80.08282215604504, 14.805023582890225],
              [80.086586937685922, 14.804065122105673],
              [80.087591568658695, 14.802988209190229],
              [80.089799793171437, 14.801074832530972],
              [80.090744817177665, 14.800662831976235],
              [80.095150974864907, 14.78796557568225],
              [80.095869614783851, 14.779594259818243],
              [80.102235208387924, 14.763473264780833],
              [80.102975850480618, 14.761161750168601],
              [80.107127945084073, 14.750263312110603],
              [80.108388212811747, 14.746465842225916],
              [80.110925952395746, 14.740237689403036],
              [80.111883554337851, 14.738282954821264],
              [80.112553085302181, 14.737718244551255],
              [80.114027477936872, 14.733209129803749],
              [80.116300569575515, 14.730975717926583],
              [80.117225112976826, 14.730055922764612],
              [80.117944596739846, 14.729424722909373],
              [80.118490127027087, 14.728093819474621],
              [80.120163395503937, 14.726452172433961],
              [80.121119144911916, 14.725810378139021],
              [80.121170312383242, 14.724891748395921],
              [80.12415349064571, 14.721750469410399],
              [80.125921651278531, 14.718800497326171],
              [80.126218925487194, 14.717663214485819],
              [80.13013970077435, 14.7138104287099],
              [80.13226056447877, 14.709150497377184],
              [80.13368707730308, 14.704224529163769],
              [80.133718313955626, 14.695402367291635],
              [80.130154781727924, 14.692731831474392],
              [80.129479251902808, 14.692558145396989],
              [80.12202139334488, 14.690239770494676],
              [80.120395610937862, 14.690156097619925],
              [80.12093921863891, 14.684517122391693],
              [80.121366600339798, 14.683179147485845],
              [80.124467730468837, 14.681772325537553],
              [80.127956629129471, 14.681491000107545],
              [80.129098009293386, 14.681779921635668],
              [80.133156423597939, 14.684476132915202],
              [80.136398030989653, 14.688721417484357],
              [80.137813614097809, 14.692664472176222],
              [80.139167499633231, 14.693838865006466],
              [80.141228199867328, 14.694175919104328],
              [80.142889947157698, 14.693593160940527],
              [80.144602693999445, 14.692090689108561],
              [80.145359140985079, 14.691208477351591],
              [80.145684076594137, 14.690465409963707],
              [80.14970432445142, 14.681271244792848],
              [80.152979070659512, 14.673629776569115],
              [80.154112462464639, 14.671038049176971],
              [80.159739421943073, 14.636193565810395],
              [80.164287391786274, 14.620760510673616],
              [80.166438169935475, 14.616378036755822],
              [80.167105394496957, 14.615837124262146],
              [80.171586106627672, 14.605951909789908],
              [80.174772648966325, 14.602958784062041],
              [80.175505036129493, 14.601199426428245],
              [80.176569214603376, 14.599871900155843],
              [80.177535933312527, 14.599460985295508],
              [80.181914008272713, 14.595814005507981],
              [80.183869237812019, 14.589809570804219],
              [80.183128755059613, 14.588665228159782],
              [80.181830832532455, 14.584728606826502],
              [80.18029152470973, 14.583060162661981],
              [80.172345707684428, 14.579359319682725],
              [80.170968197547325, 14.579057587906576],
              [80.167152933631144, 14.576697197378651],
              [80.164907869271872, 14.574992384235285],
              [80.163184184240151, 14.574558814403746],
              [80.160554533342065, 14.57384758521407],
              [80.150249292361138, 14.569314953015228],
              [80.147154482361429, 14.567953850586132],
              [80.139510116772897, 14.563506884598977],
              [80.138630742828923, 14.56230942645829],
              [80.137117127644103, 14.560181500823546],
              [80.134772072691362, 14.558148614837757],
              [80.127583440474041, 14.554000401963236],
              [80.125911703695863, 14.55303941189776],
              [80.123703499030739, 14.550668129529745],
              [80.122577989259298, 14.550067864025072],
              [80.118058631960594, 14.54765967437368],
              [80.107328352184936, 14.544388970587468],
              [80.102213146347708, 14.541199234816329],
              [80.09468994723585, 14.537148645166331],
              [80.09346811581031, 14.536187558214408],
              [80.093462871651639, 14.535686011237114],
              [80.093449065312939, 14.534365570184063],
              [80.102936828730037, 14.531837335485214],
              [80.108151145902184, 14.530608144335259],
              [80.110486941439262, 14.530198601796151],
              [80.115559627589164, 14.529837215278448],
              [80.115732806408516, 14.530998224042445],
              [80.116472447406579, 14.53128987083684],
              [80.12204318803623, 14.53650680615254],
              [80.123500885120336, 14.537479807448824],
              [80.128175362270952, 14.543134144642679],
              [80.1292113093333, 14.544478055171652],
              [80.130368085331156, 14.545781448606432],
              [80.135983673762212, 14.549755650525714],
              [80.139926150319525, 14.551939801811891],
              [80.142869729816823, 14.554694428534077],
              [80.143203038507352, 14.555517505537958],
              [80.145025587627686, 14.556302827430768],
              [80.14687305554196, 14.556627870995268],
              [80.153107069072234, 14.559227695164735],
              [80.155039583328971, 14.560179200230168],
              [80.162055061100489, 14.562345100492063],
              [80.170615956565712, 14.566675073850515],
              [80.17698670075373, 14.566697498387104],
              [80.184337612139814, 14.56624406755164],
              [80.188501347858846, 14.566975205927447],
              [80.192671951696411, 14.566035690045824],
              [80.194638539577795, 14.563892658264633],
              [80.194402949808591, 14.561741475353692],
              [80.193427033967112, 14.559593570111058],
              [80.19392345659918, 14.558161178125552],
              [80.190765086862029, 14.550272673595108],
              [80.188381462569225, 14.533073792883346],
              [80.186980450611259, 14.513729787952668],
              [80.181745676822402, 14.479780402168597],
              [80.179306656569111, 14.456909559100774],
              [80.179111963690559, 14.441415859691741],
              [80.177139372876127, 14.419521785550142],
              [80.174112231092295, 14.383485269444265],
              [80.172883605268453, 14.3742445261929],
              [80.173562318423649, 14.360387302764838],
              [80.173278812097351, 14.352072903556719],
              [80.172985342616471, 14.346526103512051],
              [80.168902665975054, 14.340047188094568],
              [80.165774100862507, 14.331723298008546],
              [80.162650204703311, 14.322468795987376],
              [80.158544370120239, 14.315024843453113],
              [80.15147941634109, 14.299376666012424],
              [80.148404435021916, 14.288953941935889],
              [80.146645204047843, 14.283736980945708],
              [80.145785649305083, 14.277228221967674],
              [80.144046938943973, 14.266801589867583],
              [80.144553206057708, 14.262012850498497],
              [80.14496337250074, 14.258126291828903],
              [80.145872305949069, 14.254229132858553],
              [80.144104057602078, 14.251617986907181],
              [80.140999663982882, 14.249002147250488],
              [80.137440910113696, 14.247255319586449],
              [80.132545733448808, 14.24809999083927],
              [80.126774831529815, 14.246776518446913],
              [80.124113444227419, 14.244169498601435],
              [80.123678257778238, 14.24242538580036],
              [80.125464467962843, 14.240266991565683],
              [80.127681145715826, 14.241137695225119],
              [80.131245721883545, 14.24115090430306],
              [80.136143020171346, 14.239874553800398],
              [80.137479508792467, 14.237273913716479],
              [80.135745649912678, 14.225544041523102],
              [80.132687060799526, 14.211211530838868],
              [80.130968544494806, 14.195582405815539],
              [80.128791865487983, 14.184299089641518],
              [80.128864476365834, 14.149028236759991],
              [80.129568413193908, 14.141099443602464],
              [80.130274610354263, 14.135823183659712],
              [80.133024905288607, 14.123936514685685],
              [80.137150550824231, 14.104136552703318],
              [80.139226891314877, 14.092259184575193],
              [80.140629348541495, 14.080367833503885],
              [80.145457132248339, 14.055947957931373],
              [80.148878080039708, 14.044062113212055],
              [80.152319068855888, 14.030207783340153],
              [80.15368532084176, 14.024263617778843],
              [80.152846212443137, 14.022568873143669],
              [80.15198529844065, 14.021806125537205],
              [80.148531158940045, 14.022046869235776],
              [80.145593470095832, 14.022542850958153],
              [80.144213942694535, 14.022032293445321],
              [80.143356324265824, 14.020512136601189],
              [80.144057880565128, 14.017479084337936],
              [80.147094441482636, 14.013693690059206],
              [80.148567438596615, 14.012179662386711],
              [80.150820447676551, 14.00991143438022],
              [80.153075440692874, 14.006883570821991],
              [80.156117897375907, 14.001581192928759],
              [80.158962525269828, 13.992969890900346],
              [80.164338127448559, 13.992988421294656],
              [80.164998331485208, 13.996933412812446],
              [80.165666265421635, 13.998906245013323],
              [80.167692424776419, 13.995297402309523],
              [80.169387619115128, 13.99234633071087],
              [80.174132575814667, 13.981527996713185],
              [80.179897569288926, 13.965790727926546],
              [80.184648201458685, 13.95300093104934],
              [80.187021074956021, 13.947428072434075],
              [80.188155055047559, 13.943591561690507],
              [80.18838008153034, 13.942830224820705],
              [80.188386748249741, 13.943032787548155],
              [80.190479185166112, 13.937986278950447],
              [80.193852166058946, 13.929149811212161],
              [80.198659054351651, 13.916839553184978],
              [80.200120953605222, 13.913296736190535],
              [80.205048913984569, 13.903112198557567],
              [80.205721128694961, 13.901556339994547],
              [80.205922992721753, 13.899977608552968],
              [80.206780601201672, 13.899352600513854],
              [80.215489371973717, 13.876204867203896],
              [80.216346365034042, 13.874267723871485],
              [80.21985093722526, 13.867764141853883],
              [80.221740651825883, 13.864566271841847],
              [80.223669521070292, 13.860217998801698],
              [80.224334050713196, 13.859675708775979],
              [80.225951319367994, 13.855426914983154],
              [80.230632783428518, 13.844951950893837],
              [80.232878625580213, 13.840389791370567],
              [80.236146083762264, 13.831686386494654],
              [80.237109376289254, 13.83083677636075],
              [80.238252211183521, 13.828844245569512],
              [80.238664769920774, 13.827735956343282],
              [80.239195783528089, 13.826174026876256],
              [80.24010084990033, 13.818063933148863],
              [80.239976166478129, 13.816007188502283],
              [80.238768498136835, 13.814816736493103],
              [80.238493878207862, 13.814550567759301],
              [80.237538803456857, 13.813624874146321],
              [80.237886380362283, 13.809333764770978],
              [80.238545530659792, 13.808008397140394],
              [80.244217392165979, 13.805809075187197],
              [80.244958480069158, 13.805155365867767],
              [80.24713312101153, 13.799713191706045],
              [80.247654163011475, 13.797459017762669],
              [80.249459399596731, 13.788358499057498],
              [80.249025798880155, 13.787667839319743],
              [80.248487209959706, 13.786742144689255],
              [80.248791905478981, 13.776205280619449],
              [80.248159143779219, 13.758594017982784],
              [80.247135716244884, 13.753542586555167],
              [80.246355932702954, 13.75096768189767],
              [80.245822262766637, 13.745112194218422],
              [80.243690892201982, 13.729567318282287],
              [80.241542059318988, 13.722245947346597],
              [80.239770129647866, 13.716233998776525],
              [80.239692980231439, 13.7132810487134],
              [80.236204519761941, 13.691446290447756],
              [80.235509984457849, 13.683347077818999],
              [80.23675182539813, 13.655762075561313],
              [80.238583715038999, 13.647032204701505],
              [80.239188514014529, 13.644090462398433],
              [80.240682657563525, 13.634628555936501],
              [80.241790499961269, 13.631066957076612],
              [80.244386279580965, 13.621222987438394],
              [80.244390986312851, 13.618942175838356],
              [80.253480337897827, 13.596273188126858],
              [80.256012115393219, 13.589812253311594],
              [80.256279565692466, 13.589227037594144],
              [80.25995294793654, 13.581188754158289],
              [80.260723450913304, 13.580858975818716],
              [80.261159442336179, 13.579291299573185],
              [80.262125772997024, 13.577497549129019],
              [80.26233000465794, 13.576747004504673],
              [80.264388871175584, 13.572980728695279],
              [80.265279506041168, 13.572588876481309],
              [80.26658374723587, 13.56972868262668],
              [80.269684217088752, 13.563126322569977],
              [80.269684217179289, 13.563126322621395],
              [80.271149743452398, 13.559961930705235],
              [80.272818061424871, 13.556889571252123],
              [80.284000010965542, 13.534117651038903],
              [80.288071154778848, 13.519025471654084],
              [80.29049122937694, 13.511983614518371],
              [80.292032001193505, 13.502476770978973],
              [80.29285611698981, 13.497588596799414],
              [80.295633947291179, 13.489111495025771],
              [80.30176191096065, 13.475552022087449],
              [80.303984720328486, 13.472186213644971],
              [80.30687792910868, 13.469498295656436],
              [80.31026089221902, 13.464647390400859],
              [80.312571201232501, 13.461861887282932],
              [80.317862518362759, 13.458258738049404],
              [80.318094497434544, 13.451680740366571],
              [80.314265050420445, 13.44989698390769],
              [80.310735500578275, 13.450870191197701],
              [80.311774364727668, 13.443688541122375],
              [80.312187641426902, 13.439446988556966],
              [80.312013222980866, 13.43609751356054],
              [80.310923770358229, 13.432286184283258],
              [80.304652361162624, 13.432682879465291],
              [80.298439143205613, 13.434648833208669],
              [80.294306025620472, 13.437250189517993],
              [80.291754438060551, 13.44016269009715],
              [80.287266397095209, 13.439704671380049],
              [80.285590896182626, 13.434550789377322],
              [80.283909673997741, 13.431262715932734],
              [80.280864605973065, 13.427951570657617],
              [80.284475930665494, 13.426798776887253],
              [80.29076794495208, 13.421173138980453],
              [80.292891111540811, 13.415705372765627],
              [80.291851091518026, 13.412726689991484],
              [80.287821655178902, 13.412522391163131],
              [80.288878984778151, 13.402806410166395],
              [80.292144068602525, 13.401037342948541],
              [80.295059916351406, 13.399226671935129],
              [80.306072281121828, 13.397135177316748],
              [80.309852373023631, 13.39497623926847],
              [80.314751095485235, 13.391652705572623],
              [80.320669587309808, 13.390893367515607],
              [80.325116845175472, 13.383146313703003],
              [80.328342501648137, 13.385221641831457],
              [80.327940963682423, 13.388357606784146],
              [80.328231897819705, 13.393487383895252],
              [80.327735299861203, 13.40551190427154],
              [80.327435647245238, 13.41293944860508],
              [80.325692556451642, 13.419647602420152],
              [80.32453193831995, 13.431777566381889],
              [80.324407310774433, 13.435457898128684],
              [80.32565598468787, 13.439828727849777],
              [80.329324431783562, 13.438447584987991],
              [80.329924898152981, 13.427119049633541],
              [80.333192881941159, 13.40892119305075],
              [80.332913660477445, 13.405773734002123],
              [80.332626491861092, 13.40232698259998],
              [80.334155524234689, 13.390769016399016],
              [80.337139321243853, 13.370390397621293],
              [80.340715973315994, 13.351361618161244],
              [80.346285563687275, 13.312450431353943],
              [80.34629406247825, 13.293399719407214],
              [80.34263028743824, 13.275270909563252],
              [80.341770907511517, 13.270929559645959],
              [80.340168496262905, 13.267685474257654],
              [80.338399705487575, 13.262895250797865],
              [80.334391241268591, 13.249715866069021],
              [80.332599480100257, 13.244948223596939],
              [80.329624363168023, 13.233810346549063],
              [80.322525401888413, 13.20722892685302],
              [80.318176387889096, 13.18971244946418],
              [80.316992015790404, 13.185206307597895],
              [80.315230662780792, 13.178065662380035],
              [80.310323171850456, 13.163929340352212],
              [80.307711942453054, 13.15187159371043],
              [80.303578954489979, 13.141430546848314],
              [80.299634163533909, 13.132742792195405],
              [80.297687768718191, 13.125461595260512],
              [80.297982180934952, 13.119107387926002],
              [80.300140213382363, 13.113697161502019],
              [80.300649005159642, 13.110754315430169],
              [80.301002111704904, 13.101682190563832],
              [80.30587149402497, 13.098793177609465],
              [80.305690488554305, 13.094713343500244],
              [80.301438154088515, 13.084454976121725],
              [80.298496502397668, 13.079903322381616],
              [80.293954049320405, 13.073949004381006],
              [80.291373641043862, 13.072166687410116],
              [80.289684646665819, 13.066870150476106],
              [80.287387700137742, 13.063201420114181],
              [80.285191161719013, 13.055455553716305],
              [80.282936930460792, 13.034348242879748],
              [80.280302780066222, 13.024339168786611],
              [80.278840341917089, 13.012525134595579],
              [80.275671198418181, 13.000482755324741],
              [80.27330469500582, 12.995016059749357],
              [80.27072562649667, 12.980907539957379],
              [80.26818237067819, 12.970890816120251],
              [80.266336777864979, 12.963619726287499],
              [80.265023117151372, 12.958395995445825],
              [80.26353608643646, 12.948608830991754],
              [80.260218009628758, 12.937254855850087],
              [80.258037100743536, 12.919763867402752],
              [80.255484484163489, 12.902061067260131],
              [80.253644640755155, 12.892453448399801],
              [80.251782684997934, 12.877501232717282],
              [80.251129898760297, 12.855890642132184],
              [80.25103645552926, 12.852793673801795],
              [80.250688254194216, 12.840302323139987],
              [80.246841469294111, 12.800557047245634],
              [80.247150163234451, 12.793303470399859],
              [80.252282517266934, 12.789728950017148],
              [80.254745194207587, 12.782571958807562],
              [80.254894626848923, 12.773198069418758],
              [80.253855636454503, 12.76684839616958],
              [80.245911414089051, 12.749744431411951],
              [80.244812019914278, 12.746112506397829],
              [80.241027657593932, 12.736687043421451],
              [80.236534463248347, 12.726054137749491],
              [80.231809035619108, 12.710119839804802],
              [80.230353408305945, 12.706921561632507],
              [80.228130488177626, 12.699865162818789],
              [80.224934217150007, 12.692105854331833],
              [80.223752856806797, 12.687759813889992],
              [80.222302725478926, 12.682463936364037],
              [80.219262441292017, 12.675259856888752],
              [80.218486901853254, 12.672070250748311],
              [80.216063036091953, 12.664343635773934],
              [80.207514910427776, 12.642229740707675],
              [80.203203122845864, 12.627197180835241],
              [80.200859534759005, 12.622189418918772],
              [80.196293527763942, 12.603536476739674],
              [80.19152910159336, 12.590825293552411],
              [80.190609341713056, 12.586250799508569],
              [80.189371845561809, 12.580981607925922],
              [80.187510596667352, 12.57167214249772],
              [80.183694663507907, 12.563212035729377],
              [80.182873978781785, 12.558225415553643],
              [80.17994716097067, 12.551596796135055],
              [80.175206302940424, 12.544069138732457],
              [80.170543885170858, 12.532648447664066],
              [80.163832111801909, 12.517145175573219],
              [80.162923941326923, 12.508423683768655],
              [80.163622879981048, 12.501958612172116],
              [80.164369285966487, 12.49537900288289],
              [80.163813724055828, 12.478206825298738],
              [80.16252224552936, 12.471783580478483],
              [80.159452422200673, 12.468770882997426],
              [80.151831008312641, 12.470051575987934],
              [80.150454718764678, 12.461415721563789],
              [80.145513469617285, 12.460013881783494],
              [80.141521664012842, 12.459338392347989],
              [80.140518939780577, 12.455822186714999],
              [80.143456464177603, 12.453212539060699],
              [80.146021774215797, 12.450481648358789],
              [80.148862269427099, 12.448146411318273],
              [80.143970674766251, 12.444878419638094],
              [80.138859345054186, 12.447367137341748],
              [80.134241530277166, 12.447950101686533],
              [80.131048815876809, 12.447055344069559],
              [80.132832568500774, 12.443369859919279],
              [80.134302894550558, 12.44032442165558],
              [80.138708293547936, 12.436535185283747],
              [80.138227705413215, 12.432428249518273],
              [80.131294657195639, 12.423048684998868],
              [80.128799727970602, 12.420757403472795],
              [80.12614538030725, 12.416574789989197],
              [80.123959628048652, 12.41396435963113],
              [80.122265886406225, 12.411361493381666],
              [80.114425744534316, 12.403329081588769],
              [80.112367286039387, 12.400097708978164],
              [80.108070895656297, 12.396191680310965],
              [80.104824214060486, 12.390940278354261],
              [80.096209700618104, 12.381538013634048],
              [80.086482399971246, 12.368247900142391],
              [80.082168250951753, 12.364088193295112],
              [80.080201120533957, 12.360996940821327],
              [80.07721070075489, 12.357453644507432],
              [80.067865077794877, 12.348684772512852],
              [80.062196953687589, 12.341186441982552],
              [80.056940640780027, 12.33427088214891],
              [80.054759244865636, 12.331453422303941],
              [80.051082105983795, 12.325364679316857],
              [80.049510727181584, 12.322486612145816],
              [80.045559033641538, 12.317570024032401],
              [80.04376788324285, 12.313673516351434],
              [80.039464709802829, 12.308867311090548],
              [80.038128235944669, 12.305898737846009],
              [80.035409197683975, 12.303142777260282],
              [80.033408350911344, 12.299243447238418],
              [80.029542722093552, 12.294903991977542],
              [80.025040343518469, 12.287790841633694],
              [80.01913841848787, 12.282039643112697],
              [80.015775078024802, 12.277015806994086],
              [80.014018160117928, 12.272428733336731],
              [80.010180368654972, 12.266245269476883],
              [80.008844477024837, 12.261710444746774],
              [80.004776902315072, 12.25589088662951],
              [80.000325416584516, 12.246382222707279],
              [79.994822421658313, 12.237456374289955],
              [79.992590938104314, 12.23495998046478],
              [79.990343714686389, 12.230387833249141],
              [79.967633493251583, 12.193313474777669],
              [79.96053343222043, 12.183464202650283],
              [79.955726133702143, 12.175100678263323],
              [79.953967450082857, 12.172333199798469],
              [79.949330229817619, 12.165170038259832],
              [79.948116709402868, 12.161949765447725],
              [79.938143892707174, 12.150492251752715],
              [79.937060809375637, 12.146397886235791],
              [79.933779851673293, 12.142271871428836],
              [79.929584371609721, 12.135321730548187],
              [79.918277162939219, 12.1179916417288],
              [79.914062186929584, 12.109312042490275],
              [79.90875535636728, 12.101722785530921],
              [79.905012984112915, 12.095769350839214],
              [79.90181703934563, 12.090791235054049],
              [79.898529486511563, 12.085742935514457],
              [79.894582886362656, 12.080985176516972],
              [79.891793146619918, 12.07543631780702],
              [79.88820625598062, 12.070060843019034],
              [79.885967427954299, 12.065189456100352],
              [79.882439302739442, 12.059076797286055],
              [79.878477937052182, 12.050723230374913],
              [79.875020239555695, 12.043277818334815],
              [79.872382971836728, 12.036784736154592],
              [79.868154248724849, 12.030690098593526],
              [79.86473437473461, 12.021973751918637],
              [79.861272781527063, 12.015172984984527],
              [79.859893151744728, 12.010307021127185],
              [79.857852193919911, 12.004552228463135],
              [79.856372866468618, 12.000737663640454],
              [79.853386944784134, 11.992812605898763],
              [79.84842264920951, 11.979972509218296],
              [79.845932854550512, 11.976317836533793],
              [79.84050019010499, 11.954560675468331],
              [79.83948350413192, 11.951270259119235],
              [79.834064297289643, 11.93384337709232],
              [79.828645129937257, 11.916428604616106],
              [79.823227535131494, 11.89900114931392],
              [79.817886142084404, 11.875796438187344],
              [79.814605210918415, 11.858413809616531],
              [79.81089709882194, 11.84438587594715],
              [79.809952611699728, 11.840812485508332],
              [79.808117175599818, 11.834064490283263],
              [79.797776205746672, 11.797452664267755],
              [79.795087912456168, 11.784826815448895],
              [79.794065568733103, 11.780023677884877],
              [79.79416549533309, 11.77366398173544],
              [79.793129283862925, 11.757792872729182],
              [79.790053706131872, 11.747075821359346],
              [79.786442035358945, 11.739301012662448],
              [79.781628648962055, 11.738168976495139],
              [79.776496488457468, 11.741086835120347],
              [79.770246042518778, 11.745302730204893],
              [79.766968910588645, 11.744469201508451],
              [79.767605973424182, 11.741067797048789],
              [79.771082880798645, 11.736580024512644],
              [79.77625009216986, 11.732970785217605],
              [79.780845216438806, 11.730137127188351],
              [79.784971945403356, 11.730406288672333],
              [79.7851562024629, 11.726099524338039],
              [79.783940609344043, 11.721771134120264],
              [79.781757058314582, 11.715169921513548],
              [79.778032547839416, 11.704235595374694],
              [79.776268127990889, 11.699207979265859],
              [79.771986985977023, 11.679184305620423],
              [79.76976369140425, 11.673711463088869],
              [79.767454552188426, 11.661853811139208],
              [79.766730932119302, 11.656012470752289],
              [79.764862287490217, 11.647295344874983],
              [79.763346352962643, 11.636924016068802],
              [79.761518371426817, 11.628621636577263],
              [79.759253613670069, 11.612546425919859],
              [79.758988049132114, 11.602794246814918],
              [79.758446659357389, 11.578056098399298],
              [79.759159517215849, 11.565744956715717],
              [79.759695844422922, 11.561042928986291],
              [79.760840521430083, 11.556520630805396],
              [79.763194382222423, 11.537496055469475],
              [79.765169311242644, 11.529136735049354],
              [79.767344014820168, 11.522832048577353],
              [79.770378029807105, 11.519697187767498],
              [79.773215118083058, 11.514301857266181],
              [79.776002618366391, 11.512062016969107],
              [79.777653961646365, 11.509367424886031],
              [79.778852934815433, 11.505744416346966],
              [79.782810070553808, 11.49582509338444],
              [79.784348474609928, 11.492672665338151],
              [79.790584527114348, 11.475983919507167],
              [79.79290001445203, 11.47399130853246],
              [79.795867880412615, 11.467652424436984],
              [79.799397387285609, 11.461160107787418],
              [79.801387137517068, 11.458226580506981],
              [79.803488782795171, 11.45449293554989],
              [79.806150733780342, 11.448310633551483],
              [79.810417356529982, 11.439317448999484],
              [79.814160467416116, 11.4206075117234],
              [79.814895051435428, 11.416937742715783],
              [79.816737207866169, 11.403575517458805],
              [79.818050319764495, 11.39859405934639],
              [79.824510049522303, 11.367163251004706],
              [79.824004469004194, 11.363744323409962],
              [79.815891994625872, 11.368392809971718],
              [79.812434027400741, 11.370391143025074],
              [79.808557365355199, 11.369410763857433],
              [79.802344747213496, 11.374983388908626],
              [79.798688902399107, 11.368592471012125],
              [79.802147022450285, 11.366594483893236],
              [79.810495834770691, 11.361742153913902],
              [79.814114158113853, 11.358386432552203],
              [79.813119155704669, 11.354983718893763],
              [79.812621142741165, 11.351104577797917],
              [79.811176805507401, 11.348131844300779],
              [79.809375104905797, 11.345615196497684],
              [79.812379090797023, 11.344301369312289],
              [79.81673242470346, 11.344597655146503],
              [79.819446766604173, 11.354179877579732],
              [79.822318680930209, 11.355330343956336],
              [79.82586258733194, 11.355244755796937],
              [79.831022991440648, 11.354585860264583],
              [79.835746383471701, 11.355025663040374],
              [79.839757892027237, 11.3533347176235],
              [79.840100912571842, 11.346310722051463],
              [79.835640743796247, 11.330594766978678],
              [79.83401906007731, 11.32397831695139],
              [79.83440928850284, 11.311009235759673],
              [79.835100949487568, 11.305557848300733],
              [79.835088602663404, 11.300417798557223],
              [79.837652366957911, 11.28252614496612],
              [79.845430310463016, 11.25148512140578],
              [79.846385603749752, 11.247073594782258],
              [79.852409163840974, 11.204505475577591],
              [79.853929216579985, 11.195217331555423],
              [79.857139942102947, 11.150808812944279],
              [79.858153409550425, 11.113844083276232],
              [79.858167078014887, 11.109109044097556],
              [79.857869694745759, 11.09092077751184],
              [79.857574610972506, 11.087528283181372],
              [79.854507212847793, 11.085660797651514],
              [79.854690903056394, 11.081353922397867],
              [79.857173270771867, 11.075952553251174],
              [79.857250481704938, 11.047352403365784],
              [79.856562753635828, 11.027406118995339],
              [79.8567955432611, 11.012659466394659],
              [79.852493464767761, 10.99466313814615],
              [79.852484521040324, 10.987941068631732],
              [79.852462447484555, 10.970049006452641],
              [79.85206636205821, 10.927221882118719],
              [79.85190277551348, 10.915488066989308],
              [79.851081623172249, 10.910035892855094],
              [79.844396834139488, 10.906061990102904],
              [79.848938482560385, 10.901383291523562],
              [79.848604359979305, 10.879806302390154],
              [79.844256636784792, 10.878172939755913],
              [79.837651468784941, 10.876504663936243],
              [79.835509295943154, 10.873729035323398],
              [79.83750552780198, 10.87103984567123],
              [79.843438442759521, 10.872490595535309],
              [79.847788596873187, 10.872556906526153],
              [79.84975708750909, 10.848087647777211],
              [79.848954850036279, 10.835629720446306],
              [79.849469383140601, 10.826968511203033],
              [79.849830793473785, 10.822921312687988],
              [79.84866098225281, 10.818893201624112],
              [79.846651341910828, 10.816557385015907],
              [79.840097024530195, 10.814728551522849],
              [79.835770524342095, 10.81325628361159],
              [79.836550781467054, 10.809557786265572],
              [79.842070869557674, 10.810563864734565],
              [79.845264155626666, 10.811603665277683],
              [79.848133946338166, 10.81254694819577],
              [79.850143717619275, 10.808982108566607],
              [79.850263225929694, 10.795570421173041],
              [79.850190533387163, 10.789899453468131],
              [79.851151539403688, 10.760091007688832],
              [79.850985247268753, 10.744139615915893],
              [79.850700704691903, 10.718114189251686],
              [79.851304328239593, 10.709388578451943],
              [79.852774741267055, 10.687078049159894],
              [79.853452649247345, 10.680958100156881],
              [79.85478453720836, 10.67763577437926],
              [79.8571972837196, 10.669214963845336],
              [79.857412736606733, 10.65269327176533],
              [79.858265818436593, 10.588702557534711],
              [79.858099577784756, 10.568510398212517],
              [79.859472118329393, 10.562538930827712],
              [79.859459399064093, 10.552507871200257],
              [79.860106604519586, 10.532886310210086],
              [79.860709576890969, 10.515471844075305],
              [79.861492553476523, 10.492597068597487],
              [79.8620205554558, 10.484192647494659],
              [79.86379575447009, 10.473410555264495],
              [79.864017707439913, 10.469726922161913],
              [79.865489822213121, 10.423999622175288],
              [79.865747370625712, 10.418056823613881],
              [79.866871423321001, 10.411620678738419],
              [79.867387144771399, 10.401164861060446],
              [79.86817001510623, 10.378267771206069],
              [79.870886902428765, 10.340487730428],
              [79.872382852691644, 10.332559193472548],
              [79.874430588033434, 10.322150259207694],
              [79.875506695908214, 10.314400454666195],
              [79.876456700163871, 10.311579935588314],
              [79.878111493431732, 10.305451481206877],
              [79.87895291011445, 10.299264502018408],
              [79.879328373355307, 10.290281673731265],
              [79.878702666020516, 10.287275900815771],
              [79.876232443490352, 10.285549392216801],
              [79.870628199344338, 10.285914661307849],
              [79.866015209814918, 10.286387642942067],
              [79.861055277461546, 10.284305647169948],
              [79.849213280845333, 10.281402054911345],
              [79.838479186597482, 10.280312709252941],
              [79.833919998056416, 10.279366041084598],
              [79.819530938111143, 10.277089431319329],
              [79.804554894563253, 10.27300566787879],
              [79.797770755874581, 10.271323910429837],
              [79.791489498770375, 10.272569111107916],
              [79.788487191350896, 10.275211569209855],
              [79.787104628643121, 10.27922461399687],
              [79.786000395660281, 10.286383666553871],
              [79.785621144790198, 10.289519988008324],
              [79.783928053737711, 10.292182906558974],
              [79.777951129234751, 10.295224688919873],
              [79.768956246863084, 10.301813220629928],
              [79.76294374555134, 10.307097672587378],
              [79.759263436862625, 10.310627973920656],
              [79.752215560043823, 10.312793102220278],
              [79.739154378469536, 10.316204171522129],
              [79.736626874320791, 10.320174537109899],
              [79.735150262893129, 10.323862243874711],
              [79.728640936685551, 10.329890300856135],
              [79.72408649748624, 10.328664710532225],
              [79.7188309169495, 10.329042568331998],
              [79.713429237414672, 10.331283926240646],
              [79.70760251495075, 10.33112176196841],
              [79.704110356446236, 10.328807479787626],
              [79.704023429195075, 10.325625208341922],
              [79.713597691869111, 10.321075721902027],
              [79.716944461941424, 10.319469270362301],
              [79.719188768378771, 10.31720029980149],
              [79.723806462987568, 10.310359479871192],
              [79.719271990414811, 10.310724741873758],
              [79.70901345653742, 10.311759750891882],
              [79.698707805380195, 10.314199432958237],
              [79.692626244292214, 10.316821904209966],
              [79.688135311123389, 10.318778114407413],
              [79.679125085456178, 10.324303943694524],
              [79.66263698603187, 10.329823876452666],
              [79.647665859197701, 10.334838364828077],
              [79.640449068466921, 10.337234289626577],
              [79.635948190094979, 10.33695379197237],
              [79.632769924628903, 10.335357267315745],
              [79.62836847239366, 10.331897769822545],
              [79.624458932584588, 10.32683267223895],
              [79.616285337540944, 10.323979355553648],
              [79.612190265007342, 10.321653873886058],
              [79.613385338288637, 10.318262108063172],
              [79.631497482264166, 10.315709764657138],
              [79.644762266242026, 10.315359755106595],
              [79.648396135615968, 10.316110062590084],
              [79.662633977412682, 10.311821699660049],
              [79.672962302269596, 10.31083602358928],
              [79.681008775874176, 10.307323084210548],
              [79.691765245807687, 10.30007384980054],
              [79.699951140083797, 10.295179745171513],
              [79.704782584395417, 10.293667264744888],
              [79.722828348693881, 10.289322584800919],
              [79.727017250009709, 10.288789712630919],
              [79.732474282364223, 10.291596360052782],
              [79.734694148141784, 10.2950431339909],
              [79.738061883754696, 10.297816347630727],
              [79.742383762269384, 10.299083637502296],
              [79.747431639011069, 10.29999395703296],
              [79.750241481114656, 10.291463575089008],
              [79.753711755074477, 10.287670899238163],
              [79.757317332947125, 10.288620280036087],
              [79.762596282634121, 10.287812025328746],
              [79.765584627243982, 10.286513526650586],
              [79.768246218699645, 10.28475855985014],
              [79.772619421618103, 10.282021846374741],
              [79.774960694391595, 10.277979041836421],
              [79.776378008210358, 10.275074382170803],
              [79.769354940841993, 10.272843195144215],
              [79.761507469518079, 10.273887055418772],
              [79.752823774024506, 10.275600634984238],
              [79.741532215272841, 10.277334547359336],
              [79.719873315990696, 10.279825093138953],
              [79.706321252127239, 10.283480434840845],
              [79.696927924761027, 10.28420602730861],
              [79.692683869934058, 10.285267446386651],
              [79.689513632511208, 10.285954319689813],
              [79.67987230665338, 10.289048984396921],
              [79.674532167898789, 10.29036895494227],
              [79.665504817520059, 10.291445512068451],
              [79.656848671618562, 10.289692530913214],
              [79.651802644769191, 10.290071845905274],
              [79.647601319711654, 10.291387183355722],
              [79.640061546138611, 10.293731327180812],
              [79.635462594018406, 10.295178209655083],
              [79.632672046704002, 10.29674644104453],
              [79.627695741671843, 10.29853273051325],
              [79.624449098432976, 10.299678899223208],
              [79.616634326936293, 10.301764445918645],
              [79.611376687231839, 10.302300838120765],
              [79.594424394290158, 10.305044443666711],
              [79.578854667653474, 10.305665618172995],
              [79.563949949328958, 10.308141079391749],
              [79.55254984222374, 10.307953834124124],
              [79.547655016950756, 10.306889495273383],
              [79.544732789389869, 10.308597918169097],
              [79.546895499363657, 10.313890462838893],
              [79.55006249900029, 10.317013675666358],
              [79.552567869991151, 10.320997921296206],
              [79.554388738572897, 10.327599593130735],
              [79.561406248024454, 10.331221723182429],
              [79.565463697844038, 10.331194201640491],
              [79.576416667642974, 10.328999821573229],
              [79.587739334462654, 10.328263134642564],
              [79.597924316491302, 10.3275528873819],
              [79.611151019988299, 10.329566489302982],
              [79.614785098904136, 10.334489458071127],
              [79.613061881561251, 10.338887523883288],
              [79.60979611566087, 10.342475823027545],
              [79.600115528513456, 10.347781304296513],
              [79.59181104856772, 10.344395364212703],
              [79.587491870916793, 10.342965189794365],
              [79.581902889901116, 10.342458731111071],
              [79.549541157654801, 10.349208902180191],
              [79.546779233300228, 10.35096416764716],
              [79.537247340800647, 10.354219087366264],
              [79.532762987116129, 10.355735688945698],
              [79.52696906074523, 10.354948718293461],
              [79.529454276727279, 10.350863487964277],
              [79.531751724344176, 10.348227392742311],
              [79.537861228913926, 10.341389432686432],
              [79.530835941392681, 10.343394050333224],
              [79.52698796420708, 10.344299005811672],
              [79.523223292873212, 10.345804198579579],
              [79.519410152684287, 10.347355000208992],
              [79.507642345647852, 10.353683425332585],
              [79.504051260576503, 10.353944607465415],
              [79.503834181620775, 10.350946274676863],
              [79.507297784567967, 10.348052879492965],
              [79.510951395317434, 10.346246702828642],
              [79.527564934015047, 10.339099131798648],
              [79.53309422143947, 10.33623945522052],
              [79.537258400589621, 10.333127201326631],
              [79.53783037439446, 10.32677460659451],
              [79.535815024638623, 10.323790381346221],
              [79.528253348985672, 10.317764571514992],
              [79.522723154481426, 10.31382317672119],
              [79.51932207176371, 10.311738166667483],
              [79.514303114508891, 10.311862504992352],
              [79.50254005606952, 10.313903726915779],
              [79.493190290532851, 10.31605270215109],
              [79.481748391093987, 10.31701520330691],
              [79.473399611768016, 10.318829628973523],
              [79.464310420358643, 10.320804206304741],
              [79.453072464578497, 10.321975526774887],
              [79.447795257166305, 10.323685327956849],
              [79.438649651560269, 10.324684460514973],
              [79.422869417128894, 10.324634442407515],
              [79.401605558623856, 10.324751217052848],
              [79.395515784581718, 10.323656371123329],
              [79.38793500442894, 10.321568353020494],
              [79.382967042910565, 10.318763784470656],
              [79.377456354880934, 10.313875042761707],
              [79.373535010211199, 10.307054253636107],
              [79.367765732325921, 10.299648219636122],
              [79.364821560206991, 10.298030023936313],
              [79.359097825428009, 10.298670130261653],
              [79.353325852145005, 10.300715825856035],
              [79.349006290350943, 10.302001754465923],
              [79.353159681150061, 10.29031590408383],
              [79.345878827809827, 10.289730055291264],
              [79.342585759245054, 10.289451609646921],
              [79.329130086878081, 10.286054422509467],
              [79.324850143687826, 10.282569269728729],
              [79.322442375280289, 10.276879602847888],
              [79.317506689391976, 10.271780342797664],
              [79.30956367288556, 10.269834156556676],
              [79.305462942366077, 10.267964855834233],
              [79.298999001165186, 10.264431039399971],
              [79.298780265404744, 10.261461369281465],
              [79.296070216781686, 10.256898325339266],
              [79.292494172030985, 10.252987023519324],
              [79.281544429119492, 10.244613642258786],
              [79.277077615383675, 10.239925009802903],
              [79.272820161468374, 10.232589603034123],
              [79.271937969586375, 10.226072937316205],
              [79.274489260716223, 10.223627036146897],
              [79.277877488961764, 10.219812709605813],
              [79.277983515838983, 10.213913359251491],
              [79.276097671061763, 10.210284032067058],
              [79.270261885487344, 10.204258094022746],
              [79.267627930996198, 10.19967006567275],
              [79.261523374357509, 10.193888799525476],
              [79.258822367561223, 10.192278190147428],
              [79.254058096892308, 10.191272772550603],
              [79.250199097491247, 10.18894639940561],
              [79.248651099608466, 10.185968064952721],
              [79.242404218283809, 10.178297744616364],
              [79.240170984080677, 10.174685229095425],
              [79.238480066465499, 10.168085197980636],
              [79.238704947863255, 10.161979792254527],
              [79.233448169627849, 10.154833322007287],
              [79.231705252773253, 10.149799982370778],
              [79.22882103814635, 10.144999993239207],
              [79.228856757675672, 10.140238479381168],
              [79.228901784210976, 10.134096637902951],
              [79.23253369144993, 10.129641817268718],
              [79.233094881332093, 10.12421119861016],
              [79.231775177431132, 10.121467026281403],
              [79.228047410067234, 10.113217831477225],
              [79.226383412801951, 10.103851062171868],
              [79.226911835536853, 10.092563845249437],
              [79.229820126904698, 10.085721608700721],
              [79.232668563811998, 10.078348409249738],
              [79.240854708594867, 10.073511880013521],
              [79.245014297925835, 10.070633752669291],
              [79.245609594256493, 10.063381762518263],
              [79.250917651626622, 10.059855349173016],
              [79.251329286036807, 10.04985720372243],
              [79.25405331076081, 10.048083320291074],
              [79.261702928715692, 10.044597469580239],
              [79.262428561777554, 10.041659161598112],
              [79.263409520407322, 10.038725240944787],
              [79.250571660830147, 10.028749497401577],
              [79.245172171885983, 10.024481442127801],
              [79.241900716267935, 10.021888787471765],
              [79.233105814721625, 10.015509182697146],
              [79.227768094366937, 10.010458955817136],
              [79.224540505142073, 10.008193384850715],
              [79.220311855189394, 10.004734388679324],
              [79.218050328202622, 10.00254192926824],
              [79.217676678767248, 9.997532645916385],
              [79.213126085604159, 9.991319965282619],
              [79.208057534938675, 9.980348592390104],
              [79.201352135122804, 9.972737408862532],
              [79.199565899283414, 9.968855429765249],
              [79.195000120486668, 9.963541794033231],
              [79.1942627650037, 9.960264579208228],
              [79.190683507252331, 9.958662498661189],
              [79.186203751495555, 9.95673735851806],
              [79.182721399802418, 9.954932089824302],
              [79.172117541084475, 9.947412564716577],
              [79.168417849908167, 9.944257838045901],
              [79.163389415802456, 9.937574534466725],
              [79.157349747477411, 9.930435433219328],
              [79.155005119712555, 9.924168627969541],
              [79.152183306231933, 9.914896215650732],
              [79.151005560762059, 9.910794370019079],
              [79.147951972164023, 9.907812048189856],
              [79.143923569154353, 9.903636215438713],
              [79.125482533354571, 9.888551173376626],
              [79.120828824297803, 9.880536472832047],
              [79.120594905859889, 9.868059328394885],
              [79.122503502438477, 9.865119223726634],
              [79.123078451310491, 9.857867108718304],
              [79.120454392972988, 9.851710605635649],
              [79.117649210369976, 9.849146942898564],
              [79.114047267913151, 9.846199366311597],
              [79.105175683094146, 9.838939775825859],
              [79.101405057053114, 9.833431006281598],
              [79.094655112700977, 9.827222821534088],
              [79.090392314105188, 9.823272531992876],
              [79.087492211859768, 9.819577319868205],
              [79.080970107610085, 9.811113304237836],
              [79.077580361395377, 9.800100584487977],
              [79.07453062600392, 9.793244268179119],
              [79.068936006226508, 9.786110647556798],
              [79.066586939837066, 9.784015960437292],
              [79.062269167021185, 9.778058490976088],
              [79.057083902489111, 9.773883528039384],
              [79.045124172053562, 9.766150296184293],
              [79.037253347929806, 9.760565523556211],
              [79.028713682281833, 9.75224803131144],
              [79.026421679661865, 9.749646720247968],
              [79.025080837911645, 9.744439313396986],
              [79.01771876990577, 9.737729501096194],
              [79.014145890485082, 9.732914483481986],
              [79.011190651068787, 9.72981696740155],
              [78.991601451571896, 9.71253448231311],
              [78.989338522736531, 9.709587901795816],
              [78.987551342900517, 9.707226428603073],
              [78.98484524333729, 9.701988865187188],
              [78.982753214542825, 9.697408199728866],
              [78.977095198689881, 9.682755717826522],
              [78.975753848974023, 9.676436800684309],
              [78.974231040868375, 9.665018153177007],
              [78.970665710201189, 9.661102290228575],
              [78.967177416664839, 9.651930679654617],
              [78.965861830166048, 9.649185294730827],
              [78.960921910814918, 9.639571926704765],
              [78.95843856138778, 9.634822626231596],
              [78.957202942607125, 9.631525471429748],
              [78.955713771182801, 9.628178178836494],
              [78.951241863171134, 9.620786215507785],
              [78.948690853170177, 9.615966313604011],
              [78.94407969433442, 9.611061866598515],
              [78.941325457920499, 9.607206607628934],
              [78.93808696812934, 9.604426159773217],
              [78.935864028605991, 9.601894592956754],
              [78.932161740964901, 9.597975216439451],
              [78.9308788686252, 9.594769547263102],
              [78.925245729684661, 9.586341810410259],
              [78.924538453225296, 9.583307477292662],
              [78.923002647346962, 9.57875972443018],
              [78.920316670076687, 9.572577024982285],
              [78.9187773611891, 9.564570608714236],
              [78.919623622178591, 9.54814625287],
              [78.919064161851779, 9.543478877871056],
              [78.918743981319651, 9.53521257942926],
              [78.918598108806748, 9.531457137784312],
              [78.916422899519048, 9.520395436131176],
              [78.915828940980106, 9.5138817448829],
              [78.915136653778546, 9.510041540302435],
              [78.915452496087994, 9.499602751167757],
              [78.907634120907971, 9.496528681534278],
              [78.901464012955373, 9.492101997253066],
              [78.897980382978233, 9.488854929188177],
              [78.894540469427966, 9.478576348473137],
              [78.895346985734747, 9.471558427244501],
              [78.898879249593875, 9.46005006644865],
              [78.900426098330811, 9.456689262032004],
              [78.903210859984796, 9.453997541238179],
              [78.906021716518595, 9.449968687275309],
              [78.908908563709829, 9.445549819839126],
              [78.910419995004901, 9.442857165470723],
              [78.913798632737567, 9.436948289330065],
              [78.918930950729191, 9.431372023565991],
              [78.921291526151251, 9.426642929838874],
              [78.927651889095017, 9.419844015862685],
              [78.929251490405079, 9.417360647076666],
              [78.937350508255861, 9.409233825929963],
              [78.941791453589019, 9.403436358346324],
              [78.944562828671067, 9.400190567051204],
              [78.94783914507228, 9.397208135824101],
              [78.950624072228209, 9.394515649523701],
              [78.953250699187265, 9.391544341764726],
              [78.957439618564237, 9.388070830985196],
              [78.961907500028559, 9.383243031168227],
              [78.963887071558503, 9.380258935931973],
              [78.969240864080234, 9.375123821492904],
              [78.974606143680944, 9.368190847073587],
              [78.976954171355175, 9.365259870652141],
              [78.979259980534721, 9.362143673591355],
              [78.986384936960931, 9.356395345130672],
              [78.993409334127719, 9.349907992454705],
              [79.015175984191799, 9.33149388510193],
              [79.016388913986859, 9.328565099349591],
              [79.019158669880582, 9.326563720497752],
              [79.021701188802041, 9.324350906149899],
              [79.026340241575554, 9.320263211519949],
              [79.030703235328843, 9.316560009615463],
              [79.033727131634407, 9.315279688204969],
              [79.043138663207955, 9.307313174115185],
              [79.05179808732224, 9.299932086386193],
              [79.054627041442018, 9.298485435308564],
              [79.060020623106311, 9.296070634894097],
              [79.063287397019309, 9.294701035947933],
              [79.069270617695665, 9.294233475565653],
              [79.073302078914168, 9.295321812298825],
              [79.078044563940495, 9.296768095671526],
              [79.084885002143125, 9.296224279675814],
              [79.09571743547086, 9.290172603056053],
              [79.101430685250605, 9.289262088388023],
              [79.110093249709152, 9.290341746440944],
              [79.120971404652266, 9.293028752913662],
              [79.12874792112224, 9.290679319179297],
              [79.147713404212354, 9.288070298769103],
              [79.153240723637097, 9.285887066452824],
              [79.156642483582047, 9.285948607467452],
              [79.160720746669881, 9.288295563306891],
              [79.170140966962663, 9.288450338572865],
              [79.176078815692023, 9.287911506643182],
              [79.184063782409353, 9.287542627170421],
              [79.191653240171277, 9.285815931301247],
              [79.188270516869466, 9.280890748553487],
              [79.184240308047251, 9.277932009656897],
              [79.180258881473534, 9.278418496478048],
              [79.174392266250479, 9.277621682527769],
              [79.160943723995501, 9.276197351401365],
              [79.1495530630486, 9.274915299060579],
              [79.12938763139249, 9.268648969242763],
              [79.096269890153522, 9.260463276734566],
              [79.082402709886892, 9.259173162301376],
              [79.067081624313076, 9.261406875643662],
              [79.055591868608872, 9.261773424979015],
              [79.049655090741865, 9.26228706328966],
              [79.040818763778617, 9.264316088791873],
              [79.031245683437959, 9.265507323675871],
              [79.016150705005188, 9.268658801431066],
              [78.999184548400592, 9.273326343073446],
              [78.987758940261571, 9.27514494854654],
              [78.984596640597374, 9.274624929862807],
              [78.968399519048575, 9.274117690442438],
              [78.96203685603696, 9.273907831890249],
              [78.94181653466579, 9.270672605975005],
              [78.92620063512274, 9.265171002871769],
              [78.915140446802013, 9.258808340148461],
              [78.912513302377789, 9.253317762238169],
              [78.908512643025588, 9.249415792052629],
              [78.904878896258694, 9.248194272585163],
              [78.893541035951102, 9.250241473102754],
              [78.884706416430888, 9.254641325544309],
              [78.877585078758699, 9.256537028930556],
              [78.869649475299397, 9.255027165883449],
              [78.856491607231845, 9.251828465292313],
              [78.852212462474142, 9.249234054978578],
              [78.846520775099776, 9.247881589341358],
              [78.814844535761083, 9.237436680455831],
              [78.809503501281085, 9.23503497900227],
              [78.805162515250927, 9.232895124898164],
              [78.794506352378306, 9.228518534773553],
              [78.776647735632991, 9.22193005128773],
              [78.765183616404315, 9.218598148214227],
              [78.760084550941031, 9.216586553098155],
              [78.744251182027241, 9.211562199000419],
              [78.741311507263461, 9.210600971303935],
              [78.730297547693098, 9.209669184449082],
              [78.727214650989637, 9.209408265900883],
              [78.722932094345509, 9.207065919693127],
              [78.721623701549092, 9.202959708989633],
              [78.722247764203601, 9.188882970354888],
              [78.706954869302763, 9.190871199305432],
              [78.694032406845594, 9.194800844295342],
              [78.685951294476709, 9.195340044742547],
              [78.676895730829273, 9.19446943454839],
              [78.672880253680333, 9.193706564838468],
              [78.668216473319248, 9.191482682034325],
              [78.657694661279209, 9.18742777252017],
              [78.651876316889087, 9.18323324041987],
              [78.649902549813163, 9.178859853706228],
              [78.645651885899852, 9.174949495623144],
              [78.645111556157431, 9.167214502231323],
              [78.64934664672252, 9.161393695315986],
              [78.651579227713427, 9.157378485193743],
              [78.649917047645928, 9.15483284214354],
              [78.643976453878878, 9.155616522492071],
              [78.639977451191911, 9.157683278710188],
              [78.630303508130936, 9.156480348257777],
              [78.626001955816434, 9.155151354698976],
              [78.620435088194284, 9.153382442900087],
              [78.611062311703463, 9.151031837037644],
              [78.600162913163643, 9.147498297949985],
              [78.58553761887616, 9.139256325374227],
              [78.58209704028242, 9.136558384553782],
              [78.580298823056751, 9.13394187188611],
              [78.575382579863216, 9.128634013661664],
              [78.568761909936399, 9.128735065351355],
              [78.560637710933037, 9.131064952390302],
              [78.556968821698618, 9.132791185704631],
              [78.548932206683787, 9.13537705013797],
              [78.532299718071528, 9.136155885614246],
              [78.528204560479779, 9.13607462053259],
              [78.511255657842, 9.133225401098757],
              [78.491432399183012, 9.129027378035689],
              [78.484094836562008, 9.131371824251625],
              [78.477283845375226, 9.130544232006979],
              [78.474151072409143, 9.127530494471698],
              [78.466026964616219, 9.124186457006608],
              [78.450771682250689, 9.121610019136657],
              [78.43540225911903, 9.117670867412013],
              [78.422275899797555, 9.113349251269907],
              [78.397734954792114, 9.098974855255172],
              [78.391261062736547, 9.093815225798041],
              [78.383482564086819, 9.088932341675216],
              [78.378888465973773, 9.086141903778126],
              [78.372779497469651, 9.081636537711805],
              [78.37005422096739, 9.080267333881121],
              [78.360701893338884, 9.072584218776401],
              [78.356191647453016, 9.070232771537484],
              [78.3475614165705, 9.06461568402354],
              [78.343927718258058, 9.057947254522984],
              [78.340627721368008, 9.055274080634083],
              [78.335852349024279, 9.052364116991537],
              [78.330915125761052, 9.049426961245494],
              [78.321257693435385, 9.044073875049593],
              [78.313063302126224, 9.040218735160304],
              [78.30913884783287, 9.038663401176459],
              [78.307777816820774, 9.03494400482861],
              [78.307676460165226, 9.031254134149197],
              [78.305235357855423, 9.027512261189743],
              [78.301653041416401, 9.026702023893767],
              [78.298055770121707, 9.026628732579773],
              [78.296491009502645, 9.024135719721578],
              [78.293301203706832, 9.02185736195147],
              [78.290227476494664, 9.022148420912666],
              [78.28610941877406, 9.024324201622347],
              [78.282049384154121, 9.021520195035976],
              [78.278806094567727, 9.013959536130988],
              [78.274779467985582, 9.010717901039708],
              [78.270856601396474, 9.012435859647898],
              [78.268976684088145, 9.014888029511349],
              [78.266865216918745, 9.01848817707562],
              [78.263602863571521, 9.021810903512407],
              [78.261492146729324, 9.02428098036895],
              [78.258928153455926, 9.026281121939071],
              [78.244806604708202, 9.033254702355816],
              [78.239190525457872, 9.03516864283983],
              [78.233681403956993, 9.031445878862344],
              [78.239517743279393, 9.030632663858034],
              [78.244911450299327, 9.028298956875611],
              [78.258211335054028, 9.018541054551944],
              [78.261228217236706, 9.015881925266692],
              [78.263236527567358, 9.012787317668916],
              [78.265445787445927, 9.010065037269744],
              [78.267153976423785, 9.006940793659554],
              [78.268095485985882, 9.002855445491136],
              [78.266907962088638, 8.999879225601751],
              [78.26418400998314, 8.997379560628266],
              [78.258950595643626, 8.994274301019448],
              [78.255136975628673, 8.990783656937834],
              [78.245807546670036, 8.985587534776549],
              [78.237369064112713, 8.98087132191149],
              [78.221238452684815, 8.969077907825136],
              [78.216983843398765, 8.965692482550693],
              [78.212489896447494, 8.961541037884643],
              [78.209654650712125, 8.956708956551234],
              [78.206507461399951, 8.953461745395863],
              [78.203574743492254, 8.947728748432773],
              [78.199678307592549, 8.941269055812539],
              [78.198300858834813, 8.937842382261953],
              [78.19508465538982, 8.933486482039381],
              [78.193358106409107, 8.929830247567384],
              [78.189983000001973, 8.923165090576429],
              [78.186945837239492, 8.915838396164098],
              [78.184799487962422, 8.903525885277693],
              [78.18300628703841, 8.896455102821953],
              [78.176759880746275, 8.889503548689818],
              [78.175578541531991, 8.886777317886805],
              [78.172107149041707, 8.880341130047224],
              [78.172724056357367, 8.871960233195585],
              [78.168929404130992, 8.846907026272255],
              [78.168793843199609, 8.841043611396513],
              [78.168567625921341, 8.831241854454875],
              [78.167859812167009, 8.824216921515513],
              [78.164843354340675, 8.793046010470484],
              [78.166155958156537, 8.77476358762879],
              [78.16540017233082, 8.761280168355173],
              [78.165347659007097, 8.758327946264549],
              [78.168767866632834, 8.758398798928068],
              [78.171210356676454, 8.760963234515785],
              [78.172261726156577, 8.764836215958113],
              [78.175329110004, 8.766306499321866],
              [78.179016520976916, 8.763569412519498],
              [78.182027386290358, 8.762921832654996],
              [78.189039298662635, 8.761955689028108],
              [78.192569638450252, 8.762305289692891],
              [78.198196720860835, 8.765143211867807],
              [78.198174138624267, 8.771714695747093],
              [78.196165366176615, 8.774855205275728],
              [78.195993141963044, 8.783014950391602],
              [78.197784203728787, 8.785796276300712],
              [78.200456003885861, 8.78741989524994],
              [78.202254992925432, 8.783217571899236],
              [78.203929517499617, 8.78037994482947],
              [78.204173786952254, 8.776408522531668],
              [78.205669143089949, 8.772653460869259],
              [78.205808608459137, 8.768206308193315],
              [78.205056373716317, 8.765165634926319],
              [78.196744745317886, 8.747402590939986],
              [78.193862583829286, 8.744852565535814],
              [78.189757367308857, 8.745435789273523],
              [78.188482585745135, 8.751082680066919],
              [78.185047094692777, 8.75170331550386],
              [78.169870340750208, 8.743432853429113],
              [78.164078155638563, 8.731989342588685],
              [78.162786933973877, 8.728549899349622],
              [78.159857908900506, 8.71622133230745],
              [78.157006413084048, 8.710476973165605],
              [78.152168598199026, 8.70489987064326],
              [78.145742394847133, 8.700499948756645],
              [78.141026924372397, 8.692907396567783],
              [78.140348852000542, 8.689964054990551],
              [78.138855277588618, 8.676511579305236],
              [78.135433994733617, 8.666685887718991],
              [78.132790761703561, 8.655698323861508],
              [78.131759437488455, 8.651413072964692],
              [78.129828304816215, 8.646599301090676],
              [78.127794333078739, 8.641137356590461],
              [78.126303606287024, 8.635179726578532],
              [78.126920312822563, 8.627928426671499],
              [78.128417078429322, 8.622724985026847],
              [78.132010847364057, 8.613506927440925],
              [78.1335483767282, 8.610748717700904],
              [78.135497392153511, 8.604954953512198],
              [78.137259595724387, 8.60252421477445],
              [78.14180721160615, 8.590766118127545],
              [78.141733412961202, 8.584422697663051],
              [78.139080934494686, 8.574382074664143],
              [78.138543801212109, 8.566020676341358],
              [78.134820517034001, 8.552767963330302],
              [78.128597093001929, 8.543850562077187],
              [78.124743009209453, 8.536074636788186],
              [78.124085578858057, 8.529472956563882],
              [78.124813329518503, 8.523697544064166],
              [78.126990048559293, 8.512627740219104],
              [78.129812967935052, 8.50588379384393],
              [78.133085889219885, 8.498665335279965],
              [78.132989132993828, 8.49232165863978],
              [78.13106850536893, 8.48704631471796],
              [78.12907544457444, 8.484076303461881],
              [78.117253066641311, 8.472875367273756],
              [78.105445539460902, 8.463179545879505],
              [78.097637504703826, 8.453134996789764],
              [78.085100728058123, 8.439681396768821],
              [78.080450708759159, 8.431904089842819],
              [78.07651958324557, 8.428528138200933],
              [78.071073426327786, 8.420718237916494],
              [78.067150037521969, 8.416248643647899],
              [78.064923364428296, 8.408506127695119],
              [78.062055313443366, 8.391978408129127],
              [78.060579305193684, 8.386451978362608],
              [78.059899488241086, 8.380942841495852],
              [78.065603972449409, 8.376677297387795],
              [78.068041546454765, 8.374527385269159],
              [78.06731546275104, 8.371218250692532],
              [78.063338479666839, 8.370026336029731],
              [78.053031482195891, 8.36433051769243],
              [78.042164750081525, 8.358786380543137],
              [78.010985551401859, 8.34777969579237],
              [77.992102202847533, 8.341146468096712],
              [77.987319273449089, 8.340145482893032],
              [77.976741919323118, 8.335839084359819],
              [77.969753949413686, 8.33004098003088],
              [77.962440629099987, 8.32326685728723],
              [77.959472966146805, 8.31956018854323],
              [77.957517090799854, 8.317096947900517],
              [77.954287485301748, 8.312647078534335],
              [77.947828185699976, 8.305936597499871],
              [77.939962817059197, 8.301225812806573],
              [77.922166206438703, 8.29448101163975],
              [77.915017329260934, 8.292170082218863],
              [77.909526581589688, 8.290590144159873],
              [77.903149610745245, 8.28544911735103],
              [77.900715244633034, 8.282675768353803],
              [77.895324934932347, 8.275734468293912],
              [77.890171232977039, 8.270642571368461],
              [77.884793365930904, 8.267344874695075],
              [77.869514071280634, 8.260674753193397],
              [77.862930506412908, 8.258925046726331],
              [77.837657438609071, 8.251801604958052],
              [77.822135732398891, 8.248414600536551],
              [77.81441323653489, 8.24611758536801],
              [77.80981885394479, 8.243171848345462],
              [77.798627522774794, 8.233692754502993],
              [77.786878597124399, 8.225625141896101],
              [77.785478793797978, 8.221176981716679],
              [77.783835433082132, 8.218189666619935],
              [77.784767257223834, 8.213620497698034],
              [77.787351136929331, 8.208510906605957],
              [77.786895081895537, 8.203036260502033],
              [77.783892050229056, 8.199926959247144],
              [77.780895666979987, 8.196563827553922],
              [77.775543221079602, 8.193265359713687],
              [77.765758805235919, 8.192571926823867],
              [77.758710353696344, 8.188148270358045],
              [77.755531683404641, 8.182613968178005],
              [77.753129760295892, 8.178480250146182],
              [77.742361198739616, 8.171650075668284],
              [77.734246640750555, 8.167639162822137],
              [77.716181233790365, 8.165404553479302],
              [77.687001946470772, 8.158639909971129],
              [77.672959745776893, 8.156292990836656],
              [77.662939048612699, 8.15651606868682],
              [77.655397830024967, 8.159088696191517],
              [77.646411406663944, 8.157211731710033],
              [77.641039987490629, 8.154921119334992],
              [77.634889026641048, 8.15227171179864],
              [77.618168330313893, 8.148512384386278],
              [77.606242909918336, 8.145988308889025],
              [77.591088840996946, 8.141757731697718],
              [77.583077067145325, 8.137287721732717],
              [77.578952847974534, 8.132884520136713],
              [77.571595080422568, 8.12750929292152],
              [77.568672307699671, 8.126083560969414],
              [77.56307109762929, 8.121647122429474],
              [77.561738989513586, 8.118665401171294],
              [77.559345901738112, 8.111786557467102],
              [77.558720006837419, 8.106791365842595],
              [77.559089652690687, 8.103391018484491],
              [77.56194426726627, 8.096515800953188],
              [77.565382465398301, 8.093817495283195],
              [77.565801326383564, 8.09012387895835],
              [77.558221648567837, 8.08208866730587],
              [77.555591220145359, 8.078788283409324],
              [77.547166342464777, 8.078140337895011],
              [77.53745543050529, 8.079545668711093],
              [77.527863483081049, 8.081129664630838],
              [77.523822186751985, 8.081223949846327],
              [77.512001735076254, 8.080314100056418],
              [77.507967754303692, 8.080040391957979],
              [77.504591940162825, 8.079964723637122],
              [77.499176540488406, 8.080770135459018],
              [77.492373076643418, 8.082926076113548],
              [77.480505843836923, 8.085442111761934],
              [77.466604981366103, 8.087905312953032],
              [77.45476302415112, 8.089026140878573],
              [77.448829083493337, 8.091393627617228],
              [77.442403916031409, 8.093738946717588],
              [77.421613967014054, 8.098481311386049],
              [77.409684016698378, 8.103307659780009],
              [77.405694290866762, 8.104185922011975],
              [77.398529661292386, 8.104554034272853],
              [77.39234581271954, 8.106466176781682],
              [77.389154268304864, 8.107753950998875],
              [77.381797744477538, 8.111438239938895],
              [77.373726130799056, 8.115421652045608],
              [77.370785560459396, 8.117710808690804],
              [77.365868498935953, 8.120915341218504],
              [77.361073058302097, 8.123234111201043],
              [77.358034024543173, 8.123902838639538],
              [77.352818217202028, 8.123853142579256],
              [77.348998419703122, 8.124319301147755],
              [77.340574118724192, 8.125234339757206],
              [77.336094543160257, 8.123333427754403],
              [77.328595255565844, 8.123162461824233],
              [77.317489101322195, 8.121317978891845],
              [77.31034097572406, 8.125927654332362],
              [77.30859439526229, 8.128562023005435],
              [77.30696224696122, 8.13424325225597],
              [77.30245837164432, 8.142302754626987],
              [77.300233080666743, 8.145664343856444],
              [77.297006873971512, 8.149796826218729],
              [77.29006330083952, 8.155062089134368],
              [77.283392294237487, 8.160035573757064],
              [77.276744471569543, 8.163941416355321],
              [77.250465423581986, 8.17016236288911],
              [77.240287905371304, 8.177858870908981],
              [77.236174663468546, 8.183920695993386],
              [77.233767444147148, 8.189122384411771],
              [77.227344554374255, 8.195223131550284],
              [77.223217665469633, 8.197917623131852],
              [77.205051668780428, 8.206558868930786],
              [77.199149098376594, 8.211320086424184],
              [77.193473263451381, 8.215836489762371],
              [77.187123603784045, 8.219747203420106],
              [77.183656491060134, 8.222848627203646],
              [77.18145693060336, 8.225080336570162],
              [77.17933249447438, 8.227982312706134],
              [77.174438054485407, 8.232848561373793],
              [77.171414366332499, 8.235729842691498],
              [77.168342262743437, 8.240661632523103],
              [77.164192940306947, 8.243286445655713],
              [77.160295798348045, 8.245553949274717],
              [77.157275496386845, 8.246768285994708],
              [77.152430895853229, 8.250506096398603],
              [77.144372097463403, 8.254399252163671],
              [77.128422042193435, 8.265809079376202],
              [77.122246142922364, 8.272406443324657],
              [77.115206326204287, 8.278688631729711],
              [77.110889293923748, 8.28250726109709],
              [77.100038424802634, 8.291311065917743],
            ],
          ],
          [
            [
              [92.219950435089501, 10.965103354179929],
              [92.230060028703079, 10.972098230690547],
              [92.227454783367193, 10.968161720861865],
              [92.224338247622157, 10.966947561617491],
              [92.219950435089501, 10.965103354179929],
            ],
          ],
          [
            [
              [92.662902400790131, 10.971583411280752],
              [92.662088370711473, 10.975783762106238],
              [92.660996644018041, 10.980053445407343],
              [92.663910405851396, 10.980911746591142],
              [92.667824109317095, 10.981448169305368],
              [92.671123798745057, 10.980229073628454],
              [92.671516110397434, 10.976720798071597],
              [92.668862900070536, 10.974500537162102],
              [92.662902400790131, 10.971583411280752],
            ],
          ],
          [
            [
              [92.713643452343788, 11.300823790464518],
              [92.714657131548719, 11.306280406123143],
              [92.715332854501156, 11.310025442586499],
              [92.717422305754965, 11.31409651143346],
              [92.717741168556316, 11.319321198012899],
              [92.719840114098332, 11.322120673770131],
              [92.7226196851705, 11.323394754127001],
              [92.724063483931758, 11.318750716098039],
              [92.723012720792923, 11.315721208686796],
              [92.722923324294371, 11.311189288692409],
              [92.722360161987353, 11.308045290809124],
              [92.719205511813641, 11.306886427251097],
              [92.717252745060435, 11.303163009938393],
              [92.713643452343788, 11.300823790464518],
            ],
          ],
          [
            [
              [92.688323228232051, 11.234066801680099],
              [92.686653075359516, 11.237554712162568],
              [92.689553293420332, 11.241995196160385],
              [92.691180319673606, 11.245487456422133],
              [92.693463130595248, 11.252238036687542],
              [92.692743676953143, 11.255958443418812],
              [92.692842508168752, 11.258962954862822],
              [92.692355268189019, 11.262937989457724],
              [92.691756323570218, 11.266057012718489],
              [92.691963798639108, 11.270264401129868],
              [92.694282164648527, 11.274681336265072],
              [92.697177016751681, 11.276072219617905],
              [92.700330512041731, 11.277138916639226],
              [92.703723778498258, 11.276658319409202],
              [92.703748959146651, 11.272358858707554],
              [92.704589003801843, 11.267713852330344],
              [92.705001992892875, 11.2607345156003],
              [92.705257411552665, 11.256782504517215],
              [92.704929029615201, 11.253176849165888],
              [92.701201050225407, 11.247232329832904],
              [92.696204997806447, 11.244083408774758],
              [92.69353420260974, 11.240012831116081],
              [92.69111564935244, 11.236751589741086],
              [92.688323228232051, 11.234066801680099],
            ],
          ],
          [
            [
              [92.72076147495703, 11.898483707919354],
              [92.717045987274474, 11.903576578186151],
              [92.717090776402131, 11.907747049639809],
              [92.718255542275884, 11.912496377447548],
              [92.717969729150866, 11.917500577108592],
              [92.718431897919046, 11.922343524400659],
              [92.720272290285749, 11.926677001023993],
              [92.723646316735753, 11.92452553054628],
              [92.72450666382332, 11.921097890964704],
              [92.725617882304903, 11.918180831382331],
              [92.725216070623233, 11.915099165232775],
              [92.723884528015347, 11.911344189375368],
              [92.724750367150435, 11.906920890605866],
              [92.72376279807402, 11.903839222647216],
              [92.72076147495703, 11.898483707919354],
            ],
          ],
          [
            [
              [93.048775710508778, 11.805503262270909],
              [93.041557586735664, 11.80988891886366],
              [93.037677084439849, 11.812509755434693],
              [93.033966768101777, 11.813579243700723],
              [93.03146504975615, 11.815639821188924],
              [93.028135412694311, 11.820742180952291],
              [93.023712506803989, 11.825123703065707],
              [93.017200963812215, 11.826519911135676],
              [93.015769674383606, 11.829138927315604],
              [93.014703370069881, 11.834211238764016],
              [93.014873765929778, 11.838750492558077],
              [93.019454349415497, 11.835620276641803],
              [93.028634505652548, 11.831047729661968],
              [93.033912002442705, 11.829465889742812],
              [93.038485697503944, 11.828418962927593],
              [93.046935594513187, 11.832438672836398],
              [93.055719933381397, 11.834858779782072],
              [93.06381208688039, 11.83484823248984],
              [93.069810291402575, 11.832918484107672],
              [93.072993450871522, 11.829416441508444],
              [93.071774731307087, 11.824369315831088],
              [93.065448969765058, 11.818773901490362],
              [93.062644592273699, 11.813706200557725],
              [93.061095294908114, 11.809516173203978],
              [93.058446066509063, 11.807250330358736],
              [93.054227285380463, 11.806376070779718],
              [93.048775710508778, 11.805503262270909],
            ],
          ],
          [
            [
              [93.037293193809461, 11.876595761575512],
              [93.031293630076902, 11.878363733407253],
              [93.02491838881393, 11.886408207391451],
              [93.023137349668389, 11.89583783809617],
              [93.016411322413674, 11.904254451425173],
              [93.008265273293389, 11.917536559918046],
              [93.000478173668597, 11.928385712018828],
              [92.998340616965962, 11.932604141739869],
              [93.001153598515003, 11.9353822959749],
              [93.00398885529107, 11.932251600770426],
              [93.004701218323362, 11.928752735845455],
              [93.010319728480098, 11.93013778696487],
              [93.012799207011625, 11.92837394776727],
              [93.014214367319781, 11.924526701951894],
              [93.01739640135807, 11.922439346935578],
              [93.018083738557351, 11.925936582383788],
              [93.020034721608042, 11.928390497023319],
              [93.018782903196012, 11.932585046803872],
              [93.017698885908075, 11.935365988954548],
              [93.017104368548189, 11.938493870452071],
              [93.016301220984403, 11.941368591496403],
              [93.017308916485007, 11.946580412136212],
              [93.014462251784551, 11.95286132696075],
              [93.013400660348765, 11.956014079007259],
              [93.01092060594749, 11.95777697318405],
              [93.007876116278382, 11.962217807897465],
              [93.002681095846171, 11.957900560870641],
              [93.001850896350277, 11.961423541416105],
              [93.001369974181841, 11.964945677369068],
              [92.998564647097027, 11.966524109534831],
              [92.99574435654813, 11.96513676503214],
              [92.993001181220421, 11.962288310209928],
              [92.991169777714475, 11.958908019889593],
              [92.995423004448654, 11.957444599852947],
              [92.989464259658533, 11.952885112817448],
              [92.991753071510232, 11.946279998716744],
              [92.992746602616279, 11.942757147672067],
              [92.989528344552937, 11.942111008905654],
              [92.98628718460121, 11.941465431968364],
              [92.983406359611948, 11.937945425367133],
              [92.980518261569145, 11.936997649615869],
              [92.973294111958694, 11.939969636146479],
              [92.968701479896779, 11.944860592114896],
              [92.96584224499945, 11.953968815381803],
              [92.965453763013358, 11.963398997874465],
              [92.959070212987982, 11.972161479387697],
              [92.951998027291879, 11.977402106582183],
              [92.943540316163777, 11.979168360851729],
              [92.935090236177729, 11.979520222517543],
              [92.93047970235483, 11.982325197808102],
              [92.928352782542476, 11.988258923151852],
              [92.92586076675731, 11.992453103610938],
              [92.929360992524579, 11.998408004954463],
              [92.934274722502153, 12.001209542740558],
              [92.940622153780424, 12.001901543308895],
              [92.946612389209321, 12.004355455839715],
              [92.952567483682188, 12.009936385776909],
              [92.956555339130446, 12.019881462908764],
              [92.95816617948617, 12.022888246823719],
              [92.959896145699233, 12.028124502719248],
              [92.960587731245866, 12.036189600492538],
              [92.961606305858538, 12.044578434934129],
              [92.966178043186105, 12.045966055331826],
              [92.966542429800882, 12.042466802069747],
              [92.964819559785013, 12.035467600633014],
              [92.968032099149227, 12.025685876438233],
              [92.970855044878178, 12.020771263371353],
              [92.976511544375057, 12.019375892957482],
              [92.983915490618401, 12.019022938049883],
              [92.990613531316015, 12.019713047665656],
              [92.990597069593377, 12.024254876818093],
              [92.984935386699178, 12.026716206014003],
              [92.97895436976583, 12.027763388027658],
              [92.977164691411588, 12.031264533032399],
              [92.976443639310048, 12.036526140087615],
              [92.980318479160516, 12.037566148296184],
              [92.983848480395253, 12.036520631160483],
              [92.991621950879988, 12.030905511728744],
              [92.999368818742781, 12.033007415205137],
              [93.003266734845553, 12.026699726836627],
              [93.008242663347616, 12.019696695084621],
              [93.008962056969523, 12.014806468047157],
              [93.007225905196933, 12.004310132522127],
              [93.007262508526651, 11.994159653339144],
              [93.008356824932477, 11.988550666139281],
              [93.01437864019168, 11.975962410355018],
              [93.024315516536944, 11.958458968649776],
              [93.028935340141487, 11.945501942524759],
              [93.037423244793061, 11.940603172781437],
              [93.045240150180788, 11.92064695484126],
              [93.047022151991399, 11.910868745251646],
              [93.053773582642791, 11.894412784103281],
              [93.05310630051018, 11.884614516045387],
              [93.047131540074233, 11.878344989037217],
              [93.037293193809461, 11.876595761575512],
            ],
          ],
          [
            [
              [92.745884948167443, 11.941135878864046],
              [92.743538617088646, 11.9434731471842],
              [92.742912730785534, 11.946808891062179],
              [92.738285866364691, 11.948218001973579],
              [92.74003701964493, 11.952159040336641],
              [92.743054422503235, 11.95515072438357],
              [92.749517664230666, 11.955339832768374],
              [92.752450536584121, 11.956825125029177],
              [92.758064823060749, 11.959100620952078],
              [92.761839149234945, 11.960262157299105],
              [92.766726730955824, 11.958597262130493],
              [92.768163955361459, 11.955771401016566],
              [92.768036372152594, 11.949491923877053],
              [92.765954272238332, 11.945737931794325],
              [92.760760971034514, 11.943995679972886],
              [92.756379851754943, 11.942649133417635],
              [92.753114093781207, 11.942229859371746],
              [92.745884948167443, 11.941135878864046],
            ],
          ],
          [
            [
              [92.731185573165035, 11.951338147050013],
              [92.730096262959279, 11.943390889042838],
              [92.731138598102788, 11.936441282207024],
              [92.724656072453683, 11.935694037851986],
              [92.722871108376964, 11.941900638629354],
              [92.724082074780611, 11.946350653720081],
              [92.726070768504314, 11.949596320837459],
              [92.731185573165035, 11.951338147050013],
            ],
          ],
          [
            [
              [92.599513216161426, 11.92283955777709],
              [92.597047260615284, 11.925290449475897],
              [92.596919005610388, 11.930549561060555],
              [92.596887998203698, 11.935368316520124],
              [92.596602775455153, 11.939537485468755],
              [92.597393610438658, 11.94338593173751],
              [92.598933360320558, 11.947141525504017],
              [92.597117627184645, 11.949987778684521],
              [92.595672809978396, 11.956751147274202],
              [92.594578927007731, 11.959783726246391],
              [92.592981215543489, 11.964762147840617],
              [92.590677393143324, 11.967120877368483],
              [92.588999634648104, 11.970454732820405],
              [92.594829574708626, 11.971137897278039],
              [92.5968305023125, 11.968755155692492],
              [92.599819854856278, 11.964845355210509],
              [92.601895612573202, 11.961581424549813],
              [92.600262516702628, 11.958080329058452],
              [92.601201006141267, 11.953680265205993],
              [92.603050182993272, 11.94935066462774],
              [92.602977819483229, 11.946245192004064],
              [92.603001333184039, 11.942561381084658],
              [92.603680689110888, 11.938740695003657],
              [92.605032576909039, 11.935151778076788],
              [92.602482183633612, 11.932690818151908],
              [92.601452799208914, 11.929538929984922],
              [92.602622667975169, 11.925463700298488],
              [92.599513216161426, 11.92283955777709],
            ],
          ],
          [
            [
              [92.73623227053227, 11.972915846907615],
              [92.73528060590489, 11.975996903157727],
              [92.738459128056618, 11.979845785669852],
              [92.742084169798119, 11.978249449330487],
              [92.740911850357648, 11.975167386900816],
              [92.73623227053227, 11.972915846907615],
            ],
          ],
          [
            [
              [92.749749052175972, 11.972764738902962],
              [92.748632040051319, 11.976169488044981],
              [92.747026260603221, 11.979852033960031],
              [92.749851797015907, 11.983678651150052],
              [92.752886152276972, 11.983681076037399],
              [92.755998271724252, 11.982524635598871],
              [92.755366418958971, 11.978770581941635],
              [92.753441055262655, 11.976265747625964],
              [92.749749052175972, 11.972764738902962],
            ],
          ],
          [
            [
              [92.760659322280048, 11.992631731283328],
              [92.757608867818661, 11.995294199270978],
              [92.758430165996401, 11.999117931879894],
              [92.761287315735913, 12.001715675980467],
              [92.761527255987531, 12.004890778507265],
              [92.765307832479294, 12.004963489962313],
              [92.766075166885642, 12.001557456213005],
              [92.766424901079958, 11.997038973072149],
              [92.764949607995632, 11.99346938558843],
              [92.760659322280048, 11.992631731283328],
            ],
          ],
          [
            [
              [92.774193272535143, 12.00714736660148],
              [92.770982694152281, 12.009230519175295],
              [92.771801693235204, 12.013403091532526],
              [92.774747586265235, 12.012732826648397],
              [92.774193272535143, 12.00714736660148],
            ],
          ],
          [
            [
              [92.741667191459541, 12.036601206631152],
              [92.746496604818731, 12.029026112647015],
              [92.748802056468747, 12.021820860972943],
              [92.749091391210399, 12.01586506919147],
              [92.745352311144202, 12.012154206867727],
              [92.740405209323882, 12.007538387161606],
              [92.739324507783664, 12.017107697874298],
              [92.736283290111388, 12.022065153379407],
              [92.735991513133712, 12.02853041311624],
              [92.736206313827125, 12.035924167824506],
              [92.733087523211196, 12.033928045160636],
              [92.731992288262362, 12.037774152922283],
              [92.731361403698202, 12.041945289916065],
              [92.730687254547547, 12.045351322052467],
              [92.731161874203011, 12.048388189633123],
              [92.735522841499176, 12.049643816527597],
              [92.74126590569054, 12.045801263151775],
              [92.744223221936153, 12.043046203842577],
              [92.747848712280629, 12.042145437140839],
              [92.749936866902445, 12.044811876602983],
              [92.751433687446976, 12.048568504899841],
              [92.755302538768589, 12.050146897377834],
              [92.759461708817668, 12.049482916661905],
              [92.764053656442641, 12.046932475764976],
              [92.76756027332452, 12.046424930037464],
              [92.773297927302792, 12.048167543510758],
              [92.774099150444925, 12.042212094617929],
              [92.779041723939415, 12.044022323200931],
              [92.78015420529978, 12.041033327436388],
              [92.776525633007438, 12.039440925123241],
              [92.779366699825459, 12.035262344957001],
              [92.777905650739655, 12.029050028455146],
              [92.776455048270108, 12.025155741469442],
              [92.776989716230077, 12.021332411878976],
              [92.774052496035509, 12.020403113985958],
              [92.769561304309832, 12.021929941697715],
              [92.766613106043536, 12.023016710485077],
              [92.765427842009544, 12.026283609888507],
              [92.762226964517225, 12.026606252336416],
              [92.761667780581845, 12.022016686523438],
              [92.75805440793566, 12.020669516589853],
              [92.755443560170633, 12.024352566779756],
              [92.755058249484975, 12.03060888273162],
              [92.754033576277649, 12.03420088884095],
              [92.748826985429716, 12.034103836904382],
              [92.741667191459541, 12.036601206631152],
            ],
          ],
          [
            [
              [92.626461160497811, 11.536976289441753],
              [92.628675465978645, 11.540219278748172],
              [92.630322060008055, 11.537191219816266],
              [92.626461160497811, 11.536976289441753],
            ],
          ],
          [
            [
              [92.566533338857639, 11.510743571642237],
              [92.564237455962001, 11.512959111459034],
              [92.561604024004637, 11.517210079807105],
              [92.558460405428249, 11.520719481482871],
              [92.556299276933473, 11.523746116514275],
              [92.555665727032931, 11.528093033954148],
              [92.55696439611684, 11.531821462497533],
              [92.561409588026521, 11.531922688802332],
              [92.563506468418581, 11.528202604757496],
              [92.566648049868448, 11.524485322765317],
              [92.569404761780078, 11.522964036721694],
              [92.572365490131446, 11.518620793618979],
              [92.571438614320812, 11.514755540958744],
              [92.566533338857639, 11.510743571642237],
            ],
          ],
          [
            [
              [92.604857909777991, 11.516833920606487],
              [92.603419427152787, 11.520070739517605],
              [92.602764440671166, 11.524117929545797],
              [92.604483253284798, 11.527961566674618],
              [92.606228763412489, 11.524425080479345],
              [92.608287778225829, 11.518968840752342],
              [92.604857909777991, 11.516833920606487],
            ],
          ],
          [
            [
              [92.612429362979398, 11.540491560716266],
              [92.612081934536093, 11.543915262610163],
              [92.612478745877283, 11.547363829724551],
              [92.613483154114903, 11.550488204360203],
              [92.617540900943226, 11.549200004073571],
              [92.620093395406315, 11.546567692997202],
              [92.61981087471132, 11.543327518116026],
              [92.619445562953004, 11.53867703144876],
              [92.618662744065176, 11.53383970302877],
              [92.617871335929024, 11.530206075527468],
              [92.614409248790238, 11.529691183331554],
              [92.613125904697498, 11.526542635547436],
              [92.609580642575409, 11.52413056797559],
              [92.609038699676418, 11.528964648688287],
              [92.608296580946742, 11.531901347237886],
              [92.607360129277396, 11.536341304029683],
              [92.607757064459776, 11.539673423082281],
              [92.612429362979398, 11.540491560716266],
            ],
          ],
          [
            [
              [92.595422173755892, 11.532086448322508],
              [92.589116078170008, 11.529342905589461],
              [92.588484092371758, 11.533667422933361],
              [92.587856054496797, 11.537114032297564],
              [92.587413826101255, 11.540444093439643],
              [92.590571327418701, 11.541469142726479],
              [92.592578658078338, 11.544202791474472],
              [92.591533862290802, 11.547232047565865],
              [92.590090710060366, 11.550746143990459],
              [92.58954722333452, 11.555510631085346],
              [92.589428281987551, 11.5594438740576],
              [92.590525880006652, 11.56238423569935],
              [92.59122757729908, 11.565300927141983],
              [92.594273361828314, 11.565815798034851],
              [92.594394405215596, 11.561581802449204],
              [92.594330060081532, 11.55744071726169],
              [92.596096765174806, 11.550664918523861],
              [92.597759843435469, 11.54532364147364],
              [92.598399067124504, 11.540257336140529],
              [92.59800235471144, 11.536925184115541],
              [92.595422173755892, 11.532086448322508],
            ],
          ],
          [
            [
              [92.261757477979586, 11.512176738319464],
              [92.258442708745122, 11.513342340528263],
              [92.255403764330836, 11.515017665733428],
              [92.250120416844283, 11.517748649086851],
              [92.246002435456589, 11.520228598188],
              [92.241248641479444, 11.521109833596006],
              [92.237968488377092, 11.520980567674703],
              [92.234948502443842, 11.520435046172844],
              [92.229021769101905, 11.519760309525811],
              [92.223736738546293, 11.519991319069016],
              [92.218593513592197, 11.522582343615753],
              [92.216293334494068, 11.5271751062141],
              [92.21507522322112, 11.530570115128151],
              [92.213738377353138, 11.534219848296829],
              [92.212776748124625, 11.537615747091849],
              [92.21195139833641, 11.541152125761807],
              [92.211261416110091, 11.545220951876354],
              [92.211358240879392, 11.54980272255127],
              [92.213020657733878, 11.553743916733294],
              [92.215615961798633, 11.557410531956746],
              [92.216760302902017, 11.561997679112379],
              [92.21724594201028, 11.567252158118356],
              [92.216005391441087, 11.573146547058498],
              [92.21413927849882, 11.575868987731706],
              [92.210283814656876, 11.579923203753117],
              [92.21301314590481, 11.581764361403437],
              [92.215249918793077, 11.584134363395108],
              [92.218259053401553, 11.585976884625646],
              [92.222488440744002, 11.584167067474594],
              [92.227769465137314, 11.582108916143335],
              [92.232518659520494, 11.582129793875593],
              [92.235811872690533, 11.583441012964197],
              [92.241997965655131, 11.584115271720613],
              [92.247918020284686, 11.585715418191596],
              [92.252133270228967, 11.585733344644085],
              [92.25659948395807, 11.585891243121429],
              [92.260950523922006, 11.586164596491534],
              [92.264782197429057, 11.584745814401263],
              [92.26995456110042, 11.581505576126316],
              [92.271830264227546, 11.577440815933564],
              [92.272660816891545, 11.57300179908961],
              [92.272574297599846, 11.569854409061708],
              [92.272070766552559, 11.566057126025965],
              [92.27170760110063, 11.562515215766584],
              [92.271505407264797, 11.556475808903606],
              [92.270469253135559, 11.552538609387451],
              [92.271195059122064, 11.547058297709231],
              [92.271749985474131, 11.542086198591146],
              [92.274144303510269, 11.539990386627354],
              [92.276545063271143, 11.536715003638436],
              [92.277627199216568, 11.532925905572117],
              [92.277397348436821, 11.529916909800122],
              [92.276499797418751, 11.526119216491296],
              [92.273020639080826, 11.51981186821526],
              [92.269360455802499, 11.515354986578984],
              [92.26621899430063, 11.512704866360256],
              [92.261757477979586, 11.512176738319464],
            ],
          ],
          [
            [
              [92.610424271423653, 11.337129412706492],
              [92.60637644165655, 11.338047033963662],
              [92.601675539883715, 11.339101167597759],
              [92.597641978883317, 11.341105613597776],
              [92.593467478612524, 11.343363115749126],
              [92.591313380407499, 11.345625014055118],
              [92.588184109374907, 11.351629087074206],
              [92.585732443873724, 11.356711417336131],
              [92.585308990586441, 11.360848456244533],
              [92.588632534245747, 11.364462267215915],
              [92.591034216906593, 11.366848613783054],
              [92.593685740612074, 11.369928705809759],
              [92.593939709747175, 11.373674702980972],
              [92.593363730496677, 11.38021782648304],
              [92.593059206929667, 11.38396257253225],
              [92.591815375929087, 11.38916353838183],
              [92.593818933795973, 11.391964653512527],
              [92.599184316806443, 11.392783962275772],
              [92.605094490048003, 11.391986474036456],
              [92.610313200009614, 11.393729639911038],
              [92.61420707446328, 11.39535565455712],
              [92.61715368942707, 11.396146669932033],
              [92.620353536003151, 11.397494561121205],
              [92.62424787847408, 11.399512079023697],
              [92.625967214081342, 11.402984421052823],
              [92.626175200933417, 11.406984959363786],
              [92.626690116288103, 11.410061672801493],
              [92.623706128411399, 11.415004789788975],
              [92.624081066991863, 11.418197038838908],
              [92.623257293295481, 11.423282997874683],
              [92.625378035244424, 11.426224414563343],
              [92.628060201556053, 11.428633930988001],
              [92.627367081321523, 11.431569470555186],
              [92.625068092582438, 11.434641668412178],
              [92.621845302988717, 11.433155327000124],
              [92.61886431475007, 11.437428877558879],
              [92.616942501746991, 11.443578192337123],
              [92.614761368193712, 11.449841768296068],
              [92.612856826784721, 11.453169130085673],
              [92.612298486908983, 11.456914630731431],
              [92.61213684878625, 11.460129254266167],
              [92.612511643322193, 11.463322054963855],
              [92.614635975215293, 11.469477816061419],
              [92.617015610108211, 11.475496105737649],
              [92.61873708531111, 11.479107167780988],
              [92.620455563449639, 11.482857398240448],
              [92.62164603630282, 11.486051814171484],
              [92.623769563540961, 11.488599624757684],
              [92.625775285763496, 11.491402422281059],
              [92.627757341056949, 11.494343649643996],
              [92.629363623001851, 11.497700294532867],
              [92.631480095877635, 11.501705635554488],
              [92.6350757287764, 11.506777610963816],
              [92.637879488308215, 11.508540545031833],
              [92.639648106982833, 11.505050659284207],
              [92.636580235884082, 11.500649877778537],
              [92.64022005429554, 11.49892133503252],
              [92.644250472735251, 11.50186544757654],
              [92.646686003878941, 11.499070061224355],
              [92.6456195325663, 11.494904117151817],
              [92.64632207814671, 11.490510159511096],
              [92.6499826212915, 11.485566701965991],
              [92.65268768782542, 11.48422845712755],
              [92.656868857349934, 11.481296960565222],
              [92.660084553950156, 11.480376688480701],
              [92.663044915461342, 11.479710350685249],
              [92.668164368412079, 11.479186223681154],
              [92.669787448420408, 11.476111453029338],
              [92.669280375870699, 11.471692939009396],
              [92.67198483654542, 11.466632099854365],
              [92.673766971508215, 11.46422874061351],
              [92.676989998012843, 11.462220022402477],
              [92.677154482735006, 11.458080076775763],
              [92.67610610650145, 11.454217353813934],
              [92.677202533850362, 11.450077751631305],
              [92.678977044987022, 11.444991910553178],
              [92.68170912494422, 11.439260737889816],
              [92.684025176412106, 11.43285730100326],
              [92.686473846400204, 11.427910823288606],
              [92.68568885938619, 11.42309954124133],
              [92.682895609866108, 11.419765606134471],
              [92.679273252839266, 11.41895191629002],
              [92.675516429090749, 11.417074402980811],
              [92.675022935639987, 11.410274546123075],
              [92.67262672049209, 11.406917644000055],
              [92.667429579219643, 11.405176091496617],
              [92.663949430383752, 11.403853527793988],
              [92.659116271669376, 11.403569197771398],
              [92.653608018238288, 11.403166933527892],
              [92.647445213170656, 11.403689503898606],
              [92.644611465741605, 11.406761069747754],
              [92.641520986606025, 11.406755842992039],
              [92.639651680052324, 11.404348212344262],
              [92.639676497570704, 11.400463553480103],
              [92.641529033400246, 11.397030232996498],
              [92.645743630134959, 11.396727315811487],
              [92.64669519458468, 11.393260137596368],
              [92.646477036941292, 11.38752414720965],
              [92.649819208712728, 11.388339113283816],
              [92.650865259289048, 11.39194828980728],
              [92.651909497721817, 11.39595054831624],
              [92.65473867886368, 11.39729490797974],
              [92.659026126072561, 11.39554386914959],
              [92.66120054916729, 11.393281251725567],
              [92.663363644097799, 11.389561902661759],
              [92.662456216060932, 11.385676013005158],
              [92.665939548984042, 11.386212466897478],
              [92.671024908661224, 11.387283733293245],
              [92.675318627671984, 11.388237995648627],
              [92.677888380063976, 11.386091188060997],
              [92.68178676346281, 11.383574948302714],
              [92.687043758559227, 11.382773304765523],
              [92.691615572463789, 11.38011937892489],
              [92.69270931014249, 11.37595944247785],
              [92.69112777965988, 11.372096220225876],
              [92.689804850290201, 11.367816258475113],
              [92.689829279546345, 11.363678022759313],
              [92.68742493253238, 11.361547447854234],
              [92.681539505648004, 11.358604214431692],
              [92.675799462315979, 11.354989503653131],
              [92.670303627214111, 11.352969493882386],
              [92.667513003225977, 11.34949832427985],
              [92.665909338791622, 11.345750939018249],
              [92.659995824203378, 11.347221760730324],
              [92.65611235048101, 11.347748116303775],
              [92.651280294124149, 11.347601361323907],
              [92.646729392884097, 11.347063184108217],
              [92.644730439573451, 11.343314690659545],
              [92.641798255756242, 11.340373022855525],
              [92.636433851722344, 11.339694371625423],
              [92.631741720288602, 11.33954782666579],
              [92.627723398768453, 11.339147699833093],
              [92.624488167814235, 11.339951062689558],
              [92.621664704976112, 11.341680875639454],
              [92.618720839097762, 11.340612308234325],
              [92.614968324685961, 11.338871345687185],
              [92.610424271423653, 11.337129412706492],
            ],
          ],
          [
            [
              [92.6152511245878, 11.55777958150318],
              [92.612785684926592, 11.561014309184994],
              [92.610329747666214, 11.562907374885549],
              [92.606384848575942, 11.561003559933329],
              [92.603117355009175, 11.562593086103897],
              [92.603392551839562, 11.566551393086201],
              [92.603278688902577, 11.569767087056327],
              [92.603349597906259, 11.573121594350607],
              [92.605367421076949, 11.577661100167528],
              [92.608509889113876, 11.577967430685089],
              [92.611564848712376, 11.577070244483615],
              [92.614411544347874, 11.576057441372992],
              [92.617695273350563, 11.572013735169994],
              [92.618434656995632, 11.569100494228165],
              [92.617826646425229, 11.566068426786277],
              [92.616952453307917, 11.560906411687277],
              [92.6152511245878, 11.55777958150318],
            ],
          ],
          [
            [
              [92.543854833945502, 11.560041277981108],
              [92.54101374132469, 11.56338941945816],
              [92.53772988398147, 11.563868168659917],
              [92.534654937791856, 11.567308047316068],
              [92.535189664305619, 11.570756961540219],
              [92.535325683840426, 11.574597997807254],
              [92.535556473323567, 11.578208406035273],
              [92.535206569318674, 11.58165614310561],
              [92.53360830329629, 11.587043228801727],
              [92.534401090679992, 11.590238348019335],
              [92.535863824879868, 11.594105942150355],
              [92.538219561718989, 11.596634348112225],
              [92.541776438119129, 11.597475334579848],
              [92.546824544948279, 11.594779355064574],
              [92.548243298101937, 11.591496403133741],
              [92.546682445702714, 11.588392005706707],
              [92.544490475642561, 11.585425795056329],
              [92.542117522980902, 11.582157772106854],
              [92.541230658661803, 11.578962952515194],
              [92.542656334973543, 11.574777100897217],
              [92.545977594382293, 11.572587380000076],
              [92.548033545842884, 11.574882269168532],
              [92.547743498026023, 11.579624764220471],
              [92.548143084143334, 11.582587851161454],
              [92.551513521659658, 11.583150846499699],
              [92.554319325701172, 11.581444112237325],
              [92.55885911857888, 11.581292272162667],
              [92.561236674797982, 11.584073904379661],
              [92.56418215892343, 11.585885943735203],
              [92.56757205412778, 11.583695064136959],
              [92.568247883397433, 11.579993680350123],
              [92.563241827207264, 11.576882695027402],
              [92.562376877604223, 11.574011764765414],
              [92.56272348512627, 11.570981103872848],
              [92.565371539685415, 11.568442006897],
              [92.564977952480646, 11.564599767823315],
              [92.560544211544752, 11.562947821575236],
              [92.557014696606771, 11.561945027370015],
              [92.555807612818029, 11.558008322305147],
              [92.553194210091675, 11.555643107993866],
              [92.548982122204123, 11.555633894156125],
              [92.544861686196654, 11.555624557797483],
              [92.543854833945502, 11.560041277981108],
            ],
          ],
          [
            [
              [92.700705640196958, 12.223812644493535],
              [92.7035665322163, 12.21820404171479],
              [92.7057108847698, 12.211550793583202],
              [92.705733589610801, 12.204199409853334],
              [92.705766521964861, 12.193857196923132],
              [92.704339895309985, 12.181936550742773],
              [92.701617252827617, 12.172629051929761],
              [92.701040147955339, 12.166745509857787],
              [92.697877670662436, 12.163589263302518],
              [92.697914022009115, 12.157630555832858],
              [92.700069689319918, 12.152740496759552],
              [92.703211257665387, 12.159049875596347],
              [92.705962413202059, 12.168489490825138],
              [92.709840321964762, 12.1688420505326],
              [92.709513097193238, 12.164644845150509],
              [92.707452602689415, 12.157292192037669],
              [92.705719233198451, 12.149941245937766],
              [92.701504504640425, 12.147131255818946],
              [92.701548187055621, 12.139782192557879],
              [92.703704259139045, 12.134545922074784],
              [92.707911135307512, 12.138745279235552],
              [92.710943689755126, 12.147628725184941],
              [92.710828872240427, 12.15140711175224],
              [92.711177612567553, 12.155673834943903],
              [92.71326675155828, 12.158133540761426],
              [92.714106990080708, 12.162772217977782],
              [92.714920108078317, 12.167386961522203],
              [92.718528535063513, 12.169964904735432],
              [92.720646776065777, 12.167508928187768],
              [92.723018773866386, 12.169574924187792],
              [92.726137352312634, 12.172036613839495],
              [92.729298342411468, 12.171482380531028],
              [92.7319792333696, 12.168448468469615],
              [92.734633919712465, 12.17507845113302],
              [92.742334610524082, 12.172630632815741],
              [92.746820210843012, 12.173098443551396],
              [92.751027284781074, 12.173565554043122],
              [92.75416703013029, 12.171968490232496],
              [92.758922593818497, 12.172694881049814],
              [92.760958681913451, 12.169887030614642],
              [92.759528030874804, 12.166408015969232],
              [92.762868532023532, 12.166595805040911],
              [92.764559810313514, 12.1695185156505],
              [92.766179652578799, 12.172557575756086],
              [92.76720971231633, 12.176801590210308],
              [92.768445263703981, 12.181555535553235],
              [92.768802648073745, 12.184756605996762],
              [92.769075480225652, 12.190715463310207],
              [92.768453448458118, 12.197717883580811],
              [92.768149772637017, 12.20168341042376],
              [92.767162248978522, 12.20736387422474],
              [92.767329604876167, 12.211051728087531],
              [92.768272883003362, 12.213881747392859],
              [92.768827377468313, 12.219377224313327],
              [92.769365407641601, 12.223714477152665],
              [92.769158830832239, 12.227123824269329],
              [92.769232108829812, 12.230903945957907],
              [92.770170958130848, 12.234591738320891],
              [92.771764753419376, 12.238675284353917],
              [92.773258818385187, 12.243221641355991],
              [92.771906640841564, 12.247001787307338],
              [92.765715312189542, 12.250490118175419],
              [92.765147252266843, 12.24708957877203],
              [92.765819476511865, 12.243772924702558],
              [92.764411459726517, 12.24026979927058],
              [92.763679388883673, 12.237254860955078],
              [92.761409465634884, 12.233356913798684],
              [92.75881516633055, 12.237157801701821],
              [92.756134956363098, 12.235532849463885],
              [92.753197732591374, 12.233652013590769],
              [92.749857139539216, 12.233068630419456],
              [92.748504873311944, 12.236291238850191],
              [92.749255647660249, 12.240351185834495],
              [92.74685106739922, 12.24366541672892],
              [92.745500848496107, 12.246679572409938],
              [92.746156327487824, 12.250877072282847],
              [92.747146651975754, 12.253870540277262],
              [92.748737306437945, 12.257860812289287],
              [92.748526279495564, 12.262198350484297],
              [92.747806031989626, 12.265792775127879],
              [92.750931687798456, 12.267186401156371],
              [92.752842065400472, 12.264265773677577],
              [92.752447610672363, 12.259696254082256],
              [92.752932008953721, 12.25656581121917],
              [92.756951924560255, 12.257288370753685],
              [92.761744538190499, 12.257640095316571],
              [92.763977565568425, 12.260053024899879],
              [92.766815886849585, 12.258524475529354],
              [92.767923555268993, 12.26133240423891],
              [92.768324012151552, 12.265321628673373],
              [92.770082363552561, 12.268616310331762],
              [92.773686556601746, 12.268549797210746],
              [92.776602166665938, 12.26555872537331],
              [92.778627619353315, 12.262939371839453],
              [92.781945774615991, 12.263637153079626],
              [92.785584932120329, 12.265703693571123],
              [92.788588320286905, 12.268211135016161],
              [92.78952729373448, 12.27203862194528],
              [92.789161806177773, 12.275030189764857],
              [92.791560187748345, 12.277072508395158],
              [92.789488063588948, 12.279831607716462],
              [92.786113628591266, 12.280780465853347],
              [92.784974198749126, 12.283981116860163],
              [92.784651519835847, 12.287552865226578],
              [92.781047253877162, 12.287713636197429],
              [92.780009771594507, 12.293790368890079],
              [92.777536805714988, 12.296526393714345],
              [92.775296610419232, 12.300003752549848],
              [92.773054422973303, 12.30357527236893],
              [92.776952203354114, 12.305549271533765],
              [92.781103641645245, 12.303742339714479],
              [92.7842683459223, 12.30260776598635],
              [92.787345132080532, 12.300405960077375],
              [92.789112674490411, 12.297901906108052],
              [92.792791452803741, 12.296744224391759],
              [92.795925932062872, 12.296907469844246],
              [92.797596314980652, 12.29994723186393],
              [92.799053016848191, 12.303288589529044],
              [92.800955712788195, 12.30602653291251],
              [92.804012110361526, 12.30792972690185],
              [92.807545517018468, 12.307769228913392],
              [92.810614122784301, 12.30746933790558],
              [92.811363753977005, 12.311575496733441],
              [92.808526781154796, 12.313012169221532],
              [92.80472605834963, 12.314913534852403],
              [92.801361252533269, 12.31363621502641],
              [92.799999359198623, 12.310271734279977],
              [92.796711146829182, 12.307996282291137],
              [92.79607589906162, 12.313168738827621],
              [92.79551955083133, 12.316578408867482],
              [92.792223477620226, 12.315974201847926],
              [92.788016699915303, 12.315067078373927],
              [92.783191367838299, 12.315829701129909],
              [92.782933863392699, 12.320445844891983],
              [92.785377924850025, 12.322651705593708],
              [92.787212964255644, 12.32532034721963],
              [92.785889499155317, 12.328057298628011],
              [92.782114308226653, 12.329260641168901],
              [92.778677368022628, 12.328655369741764],
              [92.776397677184747, 12.325986117830363],
              [92.772187730108158, 12.32554316181113],
              [92.771695082642452, 12.33025188111103],
              [92.770530306089881, 12.333521638476583],
              [92.767829786948468, 12.335330160647139],
              [92.764069292510314, 12.333796187001395],
              [92.762473247426982, 12.330315127406619],
              [92.762437864678134, 12.3237034969071],
              [92.763125997267338, 12.315578327139992],
              [92.760120552183466, 12.311012184981424],
              [92.758221209127981, 12.30750774969623],
              [92.756653295622428, 12.303168539910752],
              [92.7545904787724, 12.299455588708174],
              [92.751544378300807, 12.296043119967361],
              [92.747934191107731, 12.297315754745105],
              [92.744879170486925, 12.295712689169143],
              [92.743317966351896, 12.29886549101656],
              [92.738788953264077, 12.300857064982733],
              [92.735031865936079, 12.299112804390566],
              [92.731155387372766, 12.297995846930331],
              [92.725542332104652, 12.297596884109609],
              [92.721626517898784, 12.299031077922468],
              [92.718177473667623, 12.300395072310749],
              [92.715466026393145, 12.303964506597525],
              [92.713828400982564, 12.308162538700676],
              [92.71007377079026, 12.309898114222115],
              [92.706756045005477, 12.312932929158212],
              [92.706799671820121, 12.317572598447491],
              [92.706943924555063, 12.320982598603862],
              [92.706922108245763, 12.324717704855766],
              [92.706060101498352, 12.328196314584295],
              [92.70060814441257, 12.327749074716827],
              [92.699303738359575, 12.330694384787975],
              [92.698881802232037, 12.334800488618225],
              [92.698935957162846, 12.341575004665732],
              [92.698814954192514, 12.346354292046],
              [92.699406640925687, 12.349324466049939],
              [92.698567570059467, 12.35247871819265],
              [92.697941780243397, 12.35547090819977],
              [92.697432518020662, 12.358509919330212],
              [92.698082650769166, 12.363545610876987],
              [92.699608187685087, 12.366817706777649],
              [92.700708118629407, 12.370694914404822],
              [92.701177152481179, 12.374639755939498],
              [92.700455823679249, 12.377887434354204],
              [92.696809631343314, 12.380782864103706],
              [92.697274080877492, 12.385354714464086],
              [92.696199912356704, 12.389019734282462],
              [92.696475284784796, 12.39359112056713],
              [92.696304272607605, 12.398858761263119],
              [92.696207697433735, 12.40356914332718],
              [92.695970422646496, 12.407861826304963],
              [92.695620039244531, 12.411527378580463],
              [92.695848853402495, 12.416539958681064],
              [92.696736931531092, 12.420834813097597],
              [92.697459771621183, 12.425198736835075],
              [92.697849653377105, 12.43086125506861],
              [92.697026122312963, 12.439007246052375],
              [92.701202184755644, 12.442143815124808],
              [92.701523308570771, 12.447273530700253],
              [92.702271748303573, 12.451637054117187],
              [92.702455741145371, 12.455978261864434],
              [92.700819320025971, 12.459596669696291],
              [92.699413258357964, 12.463540116169403],
              [92.69845840773057, 12.466579513618354],
              [92.699763695165174, 12.471640602881486],
              [92.700659032211945, 12.474683414512072],
              [92.701331568507456, 12.479882611716317],
              [92.702063103120182, 12.482924152209959],
              [92.70371246484271, 12.489356062214247],
              [92.704389022466984, 12.494068993165467],
              [92.702894092502945, 12.497107176457867],
              [92.700440366958333, 12.500099181530167],
              [92.699014623892623, 12.503556094528083],
              [92.700090218081058, 12.507851801104982],
              [92.697959044531601, 12.51137738718953],
              [92.694453965593397, 12.513788315144874],
              [92.692629433144631, 12.517105076311124],
              [92.696178049266223, 12.519338084551491],
              [92.697823595635825, 12.522799142120936],
              [92.698014537435242, 12.526188722239887],
              [92.698904035599824, 12.530344520584555],
              [92.699234287056299, 12.533804253733095],
              [92.699913115457107, 12.537890887251855],
              [92.702117577428496, 12.541770573884214],
              [92.704611881668157, 12.543908996551417],
              [92.707264327325973, 12.547372049786647],
              [92.707383257690182, 12.551318221684598],
              [92.706941496010572, 12.554730511031901],
              [92.705482269732244, 12.559488575891562],
              [92.703728971042139, 12.562597705877998],
              [92.702461072616273, 12.566937966067714],
              [92.705892210881146, 12.569751352535189],
              [92.70634340452149, 12.572862393173009],
              [92.705845617538657, 12.577667866214918],
              [92.70472053800593, 12.581707448796456],
              [92.704397101616266, 12.584980834956834],
              [92.705315948791338, 12.587930093995269],
              [92.707803781595672, 12.591671305520061],
              [92.709823232767747, 12.595087031550007],
              [92.710275869916856, 12.598036094795967],
              [92.706990029260623, 12.598357807109952],
              [92.703684884538021, 12.598192234829742],
              [92.700991550952978, 12.601602111517076],
              [92.692625390332054, 12.604656797459539],
              [92.687783891203964, 12.606717797919018],
              [92.683418814118014, 12.603298689678766],
              [92.679526084364127, 12.607985861477324],
              [92.683210330184139, 12.610751853983924],
              [92.685706866197904, 12.612937480266122],
              [92.686833136691575, 12.609564903892457],
              [92.692442068678844, 12.612070750597191],
              [92.698088921834795, 12.612952852990551],
              [92.701686352213173, 12.615396130464571],
              [92.70873883852046, 12.620258000143741],
              [92.710275274013284, 12.62634302831901],
              [92.710550979468607, 12.631475890148556],
              [92.710226751676444, 12.634888219585887],
              [92.71067507273267, 12.638465053196724],
              [92.712861261899448, 12.641579693151851],
              [92.714754306077992, 12.638772212026897],
              [92.715707976442431, 12.635824114389873],
              [92.716067231283944, 12.63069241719138],
              [92.716408708471775, 12.62446908395521],
              [92.715795051990895, 12.621054465618986],
              [92.715357199371823, 12.615619837689076],
              [92.714608180606845, 12.611114510022754],
              [92.716512566031483, 12.606287099207792],
              [92.71917349903083, 12.608472312311285],
              [92.720095112845755, 12.611421531824892],
              [92.720848486828885, 12.614999044785955],
              [92.720825024714927, 12.619039546448178],
              [92.721578063696555, 12.626657155460626],
              [92.723765350701726, 12.629933577825547],
              [92.727848402367115, 12.629311394414172],
              [92.728812430973164, 12.624806817552466],
              [92.733370384909065, 12.62325539869185],
              [92.736658696108293, 12.622631300142906],
              [92.739813368331156, 12.620289132295085],
              [92.742663660015523, 12.618131882850051],
              [92.746583381689263, 12.617671080823548],
              [92.749891495367407, 12.617511206525677],
              [92.754443495926026, 12.616748733050631],
              [92.758998193431978, 12.615962099545758],
              [92.761520310393877, 12.613479908099606],
              [92.761073768568977, 12.609438425133501],
              [92.761570964087269, 12.604470032720654],
              [92.760970569135353, 12.598246329446361],
              [92.761958855905036, 12.593418073848294],
              [92.763686898362764, 12.590469608896518],
              [92.76791274779886, 12.593886516265236],
              [92.768828127043832, 12.597927669382372],
              [92.769111492377334, 12.601828198201368],
              [92.770665006224348, 12.605079929641823],
              [92.775073043151991, 12.605408162938065],
              [92.774926813307559, 12.601995013309811],
              [92.774782896515305, 12.598256325816715],
              [92.774191045170511, 12.594842777471966],
              [92.774214142610845, 12.590640367259615],
              [92.77391302994252, 12.585507787245978],
              [92.775665797388143, 12.581933806684635],
              [92.776160516368464, 12.5772675227858],
              [92.778988165810901, 12.574483369549181],
              [92.783577107764444, 12.571374923556139],
              [92.784968542705656, 12.574324342046234],
              [92.783846440338394, 12.577899620148738],
              [92.781148763173633, 12.582703523673953],
              [92.782230221686234, 12.58644284982282],
              [92.786015877421065, 12.584425309407923],
              [92.789162145217688, 12.583799363171071],
              [92.790215901190663, 12.588629173253764],
              [92.790196354581653, 12.59204334095312],
              [92.789863486441732, 12.597800932143102],
              [92.792683455720095, 12.60091388521532],
              [92.796903747219176, 12.601056035105385],
              [92.79861369934622, 12.605886492806125],
              [92.798120212542898, 12.610855990570348],
              [92.798399737100922, 12.615523485213126],
              [92.798543585432924, 12.619400750536151],
              [92.801671376963029, 12.622514392678365],
              [92.798520631095883, 12.624068510075404],
              [92.795677608711955, 12.625158266544846],
              [92.794884495794236, 12.628572207065817],
              [92.793132973326053, 12.631543610440186],
              [92.789053133629665, 12.631378210118912],
              [92.784490766091409, 12.63369834283397],
              [92.783062720052314, 12.6376216246959],
              [92.782434652633512, 12.641290795321373],
              [92.782417525332846, 12.644472886655107],
              [92.782464449716286, 12.648978097368479],
              [92.786232072567884, 12.650373829133224],
              [92.789434025314989, 12.652628583882903],
              [92.793036026582669, 12.654651285673731],
              [92.795126307253156, 12.658786055285425],
              [92.795202676933926, 12.662362759280583],
              [92.792656012332969, 12.664683328191613],
              [92.788266843614068, 12.665006089349191],
              [92.786280061209126, 12.668256274636477],
              [92.788471433051299, 12.67090599751989],
              [92.79214874714863, 12.672231407847267],
              [92.790417286707807, 12.675645076719041],
              [92.788824270651105, 12.679382890991731],
              [92.787298203366959, 12.684422201611051],
              [92.785548151343534, 12.691505169157967],
              [92.785879973704638, 12.695013102003397],
              [92.785851408778143, 12.700680485623767],
              [92.785383508876322, 12.704628702080338],
              [92.785696009934824, 12.707741265472878],
              [92.785676277134684, 12.711806677673918],
              [92.783710469722323, 12.714802751145891],
              [92.784021244788462, 12.718425964179181],
              [92.786616759389389, 12.720146306296598],
              [92.790266491977093, 12.72228515537431],
              [92.792655067228949, 12.718755720423033],
              [92.795888575803261, 12.719826672779508],
              [92.797703494134964, 12.722939574068885],
              [92.798790938720146, 12.725821490430143],
              [92.799081170852716, 12.728910988896059],
              [92.795626130351565, 12.729768050835027],
              [92.792175617900398, 12.729767154129604],
              [92.789340893097659, 12.733504978964719],
              [92.784267896785352, 12.734036695624798],
              [92.781439259698359, 12.736287973234619],
              [92.778844127457816, 12.738748500899716],
              [92.77807280120868, 12.742604282430825],
              [92.774087811881543, 12.741533756022646],
              [92.769983125481914, 12.740764782655432],
              [92.765882253767089, 12.739599531997801],
              [92.766113049465929, 12.736069212467937],
              [92.767864629214344, 12.733073447555414],
              [92.766309174373959, 12.730168599114604],
              [92.764702534647313, 12.727495601889066],
              [92.761145445280533, 12.725681466943639],
              [92.763417044907953, 12.722360956605339],
              [92.766345197418374, 12.723222995918501],
              [92.769878796923905, 12.72526901101881],
              [92.771058325245065, 12.728568416099385],
              [92.77376644852076, 12.726875454973056],
              [92.774117005469407, 12.722809944432884],
              [92.774345490999721, 12.719697364609218],
              [92.775232354889454, 12.716167797388778],
              [92.775788418802804, 12.713078275341045],
              [92.774738271785154, 12.707410180267724],
              [92.774104578392098, 12.703228410536687],
              [92.773832827218286, 12.696933728112556],
              [92.772771690742019, 12.69340236635581],
              [92.771728507486216, 12.686991250719192],
              [92.771316470655051, 12.680347944501184],
              [92.770798092325464, 12.676723784559821],
              [92.767574950306638, 12.673726053203442],
              [92.765729654712317, 12.676813394916957],
              [92.766783418147199, 12.681320480861785],
              [92.764399395051043, 12.683989051820053],
              [92.762135021668996, 12.681851298533529],
              [92.759133674756541, 12.677133261805606],
              [92.756661617123228, 12.674669728378014],
              [92.752253697480697, 12.67380653569281],
              [92.748890005549185, 12.675406299991945],
              [92.74512200925183, 12.673800810615946],
              [92.739732257288651, 12.672727385845874],
              [92.733584791908257, 12.67272213273268],
              [92.732156443188785, 12.676576112775376],
              [92.732243829420668, 12.681593532513403],
              [92.731138577247293, 12.686306860042196],
              [92.733035183548481, 12.691000611631425],
              [92.734753500461949, 12.694439813945534],
              [92.736682564870875, 12.697646620864958],
              [92.740458391692229, 12.698068986078969],
              [92.742269783225481, 12.701275519503076],
              [92.742042903562123, 12.704387689966643],
              [92.742985716740961, 12.70780346540535],
              [92.739096434901981, 12.711005448223885],
              [92.738532204937201, 12.715069647682203],
              [92.740886549423706, 12.717975947376758],
              [92.744327838103573, 12.719674424003223],
              [92.747466183725678, 12.72074564185397],
              [92.74882954194652, 12.724603010816528],
              [92.744285795586293, 12.727061538178143],
              [92.73963102675981, 12.728659403800767],
              [92.737245937905755, 12.731004645034483],
              [92.73743485328869, 12.735186188782642],
              [92.737397473593802, 12.741806498325175],
              [92.733417336109838, 12.739990403438069],
              [92.730819278032001, 12.742543255640083],
              [92.729598142826575, 12.747141366483788],
              [92.732484411435394, 12.751117680465311],
              [92.731830033089196, 12.754741036427211],
              [92.728787644271705, 12.757410041446512],
              [92.725360521326763, 12.761495138005115],
              [92.723921973981405, 12.766721169350447],
              [92.722284375913546, 12.769832875229419],
              [92.717745945991453, 12.770896188071598],
              [92.717188092417956, 12.774101792729223],
              [92.717379569696661, 12.777401124255814],
              [92.720164716415724, 12.77923929302872],
              [92.720374620567398, 12.783608226120107],
              [92.719804697279088, 12.788533597404985],
              [92.721290755696117, 12.791740766103194],
              [92.72481177726722, 12.796063379485851],
              [92.727242754972139, 12.78981820391453],
              [92.730503155575093, 12.78619674230764],
              [92.729660003573585, 12.781804848265818],
              [92.728717221646988, 12.778063702318082],
              [92.731847557066715, 12.776579123732112],
              [92.736716762975277, 12.775189940000603],
              [92.73594195751366, 12.779464717711113],
              [92.735380002107235, 12.783088299812393],
              [92.733735214765915, 12.787385235728667],
              [92.733054969221371, 12.791451130844264],
              [92.733266399854614, 12.7952171660139],
              [92.73845866349383, 12.791130221340879],
              [92.741217515900559, 12.793246893830304],
              [92.741735164071557, 12.797105132614641],
              [92.739651369230018, 12.800425508868654],
              [92.73606695213644, 12.803093641637416],
              [92.735292073675154, 12.807043176194934],
              [92.731998054267194, 12.812407901191328],
              [92.734689792807401, 12.818057313467991],
              [92.733801132878739, 12.821913429287283],
              [92.73485971542334, 12.825562466399061],
              [92.734843470270164, 12.828653260665215],
              [92.735481301244022, 12.83197648156235],
              [92.741550261901168, 12.830169241082748],
              [92.745535638660456, 12.83186971386808],
              [92.745181260085303, 12.836377035405029],
              [92.746018777793537, 12.84181513426304],
              [92.749890467034874, 12.842585714609175],
              [92.75346185969623, 12.842588982206447],
              [92.757056198280466, 12.838199209190748],
              [92.758036853213326, 12.834877036266198],
              [92.757971513866778, 12.829648909269398],
              [92.754627287415744, 12.827066716248011],
              [92.752696080549299, 12.824067574882605],
              [92.754872040657958, 12.820979246588148],
              [92.756477136135871, 12.823977845318836],
              [92.760496718805371, 12.823121253172152],
              [92.760826857850873, 12.818636288647289],
              [92.760540131201566, 12.81552291365402],
              [92.763796143167113, 12.812736896398008],
              [92.765942403412154, 12.815201117432887],
              [92.766129972107464, 12.81970956803492],
              [92.765358290429404, 12.823542426260975],
              [92.764468274252991, 12.827074455770481],
              [92.763365286318034, 12.83125678338423],
              [92.761397259632474, 12.834787001240809],
              [92.762674431711062, 12.837669609082344],
              [92.767543282723736, 12.836488052219966],
              [92.769307144578676, 12.831469635391246],
              [92.770197281273994, 12.827821775839334],
              [92.771181516990524, 12.823454327834607],
              [92.770998161124524, 12.818527962114546],
              [92.77176571057862, 12.815414769377618],
              [92.772981324060396, 12.812324646989511],
              [92.774180825944796, 12.807400004484283],
              [92.775287560698956, 12.802265698858967],
              [92.776526476147026, 12.798943597366929],
              [92.777723341895992, 12.79466940266607],
              [92.778737283221375, 12.789859906580769],
              [92.779302902365615, 12.78493558152454],
              [92.779082628030281, 12.781937811158489],
              [92.776511091214289, 12.780123212940824],
              [92.773937624204436, 12.778194148179237],
              [92.773953314541274, 12.775196852264328],
              [92.776130452008587, 12.771991657376796],
              [92.775611911681025, 12.767926255836263],
              [92.772929575704509, 12.76471788746187],
              [92.771326786424325, 12.76162687481319],
              [92.772190839836881, 12.758096319763377],
              [92.775212570205809, 12.759376702576299],
              [92.778571044462382, 12.758959586536834],
              [92.782018032467292, 12.759705299584946],
              [92.783664910004219, 12.763771875740504],
              [92.785381588612466, 12.76760635181701],
              [92.7849155030449, 12.771463376758817],
              [92.78393148512535, 12.775319723359443],
              [92.787589423923279, 12.776274122302764],
              [92.791494075922799, 12.775090660164098],
              [92.794067479965619, 12.776927517167895],
              [92.790387886430693, 12.779807171613614],
              [92.788428066242545, 12.782152253496818],
              [92.788829062061367, 12.786009987593637],
              [92.790007224900378, 12.789960140028978],
              [92.791187339086591, 12.793283927750059],
              [92.794517120516119, 12.794144966278498],
              [92.796568906322889, 12.796934527270842],
              [92.797631550072268, 12.800350027089353],
              [92.799993470733781, 12.802373090558893],
              [92.802771513025732, 12.805486866512092],
              [92.802655530860108, 12.809647086846224],
              [92.801981349755508, 12.812968979954386],
              [92.799921929237186, 12.816290923041249],
              [92.798613813171812, 12.819078571278776],
              [92.795382766747053, 12.817241103222619],
              [92.79416971403252, 12.820447038353851],
              [92.795442682185438, 12.823770957885479],
              [92.791650300186291, 12.826022941859884],
              [92.788732001362675, 12.826973389467749],
              [92.78724846568187, 12.823557445641114],
              [92.785651468994544, 12.818955307429789],
              [92.782402669702194, 12.820232297959384],
              [92.782056488427187, 12.823763226428493],
              [92.782478671311026, 12.828248494996158],
              [92.782785204569819, 12.832407802218027],
              [92.782314155789081, 12.83691614956091],
              [92.782412603122836, 12.840750818656741],
              [92.782390367103474, 12.844817019064765],
              [92.780742285809367, 12.849951945873141],
              [92.780719999176085, 12.854018265862923],
              [92.783836022339173, 12.855855906986225],
              [92.785378325914451, 12.852859852738844],
              [92.786150194254986, 12.84921144482035],
              [92.786502848309013, 12.844609687061027],
              [92.787813350170836, 12.841195419198337],
              [92.790945015075465, 12.839686516250861],
              [92.792546683045188, 12.843219676097895],
              [92.791770557532288, 12.84805304411586],
              [92.792081813289755, 12.851352125564711],
              [92.796203251684744, 12.849217054533069],
              [92.799439409586711, 12.850194225559616],
              [92.800928015823146, 12.85307666059537],
              [92.803120135646566, 12.856493896627409],
              [92.805170880330834, 12.859492854344433],
              [92.803863052144834, 12.862583881827128],
              [92.799958245729599, 12.863766711577924],
              [92.795630234088009, 12.864833787502533],
              [92.791837035809621, 12.866853415006544],
              [92.794641573984961, 12.869434987864775],
              [92.795919671263519, 12.872316491475384],
              [92.794495667201886, 12.875198397641888],
              [92.794804339732323, 12.878847496521576],
              [92.79704720516618, 12.881195671627037],
              [92.794984530401322, 12.885052952826825],
              [92.79313654596757, 12.887840908582342],
              [92.796150226854905, 12.891049259865797],
              [92.799491430597683, 12.890400361890746],
              [92.801991770543779, 12.888380253039172],
              [92.807584187634788, 12.893077099918337],
              [92.810389719391566, 12.895867393760657],
              [92.814059204675473, 12.895125297939364],
              [92.817636551888882, 12.894359417642729],
              [92.821969090899529, 12.892454860517853],
              [92.822438849777242, 12.887736775199169],
              [92.824285882815829, 12.884855409715831],
              [92.828060721702002, 12.886344139126239],
              [92.832376984694108, 12.887949619332069],
              [92.836046141676761, 12.887206980541771],
              [92.837638095561587, 12.883673987751139],
              [92.836361234963832, 12.880791448940643],
              [92.835419474162279, 12.876283436334869],
              [92.834573876173607, 12.871378965990949],
              [92.83383849528461, 12.868171890452899],
              [92.83340856043128, 12.864847569683581],
              [92.835699623764441, 12.862059763518879],
              [92.838932780794224, 12.863873851798962],
              [92.841835267956881, 12.866012492735047],
              [92.843594875597091, 12.861968776399276],
              [92.842848438875279, 12.855856447232068],
              [92.842992897379872, 12.850395150520388],
              [92.840517975294716, 12.847188284522376],
              [92.836651499498387, 12.845257706670061],
              [92.835151191839344, 12.839819989895947],
              [92.837863309067941, 12.837775520145646],
              [92.841211502060943, 12.840030030613608],
              [92.843452377739027, 12.842703023957542],
              [92.847346103045993, 12.843773467906715],
              [92.850789780471317, 12.846120453132819],
              [92.850936160946858, 12.849746308462496],
              [92.85166576540135, 12.854463974961108],
              [92.853139310433875, 12.860668728215954],
              [92.853351182014407, 12.865479101736494],
              [92.854291622026821, 12.870081172574157],
              [92.855027957034793, 12.873705757864888],
              [92.856844200493711, 12.877146451141481],
              [92.859461571216471, 12.874891776159902],
              [92.860028687970043, 12.869546723689057],
              [92.863156111326845, 12.869012392468759],
              [92.864006026978529, 12.872754298454831],
              [92.864738048037353, 12.876937574711397],
              [92.868306449466402, 12.877681631581897],
              [92.872089416372248, 12.878006442380212],
              [92.872611468584481, 12.881841390207553],
              [92.869350104705177, 12.885583135225415],
              [92.864266281124586, 12.887722003521642],
              [92.860817520860863, 12.886443272678722],
              [92.856265131229435, 12.88516407771985],
              [92.852721848177566, 12.88421123995303],
              [92.848399716168913, 12.883768959485304],
              [92.844288155857058, 12.883767983677396],
              [92.842323317961203, 12.886882116330188],
              [92.841287913066978, 12.891901849869354],
              [92.838895586188698, 12.895644173987106],
              [92.83499669797601, 12.895526950219196],
              [92.831320496256765, 12.892852831665618],
              [92.83013050774791, 12.895850424117061],
              [92.830200151483922, 12.900568780849067],
              [92.826524313613135, 12.902380900676519],
              [92.822091858262056, 12.900891733431818],
              [92.817554490148325, 12.901309114614691],
              [92.813876332193601, 12.903654501757673],
              [92.811577909712611, 12.907396165693262],
              [92.809936074459671, 12.911160956971807],
              [92.810035252861496, 12.914995388371986],
              [92.806582003425603, 12.914575885857092],
              [92.803666622468583, 12.909973116762417],
              [92.799565229455808, 12.90804173906851],
              [92.796749935790572, 12.911364728298347],
              [92.795737942270577, 12.916174921226679],
              [92.794641695769329, 12.918963281040925],
              [92.794527478669593, 12.923240617133761],
              [92.794712008014116, 12.928052814041546],
              [92.79665033490889, 12.930610498976185],
              [92.799901255177403, 12.929239688617026],
              [92.801620339292015, 12.933192920612379],
              [92.801367177542758, 12.936934973980213],
              [92.800715721861778, 12.940142943857099],
              [92.800367647742021, 12.943885414641461],
              [92.80028035247517, 12.947115651249419],
              [92.799747186088084, 12.950091188141201],
              [92.799681979342893, 12.953485550354836],
              [92.799101463166593, 12.95683249108254],
              [92.795269382498546, 12.956761222623777],
              [92.791211689682783, 12.954782798709161],
              [92.788265621407646, 12.956153237286886],
              [92.789445530821666, 12.959872816020312],
              [92.789710242240005, 12.963197027885592],
              [92.788729526556523, 12.966521904692192],
              [92.788172442563067, 12.96972866145901],
              [92.789353265485659, 12.972985185363145],
              [92.790889193854738, 12.975867645022953],
              [92.793175536038007, 12.979728949214397],
              [92.791462060896109, 12.983424758660572],
              [92.792078159810615, 12.987214334474491],
              [92.793938382317137, 12.990864905798821],
              [92.796794764575694, 12.993633333457646],
              [92.799250621111781, 12.991611561806842],
              [92.800213080406706, 12.987078684223926],
              [92.80315832262373, 12.986104167762566],
              [92.806613535227996, 12.986408039018695],
              [92.807499311118761, 12.983293170938762],
              [92.806624936502999, 12.979433459984362],
              [92.8061953103756, 12.976107881018295],
              [92.805160385152178, 12.971852820984578],
              [92.805365604300803, 12.968296719778312],
              [92.808192606967324, 12.967089243074641],
              [92.810083024032338, 12.970088916544007],
              [92.810607990085757, 12.973064408527572],
              [92.811505903379995, 12.976691800138775],
              [92.812620417128244, 12.979714853138029],
              [92.814909653836438, 12.98280713570705],
              [92.818022540453541, 12.980902401967207],
              [92.821231728832558, 12.978485163598112],
              [92.82284062548193, 12.981461780755247],
              [92.821696263328576, 12.98467005809629],
              [92.819774635224732, 12.987947220407612],
              [92.818112581631127, 12.990992507360405],
              [92.816218140908916, 12.993526288586368],
              [92.814527322606438, 12.997919060982774],
              [92.816130541765503, 13.00182618310801],
              [92.820004196201936, 13.003059825719607],
              [92.821945004201083, 13.000525829789604],
              [92.82570056176138, 13.001759144343163],
              [92.829392684979098, 13.001830057661639],
              [92.832341748617239, 13.00001789436779],
              [92.834923272641092, 12.996623589592742],
              [92.837565263960158, 12.994648347921622],
              [92.841703076054827, 12.994764716671892],
              [92.840864830175249, 12.997857067943158],
              [92.839910894790549, 13.000833301866066],
              [92.837781068679774, 13.00366908915124],
              [92.838915829297022, 13.007086958045194],
              [92.839837960372975, 13.011039786245028],
              [92.839065780908385, 13.015062821635967],
              [92.839989018946554, 13.018410511815958],
              [92.840909851791508, 13.022433974830435],
              [92.842397372153798, 13.02627045069636],
              [92.843368724996807, 13.029874623197172],
              [92.841119641977713, 13.032524413389492],
              [92.837845980085376, 13.03333840279986],
              [92.834718876502762, 13.033011493475994],
              [92.832617628692148, 13.030058022827602],
              [92.831025146421055, 13.033196238893064],
              [92.827520733883702, 13.033196283339283],
              [92.824508035719049, 13.033706406586361],
              [92.823397737442477, 13.029683399095527],
              [92.82341502785907, 13.026451874152185],
              [92.823204820467041, 13.021266527916477],
              [92.822328193307257, 13.017917482496967],
              [92.819152955697632, 13.017916354757405],
              [92.816318009148901, 13.020333936211385],
              [92.814118864627588, 13.02279777002121],
              [92.813653966809738, 13.026378627708361],
              [92.813561152316666, 13.030540046222775],
              [92.813160476861384, 13.035353752370318],
              [92.810723134095213, 13.038328362879172],
              [92.807270642168106, 13.03739634601653],
              [92.807169726353152, 13.034188440251192],
              [92.806995742903183, 13.031141622978147],
              [92.805768721223004, 13.027188657847189],
              [92.806401575264474, 13.023236398606167],
              [92.809162061914321, 13.021609160202702],
              [92.811575136469116, 13.018889728264028],
              [92.812272227688382, 13.015611627745587],
              [92.809768985782696, 13.013192438461111],
              [92.806149730403206, 13.012843024678094],
              [92.802195978445567, 13.013189699506965],
              [92.803187689765736, 13.01697970827643],
              [92.800662220142954, 13.018768497295122],
              [92.797856016468174, 13.020255941319135],
              [92.795885391853048, 13.023719555683984],
              [92.793907155864318, 13.01960289733641],
              [92.789765938435593, 13.019716957896051],
              [92.787050450321871, 13.022039795226476],
              [92.786561204034598, 13.025643907389435],
              [92.787361005076065, 13.02994588045593],
              [92.788633616897556, 13.034132869068731],
              [92.788848132609374, 13.037969177944635],
              [92.789134999487601, 13.041457191636454],
              [92.789582713750249, 13.045875562913613],
              [92.789438864107055, 13.050874433203122],
              [92.789886706970805, 13.055294063178245],
              [92.789853923929499, 13.061712050060859],
              [92.789358779667538, 13.066130089406384],
              [92.789578994751892, 13.069269144226814],
              [92.790020675480264, 13.074734200129425],
              [92.791761600561998, 13.079037592280107],
              [92.79233432832153, 13.082061681883644],
              [92.792894650683252, 13.087294321800654],
              [92.791567329180779, 13.093573002808874],
              [92.793435314485464, 13.096388502111495],
              [92.796513696054845, 13.097319755722559],
              [92.800762956412825, 13.094740009116185],
              [92.800781802289194, 13.091136404305114],
              [92.802220919792489, 13.085787235046705],
              [92.802133650850692, 13.079972798226066],
              [92.802270546594698, 13.076368416688187],
              [92.80346073799447, 13.07346260613844],
              [92.806179078315253, 13.07125474924163],
              [92.809358863477556, 13.070441726769879],
              [92.812896330844197, 13.068931701717958],
              [92.815377827308708, 13.066956153413415],
              [92.817243900845043, 13.069863241410534],
              [92.818639227329413, 13.073236218274689],
              [92.820155881755667, 13.075910778579551],
              [92.822495490666256, 13.078354064393043],
              [92.823794321473059, 13.08235441199054],
              [92.825024165359125, 13.08556394670285],
              [92.825171644416386, 13.089447979513762],
              [92.826285313754155, 13.092239349760597],
              [92.828272868314841, 13.094797842924388],
              [92.82560709529767, 13.096378834533489],
              [92.825942933896428, 13.099680956641883],
              [92.82599774318993, 13.103122429811416],
              [92.828694394900694, 13.104705333520181],
              [92.826491516744937, 13.107844804812265],
              [92.825417415411295, 13.110751459333542],
              [92.82894356011316, 13.111799363434249],
              [92.832118248682974, 13.112149141548958],
              [92.83476997599459, 13.113894386416369],
              [92.832448387774377, 13.1166148350136],
              [92.829024584203154, 13.119172003665092],
              [92.824500039687791, 13.120286858423684],
              [92.821423128805364, 13.123309461550763],
              [92.819055833933973, 13.12598435209005],
              [92.815522294687085, 13.126912892855609],
              [92.811916041279858, 13.127771865637353],
              [92.809619404243264, 13.130050593475683],
              [92.811539133747289, 13.132539787113719],
              [92.814789777780589, 13.131843916124453],
              [92.81832407058576, 13.131100461967272],
              [92.818706970599692, 13.134590214916116],
              [92.822361298194195, 13.133544577587358],
              [92.824213820116285, 13.1303348462994],
              [92.827219203457133, 13.127079012774399],
              [92.830361104397625, 13.124824786836353],
              [92.833663139584715, 13.123429526993332],
              [92.836662059263048, 13.121569852107571],
              [92.839311562559331, 13.12343109720794],
              [92.842971022315851, 13.121454372307156],
              [92.848558075690647, 13.119293205966255],
              [92.850619324090133, 13.121688225328676],
              [92.852766800455868, 13.125177272004093],
              [92.848599034702133, 13.125525398934132],
              [92.846634856901147, 13.12789773325782],
              [92.849214986490097, 13.129875402803798],
              [92.851559705766903, 13.131806108044042],
              [92.850791968935781, 13.13471387689399],
              [92.848076725423525, 13.136527481194193],
              [92.846219176500568, 13.140551241425788],
              [92.845400606869461, 13.144435160076709],
              [92.847926901777399, 13.148110585656068],
              [92.850094274238629, 13.152554875698705],
              [92.85093687688348, 13.156402862151426],
              [92.845233665665404, 13.154949834457426],
              [92.842943492142467, 13.151064478258101],
              [92.839474040461909, 13.152785035396535],
              [92.838423983688287, 13.155763067950977],
              [92.833680464403301, 13.153458813932593],
              [92.83089230092591, 13.15529583375262],
              [92.826738593136014, 13.157457332215795],
              [92.823267677855924, 13.15461827168309],
              [92.818773103064601, 13.154151885279816],
              [92.816900101808869, 13.156663606868095],
              [92.813669704443384, 13.157802130479483],
              [92.810295201617706, 13.159172930147159],
              [92.809590900458403, 13.163522973038127],
              [92.810610604509421, 13.166709546555516],
              [92.811297893958169, 13.170711777880937],
              [92.81092596198522, 13.174038472668531],
              [92.811142460755406, 13.178038778075175],
              [92.814723254956306, 13.177458874388007],
              [92.814342211748041, 13.183297910686626],
              [92.814306002430811, 13.19036972180513],
              [92.814378901151471, 13.194370830664646],
              [92.813362032320015, 13.20460787418388],
              [92.816571340486533, 13.217335156736326],
              [92.81915358248466, 13.223548039874235],
              [92.820004235211655, 13.227852227291084],
              [92.82173069559137, 13.231109972920102],
              [92.823829962048208, 13.235391687688438],
              [92.824049645061763, 13.238718792109772],
              [92.824833331352266, 13.241813662927216],
              [92.826440287822592, 13.24558385064789],
              [92.829892592671229, 13.248097994825422],
              [92.832564726399468, 13.245911467524339],
              [92.832817974092848, 13.24225887475267],
              [92.835031566240275, 13.237931191497736],
              [92.839439686851392, 13.237233689013706],
              [92.842671730863074, 13.236094305902116],
              [92.84570586024023, 13.232441881547897],
              [92.846995711507518, 13.228673567481405],
              [92.847251280655769, 13.224555130125887],
              [92.847383655951916, 13.221228827195389],
              [92.847520323225282, 13.217692056832734],
              [92.845913115745418, 13.213922429593543],
              [92.845582304582678, 13.209013488835923],
              [92.848019162908116, 13.206826464109399],
              [92.850249781278052, 13.203523499005851],
              [92.85003727107221, 13.198498987005532],
              [92.84658258958325, 13.197358263981938],
              [92.844502627317269, 13.194031295533982],
              [92.84843576793422, 13.193798801980259],
              [92.849606610651463, 13.190262532979926],
              [92.850895604311788, 13.186843449730091],
              [92.854576111625747, 13.190146906349881],
              [92.85782967505429, 13.189472522693444],
              [92.861187047295203, 13.186379632535695],
              [92.864679752623658, 13.185122408612127],
              [92.865343030557042, 13.189240153594975],
              [92.862194727947781, 13.192543412690528],
              [92.860460673517963, 13.195638507522517],
              [92.860436941847354, 13.200779699944469],
              [92.861455077953465, 13.204781058478178],
              [92.864107360935947, 13.206270772145453],
              [92.8671168295797, 13.207642518968969],
              [92.86863464223957, 13.210272340030921],
              [92.870594783172862, 13.214156996191496],
              [92.868716574805404, 13.218042675653027],
              [92.864095964397379, 13.219066195536435],
              [92.859799362701594, 13.22078761507178],
              [92.858746878180256, 13.224207416281756],
              [92.85769149874784, 13.228209160601773],
              [92.855020105796314, 13.230396035132705],
              [92.85476781481853, 13.233699708480421],
              [92.856141079391605, 13.237144074373305],
              [92.858438545712815, 13.23954031514892],
              [92.861091237045301, 13.241704017323871],
              [92.858299001890941, 13.244450086943326],
              [92.854959114967841, 13.243309717049472],
              [92.853200932611372, 13.246403565810049],
              [92.852616570311056, 13.25005745368132],
              [92.852364038341662, 13.25347722872273],
              [92.856532667177163, 13.25382672031254],
              [92.859752041656236, 13.255642057959268],
              [92.863691601415823, 13.254850858559585],
              [92.867271048918383, 13.25520031832013],
              [92.869352792743328, 13.258178735442296],
              [92.871414388532258, 13.2609007520778],
              [92.87220170022583, 13.263879492495526],
              [92.868727369709191, 13.266276484934792],
              [92.864913147128831, 13.265601642364736],
              [92.860981200330983, 13.264786758690745],
              [92.856696159087178, 13.263995067248398],
              [92.853347839332002, 13.264902726466872],
              [92.84998105897759, 13.268904616868497],
              [92.847638235528521, 13.271091726127256],
              [92.844052907591248, 13.271997762292383],
              [92.838852180772648, 13.270391791619472],
              [92.835151057411409, 13.270740481119859],
              [92.832826031431381, 13.274159994463565],
              [92.830269593558768, 13.276556115172882],
              [92.827126573455033, 13.278044227072613],
              [92.824245736807683, 13.27953295886036],
              [92.821711147485573, 13.28209206451827],
              [92.820541811079352, 13.285047092235489],
              [92.822911135797995, 13.287234314781703],
              [92.822990680587424, 13.290283892591267],
              [92.821042628205007, 13.293074970303037],
              [92.821377703142332, 13.296984877341895],
              [92.824541201577745, 13.295869156483382],
              [92.827641355229034, 13.293239986412059],
              [92.831980912444536, 13.292474038098529],
              [92.834873668293568, 13.293847792899255],
              [92.840610913324667, 13.291498850593458],
              [92.841842104809146, 13.295081981744167],
              [92.844589596744598, 13.29254610082814],
              [92.846948464083297, 13.296921305173022],
              [92.844719683328677, 13.299620359638345],
              [92.841210818983015, 13.299178514582362],
              [92.836263794884076, 13.298479221945879],
              [92.833418206296244, 13.30213147274093],
              [92.834720226548612, 13.305878753084732],
              [92.836819903931811, 13.310323855254167],
              [92.836895410429875, 13.313908087386045],
              [92.832236877396099, 13.312161769504199],
              [92.827742054753301, 13.311020041059676],
              [92.821656487250394, 13.311902683274322],
              [92.818457571283687, 13.315113163490071],
              [92.819402925094437, 13.319464885991849],
              [92.822029839219994, 13.321910279728602],
              [92.823333221120478, 13.325145238848403],
              [92.82157003105668, 13.329054567515904],
              [92.819424763642431, 13.333685951518602],
              [92.821435136237554, 13.337084851017696],
              [92.824520477484512, 13.337620592484701],
              [92.827146630927245, 13.34067074006315],
              [92.830575235525515, 13.343208026740182],
              [92.831451175233568, 13.347142532230151],
              [92.831951422925457, 13.351052002366856],
              [92.833091772264368, 13.354008537276135],
              [92.833852821785158, 13.357336950212149],
              [92.834539396144081, 13.361783728708353],
              [92.835312211797316, 13.367532291409455],
              [92.835551805502817, 13.371373013587768],
              [92.835621244521676, 13.376680373878189],
              [92.836051302817822, 13.380521611833416],
              [92.839301786324128, 13.381312976596048],
              [92.842751570912057, 13.379917077052822],
              [92.845076948073654, 13.376775999350707],
              [92.844808831480847, 13.373726184806539],
              [92.844209602927663, 13.370746864268082],
              [92.844232407406182, 13.366231647839445],
              [92.845665426377337, 13.362553378378127],
              [92.84735609240002, 13.358993197113758],
              [92.850544120362287, 13.357760136718882],
              [92.850691555634597, 13.361692957088341],
              [92.852275221702669, 13.36579009528268],
              [92.854644687577505, 13.368396880567852],
              [92.853919267423521, 13.371888860607067],
              [92.853551297955647, 13.374937849031172],
              [92.853440403234572, 13.378243644610567],
              [92.854391789836271, 13.381828385829339],
              [92.854436444989034, 13.387018482198457],
              [92.857330731624899, 13.388206952973009],
              [92.857765436233493, 13.391186337438029],
              [92.852123040677327, 13.392373195046321],
              [92.843920636458407, 13.396468707052307],
              [92.840430163903562, 13.396468453978652],
              [92.836812949977599, 13.398073617719872],
              [92.834763518442585, 13.402426118881035],
              [92.835426947983777, 13.40654675052998],
              [92.840752284822727, 13.417279537147984],
              [92.84839195937225, 13.417932812443247],
              [92.852548314379703, 13.416885646561921],
              [92.856436812172873, 13.417537639084959],
              [92.858021433211789, 13.421519445196729],
              [92.860834721670486, 13.425616442837645],
              [92.866313950519924, 13.429201468173352],
              [92.870328850388418, 13.433183639849378],
              [92.873804317191883, 13.436745026353716],
              [92.875654138479376, 13.439399439132165],
              [92.876060984677409, 13.443636510423742],
              [92.875760666070576, 13.44736212746596],
              [92.870785635258272, 13.451319914845921],
              [92.867671694422825, 13.456488604816213],
              [92.867512812088165, 13.460213864608001],
              [92.867397588044554, 13.469876521597056],
              [92.871157580641977, 13.47276427856179],
              [92.869465565690717, 13.476465863212585],
              [92.870438315124346, 13.480308135182071],
              [92.87365830011943, 13.483474433980817],
              [92.877328928349215, 13.485872062036616],
              [92.881361976203962, 13.486268266729194],
              [92.884568030581264, 13.486873685409128],
              [92.884726643070678, 13.483473286908632],
              [92.881857748318993, 13.480959431745777],
              [92.883217638681558, 13.477792168827339],
              [92.886712031262277, 13.477256845203408],
              [92.891442708059145, 13.47513710602226],
              [92.894467637257563, 13.473809432258472],
              [92.898375533905366, 13.471015074302324],
              [92.900962847501162, 13.472876784703294],
              [92.899952736865217, 13.476904545812866],
              [92.899793520004494, 13.481025849131752],
              [92.897777848379064, 13.483332289729624],
              [92.897950284024475, 13.486917973960148],
              [92.900082409987419, 13.490364154288979],
              [92.901155638390748, 13.493203884069462],
              [92.902272935075999, 13.496393925199733],
              [92.904215316773843, 13.500375351429195],
              [92.906138542322495, 13.50314609309547],
              [92.908085139170055, 13.505800214189742],
              [92.910951567272392, 13.508709721583829],
              [92.914960850540908, 13.509850566692275],
              [92.921219763318518, 13.508614294871855],
              [92.919793005132234, 13.516438329970834],
              [92.912931032339969, 13.520655386668041],
              [92.913342798634645, 13.528923367296404],
              [92.909649372595013, 13.536609361534513],
              [92.903963189070836, 13.546555081367359],
              [92.912959733224525, 13.546249852791878],
              [92.920127133291643, 13.548646465732899],
              [92.928984969838041, 13.547734372341209],
              [92.937670946385069, 13.548638546006199],
              [92.944064687230025, 13.549543894806748],
              [92.948171164740231, 13.555713828166533],
              [92.955807512753267, 13.553589751725617],
              [92.960957871239742, 13.558407188095204],
              [92.968906975537323, 13.554489990545221],
              [92.97170538147121, 13.545614591254093],
              [92.979352638549642, 13.539879793171695],
              [92.981600556528548, 13.5450021712532],
              [92.987247621926372, 13.550120696512828],
              [92.984232527967222, 13.554408022944335],
              [92.984662172128893, 13.559089498457194],
              [92.985213653760866, 13.563491034291921],
              [92.985102029297337, 13.567450819311446],
              [92.98562467064238, 13.572946577938188],
              [92.985160953102479, 13.577185890394375],
              [92.985498146509741, 13.581145660297484],
              [92.988229624875416, 13.583285695216841],
              [92.989424401637606, 13.579697882395427],
              [92.991164638394707, 13.575457593102074],
              [92.994646967027649, 13.572590012664618],
              [92.998857439814401, 13.570512873921153],
              [93.001229862016686, 13.567901828244436],
              [93.003246979163904, 13.565385062710719],
              [93.005619180949253, 13.561959623601311],
              [93.006106386735667, 13.557906253058505],
              [93.007942916186138, 13.553222997448932],
              [93.01295038299321, 13.552310525628734],
              [93.01395587001376, 13.555546600419161],
              [93.014393156992867, 13.558713646447059],
              [93.015004280032031, 13.56590969309536],
              [93.014803611614767, 13.569240605758802],
              [93.015352363177158, 13.573827846251698],
              [93.015332598774464, 13.579301563618797],
              [93.01577132370646, 13.582282185718148],
              [93.019785202530045, 13.582627431225333],
              [93.023254946244705, 13.58308936781664],
              [93.025413668120891, 13.586953865878131],
              [93.027973374350765, 13.584505315015956],
              [93.029830999104007, 13.579915305877012],
              [93.030837073911783, 13.576046982173116],
              [93.0325018741718, 13.572621779112314],
              [93.03478707644291, 13.566959426461425],
              [93.03572221309436, 13.562905563034722],
              [93.037110325913261, 13.557687529507321],
              [93.038023315332552, 13.55309861514967],
              [93.039050190616678, 13.550045537990451],
              [93.039512159596271, 13.545806396647336],
              [93.04052334561564, 13.540589092515553],
              [93.040142352286466, 13.53404580087744],
              [93.038882674099497, 13.529994834240743],
              [93.038519360348999, 13.525756786690287],
              [93.039548588197192, 13.521982732387984],
              [93.040271643621054, 13.517580586393594],
              [93.038570504785838, 13.510923093720724],
              [93.037665214341544, 13.506708728533498],
              [93.037416362738497, 13.503635779425018],
              [93.036886849371953, 13.499584827923739],
              [93.036332902115106, 13.496185129041066],
              [93.034429145117045, 13.493835248020508],
              [93.031081658356683, 13.492233014204306],
              [93.027877465138033, 13.491141671182264],
              [93.027086308762748, 13.487649945715232],
              [93.030540277512515, 13.485480127916802],
              [93.033098407319514, 13.482776347157705],
              [93.032852306190037, 13.479098466486157],
              [93.032579730141194, 13.475582991413447],
              [93.028311653215184, 13.474608679302115],
              [93.024843882956816, 13.474775884022897],
              [93.020641802221746, 13.475059596122465],
              [93.017289720025332, 13.475249582456689],
              [93.01437252626198, 13.472714672733357],
              [93.01118324550896, 13.473718696269367],
              [93.008627582112624, 13.475700890839207],
              [93.004697196496977, 13.479033461192643],
              [93.000682383901108, 13.480294923093844],
              [92.999962614150633, 13.476872802406662],
              [92.998609878022052, 13.472915852801872],
              [92.999707253094016, 13.469492283036431],
              [93.001655413229528, 13.466160504282399],
              [93.0051052111356, 13.464551172508793],
              [93.004861143290668, 13.460685739852751],
              [93.003909880431692, 13.456286681609988],
              [93.002837897529105, 13.452236889362618],
              [93.000462770174792, 13.45016637769058],
              [92.998635137951538, 13.453404628950031],
              [92.99680414179447, 13.456921708180177],
              [92.993616077067912, 13.457995714794201],
              [92.990057054140493, 13.456927466550242],
              [92.990069070051007, 13.453412065907635],
              [92.985153810305221, 13.455581028553189],
              [92.983895559372101, 13.451810307230994],
              [92.984077310621544, 13.447130240395081],
              [92.984733029125593, 13.442101335623132],
              [92.983945066261029, 13.438865563855481],
              [92.982588962876974, 13.435700543956086],
              [92.981236600275068, 13.431300566305341],
              [92.981579210449638, 13.427995523642242],
              [92.983947178642282, 13.425735088852154],
              [92.987579148515721, 13.42601100494147],
              [92.99049809780719, 13.427801174387476],
              [92.990474636369811, 13.433994643319439],
              [92.991289567774373, 13.441078799245576],
              [92.99673443640468, 13.4382259509088],
              [92.999574815143319, 13.435336672751186],
              [93.000676353754116, 13.430748925540225],
              [93.003167571252092, 13.427417951409103],
              [93.00534608837954, 13.425087520552715],
              [93.009549751563753, 13.423826318921822],
              [93.011803375311274, 13.426617516557195],
              [93.01470071041426, 13.43434483553794],
              [93.015868067938811, 13.437928826893677],
              [93.016391382966759, 13.443073284090328],
              [93.018220408311407, 13.446214357990653],
              [93.016451981232038, 13.452595527609935],
              [93.014900603223452, 13.457626408094672],
              [93.014601673729032, 13.461584605956542],
              [93.014375263899311, 13.465636213593609],
              [93.017265120201472, 13.468963416076926],
              [93.020364987527302, 13.46635148639394],
              [93.023389554173406, 13.465440632738231],
              [93.02456004253591, 13.468419765178483],
              [93.027488396218104, 13.467322901759223],
              [93.028400294221711, 13.463363012705335],
              [93.030699883222539, 13.459960658229381],
              [93.031067178672799, 13.456165442390319],
              [93.03171791203421, 13.452486082986042],
              [93.032198835707561, 13.449529293735036],
              [93.028744357856255, 13.445737698607848],
              [93.024557110685393, 13.442599229591181],
              [93.021094644696944, 13.440530683904884],
              [93.023491481000633, 13.436663007446294],
              [93.028501986624164, 13.433957902073361],
              [93.033119433521549, 13.429365926902884],
              [93.035585456738147, 13.425498509796441],
              [93.03833317169439, 13.42253830383682],
              [93.039426179010093, 13.419743895294534],
              [93.038988767200124, 13.416694215012425],
              [93.037727321073305, 13.413622619153355],
              [93.040661124907118, 13.410756157863736],
              [93.047383550435043, 13.410468940707142],
              [93.05019917619029, 13.414957974113742],
              [93.053367839408864, 13.419820058710044],
              [93.056728486779932, 13.423772613302653],
              [93.058086667146085, 13.426914042956852],
              [93.061368807979036, 13.42583933044482],
              [93.06036494331056, 13.422511484912032],
              [93.059645783865136, 13.418996895474738],
              [93.058668171736414, 13.41504065499155],
              [93.05558318194295, 13.413158937984127],
              [93.056329010677743, 13.409199708284863],
              [93.0609710239777, 13.410195221941219],
              [93.064240466232974, 13.412868664506268],
              [93.067424498174674, 13.413236163673893],
              [93.067249220134926, 13.409092018285721],
              [93.064713002943648, 13.405859694158691],
              [93.06099290248811, 13.403443863105625],
              [93.056984297784268, 13.403448957612504],
              [93.053806709227757, 13.401567597622213],
              [93.050313968371682, 13.402037574872178],
              [93.047106586947208, 13.401809088607607],
              [93.043716820343107, 13.39974148846828],
              [93.042219525324484, 13.396740522555861],
              [93.040955374817457, 13.393576138000205],
              [93.037674240226977, 13.394510419662526],
              [93.035097651021005, 13.39635339142907],
              [93.031418936764183, 13.396240360934218],
              [93.027340660484796, 13.395314391018115],
              [93.02430058229497, 13.394967983933006],
              [93.023488205734878, 13.391523268831936],
              [93.020350885306769, 13.391643521550154],
              [93.015958414122423, 13.393115009933155],
              [93.01321750543616, 13.394793958663662],
              [93.010126479664578, 13.39468079812252],
              [93.007551253208234, 13.396428789240547],
              [93.004150479893525, 13.397293020624533],
              [93.001571015722746, 13.399483456422985],
              [93.002739057291407, 13.402531626013008],
              [93.00341253963694, 13.405581325864825],
              [93.002927112261574, 13.409097266176104],
              [93.000372437261447, 13.411077796513684],
              [92.998309741840487, 13.414129064281216],
              [92.995144533191592, 13.415621934385754],
              [92.991457605154437, 13.417185353680113],
              [92.988964777309036, 13.41546386078188],
              [92.989658759604907, 13.412460611067363],
              [92.991890226999459, 13.409106684472901],
              [92.993788055640707, 13.405822622061981],
              [92.995498556118193, 13.40284051796869],
              [92.995911284693889, 13.39948826525546],
              [92.993703476884633, 13.396999401376533],
              [92.990268249409581, 13.395047802478386],
              [92.99040095069455, 13.391415831479259],
              [92.988998680341581, 13.387785397890202],
              [92.986245459119672, 13.386344296316762],
              [92.982022845973432, 13.386278453123177],
              [92.984443980355451, 13.382481833021759],
              [92.987259331477247, 13.38010553065374],
              [92.991458529030808, 13.379705794085584],
              [92.995485591822771, 13.380843492449802],
              [92.999979533646794, 13.383841448709912],
              [93.003769984640527, 13.385560904606102],
              [93.007212347919406, 13.385510844080445],
              [93.010527863766882, 13.382132864504641],
              [93.011252413058855, 13.377081269038271],
              [93.011029738232423, 13.373542611001927],
              [93.010570871042106, 13.370215342958842],
              [93.008722419019037, 13.366236447453678],
              [93.005923836894937, 13.364051361745638],
              [93.002251414388013, 13.362610659462968],
              [92.999213107289691, 13.361869250314323],
              [92.995608261912537, 13.360894945116144],
              [92.992621008086246, 13.359337910212103],
              [92.990293204577739, 13.357082460317084],
              [92.988724113639179, 13.354499552958382],
              [92.987084170648089, 13.3516390493657],
              [92.984769538262071, 13.346752407565065],
              [92.984971076454642, 13.343516943282516],
              [92.984207812677028, 13.339769961899229],
              [92.980766105859402, 13.339493297663667],
              [92.977736044523937, 13.342544878989617],
              [92.97630859675975, 13.345897886811139],
              [92.974477535390889, 13.349926223803783],
              [92.972837609774814, 13.353440988381028],
              [92.973175796113807, 13.35718882279507],
              [92.96946783910208, 13.358937246697263],
              [92.967676523721806, 13.364664195887766],
              [92.962657751890632, 13.363922074607453],
              [92.959375298819722, 13.35894395186032],
              [92.957536256005255, 13.353195338120049],
              [92.956677511086895, 13.349844161832157],
              [92.956033928842871, 13.34584123968456],
              [92.955275526401536, 13.340861703028791],
              [92.958479622209083, 13.335878824822435],
              [92.966306661534247, 13.329775780120901],
              [92.969285073872001, 13.327795721812082],
              [92.972367911935976, 13.328933144459587],
              [92.975342443286252, 13.327837492986864],
              [92.978153030258071, 13.326229227254837],
              [92.981840997689588, 13.323805962578128],
              [92.984137134374791, 13.320871949521493],
              [92.984621845111761, 13.317869659429698],
              [92.984873055686805, 13.313773747025566],
              [92.983989291809408, 13.310260227662269],
              [92.980986612728941, 13.306864491134339],
              [92.978355832573385, 13.304492677475611],
              [92.975799033054614, 13.301329887614358],
              [92.972728164624712, 13.297073341723992],
              [92.968945271325111, 13.294422430342701],
              [92.965630815654563, 13.292260702859288],
              [92.964061596517382, 13.289515633440448],
              [92.965651597968048, 13.286605450765622],
              [92.968907408535472, 13.285672622081224],
              [92.971993644210031, 13.286252733706586],
              [92.975886564266588, 13.284899447487781],
              [92.980293194179453, 13.284896591397953],
              [92.983359455414316, 13.284265438077629],
              [92.985727753362838, 13.281052310009926],
              [92.987059701595967, 13.27767756920494],
              [92.989170649789969, 13.274207990113799],
              [92.99226543563114, 13.272018767391527],
              [92.995377796060325, 13.271969058414465],
              [92.998162029690562, 13.270454637030964],
              [93.001505124782398, 13.271289395575135],
              [93.005224635004836, 13.272681598320039],
              [93.003326149997235, 13.276220374578831],
              [93.001689750019892, 13.279177689631048],
              [93.001107743357508, 13.283017893452925],
              [92.999519402828383, 13.285648808812864],
              [92.998021981385492, 13.289186450567179],
              [92.997395758773621, 13.292910806563151],
              [92.997689823343435, 13.296447653555804],
              [93.000841938827094, 13.297585833275228],
              [93.001325222914218, 13.29451331633223],
              [93.002753763562737, 13.290578558212307],
              [93.006275604375361, 13.288039140453193],
              [93.00734900268229, 13.284454369439242],
              [93.007974451179663, 13.2805210031279],
              [93.008364234930539, 13.277355773105452],
              [93.011874514178018, 13.277492254661263],
              [93.015094722603976, 13.279746445558468],
              [93.017489520344427, 13.282443500120507],
              [93.020265057380357, 13.283836241899335],
              [93.023157773881252, 13.285532463421632],
              [93.027444257436642, 13.285737403030781],
              [93.02934063441036, 13.282989285629801],
              [93.031776687373252, 13.280403111112191],
              [93.034337666608721, 13.282215501218122],
              [93.036001120455964, 13.285424223799239],
              [93.039362501423042, 13.287492104715595],
              [93.042567605650774, 13.287580869275459],
              [93.044109631859342, 13.284787043074767],
              [93.044473945922462, 13.281574703506692],
              [93.043376954067242, 13.278457765822528],
              [93.040650146329043, 13.276227605203113],
              [93.039623034614493, 13.273343970796406],
              [93.039328964304985, 13.270109663142144],
              [93.038230783123083, 13.267062222917659],
              [93.037536247279391, 13.263665587472611],
              [93.038234086938928, 13.259778974185833],
              [93.039732914184455, 13.255146723218193],
              [93.041302036207696, 13.25142157957151],
              [93.043265509261843, 13.248883115263439],
              [93.04647172007536, 13.248042116258475],
              [93.047496479838969, 13.251880174822658],
              [93.046117187793669, 13.255511251843203],
              [93.045890244010153, 13.259653681636076],
              [93.045525391788601, 13.263610181358112],
              [93.048390458010488, 13.266235198541207],
              [93.051069478702303, 13.268419952035618],
              [93.05285159497744, 13.270906698949315],
              [93.055931933422571, 13.272625259775625],
              [93.05934812843978, 13.273179203972054],
              [93.060136952879475, 13.269594419613554],
              [93.058216759108191, 13.266083146084224],
              [93.056222198323482, 13.263060581354335],
              [93.055718087596546, 13.258919828872539],
              [93.055682804488654, 13.255243016609947],
              [93.055531570379827, 13.251451315651639],
              [93.055542084886881, 13.248402859107513],
              [93.055246283937194, 13.245122352257356],
              [93.053469502522205, 13.240819631066849],
              [93.049918287306525, 13.23949769840247],
              [93.048679166601048, 13.2365444249932],
              [93.04819611637555, 13.233240955044074],
              [93.046157647496159, 13.230009509918251],
              [93.04376202667838, 13.227732734086706],
              [93.042287538391989, 13.224849908306712],
              [93.043288983407237, 13.221196002736601],
              [93.043323391960101, 13.218008532186738],
              [93.042392388327158, 13.214612459499849],
              [93.041485676625427, 13.211403158533408],
              [93.039684440325232, 13.207566222369769],
              [93.037128542305695, 13.204614481951769],
              [93.035442011832657, 13.201801528169339],
              [93.034252617002579, 13.198708364152617],
              [93.032757510602735, 13.195243354242841],
              [93.031637333189565, 13.192057438227135],
              [93.031203018244412, 13.188545028424853],
              [93.03104932433321, 13.184916791099377],
              [93.033156846899658, 13.181494209899522],
              [93.034581305518472, 13.178143465647594],
              [93.035701281327277, 13.17446624797285],
              [93.035877344282824, 13.171395596411395],
              [93.035135987781828, 13.167929754800069],
              [93.033332988027837, 13.164698947303808],
              [93.032685553358036, 13.161767826773788],
              [93.03411021525153, 13.158161662772191],
              [93.035555754046953, 13.155135538703011],
              [93.036156406898726, 13.151924495771491],
              [93.036285174615742, 13.148900860454876],
              [93.036930344200186, 13.145898872689649],
              [93.036967071864524, 13.142363245415931],
              [93.03459754431195, 13.139668170295364],
              [93.0324885943906, 13.136809923197983],
              [93.031232759430182, 13.132647948219841],
              [93.031245406153957, 13.128694051015586],
              [93.030997786653458, 13.125716623742198],
              [93.030444674998122, 13.122600283148209],
              [93.030764139071266, 13.118367354189628],
              [93.031222008357844, 13.115226738523965],
              [93.031308628764805, 13.110807357668252],
              [93.03256776825566, 13.107456400934089],
              [93.033901690573401, 13.103129735411562],
              [93.03506571558097, 13.099779328062603],
              [93.036160634273116, 13.096521713652679],
              [93.036579012285557, 13.091125282146628],
              [93.034781271148859, 13.086964760421315],
              [93.030999430192338, 13.084852407792939],
              [93.028442061576911, 13.082576563386725],
              [93.026142943963492, 13.080602252984891],
              [93.023656178039602, 13.078395895509825],
              [93.020700481428491, 13.07635160799758],
              [93.023600814804084, 13.074140140017303],
              [93.02715783883103, 13.072926378857002],
              [93.029215302103154, 13.069970997611735],
              [93.027082192296589, 13.0676944342565],
              [93.024858960340239, 13.064348182259693],
              [93.022893136579469, 13.061582914188547],
              [93.021022272301749, 13.058468526508328],
              [93.018706612779297, 13.054889785021468],
              [93.015750127719471, 13.052451594461919],
              [93.012795076861593, 13.049827021407756],
              [93.010333602354464, 13.04755062817606],
              [93.008604958993658, 13.044528671919819],
              [93.007132694074144, 13.041438224084709],
              [93.006721716016784, 13.038321993929676],
              [93.004758403390753, 13.034650405843344],
              [93.001544120617652, 13.032630482626503],
              [92.998498914385536, 13.035399696022271],
              [92.995592675618482, 13.038750961189796],
              [92.992950716500133, 13.041031546059685],
              [92.990133515091927, 13.03931360787135],
              [92.989251365196282, 13.0361517248145],
              [92.985564786878228, 13.034481042899927],
              [92.982526777783292, 13.03513499633153],
              [92.977545351008658, 13.034277513890364],
              [92.974435900585092, 13.035140019912932],
              [92.970878922510366, 13.036492037328617],
              [92.966820299766241, 13.039517489940847],
              [92.96628788038872, 13.043307751921629],
              [92.963761215583702, 13.045937808633662],
              [92.961821049791496, 13.042660159334538],
              [92.961600157180072, 13.03935787283368],
              [92.96213268995696, 13.03556767532586],
              [92.962732698956245, 13.032218613913068],
              [92.963830362424588, 13.028195664051879],
              [92.966149283696438, 13.025054749764649],
              [92.969124938772126, 13.022192877914842],
              [92.972402871719211, 13.019958455343918],
              [92.970741636895738, 13.017332054445989],
              [92.967640603098729, 13.016752857497549],
              [92.963143299840922, 13.017546370355822],
              [92.959090761935087, 13.019827262915411],
              [92.956890854849675, 13.022688672105504],
              [92.955512967342841, 13.026131089763119],
              [92.953194133809959, 13.029713521563817],
              [92.951885642157848, 13.032923568233883],
              [92.950645657361179, 13.037434240100772],
              [92.946665987574931, 13.038367118184143],
              [92.943467567782136, 13.038228531700229],
              [92.940778204120946, 13.03995075921017],
              [92.940761128309077, 13.044113763156766],
              [92.941993348824184, 13.047321910854977],
              [92.938077001952138, 13.050253968310356],
              [92.935879476699668, 13.052835729859636],
              [92.939566150799521, 13.054043319422762],
              [92.942769841433915, 13.053251594476686],
              [92.946681040263769, 13.051830070239587],
              [92.949932063161299, 13.050526975192893],
              [92.952968609359047, 13.050315562178096],
              [92.954037519953644, 13.053825737675099],
              [92.95258606781411, 13.057338781979654],
              [92.951045096361796, 13.060688339572424],
              [92.950746676203963, 13.064339381083004],
              [92.952547526495863, 13.067059096763568],
              [92.955651542269678, 13.067429609627716],
              [92.958112469574232, 13.069707081431567],
              [92.959890857471009, 13.072170691780505],
              [92.961031088172959, 13.075612036356809],
              [92.961744443292815, 13.079541439047999],
              [92.959264288673111, 13.08212494864029],
              [92.956232829618102, 13.08112657869529],
              [92.953629509702651, 13.078546409834443],
              [92.948203485476782, 13.081967888354026],
              [92.947744281491879, 13.085201004599712],
              [92.947302369168838, 13.089410665885238],
              [92.947144942322851, 13.093642963115373],
              [92.947405900676273, 13.098737208386707],
              [92.947386931407621, 13.10322482802348],
              [92.947301113191543, 13.107016846227273],
              [92.946806220737471, 13.112924275902502],
              [92.946370055895358, 13.115924230970892],
              [92.946496947561741, 13.119505944482295],
              [92.946037089270462, 13.12287917767371],
              [92.942473686542073, 13.126614902325539],
              [92.94216119227319, 13.120509083816012],
              [92.941496392901783, 13.116485676023435],
              [92.939933019121582, 13.113346329819551],
              [92.935979172625807, 13.113347925983403],
              [92.93224454237496, 13.117047847995385],
              [92.929197693642564, 13.119398230320309],
              [92.928415228846873, 13.115025998484601],
              [92.931018389035145, 13.111582781594588],
              [92.933295214034388, 13.107883883082483],
              [92.932980566409725, 13.104092882358305],
              [92.932761007873594, 13.10030263080567],
              [92.933142567460578, 13.093719331572901],
              [92.932146738225711, 13.089929307457846],
              [92.92909843167439, 13.087139519989455],
              [92.925162552480799, 13.083002263701506],
              [92.924166930032086, 13.079211182711834],
              [92.921920741609867, 13.076421603823277],
              [92.917854001954638, 13.075539905960111],
              [92.915016913550957, 13.078540388240379],
              [92.915001660142607, 13.082005268659236],
              [92.917034686821694, 13.085585746363448],
              [92.919471512769903, 13.089892675693632],
              [92.913389417195958, 13.090029894257697],
              [92.910124144575548, 13.088914317031204],
              [92.907288288598664, 13.091496714242894],
              [92.905136282687408, 13.09417131861338],
              [92.902418524502608, 13.096637914190941],
              [92.901383931375008, 13.101986207939603],
              [92.89731016641035, 13.102429719766313],
              [92.893801491727714, 13.102546278062807],
              [92.893009306144748, 13.106128290773317],
              [92.893772555697794, 13.109128856991591],
              [92.894676925968326, 13.112477629561916],
              [92.895108723171276, 13.115594283309568],
              [92.896321984580965, 13.123083427077589],
              [92.893603704127173, 13.125757913622378],
              [92.889074882557722, 13.128107511668928],
              [92.886356570877155, 13.130667170805612],
              [92.883725739436045, 13.134365058464789],
              [92.882087351848895, 13.137599211399047],
              [92.880145199768208, 13.1401578660026],
              [92.881042517214468, 13.144622979475722],
              [92.876953540281832, 13.147973685045871],
              [92.878303031491797, 13.151648150019668],
              [92.879179276137918, 13.15534717116785],
              [92.880526674875014, 13.15958073325643],
              [92.877239539878389, 13.162698109475622],
              [92.873729539641516, 13.163140189900883],
              [92.870798654524577, 13.160255540992766],
              [92.870817114460252, 13.156463660284382],
              [92.868448228291285, 13.15432362547379],
              [92.866319796527122, 13.151439542425322],
              [92.868712272457898, 13.148648131812264],
              [92.868856325081225, 13.142833030459521],
              [92.868759144549855, 13.138250498897628],
              [92.872467610744522, 13.140948822010298],
              [92.875089561265511, 13.13892484185709],
              [92.877743572341487, 13.135017471924346],
              [92.879221968108354, 13.13078352917049],
              [92.882628822688304, 13.127108688069711],
              [92.884582295484918, 13.122084585788928],
              [92.886176503385286, 13.118176979599896],
              [92.882238442785876, 13.114944668386276],
              [92.878646209649034, 13.113037601026337],
              [92.873213660057303, 13.112037702254371],
              [92.869501021494472, 13.110805098805521],
              [92.867702897491554, 13.107781744355719],
              [92.871102529856756, 13.10510625235675],
              [92.874277266558821, 13.105896876358615],
              [92.878106110379932, 13.107222734426838],
              [92.880567138652168, 13.10980387059192],
              [92.884759619703487, 13.10912923373016],
              [92.886112900487163, 13.106222450043351],
              [92.885354699429627, 13.102315206799855],
              [92.88186428910619, 13.098524425425936],
              [92.883291439678899, 13.095291896421077],
              [92.886229916674182, 13.096290938531169],
              [92.889488029263788, 13.098988511918357],
              [92.892653296957377, 13.096639232539133],
              [92.895725750914039, 13.093615532362492],
              [92.891227304911922, 13.089150961277417],
              [92.890112086342043, 13.086034209386074],
              [92.888758598838464, 13.083244463091106],
              [92.892836528161624, 13.082010458003436],
              [92.895765641401766, 13.084359105826461],
              [92.899035122440509, 13.085032887323553],
              [92.902440564089616, 13.080892471221327],
              [92.905828278769306, 13.081450350546724],
              [92.906851735287972, 13.078542524484821],
              [92.908449007617435, 13.073751372196485],
              [92.904292105995296, 13.072078967777678],
              [92.902873058281401, 13.068521106745825],
              [92.896885931841425, 13.069918303791702],
              [92.891953204915964, 13.063824944850678],
              [92.889705471611506, 13.061267973177726],
              [92.887133612041225, 13.057803308651705],
              [92.884215004068011, 13.056202162225235],
              [92.879655438591044, 13.061943165310996],
              [92.876933476001867, 13.065733434539681],
              [92.874116130777125, 13.064175556771971],
              [92.86870659572601, 13.064059779066344],
              [92.868008910017693, 13.067082141987559],
              [92.868224321767116, 13.071547945835809],
              [92.860882169580833, 13.071872376528141],
              [92.859850842487504, 13.075779663023873],
              [92.855190892235299, 13.081244853220214],
              [92.851930891469891, 13.078685420963032],
              [92.849446622075362, 13.081476137097519],
              [92.847386471880782, 13.084033753558131],
              [92.845015378069306, 13.087941274726999],
              [92.842394244280143, 13.089614586818332],
              [92.839129555393228, 13.088497398456342],
              [92.840727279001172, 13.084358843748332],
              [92.843568627349441, 13.08068503377557],
              [92.845274329726536, 13.078010077491134],
              [92.848794531691766, 13.075104784967371],
              [92.853110784976366, 13.071496793268471],
              [92.848267153642524, 13.067638533798283],
              [92.847371395598401, 13.063174290833881],
              [92.842394752212869, 13.065614966500743],
              [92.83779165593964, 13.063939284596101],
              [92.837454285377859, 13.060591104373691],
              [92.836627972322887, 13.056474820297659],
              [92.839896361471432, 13.056824005548794],
              [92.842140878620683, 13.059824743701654],
              [92.843617409721631, 13.055918218543985],
              [92.843539125861156, 13.052802622546242],
              [92.84546271218241, 13.04922117334781],
              [92.84770462146551, 13.052453592794532],
              [92.848581720607669, 13.056151478762608],
              [92.852186270546795, 13.059593119080224],
              [92.852970853795853, 13.062849532380053],
              [92.855873588732194, 13.065966130746508],
              [92.86118575281246, 13.067198079879759],
              [92.861980926559625, 13.063058942547149],
              [92.865949680163922, 13.059710548053079],
              [92.865284906194674, 13.055920526105385],
              [92.862271275617317, 13.051455676531813],
              [92.859456689773424, 13.049897406900946],
              [92.855639371504566, 13.046106535683805],
              [92.862412786148681, 13.046548677356974],
              [92.8658017101138, 13.046106900979703],
              [92.863654747848472, 13.042525833210933],
              [92.863462358815298, 13.038526511680388],
              [92.867858771022497, 13.039084793029909],
              [92.869982981778946, 13.042317758927414],
              [92.872227524848384, 13.045665381571208],
              [92.874590490477189, 13.048339762144863],
              [92.879595289451515, 13.050663086923384],
              [92.877993546112748, 13.04519980633648],
              [92.882004649859454, 13.045325195692563],
              [92.885424590699444, 13.045432016402152],
              [92.887905959869656, 13.04810629324138],
              [92.889115251583178, 13.051245046217003],
              [92.890134984744066, 13.054593528891477],
              [92.892711449034238, 13.057383238657881],
              [92.893621632397881, 13.053686051940348],
              [92.897240302595904, 13.054918037522205],
              [92.900169112281986, 13.05759114985544],
              [92.902963102033283, 13.058939057474632],
              [92.907035769118437, 13.058263775692968],
              [92.909189591611479, 13.055356472007533],
              [92.908639809765475, 13.051892852181618],
              [92.90719344759394, 13.049218514239257],
              [92.904275458575398, 13.043987617665247],
              [92.903055598021552, 13.037848739501056],
              [92.900604227333517, 13.033710032595943],
              [92.895524613188613, 13.033153572616737],
              [92.896742156918762, 13.029362881669845],
              [92.896074546932937, 13.026015212376937],
              [92.892257061354641, 13.022550316838013],
              [92.889774141379064, 13.020086528225155],
              [92.883582739695058, 13.01597175378282],
              [92.879863426223693, 13.016971534009187],
              [92.876032918848239, 13.016298127966017],
              [92.875365519096235, 13.0127404818901],
              [92.8777556997114, 13.009601553300309],
              [92.875634101520831, 13.005928343433697],
              [92.876423568833673, 13.002696301385557],
              [92.876800871580784, 12.997674477897444],
              [92.876017992811697, 12.99388512183997],
              [92.877393704419518, 12.991187731225759],
              [92.876284344558712, 12.987398244438021],
              [92.872908028251231, 12.984956855954895],
              [92.872125589040991, 12.981376500033452],
              [92.874975822902115, 12.975123076446815],
              [92.875313780741763, 12.971100272621374],
              [92.872989070024857, 12.967427032815975],
              [92.86992140928875, 12.969775670065646],
              [92.866094355281135, 12.968776133324448],
              [92.867240694358742, 12.96519621400253],
              [92.869303459643731, 12.961407224700473],
              [92.868405441896329, 12.957268305653376],
              [92.867745412602375, 12.952711823993241],
              [92.867201715047145, 12.948132969294079],
              [92.869593051673121, 12.944668876823386],
              [92.869495986038885, 12.940089201546179],
              [92.86477601328906, 12.938880513537988],
              [92.859468707950143, 12.93808961844088],
              [92.856658568686129, 12.940763353079598],
              [92.855954430389204, 12.945668167074091],
              [92.855486255294721, 12.950130641162643],
              [92.855105839669761, 12.955826125977087],
              [92.855533444398475, 12.959964368745554],
              [92.855753216465999, 12.963079701742425],
              [92.852356608285618, 12.965427846806502],
              [92.849073666879235, 12.968309947079474],
              [92.845691192421995, 12.967867685902986],
              [92.842316042682981, 12.965751517876987],
              [92.838482198640833, 12.965750759541535],
              [92.836475607329803, 12.962635369626881],
              [92.836608637145218, 12.959496786186042],
              [92.836155689421446, 12.956148246308988],
              [92.835841416498397, 12.953150236679342],
              [92.838451391726977, 12.948245563957071],
              [92.840286105530623, 12.942992021201336],
              [92.839858399010055, 12.939435169946751],
              [92.83930872554491, 12.936181566775668],
              [92.842355370897067, 12.933392726434441],
              [92.84631346593865, 12.931394130275681],
              [92.848469026694161, 12.927931403150799],
              [92.849170693875422, 12.923817092106139],
              [92.850666407652895, 12.920794787195021],
              [92.846935636832484, 12.919469913506061],
              [92.843339160643609, 12.919469582258584],
              [92.839729290959113, 12.917679113512502],
              [92.841440581460461, 12.913540854626394],
              [92.84506247347781, 12.913101187652487],
              [92.849107793922272, 12.912543123402648],
              [92.852503246458696, 12.910196577838192],
              [92.852635483826731, 12.906965462281544],
              [92.852321023716755, 12.903851050638206],
              [92.852997525354851, 12.900155453884217],
              [92.855054653060989, 12.897273525350622],
              [92.857889615224863, 12.894367853727116],
              [92.860062383892938, 12.896924862166671],
              [92.860113218785287, 12.901038649158119],
              [92.86141457143772, 12.904223533574731],
              [92.864906489864524, 12.901108984519752],
              [92.869154497046921, 12.89746035694867],
              [92.87324601445593, 12.8969957024284],
              [92.876891744049075, 12.896042674571978],
              [92.879430256531805, 12.891115005312466],
              [92.882591090814486, 12.888534815985647],
              [92.886464447725032, 12.889208793424743],
              [92.88933613653937, 12.893461234496577],
              [92.891554681326781, 12.896180030329287],
              [92.89421727223052, 12.900154417034104],
              [92.894454603148034, 12.904477733212337],
              [92.893760991755286, 12.907591561598251],
              [92.892940237231457, 12.912055542564008],
              [92.892853498072952, 12.915704461720635],
              [92.892400820326642, 12.922515129854196],
              [92.892126912747798, 12.925699386193431],
              [92.895388347399347, 12.927256333065964],
              [92.89711539467595, 12.924420169453242],
              [92.899665078988292, 12.91691198755726],
              [92.901723066808074, 12.913727195627629],
              [92.905560542451141, 12.912122069370161],
              [92.908922213551719, 12.912051298928803],
              [92.913221814761513, 12.912515160827217],
              [92.916233619149764, 12.911444775602888],
              [92.913640267952786, 12.908122498052169],
              [92.910706337578986, 12.907309561322267],
              [92.907705285347646, 12.905822936955881],
              [92.904984240203575, 12.904335390944498],
              [92.903093382943254, 12.901639447586096],
              [92.901252910580965, 12.897735458044473],
              [92.903873811048456, 12.895294530703184],
              [92.904427939778216, 12.891854280468733],
              [92.903413800930409, 12.887601574816291],
              [92.904944595155087, 12.881442720446913],
              [92.908551932764141, 12.878372913047755],
              [92.912709808241289, 12.878930296135575],
              [92.913987525402931, 12.882300214610563],
              [92.915074216870181, 12.886413346463552],
              [92.918692405560677, 12.88655089636749],
              [92.919669940469632, 12.883320140632637],
              [92.924180940603136, 12.877903251058871],
              [92.925912903410975, 12.873859173081962],
              [92.925811814667398, 12.870070624831859],
              [92.925152180385837, 12.86451683652264],
              [92.926799575530595, 12.858706701410608],
              [92.929813494157699, 12.857241027579311],
              [92.934722326078472, 12.857238815065212],
              [92.937480639089728, 12.85479721599096],
              [92.935566664968903, 12.852218512904656],
              [92.934507907039361, 12.846828290159808],
              [92.931661825704609, 12.841971687280399],
              [92.929487593269371, 12.839812329144829],
              [92.925680698219523, 12.8346772381576],
              [92.92310865649219, 12.83196037399849],
              [92.922302879498702, 12.827917402599008],
              [92.925570163032035, 12.827381246086279],
              [92.927629781550692, 12.823453474627545],
              [92.929963338276693, 12.821292002564947],
              [92.934074249082215, 12.821568441561194],
              [92.932266072086662, 12.826565332423153],
              [92.930354178848987, 12.829262087975106],
              [92.931962304124895, 12.831955887078673],
              [92.93592919189571, 12.832512233410561],
              [92.939331184254058, 12.833440680850996],
              [92.942868050474232, 12.836273131500899],
              [92.942883829133777, 12.831951829603232],
              [92.944009942428963, 12.826699268861248],
              [92.945390102903872, 12.822492892464036],
              [92.945835824653741, 12.816683090298175],
              [92.949820099019661, 12.812916683928304],
              [92.95092419323727, 12.807363079694207],
              [92.94847255809421, 12.803599482367565],
              [92.946459596017277, 12.796560695474176],
              [92.944825559464604, 12.794005510089324],
              [92.94114396475905, 12.792659632712565],
              [92.936103943302072, 12.791036132043738],
              [92.934072228526404, 12.787923517566831],
              [92.931908473204786, 12.783464019805336],
              [92.929461681895091, 12.779282568049009],
              [92.927177904391229, 12.774822089748657],
              [92.932638912934337, 12.771845935882792],
              [92.936758387770013, 12.769010575942859],
              [92.940307833776146, 12.767939725191688],
              [92.945358332252923, 12.767518790874789],
              [92.947708496423232, 12.761035800033369],
              [92.949085859182716, 12.757387471862398],
              [92.952496983980055, 12.755364847620278],
              [92.957013335669629, 12.753200894245568],
              [92.961393598706209, 12.749412426948743],
              [92.961131816242599, 12.744835581217691],
              [92.964714221719674, 12.741046873938155],
              [92.964989882379186, 12.736864635677366],
              [92.962963109983789, 12.732940361341088],
              [92.962696543691521, 12.7292932043758],
              [92.962989690597169, 12.726320191510446],
              [92.965448934381129, 12.721462810427571],
              [92.96982550269999, 12.71848687187267],
              [92.973262193991204, 12.716045642064842],
              [92.976414444457916, 12.714301081339338],
              [92.977908473118191, 12.70983974280381],
              [92.977805168868088, 12.706332347070013],
              [92.974517338831348, 12.70700854533775],
              [92.972184974281305, 12.709704327614293],
              [92.969313784545506, 12.71172785042215],
              [92.966322200521105, 12.708222685390858],
              [92.962648856148789, 12.705529685484569],
              [92.962265055641666, 12.701744369850664],
              [92.958303355031987, 12.700538914033386],
              [92.956134812149415, 12.697148812101496],
              [92.960111370501068, 12.694730264421327],
              [92.962318179617455, 12.688504384530063],
              [92.962617949953554, 12.683928568340578],
              [92.962638744081872, 12.678516702041243],
              [92.96223961385526, 12.672850122807723],
              [92.960612974723517, 12.669065071848967],
              [92.959693033804101, 12.664606718090255],
              [92.960107833398908, 12.660286719121673],
              [92.961090500592078, 12.655292733945112],
              [92.96110214636542, 12.652064117687702],
              [92.959073288298271, 12.649348956810311],
              [92.957596145362032, 12.643543138975502],
              [92.956942127372074, 12.636669662497791],
              [92.956679453178921, 12.631816740104055],
              [92.956299748254082, 12.627613575395211],
              [92.95588995164853, 12.624107921520531],
              [92.950014414340103, 12.627339120183651],
              [92.947427331375337, 12.628965812592176],
              [92.943192484485209, 12.632358215747715],
              [92.939508807277988, 12.63236072058959],
              [92.939102138159541, 12.628830942453835],
              [92.941184889759427, 12.624394310220854],
              [92.94295234711366, 12.621954949340394],
              [92.945837439973758, 12.616543019410454],
              [92.950219952759454, 12.611292146951676],
              [92.953074252222265, 12.612777038089224],
              [92.954603598113962, 12.605739489213976],
              [92.954086216071389, 12.600468856910027],
              [92.95590202623579, 12.592388002639906],
              [92.959336661672921, 12.583470204706193],
              [92.961829541395332, 12.575782314576609],
              [92.963476335907671, 12.568607210976515],
              [92.966096281797462, 12.563892856275716],
              [92.96854917809884, 12.560245731207088],
              [92.970207981318595, 12.555786454053754],
              [92.972271319033027, 12.549447060106624],
              [92.973393055243747, 12.544593701178256],
              [92.975589826259167, 12.539995821549551],
              [92.975063876580819, 12.53674613235027],
              [92.974655619807919, 12.533379753393831],
              [92.973706029551863, 12.530549199943287],
              [92.973463058794962, 12.526764366065933],
              [92.97170995799209, 12.519337332236404],
              [92.969409350471111, 12.514487189055393],
              [92.967237843168974, 12.512191408006265],
              [92.965501492264963, 12.507062311281619],
              [92.964697305679181, 12.502744923032981],
              [92.964726016124573, 12.49601280909239],
              [92.963930597367337, 12.489653436864517],
              [92.962986336709221, 12.485197408618955],
              [92.959999676558198, 12.482507432956865],
              [92.956591658347975, 12.484946976053569],
              [92.955080143406335, 12.48817302099817],
              [92.954382456866995, 12.49223566725221],
              [92.954225979951104, 12.496693348405236],
              [92.949595333777296, 12.499782953767303],
              [92.945097784712601, 12.499924084996795],
              [92.941687143803904, 12.497094860794855],
              [92.941026753238972, 12.49277675075443],
              [92.939830253593087, 12.487369590516026],
              [92.939027056242622, 12.482936719193461],
              [92.936036385195393, 12.481034369693674],
              [92.933168908138228, 12.483195109560716],
              [92.930583233412364, 12.485215261242786],
              [92.927572686405554, 12.487932041100279],
              [92.922527377347265, 12.48995283178516],
              [92.91924665182637, 12.489954953853228],
              [92.915711920294171, 12.489282681076601],
              [92.911644020306014, 12.48738034891961],
              [92.908796186711811, 12.484828392036301],
              [92.906066566258303, 12.48213591859467],
              [92.902405453362036, 12.478074927037403],
              [92.899843334060066, 12.475104432505331],
              [92.9009411605862, 12.470393076345594],
              [92.900277102049429, 12.466888187816394],
              [92.901943131787391, 12.460667077585347],
              [92.905630298702562, 12.458926335881239],
              [92.910523351147916, 12.459458896390634],
              [92.914880638199904, 12.459457540960782],
              [92.920626739703437, 12.457969617513255],
              [92.924694410469414, 12.459848802833852],
              [92.929721241471611, 12.461749838585209],
              [92.93517676151933, 12.462419957533148],
              [92.938712700114749, 12.463230961753716],
              [92.941950985472417, 12.467128262202563],
              [92.946576504899568, 12.470654216826357],
              [92.950103985143301, 12.472926639251403],
              [92.954747665966892, 12.471438909656154],
              [92.95626422021725, 12.467260566006429],
              [92.954498918773183, 12.463616891599219],
              [92.949613382837398, 12.461321645891122],
              [92.94701988360265, 12.459304288895746],
              [92.941049506832769, 12.458773738597637],
              [92.936412384530968, 12.458241920982749],
              [92.935609115833259, 12.454737712825676],
              [92.939567207216569, 12.454852240198647],
              [92.938834664132898, 12.450814533242948],
              [92.937065677805634, 12.44784438136243],
              [92.931889948612266, 12.447846637409935],
              [92.927282841450463, 12.445968148110451],
              [92.925112598855719, 12.443811687606486],
              [92.920057313610727, 12.443000810076031],
              [92.91598141916495, 12.443141825214415],
              [92.915569612590204, 12.446366934213382],
              [92.913378430886752, 12.449082932923131],
              [92.914298350841733, 12.453399934717522],
              [92.90968618853833, 12.452449442399198],
              [92.908462618041597, 12.448666716698604],
              [92.906982503477082, 12.444350532342547],
              [92.904961138652055, 12.44045190781484],
              [92.904578487550083, 12.437064203313136],
              [92.906779810352802, 12.431934942295261],
              [92.910464292937533, 12.430053859779528],
              [92.91617682486914, 12.430725328495507],
              [92.92066941432283, 12.431396767193462],
              [92.921757911969877, 12.428565508819606],
              [92.917952214766927, 12.425874375606472],
              [92.919218232280585, 12.420211290011672],
              [92.917590679780119, 12.417357387820775],
              [92.915833222177071, 12.412507644949377],
              [92.914770223004396, 12.409004465992131],
              [92.914037416694725, 12.405477267786843],
              [92.913488127705705, 12.402112882912629],
              [92.909954619343083, 12.401719499690355],
              [92.907089956134683, 12.40346089291795],
              [92.907967157961707, 12.406453554380283],
              [92.907935798029797, 12.413856767323129],
              [92.909017807566514, 12.417777882226378],
              [92.905866416015485, 12.421004168020396],
              [92.904381949643366, 12.426496141371629],
              [92.898489245223075, 12.426413136915361],
              [92.896575341859162, 12.43033488610029],
              [92.89914161552214, 12.43260878861304],
              [92.900482420078632, 12.436391496716398],
              [92.896687542420437, 12.436671489535492],
              [92.892735074912977, 12.435186408091733],
              [92.889333887408384, 12.436393846715228],
              [92.890533723130403, 12.44017607333828],
              [92.881964674887911, 12.444587156483117],
              [92.877703070107771, 12.444332081834919],
              [92.871682422643659, 12.444819121533159],
              [92.863632485131731, 12.448068832909183],
              [92.858603199834036, 12.451781357074726],
              [92.853061903220691, 12.454264382063188],
              [92.847527027209466, 12.460739429806472],
              [92.844751867802898, 12.462734783726102],
              [92.842714951778618, 12.467701344597083],
              [92.844193684158256, 12.471670551754993],
              [92.845534021207882, 12.475638957021575],
              [92.843178999685222, 12.478053605334029],
              [92.842081602952973, 12.482207945595951],
              [92.839113208372027, 12.485363822474168],
              [92.839838551189317, 12.490609954632902],
              [92.842265927836763, 12.492583031075117],
              [92.844616743376022, 12.495578602856694],
              [92.847255353489288, 12.497830336336897],
              [92.849092050998507, 12.500476080448882],
              [92.851096341593887, 12.502728268029264],
              [92.852508208009866, 12.506396917576302],
              [92.84938731415744, 12.507556209232447],
              [92.846207081618388, 12.505814743339274],
              [92.842608546110043, 12.503887282241074],
              [92.837265102446608, 12.50430445946245],
              [92.83273988052494, 12.504651573514568],
              [92.827185935411038, 12.504650177600382],
              [92.824091732768053, 12.504973764988954],
              [92.820904083003072, 12.505135460452852],
              [92.817368648045601, 12.504391647474803],
              [92.817128322818959, 12.501233812533089],
              [92.819676135750655, 12.497823319784775],
              [92.821120861595261, 12.494411211117217],
              [92.823814667305513, 12.490187194846174],
              [92.822078808264948, 12.485521822369865],
              [92.821612978283397, 12.480693608436086],
              [92.824796212952194, 12.481042230619627],
              [92.828045623778834, 12.482529381517647],
              [92.832019019979356, 12.479861010375348],
              [92.832628248921779, 12.475126060799308],
              [92.827767491400692, 12.47238620939714],
              [92.822478438232608, 12.471479529904814],
              [92.8187142548379, 12.469806845497297],
              [92.820325135539235, 12.466163744618337],
              [92.82462168629938, 12.464562664819468],
              [92.829726962942019, 12.464658060872233],
              [92.83284330833726, 12.464657918696343],
              [92.833248840938936, 12.467653257966184],
              [92.835583303379011, 12.469742096605888],
              [92.837447302772986, 12.466655346644751],
              [92.840228078168664, 12.463406217746394],
              [92.839917736308465, 12.459832520969508],
              [92.843791185796263, 12.457929721535384],
              [92.843618541673109, 12.454936111845903],
              [92.847493811270908, 12.452941293238943],
              [92.850202198648731, 12.450039823407536],
              [92.853561656546816, 12.447882241694142],
              [92.857343495737979, 12.445700472647905],
              [92.868687833317708, 12.438855514479163],
              [92.877748974223962, 12.434631155016874],
              [92.882768716879113, 12.432890665187442],
              [92.885001008234923, 12.43613877213199],
              [92.889321594740409, 12.428920953372431],
              [92.893338206686067, 12.425927156870275],
              [92.896610601661877, 12.422212555395125],
              [92.894128174605086, 12.416991649264402],
              [92.88761539307896, 12.417480618897837],
              [92.883723566697157, 12.41845551760928],
              [92.879731203352478, 12.415810600309884],
              [92.876783844881231, 12.415044297441304],
              [92.876145231048923, 12.411471217025701],
              [92.873347771387259, 12.413722430391356],
              [92.872321000598177, 12.417876520438075],
              [92.868222563927048, 12.418131250563238],
              [92.863036226998787, 12.415253633203006],
              [92.856994451095602, 12.420475006024168],
              [92.854468951515329, 12.424697411694037],
              [92.84545835033687, 12.418222360576154],
              [92.841468870840956, 12.415250999646181],
              [92.839433287290518, 12.419961708220303],
              [92.834151169924795, 12.422443438724395],
              [92.828617226573911, 12.423950233976438],
              [92.824602301403033, 12.425920960985142],
              [92.823125035574577, 12.431026728828757],
              [92.819479570283676, 12.433949622351463],
              [92.817424881473102, 12.437545444469071],
              [92.817913526803281, 12.44269761004597],
              [92.819417727490872, 12.446179706401647],
              [92.820363855337433, 12.449220125064421],
              [92.818918433381938, 12.452469741919668],
              [92.815611954463165, 12.453396269760104],
              [92.812839585503539, 12.454811609653783],
              [92.809854118220898, 12.452117826079665],
              [92.809474646422856, 12.448682073166284],
              [92.809186107694146, 12.445317685294359],
              [92.809510101176201, 12.441882132204858],
              [92.810040146363647, 12.438633897665664],
              [92.809189722604359, 12.435663369433907],
              [92.806320926150462, 12.433364328083309],
              [92.80468840098608, 12.43661188337364],
              [92.803268369599223, 12.439303988755649],
              [92.799925710541132, 12.437816825288222],
              [92.796620285207311, 12.438487832460616],
              [92.796670239720285, 12.442433365400904],
              [92.797988400105893, 12.445637301740991],
              [92.798835276622441, 12.449420798120125],
              [92.799657824722729, 12.453482696736934],
              [92.80120811369531, 12.457382056926944],
              [92.800370567752594, 12.460978908086519],
              [92.79752831800468, 12.462300640344376],
              [92.79503643627524, 12.464062813979226],
              [92.797223277811312, 12.467105135163784],
              [92.794612670015056, 12.468913680558423],
              [92.791543335938783, 12.468866372819702],
              [92.789743143030165, 12.472694532189426],
              [92.790774003985277, 12.477151356802286],
              [92.791126675164008, 12.481283102345158],
              [92.790243740899683, 12.484392812744389],
              [92.786230063940707, 12.485876366735202],
              [92.782595810024873, 12.486546913998531],
              [92.779452050246789, 12.487265429340376],
              [92.778788931857349, 12.484177022651965],
              [92.780445528959049, 12.481045395164683],
              [92.783174529185558, 12.478679596831375],
              [92.784086763284932, 12.474525107124181],
              [92.782366279737076, 12.472017455448785],
              [92.782901120263475, 12.468466093724999],
              [92.790025457216927, 12.463666681663698],
              [92.790744460588144, 12.460231814780016],
              [92.789660446646721, 12.457190196830922],
              [92.787545518406588, 12.453824013419986],
              [92.784980008986423, 12.44757934265329],
              [92.784294782777593, 12.443911689433101],
              [92.784790551332833, 12.438945928496517],
              [92.786497009379445, 12.434955323237777],
              [92.789514440188412, 12.431452884520198],
              [92.793501784514689, 12.430154947674366],
              [92.798219059403124, 12.432710197968815],
              [92.801614638256652, 12.43278139619629],
              [92.805050594258574, 12.429858951313276],
              [92.807785739944336, 12.426263009423112],
              [92.808363293845346, 12.422944502587091],
              [92.810630040020129, 12.419465543253478],
              [92.809979825475722, 12.413570182842525],
              [92.805846482707935, 12.411666018693685],
              [92.802855438691736, 12.410155950814806],
              [92.801724314490059, 12.406953063715747],
              [92.80019725361602, 12.403610131847406],
              [92.798996639799725, 12.400106616405528],
              [92.801302660027375, 12.398135475380812],
              [92.803679469559299, 12.400108853448943],
              [92.804716492625076, 12.403612229373572],
              [92.808180912216173, 12.403776592021133],
              [92.811383469795487, 12.404984984759093],
              [92.815920556353731, 12.405891870632594],
              [92.82074945971334, 12.404988496610649],
              [92.824427683387384, 12.404525553237296],
              [92.829646526940195, 12.404921513360039],
              [92.832448076689687, 12.411512724402792],
              [92.836740770116393, 12.405063065448925],
              [92.83952911962038, 12.400074631209495],
              [92.835768392686063, 12.398101258057979],
              [92.832267264698473, 12.395849808509453],
              [92.834563981295346, 12.39088411759716],
              [92.840591855809279, 12.388402684059844],
              [92.845127303847903, 12.385178696815778],
              [92.848139051885695, 12.381929642629252],
              [92.847665382370948, 12.378449760672495],
              [92.845243653374567, 12.373586928841103],
              [92.851942818360897, 12.374969870115137],
              [92.854713100952395, 12.373230116202821],
              [92.857194874701506, 12.368287694350528],
              [92.856906300580633, 12.364877779298478],
              [92.851608565953143, 12.366454677304629],
              [92.846927246216197, 12.366546882231173],
              [92.843255071103272, 12.365780686893759],
              [92.840808153017647, 12.36341356963368],
              [92.839683084897857, 12.358795931594788],
              [92.842850708913375, 12.357334537107672],
              [92.844314785254994, 12.354666505099615],
              [92.845242880835841, 12.351395617058639],
              [92.848310453877176, 12.351187919879981],
              [92.848901607514691, 12.354667629355905],
              [92.850129559398781, 12.357567723589337],
              [92.853262435901044, 12.358542306058681],
              [92.856702695608703, 12.358704957511582],
              [92.860538885056329, 12.359007409992959],
              [92.864449224717049, 12.358845279281882],
              [92.866986758890718, 12.356965542721994],
              [92.867237658247078, 12.353091053693907],
              [92.868634776934471, 12.349958825393168],
              [92.871848631546101, 12.348358463451683],
              [92.875992427027001, 12.348149931464887],
              [92.879886674807636, 12.351096229596845],
              [92.883966791679399, 12.349726516736311],
              [92.885966433584713, 12.347314134241065],
              [92.888881533019699, 12.344645114881938],
              [92.88791434359625, 12.340909879728873],
              [92.883605346243769, 12.34176916748741],
              [92.87985550255695, 12.342441912401791],
              [92.877033223127469, 12.340609408223068],
              [92.877193993121196, 12.336062213673012],
              [92.875450155436397, 12.333464586518508],
              [92.871839269072325, 12.335227705531288],
              [92.868694889760903, 12.336828404931907],
              [92.865320562290208, 12.337732789940455],
              [92.864331354846897, 12.33408983628914],
              [92.861180150655755, 12.337129629922464],
              [92.860619926554207, 12.341908770173092],
              [92.859597218591048, 12.345319419813075],
              [92.856215286550324, 12.34768562994307],
              [92.851562494340271, 12.346547789155203],
              [92.848642940007352, 12.345409773198543],
              [92.845982144980908, 12.343809122735642],
              [92.844455825508717, 12.339864591883758],
              [92.847363550575665, 12.338797840614255],
              [92.851610343298461, 12.336734472557257],
              [92.853843678844015, 12.334623275576503],
              [92.854466585592007, 12.331491231012096],
              [92.851644342220666, 12.329680990756518],
              [92.847340236694492, 12.328984535827983],
              [92.842983421983746, 12.329819015360611],
              [92.840749473640827, 12.331952705749185],
              [92.837038868124282, 12.334829263100515],
              [92.833430580977875, 12.335454930662186],
              [92.835159214142308, 12.331488165687867],
              [92.838067887563255, 12.329817751179087],
              [92.839843448029526, 12.325805518838198],
              [92.842085166844882, 12.32230285385871],
              [92.845240182544629, 12.322836221343561],
              [92.850129677749649, 12.323301385720139],
              [92.8543448463532, 12.32283767484901],
              [92.853215799417868, 12.318964182283617],
              [92.850401729954726, 12.315228781123887],
              [92.848034516550484, 12.311283908844066],
              [92.844928552096235, 12.309845241580524],
              [92.841189637845261, 12.30870823902951],
              [92.83741842948703, 12.309774537927144],
              [92.833510805188808, 12.309541602160284],
              [92.830923361081489, 12.307777921852237],
              [92.831311990026336, 12.304738793821437],
              [92.832264902885171, 12.301491576098247],
              [92.829034622639455, 12.301490416496975],
              [92.825110301276936, 12.305131332831536],
              [92.823878433112952, 12.307937481131917],
              [92.82171169344079, 12.310604825485953],
              [92.818652892620349, 12.309676311767616],
              [92.821512788502361, 12.303530063006583],
              [92.824431446896142, 12.300492103633641],
              [92.826903253993066, 12.297221751651543],
              [92.828834420141618, 12.294786343598119],
              [92.828825757501733, 12.289210011515189],
              [92.832680417856295, 12.292885501616498],
              [92.834421542436075, 12.295553628528445],
              [92.837565380886787, 12.29395390303746],
              [92.838890926588718, 12.290613938544562],
              [92.842667523830528, 12.288712432788252],
              [92.845814724361574, 12.286277506792592],
              [92.845431873653325, 12.283099958985719],
              [92.838456289428578, 12.282518553605074],
              [92.842729170984185, 12.275955164880848],
              [92.846485047199621, 12.273589679402166],
              [92.849489146396152, 12.271479356105358],
              [92.852942646541791, 12.268580548947993],
              [92.854536661130538, 12.272454304259352],
              [92.85489728161015, 12.275492967572903],
              [92.855487067017279, 12.279367152977226],
              [92.855555676412777, 12.284701325289891],
              [92.855609416914447, 12.287880078835588],
              [92.855828415848578, 12.291080302290293],
              [92.857494014096488, 12.295186780345821],
              [92.85909390449433, 12.298132713196297],
              [92.863075109559489, 12.297692153767143],
              [92.865544116256913, 12.294954816464656],
              [92.86303308698821, 12.291614919062662],
              [92.861129932124911, 12.28818128360229],
              [92.861288736951735, 12.28430790163879],
              [92.861941273819809, 12.280062931335719],
              [92.8630100276729, 12.276630218982445],
              [92.86487787876375, 12.272315659054236],
              [92.867784296382879, 12.271017658909496],
              [92.871842781061986, 12.27359170331798],
              [92.871594162109076, 12.277150974856099],
              [92.877984155843478, 12.275934739049683],
              [92.87905382233393, 12.272548291091054],
              [92.880496633664904, 12.269045131357435],
              [92.880140891996035, 12.264963046006431],
              [92.88015747772674, 12.261368019458663],
              [92.878371632135313, 12.25816727698415],
              [92.877990170473964, 12.25466491206487],
              [92.876205701209685, 12.251069989903892],
              [92.872299496062951, 12.251070344784399],
              [92.869808383428762, 12.253250789269208],
              [92.867878769268302, 12.255894782330186],
              [92.865377586233137, 12.260440773540205],
              [92.862202772263032, 12.263920075172035],
              [92.860017578531711, 12.266099826897086],
              [92.856861079861901, 12.2659136694985],
              [92.857163271790952, 12.261460010885786],
              [92.858051262842636, 12.256752407796988],
              [92.855021014630964, 12.254386654466423],
              [92.85319674452191, 12.24919083874599],
              [92.854172066259025, 12.246152964458942],
              [92.854375447366252, 12.242464763567112],
              [92.856684193847215, 12.238870432389382],
              [92.859467716680768, 12.234255907080318],
              [92.859951900185877, 12.230568022474365],
              [92.858828942167293, 12.225651240182682],
              [92.860945685692258, 12.223077205326208],
              [92.863439516588443, 12.219969437099181],
              [92.866312022654697, 12.220920938209016],
              [92.867356714156045, 12.217512181617844],
              [92.865944494302028, 12.21410336876774],
              [92.864630142682401, 12.210415373654593],
              [92.859957766501282, 12.20955760025673],
              [92.859515375397265, 12.204363009560691],
              [92.859436125498462, 12.200860969649566],
              [92.85628518221003, 12.199817341248281],
              [92.854284661609867, 12.20246043284104],
              [92.850474194498318, 12.202459821549546],
              [92.847698691416966, 12.200859828790318],
              [92.842736357758795, 12.201994971307629],
              [92.838831535720146, 12.201994413732058],
              [92.835306094931724, 12.201134986853834],
              [92.834227514708459, 12.206353081818042],
              [92.83641241541963, 12.208996883086192],
              [92.839275496872702, 12.211919919209789],
              [92.841058872551613, 12.215607653880246],
              [92.842563115997379, 12.218553341942451],
              [92.84562028539942, 12.219689408455498],
              [92.849057402877861, 12.220061641767419],
              [92.849789925382282, 12.223470155347071],
              [92.846439170453309, 12.224699436461702],
              [92.842249127357377, 12.225533652942174],
              [92.838725986355541, 12.22365369834781],
              [92.836171606162438, 12.2200593771725],
              [92.834813402927139, 12.225531145502591],
              [92.829669253628623, 12.224974189149346],
              [92.828164494965378, 12.221842639626958],
              [92.827973081315037, 12.218456507756772],
              [92.828946938060412, 12.21495497684999],
              [92.829736935734815, 12.211546671753073],
              [92.827371037102196, 12.207765978075523],
              [92.825570178161101, 12.202848671104233],
              [92.825496951331857, 12.198883117120511],
              [92.826755291179808, 12.194987752839094],
              [92.827822445134331, 12.191974247685749],
              [92.83125424217269, 12.19311152792444],
              [92.834494800714026, 12.194804476267796],
              [92.838501616011683, 12.193112516543556],
              [92.842593891341465, 12.192835016597851],
              [92.842890985054552, 12.189635223479586],
              [92.847317946128598, 12.187990418745022],
              [92.851204781496861, 12.186621998757619],
              [92.853358620189539, 12.180918204403804],
              [92.853002974817301, 12.17732421270966],
              [92.852290611928254, 12.169857914767999],
              [92.851304185956892, 12.15919038347824],
              [92.846898515220516, 12.145830153303663],
              [92.839861388537287, 12.149127600320234],
              [92.838088387239509, 12.153346862975505],
              [92.836950998041374, 12.15633824129276],
              [92.839038134432727, 12.159770116461511],
              [92.837381846741394, 12.164012362005396],
              [92.834521417956552, 12.165518791958601],
              [92.831088068167375, 12.165147231029829],
              [92.828530082924459, 12.162108629097457],
              [92.825482176506199, 12.164102323931056],
              [92.825067521905879, 12.167509948450007],
              [92.824770340307168, 12.170918903491511],
              [92.824190992016966, 12.17460514840703],
              [92.823588641114497, 12.178292044379159],
              [92.823756513611784, 12.182349789592996],
              [92.820710626762178, 12.183669629298281],
              [92.818899350238709, 12.181025897441147],
              [92.819034217589049, 12.177246437868037],
              [92.81914707945549, 12.173744955003302],
              [92.818953838426594, 12.170244038238875],
              [92.819085885336222, 12.166929131657817],
              [92.821284157903492, 12.162222631889302],
              [92.82092579231518, 12.158906443516099],
              [92.81788083441154, 12.160320054851104],
              [92.814812055910863, 12.16154746442766],
              [92.810232608034198, 12.161174955425375],
              [92.806905071015507, 12.162773869255435],
              [92.809464922956096, 12.165047328562887],
              [92.81164870032012, 12.167691136427107],
              [92.811906847442842, 12.172142697824778],
              [92.810736338398101, 12.177429278626589],
              [92.807116654927981, 12.176383938610034],
              [92.807691838019707, 12.173463469126766],
              [92.808387687732193, 12.170054976794196],
              [92.803250036293221, 12.169287392070757],
              [92.799261280333695, 12.167314227080414],
              [92.799747172089553, 12.163720196818581],
              [92.80156483704377, 12.160498814937444],
              [92.798449413250182, 12.157296985162896],
              [92.80008302172601, 12.153310683122003],
              [92.803604079865991, 12.154634106202272],
              [92.807502639296018, 12.155957213865687],
              [92.809899199211543, 12.153314693704147],
              [92.814481298130147, 12.153223935493294],
              [92.817136401177052, 12.155126551201851],
              [92.819998720402282, 12.152762208476425],
              [92.822795104144831, 12.150026943077133],
              [92.821948180978268, 12.146525992856407],
              [92.819764714100714, 12.143767044134263],
              [92.817675044674132, 12.14102929773038],
              [92.815399894140441, 12.137713507541049],
              [92.812563839552453, 12.134698275692548],
              [92.812836511339029, 12.131591633834519],
              [92.813437167749285, 12.128648127670626],
              [92.81125070120018, 12.126375122946417],
              [92.807708465796878, 12.129132404834667],
              [92.803700176741927, 12.131286367014857],
              [92.79951259722823, 12.132235678179589],
              [92.795885723318435, 12.132998740882179],
              [92.794664758615696, 12.129589540646865],
              [92.797431832071325, 12.127805847791414],
              [92.801253874593442, 12.125535979289841],
              [92.804130435281422, 12.120530094112015],
              [92.806440492632206, 12.116728488337706],
              [92.810567389812633, 12.113624864565779],
              [92.810776431534478, 12.109173949962583],
              [92.810026506523599, 12.105023169931021],
              [92.807374489919439, 12.103028906793574],
              [92.804218229836138, 12.103120419653605],
              [92.800698827006755, 12.106340850215279],
              [92.802108768538289, 12.109076634177679],
              [92.802273795536024, 12.113341892958925],
              [92.798454584457545, 12.115496043896371],
              [92.79405833172143, 12.115888158625106],
              [92.793608468699858, 12.112480913596988],
              [92.795054747867098, 12.108517321853766],
              [92.791449485415114, 12.105478655278031],
              [92.786883106235791, 12.102740011948185],
              [92.782232061900658, 12.103016307097349],
              [92.782437803612765, 12.09951558907915],
              [92.783597766405734, 12.096687700967754],
              [92.785422984082771, 12.091681659137048],
              [92.788370229535062, 12.090919269019597],
              [92.797577361272033, 12.095351362999875],
              [92.803369891366316, 12.091135255428501],
              [92.798150557808626, 12.083947283214012],
              [92.792680449394012, 12.075483463562684],
              [92.78618455775802, 12.071261069822398],
              [92.781931403694244, 12.076010869071302],
              [92.777842366993781, 12.07628540069827],
              [92.774010772010513, 12.076469098622843],
              [92.772232610683304, 12.072596539359512],
              [92.771198113874462, 12.069559811445101],
              [92.768935800665574, 12.064458487239172],
              [92.764386951502274, 12.063134160450028],
              [92.765297272738295, 12.067770363205071],
              [92.764715122100597, 12.071640807552697],
              [92.763544684758628, 12.076553874592589],
              [92.76361741397929, 12.080239273746884],
              [92.763412880385076, 12.08355398643382],
              [92.765781193071916, 12.086291220921442],
              [92.768049367753889, 12.090164469420799],
              [92.769455952412258, 12.093665769744693],
              [92.768847571766969, 12.098115822139656],
              [92.764565263129597, 12.09943340956363],
              [92.761148641048393, 12.096116201827078],
              [92.75878523359097, 12.092614406142021],
              [92.756815691624382, 12.089413477808156],
              [92.753679860146107, 12.086003794448406],
              [92.750076165645282, 12.083172572315435],
              [92.745998879291477, 12.081083171365526],
              [92.740874232014363, 12.082330916290214],
              [92.740379761438788, 12.087429648496659],
              [92.739590562335948, 12.090835846857864],
              [92.739664288788632, 12.094127425217421],
              [92.740314954436982, 12.099042949052462],
              [92.741809939205112, 12.103217080858183],
              [92.744167265072775, 12.107947860130148],
              [92.744732969034544, 12.11105549706329],
              [92.745862965400363, 12.113815110555421],
              [92.747918517306019, 12.118152149316831],
              [92.749049393032195, 12.120980798372999],
              [92.75112651992886, 12.125711357664715],
              [92.752616136708397, 12.131022754055373],
              [92.754784525008489, 12.136124678821014],
              [92.755817804628578, 12.139440804628913],
              [92.756455172188254, 12.142547894170066],
              [92.758118155944885, 12.14644386491959],
              [92.759431761877664, 12.149574839090343],
              [92.763156273364118, 12.14804798054686],
              [92.76198781966697, 12.152405118401779],
              [92.760168711168632, 12.156091258415413],
              [92.759952612047229, 12.162360633754933],
              [92.756165029664714, 12.157316415136354],
              [92.754847552061932, 12.154579594910954],
              [92.753624460340433, 12.151842483410743],
              [92.752870265499624, 12.148712375015222],
              [92.750541453340006, 12.142820755997128],
              [92.749038615366047, 12.139620252245756],
              [92.746770250133849, 12.135747172917487],
              [92.744704054821185, 12.133172064939654],
              [92.744139423059238, 12.129693937950037],
              [92.743018843717522, 12.12542675891879],
              [92.741993210106187, 12.120603494117978],
              [92.74098961427697, 12.11615219587873],
              [92.739674514191137, 12.11322985489852],
              [92.737966495800563, 12.109542443714037],
              [92.736750033867096, 12.10557703778778],
              [92.735436762060118, 12.102260739325295],
              [92.734214218377403, 12.099431158669647],
              [92.73243102447627, 12.096787454626904],
              [92.729002422474977, 12.095648181252782],
              [92.725561299425635, 12.096780300316244],
              [92.721468692993398, 12.09761033563459],
              [92.723782812773621, 12.093185412933616],
              [92.725786199822352, 12.090243910843469],
              [92.726395257997723, 12.085607460062759],
              [92.725643578627412, 12.082408760564686],
              [92.724212948897843, 12.074989658378025],
              [92.723720103143322, 12.071419665648399],
              [92.722736477289615, 12.067570787087019],
              [92.721073417436344, 12.06430259332369],
              [92.718327099033857, 12.058805836913885],
              [92.716924996205535, 12.054539208605059],
              [92.71426104174077, 12.05087426082077],
              [92.711405272416087, 12.047789536472159],
              [92.705197409033943, 12.050284870833423],
              [92.704536316584154, 12.044073044503518],
              [92.702031700005321, 12.041242569263913],
              [92.699107292766385, 12.038156088639328],
              [92.701646490635127, 12.035308864722433],
              [92.70383299785631, 12.032808285437563],
              [92.705047706596346, 12.028476029452474],
              [92.703395834439945, 12.023468064540085],
              [92.702068131833272, 12.019201954410455],
              [92.705691809618202, 12.018372595281999],
              [92.70787012947585, 12.021387897735405],
              [92.70969614056078, 12.02421687919791],
              [92.711528590870557, 12.026652725521869],
              [92.713017524311468, 12.031660446726033],
              [92.717523421338328, 12.035836537423934],
              [92.720872107222021, 12.038250297916157],
              [92.724568876863472, 12.041267080647588],
              [92.727779647154847, 12.039346658949301],
              [92.727191041902131, 12.03584654835559],
              [92.724265770028424, 12.032992653143172],
              [92.72421322709755, 12.029910677305651],
              [92.726909868621462, 12.027827497247943],
              [92.727674326927186, 12.024815491424802],
              [92.725002954333874, 12.022565040686638],
              [92.72216294229743, 12.020985796916511],
              [92.718387696097196, 12.019382760439015],
              [92.724649260856921, 12.015032717767285],
              [92.72760645590941, 12.012369933417917],
              [92.72745077709645, 12.006623249819429],
              [92.731422338071241, 12.006372479421339],
              [92.73538033333962, 12.004197899528171],
              [92.738814897006918, 12.003782469414375],
              [92.740405209323882, 12.007538387161606],
              [92.744864428689382, 12.007379573010558],
              [92.745469658829393, 12.003626028904538],
              [92.745753214582635, 11.998690542288871],
              [92.74121449402179, 11.996369482792801],
              [92.737939857924857, 11.997362459505197],
              [92.734912596686229, 11.995854283395447],
              [92.732241369364829, 11.993511433887917],
              [92.729188533515, 11.996683739714397],
              [92.725919669637449, 11.996773077218309],
              [92.72442698076398, 11.992252897146894],
              [92.72150407404429, 11.988912746665685],
              [92.718155596112183, 11.986754058292458],
              [92.717426152422618, 11.983834252437108],
              [92.716092419396077, 11.980055811180208],
              [92.713420006829054, 11.977897292334614],
              [92.713349927682472, 11.974051284007908],
              [92.717316349390245, 11.97431037553431],
              [92.720481672983738, 11.975888729082497],
              [92.72326769910309, 11.974409043374546],
              [92.722187247389698, 11.971557595558396],
              [92.723141675824834, 11.968152914026041],
              [92.726603481664824, 11.966557965834866],
              [92.729851282214511, 11.970476347991232],
              [92.732290519738029, 11.968231717182872],
              [92.731562977945146, 11.964894539857353],
              [92.72830443952563, 11.963061028540739],
              [92.724531191194615, 11.961642846980101],
              [92.720750074839543, 11.961546573455127],
              [92.718279033441064, 11.96504348045648],
              [92.714580268725612, 11.966962588287158],
              [92.710956721029561, 11.967953904606835],
              [92.710554352813006, 11.964802708063132],
              [92.712507415955287, 11.962301913457967],
              [92.714626072668352, 11.959061241385289],
              [92.717817401495083, 11.956052321138836],
              [92.717678376918713, 11.951881430927676],
              [92.714319626874172, 11.951715983120566],
              [92.710687890363957, 11.954051872991018],
              [92.707165639096289, 11.953793302449023],
              [92.707440314206764, 11.950688794949503],
              [92.709558545131799, 11.947354459650025],
              [92.712102258860057, 11.943372802987684],
              [92.714547701205916, 11.94020170710693],
              [92.714403418748489, 11.937119698891951],
              [92.71182557043926, 11.934776837647647],
              [92.712173760250423, 11.93093170968138],
              [92.70941787253031, 11.927592056337886],
              [92.705998092781272, 11.925827013015606],
              [92.705081231806119, 11.922675256626079],
              [92.708864079348501, 11.922332822651406],
              [92.710870451503126, 11.918420073190292],
              [92.711984852469271, 11.915362664593552],
              [92.71266295041849, 11.911031538709658],
              [92.713244354056428, 11.907440693770605],
              [92.713262757389941, 11.903966781342849],
              [92.713622190420097, 11.898546728059737],
              [92.712998316594252, 11.893332884007101],
              [92.710138804176239, 11.895832153294711],
              [92.708800540641761, 11.901250892373161],
              [92.706909074635419, 11.905280331422352],
              [92.70612154193995, 11.908405837730516],
              [92.701760810383632, 11.907983898004527],
              [92.701009568685635, 11.904832357470692],
              [92.699491731302743, 11.900915986523403],
              [92.697218839924929, 11.898643124992446],
              [92.697339779179899, 11.893963872754382],
              [92.698780030624135, 11.891139172221131],
              [92.70110696023859, 11.888107785123738],
              [92.702967234934633, 11.885191666931568],
              [92.706063434814538, 11.882368373764788],
              [92.706943242008677, 11.879428492852197],
              [92.70991918844534, 11.877161579638551],
              [92.714607415525819, 11.877375356690255],
              [92.718658603134244, 11.878676204607526],
              [92.720200210411178, 11.874230978185956],
              [92.718911018019554, 11.871194918370321],
              [92.714439766154726, 11.870102082775183],
              [92.711150831264817, 11.869774311944175],
              [92.707234618664472, 11.869561366245534],
              [92.703839211306232, 11.867587943594613],
              [92.704417744572069, 11.864346229160187],
              [92.701475825992233, 11.861076673430523],
              [92.700964328135612, 11.856953201661987],
              [92.703262622721383, 11.85456998975596],
              [92.70372653301493, 11.851212616731383],
              [92.705163927749368, 11.848388444647561],
              [92.708210209840502, 11.850128880034807],
              [92.713134561363262, 11.857801378959858],
              [92.715805977813005, 11.85947146862441],
              [92.718524241976411, 11.861419611560164],
              [92.72137749908984, 11.860126462653149],
              [92.721627379434196, 11.856976134084587],
              [92.722317567751787, 11.850792461077484],
              [92.722348378076418, 11.845257805057081],
              [92.719302111722655, 11.839394549499934],
              [92.718247535027785, 11.836567432598297],
              [92.71628338655357, 11.833438834630138],
              [92.71478790065656, 11.829570575858394],
              [92.713803581198533, 11.826581080770392],
              [92.712965338870745, 11.822481522493792],
              [92.711473681567355, 11.818125743494656],
              [92.710232657821209, 11.815021056552457],
              [92.707499845650901, 11.811891480414404],
              [92.703753182807475, 11.810405115088468],
              [92.69998750621798, 11.812624376887376],
              [92.700447880609261, 11.817603623071745],
              [92.702161102421215, 11.823464906895206],
              [92.704517323050837, 11.827335363459587],
              [92.699763894887255, 11.826819861440004],
              [92.696403459259102, 11.823203253682697],
              [92.693417436055825, 11.819586849584928],
              [92.688561920475152, 11.816732340874825],
              [92.684675027698361, 11.815361114517263],
              [92.67789643810076, 11.818199903268383],
              [92.673367388038201, 11.819189906632637],
              [92.667318670771294, 11.824416080279049],
              [92.662542767631521, 11.827511595320585],
              [92.659034256314115, 11.829267353697032],
              [92.656902762958893, 11.82701792371962],
              [92.65920661202253, 11.820050060405496],
              [92.66085682035704, 11.817180265191752],
              [92.664877583840919, 11.815820445187716],
              [92.668892257130238, 11.814829586191799],
              [92.672913927605876, 11.813215058882907],
              [92.675926434525749, 11.812477579441056],
              [92.67893642346381, 11.811856689178068],
              [92.682962844400421, 11.809383308870952],
              [92.684108925654414, 11.804776957485515],
              [92.68138204050679, 11.800790681728449],
              [92.67939747791894, 11.797290476705687],
              [92.677153174494734, 11.794439497930874],
              [92.673513058356605, 11.794920900334709],
              [92.670135504211146, 11.794430572736539],
              [92.666268400448388, 11.794170090131708],
              [92.669675698412064, 11.789682327611482],
              [92.673927667858706, 11.788206671269712],
              [92.676086741377091, 11.785962590739782],
              [92.676361779156579, 11.782859961756838],
              [92.673738458191238, 11.780865043007525],
              [92.670989434477718, 11.776879486460354],
              [92.670402524721467, 11.77352033158925],
              [92.674912545488397, 11.771766501272156],
              [92.677822513869927, 11.768668170248263],
              [92.680341075595223, 11.764572562268809],
              [92.68320811057562, 11.768421182420916],
              [92.682551485299513, 11.772912317001609],
              [92.682152617844253, 11.777264383634526],
              [92.681361531289042, 11.780875922516602],
              [92.681225556052496, 11.784232706442484],
              [92.681944597992612, 11.788587211545213],
              [92.682695039511913, 11.791830264568308],
              [92.684051579837444, 11.795074346654374],
              [92.689040412985776, 11.798923918284794],
              [92.694038433564188, 11.801431694352132],
              [92.696660152663966, 11.803426555894831],
              [92.700032353431766, 11.80491285215853],
              [92.69917814300706, 11.799678416228184],
              [92.698192089445328, 11.79668929827533],
              [92.703090479051639, 11.79609369901849],
              [92.706487771011297, 11.793480338237771],
              [92.708583523588331, 11.79769772690558],
              [92.710943912789872, 11.800942116628988],
              [92.715315428905711, 11.802822304802845],
              [92.716557431015858, 11.805672328541704],
              [92.716416019222208, 11.810165171374315],
              [92.718510555240826, 11.814775168551437],
              [92.720008974989909, 11.817880819976141],
              [92.720969568704476, 11.821007662928261],
              [92.722345405257002, 11.825108633071459],
              [92.723938049423438, 11.828212947740614],
              [92.725437316135242, 11.830970349078749],
              [92.726907338974428, 11.835187622191775],
              [92.727962578255372, 11.838198954438456],
              [92.728807901740453, 11.841256622880227],
              [92.731080881212648, 11.847536367582514],
              [92.732041278671289, 11.851010700079051],
              [92.732135654674906, 11.854925640939202],
              [92.733300095625268, 11.859165074898234],
              [92.734054508255795, 11.862083895512329],
              [92.736110764952571, 11.865560822968098],
              [92.737307981411575, 11.868294850089899],
              [92.739690636319438, 11.871980254886559],
              [92.741512694788383, 11.875780236364143],
              [92.740504258866125, 11.880990959183958],
              [92.73722763269582, 11.882841204954781],
              [92.735377729610477, 11.879688987384624],
              [92.733082079147593, 11.877185567171191],
              [92.731099739880918, 11.881422089196535],
              [92.731288756288237, 11.885106385831874],
              [92.731062128659019, 11.888139937713722],
              [92.733981155147902, 11.891571622610611],
              [92.73696241149608, 11.888308300195641],
              [92.740213780168048, 11.890928782033129],
              [92.742181200717624, 11.893756665618644],
              [92.740741867383036, 11.896789946307901],
              [92.737661102898585, 11.89678637307304],
              [92.734824889606784, 11.899285572959714],
              [92.734363890252439, 11.902436441019811],
              [92.735106259708843, 11.907301040089697],
              [92.736831463603224, 11.911773974417553],
              [92.739994738264855, 11.913607260749998],
              [92.744591386453891, 11.909603311742034],
              [92.74776675217997, 11.908957142387056],
              [92.747973923510443, 11.913846266021698],
              [92.747292342557117, 11.918710735515155],
              [92.74702797175334, 11.924362880358039],
              [92.751090641017328, 11.924250526132528],
              [92.753926843654966, 11.921866186884778],
              [92.758422867805066, 11.923073914218907],
              [92.761277289848962, 11.921546641969305],
              [92.764892233458241, 11.917981254981303],
              [92.766616911533575, 11.9223149786615],
              [92.764518059713808, 11.926438137882933],
              [92.763728592412747, 11.930351771562631],
              [92.767791537717684, 11.929915395508978],
              [92.770629028946118, 11.931330424714149],
              [92.774220343138069, 11.932096891096283],
              [92.77838236052348, 11.930571256257522],
              [92.784317666419668, 11.929068846539577],
              [92.782020228115854, 11.926564656855195],
              [92.783997034650753, 11.923299969109838],
              [92.786435028079538, 11.921355653742745],
              [92.788850112852856, 11.918970729588469],
              [92.789426049213105, 11.911442053455596],
              [92.786919742182263, 11.908938055794568],
              [92.782991438080685, 11.906109323828282],
              [92.783787246858481, 11.901106090713398],
              [92.784573103418268, 11.897863721675431],
              [92.77978453809493, 11.890146889714192],
              [92.775971690465781, 11.887966645342839],
              [92.777201013578392, 11.884724936974836],
              [92.77961810962195, 11.88222491608801],
              [92.782248652416513, 11.878543764341206],
              [92.785673888660611, 11.875070628784961],
              [92.788219461052279, 11.870184526447026],
              [92.788330122790839, 11.866710728836477],
              [92.788468110450737, 11.862703340179806],
              [92.787602930063414, 11.85867228176687],
              [92.786648043549874, 11.853901622675481],
              [92.785585348662082, 11.847391890909115],
              [92.782871499384058, 11.844772966867405],
              [92.782026788189711, 11.841090051569493],
              [92.781396053025546, 11.836851588763629],
              [92.780627069134766, 11.832311508971836],
              [92.779555402071679, 11.827864469760264],
              [92.779248484063373, 11.824274598857148],
              [92.778505131847055, 11.819295156520811],
              [92.778442113025903, 11.813528286071186],
              [92.776812704643717, 11.80854921476428],
              [92.775968812895272, 11.805167479830578],
              [92.774895012065684, 11.800836352759125],
              [92.77350050259794, 11.795834100996125],
              [92.772312064679241, 11.791178203267689],
              [92.77102728129006, 11.787496382844449],
              [92.770421330666863, 11.778580435966585],
              [92.769240576483583, 11.772721245963787],
              [92.768851382878111, 11.767094147543476],
              [92.768318091421648, 11.76209307055856],
              [92.767783742682511, 11.757461856583792],
              [92.764085684168336, 11.751925259366681],
              [92.762588099973513, 11.748451024467801],
              [92.762162075357395, 11.74541831528799],
              [92.762621789746703, 11.742385543167206],
              [92.762967203055908, 11.738797307499404],
              [92.762660595888832, 11.73511585056435],
              [92.761465815783012, 11.732081346518537],
              [92.760627629509258, 11.727729013988899],
              [92.759107049110199, 11.724486276260141],
              [92.75770648249572, 11.720572096128013],
              [92.756636722315761, 11.716219302651846],
              [92.756661155871583, 11.711450635294563],
              [92.756244852801473, 11.706796657108546],
              [92.756588008832168, 11.703533472047102],
              [92.757048069098957, 11.700269421912193],
              [92.756631701236046, 11.695407658519819],
              [92.752268507571927, 11.696793353406056],
              [92.749843900665113, 11.701258820467299],
              [92.747640924083541, 11.703526054797379],
              [92.743930607288718, 11.704726692470846],
              [92.742620027559255, 11.701669477463565],
              [92.742644702929823, 11.697016367257714],
              [92.743226738372726, 11.693221081163385],
              [92.743470144049084, 11.687040467324399],
              [92.741095625278518, 11.682594222876666],
              [92.737139472725147, 11.686062347617218],
              [92.734516533007977, 11.688444501745378],
              [92.730692554620404, 11.68897288243458],
              [92.727646796478879, 11.688206142422887],
              [92.724138139768513, 11.690378911130173],
              [92.722249549875158, 11.695052125610502],
              [92.717977483717519, 11.696343997594694],
              [92.7162553902686, 11.691990649326099],
              [92.713998394374244, 11.687659437211003],
              [92.711675366615836, 11.690573592151916],
              [92.710140480058854, 11.694159864708961],
              [92.707931542023772, 11.697306199371846],
              [92.704946270017643, 11.701955295348572],
              [92.702202735606065, 11.704776622729183],
              [92.699016022918428, 11.707920508957519],
              [92.695524486690914, 11.7073842433546],
              [92.694891948774483, 11.704003413345179],
              [92.6962313288617, 11.698263979608653],
              [92.692195151919947, 11.699138397151435],
              [92.689646638677999, 11.704668850041639],
              [92.68897688493621, 11.707584359250589],
              [92.687967699885448, 11.712791633002515],
              [92.683582583351196, 11.713341546552074],
              [92.680088630950095, 11.713221031393212],
              [92.67647606905291, 11.717545890102553],
              [92.675614493635408, 11.713538860268393],
              [92.673462911949429, 11.710712354313053],
              [92.674021595580825, 11.70712477433819],
              [92.67611424194871, 11.704095002097384],
              [92.679923478402785, 11.70572016291975],
              [92.68353403048495, 11.706165375757287],
              [92.685624371792301, 11.70301921001729],
              [92.686742502848318, 11.699224735679485],
              [92.687199260815248, 11.693160536793718],
              [92.683714229600213, 11.691304551939982],
              [92.684949228597716, 11.687509407073557],
              [92.687038777413193, 11.684595160226216],
              [92.694546273822695, 11.687753385400697],
              [92.697820529411715, 11.689492650501723],
              [92.700668355157106, 11.688500368888832],
              [92.702106491747116, 11.68547083462728],
              [92.703387800432338, 11.681421184795912],
              [92.70245864436211, 11.677022026102254],
              [92.701033257089946, 11.673918050781113],
              [92.701668842056591, 11.668664776003576],
              [92.703247350214824, 11.665704008514897],
              [92.706385869044439, 11.662722255847337],
              [92.703998523062253, 11.660820792222767],
              [92.700990183936284, 11.661419406000396],
              [92.695353677842135, 11.661273593025397],
              [92.692387038609724, 11.6590243603611],
              [92.689400129739383, 11.656035256632771],
              [92.686675004619858, 11.652097585355515],
              [92.685247200619969, 11.649132953908124],
              [92.684200620636958, 11.645312586744369],
              [92.680471484747841, 11.645539828839889],
              [92.67459037712419, 11.647567726824805],
              [92.669436484516496, 11.6488573091495],
              [92.66594726163207, 11.648389314304747],
              [92.666227440910177, 11.644223318376925],
              [92.666714427119558, 11.64086797473573],
              [92.668678595790311, 11.63552524618491],
              [92.670139445996071, 11.628977236027414],
              [92.671836679148171, 11.625531518985566],
              [92.673913417702124, 11.620882261992906],
              [92.676102135267996, 11.617182853426419],
              [92.679335873284458, 11.617557753884626],
              [92.683152214906869, 11.618025677442242],
              [92.685676377258574, 11.616362034350367],
              [92.688212121194496, 11.612916699322618],
              [92.684148087603788, 11.610899139612293],
              [92.681645554032471, 11.608974732831188],
              [92.67808123600453, 11.605406684460343],
              [92.676656631540453, 11.6025349212444],
              [92.681221901950764, 11.602077896317441],
              [92.684185343240401, 11.604928146313293],
              [92.687180220289846, 11.60625176694389],
              [92.691491862714969, 11.605655229176623],
              [92.69067492291957, 11.601719999908655],
              [92.689863148593631, 11.597553942996623],
              [92.693818782655811, 11.59781334198334],
              [92.69739255420923, 11.599599498750585],
              [92.697140488847978, 11.603046503059241],
              [92.699288420010404, 11.605780233323726],
              [92.703587824884693, 11.607103975507304],
              [92.703679059577993, 11.611640582978733],
              [92.700090399192604, 11.611983262305632],
              [92.697436287126052, 11.616029791976699],
              [92.697533006289618, 11.619362703665193],
              [92.695574213622535, 11.623896148001496],
              [92.696033345519908, 11.628895851690485],
              [92.698770707205853, 11.630795793944271],
              [92.701532380903984, 11.632118696920861],
              [92.702346803381758, 11.636401437843238],
              [92.700529314191471, 11.640449995287391],
              [92.697513625560148, 11.642344121817276],
              [92.701344394619369, 11.644384758915493],
              [92.705896774724948, 11.64258541953587],
              [92.707000655813772, 11.636869250656249],
              [92.708465713195565, 11.633307022274645],
              [92.712296218655638, 11.635463707634871],
              [92.713717074808159, 11.63940032770099],
              [92.712134691016715, 11.643194126405037],
              [92.71463774344106, 11.645348809719112],
              [92.720385801021678, 11.645817670375353],
              [92.725525990703176, 11.647142282675533],
              [92.728525315627479, 11.648209596178393],
              [92.729947417578543, 11.651799237668184],
              [92.726934826532926, 11.653346892253348],
              [92.72223576042137, 11.656305069815728],
              [92.71970547842389, 11.659287775715473],
              [92.717994078746429, 11.665002696827587],
              [92.717974174372245, 11.66845234288064],
              [92.71916768483247, 11.67178601001174],
              [92.721671361792929, 11.673940789092828],
              [92.726936471877494, 11.673576687317516],
              [92.731753163839784, 11.670501994201066],
              [92.733934574437555, 11.667634483943102],
              [92.738131029250837, 11.667037291465986],
              [92.737131488074851, 11.670624020139925],
              [92.740615485211833, 11.672640278900348],
              [92.744698508935684, 11.671347312271084],
              [92.749020367025608, 11.669083476373979],
              [92.75144254340789, 11.664919304397339],
              [92.752298396339697, 11.661702740787163],
              [92.754939724238199, 11.659922547325465],
              [92.757584523681786, 11.65765608086244],
              [92.757487458766946, 11.653953113891054],
              [92.756786710602782, 11.650271981777948],
              [92.755732329066845, 11.64693851133225],
              [92.756360325772889, 11.643004726626536],
              [92.754447516958635, 11.639068180598363],
              [92.751829285549377, 11.636913844894334],
              [92.747993261367796, 11.635730428254858],
              [92.743344355934639, 11.634175326512484],
              [92.740579273727619, 11.632992441331018],
              [92.741576024945687, 11.6295227451487],
              [92.744673893499197, 11.629409232488484],
              [92.749138593787308, 11.626195819494782],
              [92.749781851422952, 11.619531117068846],
              [92.75004302782034, 11.614532697174084],
              [92.750535768636809, 11.609534991892051],
              [92.750933821661832, 11.604883490465799],
              [92.750579105616325, 11.601550927887457],
              [92.750251163874367, 11.597617533293294],
              [92.747150215903687, 11.594281843111466],
              [92.745138503108862, 11.591896798940736],
              [92.742504105539538, 11.588307882158794],
              [92.743475532041074, 11.585463157195747],
              [92.744948960937947, 11.579632875639668],
              [92.744250076680387, 11.575583119305087],
              [92.740673413982606, 11.574145358455487],
              [92.738529394956316, 11.570579579461281],
              [92.73821370975611, 11.564609845432081],
              [92.738464599394192, 11.561162119424454],
              [92.735734754423632, 11.558313919399387],
              [92.733708774888925, 11.554610623422844],
              [92.732184407282688, 11.548061158537758],
              [92.7335302031575, 11.544962794355676],
              [92.733663898265178, 11.54174669241279],
              [92.732843695253081, 11.538669071785007],
              [92.729031806633699, 11.533644287302721],
              [92.726428591049626, 11.52889911784666],
              [92.725144955811132, 11.525543570272465],
              [92.725169064470393, 11.521263974851442],
              [92.725544310205038, 11.516637236709354],
              [92.725336732842806, 11.512472345225557],
              [92.725591582021224, 11.50854043459047],
              [92.723099226342725, 11.504836660034629],
              [92.719770619615289, 11.501039901177785],
              [92.717160317678491, 11.4978216553799],
              [92.71611146423578, 11.494118987108326],
              [92.71552996646929, 11.490209565306639],
              [92.716382608896197, 11.487342188977166],
              [92.715922954036827, 11.482460307295225],
              [92.715708636772135, 11.479360350254387],
              [92.712620719659, 11.474014290181582],
              [92.709962042830625, 11.479355046497325],
              [92.707536183811754, 11.484717886990916],
              [92.705946799418896, 11.490059761356532],
              [92.702682527222464, 11.495307192986415],
              [92.700863801657192, 11.49969956423865],
              [92.697841020565733, 11.503628856085836],
              [92.693431244741475, 11.50184182627979],
              [92.689591410169911, 11.502068745019113],
              [92.686229582249638, 11.504099677695923],
              [92.682412334544594, 11.504442174352723],
              [92.677980364587739, 11.502423664527138],
              [92.675129438254586, 11.500500155497503],
              [92.671792385650591, 11.49859830936296],
              [92.666012462302916, 11.500163625613849],
              [92.662640188679973, 11.503998521359277],
              [92.659565562680442, 11.508042672806081],
              [92.655907792223005, 11.509239983801287],
              [92.651815275402967, 11.512472286644563],
              [92.648339942848551, 11.517509696949267],
              [92.647087841942181, 11.520446218364889],
              [92.646161422222136, 11.52356740897724],
              [92.64562688508164, 11.527407142426449],
              [92.645907847800814, 11.530738735683489],
              [92.646704232478811, 11.533770955235315],
              [92.649938563133105, 11.537223245544041],
              [92.652969149645955, 11.540258091761984],
              [92.653755235587838, 11.545002560831696],
              [92.653919549359884, 11.548334042572304],
              [92.65067937010501, 11.549254978929582],
              [92.646697069312836, 11.549642693197297],
              [92.644866905667669, 11.552067995950559],
              [92.646262128924988, 11.556004690546573],
              [92.647746725552466, 11.560656638320792],
              [92.649052315177016, 11.563782216932955],
              [92.646892491190556, 11.566810689481409],
              [92.643028060162862, 11.566919484811379],
              [92.639055271177156, 11.56952843354469],
              [92.63680101857571, 11.572763800897411],
              [92.636257229592943, 11.577714257719297],
              [92.633103928138553, 11.579329938488474],
              [92.630471430815874, 11.576201279442984],
              [92.629697551801641, 11.569813790853676],
              [92.629017776015814, 11.566596171629712],
              [92.628223974620056, 11.563355454015722],
              [92.626222273988333, 11.560020633150064],
              [92.623287749201864, 11.556382525036243],
              [92.622026177127395, 11.560822354024639],
              [92.622197535728759, 11.566977743059299],
              [92.622473535332986, 11.57081969493737],
              [92.622252644263497, 11.576371858574554],
              [92.621806484734719, 11.580629245549359],
              [92.619349765618836, 11.582545236185089],
              [92.614353385594697, 11.584757532380252],
              [92.61191083525452, 11.588178361912618],
              [92.610040969346713, 11.593034371549486],
              [92.609193850042658, 11.597868600041307],
              [92.609074955061359, 11.60182621732103],
              [92.608408938828788, 11.607470788280793],
              [92.610640313460181, 11.611617563789993],
              [92.613039120227313, 11.615254762985064],
              [92.617018893667989, 11.615377816761562],
              [92.620382130517442, 11.613856328538683],
              [92.623555912836551, 11.609025873066983],
              [92.624784289169156, 11.606180879363571],
              [92.628467750620956, 11.60570084231311],
              [92.631385017683215, 11.608112675054979],
              [92.635260692456541, 11.606522152324541],
              [92.639251481214188, 11.604909382752597],
              [92.641966699007654, 11.606209581343787],
              [92.644904650790139, 11.609245578740508],
              [92.646112265847961, 11.613598241280014],
              [92.646694216710429, 11.617325355264931],
              [92.646148166305025, 11.622692641040558],
              [92.644699002671373, 11.627226828910038],
              [92.645188799252125, 11.630768910672026],
              [92.644949853023675, 11.635628753994892],
              [92.641401955020328, 11.633285412038214],
              [92.639254746165548, 11.637540670078629],
              [92.637892444240151, 11.643092325259996],
              [92.636440559443017, 11.648135446075568],
              [92.633882294671594, 11.651371638462983],
              [92.632273341809793, 11.64794319350146],
              [92.631664683811493, 11.64491033167474],
              [92.631505444144352, 11.640651845513437],
              [92.631331410942394, 11.635004635154521],
              [92.631960839731889, 11.630955330002626],
              [92.631305129314953, 11.62428883879724],
              [92.629484139104136, 11.621648267805934],
              [92.625402917772718, 11.622357952342298],
              [92.622751336135863, 11.625779146830414],
              [92.621814492997828, 11.630128048682112],
              [92.619392231975638, 11.626490253711614],
              [92.617026547402645, 11.628708156692872],
              [92.614192544434744, 11.627685130617184],
              [92.610746310221501, 11.627678217104776],
              [92.609996914360167, 11.631935132591389],
              [92.608342013698348, 11.635774678423337],
              [92.604951722326632, 11.641206604802713],
              [92.603211215195742, 11.644050242159919],
              [92.604092329307591, 11.648195203915744],
              [92.60265279430044, 11.651108060486472],
              [92.599373438800811, 11.653740633940336],
              [92.596720616645257, 11.657161727579496],
              [92.595071734735868, 11.659888978070894],
              [92.594842587254405, 11.662921032896435],
              [92.597478068583214, 11.665749421422456],
              [92.599695768773174, 11.668600924101874],
              [92.601071512799109, 11.675524676094259],
              [92.6015173475121, 11.681983121829413],
              [92.600079156010409, 11.684619280193912],
              [92.598847980042152, 11.687533915251199],
              [92.597097847243489, 11.69158113552049],
              [92.596655125925565, 11.695330124542037],
              [92.596022656950836, 11.699357723079999],
              [92.59997760505793, 11.700175011393812],
              [92.605609112394561, 11.697662261160398],
              [92.607453096823875, 11.693614641427002],
              [92.611448267245123, 11.69225194237279],
              [92.614149227224672, 11.69566422776065],
              [92.613503752450853, 11.701612066194842],
              [92.612047566971739, 11.707188550963645],
              [92.611406347265969, 11.712534980908902],
              [92.610055804955365, 11.71595846892885],
              [92.607315684668961, 11.714355951411873],
              [92.604251183690167, 11.716457735134131],
              [92.602559739975547, 11.711500498328201],
              [92.60248813214244, 11.70816586132019],
              [92.600764593671073, 11.70443633444599],
              [92.597202031908438, 11.704012619377961],
              [92.593832084357032, 11.706228341405678],
              [92.594006643728903, 11.711692644378498],
              [92.595406324764085, 11.715028179685101],
              [92.595884093815144, 11.720076795690266],
              [92.595462115610047, 11.724219093488232],
              [92.593793271049634, 11.72888245400487],
              [92.589420429390941, 11.725133217606544],
              [92.58668478902716, 11.723137704340335],
              [92.588232431073138, 11.71793198466356],
              [92.582256951128642, 11.712710226120077],
              [92.579303795282001, 11.70849177304971],
              [92.574393622104395, 11.707602254672585],
              [92.575157719521528, 11.701353074501538],
              [92.574683797859095, 11.695472671710062],
              [92.5720850216575, 11.690720658381752],
              [92.568713143810314, 11.689602924902895],
              [92.566825866056178, 11.686357851462184],
              [92.563784059547075, 11.68505510541053],
              [92.561496777558673, 11.68877763220623],
              [92.560566798667381, 11.692224541257],
              [92.560031707208921, 11.695255735858261],
              [92.560941856228922, 11.698591400593907],
              [92.561223620392724, 11.701717050722538],
              [92.556010592727233, 11.704043351603179],
              [92.555383604934775, 11.70707466120208],
              [92.556385827461099, 11.710595823841153],
              [92.557483742713856, 11.713445353879559],
              [92.557953444020967, 11.716479278898156],
              [92.557232707199461, 11.71939446362847],
              [92.552467828030302, 11.717764363333162],
              [92.552535431861287, 11.721514162027971],
              [92.552600797981654, 11.725565967660392],
              [92.553208256889917, 11.728692706361542],
              [92.553884787162488, 11.731912710145785],
              [92.553839347880327, 11.738395207850736],
              [92.553897962192991, 11.743442488138518],
              [92.554083233167844, 11.747170364273011],
              [92.55444440328165, 11.752032649151657],
              [92.555449071344427, 11.755160830549562],
              [92.556958274204021, 11.759308688677406],
              [92.559996328863349, 11.761445458215391],
              [92.560674709793915, 11.764595599551081],
              [92.563102656023815, 11.76742638931051],
              [92.559831938561118, 11.768622524979673],
              [92.556671090472705, 11.770538494116142],
              [92.55531574258687, 11.774285702657391],
              [92.55477557744517, 11.778522098887068],
              [92.554138795531031, 11.782966932682418],
              [92.555744884914432, 11.7866061005601],
              [92.556091641725175, 11.793808163832173],
              [92.545911142376781, 11.789269577096086],
              [92.544962694665415, 11.784799368666595],
              [92.542240113381325, 11.780809597756937],
              [92.536240946024236, 11.782046159723974],
              [92.539678047543347, 11.790482877111213],
              [92.536372943530196, 11.796427185797857],
              [92.538555855124912, 11.807593548500352],
              [92.544548034562368, 11.807607846127873],
              [92.547279169545476, 11.810345739002004],
              [92.548465919010397, 11.817550780342282],
              [92.548790907351147, 11.821095182957416],
              [92.548344528176528, 11.825031311597158],
              [92.549560696170246, 11.827767081710537],
              [92.553324574393685, 11.826455439040586],
              [92.553208458169564, 11.829813198225249],
              [92.552158235590895, 11.833145057345851],
              [92.552244711340705, 11.837384602117551],
              [92.552523616480983, 11.841136196732352],
              [92.552070374044774, 11.845976618825954],
              [92.549405183356541, 11.850023909902147],
              [92.545134684345413, 11.847072519605444],
              [92.543599832799146, 11.849894110562913],
              [92.541023590930862, 11.854752284942061],
              [92.53838599215274, 11.851804474515207],
              [92.539324424980308, 11.84766096654255],
              [92.541093429771479, 11.844747530035383],
              [92.544556845957629, 11.843041008839686],
              [92.545605127240961, 11.83980084370911],
              [92.545857049443882, 11.833941940777734],
              [92.54352774121412, 11.830184709076695],
              [92.541055953989385, 11.833514028276415],
              [92.534930569177376, 11.825694998544668],
              [92.532701698291561, 11.820988466959182],
              [92.530020787111596, 11.814289208091465],
              [92.529060176748345, 11.808566691460882],
              [92.520347802476508, 11.804077160599009],
              [92.513831798466157, 11.805565695753952],
              [92.509527157433538, 11.814239043807349],
              [92.512953282918645, 11.823904882258692],
              [92.515658263960759, 11.830627742418953],
              [92.509899269066267, 11.833577792006782],
              [92.51481332811089, 11.844267757714187],
              [92.51722018307467, 11.856432953452329],
              [92.5194113151084, 11.863364041908895],
              [92.526455735085378, 11.864049238310153],
              [92.529546078460683, 11.861534830832943],
              [92.531797911211157, 11.867663106408884],
              [92.527357750269346, 11.870841368835611],
              [92.526818425650092, 11.874592660822966],
              [92.526883286181715, 11.878437428147629],
              [92.528174404053289, 11.884092914501126],
              [92.529872853755322, 11.88773367414397],
              [92.532605272864231, 11.89077457830512],
              [92.535854629636091, 11.893121375461483],
              [92.53970881179815, 11.895748077370177],
              [92.540499936734307, 11.899503354484413],
              [92.538752827309779, 11.902533296182799],
              [92.537612429727815, 11.905356741895865],
              [92.539107203751954, 11.908487932259781],
              [92.541653674052554, 11.911250843434553],
              [92.542868600929879, 11.91426473848836],
              [92.545463712982908, 11.916819338027924],
              [92.548505783598529, 11.919027601792211],
              [92.55152973658862, 11.920423917594933],
              [92.555294264608975, 11.922794738037247],
              [92.55806740084023, 11.926624382921723],
              [92.559176508739256, 11.93176927664941],
              [92.559807344415674, 11.935130742151275],
              [92.562428013686215, 11.937499003837676],
              [92.564822290479995, 11.935302819943647],
              [92.564360231779872, 11.93129431791008],
              [92.568639926425973, 11.929751549143846],
              [92.570060719826742, 11.926904570748782],
              [92.571968115733853, 11.924383536205749],
              [92.575199507056141, 11.92274512397098],
              [92.575457571352985, 11.919085023508138],
              [92.574412356155236, 11.914843962109705],
              [92.570884484454623, 11.91548517408447],
              [92.57016770477756, 11.911150841806997],
              [92.569634332202213, 11.907142311024803],
              [92.572678061770503, 11.905758825396518],
              [92.577768352951523, 11.90794462282353],
              [92.580102762586051, 11.901465249426648],
              [92.581038210940164, 11.897714493244649],
              [92.580405892850393, 11.894609247523501],
              [92.578370152667119, 11.891894142395836],
              [92.575419872917237, 11.890105178604109],
              [92.571709860232744, 11.890097141964521],
              [92.571827194203877, 11.886669552346916],
              [92.573735155432303, 11.883893167963913],
              [92.576923115956717, 11.885127308081429],
              [92.580370354733418, 11.885876220627271],
              [92.582774212497398, 11.882197790969364],
              [92.583373651206657, 11.876547319492024],
              [92.584403812334315, 11.872356690030008],
              [92.585426204713173, 11.869417455186177],
              [92.584526125286942, 11.864551249209791],
              [92.584312069353047, 11.861539774376951],
              [92.584431893804222, 11.857578545012261],
              [92.585058448132301, 11.854569285854437],
              [92.587942150389551, 11.855825567462526],
              [92.590190786152519, 11.858145542165307],
              [92.593455155234125, 11.858222287286047],
              [92.595155680933189, 11.861930875637677],
              [92.593344064833744, 11.864336095000967],
              [92.59222645947294, 11.867739293648963],
              [92.594535069174512, 11.871380291122248],
              [92.596008112090686, 11.874394580521104],
              [92.594345092573164, 11.878954621536561],
              [92.594456764477158, 11.883146678562365],
              [92.595526083444085, 11.887156907998625],
              [92.599883402781231, 11.88779033516245],
              [92.599444182165726, 11.883852101084051],
              [92.597905444723096, 11.880281659850434],
              [92.600020359272023, 11.87787636249376],
              [92.599746897776413, 11.873313002461483],
              [92.59907898780159, 11.868516626970713],
              [92.600672733892111, 11.863655349690676],
              [92.60263795530615, 11.859328585203317],
              [92.603827070525838, 11.855693899571927],
              [92.604018458503546, 11.851595070082379],
              [92.604172477493663, 11.845688633769319],
              [92.603640657619039, 11.841680975822468],
              [92.606090914271377, 11.837817117303505],
              [92.607512484570321, 11.834253585321662],
              [92.608236753802458, 11.830549663899856],
              [92.611821673004584, 11.831551955840414],
              [92.61255189350392, 11.826758686403913],
              [92.61548600509191, 11.830863419059087],
              [92.615214328386358, 11.836815662181971],
              [92.615030561974905, 11.840080354080623],
              [92.615239574938201, 11.843856408251929],
              [92.614512843195911, 11.848186078192791],
              [92.614234915195766, 11.851451111780063],
              [92.614353405532853, 11.854555532222973],
              [92.617474907705954, 11.855255269538624],
              [92.617287475228594, 11.858891376355345],
              [92.613529613735551, 11.86298409424634],
              [92.613268262297922, 11.867245515500649],
              [92.613071607964741, 11.872411452494918],
              [92.613372005310126, 11.876511378335636],
              [92.611460188627419, 11.880005597043938],
              [92.610501589150928, 11.884011447916318],
              [92.610090024965061, 11.889731993927429],
              [92.609907450987606, 11.892835446291528],
              [92.611845120213417, 11.901974846045301],
              [92.616068605800479, 11.903363216464408],
              [92.61524221474987, 11.908435239330339],
              [92.615129249453844, 11.911516766876398],
              [92.617419642687622, 11.914393651896056],
              [92.620705387259861, 11.915210300371417],
              [92.620676951247972, 11.919542294266762],
              [92.617463525868018, 11.92485259592458],
              [92.613850322045081, 11.921476147786731],
              [92.610058651244699, 11.919754687110355],
              [92.607821095700118, 11.922784887696787],
              [92.609358090584692, 11.926773323495421],
              [92.609593863889856, 11.929970519546362],
              [92.610873642566034, 11.934258685075157],
              [92.611325386296301, 11.940213587669653],
              [92.613413132248638, 11.945777825097519],
              [92.611651181030865, 11.951150836834191],
              [92.612537779526491, 11.954743400693259],
              [92.614066129909645, 11.960051965896939],
              [92.614848744984243, 11.965614017782933],
              [92.614421156024903, 11.970108778633211],
              [92.613730907469105, 11.975644713678246],
              [92.612954797392305, 11.98030127846779],
              [92.613044992659653, 11.984356150901643],
              [92.615660403933319, 11.987860272644923],
              [92.616529258314984, 11.990827819706613],
              [92.614210796212731, 11.995365049582794],
              [92.61574518353126, 12.003594170384007],
              [92.617240973536326, 12.017942079473833],
              [92.619859903290717, 12.020913381409411],
              [92.619117040335439, 12.027563127130243],
              [92.621721360553579, 12.032828127395781],
              [92.625414572920633, 12.035801112403856],
              [92.631556225935981, 12.039844546107938],
              [92.634696756222581, 12.045435197318623],
              [92.630104962059008, 12.043852022987132],
              [92.627481265379956, 12.041575779878944],
              [92.624298984629078, 12.042266217066762],
              [92.621478519837879, 12.0450650218334],
              [92.621270167817485, 12.048402928638982],
              [92.621592148593678, 12.053108074011991],
              [92.621027716081372, 12.057140216370248],
              [92.618564340724092, 12.062350149667713],
              [92.619053718221707, 12.073524351600804],
              [92.619663437956575, 12.087525116655046],
              [92.622052700553482, 12.101182652760146],
              [92.630811578951977, 12.108894567293454],
              [92.636391822706955, 12.120795424773],
              [92.636352031217285, 12.127102063075021],
              [92.631123794393275, 12.118677951363193],
              [92.628981664577779, 12.121131644960077],
              [92.629648299014875, 12.12639528786274],
              [92.633115538354971, 12.136184552589375],
              [92.636209806284967, 12.149497512002423],
              [92.641354412964134, 12.171207986583967],
              [92.648331606157939, 12.184528791395813],
              [92.653535354487246, 12.201348232443239],
              [92.658396863349637, 12.212903998783409],
              [92.662989405118225, 12.215345840679252],
              [92.661592172694029, 12.210451021552316],
              [92.658124657833568, 12.200288332416083],
              [92.650132427942523, 12.180682298604886],
              [92.652632094443803, 12.177184526511688],
              [92.657187916477966, 12.181735837692575],
              [92.66031338044904, 12.190483222617747],
              [92.662375724162899, 12.197140779422268],
              [92.66623066301959, 12.201367419472584],
              [92.6690192258297, 12.208002680808654],
              [92.671807677436931, 12.214662975870644],
              [92.673980362933875, 12.207314197206866],
              [92.673337676638099, 12.194002868892211],
              [92.673034502317421, 12.185956316943891],
              [92.675871463918398, 12.184568141811107],
              [92.677956826987852, 12.19157465513905],
              [92.677576321861153, 12.196814678145643],
              [92.677523939615938, 12.205232301499274],
              [92.677828205544017, 12.212931698053481],
              [92.681741191228312, 12.207672074165922],
              [92.683811032913439, 12.213635147492102],
              [92.68272532473901, 12.219222686625869],
              [92.685490677200377, 12.230102776047252],
              [92.690033321628036, 12.236740908797678],
              [92.694265396544964, 12.237093677034679],
              [92.697457051676594, 12.23501025677383],
              [92.702420430429044, 12.230470525864478],
              [92.704571596462017, 12.226252218914015],
              [92.700705640196958, 12.223812644493535],
            ],
          ],
          [
            [
              [92.995459175373213, 12.04174829255868],
              [92.990521316531883, 12.044209690631824],
              [92.984512027591606, 12.045953102171685],
              [92.980629449029593, 12.047369830089181],
              [92.977788414617493, 12.051566601712533],
              [92.975654889743055, 12.059263097805518],
              [92.978467095639871, 12.063108249890512],
              [92.975984770469196, 12.064872314856567],
              [92.972813598946303, 12.063113571748323],
              [92.971050887637958, 12.066266584626858],
              [92.966106364190679, 12.064160530071653],
              [92.961868637468513, 12.066967982059646],
              [92.961147389934382, 12.071511344169487],
              [92.960078286206667, 12.076426694731353],
              [92.965352642329734, 12.077813875883104],
              [92.968524174252025, 12.078877843924309],
              [92.968861851815916, 12.082354204881858],
              [92.971681558186091, 12.083766618571355],
              [92.972370878062492, 12.086918321981505],
              [92.973759542166263, 12.090417078321206],
              [92.969886063810506, 12.08935384969161],
              [92.96530572860101, 12.089356770553565],
              [92.961396738853438, 12.097079252709518],
              [92.958901485433543, 12.101624420477243],
              [92.962777997908674, 12.102316468586578],
              [92.967016812690957, 12.099857313490375],
              [92.972336831303991, 12.096005270093542],
              [92.97691969868248, 12.094958221688191],
              [92.979728116621203, 12.099500372846295],
              [92.986065546991057, 12.104409759320507],
              [92.986784272774969, 12.099842130670696],
              [92.993837771437072, 12.100555061421174],
              [92.998425636413117, 12.098094125738706],
              [92.998800934251335, 12.09109304746686],
              [92.994936261718991, 12.087943507872083],
              [92.991088220979108, 12.079903607912939],
              [92.991834844595076, 12.067292879797316],
              [92.990811977469363, 12.05994625421611],
              [92.994347025765606, 12.057857576940888],
              [92.997185439056381, 12.054703015924506],
              [92.997905784392998, 12.049093496613049],
              [92.995459175373213, 12.04174829255868],
            ],
          ],
          [
            [
              [93.040067147054629, 12.041215644880563],
              [93.036975894199131, 12.043722742726722],
              [93.034855077130345, 12.049171273459892],
              [93.03322497880086, 12.054804949458379],
              [93.032489632502916, 12.05784317683006],
              [93.030273751051226, 12.063547107830487],
              [93.028254753931847, 12.066586014872971],
              [93.026470043859334, 12.069159715725148],
              [93.023543454956368, 12.071088009757499],
              [93.019563298019364, 12.073826498077516],
              [93.01479019904842, 12.075824585689208],
              [93.010842017386679, 12.075990807767633],
              [93.006537564380011, 12.077780443061865],
              [93.005305205369964, 12.08218595365371],
              [93.006432210492903, 12.087562173539409],
              [93.008097557701689, 12.092127236071416],
              [93.008407003428204, 12.096392686277182],
              [93.009561195844697, 12.100401796608594],
              [93.009308444979084, 12.10564012367807],
              [93.008969071595132, 12.109327447479476],
              [93.007972438461934, 12.113083562381165],
              [93.007399603104886, 12.116700650625761],
              [93.006335194958922, 12.119924297028575],
              [93.004472376157111, 12.124423116867337],
              [93.00340608624893, 12.128434948737798],
              [93.003786793809851, 12.133395137078788],
              [93.004424441976695, 12.137823869248372],
              [93.006352859940762, 12.140627035813452],
              [93.007862511870869, 12.143430762736918],
              [93.010051129595723, 12.146002173899481],
              [93.014291132029967, 12.149707399690275],
              [93.018165818527052, 12.15093275496074],
              [93.02182961532732, 12.159159337535707],
              [93.024457834674422, 12.163167676334293],
              [93.027468840345193, 12.164208114405616],
              [93.028539323957006, 12.158781011845701],
              [93.026960816933766, 12.155467432961828],
              [93.024493136549424, 12.152664058917328],
              [93.023805414896572, 12.149002141377215],
              [93.024521906588674, 12.14485151935973],
              [93.02679935944883, 12.141718408313826],
              [93.023084408189106, 12.141398122778538],
              [93.019526346030602, 12.142931559443976],
              [93.019705764505858, 12.13836505107575],
              [93.022215004438138, 12.136436992944414],
              [93.025864904320358, 12.134903215964171],
              [93.028862954630497, 12.133046029302308],
              [93.030583078075935, 12.129449884795193],
              [93.031552088510168, 12.125901552346942],
              [93.032710156118696, 12.121983157852405],
              [93.031507111408175, 12.119016954107874],
              [93.029482695036805, 12.116051906372473],
              [93.025941653006669, 12.113227672949021],
              [93.023684689965037, 12.110749254698613],
              [93.025235107832856, 12.107942017910002],
              [93.028231373922381, 12.106733800636498],
              [93.030020948629101, 12.102396747364104],
              [93.030407725596959, 12.098849530046126],
              [93.02473549428673, 12.096042090135809],
              [93.030587227944153, 12.094607424492196],
              [93.033819126571728, 12.092030395939599],
              [93.035940154681413, 12.086719223426535],
              [93.03877910538192, 12.083517043680729],
              [93.041779959447837, 12.080384956987597],
              [93.047143151010175, 12.076530232967515],
              [93.048531502554937, 12.073144643106451],
              [93.045218976447174, 12.071619034141323],
              [93.047568214102967, 12.068023386690403],
              [93.050561682593624, 12.06713874216266],
              [93.051553567324589, 12.063428452753058],
              [93.04976392033403, 12.060950967408905],
              [93.047365741250033, 12.058543181456685],
              [93.046237255559959, 12.053886588040973],
              [93.049167274589777, 12.050684242660692],
              [93.049014913215203, 12.047393178410999],
              [93.046267460752361, 12.044986485615704],
              [93.043376084820721, 12.043714831366071],
              [93.040067147054629, 12.041215644880563],
            ],
          ],
          [
            [
              [93.116092977523095, 12.128934383938851],
              [93.112574783976783, 12.132811956575029],
              [93.110365555935729, 12.137428991780574],
              [93.112345144499571, 12.139952902289574],
              [93.114977775828393, 12.142754386958037],
              [93.11733350785785, 12.144744024016861],
              [93.120697571602832, 12.145016729855307],
              [93.122713663218931, 12.142694868876744],
              [93.122912883199731, 12.138474040438041],
              [93.121447532023069, 12.135764193055339],
              [93.11867677370968, 12.132361090967311],
              [93.116092977523095, 12.128934383938851],
            ],
          ],
          [
            [
              [92.982201094880168, 12.106452461043991],
              [92.978966954209639, 12.109422487013491],
              [92.977344231982357, 12.111996979672083],
              [92.979742602589866, 12.113919540952708],
              [92.979823368475735, 12.117140958373598],
              [92.975849093985175, 12.117862882777676],
              [92.970293343731626, 12.116313975398542],
              [92.964465552726793, 12.118589589460026],
              [92.960396148045533, 12.125431806958563],
              [92.956995468738342, 12.134359147360104],
              [92.95644978776599, 12.142056752650312],
              [92.957487934952951, 12.145371486993712],
              [92.962247863711255, 12.14729239389578],
              [92.965780729665497, 12.146594523822811],
              [92.969834443698815, 12.143786909666355],
              [92.970392350869034, 12.138893757777595],
              [92.973187916653629, 12.135112766348197],
              [92.976206364451201, 12.134462063251982],
              [92.978860997472921, 12.136477219262083],
              [92.981915222383179, 12.138306530002849],
              [92.985953596881359, 12.13983370336636],
              [92.990492237735424, 12.138299325219835],
              [92.991891685524607, 12.133405936070393],
              [92.992724633962695, 12.129233217934415],
              [92.992480529580035, 12.125871375135779],
              [92.992912091009018, 12.122903659383576],
              [92.995023875408762, 12.120722595618743],
              [92.997763287489974, 12.118795487940702],
              [92.99744917546721, 12.115596517146292],
              [92.995616919169322, 12.111912130626543],
              [92.991250763159073, 12.110942724846188],
              [92.987113818690375, 12.111178224770184],
              [92.983891655285547, 12.110879136194466],
              [92.982201094880168, 12.106452461043991],
            ],
          ],
          [
            [
              [93.054582299480685, 12.108255864674202],
              [93.052960127584839, 12.110993165385564],
              [93.052624326746013, 12.114192518508155],
              [93.056659764348723, 12.116111794049619],
              [93.059400718983838, 12.113696522220186],
              [93.063859390186934, 12.115266969787706],
              [93.067855643767686, 12.115169211542192],
              [93.067538699843169, 12.119319365762289],
              [93.066174100349926, 12.122312100550024],
              [93.064993862188715, 12.125999327170776],
              [93.061871169502595, 12.123383439497545],
              [93.058376875091398, 12.120003754228781],
              [93.054870930951679, 12.119730451024937],
              [93.0517687887221, 12.121693117253757],
              [93.048735511704862, 12.116816419500115],
              [93.046482664097582, 12.119439440925532],
              [93.044416317588812, 12.122641286351929],
              [93.040693908420536, 12.124384906248999],
              [93.036325387598879, 12.124203819662007],
              [93.035822708846638, 12.127682196660512],
              [93.036394656386861, 12.131274625882666],
              [93.037732556051779, 12.136188112466826],
              [93.038704021539303, 12.139479182243351],
              [93.040348883147161, 12.143882216167349],
              [93.043234853743158, 12.153941387459529],
              [93.045945520893866, 12.161194935653494],
              [93.048659332525887, 12.167475703663065],
              [93.049910354805533, 12.170975343479103],
              [93.050670596781245, 12.174267239876869],
              [93.051946350528667, 12.177441176579009],
              [93.0538738810788, 12.180847835876635],
              [93.055243279994286, 12.183837925895196],
              [93.057469994008883, 12.189631299472513],
              [93.059302944550055, 12.193895839116255],
              [93.061530500438721, 12.198832023215683],
              [93.062501005659996, 12.202703619713891],
              [93.063844468857582, 12.206573578656023],
              [93.069009249143846, 12.207146560334175],
              [93.073126981345183, 12.206375770125128],
              [93.074008881346671, 12.201342562644813],
              [93.070794501638119, 12.197172603098382],
              [93.073493349093724, 12.194758099587405],
              [93.077361755406514, 12.190392222995298],
              [93.080676950914267, 12.19242848735912],
              [93.083607667684149, 12.189895576518108],
              [93.082357110626049, 12.185839863075916],
              [93.082766842726372, 12.181758522347721],
              [93.078281559803713, 12.181092722987671],
              [93.073402129520233, 12.178781360182441],
              [93.071258047917311, 12.176558091959665],
              [93.072744808356077, 12.172382175847735],
              [93.075752638455072, 12.174812494385478],
              [93.079467065556827, 12.175572071372304],
              [93.083958466839732, 12.17470746186363],
              [93.086604959777375, 12.173057266438706],
              [93.088859278620987, 12.169646023563123],
              [93.088963322006563, 12.165889797579174],
              [93.087898972643671, 12.162203887115924],
              [93.086742187614107, 12.158426676873903],
              [93.08537805540432, 12.153698594376417],
              [93.086186319993104, 12.149710183176406],
              [93.083554953115268, 12.146142613384384],
              [93.087648465171753, 12.144978129936455],
              [93.091768232735788, 12.143510304095706],
              [93.092061970684952, 12.138734228448316],
              [93.089144771831286, 12.137486423296199],
              [93.087216001769264, 12.13389626226413],
              [93.087110661101306, 12.130140890671457],
              [93.084404912530218, 12.128197306382029],
              [93.084885168183845, 12.124626424993158],
              [93.086086071802498, 12.121031378357769],
              [93.083147564951616, 12.119598402380463],
              [93.081706151011048, 12.116887674480166],
              [93.082793847516953, 12.113200769086905],
              [93.085802940466039, 12.114539925189494],
              [93.089027694935709, 12.114836546600245],
              [93.089131542461232, 12.111452381141353],
              [93.087970276693596, 12.108648722852191],
              [93.085923192950062, 12.106333835018278],
              [93.08408443159145, 12.103717486870861],
              [93.086242704081414, 12.100815985499015],
              [93.087420213691701, 12.097707555617852],
              [93.085467265710506, 12.094813751221196],
              [93.083441747324571, 12.092104452614977],
              [93.083054960863052, 12.089114090746659],
              [93.083253176781739, 12.085614240228812],
              [93.080832264103549, 12.083021709880015],
              [93.078429860768225, 12.08114770429763],
              [93.074351015656376, 12.078534235970437],
              [93.072356924969199, 12.081272061153609],
              [93.070287272342881, 12.08553945852886],
              [93.067455444585818, 12.087096917458293],
              [93.064921018574196, 12.090762953574115],
              [93.061282341279892, 12.095612581520962],
              [93.058750924326944, 12.09851419873128],
              [93.056957446807345, 12.103453075360564],
              [93.054582299480685, 12.108255864674202],
            ],
          ],
          [
            [
              [92.932402621467276, 12.191526232401882],
              [92.930768704326312, 12.196837463551871],
              [92.929236988374626, 12.199480942363143],
              [92.927210248397841, 12.203261830614927],
              [92.926046573684999, 12.207505608820286],
              [92.925656314534095, 12.211193185112082],
              [92.926482604931095, 12.215181920050524],
              [92.928667300364481, 12.218380593995972],
              [92.933150641652219, 12.219515662636383],
              [92.938120690006372, 12.216962266757337],
              [92.938134899308821, 12.213182161511128],
              [92.936324278287728, 12.210260819392069],
              [92.933297644859621, 12.207131271970885],
              [92.934564191960021, 12.200521884576542],
              [92.934952326779964, 12.196927415411663],
              [92.932402621467276, 12.191526232401882],
            ],
          ],
          [
            [
              [92.872652086588445, 12.189707229259158],
              [92.869108459804579, 12.192629756100883],
              [92.865932755487336, 12.196896645547804],
              [92.864769233947356, 12.200490841848907],
              [92.867817581761699, 12.203597339451493],
              [92.871916800795972, 12.201998138701338],
              [92.87497304251832, 12.198496539039379],
              [92.877463807431425, 12.19594494395848],
              [92.879489461087445, 12.192837639356336],
              [92.876833979816496, 12.190658424144798],
              [92.872652086588445, 12.189707229259158],
            ],
          ],
          [
            [
              [92.746328775137457, 12.177735471699348],
              [92.744396947211101, 12.180098670296523],
              [92.745074301956095, 12.184551704234416],
              [92.744768676871558, 12.189003965235699],
              [92.744272590868363, 12.194383206585492],
              [92.74539675373795, 12.19797858147434],
              [92.745367866269135, 12.20347460043423],
              [92.745122557646809, 12.209711671712718],
              [92.745673149360925, 12.215672776081096],
              [92.746019129785466, 12.22086691783473],
              [92.747043356516599, 12.225691971323529],
              [92.751038904011807, 12.226646258098409],
              [92.753164863924837, 12.222774430053345],
              [92.752806389181046, 12.21964434824028],
              [92.754436807737846, 12.216537952334923],
              [92.759158577565046, 12.221194156876903],
              [92.760439569664072, 12.218049785086817],
              [92.761032802150098, 12.212090871224872],
              [92.761356048607752, 12.208403447354454],
              [92.762811896819642, 12.203116907769443],
              [92.762741711722754, 12.198664340459754],
              [92.76333240718067, 12.193563112384087],
              [92.764872459048377, 12.189391389596659],
              [92.765196503042503, 12.185982700496496],
              [92.76175723362141, 12.186188446945966],
              [92.757759038251521, 12.186370503643262],
              [92.754905105118837, 12.182380151759425],
              [92.752699039344819, 12.179526496555114],
              [92.746328775137457, 12.177735471699348],
            ],
          ],
          [
            [
              [93.853745898851557, 12.263556159530285],
              [93.850611567651143, 12.263879523817002],
              [93.847343331639536, 12.266082637061279],
              [93.844680936159747, 12.268094957081635],
              [93.841412973929891, 12.270599374862329],
              [93.838613638741364, 12.274190254772352],
              [93.837384854333777, 12.279139065346971],
              [93.839264458130103, 12.282999810317007],
              [93.843187788688013, 12.289028202186698],
              [93.84614233214873, 12.291791269716906],
              [93.848509003929436, 12.294095295499435],
              [93.85475703625805, 12.294052161886764],
              [93.858801401667236, 12.293096758322923],
              [93.861605663170792, 12.291847471613577],
              [93.864571830133173, 12.289020670227949],
              [93.866128767032336, 12.285460812510712],
              [93.86735623275581, 12.280024353369759],
              [93.868135568537127, 12.273987140228579],
              [93.865149433901081, 12.268279664639737],
              [93.863437018404241, 12.265809633712415],
              [93.859667336922101, 12.264745563266578],
              [93.853745898851557, 12.263556159530285],
            ],
          ],
          [
            [
              [93.069090156338362, 12.31281797959492],
              [93.06487427304134, 12.314331542021685],
              [93.065940977060464, 12.31720706918269],
              [93.069825269827263, 12.317595268541632],
              [93.072662878009936, 12.315388423840414],
              [93.069090156338362, 12.31281797959492],
            ],
          ],
          [
            [
              [92.893017872376021, 12.319775016644316],
              [92.891385606846981, 12.323626368653898],
              [92.89527077377808, 12.323624986026566],
              [92.893017872376021, 12.319775016644316],
            ],
          ],
          [
            [
              [92.909592496123651, 12.334687844000596],
              [92.909245341261737, 12.338933268236534],
              [92.910309833424876, 12.34199592629624],
              [92.910455589658099, 12.345916090339108],
              [92.911215961448534, 12.348979358411755],
              [92.913874184736059, 12.35097335753218],
              [92.916644238050651, 12.349070455079442],
              [92.916753508599456, 12.345404949778187],
              [92.91508432000694, 12.34192507152383],
              [92.913342617746991, 12.338839344107926],
              [92.909592496123651, 12.334687844000596],
            ],
          ],
          [
            [
              [92.93060973214007, 12.356884164733735],
              [92.926506690981498, 12.358370308487316],
              [92.921982794078502, 12.359694728372196],
              [92.91927800897696, 12.362688428316147],
              [92.9189295384856, 12.367352479166671],
              [92.920922350168837, 12.372501836204053],
              [92.922334737954287, 12.376168210702904],
              [92.924304203364841, 12.380552376983511],
              [92.925323248647842, 12.383615471304282],
              [92.925539013508029, 12.387861722889914],
              [92.926032097081062, 12.392757666647768],
              [92.926437490311784, 12.396748206308212],
              [92.927168453403596, 12.40083178105959],
              [92.928582144711882, 12.40456749958963],
              [92.929645188090262, 12.407629734730277],
              [92.9309929822263, 12.410297417926389],
              [92.933741243723276, 12.413615078056994],
              [92.937408627226176, 12.415957021876343],
              [92.940776810458516, 12.417023096081449],
              [92.943779577689853, 12.415861920098727],
              [92.946062391397987, 12.412773764112083],
              [92.948321786057846, 12.415765972092986],
              [92.947794720790128, 12.418922703490921],
              [92.950312188964716, 12.421590358464123],
              [92.951891932792506, 12.424675430757395],
              [92.954316787720032, 12.427481630048634],
              [92.956157328324778, 12.424254796137122],
              [92.956265075396729, 12.420843363574198],
              [92.957377736370347, 12.417687047330404],
              [92.957881568080907, 12.414530922914546],
              [92.955298399695621, 12.410540362834096],
              [92.952876755183382, 12.40713125070627],
              [92.951040316880068, 12.403976511215278],
              [92.947539616676792, 12.401147460555183],
              [92.943847381445536, 12.399246344002005],
              [92.943215633320463, 12.393422669676239],
              [92.94355833079338, 12.389917726691783],
              [92.943153899569282, 12.385858096704503],
              [92.943010605183005, 12.380961583293264],
              [92.942437072025285, 12.377968777925128],
              [92.939522297654008, 12.375163002479335],
              [92.936256274750932, 12.372403319975804],
              [92.934936267506956, 12.368830882393679],
              [92.933849030814272, 12.365606656733885],
              [92.933118398135733, 12.361615344692632],
              [92.93060973214007, 12.356884164733735],
            ],
          ],
          [
            [
              [92.684025884401251, 12.54014984700461],
              [92.683267646757571, 12.530673572375409],
              [92.681427451214915, 12.520990440982018],
              [92.680521370005565, 12.511866965359765],
              [92.674475702120546, 12.508097118116284],
              [92.671982605788429, 12.513457071957601],
              [92.665166339349938, 12.524450606075586],
              [92.661992153435733, 12.529993987568565],
              [92.659689571275649, 12.534425125942352],
              [92.665160426737756, 12.5407246142536],
              [92.672430753313535, 12.547606324452781],
              [92.677244867386094, 12.553904788292755],
              [92.68209496914946, 12.55033608053794],
              [92.683937780521759, 12.544232635873705],
              [92.684025884401251, 12.54014984700461],
            ],
          ],
          [
            [
              [92.862312141569618, 12.396325025846698],
              [92.866976147404714, 12.39917196672083],
              [92.869992440639606, 12.400262901667933],
              [92.873356201651106, 12.396596597205271],
              [92.874050045693565, 12.393371165354532],
              [92.875726928912059, 12.390216066296279],
              [92.879665374427375, 12.389286597644084],
              [92.883024856369758, 12.391955577325236],
              [92.88443866604257, 12.394948191863383],
              [92.890725854921229, 12.392604599787001],
              [92.888822632263128, 12.388961527894342],
              [92.886236119864577, 12.386037864916469],
              [92.883556417660728, 12.383393218147576],
              [92.882401346324542, 12.379820176036718],
              [92.883748783006467, 12.37708219401908],
              [92.883697743761985, 12.372510882932204],
              [92.880162378932425, 12.372580415957717],
              [92.879327001271193, 12.376083833007254],
              [92.877114684336178, 12.378730030772298],
              [92.873919443106445, 12.381073624117654],
              [92.871312236725402, 12.3830688099669],
              [92.869145278845011, 12.380724892884929],
              [92.868412831833865, 12.377244321259472],
              [92.864556753708243, 12.375991787447846],
              [92.862107573429867, 12.379147458791465],
              [92.862693771561567, 12.383555818940151],
              [92.863168692105063, 12.387222601894248],
              [92.862896509046493, 12.390447606445131],
              [92.862312141569618, 12.396325025846698],
            ],
          ],
          [
            [
              [92.862312141569618, 12.396325025846698],
              [92.858790597721494, 12.392210804101435],
              [92.856695197782372, 12.389866866212904],
              [92.853521521311166, 12.387383785864621],
              [92.852080454332778, 12.390376770694534],
              [92.848880175695143, 12.393369482646529],
              [92.846622872252155, 12.395364915496454],
              [92.845341655098977, 12.398752558376051],
              [92.847999611014373, 12.401097130138082],
              [92.850261469846004, 12.40341732905847],
              [92.854024778890818, 12.404508612244417],
              [92.858059467884658, 12.403418327694199],
              [92.861250772646898, 12.401748345673433],
              [92.862312141569618, 12.396325025846698],
            ],
          ],
          [
            [
              [92.863805223469214, 12.316690939274746],
              [92.864091664833893, 12.320101589800524],
              [92.863935942619605, 12.3236036420041],
              [92.866054364968889, 12.326016507073808],
              [92.868455750775766, 12.322676834268563],
              [92.871521180109013, 12.322977412734469],
              [92.876567424715461, 12.324671357185327],
              [92.880709153967146, 12.324972587376063],
              [92.884524208662469, 12.324578071400182],
              [92.885241462144151, 12.321307353489354],
              [92.883263303307743, 12.318894311964204],
              [92.880036937149384, 12.318129320681349],
              [92.875995025438272, 12.317131752923574],
              [92.871151565689402, 12.316899615130058],
              [92.867482789984436, 12.315693339743518],
              [92.863805223469214, 12.316690939274746],
            ],
          ],
          [
            [
              [92.771746958880357, 12.613208700882833],
              [92.768779864620313, 12.615667856908427],
              [92.767376566107359, 12.61928952658346],
              [92.76562014581485, 12.623003534747136],
              [92.767576130610507, 12.625699146157986],
              [92.771420355382816, 12.621869996601106],
              [92.772147756105795, 12.61745889756147],
              [92.771746958880357, 12.613208700882833],
            ],
          ],
          [
            [
              [92.770979963593348, 12.638310965083564],
              [92.766549964340413, 12.641861135704838],
              [92.763884195610729, 12.64037306953527],
              [92.762504081817951, 12.635704022509168],
              [92.760786794831304, 12.632219245146381],
              [92.759238343688637, 12.628084551625918],
              [92.755653515402344, 12.632822249630467],
              [92.75187539671434, 12.627451526079033],
              [92.750088788908968, 12.624198724668817],
              [92.744521535712863, 12.621383881120659],
              [92.74160020178708, 12.62372680356042],
              [92.739005621821789, 12.626442032956071],
              [92.737955372115323, 12.629714971058034],
              [92.736926267873869, 12.63329023559006],
              [92.735640457668609, 12.636772517078006],
              [92.732503404965655, 12.635840858003968],
              [92.731381856319928, 12.639090826870987],
              [92.730842172976793, 12.643409616498044],
              [92.731050959523571, 12.647938860344437],
              [92.731251539583425, 12.653907810278781],
              [92.732801442803805, 12.657950016304792],
              [92.736536105028733, 12.661065303974235],
              [92.738957642417446, 12.664342513152024],
              [92.741621674427279, 12.666132957085756],
              [92.743747262308645, 12.66388236094169],
              [92.746728455582826, 12.663188066320131],
              [92.749181688570872, 12.670274497004371],
              [92.755667923957475, 12.667607692690638],
              [92.759686390512883, 12.666380465090731],
              [92.762835884194757, 12.665059664667496],
              [92.768911337398094, 12.665245403777442],
              [92.765682441595118, 12.659232236182387],
              [92.763829692659428, 12.654725433819996],
              [92.762582628089604, 12.651379733019185],
              [92.766362392181961, 12.650593262057564],
              [92.768388663878042, 12.653474364483444],
              [92.769613951709488, 12.656657254517016],
              [92.77292660709054, 12.655892123081806],
              [92.773192854150906, 12.649831240132077],
              [92.772204703130043, 12.646254129965742],
              [92.771963403847337, 12.643072200977732],
              [92.770979963593348, 12.638310965083564],
            ],
          ],
          [
            [
              [92.786293886222154, 12.893065742134803],
              [92.786441040123208, 12.887698016121901],
              [92.782019561131051, 12.883790803013682],
              [92.78162378144637, 12.887578108176422],
              [92.779885334778825, 12.891830731942791],
              [92.786293886222154, 12.893065742134803],
            ],
          ],
          [
            [
              [92.786293886222154, 12.893065742134803],
              [92.784538838146432, 12.896365295200305],
              [92.788134913649799, 12.896251322946577],
              [92.786293886222154, 12.893065742134803],
            ],
          ],
          [
            [
              [92.744586868591981, 12.892663939038387],
              [92.742596110000648, 12.895474413169326],
              [92.744438409302873, 12.897917059103419],
              [92.748542589446615, 12.894806141848347],
              [92.744586868591981, 12.892663939038387],
            ],
          ],
          [
            [
              [92.929352351806216, 12.916135204067816],
              [92.929453564480596, 12.919807393718267],
              [92.932620491553877, 12.921131189458626],
              [92.932753406078461, 12.917552361819492],
              [92.929352351806216, 12.916135204067816],
            ],
          ],
          [
            [
              [92.889400352532064, 12.936368691673655],
              [92.886408683167119, 12.937439283307953],
              [92.886748986235261, 12.940460109425018],
              [92.890578219074627, 12.940761821441106],
              [92.889400352532064, 12.936368691673655],
            ],
          ],
          [
            [
              [92.869865462932651, 12.92140044556184],
              [92.865417137634324, 12.922633214385151],
              [92.861574897248644, 12.924979950942667],
              [92.858110053643614, 12.927094833212898],
              [92.857641140245875, 12.931604790276582],
              [92.859391762670171, 12.934231583889],
              [92.864515110897315, 12.934510853455548],
              [92.868517187097282, 12.933279008786243],
              [92.872424194762729, 12.932163230315608],
              [92.876940951285249, 12.931442633860692],
              [92.880712567584695, 12.929257433491122],
              [92.882297723608417, 12.92658432382799],
              [92.880453954869651, 12.92418965978959],
              [92.876285848448347, 12.92574770426722],
              [92.8735709274724, 12.928095528630873],
              [92.870353557396314, 12.927769713441773],
              [92.870532021857187, 12.924748256472775],
              [92.869865462932651, 12.92140044556184],
            ],
          ],
          [
            [
              [92.75918807718574, 12.929795839482319],
              [92.756700269014019, 12.933210498243653],
              [92.75828618615364, 12.935769029153377],
              [92.761257869908633, 12.933958105650492],
              [92.75918807718574, 12.929795839482319],
            ],
          ],
          [
            [
              [92.783827822811432, 12.794881760132176],
              [92.783894007106554, 12.800226159221998],
              [92.783444475669285, 12.805569750527118],
              [92.784619904827622, 12.809544228849147],
              [92.787331841307989, 12.807407901511477],
              [92.78820041556294, 12.803226271302155],
              [92.78768120200462, 12.799276243918721],
              [92.783827822811432, 12.794881760132176],
            ],
          ],
          [
            [
              [92.712028479284669, 12.837878486505211],
              [92.708706861733177, 12.839571123766659],
              [92.711160125623834, 12.841827309765488],
              [92.713321767240402, 12.845896926285514],
              [92.712898390469206, 12.849916990176004],
              [92.713276054331516, 12.853797800251419],
              [92.714778678486709, 12.858075687885151],
              [92.716423195302525, 12.862213656318794],
              [92.719243317019959, 12.866028861121121],
              [92.724105485268453, 12.866173532045275],
              [92.727967080480752, 12.864665829815474],
              [92.730443870463674, 12.862901987917713],
              [92.729406789272232, 12.859531139319481],
              [92.727070315279576, 12.857089333127606],
              [92.724718377426441, 12.85355480645023],
              [92.722271371083536, 12.84992641431926],
              [92.720762071601001, 12.846904165489413],
              [92.718569295555923, 12.844253029933896],
              [92.716140963833567, 12.841903168655479],
              [92.712028479284669, 12.837878486505211],
            ],
          ],
          [
            [
              [92.766138959333048, 12.85263715742869],
              [92.766375931278318, 12.8566817335533],
              [92.769323830203774, 12.859123533921831],
              [92.771543589525677, 12.856800690181915],
              [92.766138959333048, 12.85263715742869],
            ],
          ],
          [
            [
              [92.709814482870684, 12.734135586253572],
              [92.710165567305225, 12.738154163503841],
              [92.710259928491126, 12.742080825233153],
              [92.709250438107205, 12.746168322930483],
              [92.70852836870516, 12.749373428232721],
              [92.707753733585193, 12.753182552431497],
              [92.707662939081956, 12.756689918656708],
              [92.707481234275505, 12.759919393762369],
              [92.706941051124161, 12.763891480709702],
              [92.705792503486791, 12.767352088342962],
              [92.705769324642546, 12.771672460259401],
              [92.704758745913679, 12.775691172812051],
              [92.703517765872903, 12.7790351354364],
              [92.702562109066236, 12.781915376336771],
              [92.700261413553065, 12.78581612188488],
              [92.699139176540285, 12.789113836398432],
              [92.697268397137861, 12.791643829723334],
              [92.694808777172412, 12.794452600815502],
              [92.692818961559922, 12.797447516620551],
              [92.69329533227959, 12.800492121317804],
              [92.696194981145993, 12.802284919355438],
              [92.699686083381039, 12.803682948628625],
              [92.70140193939072, 12.807472330151985],
              [92.703191791700917, 12.810634487386222],
              [92.704086117922643, 12.814562441241618],
              [92.70477094109944, 12.817607512107113],
              [92.705050299699508, 12.822162397259142],
              [92.705193755572324, 12.825740398561081],
              [92.707384522582927, 12.828670804275566],
              [92.709807859793358, 12.832182913248092],
              [92.712219475058191, 12.829256890826271],
              [92.711304749907129, 12.824980845439995],
              [92.710618189846755, 12.822005059898542],
              [92.710477872358226, 12.817962820914818],
              [92.710380427775931, 12.814174975753581],
              [92.709419262813952, 12.810013793411779],
              [92.709250813356803, 12.80662163214614],
              [92.709694777115914, 12.802927338262718],
              [92.710421664261361, 12.799303833771752],
              [92.709524542203624, 12.79602637921951],
              [92.709591974351014, 12.792634894006028],
              [92.709922683104196, 12.788197074868723],
              [92.709634779526539, 12.785082947131549],
              [92.709774340259287, 12.781459301400883],
              [92.710508178323408, 12.776348287405551],
              [92.710689390417784, 12.773351224705953],
              [92.711880912681835, 12.770355800010888],
              [92.715044798144163, 12.767130089835016],
              [92.715765827258863, 12.764180077028968],
              [92.716183729127309, 12.761137053343591],
              [92.718310760333821, 12.758374575499479],
              [92.715337903840378, 12.75700090525903],
              [92.714725216465013, 12.753306783282877],
              [92.715849238483059, 12.749683592511371],
              [92.716033554444067, 12.746222602235607],
              [92.715137935225457, 12.742992153677795],
              [92.714639834147874, 12.739552788412764],
              [92.714118539577271, 12.736439599600489],
              [92.709814482870684, 12.734135586253572],
            ],
          ],
          [
            [
              [92.731998054267194, 12.812407901191328],
              [92.730409851396985, 12.806644160534082],
              [92.727027237729516, 12.806825937893153],
              [92.725124890248239, 12.802966821557353],
              [92.721807441291901, 12.80377780412441],
              [92.722071401436949, 12.806937022308196],
              [92.722054414176853, 12.810051490129419],
              [92.722100565812468, 12.814186912497943],
              [92.720437596016382, 12.817694624847512],
              [92.721424950159985, 12.821622448244401],
              [92.724367787689559, 12.824436176267227],
              [92.724693888083777, 12.829107944648074],
              [92.726249621702536, 12.832222940369496],
              [92.729342209305315, 12.82934434741953],
              [92.729719708810435, 12.8248604343646],
              [92.730141563961638, 12.821095999871408],
              [92.730352268245895, 12.816727936105154],
              [92.731998054267194, 12.812407901191328],
            ],
          ],
          [
            [
              [92.665539484593197, 12.784771198319463],
              [92.662712391805741, 12.786300938618625],
              [92.662503088713791, 12.789995490030984],
              [92.658010190726429, 12.794774510662439],
              [92.659813324033806, 12.799470947622998],
              [92.661048051026526, 12.804978918120455],
              [92.660380026564056, 12.810578621274406],
              [92.660453520764094, 12.813924534751612],
              [92.658978912218444, 12.816896650191273],
              [92.657315909181122, 12.819705794680893],
              [92.65691854557106, 12.823213887849631],
              [92.656063977688532, 12.828557721029304],
              [92.654677304407727, 12.832342549797156],
              [92.652462538695403, 12.837474467244521],
              [92.650962609242498, 12.84063351857824],
              [92.650448391879806, 12.843979167101679],
              [92.649605679889618, 12.847324294108102],
              [92.649575192430405, 12.852203297229378],
              [92.649083588857408, 12.855363561884968],
              [92.648337016596599, 12.858337419444213],
              [92.647959722039118, 12.862589902053964],
              [92.648668375035726, 12.86565769359034],
              [92.65185398319899, 12.867010730688675],
              [92.655035673566587, 12.869270644369946],
              [92.656027029583967, 12.872432073387539],
              [92.657082096497476, 12.876687235203914],
              [92.658257143516963, 12.880128979304121],
              [92.660764110055439, 12.885268072053982],
              [92.66203341405361, 12.889059209918436],
              [92.662361685923287, 12.893126920093543],
              [92.662549662300037, 12.896636568084453],
              [92.663532532918495, 12.901240133559865],
              [92.664328559234505, 12.905401448447831],
              [92.666304942949054, 12.908937070207754],
              [92.666465699916799, 12.913260371668006],
              [92.665802039417798, 12.918234086404425],
              [92.665587142168278, 12.922487858580665],
              [92.666196395011312, 12.926625899385456],
              [92.670189488949035, 12.930977535732593],
              [92.67291997149718, 12.934142882326775],
              [92.674991686081256, 12.937586534448112],
              [92.67551129661507, 12.941190039041439],
              [92.67678932560051, 12.947235285893241],
              [92.677659403322451, 12.951119262064401],
              [92.677637975095166, 12.954908497624389],
              [92.674614796928566, 12.957089287700892],
              [92.671878650678366, 12.958433686336205],
              [92.67047273958751, 12.961593908261607],
              [92.671550970819496, 12.966105060675231],
              [92.674628057563595, 12.970269983834793],
              [92.676635055607207, 12.972900449362847],
              [92.678513122744363, 12.977063856929011],
              [92.679683897371532, 12.982017825217225],
              [92.680581722962671, 12.985180474825851],
              [92.683198231779443, 12.987904092189428],
              [92.686400282025403, 12.987187609584401],
              [92.6912374252814, 12.988449238324602],
              [92.69526172821233, 12.987826771276881],
              [92.699566931853795, 12.987482919740872],
              [92.702314590436245, 12.984044908368386],
              [92.704899829531257, 12.980514561665981],
              [92.70800368975361, 12.98035547533782],
              [92.712364520510789, 12.982429519374218],
              [92.716294684368094, 12.981969005634433],
              [92.714762587881083, 12.978549723168207],
              [92.712407359114536, 12.975291853443071],
              [92.711252035683628, 12.971594742308772],
              [92.712445735769521, 12.96878240330698],
              [92.712567095815118, 12.964086455009898],
              [92.711598147018066, 12.960552634659489],
              [92.711531692107656, 12.955763009722181],
              [92.707721929013047, 12.950727571150802],
              [92.710190479968347, 12.948090308861753],
              [92.713137941740698, 12.946374124610266],
              [92.715527444355089, 12.944120715846234],
              [92.716915707312609, 12.93970612310477],
              [92.716938070527817, 12.935823843643684],
              [92.715687589450752, 12.932567926481811],
              [92.712947818714269, 12.930845459780528],
              [92.70922246758083, 12.928679028351247],
              [92.707499414881894, 12.925771680837071],
              [92.712825433511043, 12.923429619606427],
              [92.716575780224403, 12.921272116661875],
              [92.716411891729948, 12.917018108681944],
              [92.716815827356214, 12.911881871724109],
              [92.716850403276752, 12.906280781207425],
              [92.717046886645505, 12.900679035230883],
              [92.716630035630303, 12.895611230181606],
              [92.716208317547569, 12.891195271643433],
              [92.71582896346996, 12.887800960199261],
              [92.714102819965674, 12.885266550304456],
              [92.710644722462661, 12.8861695558621],
              [92.707437373391571, 12.887978630207185],
              [92.703520582389629, 12.88678793028773],
              [92.699875947537564, 12.883437702574991],
              [92.697987626045332, 12.880925479027251],
              [92.696077957187583, 12.878017674275581],
              [92.69892945814037, 12.876394334911021],
              [92.701925693809315, 12.878397113137961],
              [92.703906862183302, 12.881002196586714],
              [92.707202159328418, 12.88002981702448],
              [92.710845325582127, 12.879754234478229],
              [92.714606572624319, 12.879479945569342],
              [92.715707291217925, 12.876227046884365],
              [92.71354192677704, 12.872622566246347],
              [92.710843915101506, 12.868204567502136],
              [92.709307188041507, 12.865483647732994],
              [92.706667567614602, 12.862947253963601],
              [92.703494255855546, 12.859433983035542],
              [92.699935498631035, 12.857152259381246],
              [92.69840122034168, 12.854548035596004],
              [92.698514109789627, 12.851201339402486],
              [92.698275712906934, 12.847947846162091],
              [92.694825855548046, 12.843157186661129],
              [92.692277186606646, 12.841248241932801],
              [92.687278688775379, 12.840614630405039],
              [92.682596581842716, 12.841886156809124],
              [92.679326153691292, 12.84260189446249],
              [92.675740068753527, 12.845037369022632],
              [92.671621323895735, 12.84665802851524],
              [92.666790695331628, 12.845025177112454],
              [92.665647315144554, 12.839957883731888],
              [92.666877031787763, 12.834893333798865],
              [92.669097354520758, 12.832711867659889],
              [92.669476003816669, 12.828576443791681],
              [92.669307911223711, 12.825415531743795],
              [92.669260689554321, 12.821604625176057],
              [92.670902181378963, 12.818191059792751],
              [92.674736514238944, 12.820706722831629],
              [92.677816937750634, 12.824056806772502],
              [92.680737652736028, 12.822712528288042],
              [92.680221727731066, 12.818646119370214],
              [92.679679550760781, 12.81513651245249],
              [92.678239072411628, 12.81250847894724],
              [92.675336344521455, 12.811063789889403],
              [92.672695795519132, 12.809061765241619],
              [92.670814989077797, 12.805550969981347],
              [92.670268502923292, 12.802460445440268],
              [92.669663254188109, 12.797951690062192],
              [92.6685149518526, 12.793535617780591],
              [92.66762744998141, 12.788933426047437],
              [92.665539484593197, 12.784771198319463],
            ],
          ],
          [
            [
              [92.708454894099347, 12.230222520932013],
              [92.705691055423628, 12.234973751132065],
              [92.705107993675412, 12.238567477573913],
              [92.704409266175389, 12.242184623841185],
              [92.703357642248548, 12.246033195494114],
              [92.703100613451426, 12.249883481446592],
              [92.702843304059584, 12.254057721375379],
              [92.702488284374368, 12.258695721390708],
              [92.701541979635138, 12.264354258734413],
              [92.702184596019407, 12.270455716678898],
              [92.702274120285409, 12.275094674178062],
              [92.702249171228019, 12.279385515101202],
              [92.702904312669119, 12.283445440493919],
              [92.702767364118998, 12.287062965989254],
              [92.702863213633279, 12.29047396779826],
              [92.703400644873184, 12.294649323237218],
              [92.709221805895979, 12.295329167237327],
              [92.712876944636008, 12.294544597776007],
              [92.719392624458891, 12.292741388422829],
              [92.720770879527862, 12.289124701807703],
              [92.719766170244753, 12.284485006913195],
              [92.718427272241485, 12.281328054570295],
              [92.717416189181506, 12.278149957641793],
              [92.716416399325126, 12.273185015949352],
              [92.715757950835354, 12.26968158688843],
              [92.713852537792746, 12.263579651100335],
              [92.712724383851196, 12.260284793659949],
              [92.711839637860535, 12.255552739563795],
              [92.711652869175722, 12.251238444022478],
              [92.710872204860379, 12.244905400214396],
              [92.71067834021342, 12.241866897646794],
              [92.710231862994405, 12.238480448657965],
              [92.71014253881566, 12.233609896688694],
              [92.708454894099347, 12.230222520932013],
            ],
          ],
          [
            [
              [93.101251290345658, 12.232120450926567],
              [93.102293262936058, 12.227573394078652],
              [93.101953559273937, 12.223284559813777],
              [93.103417965733499, 12.218805834968638],
              [93.103355080339867, 12.215813932919305],
              [93.103089765671584, 12.21075955363991],
              [93.102118942784287, 12.206841624935516],
              [93.099512398122968, 12.203228575557358],
              [93.097096692307801, 12.205550935131273],
              [93.095918818945222, 12.208521259452242],
              [93.095184278082769, 12.211420948788112],
              [93.094166134881178, 12.215551109971161],
              [93.093922921792853, 12.218519185702499],
              [93.093118924275856, 12.221559122857839],
              [93.092384453331476, 12.224691092261015],
              [93.094131322769059, 12.227145788898008],
              [93.097189884140647, 12.228811176546433],
              [93.101251290345658, 12.232120450926567],
            ],
          ],
          [
            [
              [93.095031495442242, 12.239112361361768],
              [93.094531351261736, 12.234543589493853],
              [93.091779146467331, 12.23178853836891],
              [93.088560207397421, 12.228754807233383],
              [93.085360626750756, 12.227368605083162],
              [93.080459371476351, 12.224777795122508],
              [93.077704191720684, 12.223043283138784],
              [93.074195450393248, 12.223257376803247],
              [93.070617747914284, 12.222984054488643],
              [93.066875169514375, 12.223499219757787],
              [93.063596742270363, 12.224663572324138],
              [93.062253805173825, 12.228143724045024],
              [93.062992292874625, 12.231041513978067],
              [93.063636969907648, 12.234148195760378],
              [93.065959353863732, 12.239223817431371],
              [93.068563555305232, 12.243789510030249],
              [93.070445350039648, 12.24784597701151],
              [93.073078617088697, 12.251390076800519],
              [93.075923228530158, 12.253774917218111],
              [93.079354531285759, 12.256437085748509],
              [93.082772536952049, 12.254994157441844],
              [93.083954928565831, 12.250864433332005],
              [93.083031178497109, 12.247386222147041],
              [93.082387447085353, 12.243607708687183],
              [93.081583170671493, 12.238831370305668],
              [93.082345325303478, 12.234632515164867],
              [93.08729952665675, 12.235552031305046],
              [93.091530663007461, 12.236357589065761],
              [93.095031495442242, 12.239112361361768],
            ],
          ],
          [
            [
              [92.734220554692328, 12.181434959202539],
              [92.73171543316576, 12.186440614837103],
              [92.730082910569962, 12.189847755254176],
              [92.729502327600073, 12.193046885042982],
              [92.728975509156029, 12.19842626854178],
              [92.725872353237008, 12.194179793533662],
              [92.725703038038489, 12.191164881467895],
              [92.723122235458931, 12.188518859678537],
              [92.722074470910798, 12.191810720111437],
              [92.722146157437948, 12.195497590157323],
              [92.722569435207589, 12.20345284911747],
              [92.722362228007526, 12.20704642172069],
              [92.722341267307357, 12.21054793940587],
              [92.722778825235807, 12.215835889568254],
              [92.722565373294472, 12.22056695527886],
              [92.721677659779871, 12.224531093898761],
              [92.721561157639059, 12.228404607179225],
              [92.722688718442143, 12.231721728547766],
              [92.724406140073341, 12.234181574968597],
              [92.725437425300584, 12.237592032928596],
              [92.729621113774286, 12.238060637880938],
              [92.731166121960101, 12.233725323614012],
              [92.729858529368656, 12.22945581418119],
              [92.728834080691584, 12.224353206092935],
              [92.728393151299912, 12.219529617319367],
              [92.728701365784843, 12.21498392925036],
              [92.729494649409006, 12.211111866302929],
              [92.731312192668213, 12.207889903819584],
              [92.733960975598237, 12.210930594543701],
              [92.738766631216535, 12.21616797803819],
              [92.740073729960145, 12.209151228887045],
              [92.740013521807882, 12.2030979329553],
              [92.739858769641714, 12.197694993251474],
              [92.739695022798159, 12.193451122395267],
              [92.738851263835187, 12.189462201316578],
              [92.738311241884517, 12.185589780218125],
              [92.737089595527365, 12.18257361017344],
              [92.734220554692328, 12.181434959202539],
            ],
          ],
          [
            [
              [92.738733919112221, 12.227005958190583],
              [92.737659841512823, 12.23087786612755],
              [92.741099501146664, 12.230603647669332],
              [92.738733919112221, 12.227005958190583],
            ],
          ],
          [
            [
              [92.874383463353553, 12.214659792810387],
              [92.873223029894504, 12.217882607482361],
              [92.872354517264696, 12.224028739299753],
              [92.871288085005062, 12.227042903727293],
              [92.870220050125369, 12.230359580245375],
              [92.870100983706536, 12.235554286129226],
              [92.871228268846409, 12.23972905566796],
              [92.872828330073006, 12.242651594083858],
              [92.877696279720411, 12.241793198721806],
              [92.877713586879707, 12.238499651616596],
              [92.877542955611247, 12.234719875841039],
              [92.881079981639871, 12.233281989834321],
              [92.884306969567092, 12.23358221739497],
              [92.886112218525085, 12.237733571704226],
              [92.885418339513635, 12.24123606078637],
              [92.884747805738556, 12.244830808895124],
              [92.887306689945348, 12.247845617144371],
              [92.890444288072729, 12.246801417726953],
              [92.891420225864138, 12.243021390953668],
              [92.892018776753375, 12.240006294037922],
              [92.895827261416073, 12.24104909080738],
              [92.898500883820162, 12.23914651553895],
              [92.900802508521025, 12.236966479854834],
              [92.902405997061805, 12.239632492107987],
              [92.90222978839671, 12.245558109679997],
              [92.90659401215018, 12.239237190685429],
              [92.908525988619047, 12.235642384984125],
              [92.911021577536431, 12.231953613570248],
              [92.913333755943285, 12.227430598039064],
              [92.914004596153788, 12.223441739268166],
              [92.91278075396697, 12.220334803571184],
              [92.909727590495464, 12.223257443491782],
              [92.908753427698159, 12.226759796194754],
              [92.904557945839798, 12.228661951847139],
              [92.901688152730742, 12.227225117792296],
              [92.898646579510299, 12.227318855295279],
              [92.895105388016447, 12.229986238095341],
              [92.890824430871888, 12.229987389365828],
              [92.886525778894878, 12.228944478539079],
              [92.883591929277671, 12.226486152985634],
              [92.881311381675729, 12.22384217805771],
              [92.880086409278405, 12.220711319099435],
              [92.878484946353268, 12.217974912146571],
              [92.874383463353553, 12.214659792810387],
            ],
          ],
          [
            [
              [92.863997028509189, 12.235832509774312],
              [92.860921507647376, 12.238105801622355],
              [92.861304399646187, 12.241515004958426],
              [92.861287706347099, 12.244645423679898],
              [92.864136116470291, 12.245782386106535],
              [92.865764028773484, 12.243022157182544],
              [92.86463560879038, 12.239241506890039],
              [92.863997028509189, 12.235832509774312],
            ],
          ],
          [
            [
              [93.095031495442242, 12.239112361361768],
              [93.096563424146794, 12.242588519004949],
              [93.098001171622514, 12.246784474282734],
              [93.098644344691351, 12.250981001109748],
              [93.09973074531591, 12.255246254547858],
              [93.10272139598618, 12.256401619205366],
              [93.105229483335606, 12.2545881689498],
              [93.105894408407252, 12.251107805395728],
              [93.104883366995949, 12.245172880712833],
              [93.10517141815545, 12.242134193541917],
              [93.104017077631013, 12.237195984860962],
              [93.095031495442242, 12.239112361361768],
            ],
          ],
          [
            [
              [92.745034593348748, 12.278242330295381],
              [92.74596521463215, 12.272633544101533],
              [92.744958776196214, 12.268574221784718],
              [92.743719867161857, 12.264397648231364],
              [92.742823194185988, 12.261334725757722],
              [92.741134652006565, 12.257831884491411],
              [92.73956864968369, 12.253770611768017],
              [92.734668257545309, 12.251493117484909],
              [92.735897288900404, 12.257594406579258],
              [92.737114818840425, 12.261677403749401],
              [92.73779397218874, 12.265737459514305],
              [92.739353392812788, 12.271166402592046],
              [92.741957585938593, 12.273882605480598],
              [92.745034593348748, 12.278242330295381],
            ],
          ],
          [
            [
              [93.025597073514376, 12.270677255163289],
              [93.023065970959323, 12.272419718817165],
              [93.024901895148474, 12.275827043905311],
              [93.028409037294651, 12.276125221589485],
              [93.028724599536915, 12.272947322026662],
              [93.025597073514376, 12.270677255163289],
            ],
          ],
          [
            [
              [92.764474361741478, 12.284988836493669],
              [92.765169961394662, 12.281880681719652],
              [92.766588133872233, 12.279236882460673],
              [92.764354531970454, 12.276939377972663],
              [92.763550522908957, 12.273830932182854],
              [92.763453278620858, 12.270421288572736],
              [92.759071265487421, 12.271948180140349],
              [92.755746526436226, 12.272410083959612],
              [92.753831229422147, 12.275771768971998],
              [92.754694321826051, 12.280620024675821],
              [92.756217799030054, 12.28433251213276],
              [92.758209311087427, 12.288137813770478],
              [92.761279735626772, 12.287096966752795],
              [92.764474361741478, 12.284988836493669],
            ],
          ],
          [
            [
              [92.921419742956701, 12.228634172368388],
              [92.91920289194266, 12.232786537006213],
              [92.918720188737652, 12.236473523499974],
              [92.919303715303599, 12.24243482450381],
              [92.920153263594145, 12.245843499843771],
              [92.920701341294986, 12.248788230697921],
              [92.92173354734669, 12.253983850128757],
              [92.922581782989269, 12.257578502796921],
              [92.921601904378335, 12.26249531258733],
              [92.921674761416213, 12.267413335681203],
              [92.920233762609996, 12.271101457076631],
              [92.916222274617297, 12.273190579317406],
              [92.911914428193285, 12.27432811274611],
              [92.907135159695571, 12.275652121092394],
              [92.903701427722368, 12.274700910609546],
              [92.903679146466388, 12.279618423090179],
              [92.901859108242391, 12.283678574934072],
              [92.903552438797036, 12.287272676076791],
              [92.906701644211182, 12.289081604307517],
              [92.911080296441554, 12.288221987232394],
              [92.915205764189992, 12.286899021658597],
              [92.916269741645962, 12.28397582002116],
              [92.914837526315381, 12.279987034207259],
              [92.915154254047522, 12.276878548575214],
              [92.919242419503021, 12.278384384865648],
              [92.923427991371611, 12.278847393214008],
              [92.925275069166915, 12.273651103614993],
              [92.929362821616181, 12.275063787339572],
              [92.929917985983735, 12.281883232229672],
              [92.929689945227409, 12.286313734578458],
              [92.929576596723535, 12.290767252351458],
              [92.929953169142451, 12.296055618384523],
              [92.930593739297237, 12.299466139798609],
              [92.932780008257708, 12.302317883325605],
              [92.934896902551642, 12.299950494399482],
              [92.934517052770431, 12.295497154121719],
              [92.934256593648584, 12.290950929052542],
              [92.933619791208841, 12.286219464652465],
              [92.935435007910755, 12.28292489101252],
              [92.937650737683128, 12.27884077675037],
              [92.939863757373985, 12.275917890627507],
              [92.940249907535943, 12.2728787941164],
              [92.938252045119881, 12.269493163262746],
              [92.934550619715907, 12.265041758885566],
              [92.932949077372896, 12.262004154099543],
              [92.93181515558301, 12.259082587674877],
              [92.929542503991726, 12.254837996654365],
              [92.92813285325218, 12.250757397557543],
              [92.926723360960295, 12.246328002587193],
              [92.926736623836177, 12.2432894453888],
              [92.926666138078588, 12.237908422414359],
              [92.92605232035001, 12.233549785628311],
              [92.924265602856693, 12.230697610018169],
              [92.921419742956701, 12.228634172368388],
            ],
          ],
          [
            [
              [92.871594162109076, 12.277150974856099],
              [92.866293938615968, 12.279460398497543],
              [92.867424382874361, 12.282940131771946],
              [92.870577689179271, 12.284076658794344],
              [92.873023447883483, 12.281663867650083],
              [92.871594162109076, 12.277150974856099],
            ],
          ],
          [
            [
              [92.88156398445274, 12.281291719339308],
              [92.879277576674383, 12.285142382834476],
              [92.88411643214701, 12.285768666357701],
              [92.88156398445274, 12.281291719339308],
            ],
          ],
          [
            [
              [92.763125997267338, 12.315578327139992],
              [92.766824787449536, 12.317395767046253],
              [92.768160157026159, 12.31315168048584],
              [92.767114684491261, 12.307212264678608],
              [92.763761102602373, 12.304473244884166],
              [92.762900553873905, 12.30774354892176],
              [92.763585600891474, 12.310712934201254],
              [92.763125997267338, 12.315578327139992],
            ],
          ],
          [
            [
              [74.095414227157065, 14.868560344339706],
              [74.092112481189773, 14.868582860454259],
              [74.089564064723902, 14.871469932316996],
              [74.090319914392552, 14.874697198675438],
              [74.094008076978113, 14.876469480834903],
              [74.096910563921455, 14.872139172541294],
              [74.095414227157065, 14.868560344339706],
            ],
          ],
          [
            [
              [74.191811842429928, 14.870145901696525],
              [74.18654421512943, 14.872539059252635],
              [74.188011774705757, 14.87534932609003],
              [74.193788630928651, 14.876708540106229],
              [74.198109512577034, 14.876675947498169],
              [74.198078587244851, 14.872920812007484],
              [74.195185176847531, 14.871065325430664],
              [74.191811842429928, 14.870145901696525],
            ],
          ],
          [
            [
              [74.084493990430545, 14.787503267402785],
              [74.079748545549094, 14.790404867862364],
              [74.081247118740052, 14.794348003560629],
              [74.086392557372633, 14.795026154447045],
              [74.087832894243093, 14.791426180511657],
              [74.084493990430545, 14.787503267402785],
            ],
          ],
          [
            [
              [74.05677707303532, 14.812106420740527],
              [74.053476614746572, 14.812129189192293],
              [74.050928434257855, 14.815015155313409],
              [74.051682997029459, 14.818243283050943],
              [74.055370308833275, 14.820016351343103],
              [74.058272886726101, 14.81568631985745],
              [74.05677707303532, 14.812106420740527],
            ],
          ],
          [
            [
              [74.092524496962099, 14.828017046863227],
              [74.089223661548118, 14.828040630904884],
              [74.086674835714845, 14.830926146187055],
              [74.087431496142869, 14.834154286006463],
              [74.091118530366202, 14.835926454137805],
              [74.094020250027853, 14.831596662089895],
              [74.092524496962099, 14.828017046863227],
            ],
          ],
          [
            [
              [74.099410519578797, 14.837722082951851],
              [74.095158390530415, 14.839017145072429],
              [74.09156922788479, 14.840721033972786],
              [74.091597255262201, 14.84433340334135],
              [74.095307333420422, 14.845894751965675],
              [74.100161097357386, 14.843376453906146],
              [74.099410519578797, 14.837722082951851],
            ],
          ],
          [
            [
              [73.465837794310076, 16.033059719035631],
              [73.460552471197474, 16.035115352695655],
              [73.459896751823266, 16.038988470995346],
              [73.459237910483253, 16.043023805365774],
              [73.462125416915924, 16.045342880405062],
              [73.46486050881991, 16.043777888443131],
              [73.465762463821832, 16.039332583153353],
              [73.465837794310076, 16.033059719035631],
            ],
          ],
          [
            [
              [81.275357995787473, 16.278291132646313],
              [81.271335328241875, 16.279234890284922],
              [81.270452431902456, 16.286011360449553],
              [81.278527435958551, 16.289745759635668],
              [81.279574228026803, 16.295043969648585],
              [81.27626978308065, 16.297817475406966],
              [81.270418171423003, 16.302545865040315],
              [81.267923589033629, 16.310124286596771],
              [81.270116429354502, 16.312942356487142],
              [81.277041541987842, 16.316369796553676],
              [81.281057943436039, 16.314573816335479],
              [81.28633367825995, 16.311890838101061],
              [81.293229249478998, 16.314925640374515],
              [81.298058420885241, 16.316920095232504],
              [81.314372794626053, 16.318703866517559],
              [81.324859051166953, 16.320514927899801],
              [81.330448036933561, 16.320137541685597],
              [81.326759523949931, 16.317198102198468],
              [81.318877445386562, 16.314263053911105],
              [81.311751105360997, 16.307647031204418],
              [81.322173607556977, 16.310208247917313],
              [81.326750698536671, 16.312289637592272],
              [81.330438004045789, 16.314245757466825],
              [81.335037973373858, 16.316055206507215],
              [81.351857851376224, 16.323272046013685],
              [81.360746743708177, 16.328420797608928],
              [81.363263762202465, 16.331944785827847],
              [81.368899681721345, 16.334020425533545],
              [81.38023578845268, 16.332486105059381],
              [81.388036714101929, 16.335580920994008],
              [81.391757736153622, 16.336417630854818],
              [81.393742430346776, 16.333791127027922],
              [81.392236130840274, 16.331005071061721],
              [81.386780974625879, 16.328661581392161],
              [81.379889918236586, 16.327403606656528],
              [81.370291838480838, 16.324572470045794],
              [81.357211084828535, 16.318978815998239],
              [81.349466758403807, 16.314779512281952],
              [81.331881490468589, 16.308334445897938],
              [81.326926008325259, 16.306495878672383],
              [81.317253508981466, 16.300388073121656],
              [81.30919930823957, 16.295252345101002],
              [81.288780259421102, 16.284573929941214],
              [81.275357995787473, 16.278291132646313],
            ],
          ],
          [
            [
              [73.386972003540052, 16.61592349284571],
              [73.383463663983278, 16.616006075485711],
              [73.382446400454668, 16.619420762957265],
              [73.386005823185243, 16.62165848395427],
              [73.386972003540052, 16.61592349284571],
            ],
          ],
          [
            [
              [71.512787317375867, 20.915255714161223],
              [71.518654625108681, 20.914364267623146],
              [71.523226992975154, 20.912797940006151],
              [71.526002728033248, 20.909085588757591],
              [71.525800394321664, 20.905453097401917],
              [71.518004432448194, 20.902363651595941],
              [71.511744882159419, 20.904611799247125],
              [71.511362715066426, 20.908011964621359],
              [71.512787317375867, 20.915255714161223],
            ],
          ],
          [
            [
              [87.880681728218079, 21.744022112129155],
              [87.878914011446042, 21.748764041643618],
              [87.882968404443062, 21.756731205642119],
              [87.88560206581225, 21.759055879762585],
              [87.892669587836195, 21.765465737018857],
              [87.898320875300499, 21.770136584772416],
              [87.900773354585297, 21.772147984249884],
              [87.90421041923662, 21.771536667341312],
              [87.903558248580367, 21.767939370374339],
              [87.899372919018617, 21.760717075144736],
              [87.895613271224448, 21.757536150608566],
              [87.893244627624526, 21.7545264749917],
              [87.890041535957721, 21.750222790900516],
              [87.886947207920457, 21.747022599291135],
              [87.884071328652396, 21.7445139684304],
              [87.880681728218079, 21.744022112129155],
            ],
          ],
          [
            [
              [72.305799068928266, 21.002143731190383],
              [72.302038576763792, 21.003269752191994],
              [72.296885105305819, 21.005317545531057],
              [72.293516915918701, 21.011660589836556],
              [72.289928214782506, 21.014602626610227],
              [72.287634411322884, 21.021153573586886],
              [72.285217262962547, 21.02802621809532],
              [72.286196056710537, 21.033173239766821],
              [72.28724918472561, 21.041492826940658],
              [72.288963737698509, 21.051674356502406],
              [72.293952961457677, 21.065620849433365],
              [72.296301147852134, 21.072147685313858],
              [72.298235229076425, 21.079616026685429],
              [72.298709114491871, 21.105102446548944],
              [72.298149329663062, 21.109400733266995],
              [72.29671010144105, 21.117054416636869],
              [72.301162375900347, 21.124683570701489],
              [72.305368049638318, 21.127254262755379],
              [72.30742003969219, 21.124518742292736],
              [72.309738363097864, 21.116589763964527],
              [72.312683931948243, 21.093539952388653],
              [72.31411857163485, 21.081311853789114],
              [72.314213776680234, 21.074740348840947],
              [72.314062085908418, 21.065063547432462],
              [72.312388414605067, 21.039440630589873],
              [72.312261756239181, 21.033166224528319],
              [72.312620411064074, 21.016643333916171],
              [72.312764098798425, 21.011654492015158],
              [72.305799068928266, 21.002143731190383],
            ],
          ],
          [
            [
              [86.427543382983046, 20.020536607354572],
              [86.424030194344382, 20.021834113151183],
              [86.424193397534566, 20.025207633150266],
              [86.425555809807321, 20.029749088890224],
              [86.430420629522118, 20.037846530528498],
              [86.434289263086754, 20.033843832560592],
              [86.434355239644404, 20.028667939338071],
              [86.433744596750927, 20.024576640917285],
              [86.427543382983046, 20.020536607354572],
            ],
          ],
          [
            [
              [86.388410789505457, 19.96309641522701],
              [86.382814116085996, 19.966065736498049],
              [86.3794712990844, 19.971403076767626],
              [86.384363940465491, 19.978649969797083],
              [86.387480833160424, 19.980773168266968],
              [86.392176845243796, 19.984394610035476],
              [86.398954054580045, 19.988802785803031],
              [86.408216453690954, 19.994877457869475],
              [86.41334893945529, 19.998940592714465],
              [86.418359567976182, 20.00452563939983],
              [86.423701250564491, 20.009959350866112],
              [86.427495885591156, 20.009454684224032],
              [86.428247233216467, 20.005352869423188],
              [86.426677694509266, 20.002038450585871],
              [86.421853111614851, 19.996790709328845],
              [86.416144823441286, 19.992384009759043],
              [86.411010528208138, 19.987747484396824],
              [86.408277820431451, 19.985492688195034],
              [86.405418051961178, 19.98365770444429],
              [86.397117660217503, 19.979956883573863],
              [86.393618218892598, 19.976930220402497],
              [86.391499335411169, 19.972258207188254],
              [86.388410789505457, 19.96309641522701],
            ],
          ],
          [
            [
              [86.789481065042494, 20.358271829963684],
              [86.787831363377919, 20.3612882442219],
              [86.788918081793483, 20.366873417220816],
              [86.791193828306675, 20.370865676156068],
              [86.794907944097389, 20.373414495312453],
              [86.798038972769191, 20.371230140035262],
              [86.797239129215882, 20.365563332367731],
              [86.789481065042494, 20.358271829963684],
            ],
          ],
          [
            [
              [72.734138633939381, 19.452402955337945],
              [72.730608754569076, 19.455149952523318],
              [72.729277851202653, 19.45812869031176],
              [72.728040548861728, 19.461269772798296],
              [72.729543916273528, 19.464287592582913],
              [72.73427285396852, 19.462027415446716],
              [72.735656956315296, 19.458866688865978],
              [72.734138633939381, 19.452402955337945],
            ],
          ],
          [
            [
              [86.806690056831272, 20.369261474389852],
              [86.803979225267625, 20.376853637047912],
              [86.802184506980325, 20.383209977619746],
              [86.800815651171987, 20.390351911386286],
              [86.801843763602776, 20.393755147935902],
              [86.806486383903888, 20.397803459484553],
              [86.809617382522646, 20.396078837013089],
              [86.811199588877813, 20.383592638200525],
              [86.811114037449713, 20.373824863782538],
              [86.806690056831272, 20.369261474389852],
            ],
          ],
          [
            [
              [86.793371556745043, 20.39498061793898],
              [86.79010785141574, 20.3964802918148],
              [86.788813837735844, 20.4002398295424],
              [86.78789404167091, 20.405177663240604],
              [86.788155048774712, 20.415121776509348],
              [86.790608184208992, 20.42542813812636],
              [86.79565068262032, 20.435391574562512],
              [86.800112545590295, 20.443517375413894],
              [86.799877643874026, 20.447482366009012],
              [86.799570668258994, 20.460119115683536],
              [86.800597862075605, 20.465912555069142],
              [86.800030916487415, 20.469133820592162],
              [86.79527054981088, 20.474793374556771],
              [86.794122397164216, 20.480040245244652],
              [86.794432324796432, 20.486119065592781],
              [86.795520159435384, 20.489267729057662],
              [86.798715948868178, 20.490689093544169],
              [86.802249979459489, 20.489177033875066],
              [86.805806383117002, 20.483363832013456],
              [86.809943226361341, 20.470741582662772],
              [86.811962066130747, 20.453914932156458],
              [86.811624075956217, 20.445399021343789],
              [86.811075612802767, 20.442319495977337],
              [86.808353725297138, 20.436301323890486],
              [86.805296712119826, 20.431332437015939],
              [86.801871567621717, 20.420631939134676],
              [86.79765702238366, 20.401574189469663],
              [86.793371556745043, 20.39498061793898],
            ],
          ],
          [
            [
              [87.056101902017289, 20.733083102866701],
              [87.052626225140344, 20.733404075085463],
              [87.051889874351033, 20.737506152384093],
              [87.056055610210848, 20.74097108416165],
              [87.060870103664897, 20.738681207972306],
              [87.060178316905947, 20.734850539425299],
              [87.056101902017289, 20.733083102866701],
            ],
          ],
          [
            [
              [87.075343987230681, 20.730523396961402],
              [87.0720274190314, 20.733847887055092],
              [87.07220266968713, 20.738553108187279],
              [87.072350553311537, 20.742223850422011],
              [87.074259970911157, 20.746412454091452],
              [87.07808731785056, 20.746259684077767],
              [87.080872352927614, 20.739786964899512],
              [87.08024224693105, 20.734390787112023],
              [87.075343987230681, 20.730523396961402],
            ],
          ],
          [
            [
              [87.091353234060961, 20.755810340102524],
              [87.087319075506244, 20.757146269598728],
              [87.087288169217146, 20.760227188542967],
              [87.092043969117768, 20.764169360647379],
              [87.095397042559938, 20.761532255450735],
              [87.095059207667873, 20.757456039641713],
              [87.091353234060961, 20.755810340102524],
            ],
          ],
          [
            [
              [86.993909300907546, 20.846707752020741],
              [86.99061555476564, 20.84823497812804],
              [86.989010207551786, 20.852147394563264],
              [86.98798766389892, 20.855481232280692],
              [86.98817054164698, 20.861244051635243],
              [86.994129615253883, 20.864812510887496],
              [86.996046736927497, 20.862219657308689],
              [86.997539455887576, 20.855715220264141],
              [86.997573296752236, 20.852655906594837],
              [86.993909300907546, 20.846707752020741],
            ],
          ],
          [
            [
              [86.995966687792816, 20.792248094392974],
              [86.990527870939715, 20.796491831692212],
              [86.990491746084203, 20.802481409637565],
              [86.995695305931648, 20.80723903500866],
              [87.001590893219245, 20.804973665908545],
              [86.999864922408918, 20.799057844600686],
              [86.999296813065698, 20.795093761672835],
              [86.995966687792816, 20.792248094392974],
            ],
          ],
          [
            [
              [86.990538638062461, 20.776517788377458],
              [86.986796760492894, 20.779354123740671],
              [86.985930346370708, 20.783051868733903],
              [86.991615099013146, 20.783461907978502],
              [86.992780556168043, 20.778744028265503],
              [86.990538638062461, 20.776517788377458],
            ],
          ],
          [
            [
              [86.929718572248717, 20.774275484778418],
              [86.917258276867017, 20.776262418426988],
              [86.910097777087259, 20.776285675112408],
              [86.899782604085658, 20.777209102974556],
              [86.89517364131116, 20.776495834770106],
              [86.885039739901828, 20.779019501812755],
              [86.880707978959848, 20.780316941521551],
              [86.880928664466452, 20.78504387785021],
              [86.889693798931575, 20.786719503153883],
              [86.893535174189324, 20.786317928640504],
              [86.904685416662474, 20.783609692823894],
              [86.911136256009968, 20.782583765426239],
              [86.917228921298971, 20.78364360991154],
              [86.920500664699603, 20.783587924561186],
              [86.927066863629975, 20.783889761484435],
              [86.939600405674341, 20.784244267324137],
              [86.945808471429714, 20.78327431619218],
              [86.952116049127667, 20.780779886301577],
              [86.954947187098568, 20.778562467167067],
              [86.954073932663647, 20.775428710055216],
              [86.94806491704432, 20.775493918437451],
              [86.929718572248717, 20.774275484778418],
            ],
          ],
          [
            [
              [87.07476050150396, 20.774229308249289],
              [87.071249699541383, 20.775769112543429],
              [87.070331035142843, 20.77919076075592],
              [87.069296480993927, 20.784572204436309],
              [87.069725534923393, 20.78804604078589],
              [87.071613920808133, 20.791798375208597],
              [87.076317422234453, 20.794295585289245],
              [87.079238603363436, 20.785793142922454],
              [87.078730121592073, 20.780828660559578],
              [87.07476050150396, 20.774229308249289],
            ],
          ],
          [
            [
              [68.526772344872157, 23.309939985900485],
              [68.528174882788761, 23.30504314134971],
              [68.529197531140895, 23.301121024786784],
              [68.529609888209038, 23.297824813499464],
              [68.527551507754481, 23.290428867425],
              [68.524703985861606, 23.288319389200804],
              [68.520157674397026, 23.288397515978314],
              [68.514803231964905, 23.291715796319476],
              [68.514797552744312, 23.296468129375178],
              [68.518234460557352, 23.300635250338182],
              [68.519439965034053, 23.304703955930631],
              [68.522969010008538, 23.30912657738649],
              [68.520653906280771, 23.312078399612108],
              [68.514880301304601, 23.315227795632968],
              [68.510933726236658, 23.316970943614557],
              [68.50451393091636, 23.31940583466179],
              [68.499851747518974, 23.321524665860405],
              [68.496567301979411, 23.329353532723271],
              [68.497581793035224, 23.332420226147416],
              [68.501843566438197, 23.33677654853464],
              [68.506110971257129, 23.341135540292509],
              [68.510183866790115, 23.344320725193981],
              [68.520543588199061, 23.350623226478778],
              [68.524395390852604, 23.351494079464935],
              [68.531578469758074, 23.348630873596374],
              [68.536986007573788, 23.347081177882846],
              [68.541163454602909, 23.34692579425738],
              [68.552370198311777, 23.34863143461952],
              [68.554292800698008, 23.345507987478889],
              [68.555526368756389, 23.334816415200713],
              [68.554372766774776, 23.32879610223511],
              [68.550791467999545, 23.325315642805634],
              [68.540456841901658, 23.322664633666719],
              [68.536831492775505, 23.321730905472002],
              [68.533003926332995, 23.314525394210342],
              [68.529250329635943, 23.312116105910359],
              [68.526772344872157, 23.309939985900485],
            ],
          ],
          [
            [
              [68.388542041269943, 23.44649281869372],
              [68.392393741236944, 23.437036826359236],
              [68.393943700447906, 23.429729729868907],
              [68.38864242298196, 23.430840221286573],
              [68.386596747408532, 23.433729004797126],
              [68.38253135134903, 23.431586653425327],
              [68.378449582266882, 23.441359564487222],
              [68.377351940418791, 23.450215183785012],
              [68.372586507001699, 23.465573052209816],
              [68.37199129836911, 23.469872969851554],
              [68.376572381890341, 23.476618378312121],
              [68.382232191582389, 23.47491335490767],
              [68.392501323298134, 23.468237678215619],
              [68.390680205486532, 23.463212919235772],
              [68.390134283165708, 23.459685315971715],
              [68.389706087450776, 23.45462543709608],
              [68.388542041269943, 23.44649281869372],
            ],
          ],
          [
            [
              [68.396157354696669, 23.443937567299294],
              [68.394179590898233, 23.449534143545165],
              [68.394904560661914, 23.45603146210096],
              [68.396926030587366, 23.462563652383086],
              [68.400251639492254, 23.466760481141069],
              [68.406128187290875, 23.467946757324007],
              [68.407681517177608, 23.463662952019334],
              [68.405236307957864, 23.45820105148114],
              [68.403269956809254, 23.454192799084378],
              [68.400926274790265, 23.449815419635421],
              [68.396157354696669, 23.443937567299294],
            ],
          ],
          [
            [
              [68.399779841683397, 23.470204064872881],
              [68.399670949002086, 23.474036268539059],
              [68.406695329189347, 23.480633368038539],
              [68.409942080971831, 23.478369591960153],
              [68.408540688195231, 23.474296214302797],
              [68.399779841683397, 23.470204064872881],
            ],
          ],
          [
            [
              [89.586983715427976, 25.933784868379483],
              [89.583665789549613, 25.943393644138787],
              [89.584546794771015, 25.947573229620627],
              [89.576091423717017, 25.95132508921877],
              [89.582942010364945, 25.953226087205504],
              [89.588946447806677, 25.955462893057426],
              [89.592649758534108, 25.960898500852803],
              [89.595604648584427, 25.96314090463348],
              [89.599239138936426, 25.963362098943971],
              [89.602073855269609, 25.960689787463998],
              [89.605449135090637, 25.959900693164112],
              [89.607950793091973, 25.956562658976235],
              [89.610836616494623, 25.954281578552408],
              [89.615576607478147, 25.951859077727136],
              [89.612673476474342, 25.94341314205953],
              [89.607924485023787, 25.943677527174955],
              [89.603272193055929, 25.943001774020686],
              [89.601376482756493, 25.938480181898889],
              [89.598877523775656, 25.935800963061606],
              [89.593055421103728, 25.938828647604424],
              [89.586983715427976, 25.933784868379483],
            ],
          ],
          [
            [
              [88.776381952551006, 26.129962090826613],
              [88.771138323204525, 26.131324997548063],
              [88.769577392629529, 26.142392205569273],
              [88.764552753392948, 26.146441654586088],
              [88.762279808924859, 26.148939469323793],
              [88.768553966026531, 26.152107394394275],
              [88.773377200361566, 26.156003512750011],
              [88.775915475938561, 26.158147488612247],
              [88.777912637691685, 26.162725699616065],
              [88.773023864344523, 26.163446869114775],
              [88.768754929407478, 26.161387157525493],
              [88.765264582610868, 26.162733563785228],
              [88.763374911770597, 26.165438075572634],
              [88.762717938748736, 26.171982691008377],
              [88.768738912713431, 26.174735607748875],
              [88.773474441678985, 26.174290646259564],
              [88.777234181193535, 26.176554245826662],
              [88.776345977706072, 26.184062168250268],
              [88.780220166299699, 26.190805991193464],
              [88.781684744412516, 26.19467040410505],
              [88.781288099654546, 26.199861320906852],
              [88.774192327111223, 26.206271015458345],
              [88.769628922236606, 26.209105325324487],
              [88.769236284413196, 26.21227440741869],
              [88.770114859639662, 26.216113616373612],
              [88.765828873045933, 26.219707054833744],
              [88.765289872690829, 26.228755904851702],
              [88.768277847926512, 26.234186703109998],
              [88.775805179437626, 26.237838734959549],
              [88.780309600928916, 26.238520387468583],
              [88.796147582948961, 26.228849963937627],
              [88.799417189064059, 26.225689084532512],
              [88.802670596022367, 26.217797276969556],
              [88.80293875171715, 26.213272755662967],
              [88.799175803934276, 26.21121713729076],
              [88.7988312978881, 26.207357078668888],
              [88.803577077130498, 26.203556095255262],
              [88.803213767224349, 26.196249995023535],
              [88.802258961582169, 26.192480968264459],
              [88.799873827499511, 26.189739012199443],
              [88.795990732897181, 26.18566233240913],
              [88.791758050709717, 26.179767961559492],
              [88.78848787732943, 26.174543074563992],
              [88.788015996531783, 26.17139531686902],
              [88.789565341732001, 26.162808483518074],
              [88.792282019186416, 26.156063459639441],
              [88.793386971896084, 26.152964439539673],
              [88.793996436487134, 26.14451274511217],
              [88.789630822907128, 26.140638748173792],
              [88.789273363771755, 26.132277439885833],
              [88.78240436496597, 26.132486478948596],
              [88.776381952551006, 26.129962090826613],
            ],
          ],
          [
            [
              [88.647945915409494, 26.252754103677415],
              [88.645670835013618, 26.254996667107264],
              [88.643215505061633, 26.257260672012009],
              [88.640633803237023, 26.259502377477244],
              [88.638607337978996, 26.263329700842277],
              [88.641222592962265, 26.265338869323948],
              [88.644215695968441, 26.270027843568084],
              [88.641083805917077, 26.28045201256008],
              [88.641329044835359, 26.284601683020952],
              [88.646390306206555, 26.284978056383576],
              [88.648643079618012, 26.280837179024342],
              [88.652019027607423, 26.275276281855227],
              [88.659388908359887, 26.273468041912729],
              [88.660890648067394, 26.269966740714899],
              [88.661163990479452, 26.26500522901625],
              [88.659035101719724, 26.262538210869469],
              [88.652809439730405, 26.259320245407054],
              [88.650915869964606, 26.255247616073099],
              [88.647945915409494, 26.252754103677415],
            ],
          ],
          [
            [
              [88.718371905256149, 26.175922302957655],
              [88.710112403273101, 26.18018959215415],
              [88.70844720036348, 26.183353387442388],
              [88.709319419677954, 26.188319109505034],
              [88.708026421264108, 26.193941989210728],
              [88.712287378340264, 26.19850639582647],
              [88.711755745917912, 26.20438431748962],
              [88.702502288595895, 26.208187226922128],
              [88.69371686691089, 26.209305616333513],
              [88.688178561234579, 26.213097913077238],
              [88.685587133032413, 26.21793570575193],
              [88.68034204130565, 26.231631332932832],
              [88.679812762136578, 26.237050653151542],
              [88.681812481158744, 26.239974223425623],
              [88.682055342226249, 26.243375871308992],
              [88.679044384967838, 26.24472032802365],
              [88.671783257905133, 26.245841189285859],
              [88.67125433365797, 26.250595019968259],
              [88.672848025952831, 26.253517601596418],
              [88.679008532024511, 26.25423038270441],
              [88.683774986772505, 26.253100901772697],
              [88.688271190140853, 26.249072726679529],
              [88.699411014616842, 26.225359879105003],
              [88.705685606015578, 26.222212502431489],
              [88.70996166519501, 26.222456997337826],
              [88.711789089559474, 26.230756774805251],
              [88.714907885808927, 26.234697841749977],
              [88.718191122403198, 26.235373927237273],
              [88.721941773328965, 26.232677573244072],
              [88.721700412053124, 26.229275847853486],
              [88.719205033068334, 26.221824553450897],
              [88.719069141685495, 26.217230221143044],
              [88.71939411442699, 26.211649021674518],
              [88.72301945795742, 26.208720803777034],
              [88.72267268282171, 26.198312657492124],
              [88.726062477014679, 26.196969334700832],
              [88.731592930665173, 26.194506721544069],
              [88.732098575423635, 26.188397216467397],
              [88.729615397764078, 26.185218706061118],
              [88.722467522301486, 26.184069335809681],
              [88.719221372965592, 26.180451524981454],
              [88.718371905256149, 26.175922302957655],
            ],
          ],
          [
            [
              [88.941741478984056, 26.370070004633412],
              [88.937993429396911, 26.370752138212037],
              [88.934983271512721, 26.372308534463077],
              [88.934925162179923, 26.376947871307607],
              [88.938134891827403, 26.378195992308715],
              [88.940230040968828, 26.375144568515619],
              [88.941741478984056, 26.370070004633412],
            ],
          ],
          [
            [
              [88.621219446292301, 26.403459895792526],
              [88.610654944923326, 26.405437725624875],
              [88.606641478042619, 26.407695225014425],
              [88.607490857721828, 26.41153349133663],
              [88.609616450364001, 26.415379954041221],
              [88.615624995517976, 26.41744850329037],
              [88.619531513293609, 26.416224290620161],
              [88.62744480723353, 26.414328379794505],
              [88.630207330900632, 26.412546960357261],
              [88.629482350776698, 26.409145492128193],
              [88.621219446292301, 26.403459895792526],
            ],
          ],
          [
            [
              [92.95040210693773, 12.941415290124038],
              [92.949142488781803, 12.944763774576908],
              [92.953778791323259, 12.949363599932321],
              [92.95635425094126, 12.951476951413159],
              [92.960541535682879, 12.951033161920224],
              [92.963491201239137, 12.948009345950535],
              [92.961126810564082, 12.945756269179425],
              [92.957744168615932, 12.944875117018029],
              [92.953894043553959, 12.943761706651586],
              [92.95040210693773, 12.941415290124038],
            ],
          ],
          [
            [
              [92.973527125980283, 12.970040668508206],
              [92.976327913824832, 12.966133252476036],
              [92.980403501520399, 12.964106924517937],
              [92.983471126463598, 12.960966812458658],
              [92.983931383140401, 12.95773467161419],
              [92.982484688855692, 12.954365974432257],
              [92.980692101388115, 12.950112212682056],
              [92.979222385109779, 12.946975786837459],
              [92.978460505395006, 12.943395808065484],
              [92.97847415306947, 12.939932436074105],
              [92.978135966409269, 12.936120303689048],
              [92.974865855992462, 12.93679750382536],
              [92.9725758573543, 12.939610935761854],
              [92.972675972582806, 12.943865895750431],
              [92.971404899582467, 12.95011938473313],
              [92.969934553853165, 12.953491113784757],
              [92.966989237722814, 12.9556088672052],
              [92.962445650481257, 12.956959890865004],
              [92.957362612018827, 12.95842805886091],
              [92.953948722785498, 12.959080578362016],
              [92.951567430099701, 12.961220777196731],
              [92.950988155644211, 12.964917118808458],
              [92.953922110319013, 12.965798741912804],
              [92.95778299435716, 12.96479645860996],
              [92.961161906033922, 12.966469268507572],
              [92.962275329708874, 12.970048810959625],
              [92.962259272469296, 12.974302830408813],
              [92.960670377498431, 12.977441929197417],
              [92.957937038757905, 12.979117662035696],
              [92.95487449325735, 12.980351884239298],
              [92.953401531497832, 12.984049749790046],
              [92.955764892881277, 12.98695389404179],
              [92.960273822632985, 12.988299846126996],
              [92.963125395148509, 12.98685682003023],
              [92.963259886299994, 12.982694618484693],
              [92.963840826895122, 12.978556235580818],
              [92.965193430158067, 12.975532792481383],
              [92.967253624233791, 12.971625341716878],
              [92.973527125980283, 12.970040668508206],
            ],
          ],
          [
            [
              [92.910775730068934, 12.950405179581061],
              [92.90670246984412, 12.952056880426428],
              [92.905136599585489, 12.955264832680173],
              [92.904395517874292, 12.958218220138358],
              [92.904629903843343, 12.96337809477077],
              [92.904968236981759, 12.966748962938818],
              [92.90499627057892, 12.971143620370968],
              [92.90481839671699, 12.974281369287345],
              [92.90506038871284, 12.977839055891893],
              [92.90473879976129, 12.981209180809843],
              [92.904065278201188, 12.984696925955724],
              [92.902451075778202, 12.988324345965189],
              [92.898724129924688, 12.991091722485269],
              [92.896898422467885, 12.994184577812913],
              [92.897425628645024, 12.997485799720899],
              [92.895433813473915, 13.000763886044494],
              [92.891672017107894, 13.0010439716102],
              [92.888431532291278, 12.999626774047316],
              [92.888412678123586, 13.003903929094001],
              [92.88823435733714, 13.007158927441999],
              [92.887252213026642, 13.010763371166036],
              [92.888322376827858, 13.01366932395892],
              [92.892821570554389, 13.011901606889051],
              [92.895469739114816, 13.008808616503201],
              [92.897506621748818, 13.005483886498427],
              [92.900999110235418, 13.00276265378592],
              [92.904065793450314, 13.000925242707712],
              [92.907465542707442, 13.002830689572294],
              [92.911426764211839, 13.000504988575038],
              [92.912172922315335, 12.996970626579214],
              [92.912656183783525, 12.993947904094211],
              [92.913141087274624, 12.990390344498648],
              [92.915740627079543, 12.987483611233495],
              [92.918958795510051, 12.988179773697421],
              [92.922668067688505, 12.989550309446136],
              [92.925911984121811, 12.989898090047065],
              [92.926470963598092, 12.985643452242261],
              [92.926538759999985, 12.980830264789414],
              [92.930440993883607, 12.981131158273026],
              [92.933968224311755, 12.981199423208253],
              [92.935696664243935, 12.978060207108767],
              [92.934937686777559, 12.974270605090716],
              [92.933796002339477, 12.971435474015804],
              [92.931056631542347, 12.969065022247515],
              [92.927833762838588, 12.969532062093268],
              [92.927474729767596, 12.965556532227774],
              [92.924685541527694, 12.963372589576942],
              [92.921084838631884, 12.963861454754436],
              [92.917912297058322, 12.963793149199816],
              [92.914389769760632, 12.962725170907733],
              [92.913136049304612, 12.959052814020733],
              [92.913761272182583, 12.955983306932174],
              [92.910775730068934, 12.950405179581061],
            ],
          ],
          [
            [
              [92.985540635085982, 12.985143550282304],
              [92.985177028049392, 12.988398087783454],
              [92.984478617123671, 12.992420838873368],
              [92.987759796308396, 12.995440487906279],
              [92.991263338807059, 12.995437664930529],
              [92.994433974040177, 12.996458293391068],
              [93.000677505277977, 12.997823292254504],
              [92.997714986749898, 12.993432929981479],
              [92.993988960231945, 12.989948057584435],
              [92.991179702821583, 12.986835661714087],
              [92.988931766638018, 12.984372796460722],
              [92.985540635085982, 12.985143550282304],
            ],
          ],
          [
            [
              [92.830426718351021, 13.006946066924415],
              [92.827426821083009, 13.009735039734363],
              [92.82846778484361, 13.013199859718933],
              [92.830189823922225, 13.01654856776101],
              [92.833449473673042, 13.018478880389868],
              [92.833846420579974, 13.014688556933702],
              [92.833040746501553, 13.011154884944998],
              [92.830426718351021, 13.006946066924415],
            ],
          ],
          [
            [
              [92.938641845522909, 12.999192300344491],
              [92.935697805111388, 13.000263829980057],
              [92.933942860076073, 13.004007019776592],
              [92.93362351966357, 13.007076485530288],
              [92.93163523962788, 13.010332250128736],
              [92.92882349587407, 13.013193197274303],
              [92.925454012746371, 13.01489191586823],
              [92.924385616021041, 13.011404705372502],
              [92.925789633133846, 13.007963074008421],
              [92.926624593593971, 13.005056442315501],
              [92.923171388603947, 13.00382535511107],
              [92.921347512951058, 13.006849276147245],
              [92.918888768626672, 13.010221281392166],
              [92.91647650335689, 13.01301181079598],
              [92.915333019662228, 13.016383596528891],
              [92.914708404341681, 13.019522893449887],
              [92.917026890595011, 13.022010151428594],
              [92.921387543421787, 13.025101514727368],
              [92.924440549536428, 13.026332594078974],
              [92.928645615475205, 13.027749480600331],
              [92.932048809147659, 13.029188775835928],
              [92.934923210183229, 13.028048776391454],
              [92.934866573855885, 13.024677354496575],
              [92.938543235661967, 13.023024206048003],
              [92.938909476626677, 13.019700058707269],
              [92.938621853482857, 13.015374409996074],
              [92.939247424836935, 13.012049861344005],
              [92.939921619158511, 13.008375334652333],
              [92.940481668828625, 13.003934081291462],
              [92.938641845522909, 12.999192300344491],
            ],
          ],
          [
            [
              [92.948203485476782, 13.081967888354026],
              [92.944675535625407, 13.075970530198189],
              [92.940714631592058, 13.077971620831914],
              [92.943077435419454, 13.081319887404932],
              [92.948203485476782, 13.081967888354026],
            ],
          ],
          [
            [
              [92.8182479865483, 13.085491404030448],
              [92.815299841082748, 13.086839080760946],
              [92.81617912929984, 13.089746958210174],
              [92.818332931720519, 13.091887598676736],
              [92.821585688034062, 13.091260701637889],
              [92.820305555949361, 13.088236573786167],
              [92.8182479865483, 13.085491404030448],
            ],
          ],
          [
            [
              [92.700385571480652, 13.076098682966434],
              [92.695576154207956, 13.081744246722964],
              [92.695357286850268, 13.086836356764749],
              [92.694187725220019, 13.08985890916234],
              [92.693387723245621, 13.097765238148929],
              [92.69527160602172, 13.101349509391717],
              [92.702152766440378, 13.099846152674971],
              [92.70671968167315, 13.099664396083917],
              [92.713191838758505, 13.10381221788764],
              [92.71681624187292, 13.103815217918477],
              [92.713970179165642, 13.099486522929565],
              [92.710366458749746, 13.095901428927355],
              [92.706557446766098, 13.095338595157786],
              [92.704491653459286, 13.090429278466154],
              [92.701633099551103, 13.088169316846768],
              [92.70111168830995, 13.080796616394421],
              [92.700385571480652, 13.076098682966434],
            ],
          ],
          [
            [
              [92.809001940032232, 13.089674671238051],
              [92.807154270592676, 13.092115767005463],
              [92.807138547079305, 13.095254687192943],
              [92.807587293167941, 13.09944091918217],
              [92.80787859655166, 13.102535205570083],
              [92.810504496928829, 13.104164644913993],
              [92.812477855020376, 13.100606684322253],
              [92.81249461828375, 13.097187119778056],
              [92.813850810510559, 13.094211738090447],
              [92.813160256526729, 13.091257784440591],
              [92.809001940032232, 13.089674671238051],
            ],
          ],
          [
            [
              [92.751516875477876, 13.203964676131415],
              [92.748726600919255, 13.206335440242531],
              [92.750239214564289, 13.209523358521261],
              [92.753570028469639, 13.212086605828393],
              [92.756264225521107, 13.210296591133268],
              [92.755220997325395, 13.207271209407716],
              [92.751516875477876, 13.203964676131415],
            ],
          ],
          [
            [
              [92.843807028009806, 13.245005858110964],
              [92.848310275640216, 13.24409979182032],
              [92.846373485485017, 13.240213859461337],
              [92.843807028009806, 13.245005858110964],
            ],
          ],
          [
            [
              [93.011920714706221, 13.293161214933026],
              [93.008176518014494, 13.29527122780696],
              [93.00966332811862, 13.298308647389971],
              [93.013597685994839, 13.295731679058978],
              [93.011920714706221, 13.293161214933026],
            ],
          ],
          [
            [
              [74.683816329057478, 13.344020997695207],
              [74.680441864770557, 13.345743042578514],
              [74.680478904959486, 13.349126355861365],
              [74.684846884552925, 13.348578203992242],
              [74.683816329057478, 13.344020997695207],
            ],
          ],
          [
            [
              [74.689849067604442, 13.335328754255404],
              [74.68647495126433, 13.337049763229352],
              [74.686512137070309, 13.340432985048656],
              [74.69087981744886, 13.339884664615901],
              [74.689849067604442, 13.335328754255404],
            ],
          ],
          [
            [
              [93.072741307851686, 13.306648120735463],
              [93.069859233208547, 13.308909323858551],
              [93.071828798614433, 13.311955721662446],
              [93.074943919335581, 13.311206290623536],
              [93.075401063436701, 13.308203482545325],
              [93.072741307851686, 13.306648120735463],
            ],
          ],
          [
            [
              [74.695596788408835, 13.32664360369249],
              [74.692222956166958, 13.328364701705219],
              [74.692260220590825, 13.33174896373899],
              [74.696627603206579, 13.331200483404638],
              [74.695596788408835, 13.32664360369249],
            ],
          ],
          [
            [
              [74.67409831353983, 13.375897200065985],
              [74.668368524319192, 13.378233377714338],
              [74.667294412390731, 13.384804880357024],
              [74.671092084460341, 13.385434276873934],
              [74.673701345653228, 13.382230828046968],
              [74.67409831353983, 13.375897200065985],
            ],
          ],
          [
            [
              [80.320669587309808, 13.390893367515607],
              [80.317939890829095, 13.394855640354811],
              [80.31675989210153, 13.400280043141748],
              [80.321170409144685, 13.400825739043038],
              [80.322310858922208, 13.397496536761748],
              [80.320669587309808, 13.390893367515607],
            ],
          ],
          [
            [
              [80.306860266840928, 13.409341515113166],
              [80.30388932921727, 13.410919469343449],
              [80.301993961997482, 13.413821506538239],
              [80.301444985614069, 13.417778859792399],
              [80.303320065947972, 13.422272668901904],
              [80.307372026715626, 13.419911661999903],
              [80.308729391729798, 13.416214266130734],
              [80.30982075834909, 13.413051047560483],
              [80.306860266840928, 13.409341515113166],
            ],
          ],
          [
            [
              [80.318411894931643, 13.413404445163138],
              [80.313677675495484, 13.414962008509098],
              [80.31263609723392, 13.421728145270254],
              [80.317296714039315, 13.425558462811081],
              [80.320674504093574, 13.42301121416147],
              [80.321033527189769, 13.416255172851328],
              [80.318411894931643, 13.413404445163138],
            ],
          ],
          [
            [
              [92.965532000217792, 13.34059829917094],
              [92.962345054567038, 13.341508801879872],
              [92.961790586156923, 13.344721104470148],
              [92.964467692508677, 13.347465096183283],
              [92.966765556617176, 13.344601544082391],
              [92.965532000217792, 13.34059829917094],
            ],
          ],
          [
            [
              [93.021195556527644, 13.313297428326969],
              [93.017980744447357, 13.316140007252137],
              [93.015397749223553, 13.319540977409204],
              [93.014751685848125, 13.322752440196888],
              [93.015137419451918, 13.326732666159156],
              [93.015475328797052, 13.331014396867134],
              [93.015579980878272, 13.334411614227159],
              [93.018140555638951, 13.337108969275784],
              [93.020930743841802, 13.334639814196498],
              [93.0197957568801, 13.329450832997669],
              [93.019971809454901, 13.325936647407259],
              [93.019587276028389, 13.32153808675802],
              [93.021580606119826, 13.317904961236739],
              [93.021195556527644, 13.313297428326969],
            ],
          ],
          [
            [
              [93.066906814403495, 13.310845162438136],
              [93.063698687028122, 13.311361769835624],
              [93.061542661860855, 13.314948931421913],
              [93.060706190192292, 13.318463998688497],
              [93.060296546174541, 13.321629110005698],
              [93.059218509545573, 13.326704073664706],
              [93.05897145234789, 13.330102243033862],
              [93.059076164584326, 13.334035985593745],
              [93.058900955117096, 13.337317305543527],
              [93.05578515766372, 13.338066449112025],
              [93.052471574694366, 13.335021882841984],
              [93.04957997134531, 13.33260518325401],
              [93.046899323895047, 13.330443871363089],
              [93.043157660574778, 13.32865624071764],
              [93.040227323925919, 13.330963832728195],
              [93.040688667373217, 13.334198395745618],
              [93.041550626303589, 13.337130532317698],
              [93.041774339337408, 13.340643719454565],
              [93.042706847720751, 13.343528430850608],
              [93.043803676693315, 13.347158682387192],
              [93.044899559337182, 13.350718568984796],
              [93.04606392332586, 13.35469720897555],
              [93.046046170886996, 13.359771674671753],
              [93.047663893921239, 13.36288801360274],
              [93.048925591672486, 13.36593627549132],
              [93.052270049040573, 13.367072567675024],
              [93.054239204367519, 13.370398318028158],
              [93.053350885192913, 13.375357035551175],
              [93.050771479082385, 13.378083715483639],
              [93.050168166617979, 13.38199520006521],
              [93.050936364530699, 13.384997484497969],
              [93.052149059801323, 13.389138783148036],
              [93.055854035510507, 13.388365939420202],
              [93.057329693074806, 13.384849866030539],
              [93.058381788818551, 13.379820387752977],
              [93.058936456556225, 13.37660719187547],
              [93.061053883186091, 13.370994461081766],
              [93.062452994233041, 13.368292620990061],
              [93.063975317555943, 13.36437975873063],
              [93.066341451447713, 13.361374937986566],
              [93.067579817790232, 13.358206939754844],
              [93.069426276853719, 13.355527475273499],
              [93.072329510020992, 13.354382921782062],
              [93.075096519681978, 13.352238285583901],
              [93.075154920250327, 13.348490640186451],
              [93.07540144118515, 13.344859246120706],
              [93.078967924593954, 13.343131454217286],
              [93.08199984616833, 13.345897197907282],
              [93.082507801134298, 13.349294214474904],
              [93.085475267156866, 13.349988166729135],
              [93.087937452089719, 13.347262099526956],
              [93.088017486175289, 13.34381630227403],
              [93.084934224851736, 13.342028788315174],
              [93.081615976292369, 13.340637868839885],
              [93.077613445862696, 13.338618816166056],
              [93.074128304720162, 13.33745999903612],
              [93.072277574461268, 13.334250753251824],
              [93.070994070241909, 13.330039614263841],
              [93.070723124338926, 13.326525625839642],
              [93.070025869441452, 13.323454855872113],
              [93.069685795083629, 13.319196122227105],
              [93.069461850276696, 13.315053514574542],
              [93.066906814403495, 13.310845162438136],
            ],
          ],
          [
            [
              [93.02721949079455, 13.356347797230582],
              [93.023770926802797, 13.358283493053587],
              [93.020628790256296, 13.360219465985876],
              [93.022552322053073, 13.362638512829154],
              [93.025778467235526, 13.363751502458355],
              [93.02868314030033, 13.362561126345534],
              [93.032363563324679, 13.36218522894001],
              [93.032965992597568, 13.358576516816191],
              [93.02721949079455, 13.356347797230582],
            ],
          ],
          [
            [
              [93.013717989514149, 13.360878078702411],
              [93.013797687056851, 13.364718561710736],
              [93.014229562806818, 13.369303915406348],
              [93.014567070834516, 13.373377081886662],
              [93.018238615964748, 13.375816816850476],
              [93.022053993813159, 13.376860877921692],
              [93.026626612140049, 13.377297654540271],
              [93.030142878872255, 13.376549069502465],
              [93.028363244447164, 13.373292531071383],
              [93.02582710583016, 13.36989629894139],
              [93.023436406817495, 13.366197903283418],
              [93.020067625864797, 13.365246977853317],
              [93.017459218935414, 13.362945214294998],
              [93.013717989514149, 13.360878078702411],
            ],
          ],
          [
            [
              [94.252031354346741, 13.435766710827055],
              [94.246432374362996, 13.442758195351479],
              [94.249313288743508, 13.452160021041562],
              [94.251295113890947, 13.456867749031209],
              [94.252996216047279, 13.461555104611705],
              [94.25977267968635, 13.466751487140973],
              [94.268773723192027, 13.468620422597336],
              [94.274673031572661, 13.468563497505263],
              [94.274374928136751, 13.461627324962306],
              [94.273495140805025, 13.456093937517219],
              [94.275700209186951, 13.449692759556934],
              [94.271157376701908, 13.443078839317982],
              [94.259887441368278, 13.435691206717932],
              [94.252031354346741, 13.435766710827055],
            ],
          ],
          [
            [
              [93.098148121820984, 13.439893598015193],
              [93.096184659276147, 13.444686591397744],
              [93.100144336923634, 13.443499515621026],
              [93.098148121820984, 13.439893598015193],
            ],
          ],
          [
            [
              [92.8838454384166, 13.58778271341893],
              [92.880171170338002, 13.59057789997431],
              [92.879377588535661, 13.593746482269044],
              [92.879667783600652, 13.597356286128814],
              [92.885280600155724, 13.604506729977849],
              [92.894254126092989, 13.610235481247271],
              [92.898139481089927, 13.613006521163706],
              [92.901805364432008, 13.612097287285629],
              [92.902586805218107, 13.606227806704567],
              [92.898875129698581, 13.601802442270547],
              [92.893995658157138, 13.599543648588385],
              [92.889818897059897, 13.598403040606343],
              [92.887921351830983, 13.595468893080186],
              [92.886255338686269, 13.592696930181901],
              [92.8838454384166, 13.58778271341893],
            ],
          ],
          [
            [
              [93.044972740157931, 13.634241474440257],
              [93.044252341552223, 13.637409437855656],
              [93.042799088480123, 13.6414187058314],
              [93.041837231421283, 13.645869230343022],
              [93.042298904548048, 13.649618882419665],
              [93.046937049110738, 13.654319734164726],
              [93.048580553042541, 13.65736884802156],
              [93.051787796289659, 13.659345507439724],
              [93.053075270754078, 13.662769005932219],
              [93.054507628684675, 13.665562451571892],
              [93.062118630706109, 13.665086363153522],
              [93.064511920270078, 13.663103423776613],
              [93.067002498424884, 13.659814787684756],
              [93.061908223593591, 13.657236135706837],
              [93.057987289927169, 13.656658255395579],
              [93.054899051180058, 13.654425712011728],
              [93.052880421789112, 13.650561343402542],
              [93.052421000777159, 13.646322309883931],
              [93.051255909924322, 13.641640405309749],
              [93.049475000506277, 13.637053672043571],
              [93.044972740157931, 13.634241474440257],
            ],
          ],
          [
            [
              [74.683819943974925, 13.652171821825036],
              [74.680387076627696, 13.653126246042675],
              [74.678715684146894, 13.658805243294264],
              [74.677631823792581, 13.666734688682048],
              [74.686946918244985, 13.663948462809367],
              [74.690379057649182, 13.660737014043827],
              [74.691247519985652, 13.656631018740274],
              [74.687995726166079, 13.652820115693979],
              [74.683819943974925, 13.652171821825036],
            ],
          ],
          [
            [
              [93.014171891501988, 13.684619462573997],
              [93.019440376176448, 13.684871231811389],
              [93.020161489775376, 13.681933927175331],
              [93.021697424359147, 13.668955959084954],
              [93.023841467472053, 13.656862478960317],
              [93.027538143557507, 13.647422822919824],
              [93.028432998517715, 13.641550915080137],
              [93.023103219686362, 13.638715027890214],
              [93.018467890488097, 13.64018750071366],
              [93.012167166063449, 13.644020607512742],
              [93.002383531254111, 13.651525068804954],
              [92.993967561862846, 13.65248734059406],
              [92.984013643992441, 13.648325369488056],
              [92.971804598710335, 13.652574917305193],
              [92.968880066706589, 13.662874484480259],
              [92.973126682232873, 13.670978676431311],
              [92.978377498822297, 13.675564614987028],
              [92.986680962525512, 13.679612344222967],
              [93.001011998928817, 13.68440590726987],
              [93.014171891501988, 13.684619462573997],
            ],
          ],
          [
            [
              [74.331040150796412, 14.01425232139448],
              [74.327669568658564, 14.015108881522922],
              [74.325057679370857, 14.016810830723529],
              [74.326094948017229, 14.022325343916599],
              [74.329403074646748, 14.019857584308824],
              [74.331539924254784, 14.017631083854148],
              [74.331040150796412, 14.01425232139448],
            ],
          ],
          [
            [
              [74.472010945444978, 14.083799476132025],
              [74.468945622402785, 14.085197487976613],
              [74.468994915814164, 14.090143795424938],
              [74.474863133705199, 14.088993252234182],
              [74.472010945444978, 14.083799476132025],
            ],
          ],
          [
            [
              [74.487914735861267, 14.022405851932364],
              [74.484848403067815, 14.023530930154575],
              [74.483203425067387, 14.027116766287515],
              [74.486313748058976, 14.030386518977727],
              [74.489366875801082, 14.027885969070454],
              [74.487914735861267, 14.022405851932364],
            ],
          ],
          [
            [
              [74.479686493870403, 14.26438866068564],
              [74.473687991440741, 14.265822573999758],
              [74.469383050811061, 14.267540331695546],
              [74.4611480525015, 14.270835783811334],
              [74.458604445890913, 14.2725143906178],
              [74.46072860545064, 14.275902437872825],
              [74.4656920781688, 14.276755581372267],
              [74.470287814909611, 14.275932619241932],
              [74.473781817368021, 14.275326299993779],
              [74.478182622041373, 14.276184944193876],
              [74.480722624117774, 14.274206537862819],
              [74.479686493870403, 14.26438866068564],
            ],
          ],
          [
            [
              [74.399109607057383, 14.31023007317973],
              [74.395227530114255, 14.312276623163585],
              [74.395278760491223, 14.317713423821084],
              [74.400419228115723, 14.318069470317052],
              [74.402656017776579, 14.315636865126661],
              [74.399109607057383, 14.31023007317973],
            ],
          ],
          [
            [
              [74.397634596390034, 14.461036837759833],
              [74.392338824116791, 14.462899545914556],
              [74.390703306892974, 14.468896441224082],
              [74.389885575273567, 14.474473121283957],
              [74.391766541238511, 14.47696539548055],
              [74.395482181476325, 14.477140532499261],
              [74.400991145983056, 14.473020878733358],
              [74.402578940948132, 14.469417869925483],
              [74.402657641920428, 14.465297204810502],
              [74.397634596390034, 14.461036837759833],
            ],
          ],
          [
            [
              [74.113465097006326, 14.75200770745826],
              [74.110099325604921, 14.754999962959856],
              [74.109087256064896, 14.757951944241958],
              [74.112226481663555, 14.759057575519716],
              [74.114274134159729, 14.756098215733596],
              [74.119148959510866, 14.753417127253071],
              [74.113465097006326, 14.75200770745826],
            ],
          ],
          [
            [
              [74.481169921160856, 14.010043741484967],
              [74.476702056883397, 14.011395669592277],
              [74.476056388311477, 14.014808313324995],
              [74.480752460073234, 14.015226139978326],
              [74.485259545199767, 14.013137043676796],
              [74.481169921160856, 14.010043741484967],
            ],
          ],
          [
            [
              [93.088017053052525, 13.420213665036579],
              [93.086639941527508, 13.423824045500353],
              [93.087548166361231, 13.426965867894296],
              [93.09044432615039, 13.429406227706913],
              [93.091188160510285, 13.425260243341306],
              [93.088017053052525, 13.420213665036579],
            ],
          ],
          [
            [
              [92.817541788679605, 13.43063585926112],
              [92.816548312041746, 13.422161947419417],
              [92.815769928435699, 13.41713349151471],
              [92.813245802212379, 13.412499119866887],
              [92.808029531715931, 13.408656186015193],
              [92.80600761155786, 13.412100283532554],
              [92.805956382694191, 13.422157629635507],
              [92.804582419142079, 13.428000600725539],
              [92.803758817568166, 13.432097049482307],
              [92.8034395476529, 13.438268977035808],
              [92.80842731867088, 13.437267431812169],
              [92.810989363882868, 13.434218955487992],
              [92.816016275884238, 13.433895155055346],
              [92.817648147161051, 13.437900119269257],
              [92.819400540438423, 13.441043406516519],
              [92.821362663629586, 13.444932609558579],
              [92.826237843698209, 13.446750391106583],
              [92.830813734961026, 13.447006916057196],
              [92.835380142818181, 13.449267201979982],
              [92.837850979678123, 13.451082905301771],
              [92.840337974370371, 13.448826137117495],
              [92.840878998692133, 13.444634558435752],
              [92.841955599575599, 13.441491726731297],
              [92.840273077421131, 13.438092154147595],
              [92.838184376537754, 13.435787329357868],
              [92.834940238055097, 13.433528715576655],
              [92.832546957367299, 13.43112973077077],
              [92.830649726795087, 13.428126063982578],
              [92.824192281763956, 13.427122391772675],
              [92.820548934014909, 13.428496144880583],
              [92.817541788679605, 13.43063585926112],
            ],
          ],
        ],
      },
    },
  ],
};
export function isMobile() {
  if (window.innerWidth < 770) return true;
  else return false;
}
export function check_boundary(lat, lon) {
  var gjLayer = L.geoJson(statesData);
  var results = leafletPip.pointInLayer([lon, lat], gjLayer);
  console.log(results);
  console.log(lat, lon);
  if (results.length === 1) return true;
  else return false;
}

// export function check_boundary_himalyan(lat,lon)
// {
//   var gjLayer = L.geoJson(india_himalayan);
//   var results = leafletPip.pointInLayer([lon, lat], gjLayer);
//   console.log(results)
//   console.log(lat,lon)
//   if( results.length===1 )
//     return true
//   else
//     return false
// }
